function _typeof2(obj) { "@babel/helpers - typeof"; return _typeof2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof2(obj); }

module.exports =
/******/
function (modules) {
  // webpackBootstrap

  /******/
  // The module cache

  /******/
  var installedModules = {};
  /******/

  /******/
  // The require function

  /******/

  function __webpack_require__(moduleId) {
    /******/

    /******/
    // Check if module is in cache

    /******/
    if (installedModules[moduleId]) {
      /******/
      return installedModules[moduleId].exports;
      /******/
    }
    /******/
    // Create a new module (and put it into the cache)

    /******/


    var module = installedModules[moduleId] = {
      /******/
      i: moduleId,

      /******/
      l: false,

      /******/
      exports: {}
      /******/

    };
    /******/

    /******/
    // Execute the module function

    /******/

    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/

    /******/
    // Flag the module as loaded

    /******/

    module.l = true;
    /******/

    /******/
    // Return the exports of the module

    /******/

    return module.exports;
    /******/
  }
  /******/

  /******/

  /******/
  // expose the modules object (__webpack_modules__)

  /******/


  __webpack_require__.m = modules;
  /******/

  /******/
  // expose the module cache

  /******/

  __webpack_require__.c = installedModules;
  /******/

  /******/
  // define getter function for harmony exports

  /******/

  __webpack_require__.d = function (exports, name, getter) {
    /******/
    if (!__webpack_require__.o(exports, name)) {
      /******/
      Object.defineProperty(exports, name, {
        enumerable: true,
        get: getter
      });
      /******/
    }
    /******/

  };
  /******/

  /******/
  // define __esModule on exports

  /******/


  __webpack_require__.r = function (exports) {
    /******/
    if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
      /******/
      Object.defineProperty(exports, Symbol.toStringTag, {
        value: 'Module'
      });
      /******/
    }
    /******/


    Object.defineProperty(exports, '__esModule', {
      value: true
    });
    /******/
  };
  /******/

  /******/
  // create a fake namespace object

  /******/
  // mode & 1: value is a module id, require it

  /******/
  // mode & 2: merge all properties of value into the ns

  /******/
  // mode & 4: return value when already ns object

  /******/
  // mode & 8|1: behave like require

  /******/


  __webpack_require__.t = function (value, mode) {
    /******/
    if (mode & 1) value = __webpack_require__(value);
    /******/

    if (mode & 8) return value;
    /******/

    if (mode & 4 && _typeof2(value) === 'object' && value && value.__esModule) return value;
    /******/

    var ns = Object.create(null);
    /******/

    __webpack_require__.r(ns);
    /******/


    Object.defineProperty(ns, 'default', {
      enumerable: true,
      value: value
    });
    /******/

    if (mode & 2 && typeof value != 'string') for (var key in value) {
      __webpack_require__.d(ns, key, function (key) {
        return value[key];
      }.bind(null, key));
    }
    /******/

    return ns;
    /******/
  };
  /******/

  /******/
  // getDefaultExport function for compatibility with non-harmony modules

  /******/


  __webpack_require__.n = function (module) {
    /******/
    var getter = module && module.__esModule ?
    /******/
    function getDefault() {
      return module['default'];
    } :
    /******/
    function getModuleExports() {
      return module;
    };
    /******/

    __webpack_require__.d(getter, 'a', getter);
    /******/


    return getter;
    /******/
  };
  /******/

  /******/
  // Object.prototype.hasOwnProperty.call

  /******/


  __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/

  /******/
  // __webpack_public_path__

  /******/


  __webpack_require__.p = "";
  /******/

  /******/

  /******/
  // Load entry module and return exports

  /******/

  return __webpack_require__(__webpack_require__.s = 26);
  /******/
}
/************************************************************************/

/******/
([
/* 0 */

/***/
function (module, exports, __webpack_require__) {
  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  if (false) {
    var throwOnDirectAccess, ReactIs;
  } else {
    // By explicitly using `prop-types` you are opting into new production behavior.
    // http://fb.me/prop-types-in-prod
    module.exports = __webpack_require__(28)();
  }
  /***/

},
/* 1 */

/***/
function (module, exports) {
  module.exports = require("react");
  /***/
},
/* 2 */

/***/
function (module, exports) {
  function _extends() {
    module.exports = _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return _extends.apply(this, arguments);
  }

  module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;
  /***/
},
/* 3 */

/***/
function (module, exports) {
  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;
  /***/
},
/* 4 */

/***/
function (module, exports, __webpack_require__) {
  var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  /*!
    Copyright (c) 2018 Jed Watson.
    Licensed under the MIT License (MIT), see
    http://jedwatson.github.io/classnames
  */

  /* global define */


  (function () {
    'use strict';

    var hasOwn = {}.hasOwnProperty;

    function classNames() {
      var classes = [];

      for (var i = 0; i < arguments.length; i++) {
        var arg = arguments[i];
        if (!arg) continue;

        var argType = _typeof(arg);

        if (argType === 'string' || argType === 'number') {
          classes.push(arg);
        } else if (Array.isArray(arg)) {
          if (arg.length) {
            var inner = classNames.apply(null, arg);

            if (inner) {
              classes.push(inner);
            }
          }
        } else if (argType === 'object') {
          if (arg.toString === Object.prototype.toString) {
            for (var key in arg) {
              if (hasOwn.call(arg, key) && arg[key]) {
                classes.push(key);
              }
            }
          } else {
            classes.push(arg.toString());
          }
        }
      }

      return classes.join(' ');
    }

    if (true && module.exports) {
      classNames["default"] = classNames;
      module.exports = classNames;
    } else if (true && _typeof(__webpack_require__(11)) === 'object' && __webpack_require__(11)) {
      // register as 'classnames', consistent with npm package name
      !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
        return classNames;
      }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else {
      window.classNames = classNames;
    }
  })();
  /***/

},
/* 5 */

/***/
function (module, exports, __webpack_require__) {
  var objectWithoutPropertiesLoose = __webpack_require__(27);

  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = objectWithoutPropertiesLoose(source, excluded);
    var key, i;

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  module.exports = _objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;
  /***/
},
/* 6 */

/***/
function (module, exports, __webpack_require__) {
  var arrayWithHoles = __webpack_require__(30);

  var iterableToArrayLimit = __webpack_require__(31);

  var unsupportedIterableToArray = __webpack_require__(12);

  var nonIterableRest = __webpack_require__(32);

  function _slicedToArray(arr, i) {
    return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
  }

  module.exports = _slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
  /***/
},
/* 7 */

/***/
function (module, exports) {
  /**
  A function that returns a universally unique identifier (uuid).  
  example: 1b83fd69-abe7-468c-bea1-306a8aa1c81d
  @returns `string` : 32 character uuid (see example)
  */
  function uuid() {
    var hashTable = ['a', 'b', 'c', 'd', 'e', 'f', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
    var uuid = [];

    for (var i = 0; i < 35; i++) {
      if (i === 7 || i === 12 || i === 17 || i === 22) {
        uuid[i] = '-';
      } else {
        uuid[i] = hashTable[Math.floor(Math.random() * hashTable.length - 1)];
      }
    }

    return uuid.join('');
  }

  module.exports = uuid;
  /***/
},
/* 8 */

/***/
function (module, exports) {
  function _typeof(obj) {
    "@babel/helpers - typeof";

    return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
  }

  module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;
  /***/
},
/* 9 */

/***/
function (module, exports, __webpack_require__) {
  var arrayWithoutHoles = __webpack_require__(37);

  var iterableToArray = __webpack_require__(38);

  var unsupportedIterableToArray = __webpack_require__(12);

  var nonIterableSpread = __webpack_require__(39);

  function _toConsumableArray(arr) {
    return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
  }

  module.exports = _toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
  /***/
},
/* 10 */

/***/
function (module, exports, __webpack_require__) {
  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }

  var e = g(__webpack_require__(40)),
      t = __webpack_require__(1),
      n = t.Children,
      r = t.cloneElement,
      o = t.Component,
      i = t.createElement,
      l = t.createRef,
      a = g(__webpack_require__(4)),
      c = __webpack_require__(41),
      s = g(c);

  exports.Sortable = s;
  var u = c.Direction;
  exports.Direction = u;
  var f = c.DOMRect;
  exports.DOMRect = f;
  var p = c.GroupOptions;
  exports.GroupOptions = p;
  var d = c.MoveEvent;
  exports.MoveEvent = d;
  var b = c.Options;
  exports.Options = b;
  var y = c.PullResult;
  exports.PullResult = y;
  var v = c.PutResult;
  exports.PutResult = v;
  var h = c.SortableEvent;
  exports.SortableEvent = h;
  var m = c.SortableOptions;
  exports.SortableOptions = m;
  var O = c.Utils;

  function g(e) {
    return e && e.__esModule ? e["default"] : e;
  }

  function w(e, t) {
    if (null == e) return {};

    var n,
        r,
        o = function (e, t) {
      if (null == e) return {};
      var n,
          r,
          o = {},
          i = Object.keys(e);

      for (r = 0; r < i.length; r++) {
        n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
      }

      return o;
    }(e, t);

    if (Object.getOwnPropertySymbols) {
      var i = Object.getOwnPropertySymbols(e);

      for (r = 0; r < i.length; r++) {
        n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
      }
    }

    return o;
  }

  function S(e) {
    return function (e) {
      if (Array.isArray(e)) return j(e);
    }(e) || function (e) {
      if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e);
    }(e) || function (e, t) {
      if (!e) return;
      if ("string" == typeof e) return j(e, t);
      var n = Object.prototype.toString.call(e).slice(8, -1);
      "Object" === n && e.constructor && (n = e.constructor.name);
      if ("Map" === n || "Set" === n) return Array.from(e);
      if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return j(e, t);
    }(e) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }

  function j(e, t) {
    (null == t || t > e.length) && (t = e.length);

    for (var n = 0, r = new Array(t); n < t; n++) {
      r[n] = e[n];
    }

    return r;
  }

  function x(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function I(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? x(Object(n), !0).forEach(function (t) {
        P(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : x(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }

    return e;
  }

  function P(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  function E(e) {
    null !== e.parentElement && e.parentElement.removeChild(e);
  }

  function k(e) {
    e.forEach(function (e) {
      return E(e.element);
    });
  }

  function C(e) {
    e.forEach(function (e) {
      var t, n, r, o;
      t = e.parentElement, n = e.element, r = e.oldIndex, o = t.children[r] || null, t.insertBefore(n, o);
    });
  }

  function D(e, t) {
    var n = M(e),
        r = {
      parentElement: e.from
    },
        o = [];

    switch (n) {
      case "normal":
        o = [{
          element: e.item,
          newIndex: e.newIndex,
          oldIndex: e.oldIndex,
          parentElement: e.from
        }];
        break;

      case "swap":
        o = [I({
          element: e.item,
          oldIndex: e.oldIndex,
          newIndex: e.newIndex
        }, r), I({
          element: e.swapItem,
          oldIndex: e.newIndex,
          newIndex: e.oldIndex
        }, r)];
        break;

      case "multidrag":
        o = e.oldIndicies.map(function (t, n) {
          return I({
            element: t.multiDragElement,
            oldIndex: t.index,
            newIndex: e.newIndicies[n].index
          }, r);
        });
    }

    return function (e, t) {
      return e.map(function (e) {
        return I(I({}, e), {}, {
          item: t[e.oldIndex]
        });
      }).sort(function (e, t) {
        return e.oldIndex - t.oldIndex;
      });
    }(o, t);
  }

  function A(e, t) {
    var n = S(t);
    return e.concat().reverse().forEach(function (e) {
      return n.splice(e.oldIndex, 1);
    }), n;
  }

  function R(e, t, n, r) {
    var o = S(t);
    return e.forEach(function (e) {
      var t = r && n && r(e.item, n);
      o.splice(e.newIndex, 0, t || e.item);
    }), o;
  }

  function M(e) {
    return e.oldIndicies && e.oldIndicies.length > 0 ? "multidrag" : e.swapItem ? "swap" : "normal";
  }

  function U(e) {
    return (U = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
      return _typeof(e);
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
    })(e);
  }

  function L(e) {
    return function (e) {
      if (Array.isArray(e)) return _(e);
    }(e) || function (e) {
      if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e);
    }(e) || function (e, t) {
      if (!e) return;
      if ("string" == typeof e) return _(e, t);
      var n = Object.prototype.toString.call(e).slice(8, -1);
      "Object" === n && e.constructor && (n = e.constructor.name);
      if ("Map" === n || "Set" === n) return Array.from(e);
      if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _(e, t);
    }(e) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }

  function _(e, t) {
    (null == t || t > e.length) && (t = e.length);

    for (var n = 0, r = new Array(t); n < t; n++) {
      r[n] = e[n];
    }

    return r;
  }

  function H(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function N(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? H(Object(n), !0).forEach(function (t) {
        B(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : H(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }

    return e;
  }

  function q(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  function T(e, t) {
    return (T = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  function F(e) {
    var t = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;

      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }();

    return function () {
      var n,
          r = $(e);

      if (t) {
        var o = $(this).constructor;
        n = Reflect.construct(r, arguments, o);
      } else n = r.apply(this, arguments);

      return G(this, n);
    };
  }

  function G(e, t) {
    return !t || "object" !== U(t) && "function" != typeof t ? function (e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }(e) : t;
  }

  function $(e) {
    return ($ = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function B(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  exports.Utils = O;

  var J = {
    dragging: null
  },
      z = function (t) {
    !function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && T(e, t);
    }(d, o);
    var c,
        u,
        f,
        p = F(d);

    function d(t) {
      var n;
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, d), (n = p.call(this, t)).ref = l();
      var r = t.list.map(function (e) {
        return N(N({}, e), {}, {
          chosen: !1,
          selected: !1
        });
      });
      return t.setList(r, n.sortable, J), e(!t.plugins, '\nPlugins prop is no longer supported.\nInstead, mount it with "Sortable.mount(new MultiDrag())"\nPlease read the updated README.md at https://github.com/SortableJS/react-sortablejs.\n      '), n;
    }

    return c = d, (u = [{
      key: "componentDidMount",
      value: function value() {
        if (null !== this.ref.current) {
          var e = this.makeOptions();
          s.create(this.ref.current, e);
        }
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.props,
            t = e.tag,
            n = {
          style: e.style,
          className: e.className,
          id: e.id
        };
        return i(t && null !== t ? t : "div", N({
          ref: this.ref
        }, n), this.getChildren());
      }
    }, {
      key: "getChildren",
      value: function value() {
        var e = this.props,
            t = e.children,
            o = e.dataIdAttr,
            i = e.selectedClass,
            l = void 0 === i ? "sortable-selected" : i,
            c = e.chosenClass,
            s = void 0 === c ? "sortable-chosen" : c,
            u = (e.dragClass, e.fallbackClass, e.ghostClass, e.swapClass, e.filter),
            f = void 0 === u ? "sortable-filter" : u,
            p = e.list;
        if (!t || null == t) return null;
        var d = o || "data-id";
        return n.map(t, function (e, t) {
          var n,
              o,
              i = p[t],
              c = e.props.className,
              u = "string" == typeof f && B({}, f.replace(".", ""), !!i.filtered),
              b = a(c, N((B(n = {}, l, i.selected), B(n, s, i.chosen), n), u));
          return r(e, (B(o = {}, d, e.key), B(o, "className", b), o));
        });
      }
    }, {
      key: "makeOptions",
      value: function value() {
        var e,
            t = this,
            n = ((e = this.props).list, e.setList, e.children, e.tag, e.style, e.className, e.clone, e.onAdd, e.onChange, e.onChoose, e.onClone, e.onEnd, e.onFilter, e.onRemove, e.onSort, e.onStart, e.onUnchoose, e.onUpdate, e.onMove, e.onSpill, e.onSelect, e.onDeselect, w(e, ["list", "setList", "children", "tag", "style", "className", "clone", "onAdd", "onChange", "onChoose", "onClone", "onEnd", "onFilter", "onRemove", "onSort", "onStart", "onUnchoose", "onUpdate", "onMove", "onSpill", "onSelect", "onDeselect"]));
        return ["onAdd", "onChoose", "onDeselect", "onEnd", "onRemove", "onSelect", "onSpill", "onStart", "onUnchoose", "onUpdate"].forEach(function (e) {
          return n[e] = t.prepareOnHandlerPropAndDOM(e);
        }), ["onChange", "onClone", "onFilter", "onSort"].forEach(function (e) {
          return n[e] = t.prepareOnHandlerProp(e);
        }), N(N({}, n), {}, {
          onMove: function onMove(e, n) {
            var r = t.props.onMove,
                o = e.willInsertAfter || -1;
            if (!r) return o;
            var i = r(e, n, t.sortable, J);
            return void 0 !== i && i;
          }
        });
      }
    }, {
      key: "prepareOnHandlerPropAndDOM",
      value: function value(e) {
        var t = this;
        return function (n) {
          t.callOnHandlerProp(n, e), t[e](n);
        };
      }
    }, {
      key: "prepareOnHandlerProp",
      value: function value(e) {
        var t = this;
        return function (n) {
          t.callOnHandlerProp(n, e);
        };
      }
    }, {
      key: "callOnHandlerProp",
      value: function value(e, t) {
        var n = this.props[t];
        n && n(e, this.sortable, J);
      }
    }, {
      key: "onAdd",
      value: function value(e) {
        var t = this.props,
            n = t.list,
            r = t.setList,
            o = t.clone,
            i = D(e, L(J.dragging.props.list));
        k(i), r(R(i, n, e, o).map(function (e) {
          return N(N({}, e), {}, {
            selected: !1
          });
        }), this.sortable, J);
      }
    }, {
      key: "onRemove",
      value: function value(t) {
        var n = this,
            r = this.props,
            o = r.list,
            i = r.setList,
            l = M(t),
            a = D(t, o);
        C(a);
        var c = L(o);
        if ("clone" !== t.pullMode) c = A(a, c);else {
          var s = a;

          switch (l) {
            case "multidrag":
              s = a.map(function (e, n) {
                return N(N({}, e), {}, {
                  element: t.clones[n]
                });
              });
              break;

            case "normal":
              s = a.map(function (e) {
                return N(N({}, e), {}, {
                  element: t.clone
                });
              });
              break;

            case "swap":
            default:
              e(!0, 'mode "'.concat(l, '" cannot clone. Please remove "props.clone" from <ReactSortable/> when using the "').concat(l, '" plugin'));
          }

          k(s), a.forEach(function (e) {
            var r = e.oldIndex,
                o = n.props.clone(e.item, t);
            c.splice(r, 1, o);
          });
        }
        i(c = c.map(function (e) {
          return N(N({}, e), {}, {
            selected: !1
          });
        }), this.sortable, J);
      }
    }, {
      key: "onUpdate",
      value: function value(e) {
        var t = this.props,
            n = t.list,
            r = t.setList,
            o = D(e, n);
        return k(o), C(o), r(function (e, t) {
          return R(e, A(e, t));
        }(o, n), this.sortable, J);
      }
    }, {
      key: "onStart",
      value: function value() {
        J.dragging = this;
      }
    }, {
      key: "onEnd",
      value: function value() {
        J.dragging = null;
      }
    }, {
      key: "onChoose",
      value: function value(e) {
        var t = this.props,
            n = t.list;
        (0, t.setList)(n.map(function (t, n) {
          return n === e.oldIndex ? N(N({}, t), {}, {
            chosen: !0
          }) : t;
        }), this.sortable, J);
      }
    }, {
      key: "onUnchoose",
      value: function value(e) {
        var t = this.props,
            n = t.list;
        (0, t.setList)(n.map(function (t, n) {
          return n === e.oldIndex ? N(N({}, t), {}, {
            chosen: !1
          }) : t;
        }), this.sortable, J);
      }
    }, {
      key: "onSpill",
      value: function value(e) {
        var t = this.props,
            n = t.removeOnSpill,
            r = t.revertOnSpill;
        n && !r && E(e.item);
      }
    }, {
      key: "onSelect",
      value: function value(e) {
        var t = this.props,
            n = t.list,
            r = t.setList,
            o = n.map(function (e) {
          return N(N({}, e), {}, {
            selected: !1
          });
        });
        e.newIndicies.forEach(function (t) {
          var n = t.index;
          if (-1 === n) return console.log('"'.concat(e.type, '" had indice of "').concat(t.index, "\", which is probably -1 and doesn't usually happen here.")), void console.log(e);
          o[n].selected = !0;
        }), r(o, this.sortable, J);
      }
    }, {
      key: "onDeselect",
      value: function value(e) {
        var t = this.props,
            n = t.list,
            r = t.setList,
            o = n.map(function (e) {
          return N(N({}, e), {}, {
            selected: !1
          });
        });
        e.newIndicies.forEach(function (e) {
          var t = e.index;
          -1 !== t && (o[t].selected = !0);
        }), r(o, this.sortable, J);
      }
    }, {
      key: "sortable",
      get: function get() {
        var e = this.ref.current;
        if (null === e) return null;
        var t = Object.keys(e).find(function (e) {
          return e.includes("Sortable");
        });
        return t ? e[t] : null;
      }
    }]) && q(c.prototype, u), f && q(c, f), d;
  }();

  exports.ReactSortable = z, B(z, "defaultProps", {
    clone: function clone(e) {
      return e;
    }
  });
  /***/
},
/* 11 */

/***/
function (module, exports) {
  /* WEBPACK VAR INJECTION */
  (function (__webpack_amd_options__) {
    /* globals __webpack_amd_options__ */
    module.exports = __webpack_amd_options__;
    /* WEBPACK VAR INJECTION */
  }).call(this, {});
  /***/
},
/* 12 */

/***/
function (module, exports, __webpack_require__) {
  var arrayLikeToArray = __webpack_require__(13);

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
  }

  module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
  /***/
},
/* 13 */

/***/
function (module, exports) {
  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }

  module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
  /***/
},
/* 14 */

/***/
function (module, exports) {
  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  /**
   * Checks if `value` is the
   * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
   * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an object, else `false`.
   * @example
   *
   * _.isObject({});
   * // => true
   *
   * _.isObject([1, 2, 3]);
   * // => true
   *
   * _.isObject(_.noop);
   * // => true
   *
   * _.isObject(null);
   * // => false
   */


  function isObject(value) {
    var type = _typeof(value);

    return value != null && (type == 'object' || type == 'function');
  }

  module.exports = isObject;
  /***/
},
/* 15 */

/***/
function (module, exports, __webpack_require__) {
  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }

  var freeGlobal = __webpack_require__(44);
  /** Detect free variable `self`. */


  var freeSelf = (typeof self === "undefined" ? "undefined" : _typeof(self)) == 'object' && self && self.Object === Object && self;
  /** Used as a reference to the global object. */

  var root = freeGlobal || freeSelf || Function('return this')();
  module.exports = root;
  /***/
},
/* 16 */

/***/
function (module, exports, __webpack_require__) {
  var root = __webpack_require__(15);
  /** Built-in value references. */


  var _Symbol = root.Symbol;
  module.exports = _Symbol;
  /***/
},
/* 17 */

/***/
function (module, exports, __webpack_require__) {
  var reactProperty = __webpack_require__(55);

  var utilities = __webpack_require__(18);

  var setStyleProp = utilities.setStyleProp;
  var htmlProperties = reactProperty.html;
  var svgProperties = reactProperty.svg;
  var isCustomAttribute = reactProperty.isCustomAttribute;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  /**
   * Converts HTML/SVG DOM attributes to React props.
   *
   * @param  {object} [attributes={}] - HTML/SVG DOM attributes.
   * @return {object}                 - React props.
   */

  function attributesToProps(attributes) {
    attributes = attributes || {};
    var attributeName;
    var attributeNameLowerCased;
    var attributeValue;
    var property;
    var props = {};

    for (attributeName in attributes) {
      attributeValue = attributes[attributeName]; // ARIA (aria-*) or custom data (data-*) attribute

      if (isCustomAttribute(attributeName)) {
        props[attributeName] = attributeValue;
        continue;
      } // convert HTML attribute to React prop


      attributeNameLowerCased = attributeName.toLowerCase();

      if (hasOwnProperty.call(htmlProperties, attributeNameLowerCased)) {
        property = htmlProperties[attributeNameLowerCased];
        props[property.propertyName] = property.hasBooleanValue || property.hasOverloadedBooleanValue && !attributeValue ? true : attributeValue;
        continue;
      } // convert SVG attribute to React prop


      if (hasOwnProperty.call(svgProperties, attributeName)) {
        property = svgProperties[attributeName];
        props[property.propertyName] = attributeValue;
        continue;
      } // preserve custom attribute if React >=16


      if (utilities.PRESERVE_CUSTOM_ATTRIBUTES) {
        props[attributeName] = attributeValue;
      }
    } // transform inline style to object


    setStyleProp(attributes.style, props);
    return props;
  }

  module.exports = attributesToProps;
  /***/
},
/* 18 */

/***/
function (module, exports, __webpack_require__) {
  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }

  var React = __webpack_require__(1);

  var styleToJS = __webpack_require__(59)["default"];
  /**
   * Swap key with value in an object.
   *
   * @param  {Object}   obj        - The object.
   * @param  {Function} [override] - The override method.
   * @return {Object}              - The inverted object.
   */


  function invertObject(obj, override) {
    if (!obj || _typeof(obj) !== 'object') {
      throw new TypeError('First argument must be an object');
    }

    var key;
    var value;
    var isOverridePresent = typeof override === 'function';
    var overrides = {};
    var result = {};

    for (key in obj) {
      value = obj[key];

      if (isOverridePresent) {
        overrides = override(key, value);

        if (overrides && overrides.length === 2) {
          result[overrides[0]] = overrides[1];
          continue;
        }
      }

      if (typeof value === 'string') {
        result[value] = key;
      }
    }

    return result;
  }
  /**
   * Check if a given tag is a custom component.
   *
   * @see {@link https://github.com/facebook/react/blob/v16.6.3/packages/react-dom/src/shared/isCustomComponent.js}
   *
   * @param {string} tagName - The name of the html tag.
   * @param {Object} props   - The props being passed to the element.
   * @return {boolean}
   */


  function isCustomComponent(tagName, props) {
    if (tagName.indexOf('-') === -1) {
      return props && typeof props.is === 'string';
    }

    switch (tagName) {
      // These are reserved SVG and MathML elements.
      // We don't mind this whitelist too much because we expect it to never grow.
      // The alternative is to track the namespace in a few places which is convoluted.
      // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
      case 'annotation-xml':
      case 'color-profile':
      case 'font-face':
      case 'font-face-src':
      case 'font-face-uri':
      case 'font-face-format':
      case 'font-face-name':
      case 'missing-glyph':
        return false;

      default:
        return true;
    }
  }

  var styleToJSOptions = {
    reactCompat: true
  };
  /**
   * Sets style prop.
   *
   * @param {null|undefined|string} style
   * @param {object} props
   */

  function setStyleProp(style, props) {
    if (style === null || style === undefined) {
      return;
    }

    props.style = styleToJS(style, styleToJSOptions);
  }
  /**
   * @constant {boolean}
   * @see {@link https://reactjs.org/blog/2017/09/08/dom-attributes-in-react-16.html}
   */


  var PRESERVE_CUSTOM_ATTRIBUTES = React.version.split('.')[0] >= 16;
  module.exports = {
    PRESERVE_CUSTOM_ATTRIBUTES: PRESERVE_CUSTOM_ATTRIBUTES,
    invertObject: invertObject,
    isCustomComponent: isCustomComponent,
    setStyleProp: setStyleProp
  };
  /***/
},
/* 19 */

/***/
function (module, exports, __webpack_require__) {
  var CASE_SENSITIVE_TAG_NAMES = __webpack_require__(65).CASE_SENSITIVE_TAG_NAMES;

  var caseSensitiveTagNamesMap = {};
  var tagName;

  for (var i = 0, len = CASE_SENSITIVE_TAG_NAMES.length; i < len; i++) {
    tagName = CASE_SENSITIVE_TAG_NAMES[i];
    caseSensitiveTagNamesMap[tagName.toLowerCase()] = tagName;
  }
  /**
   * Gets case-sensitive tag name.
   *
   * @param  {String}           tagName - The lowercase tag name.
   * @return {String|undefined}
   */


  function getCaseSensitiveTagName(tagName) {
    return caseSensitiveTagNamesMap[tagName];
  }
  /**
   * Formats DOM attributes to a hash map.
   *
   * @param  {NamedNodeMap} attributes - The list of attributes.
   * @return {Object}                  - A map of attribute name to value.
   */


  function formatAttributes(attributes) {
    var result = {};
    var attribute; // `NamedNodeMap` is array-like

    for (var i = 0, len = attributes.length; i < len; i++) {
      attribute = attributes[i];
      result[attribute.name] = attribute.value;
    }

    return result;
  }
  /**
   * Corrects the tag name if it is case-sensitive (SVG).
   * Otherwise, returns the lowercase tag name (HTML).
   *
   * @param  {String} tagName - The lowercase tag name.
   * @return {String}         - The formatted tag name.
   */


  function formatTagName(tagName) {
    tagName = tagName.toLowerCase();
    var caseSensitiveTagName = getCaseSensitiveTagName(tagName);

    if (caseSensitiveTagName) {
      return caseSensitiveTagName;
    }

    return tagName;
  }
  /**
   * Formats the browser DOM nodes to mimic the output of `htmlparser2.parseDOM()`.
   *
   * @param  {NodeList} nodes        - The DOM nodes.
   * @param  {Object}   [parentObj]  - The formatted parent node.
   * @param  {String}   [directive]  - The directive.
   * @return {Object[]}              - The formatted DOM object.
   */


  function formatDOM(nodes, parentObj, directive) {
    parentObj = parentObj || null;
    var result = [];
    var node;
    var prevNode;
    var nodeObj; // `NodeList` is array-like

    for (var i = 0, len = nodes.length; i < len; i++) {
      node = nodes[i]; // reset

      nodeObj = {
        next: null,
        prev: result[i - 1] || null,
        parent: parentObj
      }; // set the next node for the previous node (if applicable)

      prevNode = result[i - 1];

      if (prevNode) {
        prevNode.next = nodeObj;
      } // set the node name if it's not "#text" or "#comment"
      // e.g., "div"


      if (node.nodeName[0] !== '#') {
        nodeObj.name = formatTagName(node.nodeName); // also, nodes of type "tag" have "attribs"

        nodeObj.attribs = {}; // default

        if (node.attributes && node.attributes.length) {
          nodeObj.attribs = formatAttributes(node.attributes);
        }
      } // set the node type
      // e.g., "tag"


      switch (node.nodeType) {
        // 1 = element
        case 1:
          if (nodeObj.name === 'script' || nodeObj.name === 'style') {
            nodeObj.type = nodeObj.name;
          } else {
            nodeObj.type = 'tag';
          } // recursively format the children


          nodeObj.children = formatDOM(node.childNodes, nodeObj);
          break;
        // 2 = attribute
        // 3 = text

        case 3:
          nodeObj.type = 'text';
          nodeObj.data = node.nodeValue;
          break;
        // 8 = comment

        case 8:
          nodeObj.type = 'comment';
          nodeObj.data = node.nodeValue;
          break;
      }

      result.push(nodeObj);
    }

    if (directive) {
      result.unshift({
        name: directive.substring(0, directive.indexOf(' ')).toLowerCase(),
        data: directive,
        type: 'directive',
        next: result[0] ? result[0] : null,
        prev: null,
        parent: parentObj
      });

      if (result[1]) {
        result[1].prev = result[0];
      }
    }

    return result;
  }
  /**
   * Detects IE with or without version.
   *
   * @param  {Number}  [version] - The IE version to detect.
   * @return {Boolean}           - Whether IE or the version has been detected.
   */


  function isIE(version) {
    if (version) {
      return document.documentMode === version;
    }

    return /(MSIE |Trident\/|Edge\/)/.test(navigator.userAgent);
  }

  module.exports = {
    formatAttributes: formatAttributes,
    formatDOM: formatDOM,
    isIE: isIE
  };
  /***/
},
/* 20 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') {
      return;
    }

    if (false) {}

    try {
      // Verify that the code above has been dead code eliminated (DCE'd).
      __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
      // DevTools shouldn't crash React, no matter what.
      // We should still report in case we break this code.
      console.error(err);
    }
  }

  if (true) {
    // DCE check should happen before ReactDOM bundle executes so that
    // DevTools can report bad minification during injection.
    checkDCE();
    module.exports = __webpack_require__(33);
  } else {}
  /***/

},
/* 21 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }

  Object.defineProperty(exports, '__esModule', {
    value: true
  });
  var win$1 = window;

  var raf = win$1.requestAnimationFrame || win$1.webkitRequestAnimationFrame || win$1.mozRequestAnimationFrame || win$1.msRequestAnimationFrame || function (cb) {
    return setTimeout(cb, 16);
  };

  var win = window;

  var caf = win.cancelAnimationFrame || win.mozCancelAnimationFrame || function (id) {
    clearTimeout(id);
  };

  function extend() {
    var obj,
        name,
        copy,
        target = arguments[0] || {},
        i = 1,
        length = arguments.length;

    for (; i < length; i++) {
      if ((obj = arguments[i]) !== null) {
        for (name in obj) {
          copy = obj[name];

          if (target === copy) {
            continue;
          } else if (copy !== undefined) {
            target[name] = copy;
          }
        }
      }
    }

    return target;
  }

  function checkStorageValue(value) {
    return ['true', 'false'].indexOf(value) >= 0 ? JSON.parse(value) : value;
  }

  function setLocalStorage(storage, key, value, access) {
    if (access) {
      try {
        storage.setItem(key, value);
      } catch (e) {}
    }

    return value;
  }

  function getSlideId() {
    var id = window.tnsId;
    window.tnsId = !id ? 1 : id + 1;
    return 'tns' + window.tnsId;
  }

  function getBody() {
    var doc = document,
        body = doc.body;

    if (!body) {
      body = doc.createElement('body');
      body.fake = true;
    }

    return body;
  }

  var docElement = document.documentElement;

  function setFakeBody(body) {
    var docOverflow = '';

    if (body.fake) {
      docOverflow = docElement.style.overflow; //avoid crashing IE8, if background image is used

      body.style.background = ''; //Safari 5.13/5.1.4 OSX stops loading if ::-webkit-scrollbar is used and scrollbars are visible

      body.style.overflow = docElement.style.overflow = 'hidden';
      docElement.appendChild(body);
    }

    return docOverflow;
  }

  function resetFakeBody(body, docOverflow) {
    if (body.fake) {
      body.remove();
      docElement.style.overflow = docOverflow; // Trigger layout so kinetic scrolling isn't disabled in iOS6+
      // eslint-disable-next-line

      docElement.offsetHeight;
    }
  } // get css-calc 


  function calc() {
    var doc = document,
        body = getBody(),
        docOverflow = setFakeBody(body),
        div = doc.createElement('div'),
        result = false;
    body.appendChild(div);

    try {
      var str = '(10px * 10)',
          vals = ['calc' + str, '-moz-calc' + str, '-webkit-calc' + str],
          val;

      for (var i = 0; i < 3; i++) {
        val = vals[i];
        div.style.width = val;

        if (div.offsetWidth === 100) {
          result = val.replace(str, '');
          break;
        }
      }
    } catch (e) {}

    body.fake ? resetFakeBody(body, docOverflow) : div.remove();
    return result;
  } // get subpixel support value


  function percentageLayout() {
    // check subpixel layout supporting
    var doc = document,
        body = getBody(),
        docOverflow = setFakeBody(body),
        wrapper = doc.createElement('div'),
        outer = doc.createElement('div'),
        str = '',
        count = 70,
        perPage = 3,
        supported = false;
    wrapper.className = "tns-t-subp2";
    outer.className = "tns-t-ct";

    for (var i = 0; i < count; i++) {
      str += '<div></div>';
    }

    outer.innerHTML = str;
    wrapper.appendChild(outer);
    body.appendChild(wrapper);
    supported = Math.abs(wrapper.getBoundingClientRect().left - outer.children[count - perPage].getBoundingClientRect().left) < 2;
    body.fake ? resetFakeBody(body, docOverflow) : wrapper.remove();
    return supported;
  }

  function mediaquerySupport() {
    if (window.matchMedia || window.msMatchMedia) {
      return true;
    }

    var doc = document,
        body = getBody(),
        docOverflow = setFakeBody(body),
        div = doc.createElement('div'),
        style = doc.createElement('style'),
        rule = '@media all and (min-width:1px){.tns-mq-test{position:absolute}}',
        position;
    style.type = 'text/css';
    div.className = 'tns-mq-test';
    body.appendChild(style);
    body.appendChild(div);

    if (style.styleSheet) {
      style.styleSheet.cssText = rule;
    } else {
      style.appendChild(doc.createTextNode(rule));
    }

    position = window.getComputedStyle ? window.getComputedStyle(div).position : div.currentStyle['position'];
    body.fake ? resetFakeBody(body, docOverflow) : div.remove();
    return position === "absolute";
  } // create and append style sheet


  function createStyleSheet(media, nonce) {
    // Create the <style> tag
    var style = document.createElement("style"); // style.setAttribute("type", "text/css");
    // Add a media (and/or media query) here if you'd like!
    // style.setAttribute("media", "screen")
    // style.setAttribute("media", "only screen and (max-width : 1024px)")

    if (media) {
      style.setAttribute("media", media);
    } // Add nonce attribute for Content Security Policy


    if (nonce) {
      style.setAttribute("nonce", nonce);
    } // WebKit hack :(
    // style.appendChild(document.createTextNode(""));
    // Add the <style> element to the page


    document.querySelector('head').appendChild(style);
    return style.sheet ? style.sheet : style.styleSheet;
  } // cross browsers addRule method


  function addCSSRule(sheet, selector, rules, index) {
    // return raf(function() {
    'insertRule' in sheet ? sheet.insertRule(selector + '{' + rules + '}', index) : sheet.addRule(selector, rules, index); // });
  } // cross browsers addRule method


  function removeCSSRule(sheet, index) {
    // return raf(function() {
    'deleteRule' in sheet ? sheet.deleteRule(index) : sheet.removeRule(index); // });
  }

  function getCssRulesLength(sheet) {
    var rule = 'insertRule' in sheet ? sheet.cssRules : sheet.rules;
    return rule.length;
  }

  function toDegree(y, x) {
    return Math.atan2(y, x) * (180 / Math.PI);
  }

  function getTouchDirection(angle, range) {
    var direction = false,
        gap = Math.abs(90 - Math.abs(angle));

    if (gap >= 90 - range) {
      direction = 'horizontal';
    } else if (gap <= range) {
      direction = 'vertical';
    }

    return direction;
  } // https://toddmotto.com/ditch-the-array-foreach-call-nodelist-hack/


  function forEach(arr, callback, scope) {
    for (var i = 0, l = arr.length; i < l; i++) {
      callback.call(scope, arr[i], i);
    }
  }

  var classListSupport = ('classList' in document.createElement('_'));
  var hasClass = classListSupport ? function (el, str) {
    return el.classList.contains(str);
  } : function (el, str) {
    return el.className.indexOf(str) >= 0;
  };
  var addClass = classListSupport ? function (el, str) {
    if (!hasClass(el, str)) {
      el.classList.add(str);
    }
  } : function (el, str) {
    if (!hasClass(el, str)) {
      el.className += ' ' + str;
    }
  };
  var removeClass = classListSupport ? function (el, str) {
    if (hasClass(el, str)) {
      el.classList.remove(str);
    }
  } : function (el, str) {
    if (hasClass(el, str)) {
      el.className = el.className.replace(str, '');
    }
  };

  function hasAttr(el, attr) {
    return el.hasAttribute(attr);
  }

  function getAttr(el, attr) {
    return el.getAttribute(attr);
  }

  function isNodeList(el) {
    // Only NodeList has the "item()" function
    return typeof el.item !== "undefined";
  }

  function setAttrs(els, attrs) {
    els = isNodeList(els) || els instanceof Array ? els : [els];

    if (Object.prototype.toString.call(attrs) !== '[object Object]') {
      return;
    }

    for (var i = els.length; i--;) {
      for (var key in attrs) {
        els[i].setAttribute(key, attrs[key]);
      }
    }
  }

  function removeAttrs(els, attrs) {
    els = isNodeList(els) || els instanceof Array ? els : [els];
    attrs = attrs instanceof Array ? attrs : [attrs];
    var attrLength = attrs.length;

    for (var i = els.length; i--;) {
      for (var j = attrLength; j--;) {
        els[i].removeAttribute(attrs[j]);
      }
    }
  }

  function arrayFromNodeList(nl) {
    var arr = [];

    for (var i = 0, l = nl.length; i < l; i++) {
      arr.push(nl[i]);
    }

    return arr;
  }

  function hideElement(el, forceHide) {
    if (el.style.display !== 'none') {
      el.style.display = 'none';
    }
  }

  function showElement(el, forceHide) {
    if (el.style.display === 'none') {
      el.style.display = '';
    }
  }

  function isVisible(el) {
    return window.getComputedStyle(el).display !== 'none';
  }

  function whichProperty(props) {
    if (typeof props === 'string') {
      var arr = [props],
          Props = props.charAt(0).toUpperCase() + props.substr(1),
          prefixes = ['Webkit', 'Moz', 'ms', 'O'];
      prefixes.forEach(function (prefix) {
        if (prefix !== 'ms' || props === 'transform') {
          arr.push(prefix + Props);
        }
      });
      props = arr;
    }

    var el = document.createElement('fakeelement');
    props.length;

    for (var i = 0; i < props.length; i++) {
      var prop = props[i];

      if (el.style[prop] !== undefined) {
        return prop;
      }
    }

    return false; // explicit for ie9-
  }

  function has3DTransforms(tf) {
    if (!tf) {
      return false;
    }

    if (!window.getComputedStyle) {
      return false;
    }

    var doc = document,
        body = getBody(),
        docOverflow = setFakeBody(body),
        el = doc.createElement('p'),
        has3d,
        cssTF = tf.length > 9 ? '-' + tf.slice(0, -9).toLowerCase() + '-' : '';
    cssTF += 'transform'; // Add it to the body to get the computed style

    body.insertBefore(el, null);
    el.style[tf] = 'translate3d(1px,1px,1px)';
    has3d = window.getComputedStyle(el).getPropertyValue(cssTF);
    body.fake ? resetFakeBody(body, docOverflow) : el.remove();
    return has3d !== undefined && has3d.length > 0 && has3d !== "none";
  } // get transitionend, animationend based on transitionDuration
  // @propin: string
  // @propOut: string, first-letter uppercase
  // Usage: getEndProperty('WebkitTransitionDuration', 'Transition') => webkitTransitionEnd


  function getEndProperty(propIn, propOut) {
    var endProp = false;

    if (/^Webkit/.test(propIn)) {
      endProp = 'webkit' + propOut + 'End';
    } else if (/^O/.test(propIn)) {
      endProp = 'o' + propOut + 'End';
    } else if (propIn) {
      endProp = propOut.toLowerCase() + 'end';
    }

    return endProp;
  } // Test via a getter in the options object to see if the passive property is accessed


  var supportsPassive = false;

  try {
    var opts = Object.defineProperty({}, 'passive', {
      get: function get() {
        supportsPassive = true;
      }
    });
    window.addEventListener("test", null, opts);
  } catch (e) {}

  var passiveOption = supportsPassive ? {
    passive: true
  } : false;

  function addEvents(el, obj, preventScrolling) {
    for (var prop in obj) {
      var option = ['touchstart', 'touchmove'].indexOf(prop) >= 0 && !preventScrolling ? passiveOption : false;
      el.addEventListener(prop, obj[prop], option);
    }
  }

  function removeEvents(el, obj) {
    for (var prop in obj) {
      var option = ['touchstart', 'touchmove'].indexOf(prop) >= 0 ? passiveOption : false;
      el.removeEventListener(prop, obj[prop], option);
    }
  }

  function Events() {
    return {
      topics: {},
      on: function on(eventName, fn) {
        this.topics[eventName] = this.topics[eventName] || [];
        this.topics[eventName].push(fn);
      },
      off: function off(eventName, fn) {
        if (this.topics[eventName]) {
          for (var i = 0; i < this.topics[eventName].length; i++) {
            if (this.topics[eventName][i] === fn) {
              this.topics[eventName].splice(i, 1);
              break;
            }
          }
        }
      },
      emit: function emit(eventName, data) {
        data.type = eventName;

        if (this.topics[eventName]) {
          this.topics[eventName].forEach(function (fn) {
            fn(data, eventName);
          });
        }
      }
    };
  }

  function jsTransform(element, attr, prefix, postfix, to, duration, callback) {
    var tick = Math.min(duration, 10),
        unit = to.indexOf('%') >= 0 ? '%' : 'px',
        to = to.replace(unit, ''),
        from = Number(element.style[attr].replace(prefix, '').replace(postfix, '').replace(unit, '')),
        positionTick = (to - from) / duration * tick;
    setTimeout(moveElement, tick);

    function moveElement() {
      duration -= tick;
      from += positionTick;
      element.style[attr] = prefix + from + unit + postfix;

      if (duration > 0) {
        setTimeout(moveElement, tick);
      } else {
        callback();
      }
    }
  } // Object.keys


  if (!Object.keys) {
    Object.keys = function (object) {
      var keys = [];

      for (var name in object) {
        if (Object.prototype.hasOwnProperty.call(object, name)) {
          keys.push(name);
        }
      }

      return keys;
    };
  } // ChildNode.remove


  if (!("remove" in Element.prototype)) {
    Element.prototype.remove = function () {
      if (this.parentNode) {
        this.parentNode.removeChild(this);
      }
    };
  }

  var tns = function tns(options) {
    options = extend({
      container: '.slider',
      mode: 'carousel',
      axis: 'horizontal',
      items: 1,
      gutter: 0,
      edgePadding: 0,
      fixedWidth: false,
      autoWidth: false,
      viewportMax: false,
      slideBy: 1,
      center: false,
      controls: true,
      controlsPosition: 'top',
      controlsText: ['prev', 'next'],
      controlsContainer: false,
      prevButton: false,
      nextButton: false,
      nav: true,
      navPosition: 'top',
      navContainer: false,
      navAsThumbnails: false,
      arrowKeys: false,
      speed: 300,
      autoplay: false,
      autoplayPosition: 'top',
      autoplayTimeout: 5000,
      autoplayDirection: 'forward',
      autoplayText: ['start', 'stop'],
      autoplayHoverPause: false,
      autoplayButton: false,
      autoplayButtonOutput: true,
      autoplayResetOnVisibility: true,
      animateIn: 'tns-fadeIn',
      animateOut: 'tns-fadeOut',
      animateNormal: 'tns-normal',
      animateDelay: false,
      loop: true,
      rewind: false,
      autoHeight: false,
      responsive: false,
      lazyload: false,
      lazyloadSelector: '.tns-lazy-img',
      touch: true,
      mouseDrag: false,
      swipeAngle: 15,
      nested: false,
      preventActionWhenRunning: false,
      preventScrollOnTouch: false,
      freezable: true,
      onInit: false,
      useLocalStorage: true,
      nonce: false
    }, options || {});
    var doc = document,
        win = window,
        KEYS = {
      ENTER: 13,
      SPACE: 32,
      LEFT: 37,
      RIGHT: 39
    },
        tnsStorage = {},
        localStorageAccess = options.useLocalStorage;

    if (localStorageAccess) {
      // check browser version and local storage access
      var browserInfo = navigator.userAgent;
      var uid = new Date();

      try {
        tnsStorage = win.localStorage;

        if (tnsStorage) {
          tnsStorage.setItem(uid, uid);
          localStorageAccess = tnsStorage.getItem(uid) == uid;
          tnsStorage.removeItem(uid);
        } else {
          localStorageAccess = false;
        }

        if (!localStorageAccess) {
          tnsStorage = {};
        }
      } catch (e) {
        localStorageAccess = false;
      }

      if (localStorageAccess) {
        // remove storage when browser version changes
        if (tnsStorage['tnsApp'] && tnsStorage['tnsApp'] !== browserInfo) {
          ['tC', 'tPL', 'tMQ', 'tTf', 't3D', 'tTDu', 'tTDe', 'tADu', 'tADe', 'tTE', 'tAE'].forEach(function (item) {
            tnsStorage.removeItem(item);
          });
        } // update browserInfo


        localStorage['tnsApp'] = browserInfo;
      }
    }

    var CALC = tnsStorage['tC'] ? checkStorageValue(tnsStorage['tC']) : setLocalStorage(tnsStorage, 'tC', calc(), localStorageAccess),
        PERCENTAGELAYOUT = tnsStorage['tPL'] ? checkStorageValue(tnsStorage['tPL']) : setLocalStorage(tnsStorage, 'tPL', percentageLayout(), localStorageAccess),
        CSSMQ = tnsStorage['tMQ'] ? checkStorageValue(tnsStorage['tMQ']) : setLocalStorage(tnsStorage, 'tMQ', mediaquerySupport(), localStorageAccess),
        TRANSFORM = tnsStorage['tTf'] ? checkStorageValue(tnsStorage['tTf']) : setLocalStorage(tnsStorage, 'tTf', whichProperty('transform'), localStorageAccess),
        HAS3DTRANSFORMS = tnsStorage['t3D'] ? checkStorageValue(tnsStorage['t3D']) : setLocalStorage(tnsStorage, 't3D', has3DTransforms(TRANSFORM), localStorageAccess),
        TRANSITIONDURATION = tnsStorage['tTDu'] ? checkStorageValue(tnsStorage['tTDu']) : setLocalStorage(tnsStorage, 'tTDu', whichProperty('transitionDuration'), localStorageAccess),
        TRANSITIONDELAY = tnsStorage['tTDe'] ? checkStorageValue(tnsStorage['tTDe']) : setLocalStorage(tnsStorage, 'tTDe', whichProperty('transitionDelay'), localStorageAccess),
        ANIMATIONDURATION = tnsStorage['tADu'] ? checkStorageValue(tnsStorage['tADu']) : setLocalStorage(tnsStorage, 'tADu', whichProperty('animationDuration'), localStorageAccess),
        ANIMATIONDELAY = tnsStorage['tADe'] ? checkStorageValue(tnsStorage['tADe']) : setLocalStorage(tnsStorage, 'tADe', whichProperty('animationDelay'), localStorageAccess),
        TRANSITIONEND = tnsStorage['tTE'] ? checkStorageValue(tnsStorage['tTE']) : setLocalStorage(tnsStorage, 'tTE', getEndProperty(TRANSITIONDURATION, 'Transition'), localStorageAccess),
        ANIMATIONEND = tnsStorage['tAE'] ? checkStorageValue(tnsStorage['tAE']) : setLocalStorage(tnsStorage, 'tAE', getEndProperty(ANIMATIONDURATION, 'Animation'), localStorageAccess); // get element nodes from selectors

    var supportConsoleWarn = win.console && typeof win.console.warn === "function",
        tnsList = ['container', 'controlsContainer', 'prevButton', 'nextButton', 'navContainer', 'autoplayButton'],
        optionsElements = {};
    tnsList.forEach(function (item) {
      if (typeof options[item] === 'string') {
        var str = options[item],
            el = doc.querySelector(str);
        optionsElements[item] = str;

        if (el && el.nodeName) {
          options[item] = el;
        } else {
          if (supportConsoleWarn) {
            console.warn('Can\'t find', options[item]);
          }

          return;
        }
      }
    }); // make sure at least 1 slide

    if (options.container.children.length < 1) {
      if (supportConsoleWarn) {
        console.warn('No slides found in', options.container);
      }

      return;
    } // update options


    var responsive = options.responsive,
        nested = options.nested,
        carousel = options.mode === 'carousel' ? true : false;

    if (responsive) {
      // apply responsive[0] to options and remove it
      if (0 in responsive) {
        options = extend(options, responsive[0]);
        delete responsive[0];
      }

      var responsiveTem = {};

      for (var key in responsive) {
        var val = responsive[key]; // update responsive
        // from: 300: 2
        // to:
        //   300: {
        //     items: 2
        //   }

        val = typeof val === 'number' ? {
          items: val
        } : val;
        responsiveTem[key] = val;
      }

      responsive = responsiveTem;
      responsiveTem = null;
    } // update options


    function updateOptions(obj) {
      for (var key in obj) {
        if (!carousel) {
          if (key === 'slideBy') {
            obj[key] = 'page';
          }

          if (key === 'edgePadding') {
            obj[key] = false;
          }

          if (key === 'autoHeight') {
            obj[key] = false;
          }
        } // update responsive options


        if (key === 'responsive') {
          updateOptions(obj[key]);
        }
      }
    }

    if (!carousel) {
      updateOptions(options);
    } // === define and set variables ===


    if (!carousel) {
      options.axis = 'horizontal';
      options.slideBy = 'page';
      options.edgePadding = false;
      var animateIn = options.animateIn,
          animateOut = options.animateOut,
          animateDelay = options.animateDelay,
          animateNormal = options.animateNormal;
    }

    var horizontal = options.axis === 'horizontal' ? true : false,
        outerWrapper = doc.createElement('div'),
        innerWrapper = doc.createElement('div'),
        middleWrapper,
        container = options.container,
        containerParent = container.parentNode,
        containerHTML = container.outerHTML,
        slideItems = container.children,
        slideCount = slideItems.length,
        breakpointZone,
        windowWidth = getWindowWidth(),
        isOn = false;

    if (responsive) {
      setBreakpointZone();
    }

    if (carousel) {
      container.className += ' tns-vpfix';
    } // fixedWidth: viewport > rightBoundary > indexMax


    var autoWidth = options.autoWidth,
        fixedWidth = getOption('fixedWidth'),
        edgePadding = getOption('edgePadding'),
        gutter = getOption('gutter'),
        viewport = getViewportWidth(),
        center = getOption('center'),
        items = !autoWidth ? Math.floor(getOption('items')) : 1,
        slideBy = getOption('slideBy'),
        viewportMax = options.viewportMax || options.fixedWidthViewportWidth,
        arrowKeys = getOption('arrowKeys'),
        speed = getOption('speed'),
        rewind = options.rewind,
        loop = rewind ? false : options.loop,
        autoHeight = getOption('autoHeight'),
        controls = getOption('controls'),
        controlsText = getOption('controlsText'),
        nav = getOption('nav'),
        touch = getOption('touch'),
        mouseDrag = getOption('mouseDrag'),
        autoplay = getOption('autoplay'),
        autoplayTimeout = getOption('autoplayTimeout'),
        autoplayText = getOption('autoplayText'),
        autoplayHoverPause = getOption('autoplayHoverPause'),
        autoplayResetOnVisibility = getOption('autoplayResetOnVisibility'),
        sheet = createStyleSheet(null, getOption('nonce')),
        lazyload = options.lazyload,
        lazyloadSelector = options.lazyloadSelector,
        slidePositions,
        // collection of slide positions
    slideItemsOut = [],
        cloneCount = loop ? getCloneCountForLoop() : 0,
        slideCountNew = !carousel ? slideCount + cloneCount : slideCount + cloneCount * 2,
        hasRightDeadZone = (fixedWidth || autoWidth) && !loop ? true : false,
        rightBoundary = fixedWidth ? getRightBoundary() : null,
        updateIndexBeforeTransform = !carousel || !loop ? true : false,
        // transform
    transformAttr = horizontal ? 'left' : 'top',
        transformPrefix = '',
        transformPostfix = '',
        // index
    getIndexMax = function () {
      if (fixedWidth) {
        return function () {
          return center && !loop ? slideCount - 1 : Math.ceil(-rightBoundary / (fixedWidth + gutter));
        };
      } else if (autoWidth) {
        return function () {
          for (var i = 0; i < slideCountNew; i++) {
            if (slidePositions[i] >= -rightBoundary) {
              return i;
            }
          }
        };
      } else {
        return function () {
          if (center && carousel && !loop) {
            return slideCount - 1;
          } else {
            return loop || carousel ? Math.max(0, slideCountNew - Math.ceil(items)) : slideCountNew - 1;
          }
        };
      }
    }(),
        index = getStartIndex(getOption('startIndex')),
        indexCached = index;

    getCurrentSlide();
    var indexMin = 0,
        indexMax = !autoWidth ? getIndexMax() : null,
        preventActionWhenRunning = options.preventActionWhenRunning,
        swipeAngle = options.swipeAngle,
        moveDirectionExpected = swipeAngle ? '?' : true,
        running = false,
        onInit = options.onInit,
        events = new Events(),
        // id, class
    newContainerClasses = ' tns-slider tns-' + options.mode,
        slideId = container.id || getSlideId(),
        disable = getOption('disable'),
        disabled = false,
        freezable = options.freezable,
        freeze = freezable && !autoWidth ? getFreeze() : false,
        frozen = false,
        controlsEvents = {
      'click': onControlsClick,
      'keydown': onControlsKeydown
    },
        navEvents = {
      'click': onNavClick,
      'keydown': onNavKeydown
    },
        hoverEvents = {
      'mouseover': mouseoverPause,
      'mouseout': mouseoutRestart
    },
        visibilityEvent = {
      'visibilitychange': onVisibilityChange
    },
        docmentKeydownEvent = {
      'keydown': onDocumentKeydown
    },
        touchEvents = {
      'touchstart': onPanStart,
      'touchmove': onPanMove,
      'touchend': onPanEnd,
      'touchcancel': onPanEnd
    },
        dragEvents = {
      'mousedown': onPanStart,
      'mousemove': onPanMove,
      'mouseup': onPanEnd,
      'mouseleave': onPanEnd
    },
        hasControls = hasOption('controls'),
        hasNav = hasOption('nav'),
        navAsThumbnails = autoWidth ? true : options.navAsThumbnails,
        hasAutoplay = hasOption('autoplay'),
        hasTouch = hasOption('touch'),
        hasMouseDrag = hasOption('mouseDrag'),
        slideActiveClass = 'tns-slide-active',
        slideClonedClass = 'tns-slide-cloned',
        imgCompleteClass = 'tns-complete',
        imgEvents = {
      'load': onImgLoaded,
      'error': onImgFailed
    },
        imgsComplete,
        liveregionCurrent,
        preventScroll = options.preventScrollOnTouch === 'force' ? true : false; // controls

    if (hasControls) {
      var controlsContainer = options.controlsContainer,
          controlsContainerHTML = options.controlsContainer ? options.controlsContainer.outerHTML : '',
          prevButton = options.prevButton,
          nextButton = options.nextButton,
          prevButtonHTML = options.prevButton ? options.prevButton.outerHTML : '',
          nextButtonHTML = options.nextButton ? options.nextButton.outerHTML : '',
          prevIsButton,
          nextIsButton;
    } // nav


    if (hasNav) {
      var navContainer = options.navContainer,
          navContainerHTML = options.navContainer ? options.navContainer.outerHTML : '',
          navItems,
          pages = autoWidth ? slideCount : getPages(),
          pagesCached = 0,
          navClicked = -1,
          navCurrentIndex = getCurrentNavIndex(),
          navCurrentIndexCached = navCurrentIndex,
          navActiveClass = 'tns-nav-active',
          navStr = 'Carousel Page ',
          navStrCurrent = ' (Current Slide)';
    } // autoplay


    if (hasAutoplay) {
      var autoplayDirection = options.autoplayDirection === 'forward' ? 1 : -1,
          autoplayButton = options.autoplayButton,
          autoplayButtonHTML = options.autoplayButton ? options.autoplayButton.outerHTML : '',
          autoplayHtmlStrings = ['<span class=\'tns-visually-hidden\'>', ' animation</span>'],
          autoplayTimer,
          animating,
          autoplayHoverPaused,
          autoplayUserPaused,
          autoplayVisibilityPaused;
    }

    if (hasTouch || hasMouseDrag) {
      var initPosition = {},
          lastPosition = {},
          translateInit,
          panStart = false,
          rafIndex,
          getDist = horizontal ? function (a, b) {
        return a.x - b.x;
      } : function (a, b) {
        return a.y - b.y;
      };
    } // disable slider when slidecount <= items


    if (!autoWidth) {
      resetVariblesWhenDisable(disable || freeze);
    }

    if (TRANSFORM) {
      transformAttr = TRANSFORM;
      transformPrefix = 'translate';

      if (HAS3DTRANSFORMS) {
        transformPrefix += horizontal ? '3d(' : '3d(0px, ';
        transformPostfix = horizontal ? ', 0px, 0px)' : ', 0px)';
      } else {
        transformPrefix += horizontal ? 'X(' : 'Y(';
        transformPostfix = ')';
      }
    }

    if (carousel) {
      container.className = container.className.replace('tns-vpfix', '');
    }

    initStructure();
    initSheet();
    initSliderTransform(); // === COMMON FUNCTIONS === //

    function resetVariblesWhenDisable(condition) {
      if (condition) {
        controls = nav = touch = mouseDrag = arrowKeys = autoplay = autoplayHoverPause = autoplayResetOnVisibility = false;
      }
    }

    function getCurrentSlide() {
      var tem = carousel ? index - cloneCount : index;

      while (tem < 0) {
        tem += slideCount;
      }

      return tem % slideCount + 1;
    }

    function getStartIndex(ind) {
      ind = ind ? Math.max(0, Math.min(loop ? slideCount - 1 : slideCount - items, ind)) : 0;
      return carousel ? ind + cloneCount : ind;
    }

    function getAbsIndex(i) {
      if (i == null) {
        i = index;
      }

      if (carousel) {
        i -= cloneCount;
      }

      while (i < 0) {
        i += slideCount;
      }

      return Math.floor(i % slideCount);
    }

    function getCurrentNavIndex() {
      var absIndex = getAbsIndex(),
          result;
      result = navAsThumbnails ? absIndex : fixedWidth || autoWidth ? Math.ceil((absIndex + 1) * pages / slideCount - 1) : Math.floor(absIndex / items); // set active nav to the last one when reaches the right edge

      if (!loop && carousel && index === indexMax) {
        result = pages - 1;
      }

      return result;
    }

    function getItemsMax() {
      // fixedWidth or autoWidth while viewportMax is not available
      if (autoWidth || fixedWidth && !viewportMax) {
        return slideCount - 1; // most cases
      } else {
        var str = fixedWidth ? 'fixedWidth' : 'items',
            arr = [];

        if (fixedWidth || options[str] < slideCount) {
          arr.push(options[str]);
        }

        if (responsive) {
          for (var bp in responsive) {
            var tem = responsive[bp][str];

            if (tem && (fixedWidth || tem < slideCount)) {
              arr.push(tem);
            }
          }
        }

        if (!arr.length) {
          arr.push(0);
        }

        return Math.ceil(fixedWidth ? viewportMax / Math.min.apply(null, arr) : Math.max.apply(null, arr));
      }
    }

    function getCloneCountForLoop() {
      var itemsMax = getItemsMax(),
          result = carousel ? Math.ceil((itemsMax * 5 - slideCount) / 2) : itemsMax * 4 - slideCount;
      result = Math.max(itemsMax, result);
      return hasOption('edgePadding') ? result + 1 : result;
    }

    function getWindowWidth() {
      return win.innerWidth || doc.documentElement.clientWidth || doc.body.clientWidth;
    }

    function getInsertPosition(pos) {
      return pos === 'top' ? 'afterbegin' : 'beforeend';
    }

    function getClientWidth(el) {
      if (el == null) {
        return;
      }

      var div = doc.createElement('div'),
          rect,
          width;
      el.appendChild(div);
      rect = div.getBoundingClientRect();
      width = rect.right - rect.left;
      div.remove();
      return width || getClientWidth(el.parentNode);
    }

    function getViewportWidth() {
      var gap = edgePadding ? edgePadding * 2 - gutter : 0;
      return getClientWidth(containerParent) - gap;
    }

    function hasOption(item) {
      if (options[item]) {
        return true;
      } else {
        if (responsive) {
          for (var bp in responsive) {
            if (responsive[bp][item]) {
              return true;
            }
          }
        }

        return false;
      }
    } // get option:
    // fixed width: viewport, fixedWidth, gutter => items
    // others: window width => all variables
    // all: items => slideBy


    function getOption(item, ww) {
      if (ww == null) {
        ww = windowWidth;
      }

      if (item === 'items' && fixedWidth) {
        return Math.floor((viewport + gutter) / (fixedWidth + gutter)) || 1;
      } else {
        var result = options[item];

        if (responsive) {
          for (var bp in responsive) {
            // bp: convert string to number
            if (ww >= parseInt(bp)) {
              if (item in responsive[bp]) {
                result = responsive[bp][item];
              }
            }
          }
        }

        if (item === 'slideBy' && result === 'page') {
          result = getOption('items');
        }

        if (!carousel && (item === 'slideBy' || item === 'items')) {
          result = Math.floor(result);
        }

        return result;
      }
    }

    function getSlideMarginLeft(i) {
      return CALC ? CALC + '(' + i * 100 + '% / ' + slideCountNew + ')' : i * 100 / slideCountNew + '%';
    }

    function getInnerWrapperStyles(edgePaddingTem, gutterTem, fixedWidthTem, speedTem, autoHeightBP) {
      var str = '';

      if (edgePaddingTem !== undefined) {
        var gap = edgePaddingTem;

        if (gutterTem) {
          gap -= gutterTem;
        }

        str = horizontal ? 'margin: 0 ' + gap + 'px 0 ' + edgePaddingTem + 'px;' : 'margin: ' + edgePaddingTem + 'px 0 ' + gap + 'px 0;';
      } else if (gutterTem && !fixedWidthTem) {
        var gutterTemUnit = '-' + gutterTem + 'px',
            dir = horizontal ? gutterTemUnit + ' 0 0' : '0 ' + gutterTemUnit + ' 0';
        str = 'margin: 0 ' + dir + ';';
      }

      if (!carousel && autoHeightBP && TRANSITIONDURATION && speedTem) {
        str += getTransitionDurationStyle(speedTem);
      }

      return str;
    }

    function getContainerWidth(fixedWidthTem, gutterTem, itemsTem) {
      if (fixedWidthTem) {
        return (fixedWidthTem + gutterTem) * slideCountNew + 'px';
      } else {
        return CALC ? CALC + '(' + slideCountNew * 100 + '% / ' + itemsTem + ')' : slideCountNew * 100 / itemsTem + '%';
      }
    }

    function getSlideWidthStyle(fixedWidthTem, gutterTem, itemsTem) {
      var width;

      if (fixedWidthTem) {
        width = fixedWidthTem + gutterTem + 'px';
      } else {
        if (!carousel) {
          itemsTem = Math.floor(itemsTem);
        }

        var dividend = carousel ? slideCountNew : itemsTem;
        width = CALC ? CALC + '(100% / ' + dividend + ')' : 100 / dividend + '%';
      }

      width = 'width:' + width; // inner slider: overwrite outer slider styles

      return nested !== 'inner' ? width + ';' : width + ' !important;';
    }

    function getSlideGutterStyle(gutterTem) {
      var str = ''; // gutter maybe interger || 0
      // so can't use 'if (gutter)'

      if (gutterTem !== false) {
        var prop = horizontal ? 'padding-' : 'margin-',
            dir = horizontal ? 'right' : 'bottom';
        str = prop + dir + ': ' + gutterTem + 'px;';
      }

      return str;
    }

    function getCSSPrefix(name, num) {
      var prefix = name.substring(0, name.length - num).toLowerCase();

      if (prefix) {
        prefix = '-' + prefix + '-';
      }

      return prefix;
    }

    function getTransitionDurationStyle(speed) {
      return getCSSPrefix(TRANSITIONDURATION, 18) + 'transition-duration:' + speed / 1000 + 's;';
    }

    function getAnimationDurationStyle(speed) {
      return getCSSPrefix(ANIMATIONDURATION, 17) + 'animation-duration:' + speed / 1000 + 's;';
    }

    function initStructure() {
      var classOuter = 'tns-outer',
          classInner = 'tns-inner';
      hasOption('gutter');
      outerWrapper.className = classOuter;
      innerWrapper.className = classInner;
      outerWrapper.id = slideId + '-ow';
      innerWrapper.id = slideId + '-iw'; // set container properties

      if (container.id === '') {
        container.id = slideId;
      }

      newContainerClasses += PERCENTAGELAYOUT || autoWidth ? ' tns-subpixel' : ' tns-no-subpixel';
      newContainerClasses += CALC ? ' tns-calc' : ' tns-no-calc';

      if (autoWidth) {
        newContainerClasses += ' tns-autowidth';
      }

      newContainerClasses += ' tns-' + options.axis;
      container.className += newContainerClasses; // add constrain layer for carousel

      if (carousel) {
        middleWrapper = doc.createElement('div');
        middleWrapper.id = slideId + '-mw';
        middleWrapper.className = 'tns-ovh';
        outerWrapper.appendChild(middleWrapper);
        middleWrapper.appendChild(innerWrapper);
      } else {
        outerWrapper.appendChild(innerWrapper);
      }

      if (autoHeight) {
        var wp = middleWrapper ? middleWrapper : innerWrapper;
        wp.className += ' tns-ah';
      }

      containerParent.insertBefore(outerWrapper, container);
      innerWrapper.appendChild(container); // add id, class, aria attributes
      // before clone slides

      forEach(slideItems, function (item, i) {
        addClass(item, 'tns-item');

        if (!item.id) {
          item.id = slideId + '-item' + i;
        }

        if (!carousel && animateNormal) {
          addClass(item, animateNormal);
        }

        setAttrs(item, {
          'aria-hidden': 'true',
          'tabindex': '-1'
        });
      }); // ## clone slides
      // carousel: n + slides + n
      // gallery:      slides + n

      if (cloneCount) {
        var fragmentBefore = doc.createDocumentFragment(),
            fragmentAfter = doc.createDocumentFragment();

        for (var j = cloneCount; j--;) {
          var num = j % slideCount,
              cloneFirst = slideItems[num].cloneNode(true);
          addClass(cloneFirst, slideClonedClass);
          removeAttrs(cloneFirst, 'id');
          fragmentAfter.insertBefore(cloneFirst, fragmentAfter.firstChild);

          if (carousel) {
            var cloneLast = slideItems[slideCount - 1 - num].cloneNode(true);
            addClass(cloneLast, slideClonedClass);
            removeAttrs(cloneLast, 'id');
            fragmentBefore.appendChild(cloneLast);
          }
        }

        container.insertBefore(fragmentBefore, container.firstChild);
        container.appendChild(fragmentAfter);
        slideItems = container.children;
      }
    }

    function initSliderTransform() {
      // ## images loaded/failed
      if (hasOption('autoHeight') || autoWidth || !horizontal) {
        var imgs = container.querySelectorAll('img'); // add img load event listener

        forEach(imgs, function (img) {
          var src = img.src;

          if (!lazyload) {
            // not data img
            if (src && src.indexOf('data:image') < 0) {
              img.src = '';
              addEvents(img, imgEvents);
              addClass(img, 'loading');
              img.src = src; // data img
            } else {
              imgLoaded(img);
            }
          }
        }); // set imgsComplete

        raf(function () {
          imgsLoadedCheck(arrayFromNodeList(imgs), function () {
            imgsComplete = true;
          });
        }); // reset imgs for auto height: check visible imgs only

        if (hasOption('autoHeight')) {
          imgs = getImageArray(index, Math.min(index + items - 1, slideCountNew - 1));
        }

        lazyload ? initSliderTransformStyleCheck() : raf(function () {
          imgsLoadedCheck(arrayFromNodeList(imgs), initSliderTransformStyleCheck);
        });
      } else {
        // set container transform property
        if (carousel) {
          doContainerTransformSilent();
        } // update slider tools and events


        initTools();
        initEvents();
      }
    }

    function initSliderTransformStyleCheck() {
      if (autoWidth && slideCount > 1) {
        // check styles application
        var num = loop ? index : slideCount - 1;

        (function stylesApplicationCheck() {
          var left = slideItems[num].getBoundingClientRect().left;
          var right = slideItems[num - 1].getBoundingClientRect().right;
          Math.abs(left - right) <= 1 ? initSliderTransformCore() : setTimeout(function () {
            stylesApplicationCheck();
          }, 16);
        })();
      } else {
        initSliderTransformCore();
      }
    }

    function initSliderTransformCore() {
      // run Fn()s which are rely on image loading
      if (!horizontal || autoWidth) {
        setSlidePositions();

        if (autoWidth) {
          rightBoundary = getRightBoundary();

          if (freezable) {
            freeze = getFreeze();
          }

          indexMax = getIndexMax(); // <= slidePositions, rightBoundary <=

          resetVariblesWhenDisable(disable || freeze);
        } else {
          updateContentWrapperHeight();
        }
      } // set container transform property


      if (carousel) {
        doContainerTransformSilent();
      } // update slider tools and events


      initTools();
      initEvents();
    }

    function initSheet() {
      // gallery:
      // set animation classes and left value for gallery slider
      if (!carousel) {
        for (var i = index, l = index + Math.min(slideCount, items); i < l; i++) {
          var item = slideItems[i];
          item.style.left = (i - index) * 100 / items + '%';
          addClass(item, animateIn);
          removeClass(item, animateNormal);
        }
      } // #### LAYOUT
      // ## INLINE-BLOCK VS FLOAT
      // ## PercentageLayout:
      // slides: inline-block
      // remove blank space between slides by set font-size: 0
      // ## Non PercentageLayout:
      // slides: float
      //         margin-right: -100%
      //         margin-left: ~
      // Resource: https://docs.google.com/spreadsheets/d/147up245wwTXeQYve3BRSAD4oVcvQmuGsFteJOeA5xNQ/edit?usp=sharing


      if (horizontal) {
        if (PERCENTAGELAYOUT || autoWidth) {
          addCSSRule(sheet, '#' + slideId + ' > .tns-item', 'font-size:' + win.getComputedStyle(slideItems[0]).fontSize + ';', getCssRulesLength(sheet));
          addCSSRule(sheet, '#' + slideId, 'font-size:0;', getCssRulesLength(sheet));
        } else if (carousel) {
          forEach(slideItems, function (slide, i) {
            slide.style.marginLeft = getSlideMarginLeft(i);
          });
        }
      } // ## BASIC STYLES


      if (CSSMQ) {
        // middle wrapper style
        if (TRANSITIONDURATION) {
          var str = middleWrapper && options.autoHeight ? getTransitionDurationStyle(options.speed) : '';
          addCSSRule(sheet, '#' + slideId + '-mw', str, getCssRulesLength(sheet));
        } // inner wrapper styles


        str = getInnerWrapperStyles(options.edgePadding, options.gutter, options.fixedWidth, options.speed, options.autoHeight);
        addCSSRule(sheet, '#' + slideId + '-iw', str, getCssRulesLength(sheet)); // container styles

        if (carousel) {
          str = horizontal && !autoWidth ? 'width:' + getContainerWidth(options.fixedWidth, options.gutter, options.items) + ';' : '';

          if (TRANSITIONDURATION) {
            str += getTransitionDurationStyle(speed);
          }

          addCSSRule(sheet, '#' + slideId, str, getCssRulesLength(sheet));
        } // slide styles


        str = horizontal && !autoWidth ? getSlideWidthStyle(options.fixedWidth, options.gutter, options.items) : '';

        if (options.gutter) {
          str += getSlideGutterStyle(options.gutter);
        } // set gallery items transition-duration


        if (!carousel) {
          if (TRANSITIONDURATION) {
            str += getTransitionDurationStyle(speed);
          }

          if (ANIMATIONDURATION) {
            str += getAnimationDurationStyle(speed);
          }
        }

        if (str) {
          addCSSRule(sheet, '#' + slideId + ' > .tns-item', str, getCssRulesLength(sheet));
        } // non CSS mediaqueries: IE8
        // ## update inner wrapper, container, slides if needed
        // set inline styles for inner wrapper & container
        // insert stylesheet (one line) for slides only (since slides are many)

      } else {
        // middle wrapper styles
        update_carousel_transition_duration(); // inner wrapper styles

        innerWrapper.style.cssText = getInnerWrapperStyles(edgePadding, gutter, fixedWidth, autoHeight); // container styles

        if (carousel && horizontal && !autoWidth) {
          container.style.width = getContainerWidth(fixedWidth, gutter, items);
        } // slide styles


        var str = horizontal && !autoWidth ? getSlideWidthStyle(fixedWidth, gutter, items) : '';

        if (gutter) {
          str += getSlideGutterStyle(gutter);
        } // append to the last line


        if (str) {
          addCSSRule(sheet, '#' + slideId + ' > .tns-item', str, getCssRulesLength(sheet));
        }
      } // ## MEDIAQUERIES


      if (responsive && CSSMQ) {
        for (var bp in responsive) {
          // bp: convert string to number
          bp = parseInt(bp);
          var opts = responsive[bp],
              str = '',
              middleWrapperStr = '',
              innerWrapperStr = '',
              containerStr = '',
              slideStr = '',
              itemsBP = !autoWidth ? getOption('items', bp) : null,
              fixedWidthBP = getOption('fixedWidth', bp),
              speedBP = getOption('speed', bp),
              edgePaddingBP = getOption('edgePadding', bp),
              autoHeightBP = getOption('autoHeight', bp),
              gutterBP = getOption('gutter', bp); // middle wrapper string

          if (TRANSITIONDURATION && middleWrapper && getOption('autoHeight', bp) && 'speed' in opts) {
            middleWrapperStr = '#' + slideId + '-mw{' + getTransitionDurationStyle(speedBP) + '}';
          } // inner wrapper string


          if ('edgePadding' in opts || 'gutter' in opts) {
            innerWrapperStr = '#' + slideId + '-iw{' + getInnerWrapperStyles(edgePaddingBP, gutterBP, fixedWidthBP, speedBP, autoHeightBP) + '}';
          } // container string


          if (carousel && horizontal && !autoWidth && ('fixedWidth' in opts || 'items' in opts || fixedWidth && 'gutter' in opts)) {
            containerStr = 'width:' + getContainerWidth(fixedWidthBP, gutterBP, itemsBP) + ';';
          }

          if (TRANSITIONDURATION && 'speed' in opts) {
            containerStr += getTransitionDurationStyle(speedBP);
          }

          if (containerStr) {
            containerStr = '#' + slideId + '{' + containerStr + '}';
          } // slide string


          if ('fixedWidth' in opts || fixedWidth && 'gutter' in opts || !carousel && 'items' in opts) {
            slideStr += getSlideWidthStyle(fixedWidthBP, gutterBP, itemsBP);
          }

          if ('gutter' in opts) {
            slideStr += getSlideGutterStyle(gutterBP);
          } // set gallery items transition-duration


          if (!carousel && 'speed' in opts) {
            if (TRANSITIONDURATION) {
              slideStr += getTransitionDurationStyle(speedBP);
            }

            if (ANIMATIONDURATION) {
              slideStr += getAnimationDurationStyle(speedBP);
            }
          }

          if (slideStr) {
            slideStr = '#' + slideId + ' > .tns-item{' + slideStr + '}';
          } // add up


          str = middleWrapperStr + innerWrapperStr + containerStr + slideStr;

          if (str) {
            sheet.insertRule('@media (min-width: ' + bp / 16 + 'em) {' + str + '}', sheet.cssRules.length);
          }
        }
      }
    }

    function initTools() {
      // == slides ==
      updateSlideStatus(); // == live region ==

      outerWrapper.insertAdjacentHTML('afterbegin', '<div class="tns-liveregion tns-visually-hidden" aria-live="polite" aria-atomic="true">slide <span class="current">' + getLiveRegionStr() + '</span>  of ' + slideCount + '</div>');
      liveregionCurrent = outerWrapper.querySelector('.tns-liveregion .current'); // == autoplayInit ==

      if (hasAutoplay) {
        var txt = autoplay ? 'stop' : 'start';

        if (autoplayButton) {
          setAttrs(autoplayButton, {
            'data-action': txt
          });
        } else if (options.autoplayButtonOutput) {
          outerWrapper.insertAdjacentHTML(getInsertPosition(options.autoplayPosition), '<button type="button" data-action="' + txt + '">' + autoplayHtmlStrings[0] + txt + autoplayHtmlStrings[1] + autoplayText[0] + '</button>');
          autoplayButton = outerWrapper.querySelector('[data-action]');
        } // add event


        if (autoplayButton) {
          addEvents(autoplayButton, {
            'click': toggleAutoplay
          });
        }

        if (autoplay) {
          startAutoplay();

          if (autoplayHoverPause) {
            addEvents(container, hoverEvents);
          }

          if (autoplayResetOnVisibility) {
            addEvents(container, visibilityEvent);
          }
        }
      } // == navInit ==


      if (hasNav) {
        // will not hide the navs in case they're thumbnails
        if (navContainer) {
          setAttrs(navContainer, {
            'aria-label': 'Carousel Pagination'
          });
          navItems = navContainer.children;
          forEach(navItems, function (item, i) {
            setAttrs(item, {
              'data-nav': i,
              'tabindex': '-1',
              'aria-label': navStr + (i + 1),
              'aria-controls': slideId
            });
          }); // generated nav
        } else {
          var navHtml = '',
              hiddenStr = navAsThumbnails ? '' : 'style="display:none"';

          for (var i = 0; i < slideCount; i++) {
            // hide nav items by default
            navHtml += '<button type="button" data-nav="' + i + '" tabindex="-1" aria-controls="' + slideId + '" ' + hiddenStr + ' aria-label="' + navStr + (i + 1) + '"></button>';
          }

          navHtml = '<div class="tns-nav" aria-label="Carousel Pagination">' + navHtml + '</div>';
          outerWrapper.insertAdjacentHTML(getInsertPosition(options.navPosition), navHtml);
          navContainer = outerWrapper.querySelector('.tns-nav');
          navItems = navContainer.children;
        }

        updateNavVisibility(); // add transition

        if (TRANSITIONDURATION) {
          var prefix = TRANSITIONDURATION.substring(0, TRANSITIONDURATION.length - 18).toLowerCase(),
              str = 'transition: all ' + speed / 1000 + 's';

          if (prefix) {
            str = '-' + prefix + '-' + str;
          }

          addCSSRule(sheet, '[aria-controls^=' + slideId + '-item]', str, getCssRulesLength(sheet));
        }

        setAttrs(navItems[navCurrentIndex], {
          'aria-label': navStr + (navCurrentIndex + 1) + navStrCurrent
        });
        removeAttrs(navItems[navCurrentIndex], 'tabindex');
        addClass(navItems[navCurrentIndex], navActiveClass); // add events

        addEvents(navContainer, navEvents);
      } // == controlsInit ==


      if (hasControls) {
        if (!controlsContainer && (!prevButton || !nextButton)) {
          outerWrapper.insertAdjacentHTML(getInsertPosition(options.controlsPosition), '<div class="tns-controls" aria-label="Carousel Navigation" tabindex="0"><button type="button" data-controls="prev" tabindex="-1" aria-controls="' + slideId + '">' + controlsText[0] + '</button><button type="button" data-controls="next" tabindex="-1" aria-controls="' + slideId + '">' + controlsText[1] + '</button></div>');
          controlsContainer = outerWrapper.querySelector('.tns-controls');
        }

        if (!prevButton || !nextButton) {
          prevButton = controlsContainer.children[0];
          nextButton = controlsContainer.children[1];
        }

        if (options.controlsContainer) {
          setAttrs(controlsContainer, {
            'aria-label': 'Carousel Navigation',
            'tabindex': '0'
          });
        }

        if (options.controlsContainer || options.prevButton && options.nextButton) {
          setAttrs([prevButton, nextButton], {
            'aria-controls': slideId,
            'tabindex': '-1'
          });
        }

        if (options.controlsContainer || options.prevButton && options.nextButton) {
          setAttrs(prevButton, {
            'data-controls': 'prev'
          });
          setAttrs(nextButton, {
            'data-controls': 'next'
          });
        }

        prevIsButton = isButton(prevButton);
        nextIsButton = isButton(nextButton);
        updateControlsStatus(); // add events

        if (controlsContainer) {
          addEvents(controlsContainer, controlsEvents);
        } else {
          addEvents(prevButton, controlsEvents);
          addEvents(nextButton, controlsEvents);
        }
      } // hide tools if needed


      disableUI();
    }

    function initEvents() {
      // add events
      if (carousel && TRANSITIONEND) {
        var eve = {};
        eve[TRANSITIONEND] = onTransitionEnd;
        addEvents(container, eve);
      }

      if (touch) {
        addEvents(container, touchEvents, options.preventScrollOnTouch);
      }

      if (mouseDrag) {
        addEvents(container, dragEvents);
      }

      if (arrowKeys) {
        addEvents(doc, docmentKeydownEvent);
      }

      if (nested === 'inner') {
        events.on('outerResized', function () {
          resizeTasks();
          events.emit('innerLoaded', info());
        });
      } else if (responsive || fixedWidth || autoWidth || autoHeight || !horizontal) {
        addEvents(win, {
          'resize': onResize
        });
      }

      if (autoHeight) {
        if (nested === 'outer') {
          events.on('innerLoaded', doAutoHeight);
        } else if (!disable) {
          doAutoHeight();
        }
      }

      doLazyLoad();

      if (disable) {
        disableSlider();
      } else if (freeze) {
        freezeSlider();
      }

      events.on('indexChanged', additionalUpdates);

      if (nested === 'inner') {
        events.emit('innerLoaded', info());
      }

      if (typeof onInit === 'function') {
        onInit(info());
      }

      isOn = true;
    }

    function destroy() {
      // sheet
      sheet.disabled = true;

      if (sheet.ownerNode) {
        sheet.ownerNode.remove();
      } // remove win event listeners


      removeEvents(win, {
        'resize': onResize
      }); // arrowKeys, controls, nav

      if (arrowKeys) {
        removeEvents(doc, docmentKeydownEvent);
      }

      if (controlsContainer) {
        removeEvents(controlsContainer, controlsEvents);
      }

      if (navContainer) {
        removeEvents(navContainer, navEvents);
      } // autoplay


      removeEvents(container, hoverEvents);
      removeEvents(container, visibilityEvent);

      if (autoplayButton) {
        removeEvents(autoplayButton, {
          'click': toggleAutoplay
        });
      }

      if (autoplay) {
        clearInterval(autoplayTimer);
      } // container


      if (carousel && TRANSITIONEND) {
        var eve = {};
        eve[TRANSITIONEND] = onTransitionEnd;
        removeEvents(container, eve);
      }

      if (touch) {
        removeEvents(container, touchEvents);
      }

      if (mouseDrag) {
        removeEvents(container, dragEvents);
      } // cache Object values in options && reset HTML


      var htmlList = [containerHTML, controlsContainerHTML, prevButtonHTML, nextButtonHTML, navContainerHTML, autoplayButtonHTML];
      tnsList.forEach(function (item, i) {
        var el = item === 'container' ? outerWrapper : options[item];

        if (_typeof(el) === 'object' && el) {
          var prevEl = el.previousElementSibling ? el.previousElementSibling : false,
              parentEl = el.parentNode;
          el.outerHTML = htmlList[i];
          options[item] = prevEl ? prevEl.nextElementSibling : parentEl.firstElementChild;
        }
      }); // reset variables

      tnsList = animateIn = animateOut = animateDelay = animateNormal = horizontal = outerWrapper = innerWrapper = container = containerParent = containerHTML = slideItems = slideCount = breakpointZone = windowWidth = autoWidth = fixedWidth = edgePadding = gutter = viewport = items = slideBy = viewportMax = arrowKeys = speed = rewind = loop = autoHeight = sheet = lazyload = slidePositions = slideItemsOut = cloneCount = slideCountNew = hasRightDeadZone = rightBoundary = updateIndexBeforeTransform = transformAttr = transformPrefix = transformPostfix = getIndexMax = index = indexCached = indexMin = indexMax = swipeAngle = moveDirectionExpected = running = onInit = events = newContainerClasses = slideId = disable = disabled = freezable = freeze = frozen = controlsEvents = navEvents = hoverEvents = visibilityEvent = docmentKeydownEvent = touchEvents = dragEvents = hasControls = hasNav = navAsThumbnails = hasAutoplay = hasTouch = hasMouseDrag = slideActiveClass = imgCompleteClass = imgEvents = imgsComplete = controls = controlsText = controlsContainer = controlsContainerHTML = prevButton = nextButton = prevIsButton = nextIsButton = nav = navContainer = navContainerHTML = navItems = pages = pagesCached = navClicked = navCurrentIndex = navCurrentIndexCached = navActiveClass = navStr = navStrCurrent = autoplay = autoplayTimeout = autoplayDirection = autoplayText = autoplayHoverPause = autoplayButton = autoplayButtonHTML = autoplayResetOnVisibility = autoplayHtmlStrings = autoplayTimer = animating = autoplayHoverPaused = autoplayUserPaused = autoplayVisibilityPaused = initPosition = lastPosition = translateInit = panStart = rafIndex = getDist = touch = mouseDrag = null; // check variables
      // [animateIn, animateOut, animateDelay, animateNormal, horizontal, outerWrapper, innerWrapper, container, containerParent, containerHTML, slideItems, slideCount, breakpointZone, windowWidth, autoWidth, fixedWidth, edgePadding, gutter, viewport, items, slideBy, viewportMax, arrowKeys, speed, rewind, loop, autoHeight, sheet, lazyload, slidePositions, slideItemsOut, cloneCount, slideCountNew, hasRightDeadZone, rightBoundary, updateIndexBeforeTransform, transformAttr, transformPrefix, transformPostfix, getIndexMax, index, indexCached, indexMin, indexMax, resizeTimer, swipeAngle, moveDirectionExpected, running, onInit, events, newContainerClasses, slideId, disable, disabled, freezable, freeze, frozen, controlsEvents, navEvents, hoverEvents, visibilityEvent, docmentKeydownEvent, touchEvents, dragEvents, hasControls, hasNav, navAsThumbnails, hasAutoplay, hasTouch, hasMouseDrag, slideActiveClass, imgCompleteClass, imgEvents, imgsComplete, controls, controlsText, controlsContainer, controlsContainerHTML, prevButton, nextButton, prevIsButton, nextIsButton, nav, navContainer, navContainerHTML, navItems, pages, pagesCached, navClicked, navCurrentIndex, navCurrentIndexCached, navActiveClass, navStr, navStrCurrent, autoplay, autoplayTimeout, autoplayDirection, autoplayText, autoplayHoverPause, autoplayButton, autoplayButtonHTML, autoplayResetOnVisibility, autoplayHtmlStrings, autoplayTimer, animating, autoplayHoverPaused, autoplayUserPaused, autoplayVisibilityPaused, initPosition, lastPosition, translateInit, disX, disY, panStart, rafIndex, getDist, touch, mouseDrag ].forEach(function(item) { if (item !== null) { console.log(item); } });

      for (var a in this) {
        if (a !== 'rebuild') {
          this[a] = null;
        }
      }

      isOn = false;
    } // === ON RESIZE ===
    // responsive || fixedWidth || autoWidth || !horizontal


    function onResize(e) {
      raf(function () {
        resizeTasks(getEvent(e));
      });
    }

    function resizeTasks(e) {
      if (!isOn) {
        return;
      }

      if (nested === 'outer') {
        events.emit('outerResized', info(e));
      }

      windowWidth = getWindowWidth();
      var bpChanged,
          breakpointZoneTem = breakpointZone,
          needContainerTransform = false;

      if (responsive) {
        setBreakpointZone();
        bpChanged = breakpointZoneTem !== breakpointZone; // if (hasRightDeadZone) { needContainerTransform = true; } // *?

        if (bpChanged) {
          events.emit('newBreakpointStart', info(e));
        }
      }

      var indChanged,
          itemsChanged,
          itemsTem = items,
          disableTem = disable,
          freezeTem = freeze,
          arrowKeysTem = arrowKeys,
          controlsTem = controls,
          navTem = nav,
          touchTem = touch,
          mouseDragTem = mouseDrag,
          autoplayTem = autoplay,
          autoplayHoverPauseTem = autoplayHoverPause,
          autoplayResetOnVisibilityTem = autoplayResetOnVisibility,
          indexTem = index;

      if (bpChanged) {
        var fixedWidthTem = fixedWidth,
            autoHeightTem = autoHeight,
            controlsTextTem = controlsText,
            centerTem = center,
            autoplayTextTem = autoplayText;

        if (!CSSMQ) {
          var gutterTem = gutter,
              edgePaddingTem = edgePadding;
        }
      } // get option:
      // fixed width: viewport, fixedWidth, gutter => items
      // others: window width => all variables
      // all: items => slideBy


      arrowKeys = getOption('arrowKeys');
      controls = getOption('controls');
      nav = getOption('nav');
      touch = getOption('touch');
      center = getOption('center');
      mouseDrag = getOption('mouseDrag');
      autoplay = getOption('autoplay');
      autoplayHoverPause = getOption('autoplayHoverPause');
      autoplayResetOnVisibility = getOption('autoplayResetOnVisibility');

      if (bpChanged) {
        disable = getOption('disable');
        fixedWidth = getOption('fixedWidth');
        speed = getOption('speed');
        autoHeight = getOption('autoHeight');
        controlsText = getOption('controlsText');
        autoplayText = getOption('autoplayText');
        autoplayTimeout = getOption('autoplayTimeout');

        if (!CSSMQ) {
          edgePadding = getOption('edgePadding');
          gutter = getOption('gutter');
        }
      } // update options


      resetVariblesWhenDisable(disable);
      viewport = getViewportWidth(); // <= edgePadding, gutter

      if ((!horizontal || autoWidth) && !disable) {
        setSlidePositions();

        if (!horizontal) {
          updateContentWrapperHeight(); // <= setSlidePositions

          needContainerTransform = true;
        }
      }

      if (fixedWidth || autoWidth) {
        rightBoundary = getRightBoundary(); // autoWidth: <= viewport, slidePositions, gutter
        // fixedWidth: <= viewport, fixedWidth, gutter

        indexMax = getIndexMax(); // autoWidth: <= rightBoundary, slidePositions
        // fixedWidth: <= rightBoundary, fixedWidth, gutter
      }

      if (bpChanged || fixedWidth) {
        items = getOption('items');
        slideBy = getOption('slideBy');
        itemsChanged = items !== itemsTem;

        if (itemsChanged) {
          if (!fixedWidth && !autoWidth) {
            indexMax = getIndexMax();
          } // <= items
          // check index before transform in case
          // slider reach the right edge then items become bigger


          updateIndex();
        }
      }

      if (bpChanged) {
        if (disable !== disableTem) {
          if (disable) {
            disableSlider();
          } else {
            enableSlider(); // <= slidePositions, rightBoundary, indexMax
          }
        }
      }

      if (freezable && (bpChanged || fixedWidth || autoWidth)) {
        freeze = getFreeze(); // <= autoWidth: slidePositions, gutter, viewport, rightBoundary
        // <= fixedWidth: fixedWidth, gutter, rightBoundary
        // <= others: items

        if (freeze !== freezeTem) {
          if (freeze) {
            doContainerTransform(getContainerTransformValue(getStartIndex(0)));
            freezeSlider();
          } else {
            unfreezeSlider();
            needContainerTransform = true;
          }
        }
      }

      resetVariblesWhenDisable(disable || freeze); // controls, nav, touch, mouseDrag, arrowKeys, autoplay, autoplayHoverPause, autoplayResetOnVisibility

      if (!autoplay) {
        autoplayHoverPause = autoplayResetOnVisibility = false;
      }

      if (arrowKeys !== arrowKeysTem) {
        arrowKeys ? addEvents(doc, docmentKeydownEvent) : removeEvents(doc, docmentKeydownEvent);
      }

      if (controls !== controlsTem) {
        if (controls) {
          if (controlsContainer) {
            showElement(controlsContainer);
          } else {
            if (prevButton) {
              showElement(prevButton);
            }

            if (nextButton) {
              showElement(nextButton);
            }
          }
        } else {
          if (controlsContainer) {
            hideElement(controlsContainer);
          } else {
            if (prevButton) {
              hideElement(prevButton);
            }

            if (nextButton) {
              hideElement(nextButton);
            }
          }
        }
      }

      if (nav !== navTem) {
        if (nav) {
          showElement(navContainer);
          updateNavVisibility();
        } else {
          hideElement(navContainer);
        }
      }

      if (touch !== touchTem) {
        touch ? addEvents(container, touchEvents, options.preventScrollOnTouch) : removeEvents(container, touchEvents);
      }

      if (mouseDrag !== mouseDragTem) {
        mouseDrag ? addEvents(container, dragEvents) : removeEvents(container, dragEvents);
      }

      if (autoplay !== autoplayTem) {
        if (autoplay) {
          if (autoplayButton) {
            showElement(autoplayButton);
          }

          if (!animating && !autoplayUserPaused) {
            startAutoplay();
          }
        } else {
          if (autoplayButton) {
            hideElement(autoplayButton);
          }

          if (animating) {
            stopAutoplay();
          }
        }
      }

      if (autoplayHoverPause !== autoplayHoverPauseTem) {
        autoplayHoverPause ? addEvents(container, hoverEvents) : removeEvents(container, hoverEvents);
      }

      if (autoplayResetOnVisibility !== autoplayResetOnVisibilityTem) {
        autoplayResetOnVisibility ? addEvents(doc, visibilityEvent) : removeEvents(doc, visibilityEvent);
      }

      if (bpChanged) {
        if (fixedWidth !== fixedWidthTem || center !== centerTem) {
          needContainerTransform = true;
        }

        if (autoHeight !== autoHeightTem) {
          if (!autoHeight) {
            innerWrapper.style.height = '';
          }
        }

        if (controls && controlsText !== controlsTextTem) {
          prevButton.innerHTML = controlsText[0];
          nextButton.innerHTML = controlsText[1];
        }

        if (autoplayButton && autoplayText !== autoplayTextTem) {
          var i = autoplay ? 1 : 0,
              html = autoplayButton.innerHTML,
              len = html.length - autoplayTextTem[i].length;

          if (html.substring(len) === autoplayTextTem[i]) {
            autoplayButton.innerHTML = html.substring(0, len) + autoplayText[i];
          }
        }
      } else {
        if (center && (fixedWidth || autoWidth)) {
          needContainerTransform = true;
        }
      }

      if (itemsChanged || fixedWidth && !autoWidth) {
        pages = getPages();
        updateNavVisibility();
      }

      indChanged = index !== indexTem;

      if (indChanged) {
        events.emit('indexChanged', info());
        needContainerTransform = true;
      } else if (itemsChanged) {
        if (!indChanged) {
          additionalUpdates();
        }
      } else if (fixedWidth || autoWidth) {
        doLazyLoad();
        updateSlideStatus();
        updateLiveRegion();
      }

      if (itemsChanged && !carousel) {
        updateGallerySlidePositions();
      }

      if (!disable && !freeze) {
        // non-mediaqueries: IE8
        if (bpChanged && !CSSMQ) {
          // middle wrapper styles
          // inner wrapper styles
          if (edgePadding !== edgePaddingTem || gutter !== gutterTem) {
            innerWrapper.style.cssText = getInnerWrapperStyles(edgePadding, gutter, fixedWidth, speed, autoHeight);
          }

          if (horizontal) {
            // container styles
            if (carousel) {
              container.style.width = getContainerWidth(fixedWidth, gutter, items);
            } // slide styles


            var str = getSlideWidthStyle(fixedWidth, gutter, items) + getSlideGutterStyle(gutter); // remove the last line and
            // add new styles

            removeCSSRule(sheet, getCssRulesLength(sheet) - 1);
            addCSSRule(sheet, '#' + slideId + ' > .tns-item', str, getCssRulesLength(sheet));
          }
        } // auto height


        if (autoHeight) {
          doAutoHeight();
        }

        if (needContainerTransform) {
          doContainerTransformSilent();
          indexCached = index;
        }
      }

      if (bpChanged) {
        events.emit('newBreakpointEnd', info(e));
      }
    } // === INITIALIZATION FUNCTIONS === //


    function getFreeze() {
      if (!fixedWidth && !autoWidth) {
        var a = center ? items - (items - 1) / 2 : items;
        return slideCount <= a;
      }

      var width = fixedWidth ? (fixedWidth + gutter) * slideCount : slidePositions[slideCount],
          vp = edgePadding ? viewport + edgePadding * 2 : viewport + gutter;

      if (center) {
        vp -= fixedWidth ? (viewport - fixedWidth) / 2 : (viewport - (slidePositions[index + 1] - slidePositions[index] - gutter)) / 2;
      }

      return width <= vp;
    }

    function setBreakpointZone() {
      breakpointZone = 0;

      for (var bp in responsive) {
        bp = parseInt(bp); // convert string to number

        if (windowWidth >= bp) {
          breakpointZone = bp;
        }
      }
    } // (slideBy, indexMin, indexMax) => index


    var updateIndex = function () {
      return loop ? carousel ? // loop + carousel
      function () {
        var leftEdge = indexMin,
            rightEdge = indexMax;
        leftEdge += slideBy;
        rightEdge -= slideBy; // adjust edges when has edge paddings
        // or fixed-width slider with extra space on the right side

        if (edgePadding) {
          leftEdge += 1;
          rightEdge -= 1;
        } else if (fixedWidth) {
          if ((viewport + gutter) % (fixedWidth + gutter)) {
            rightEdge -= 1;
          }
        }

        if (cloneCount) {
          if (index > rightEdge) {
            index -= slideCount;
          } else if (index < leftEdge) {
            index += slideCount;
          }
        }
      } : // loop + gallery
      function () {
        if (index > indexMax) {
          while (index >= indexMin + slideCount) {
            index -= slideCount;
          }
        } else if (index < indexMin) {
          while (index <= indexMax - slideCount) {
            index += slideCount;
          }
        }
      } : // non-loop
      function () {
        index = Math.max(indexMin, Math.min(indexMax, index));
      };
    }();

    function disableUI() {
      if (!autoplay && autoplayButton) {
        hideElement(autoplayButton);
      }

      if (!nav && navContainer) {
        hideElement(navContainer);
      }

      if (!controls) {
        if (controlsContainer) {
          hideElement(controlsContainer);
        } else {
          if (prevButton) {
            hideElement(prevButton);
          }

          if (nextButton) {
            hideElement(nextButton);
          }
        }
      }
    }

    function enableUI() {
      if (autoplay && autoplayButton) {
        showElement(autoplayButton);
      }

      if (nav && navContainer) {
        showElement(navContainer);
      }

      if (controls) {
        if (controlsContainer) {
          showElement(controlsContainer);
        } else {
          if (prevButton) {
            showElement(prevButton);
          }

          if (nextButton) {
            showElement(nextButton);
          }
        }
      }
    }

    function freezeSlider() {
      if (frozen) {
        return;
      } // remove edge padding from inner wrapper


      if (edgePadding) {
        innerWrapper.style.margin = '0px';
      } // add class tns-transparent to cloned slides


      if (cloneCount) {
        var str = 'tns-transparent';

        for (var i = cloneCount; i--;) {
          if (carousel) {
            addClass(slideItems[i], str);
          }

          addClass(slideItems[slideCountNew - i - 1], str);
        }
      } // update tools


      disableUI();
      frozen = true;
    }

    function unfreezeSlider() {
      if (!frozen) {
        return;
      } // restore edge padding for inner wrapper
      // for mordern browsers


      if (edgePadding && CSSMQ) {
        innerWrapper.style.margin = '';
      } // remove class tns-transparent to cloned slides


      if (cloneCount) {
        var str = 'tns-transparent';

        for (var i = cloneCount; i--;) {
          if (carousel) {
            removeClass(slideItems[i], str);
          }

          removeClass(slideItems[slideCountNew - i - 1], str);
        }
      } // update tools


      enableUI();
      frozen = false;
    }

    function disableSlider() {
      if (disabled) {
        return;
      }

      sheet.disabled = true;
      container.className = container.className.replace(newContainerClasses.substring(1), '');
      removeAttrs(container, ['style']);

      if (loop) {
        for (var j = cloneCount; j--;) {
          if (carousel) {
            hideElement(slideItems[j]);
          }

          hideElement(slideItems[slideCountNew - j - 1]);
        }
      } // vertical slider


      if (!horizontal || !carousel) {
        removeAttrs(innerWrapper, ['style']);
      } // gallery


      if (!carousel) {
        for (var i = index, l = index + slideCount; i < l; i++) {
          var item = slideItems[i];
          removeAttrs(item, ['style']);
          removeClass(item, animateIn);
          removeClass(item, animateNormal);
        }
      } // update tools


      disableUI();
      disabled = true;
    }

    function enableSlider() {
      if (!disabled) {
        return;
      }

      sheet.disabled = false;
      container.className += newContainerClasses;
      doContainerTransformSilent();

      if (loop) {
        for (var j = cloneCount; j--;) {
          if (carousel) {
            showElement(slideItems[j]);
          }

          showElement(slideItems[slideCountNew - j - 1]);
        }
      } // gallery


      if (!carousel) {
        for (var i = index, l = index + slideCount; i < l; i++) {
          var item = slideItems[i],
              classN = i < index + items ? animateIn : animateNormal;
          item.style.left = (i - index) * 100 / items + '%';
          addClass(item, classN);
        }
      } // update tools


      enableUI();
      disabled = false;
    }

    function updateLiveRegion() {
      var str = getLiveRegionStr();

      if (liveregionCurrent.innerHTML !== str) {
        liveregionCurrent.innerHTML = str;
      }
    }

    function getLiveRegionStr() {
      var arr = getVisibleSlideRange(),
          start = arr[0] + 1,
          end = arr[1] + 1;
      return start === end ? start + '' : start + ' to ' + end;
    }

    function getVisibleSlideRange(val) {
      if (val == null) {
        val = getContainerTransformValue();
      }

      var start = index,
          end,
          rangestart,
          rangeend; // get range start, range end for autoWidth and fixedWidth

      if (center || edgePadding) {
        if (autoWidth || fixedWidth) {
          rangestart = -(parseFloat(val) + edgePadding);
          rangeend = rangestart + viewport + edgePadding * 2;
        }
      } else {
        if (autoWidth) {
          rangestart = slidePositions[index];
          rangeend = rangestart + viewport;
        }
      } // get start, end
      // - check auto width


      if (autoWidth) {
        slidePositions.forEach(function (point, i) {
          if (i < slideCountNew) {
            if ((center || edgePadding) && point <= rangestart + 0.5) {
              start = i;
            }

            if (rangeend - point >= 0.5) {
              end = i;
            }
          }
        }); // - check percentage width, fixed width
      } else {
        if (fixedWidth) {
          var cell = fixedWidth + gutter;

          if (center || edgePadding) {
            start = Math.floor(rangestart / cell);
            end = Math.ceil(rangeend / cell - 1);
          } else {
            end = start + Math.ceil(viewport / cell) - 1;
          }
        } else {
          if (center || edgePadding) {
            var a = items - 1;

            if (center) {
              start -= a / 2;
              end = index + a / 2;
            } else {
              end = index + a;
            }

            if (edgePadding) {
              var b = edgePadding * items / viewport;
              start -= b;
              end += b;
            }

            start = Math.floor(start);
            end = Math.ceil(end);
          } else {
            end = start + items - 1;
          }
        }

        start = Math.max(start, 0);
        end = Math.min(end, slideCountNew - 1);
      }

      return [start, end];
    }

    function doLazyLoad() {
      if (lazyload && !disable) {
        var arg = getVisibleSlideRange();
        arg.push(lazyloadSelector);
        getImageArray.apply(null, arg).forEach(function (img) {
          if (!hasClass(img, imgCompleteClass)) {
            // stop propagation transitionend event to container
            var eve = {};

            eve[TRANSITIONEND] = function (e) {
              e.stopPropagation();
            };

            addEvents(img, eve);
            addEvents(img, imgEvents); // update src

            img.src = getAttr(img, 'data-src'); // update srcset

            var srcset = getAttr(img, 'data-srcset');

            if (srcset) {
              img.srcset = srcset;
            }

            addClass(img, 'loading');
          }
        });
      }
    }

    function onImgLoaded(e) {
      imgLoaded(getTarget(e));
    }

    function onImgFailed(e) {
      imgFailed(getTarget(e));
    }

    function imgLoaded(img) {
      addClass(img, 'loaded');
      imgCompleted(img);
    }

    function imgFailed(img) {
      addClass(img, 'failed');
      imgCompleted(img);
    }

    function imgCompleted(img) {
      addClass(img, imgCompleteClass);
      removeClass(img, 'loading');
      removeEvents(img, imgEvents);
    }

    function getImageArray(start, end, imgSelector) {
      var imgs = [];

      if (!imgSelector) {
        imgSelector = 'img';
      }

      while (start <= end) {
        forEach(slideItems[start].querySelectorAll(imgSelector), function (img) {
          imgs.push(img);
        });
        start++;
      }

      return imgs;
    } // check if all visible images are loaded
    // and update container height if it's done


    function doAutoHeight() {
      var imgs = getImageArray.apply(null, getVisibleSlideRange());
      raf(function () {
        imgsLoadedCheck(imgs, updateInnerWrapperHeight);
      });
    }

    function imgsLoadedCheck(imgs, cb) {
      // execute callback function if all images are complete
      if (imgsComplete) {
        return cb();
      } // check image classes


      imgs.forEach(function (img, index) {
        if (!lazyload && img.complete) {
          imgCompleted(img);
        } // Check image.complete


        if (hasClass(img, imgCompleteClass)) {
          imgs.splice(index, 1);
        }
      }); // execute callback function if selected images are all complete

      if (!imgs.length) {
        return cb();
      } // otherwise execute this functiona again


      raf(function () {
        imgsLoadedCheck(imgs, cb);
      });
    }

    function additionalUpdates() {
      doLazyLoad();
      updateSlideStatus();
      updateLiveRegion();
      updateControlsStatus();
      updateNavStatus();
    }

    function update_carousel_transition_duration() {
      if (carousel && autoHeight) {
        middleWrapper.style[TRANSITIONDURATION] = speed / 1000 + 's';
      }
    }

    function getMaxSlideHeight(slideStart, slideRange) {
      var heights = [];

      for (var i = slideStart, l = Math.min(slideStart + slideRange, slideCountNew); i < l; i++) {
        heights.push(slideItems[i].offsetHeight);
      }

      return Math.max.apply(null, heights);
    } // update inner wrapper height
    // 1. get the max-height of the visible slides
    // 2. set transitionDuration to speed
    // 3. update inner wrapper height to max-height
    // 4. set transitionDuration to 0s after transition done


    function updateInnerWrapperHeight() {
      var maxHeight = autoHeight ? getMaxSlideHeight(index, items) : getMaxSlideHeight(cloneCount, slideCount),
          wp = middleWrapper ? middleWrapper : innerWrapper;

      if (wp.style.height !== maxHeight) {
        wp.style.height = maxHeight + 'px';
      }
    } // get the distance from the top edge of the first slide to each slide
    // (init) => slidePositions


    function setSlidePositions() {
      slidePositions = [0];
      var attr = horizontal ? 'left' : 'top',
          attr2 = horizontal ? 'right' : 'bottom',
          base = slideItems[0].getBoundingClientRect()[attr];
      forEach(slideItems, function (item, i) {
        // skip the first slide
        if (i) {
          slidePositions.push(item.getBoundingClientRect()[attr] - base);
        } // add the end edge


        if (i === slideCountNew - 1) {
          slidePositions.push(item.getBoundingClientRect()[attr2] - base);
        }
      });
    } // update slide


    function updateSlideStatus() {
      var range = getVisibleSlideRange(),
          start = range[0],
          end = range[1];
      forEach(slideItems, function (item, i) {
        // show slides
        if (i >= start && i <= end) {
          if (hasAttr(item, 'aria-hidden')) {
            removeAttrs(item, ['aria-hidden', 'tabindex']);
            addClass(item, slideActiveClass);
          } // hide slides

        } else {
          if (!hasAttr(item, 'aria-hidden')) {
            setAttrs(item, {
              'aria-hidden': 'true',
              'tabindex': '-1'
            });
            removeClass(item, slideActiveClass);
          }
        }
      });
    } // gallery: update slide position


    function updateGallerySlidePositions() {
      var l = index + Math.min(slideCount, items);

      for (var i = slideCountNew; i--;) {
        var item = slideItems[i];

        if (i >= index && i < l) {
          // add transitions to visible slides when adjusting their positions
          addClass(item, 'tns-moving');
          item.style.left = (i - index) * 100 / items + '%';
          addClass(item, animateIn);
          removeClass(item, animateNormal);
        } else if (item.style.left) {
          item.style.left = '';
          addClass(item, animateNormal);
          removeClass(item, animateIn);
        } // remove outlet animation


        removeClass(item, animateOut);
      } // removing '.tns-moving'


      setTimeout(function () {
        forEach(slideItems, function (el) {
          removeClass(el, 'tns-moving');
        });
      }, 300);
    } // set tabindex on Nav


    function updateNavStatus() {
      // get current nav
      if (nav) {
        navCurrentIndex = navClicked >= 0 ? navClicked : getCurrentNavIndex();
        navClicked = -1;

        if (navCurrentIndex !== navCurrentIndexCached) {
          var navPrev = navItems[navCurrentIndexCached],
              navCurrent = navItems[navCurrentIndex];
          setAttrs(navPrev, {
            'tabindex': '-1',
            'aria-label': navStr + (navCurrentIndexCached + 1)
          });
          removeClass(navPrev, navActiveClass);
          setAttrs(navCurrent, {
            'aria-label': navStr + (navCurrentIndex + 1) + navStrCurrent
          });
          removeAttrs(navCurrent, 'tabindex');
          addClass(navCurrent, navActiveClass);
          navCurrentIndexCached = navCurrentIndex;
        }
      }
    }

    function getLowerCaseNodeName(el) {
      return el.nodeName.toLowerCase();
    }

    function isButton(el) {
      return getLowerCaseNodeName(el) === 'button';
    }

    function isAriaDisabled(el) {
      return el.getAttribute('aria-disabled') === 'true';
    }

    function disEnableElement(isButton, el, val) {
      if (isButton) {
        el.disabled = val;
      } else {
        el.setAttribute('aria-disabled', val.toString());
      }
    } // set 'disabled' to true on controls when reach the edges


    function updateControlsStatus() {
      if (!controls || rewind || loop) {
        return;
      }

      var prevDisabled = prevIsButton ? prevButton.disabled : isAriaDisabled(prevButton),
          nextDisabled = nextIsButton ? nextButton.disabled : isAriaDisabled(nextButton),
          disablePrev = index <= indexMin ? true : false,
          disableNext = !rewind && index >= indexMax ? true : false;

      if (disablePrev && !prevDisabled) {
        disEnableElement(prevIsButton, prevButton, true);
      }

      if (!disablePrev && prevDisabled) {
        disEnableElement(prevIsButton, prevButton, false);
      }

      if (disableNext && !nextDisabled) {
        disEnableElement(nextIsButton, nextButton, true);
      }

      if (!disableNext && nextDisabled) {
        disEnableElement(nextIsButton, nextButton, false);
      }
    } // set duration


    function resetDuration(el, str) {
      if (TRANSITIONDURATION) {
        el.style[TRANSITIONDURATION] = str;
      }
    }

    function getSliderWidth() {
      return fixedWidth ? (fixedWidth + gutter) * slideCountNew : slidePositions[slideCountNew];
    }

    function getCenterGap(num) {
      if (num == null) {
        num = index;
      }

      var gap = edgePadding ? gutter : 0;
      return autoWidth ? (viewport - gap - (slidePositions[num + 1] - slidePositions[num] - gutter)) / 2 : fixedWidth ? (viewport - fixedWidth) / 2 : (items - 1) / 2;
    }

    function getRightBoundary() {
      var gap = edgePadding ? gutter : 0,
          result = viewport + gap - getSliderWidth();

      if (center && !loop) {
        result = fixedWidth ? -(fixedWidth + gutter) * (slideCountNew - 1) - getCenterGap() : getCenterGap(slideCountNew - 1) - slidePositions[slideCountNew - 1];
      }

      if (result > 0) {
        result = 0;
      }

      return result;
    }

    function getContainerTransformValue(num) {
      if (num == null) {
        num = index;
      }

      var val;

      if (horizontal && !autoWidth) {
        if (fixedWidth) {
          val = -(fixedWidth + gutter) * num;

          if (center) {
            val += getCenterGap();
          }
        } else {
          var denominator = TRANSFORM ? slideCountNew : items;

          if (center) {
            num -= getCenterGap();
          }

          val = -num * 100 / denominator;
        }
      } else {
        val = -slidePositions[num];

        if (center && autoWidth) {
          val += getCenterGap();
        }
      }

      if (hasRightDeadZone) {
        val = Math.max(val, rightBoundary);
      }

      val += horizontal && !autoWidth && !fixedWidth ? '%' : 'px';
      return val;
    }

    function doContainerTransformSilent(val) {
      resetDuration(container, '0s');
      doContainerTransform(val);
    }

    function doContainerTransform(val) {
      if (val == null) {
        val = getContainerTransformValue();
      }

      container.style[transformAttr] = transformPrefix + val + transformPostfix;
    }

    function animateSlide(number, classOut, classIn, isOut) {
      var l = number + items;

      if (!loop) {
        l = Math.min(l, slideCountNew);
      }

      for (var i = number; i < l; i++) {
        var item = slideItems[i]; // set item positions

        if (!isOut) {
          item.style.left = (i - index) * 100 / items + '%';
        }

        if (animateDelay && TRANSITIONDELAY) {
          item.style[TRANSITIONDELAY] = item.style[ANIMATIONDELAY] = animateDelay * (i - number) / 1000 + 's';
        }

        removeClass(item, classOut);
        addClass(item, classIn);

        if (isOut) {
          slideItemsOut.push(item);
        }
      }
    } // make transfer after click/drag:
    // 1. change 'transform' property for mordern browsers
    // 2. change 'left' property for legacy browsers


    var transformCore = function () {
      return carousel ? function () {
        resetDuration(container, '');

        if (TRANSITIONDURATION || !speed) {
          // for morden browsers with non-zero duration or
          // zero duration for all browsers
          doContainerTransform(); // run fallback function manually
          // when duration is 0 / container is hidden

          if (!speed || !isVisible(container)) {
            onTransitionEnd();
          }
        } else {
          // for old browser with non-zero duration
          jsTransform(container, transformAttr, transformPrefix, transformPostfix, getContainerTransformValue(), speed, onTransitionEnd);
        }

        if (!horizontal) {
          updateContentWrapperHeight();
        }
      } : function () {
        slideItemsOut = [];
        var eve = {};
        eve[TRANSITIONEND] = eve[ANIMATIONEND] = onTransitionEnd;
        removeEvents(slideItems[indexCached], eve);
        addEvents(slideItems[index], eve);
        animateSlide(indexCached, animateIn, animateOut, true);
        animateSlide(index, animateNormal, animateIn); // run fallback function manually
        // when transition or animation not supported / duration is 0

        if (!TRANSITIONEND || !ANIMATIONEND || !speed || !isVisible(container)) {
          onTransitionEnd();
        }
      };
    }();

    function render(e, sliderMoved) {
      if (updateIndexBeforeTransform) {
        updateIndex();
      } // render when slider was moved (touch or drag) even though index may not change


      if (index !== indexCached || sliderMoved) {
        // events
        events.emit('indexChanged', info());
        events.emit('transitionStart', info());

        if (autoHeight) {
          doAutoHeight();
        } // pause autoplay when click or keydown from user


        if (animating && e && ['click', 'keydown'].indexOf(e.type) >= 0) {
          stopAutoplay();
        }

        running = true;
        transformCore();
      }
    }
    /*
     * Transfer prefixed properties to the same format
     * CSS: -Webkit-Transform => webkittransform
     * JS: WebkitTransform => webkittransform
     * @param {string} str - property
     *
     */


    function strTrans(str) {
      return str.toLowerCase().replace(/-/g, '');
    } // AFTER TRANSFORM
    // Things need to be done after a transfer:
    // 1. check index
    // 2. add classes to visible slide
    // 3. disable controls buttons when reach the first/last slide in non-loop slider
    // 4. update nav status
    // 5. lazyload images
    // 6. update container height


    function onTransitionEnd(event) {
      // check running on gallery mode
      // make sure trantionend/animationend events run only once
      if (carousel || running) {
        events.emit('transitionEnd', info(event));

        if (!carousel && slideItemsOut.length > 0) {
          for (var i = 0; i < slideItemsOut.length; i++) {
            var item = slideItemsOut[i]; // set item positions

            item.style.left = '';

            if (ANIMATIONDELAY && TRANSITIONDELAY) {
              item.style[ANIMATIONDELAY] = '';
              item.style[TRANSITIONDELAY] = '';
            }

            removeClass(item, animateOut);
            addClass(item, animateNormal);
          }
        }
        /* update slides, nav, controls after checking ...
         * => legacy browsers who don't support 'event'
         *    have to check event first, otherwise event.target will cause an error
         * => or 'gallery' mode:
         *   + event target is slide item
         * => or 'carousel' mode:
         *   + event target is container,
         *   + event.property is the same with transform attribute
         */


        if (!event || !carousel && event.target.parentNode === container || event.target === container && strTrans(event.propertyName) === strTrans(transformAttr)) {
          if (!updateIndexBeforeTransform) {
            var indexTem = index;
            updateIndex();

            if (index !== indexTem) {
              events.emit('indexChanged', info());
              doContainerTransformSilent();
            }
          }

          if (nested === 'inner') {
            events.emit('innerLoaded', info());
          }

          running = false;
          indexCached = index;
        }
      }
    } // # ACTIONS


    function goTo(targetIndex, e) {
      if (freeze) {
        return;
      } // prev slideBy


      if (targetIndex === 'prev') {
        onControlsClick(e, -1); // next slideBy
      } else if (targetIndex === 'next') {
        onControlsClick(e, 1); // go to exact slide
      } else {
        if (running) {
          if (preventActionWhenRunning) {
            return;
          } else {
            onTransitionEnd();
          }
        }

        var absIndex = getAbsIndex(),
            indexGap = 0;

        if (targetIndex === 'first') {
          indexGap = -absIndex;
        } else if (targetIndex === 'last') {
          indexGap = carousel ? slideCount - items - absIndex : slideCount - 1 - absIndex;
        } else {
          if (typeof targetIndex !== 'number') {
            targetIndex = parseInt(targetIndex);
          }

          if (!isNaN(targetIndex)) {
            // from directly called goTo function
            if (!e) {
              targetIndex = Math.max(0, Math.min(slideCount - 1, targetIndex));
            }

            indexGap = targetIndex - absIndex;
          }
        } // gallery: make sure new page won't overlap with current page


        if (!carousel && indexGap && Math.abs(indexGap) < items) {
          var factor = indexGap > 0 ? 1 : -1;
          indexGap += index + indexGap - slideCount >= indexMin ? slideCount * factor : slideCount * 2 * factor * -1;
        }

        index += indexGap; // make sure index is in range

        if (carousel && loop) {
          if (index < indexMin) {
            index += slideCount;
          }

          if (index > indexMax) {
            index -= slideCount;
          }
        } // if index is changed, start rendering


        if (getAbsIndex(index) !== getAbsIndex(indexCached)) {
          render(e);
        }
      }
    } // on controls click


    function onControlsClick(e, dir) {
      if (running) {
        if (preventActionWhenRunning) {
          return;
        } else {
          onTransitionEnd();
        }
      }

      var passEventObject;

      if (!dir) {
        e = getEvent(e);
        var target = getTarget(e);

        while (target !== controlsContainer && [prevButton, nextButton].indexOf(target) < 0) {
          target = target.parentNode;
        }

        var targetIn = [prevButton, nextButton].indexOf(target);

        if (targetIn >= 0) {
          passEventObject = true;
          dir = targetIn === 0 ? -1 : 1;
        }
      }

      if (rewind) {
        if (index === indexMin && dir === -1) {
          goTo('last', e);
          return;
        } else if (index === indexMax && dir === 1) {
          goTo('first', e);
          return;
        }
      }

      if (dir) {
        index += slideBy * dir;

        if (autoWidth) {
          index = Math.floor(index);
        } // pass e when click control buttons or keydown


        render(passEventObject || e && e.type === 'keydown' ? e : null);
      }
    } // on nav click


    function onNavClick(e) {
      if (running) {
        if (preventActionWhenRunning) {
          return;
        } else {
          onTransitionEnd();
        }
      }

      e = getEvent(e);
      var target = getTarget(e),
          navIndex; // find the clicked nav item

      while (target !== navContainer && !hasAttr(target, 'data-nav')) {
        target = target.parentNode;
      }

      if (hasAttr(target, 'data-nav')) {
        var navIndex = navClicked = Number(getAttr(target, 'data-nav')),
            targetIndexBase = fixedWidth || autoWidth ? navIndex * slideCount / pages : navIndex * items,
            targetIndex = navAsThumbnails ? navIndex : Math.min(Math.ceil(targetIndexBase), slideCount - 1);
        goTo(targetIndex, e);

        if (navCurrentIndex === navIndex) {
          if (animating) {
            stopAutoplay();
          }

          navClicked = -1; // reset navClicked
        }
      }
    } // autoplay functions


    function setAutoplayTimer() {
      autoplayTimer = setInterval(function () {
        onControlsClick(null, autoplayDirection);
      }, autoplayTimeout);
      animating = true;
    }

    function stopAutoplayTimer() {
      clearInterval(autoplayTimer);
      animating = false;
    }

    function updateAutoplayButton(action, txt) {
      setAttrs(autoplayButton, {
        'data-action': action
      });
      autoplayButton.innerHTML = autoplayHtmlStrings[0] + action + autoplayHtmlStrings[1] + txt;
    }

    function startAutoplay() {
      setAutoplayTimer();

      if (autoplayButton) {
        updateAutoplayButton('stop', autoplayText[1]);
      }
    }

    function stopAutoplay() {
      stopAutoplayTimer();

      if (autoplayButton) {
        updateAutoplayButton('start', autoplayText[0]);
      }
    } // programaitcally play/pause the slider


    function play() {
      if (autoplay && !animating) {
        startAutoplay();
        autoplayUserPaused = false;
      }
    }

    function pause() {
      if (animating) {
        stopAutoplay();
        autoplayUserPaused = true;
      }
    }

    function toggleAutoplay() {
      if (animating) {
        stopAutoplay();
        autoplayUserPaused = true;
      } else {
        startAutoplay();
        autoplayUserPaused = false;
      }
    }

    function onVisibilityChange() {
      if (doc.hidden) {
        if (animating) {
          stopAutoplayTimer();
          autoplayVisibilityPaused = true;
        }
      } else if (autoplayVisibilityPaused) {
        setAutoplayTimer();
        autoplayVisibilityPaused = false;
      }
    }

    function mouseoverPause() {
      if (animating) {
        stopAutoplayTimer();
        autoplayHoverPaused = true;
      }
    }

    function mouseoutRestart() {
      if (autoplayHoverPaused) {
        setAutoplayTimer();
        autoplayHoverPaused = false;
      }
    } // keydown events on document


    function onDocumentKeydown(e) {
      e = getEvent(e);
      var keyIndex = [KEYS.LEFT, KEYS.RIGHT].indexOf(e.keyCode);

      if (keyIndex >= 0) {
        onControlsClick(e, keyIndex === 0 ? -1 : 1);
      }
    } // on key control


    function onControlsKeydown(e) {
      e = getEvent(e);
      var keyIndex = [KEYS.LEFT, KEYS.RIGHT].indexOf(e.keyCode);

      if (keyIndex >= 0) {
        if (keyIndex === 0) {
          if (!prevButton.disabled) {
            onControlsClick(e, -1);
          }
        } else if (!nextButton.disabled) {
          onControlsClick(e, 1);
        }
      }
    } // set focus


    function setFocus(el) {
      el.focus();
    } // on key nav


    function onNavKeydown(e) {
      e = getEvent(e);
      var curElement = doc.activeElement;

      if (!hasAttr(curElement, 'data-nav')) {
        return;
      } // var code = e.keyCode,


      var keyIndex = [KEYS.LEFT, KEYS.RIGHT, KEYS.ENTER, KEYS.SPACE].indexOf(e.keyCode),
          navIndex = Number(getAttr(curElement, 'data-nav'));

      if (keyIndex >= 0) {
        if (keyIndex === 0) {
          if (navIndex > 0) {
            setFocus(navItems[navIndex - 1]);
          }
        } else if (keyIndex === 1) {
          if (navIndex < pages - 1) {
            setFocus(navItems[navIndex + 1]);
          }
        } else {
          navClicked = navIndex;
          goTo(navIndex, e);
        }
      }
    }

    function getEvent(e) {
      e = e || win.event;
      return isTouchEvent(e) ? e.changedTouches[0] : e;
    }

    function getTarget(e) {
      return e.target || win.event.srcElement;
    }

    function isTouchEvent(e) {
      return e.type.indexOf('touch') >= 0;
    }

    function preventDefaultBehavior(e) {
      e.preventDefault ? e.preventDefault() : e.returnValue = false;
    }

    function getMoveDirectionExpected() {
      return getTouchDirection(toDegree(lastPosition.y - initPosition.y, lastPosition.x - initPosition.x), swipeAngle) === options.axis;
    }

    function onPanStart(e) {
      if (running) {
        if (preventActionWhenRunning) {
          return;
        } else {
          onTransitionEnd();
        }
      }

      if (autoplay && animating) {
        stopAutoplayTimer();
      }

      panStart = true;

      if (rafIndex) {
        caf(rafIndex);
        rafIndex = null;
      }

      var $ = getEvent(e);
      events.emit(isTouchEvent(e) ? 'touchStart' : 'dragStart', info(e));

      if (!isTouchEvent(e) && ['img', 'a'].indexOf(getLowerCaseNodeName(getTarget(e))) >= 0) {
        preventDefaultBehavior(e);
      }

      lastPosition.x = initPosition.x = $.clientX;
      lastPosition.y = initPosition.y = $.clientY;

      if (carousel) {
        translateInit = parseFloat(container.style[transformAttr].replace(transformPrefix, ''));
        resetDuration(container, '0s');
      }
    }

    function onPanMove(e) {
      if (panStart) {
        var $ = getEvent(e);
        lastPosition.x = $.clientX;
        lastPosition.y = $.clientY;

        if (carousel) {
          if (!rafIndex) {
            rafIndex = raf(function () {
              panUpdate(e);
            });
          }
        } else {
          if (moveDirectionExpected === '?') {
            moveDirectionExpected = getMoveDirectionExpected();
          }

          if (moveDirectionExpected) {
            preventScroll = true;
          }
        }

        if ((typeof e.cancelable !== 'boolean' || e.cancelable) && preventScroll) {
          e.preventDefault();
        }
      }
    }

    function panUpdate(e) {
      if (!moveDirectionExpected) {
        panStart = false;
        return;
      }

      caf(rafIndex);

      if (panStart) {
        rafIndex = raf(function () {
          panUpdate(e);
        });
      }

      if (moveDirectionExpected === '?') {
        moveDirectionExpected = getMoveDirectionExpected();
      }

      if (moveDirectionExpected) {
        if (!preventScroll && isTouchEvent(e)) {
          preventScroll = true;
        }

        try {
          if (e.type) {
            events.emit(isTouchEvent(e) ? 'touchMove' : 'dragMove', info(e));
          }
        } catch (err) {}

        var x = translateInit,
            dist = getDist(lastPosition, initPosition);

        if (!horizontal || fixedWidth || autoWidth) {
          x += dist;
          x += 'px';
        } else {
          var percentageX = TRANSFORM ? dist * items * 100 / ((viewport + gutter) * slideCountNew) : dist * 100 / (viewport + gutter);
          x += percentageX;
          x += '%';
        }

        container.style[transformAttr] = transformPrefix + x + transformPostfix;
      }
    }

    function onPanEnd(e) {
      if (panStart) {
        if (rafIndex) {
          caf(rafIndex);
          rafIndex = null;
        }

        if (carousel) {
          resetDuration(container, '');
        }

        panStart = false;
        var $ = getEvent(e);
        lastPosition.x = $.clientX;
        lastPosition.y = $.clientY;
        var dist = getDist(lastPosition, initPosition);

        if (Math.abs(dist)) {
          // drag vs click
          if (!isTouchEvent(e)) {
            // prevent "click"
            var target = getTarget(e);
            addEvents(target, {
              'click': function preventClick(e) {
                preventDefaultBehavior(e);
                removeEvents(target, {
                  'click': preventClick
                });
              }
            });
          }

          if (carousel) {
            rafIndex = raf(function () {
              if (horizontal && !autoWidth) {
                var indexMoved = -dist * items / (viewport + gutter);
                indexMoved = dist > 0 ? Math.floor(indexMoved) : Math.ceil(indexMoved);
                index += indexMoved;
              } else {
                var moved = -(translateInit + dist);

                if (moved <= 0) {
                  index = indexMin;
                } else if (moved >= slidePositions[slideCountNew - 1]) {
                  index = indexMax;
                } else {
                  var i = 0;

                  while (i < slideCountNew && moved >= slidePositions[i]) {
                    index = i;

                    if (moved > slidePositions[i] && dist < 0) {
                      index += 1;
                    }

                    i++;
                  }
                }
              }

              render(e, dist);
              events.emit(isTouchEvent(e) ? 'touchEnd' : 'dragEnd', info(e));
            });
          } else {
            if (moveDirectionExpected) {
              onControlsClick(e, dist > 0 ? -1 : 1);
            }
          }
        }
      } // reset


      if (options.preventScrollOnTouch === 'auto') {
        preventScroll = false;
      }

      if (swipeAngle) {
        moveDirectionExpected = '?';
      }

      if (autoplay && !animating) {
        setAutoplayTimer();
      }
    } // === RESIZE FUNCTIONS === //
    // (slidePositions, index, items) => vertical_conentWrapper.height


    function updateContentWrapperHeight() {
      var wp = middleWrapper ? middleWrapper : innerWrapper;
      wp.style.height = slidePositions[index + items] - slidePositions[index] + 'px';
    }

    function getPages() {
      var rough = fixedWidth ? (fixedWidth + gutter) * slideCount / viewport : slideCount / items;
      return Math.min(Math.ceil(rough), slideCount);
    }
    /*
     * 1. update visible nav items list
     * 2. add "hidden" attributes to previous visible nav items
     * 3. remove "hidden" attrubutes to new visible nav items
     */


    function updateNavVisibility() {
      if (!nav || navAsThumbnails) {
        return;
      }

      if (pages !== pagesCached) {
        var min = pagesCached,
            max = pages,
            fn = showElement;

        if (pagesCached > pages) {
          min = pages;
          max = pagesCached;
          fn = hideElement;
        }

        while (min < max) {
          fn(navItems[min]);
          min++;
        } // cache pages


        pagesCached = pages;
      }
    }

    function info(e) {
      return {
        container: container,
        slideItems: slideItems,
        navContainer: navContainer,
        navItems: navItems,
        controlsContainer: controlsContainer,
        hasControls: hasControls,
        prevButton: prevButton,
        nextButton: nextButton,
        items: items,
        slideBy: slideBy,
        cloneCount: cloneCount,
        slideCount: slideCount,
        slideCountNew: slideCountNew,
        index: index,
        indexCached: indexCached,
        displayIndex: getCurrentSlide(),
        navCurrentIndex: navCurrentIndex,
        navCurrentIndexCached: navCurrentIndexCached,
        pages: pages,
        pagesCached: pagesCached,
        sheet: sheet,
        isOn: isOn,
        event: e || {}
      };
    }

    return {
      version: '2.9.4',
      getInfo: info,
      events: events,
      goTo: goTo,
      play: play,
      pause: pause,
      isOn: isOn,
      updateSliderHeight: updateInnerWrapperHeight,
      refresh: initSliderTransform,
      destroy: destroy,
      rebuild: function rebuild() {
        return tns(extend(options, optionsElements));
      }
    };
  };

  exports.tns = tns;
  /***/
},
/* 22 */

/***/
function (module, exports) {
  /**
   * Returns a function, that, as long as it continues to be invoked, will not
   * be triggered. The function will be called after it stops being called for
   * N milliseconds. If `immediate` is passed, trigger the function on the
   * leading edge, instead of the trailing. The function also has a property 'clear' 
   * that is a function which will clear the timer to prevent previously scheduled executions. 
   *
   * @source underscore.js
   * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
   * @param {Function} function to wrap
   * @param {Number} timeout in ms (`100`)
   * @param {Boolean} whether to execute at the beginning (`false`)
   * @api public
   */
  function debounce(func, wait, immediate) {
    var timeout, args, context, timestamp, result;
    if (null == wait) wait = 100;

    function later() {
      var last = Date.now() - timestamp;

      if (last < wait && last >= 0) {
        timeout = setTimeout(later, wait - last);
      } else {
        timeout = null;

        if (!immediate) {
          result = func.apply(context, args);
          context = args = null;
        }
      }
    }

    ;

    var debounced = function debounced() {
      context = this;
      args = arguments;
      timestamp = Date.now();
      var callNow = immediate && !timeout;
      if (!timeout) timeout = setTimeout(later, wait);

      if (callNow) {
        result = func.apply(context, args);
        context = args = null;
      }

      return result;
    };

    debounced.clear = function () {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
    };

    debounced.flush = function () {
      if (timeout) {
        result = func.apply(context, args);
        context = args = null;
        clearTimeout(timeout);
        timeout = null;
      }
    };

    return debounced;
  }

  ; // Adds compatibility for ES modules

  debounce.debounce = debounce;
  module.exports = debounce;
  /***/
},
/* 23 */

/***/
function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */
  (function (module) {
    var __WEBPACK_AMD_DEFINE_RESULT__;

    function _typeof(obj) {
      "@babel/helpers - typeof";

      return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      }, _typeof(obj);
    }
    /* global define */


    (function (root, pluralize) {
      /* istanbul ignore else */
      if (true && (false ? undefined : _typeof(exports)) === 'object' && (false ? undefined : _typeof(module)) === 'object') {
        // Node.
        module.exports = pluralize();
      } else if (true) {
        // AMD, registers as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
          return pluralize();
        }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
      } else {}
    })(this, function () {
      // Rule storage - pluralize and singularize need to be run sequentially,
      // while other rules can be optimized using an object for instant lookups.
      var pluralRules = [];
      var singularRules = [];
      var uncountables = {};
      var irregularPlurals = {};
      var irregularSingles = {};
      /**
       * Sanitize a pluralization rule to a usable regular expression.
       *
       * @param  {(RegExp|string)} rule
       * @return {RegExp}
       */

      function sanitizeRule(rule) {
        if (typeof rule === 'string') {
          return new RegExp('^' + rule + '$', 'i');
        }

        return rule;
      }
      /**
       * Pass in a word token to produce a function that can replicate the case on
       * another word.
       *
       * @param  {string}   word
       * @param  {string}   token
       * @return {Function}
       */


      function restoreCase(word, token) {
        // Tokens are an exact match.
        if (word === token) return token; // Lower cased words. E.g. "hello".

        if (word === word.toLowerCase()) return token.toLowerCase(); // Upper cased words. E.g. "WHISKY".

        if (word === word.toUpperCase()) return token.toUpperCase(); // Title cased words. E.g. "Title".

        if (word[0] === word[0].toUpperCase()) {
          return token.charAt(0).toUpperCase() + token.substr(1).toLowerCase();
        } // Lower cased words. E.g. "test".


        return token.toLowerCase();
      }
      /**
       * Interpolate a regexp string.
       *
       * @param  {string} str
       * @param  {Array}  args
       * @return {string}
       */


      function interpolate(str, args) {
        return str.replace(/\$(\d{1,2})/g, function (match, index) {
          return args[index] || '';
        });
      }
      /**
       * Replace a word using a rule.
       *
       * @param  {string} word
       * @param  {Array}  rule
       * @return {string}
       */


      function replace(word, rule) {
        return word.replace(rule[0], function (match, index) {
          var result = interpolate(rule[1], arguments);

          if (match === '') {
            return restoreCase(word[index - 1], result);
          }

          return restoreCase(match, result);
        });
      }
      /**
       * Sanitize a word by passing in the word and sanitization rules.
       *
       * @param  {string}   token
       * @param  {string}   word
       * @param  {Array}    rules
       * @return {string}
       */


      function sanitizeWord(token, word, rules) {
        // Empty string or doesn't need fixing.
        if (!token.length || uncountables.hasOwnProperty(token)) {
          return word;
        }

        var len = rules.length; // Iterate over the sanitization rules and use the first one to match.

        while (len--) {
          var rule = rules[len];
          if (rule[0].test(word)) return replace(word, rule);
        }

        return word;
      }
      /**
       * Replace a word with the updated word.
       *
       * @param  {Object}   replaceMap
       * @param  {Object}   keepMap
       * @param  {Array}    rules
       * @return {Function}
       */


      function replaceWord(replaceMap, keepMap, rules) {
        return function (word) {
          // Get the correct token and case restoration functions.
          var token = word.toLowerCase(); // Check against the keep object map.

          if (keepMap.hasOwnProperty(token)) {
            return restoreCase(word, token);
          } // Check against the replacement map for a direct word replacement.


          if (replaceMap.hasOwnProperty(token)) {
            return restoreCase(word, replaceMap[token]);
          } // Run all the rules against the word.


          return sanitizeWord(token, word, rules);
        };
      }
      /**
       * Check if a word is part of the map.
       */


      function checkWord(replaceMap, keepMap, rules, bool) {
        return function (word) {
          var token = word.toLowerCase();
          if (keepMap.hasOwnProperty(token)) return true;
          if (replaceMap.hasOwnProperty(token)) return false;
          return sanitizeWord(token, token, rules) === token;
        };
      }
      /**
       * Pluralize or singularize a word based on the passed in count.
       *
       * @param  {string}  word      The word to pluralize
       * @param  {number}  count     How many of the word exist
       * @param  {boolean} inclusive Whether to prefix with the number (e.g. 3 ducks)
       * @return {string}
       */


      function pluralize(word, count, inclusive) {
        var pluralized = count === 1 ? pluralize.singular(word) : pluralize.plural(word);
        return (inclusive ? count + ' ' : '') + pluralized;
      }
      /**
       * Pluralize a word.
       *
       * @type {Function}
       */


      pluralize.plural = replaceWord(irregularSingles, irregularPlurals, pluralRules);
      /**
       * Check if a word is plural.
       *
       * @type {Function}
       */

      pluralize.isPlural = checkWord(irregularSingles, irregularPlurals, pluralRules);
      /**
       * Singularize a word.
       *
       * @type {Function}
       */

      pluralize.singular = replaceWord(irregularPlurals, irregularSingles, singularRules);
      /**
       * Check if a word is singular.
       *
       * @type {Function}
       */

      pluralize.isSingular = checkWord(irregularPlurals, irregularSingles, singularRules);
      /**
       * Add a pluralization rule to the collection.
       *
       * @param {(string|RegExp)} rule
       * @param {string}          replacement
       */

      pluralize.addPluralRule = function (rule, replacement) {
        pluralRules.push([sanitizeRule(rule), replacement]);
      };
      /**
       * Add a singularization rule to the collection.
       *
       * @param {(string|RegExp)} rule
       * @param {string}          replacement
       */


      pluralize.addSingularRule = function (rule, replacement) {
        singularRules.push([sanitizeRule(rule), replacement]);
      };
      /**
       * Add an uncountable word rule.
       *
       * @param {(string|RegExp)} word
       */


      pluralize.addUncountableRule = function (word) {
        if (typeof word === 'string') {
          uncountables[word.toLowerCase()] = true;
          return;
        } // Set singular and plural references for the word.


        pluralize.addPluralRule(word, '$0');
        pluralize.addSingularRule(word, '$0');
      };
      /**
       * Add an irregular word definition.
       *
       * @param {string} single
       * @param {string} plural
       */


      pluralize.addIrregularRule = function (single, plural) {
        plural = plural.toLowerCase();
        single = single.toLowerCase();
        irregularSingles[single] = plural;
        irregularPlurals[plural] = single;
      };
      /**
       * Irregular rules.
       */


      [// Pronouns.
      ['I', 'we'], ['me', 'us'], ['he', 'they'], ['she', 'they'], ['them', 'them'], ['myself', 'ourselves'], ['yourself', 'yourselves'], ['itself', 'themselves'], ['herself', 'themselves'], ['himself', 'themselves'], ['themself', 'themselves'], ['is', 'are'], ['was', 'were'], ['has', 'have'], ['this', 'these'], ['that', 'those'], // Words ending in with a consonant and `o`.
      ['echo', 'echoes'], ['dingo', 'dingoes'], ['volcano', 'volcanoes'], ['tornado', 'tornadoes'], ['torpedo', 'torpedoes'], // Ends with `us`.
      ['genus', 'genera'], ['viscus', 'viscera'], // Ends with `ma`.
      ['stigma', 'stigmata'], ['stoma', 'stomata'], ['dogma', 'dogmata'], ['lemma', 'lemmata'], ['schema', 'schemata'], ['anathema', 'anathemata'], // Other irregular rules.
      ['ox', 'oxen'], ['axe', 'axes'], ['die', 'dice'], ['yes', 'yeses'], ['foot', 'feet'], ['eave', 'eaves'], ['goose', 'geese'], ['tooth', 'teeth'], ['quiz', 'quizzes'], ['human', 'humans'], ['proof', 'proofs'], ['carve', 'carves'], ['valve', 'valves'], ['looey', 'looies'], ['thief', 'thieves'], ['groove', 'grooves'], ['pickaxe', 'pickaxes'], ['passerby', 'passersby']].forEach(function (rule) {
        return pluralize.addIrregularRule(rule[0], rule[1]);
      });
      /**
       * Pluralization rules.
       */

      [[/s?$/i, 's'], [/[^\u0000-\u007F]$/i, '$0'], [/([^aeiou]ese)$/i, '$1'], [/(ax|test)is$/i, '$1es'], [/(alias|[^aou]us|t[lm]as|gas|ris)$/i, '$1es'], [/(e[mn]u)s?$/i, '$1s'], [/([^l]ias|[aeiou]las|[ejzr]as|[iu]am)$/i, '$1'], [/(alumn|syllab|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i, '$1i'], [/(alumn|alg|vertebr)(?:a|ae)$/i, '$1ae'], [/(seraph|cherub)(?:im)?$/i, '$1im'], [/(her|at|gr)o$/i, '$1oes'], [/(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|automat|quor)(?:a|um)$/i, '$1a'], [/(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)(?:a|on)$/i, '$1a'], [/sis$/i, 'ses'], [/(?:(kni|wi|li)fe|(ar|l|ea|eo|oa|hoo)f)$/i, '$1$2ves'], [/([^aeiouy]|qu)y$/i, '$1ies'], [/([^ch][ieo][ln])ey$/i, '$1ies'], [/(x|ch|ss|sh|zz)$/i, '$1es'], [/(matr|cod|mur|sil|vert|ind|append)(?:ix|ex)$/i, '$1ices'], [/\b((?:tit)?m|l)(?:ice|ouse)$/i, '$1ice'], [/(pe)(?:rson|ople)$/i, '$1ople'], [/(child)(?:ren)?$/i, '$1ren'], [/eaux$/i, '$0'], [/m[ae]n$/i, 'men'], ['thou', 'you']].forEach(function (rule) {
        return pluralize.addPluralRule(rule[0], rule[1]);
      });
      /**
       * Singularization rules.
       */

      [[/s$/i, ''], [/(ss)$/i, '$1'], [/(wi|kni|(?:after|half|high|low|mid|non|night|[^\w]|^)li)ves$/i, '$1fe'], [/(ar|(?:wo|[ae])l|[eo][ao])ves$/i, '$1f'], [/ies$/i, 'y'], [/\b([pl]|zomb|(?:neck|cross)?t|coll|faer|food|gen|goon|group|lass|talk|goal|cut)ies$/i, '$1ie'], [/\b(mon|smil)ies$/i, '$1ey'], [/\b((?:tit)?m|l)ice$/i, '$1ouse'], [/(seraph|cherub)im$/i, '$1'], [/(x|ch|ss|sh|zz|tto|go|cho|alias|[^aou]us|t[lm]as|gas|(?:her|at|gr)o|[aeiou]ris)(?:es)?$/i, '$1'], [/(analy|diagno|parenthe|progno|synop|the|empha|cri|ne)(?:sis|ses)$/i, '$1sis'], [/(movie|twelve|abuse|e[mn]u)s$/i, '$1'], [/(test)(?:is|es)$/i, '$1is'], [/(alumn|syllab|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i, '$1us'], [/(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|quor)a$/i, '$1um'], [/(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)a$/i, '$1on'], [/(alumn|alg|vertebr)ae$/i, '$1a'], [/(cod|mur|sil|vert|ind)ices$/i, '$1ex'], [/(matr|append)ices$/i, '$1ix'], [/(pe)(rson|ople)$/i, '$1rson'], [/(child)ren$/i, '$1'], [/(eau)x?$/i, '$1'], [/men$/i, 'man']].forEach(function (rule) {
        return pluralize.addSingularRule(rule[0], rule[1]);
      });
      /**
       * Uncountable rules.
       */

      [// Singular words with no plurals.
      'adulthood', 'advice', 'agenda', 'aid', 'aircraft', 'alcohol', 'ammo', 'analytics', 'anime', 'athletics', 'audio', 'bison', 'blood', 'bream', 'buffalo', 'butter', 'carp', 'cash', 'chassis', 'chess', 'clothing', 'cod', 'commerce', 'cooperation', 'corps', 'debris', 'diabetes', 'digestion', 'elk', 'energy', 'equipment', 'excretion', 'expertise', 'firmware', 'flounder', 'fun', 'gallows', 'garbage', 'graffiti', 'hardware', 'headquarters', 'health', 'herpes', 'highjinks', 'homework', 'housework', 'information', 'jeans', 'justice', 'kudos', 'labour', 'literature', 'machinery', 'mackerel', 'mail', 'media', 'mews', 'moose', 'music', 'mud', 'manga', 'news', 'only', 'personnel', 'pike', 'plankton', 'pliers', 'police', 'pollution', 'premises', 'rain', 'research', 'rice', 'salmon', 'scissors', 'series', 'sewage', 'shambles', 'shrimp', 'software', 'species', 'staff', 'swine', 'tennis', 'traffic', 'transportation', 'trout', 'tuna', 'wealth', 'welfare', 'whiting', 'wildebeest', 'wildlife', 'you', /pok[eé]mon$/i, // Regexes.
      /[^aeiou]ese$/i, // "chinese", "japanese"
      /deer$/i, // "deer", "reindeer"
      /fish$/i, // "fish", "blowfish", "angelfish"
      /measles$/i, /o[iu]s$/i, // "carnivorous"
      /pox$/i, // "chickpox", "smallpox"
      /sheep$/i].forEach(pluralize.addUncountableRule);
      return pluralize;
    });
    /* WEBPACK VAR INJECTION */

  }).call(this, __webpack_require__(42)(module));
  /***/
},
/* 24 */

/***/
function (module, exports, __webpack_require__) {
  var isObject = __webpack_require__(14),
      now = __webpack_require__(43),
      toNumber = __webpack_require__(46);
  /** Error message constants. */


  var FUNC_ERROR_TEXT = 'Expected a function';
  /* Built-in method references for those with the same name as other `lodash` methods. */

  var nativeMax = Math.max,
      nativeMin = Math.min;
  /**
   * Creates a debounced function that delays invoking `func` until after `wait`
   * milliseconds have elapsed since the last time the debounced function was
   * invoked. The debounced function comes with a `cancel` method to cancel
   * delayed `func` invocations and a `flush` method to immediately invoke them.
   * Provide `options` to indicate whether `func` should be invoked on the
   * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
   * with the last arguments provided to the debounced function. Subsequent
   * calls to the debounced function return the result of the last `func`
   * invocation.
   *
   * **Note:** If `leading` and `trailing` options are `true`, `func` is
   * invoked on the trailing edge of the timeout only if the debounced function
   * is invoked more than once during the `wait` timeout.
   *
   * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
   * until to the next tick, similar to `setTimeout` with a timeout of `0`.
   *
   * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
   * for details over the differences between `_.debounce` and `_.throttle`.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Function
   * @param {Function} func The function to debounce.
   * @param {number} [wait=0] The number of milliseconds to delay.
   * @param {Object} [options={}] The options object.
   * @param {boolean} [options.leading=false]
   *  Specify invoking on the leading edge of the timeout.
   * @param {number} [options.maxWait]
   *  The maximum time `func` is allowed to be delayed before it's invoked.
   * @param {boolean} [options.trailing=true]
   *  Specify invoking on the trailing edge of the timeout.
   * @returns {Function} Returns the new debounced function.
   * @example
   *
   * // Avoid costly calculations while the window size is in flux.
   * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
   *
   * // Invoke `sendMail` when clicked, debouncing subsequent calls.
   * jQuery(element).on('click', _.debounce(sendMail, 300, {
   *   'leading': true,
   *   'trailing': false
   * }));
   *
   * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
   * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
   * var source = new EventSource('/stream');
   * jQuery(source).on('message', debounced);
   *
   * // Cancel the trailing debounced invocation.
   * jQuery(window).on('popstate', debounced.cancel);
   */

  function debounce(func, wait, options) {
    var lastArgs,
        lastThis,
        maxWait,
        result,
        timerId,
        lastCallTime,
        lastInvokeTime = 0,
        leading = false,
        maxing = false,
        trailing = true;

    if (typeof func != 'function') {
      throw new TypeError(FUNC_ERROR_TEXT);
    }

    wait = toNumber(wait) || 0;

    if (isObject(options)) {
      leading = !!options.leading;
      maxing = 'maxWait' in options;
      maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
      trailing = 'trailing' in options ? !!options.trailing : trailing;
    }

    function invokeFunc(time) {
      var args = lastArgs,
          thisArg = lastThis;
      lastArgs = lastThis = undefined;
      lastInvokeTime = time;
      result = func.apply(thisArg, args);
      return result;
    }

    function leadingEdge(time) {
      // Reset any `maxWait` timer.
      lastInvokeTime = time; // Start the timer for the trailing edge.

      timerId = setTimeout(timerExpired, wait); // Invoke the leading edge.

      return leading ? invokeFunc(time) : result;
    }

    function remainingWait(time) {
      var timeSinceLastCall = time - lastCallTime,
          timeSinceLastInvoke = time - lastInvokeTime,
          timeWaiting = wait - timeSinceLastCall;
      return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }

    function shouldInvoke(time) {
      var timeSinceLastCall = time - lastCallTime,
          timeSinceLastInvoke = time - lastInvokeTime; // Either this is the first call, activity has stopped and we're at the
      // trailing edge, the system time has gone backwards and we're treating
      // it as the trailing edge, or we've hit the `maxWait` limit.

      return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }

    function timerExpired() {
      var time = now();

      if (shouldInvoke(time)) {
        return trailingEdge(time);
      } // Restart the timer.


      timerId = setTimeout(timerExpired, remainingWait(time));
    }

    function trailingEdge(time) {
      timerId = undefined; // Only invoke if we have `lastArgs` which means `func` has been
      // debounced at least once.

      if (trailing && lastArgs) {
        return invokeFunc(time);
      }

      lastArgs = lastThis = undefined;
      return result;
    }

    function cancel() {
      if (timerId !== undefined) {
        clearTimeout(timerId);
      }

      lastInvokeTime = 0;
      lastArgs = lastCallTime = lastThis = timerId = undefined;
    }

    function flush() {
      return timerId === undefined ? result : trailingEdge(now());
    }

    function debounced() {
      var time = now(),
          isInvoking = shouldInvoke(time);
      lastArgs = arguments;
      lastThis = this;
      lastCallTime = time;

      if (isInvoking) {
        if (timerId === undefined) {
          return leadingEdge(lastCallTime);
        }

        if (maxing) {
          // Handle invocations in a tight loop.
          clearTimeout(timerId);
          timerId = setTimeout(timerExpired, wait);
          return invokeFunc(lastCallTime);
        }
      }

      if (timerId === undefined) {
        timerId = setTimeout(timerExpired, wait);
      }

      return result;
    }

    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
  }

  module.exports = debounce;
  /***/
},
/* 25 */

/***/
function (module, exports, __webpack_require__) {
  var domToReact = __webpack_require__(54);

  var attributesToProps = __webpack_require__(17);

  var htmlToDOM = __webpack_require__(63); // decode HTML entities by default for `htmlparser2`


  var domParserOptions = {
    decodeEntities: true,
    lowerCaseAttributeNames: false
  };
  /**
   * Converts HTML string to React elements.
   *
   * @param  {String}   html                    - HTML string.
   * @param  {Object}   [options]               - Parser options.
   * @param  {Object}   [options.htmlparser2]   - htmlparser2 options.
   * @param  {Object}   [options.library]       - Library for React, Preact, etc.
   * @param  {Function} [options.replace]       - Replace method.
   * @return {JSX.Element|JSX.Element[]|String} - React element(s), empty array, or string.
   */

  function HTMLReactParser(html, options) {
    if (typeof html !== 'string') {
      throw new TypeError('First argument must be a string');
    }

    if (html === '') {
      return [];
    }

    options = options || {};
    return domToReact(htmlToDOM(html, options.htmlparser2 || domParserOptions), options);
  }

  HTMLReactParser.domToReact = domToReact;
  HTMLReactParser.htmlToDOM = htmlToDOM;
  HTMLReactParser.attributesToProps = attributesToProps; // support CommonJS and ES Modules

  module.exports = HTMLReactParser;
  module.exports["default"] = HTMLReactParser;
  /***/
},
/* 26 */

/***/
function (module, exports, __webpack_require__) {
  module.exports = __webpack_require__(66);
  /***/
},
/* 27 */

/***/
function (module, exports) {
  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;
  /***/
},
/* 28 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var ReactPropTypesSecret = __webpack_require__(29);

  function emptyFunction() {}

  function emptyFunctionWithReset() {}

  emptyFunctionWithReset.resetWarningCache = emptyFunction;

  module.exports = function () {
    function shim(props, propName, componentName, location, propFullName, secret) {
      if (secret === ReactPropTypesSecret) {
        // It is still safe when called from React.
        return;
      }

      var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
      err.name = 'Invariant Violation';
      throw err;
    }

    ;
    shim.isRequired = shim;

    function getShim() {
      return shim;
    }

    ; // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.

    var ReactPropTypes = {
      array: shim,
      bigint: shim,
      bool: shim,
      func: shim,
      number: shim,
      object: shim,
      string: shim,
      symbol: shim,
      any: shim,
      arrayOf: getShim,
      element: shim,
      elementType: shim,
      instanceOf: getShim,
      node: shim,
      objectOf: getShim,
      oneOf: getShim,
      oneOfType: getShim,
      shape: getShim,
      exact: getShim,
      checkPropTypes: emptyFunctionWithReset,
      resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  /***/

},
/* 29 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
  module.exports = ReactPropTypesSecret;
  /***/
},
/* 30 */

/***/
function (module, exports) {
  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }

  module.exports = _arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;
  /***/
},
/* 31 */

/***/
function (module, exports) {
  function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;

    var _s, _e;

    try {
      for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"] != null) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  module.exports = _iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;
  /***/
},
/* 32 */

/***/
function (module, exports) {
  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  module.exports = _nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;
  /***/
},
/* 33 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /** @license React v16.13.1
   * react-dom.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  /*
   Modernizr 3.0.0pre (Custom Build) | MIT
  */

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }

  var aa = __webpack_require__(1),
      n = __webpack_require__(34),
      r = __webpack_require__(35);

  function u(a) {
    for (var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++) {
      b += "&args[]=" + encodeURIComponent(arguments[c]);
    }

    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }

  if (!aa) throw Error(u(227));

  function ba(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);

    try {
      b.apply(c, l);
    } catch (m) {
      this.onError(m);
    }
  }

  var da = !1,
      ea = null,
      fa = !1,
      ha = null,
      ia = {
    onError: function onError(a) {
      da = !0;
      ea = a;
    }
  };

  function ja(a, b, c, d, e, f, g, h, k) {
    da = !1;
    ea = null;
    ba.apply(ia, arguments);
  }

  function ka(a, b, c, d, e, f, g, h, k) {
    ja.apply(this, arguments);

    if (da) {
      if (da) {
        var l = ea;
        da = !1;
        ea = null;
      } else throw Error(u(198));

      fa || (fa = !0, ha = l);
    }
  }

  var la = null,
      ma = null,
      na = null;

  function oa(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = na(c);
    ka(d, b, void 0, a);
    a.currentTarget = null;
  }

  var pa = null,
      qa = {};

  function ra() {
    if (pa) for (var a in qa) {
      var b = qa[a],
          c = pa.indexOf(a);
      if (!(-1 < c)) throw Error(u(96, a));

      if (!sa[c]) {
        if (!b.extractEvents) throw Error(u(97, a));
        sa[c] = b;
        c = b.eventTypes;

        for (var d in c) {
          var e = void 0;
          var f = c[d],
              g = b,
              h = d;
          if (ta.hasOwnProperty(h)) throw Error(u(99, h));
          ta[h] = f;
          var k = f.phasedRegistrationNames;

          if (k) {
            for (e in k) {
              k.hasOwnProperty(e) && ua(k[e], g, h);
            }

            e = !0;
          } else f.registrationName ? (ua(f.registrationName, g, h), e = !0) : e = !1;

          if (!e) throw Error(u(98, d, a));
        }
      }
    }
  }

  function ua(a, b, c) {
    if (va[a]) throw Error(u(100, a));
    va[a] = b;
    wa[a] = b.eventTypes[c].dependencies;
  }

  var sa = [],
      ta = {},
      va = {},
      wa = {};

  function xa(a) {
    var b = !1,
        c;

    for (c in a) {
      if (a.hasOwnProperty(c)) {
        var d = a[c];

        if (!qa.hasOwnProperty(c) || qa[c] !== d) {
          if (qa[c]) throw Error(u(102, c));
          qa[c] = d;
          b = !0;
        }
      }
    }

    b && ra();
  }

  var ya = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement),
      za = null,
      Aa = null,
      Ba = null;

  function Ca(a) {
    if (a = ma(a)) {
      if ("function" !== typeof za) throw Error(u(280));
      var b = a.stateNode;
      b && (b = la(b), za(a.stateNode, a.type, b));
    }
  }

  function Da(a) {
    Aa ? Ba ? Ba.push(a) : Ba = [a] : Aa = a;
  }

  function Ea() {
    if (Aa) {
      var a = Aa,
          b = Ba;
      Ba = Aa = null;
      Ca(a);
      if (b) for (a = 0; a < b.length; a++) {
        Ca(b[a]);
      }
    }
  }

  function Fa(a, b) {
    return a(b);
  }

  function Ga(a, b, c, d, e) {
    return a(b, c, d, e);
  }

  function Ha() {}

  var Ia = Fa,
      Ja = !1,
      Ka = !1;

  function La() {
    if (null !== Aa || null !== Ba) Ha(), Ea();
  }

  function Ma(a, b, c) {
    if (Ka) return a(b, c);
    Ka = !0;

    try {
      return Ia(a, b, c);
    } finally {
      Ka = !1, La();
    }
  }

  var Na = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
      Oa = Object.prototype.hasOwnProperty,
      Pa = {},
      Qa = {};

  function Ra(a) {
    if (Oa.call(Qa, a)) return !0;
    if (Oa.call(Pa, a)) return !1;
    if (Na.test(a)) return Qa[a] = !0;
    Pa[a] = !0;
    return !1;
  }

  function Sa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;

    switch (_typeof(b)) {
      case "function":
      case "symbol":
        return !0;

      case "boolean":
        if (d) return !1;
        if (null !== c) return !c.acceptsBooleans;
        a = a.toLowerCase().slice(0, 5);
        return "data-" !== a && "aria-" !== a;

      default:
        return !1;
    }
  }

  function Ta(a, b, c, d) {
    if (null === b || "undefined" === typeof b || Sa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch (c.type) {
      case 3:
        return !b;

      case 4:
        return !1 === b;

      case 5:
        return isNaN(b);

      case 6:
        return isNaN(b) || 1 > b;
    }
    return !1;
  }

  function v(a, b, c, d, e, f) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
  }

  var C = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function (a) {
    C[a] = new v(a, 0, !1, a, null, !1);
  });
  [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function (a) {
    var b = a[0];
    C[b] = new v(b, 1, !1, a[1], null, !1);
  });
  ["contentEditable", "draggable", "spellCheck", "value"].forEach(function (a) {
    C[a] = new v(a, 2, !1, a.toLowerCase(), null, !1);
  });
  ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function (a) {
    C[a] = new v(a, 2, !1, a, null, !1);
  });
  "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function (a) {
    C[a] = new v(a, 3, !1, a.toLowerCase(), null, !1);
  });
  ["checked", "multiple", "muted", "selected"].forEach(function (a) {
    C[a] = new v(a, 3, !0, a, null, !1);
  });
  ["capture", "download"].forEach(function (a) {
    C[a] = new v(a, 4, !1, a, null, !1);
  });
  ["cols", "rows", "size", "span"].forEach(function (a) {
    C[a] = new v(a, 6, !1, a, null, !1);
  });
  ["rowSpan", "start"].forEach(function (a) {
    C[a] = new v(a, 5, !1, a.toLowerCase(), null, !1);
  });
  var Ua = /[\-:]([a-z])/g;

  function Va(a) {
    return a[1].toUpperCase();
  }

  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function (a) {
    var b = a.replace(Ua, Va);
    C[b] = new v(b, 1, !1, a, null, !1);
  });
  "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function (a) {
    var b = a.replace(Ua, Va);
    C[b] = new v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1);
  });
  ["xml:base", "xml:lang", "xml:space"].forEach(function (a) {
    var b = a.replace(Ua, Va);
    C[b] = new v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1);
  });
  ["tabIndex", "crossOrigin"].forEach(function (a) {
    C[a] = new v(a, 1, !1, a.toLowerCase(), null, !1);
  });
  C.xlinkHref = new v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0);
  ["src", "href", "action", "formAction"].forEach(function (a) {
    C[a] = new v(a, 1, !1, a.toLowerCase(), null, !0);
  });
  var Wa = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  Wa.hasOwnProperty("ReactCurrentDispatcher") || (Wa.ReactCurrentDispatcher = {
    current: null
  });
  Wa.hasOwnProperty("ReactCurrentBatchConfig") || (Wa.ReactCurrentBatchConfig = {
    suspense: null
  });

  function Xa(a, b, c, d) {
    var e = C.hasOwnProperty(b) ? C[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || (Ta(b, c, e, d) && (c = null), d || null === e ? Ra(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
  }

  var Ya = /^(.*)[\\\/]/,
      E = "function" === typeof Symbol && Symbol["for"],
      Za = E ? Symbol["for"]("react.element") : 60103,
      $a = E ? Symbol["for"]("react.portal") : 60106,
      ab = E ? Symbol["for"]("react.fragment") : 60107,
      bb = E ? Symbol["for"]("react.strict_mode") : 60108,
      cb = E ? Symbol["for"]("react.profiler") : 60114,
      db = E ? Symbol["for"]("react.provider") : 60109,
      eb = E ? Symbol["for"]("react.context") : 60110,
      fb = E ? Symbol["for"]("react.concurrent_mode") : 60111,
      gb = E ? Symbol["for"]("react.forward_ref") : 60112,
      hb = E ? Symbol["for"]("react.suspense") : 60113,
      ib = E ? Symbol["for"]("react.suspense_list") : 60120,
      jb = E ? Symbol["for"]("react.memo") : 60115,
      kb = E ? Symbol["for"]("react.lazy") : 60116,
      lb = E ? Symbol["for"]("react.block") : 60121,
      mb = "function" === typeof Symbol && Symbol.iterator;

  function nb(a) {
    if (null === a || "object" !== _typeof(a)) return null;
    a = mb && a[mb] || a["@@iterator"];
    return "function" === typeof a ? a : null;
  }

  function ob(a) {
    if (-1 === a._status) {
      a._status = 0;
      var b = a._ctor;
      b = b();
      a._result = b;
      b.then(function (b) {
        0 === a._status && (b = b["default"], a._status = 1, a._result = b);
      }, function (b) {
        0 === a._status && (a._status = 2, a._result = b);
      });
    }
  }

  function pb(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;

    switch (a) {
      case ab:
        return "Fragment";

      case $a:
        return "Portal";

      case cb:
        return "Profiler";

      case bb:
        return "StrictMode";

      case hb:
        return "Suspense";

      case ib:
        return "SuspenseList";
    }

    if ("object" === _typeof(a)) switch (a.$$typeof) {
      case eb:
        return "Context.Consumer";

      case db:
        return "Context.Provider";

      case gb:
        var b = a.render;
        b = b.displayName || b.name || "";
        return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");

      case jb:
        return pb(a.type);

      case lb:
        return pb(a.render);

      case kb:
        if (a = 1 === a._status ? a._result : null) return pb(a);
    }
    return null;
  }

  function qb(a) {
    var b = "";

    do {
      a: switch (a.tag) {
        case 3:
        case 4:
        case 6:
        case 7:
        case 10:
        case 9:
          var c = "";
          break a;

        default:
          var d = a._debugOwner,
              e = a._debugSource,
              f = pb(a.type);
          c = null;
          d && (c = pb(d.type));
          d = f;
          f = "";
          e ? f = " (at " + e.fileName.replace(Ya, "") + ":" + e.lineNumber + ")" : c && (f = " (created by " + c + ")");
          c = "\n    in " + (d || "Unknown") + f;
      }

      b += c;
      a = a["return"];
    } while (a);

    return b;
  }

  function rb(a) {
    switch (_typeof(a)) {
      case "boolean":
      case "number":
      case "object":
      case "string":
      case "undefined":
        return a;

      default:
        return "";
    }
  }

  function sb(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
  }

  function tb(a) {
    var b = sb(a) ? "checked" : "value",
        c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b),
        d = "" + a[b];

    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
      var e = c.get,
          f = c.set;
      Object.defineProperty(a, b, {
        configurable: !0,
        get: function get() {
          return e.call(this);
        },
        set: function set(a) {
          d = "" + a;
          f.call(this, a);
        }
      });
      Object.defineProperty(a, b, {
        enumerable: c.enumerable
      });
      return {
        getValue: function getValue() {
          return d;
        },
        setValue: function setValue(a) {
          d = "" + a;
        },
        stopTracking: function stopTracking() {
          a._valueTracker = null;
          delete a[b];
        }
      };
    }
  }

  function xb(a) {
    a._valueTracker || (a._valueTracker = tb(a));
  }

  function yb(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = sb(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
  }

  function zb(a, b) {
    var c = b.checked;
    return n({}, b, {
      defaultChecked: void 0,
      defaultValue: void 0,
      value: void 0,
      checked: null != c ? c : a._wrapperState.initialChecked
    });
  }

  function Ab(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue,
        d = null != b.checked ? b.checked : b.defaultChecked;
    c = rb(null != b.value ? b.value : c);
    a._wrapperState = {
      initialChecked: d,
      initialValue: c,
      controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
  }

  function Bb(a, b) {
    b = b.checked;
    null != b && Xa(a, "checked", b, !1);
  }

  function Cb(a, b) {
    Bb(a, b);
    var c = rb(b.value),
        d = b.type;

    if (null != c) {
      if ("number" === d) {
        if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
      } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
      a.removeAttribute("value");
      return;
    }

    b.hasOwnProperty("value") ? Db(a, b.type, c) : b.hasOwnProperty("defaultValue") && Db(a, b.type, rb(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
  }

  function Eb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
      var d = b.type;
      if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
      b = "" + a._wrapperState.initialValue;
      c || b === a.value || (a.value = b);
      a.defaultValue = b;
    }

    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
  }

  function Db(a, b, c) {
    if ("number" !== b || a.ownerDocument.activeElement !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
  }

  function Fb(a) {
    var b = "";
    aa.Children.forEach(a, function (a) {
      null != a && (b += a);
    });
    return b;
  }

  function Gb(a, b) {
    a = n({
      children: void 0
    }, b);
    if (b = Fb(b.children)) a.children = b;
    return a;
  }

  function Hb(a, b, c, d) {
    a = a.options;

    if (b) {
      b = {};

      for (var e = 0; e < c.length; e++) {
        b["$" + c[e]] = !0;
      }

      for (c = 0; c < a.length; c++) {
        e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
      }
    } else {
      c = "" + rb(c);
      b = null;

      for (e = 0; e < a.length; e++) {
        if (a[e].value === c) {
          a[e].selected = !0;
          d && (a[e].defaultSelected = !0);
          return;
        }

        null !== b || a[e].disabled || (b = a[e]);
      }

      null !== b && (b.selected = !0);
    }
  }

  function Ib(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(u(91));
    return n({}, b, {
      value: void 0,
      defaultValue: void 0,
      children: "" + a._wrapperState.initialValue
    });
  }

  function Jb(a, b) {
    var c = b.value;

    if (null == c) {
      c = b.children;
      b = b.defaultValue;

      if (null != c) {
        if (null != b) throw Error(u(92));

        if (Array.isArray(c)) {
          if (!(1 >= c.length)) throw Error(u(93));
          c = c[0];
        }

        b = c;
      }

      null == b && (b = "");
      c = b;
    }

    a._wrapperState = {
      initialValue: rb(c)
    };
  }

  function Kb(a, b) {
    var c = rb(b.value),
        d = rb(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
  }

  function Lb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
  }

  var Mb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
  };

  function Nb(a) {
    switch (a) {
      case "svg":
        return "http://www.w3.org/2000/svg";

      case "math":
        return "http://www.w3.org/1998/Math/MathML";

      default:
        return "http://www.w3.org/1999/xhtml";
    }
  }

  function Ob(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? Nb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
  }

  var Pb,
      Qb = function (a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function (b, c, d, e) {
      MSApp.execUnsafeLocalFunction(function () {
        return a(b, c, d, e);
      });
    } : a;
  }(function (a, b) {
    if (a.namespaceURI !== Mb.svg || "innerHTML" in a) a.innerHTML = b;else {
      Pb = Pb || document.createElement("div");
      Pb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";

      for (b = Pb.firstChild; a.firstChild;) {
        a.removeChild(a.firstChild);
      }

      for (; b.firstChild;) {
        a.appendChild(b.firstChild);
      }
    }
  });

  function Rb(a, b) {
    if (b) {
      var c = a.firstChild;

      if (c && c === a.lastChild && 3 === c.nodeType) {
        c.nodeValue = b;
        return;
      }
    }

    a.textContent = b;
  }

  function Sb(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
  }

  var Tb = {
    animationend: Sb("Animation", "AnimationEnd"),
    animationiteration: Sb("Animation", "AnimationIteration"),
    animationstart: Sb("Animation", "AnimationStart"),
    transitionend: Sb("Transition", "TransitionEnd")
  },
      Ub = {},
      Vb = {};
  ya && (Vb = document.createElement("div").style, "AnimationEvent" in window || (delete Tb.animationend.animation, delete Tb.animationiteration.animation, delete Tb.animationstart.animation), "TransitionEvent" in window || delete Tb.transitionend.transition);

  function Wb(a) {
    if (Ub[a]) return Ub[a];
    if (!Tb[a]) return a;
    var b = Tb[a],
        c;

    for (c in b) {
      if (b.hasOwnProperty(c) && c in Vb) return Ub[a] = b[c];
    }

    return a;
  }

  var Xb = Wb("animationend"),
      Yb = Wb("animationiteration"),
      Zb = Wb("animationstart"),
      $b = Wb("transitionend"),
      ac = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),
      bc = new ("function" === typeof WeakMap ? WeakMap : Map)();

  function cc(a) {
    var b = bc.get(a);
    void 0 === b && (b = new Map(), bc.set(a, b));
    return b;
  }

  function dc(a) {
    var b = a,
        c = a;
    if (a.alternate) for (; b["return"];) {
      b = b["return"];
    } else {
      a = b;

      do {
        b = a, 0 !== (b.effectTag & 1026) && (c = b["return"]), a = b["return"];
      } while (a);
    }
    return 3 === b.tag ? c : null;
  }

  function ec(a) {
    if (13 === a.tag) {
      var b = a.memoizedState;
      null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
      if (null !== b) return b.dehydrated;
    }

    return null;
  }

  function fc(a) {
    if (dc(a) !== a) throw Error(u(188));
  }

  function gc(a) {
    var b = a.alternate;

    if (!b) {
      b = dc(a);
      if (null === b) throw Error(u(188));
      return b !== a ? null : a;
    }

    for (var c = a, d = b;;) {
      var e = c["return"];
      if (null === e) break;
      var f = e.alternate;

      if (null === f) {
        d = e["return"];

        if (null !== d) {
          c = d;
          continue;
        }

        break;
      }

      if (e.child === f.child) {
        for (f = e.child; f;) {
          if (f === c) return fc(e), a;
          if (f === d) return fc(e), b;
          f = f.sibling;
        }

        throw Error(u(188));
      }

      if (c["return"] !== d["return"]) c = e, d = f;else {
        for (var g = !1, h = e.child; h;) {
          if (h === c) {
            g = !0;
            c = e;
            d = f;
            break;
          }

          if (h === d) {
            g = !0;
            d = e;
            c = f;
            break;
          }

          h = h.sibling;
        }

        if (!g) {
          for (h = f.child; h;) {
            if (h === c) {
              g = !0;
              c = f;
              d = e;
              break;
            }

            if (h === d) {
              g = !0;
              d = f;
              c = e;
              break;
            }

            h = h.sibling;
          }

          if (!g) throw Error(u(189));
        }
      }
      if (c.alternate !== d) throw Error(u(190));
    }

    if (3 !== c.tag) throw Error(u(188));
    return c.stateNode.current === c ? a : b;
  }

  function hc(a) {
    a = gc(a);
    if (!a) return null;

    for (var b = a;;) {
      if (5 === b.tag || 6 === b.tag) return b;
      if (b.child) b.child["return"] = b, b = b.child;else {
        if (b === a) break;

        for (; !b.sibling;) {
          if (!b["return"] || b["return"] === a) return null;
          b = b["return"];
        }

        b.sibling["return"] = b["return"];
        b = b.sibling;
      }
    }

    return null;
  }

  function ic(a, b) {
    if (null == b) throw Error(u(30));
    if (null == a) return b;

    if (Array.isArray(a)) {
      if (Array.isArray(b)) return a.push.apply(a, b), a;
      a.push(b);
      return a;
    }

    return Array.isArray(b) ? [a].concat(b) : [a, b];
  }

  function jc(a, b, c) {
    Array.isArray(a) ? a.forEach(b, c) : a && b.call(c, a);
  }

  var kc = null;

  function lc(a) {
    if (a) {
      var b = a._dispatchListeners,
          c = a._dispatchInstances;
      if (Array.isArray(b)) for (var d = 0; d < b.length && !a.isPropagationStopped(); d++) {
        oa(a, b[d], c[d]);
      } else b && oa(a, b, c);
      a._dispatchListeners = null;
      a._dispatchInstances = null;
      a.isPersistent() || a.constructor.release(a);
    }
  }

  function mc(a) {
    null !== a && (kc = ic(kc, a));
    a = kc;
    kc = null;

    if (a) {
      jc(a, lc);
      if (kc) throw Error(u(95));
      if (fa) throw a = ha, fa = !1, ha = null, a;
    }
  }

  function nc(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
  }

  function oc(a) {
    if (!ya) return !1;
    a = "on" + a;
    var b = (a in document);
    b || (b = document.createElement("div"), b.setAttribute(a, "return;"), b = "function" === typeof b[a]);
    return b;
  }

  var pc = [];

  function qc(a) {
    a.topLevelType = null;
    a.nativeEvent = null;
    a.targetInst = null;
    a.ancestors.length = 0;
    10 > pc.length && pc.push(a);
  }

  function rc(a, b, c, d) {
    if (pc.length) {
      var e = pc.pop();
      e.topLevelType = a;
      e.eventSystemFlags = d;
      e.nativeEvent = b;
      e.targetInst = c;
      return e;
    }

    return {
      topLevelType: a,
      eventSystemFlags: d,
      nativeEvent: b,
      targetInst: c,
      ancestors: []
    };
  }

  function sc(a) {
    var b = a.targetInst,
        c = b;

    do {
      if (!c) {
        a.ancestors.push(c);
        break;
      }

      var d = c;
      if (3 === d.tag) d = d.stateNode.containerInfo;else {
        for (; d["return"];) {
          d = d["return"];
        }

        d = 3 !== d.tag ? null : d.stateNode.containerInfo;
      }
      if (!d) break;
      b = c.tag;
      5 !== b && 6 !== b || a.ancestors.push(c);
      c = tc(d);
    } while (c);

    for (c = 0; c < a.ancestors.length; c++) {
      b = a.ancestors[c];
      var e = nc(a.nativeEvent);
      d = a.topLevelType;
      var f = a.nativeEvent,
          g = a.eventSystemFlags;
      0 === c && (g |= 64);

      for (var h = null, k = 0; k < sa.length; k++) {
        var l = sa[k];
        l && (l = l.extractEvents(d, b, f, e, g)) && (h = ic(h, l));
      }

      mc(h);
    }
  }

  function uc(a, b, c) {
    if (!c.has(a)) {
      switch (a) {
        case "scroll":
          vc(b, "scroll", !0);
          break;

        case "focus":
        case "blur":
          vc(b, "focus", !0);
          vc(b, "blur", !0);
          c.set("blur", null);
          c.set("focus", null);
          break;

        case "cancel":
        case "close":
          oc(a) && vc(b, a, !0);
          break;

        case "invalid":
        case "submit":
        case "reset":
          break;

        default:
          -1 === ac.indexOf(a) && F(a, b);
      }

      c.set(a, null);
    }
  }

  var wc,
      xc,
      yc,
      zc = !1,
      Ac = [],
      Bc = null,
      Cc = null,
      Dc = null,
      Ec = new Map(),
      Fc = new Map(),
      Gc = [],
      Hc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),
      Ic = "focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");

  function Jc(a, b) {
    var c = cc(b);
    Hc.forEach(function (a) {
      uc(a, b, c);
    });
    Ic.forEach(function (a) {
      uc(a, b, c);
    });
  }

  function Kc(a, b, c, d, e) {
    return {
      blockedOn: a,
      topLevelType: b,
      eventSystemFlags: c | 32,
      nativeEvent: e,
      container: d
    };
  }

  function Lc(a, b) {
    switch (a) {
      case "focus":
      case "blur":
        Bc = null;
        break;

      case "dragenter":
      case "dragleave":
        Cc = null;
        break;

      case "mouseover":
      case "mouseout":
        Dc = null;
        break;

      case "pointerover":
      case "pointerout":
        Ec["delete"](b.pointerId);
        break;

      case "gotpointercapture":
      case "lostpointercapture":
        Fc["delete"](b.pointerId);
    }
  }

  function Mc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = Kc(b, c, d, e, f), null !== b && (b = Nc(b), null !== b && xc(b)), a;
    a.eventSystemFlags |= d;
    return a;
  }

  function Oc(a, b, c, d, e) {
    switch (b) {
      case "focus":
        return Bc = Mc(Bc, a, b, c, d, e), !0;

      case "dragenter":
        return Cc = Mc(Cc, a, b, c, d, e), !0;

      case "mouseover":
        return Dc = Mc(Dc, a, b, c, d, e), !0;

      case "pointerover":
        var f = e.pointerId;
        Ec.set(f, Mc(Ec.get(f) || null, a, b, c, d, e));
        return !0;

      case "gotpointercapture":
        return f = e.pointerId, Fc.set(f, Mc(Fc.get(f) || null, a, b, c, d, e)), !0;
    }

    return !1;
  }

  function Pc(a) {
    var b = tc(a.target);

    if (null !== b) {
      var c = dc(b);
      if (null !== c) if (b = c.tag, 13 === b) {
        if (b = ec(c), null !== b) {
          a.blockedOn = b;
          r.unstable_runWithPriority(a.priority, function () {
            yc(c);
          });
          return;
        }
      } else if (3 === b && c.stateNode.hydrate) {
        a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
        return;
      }
    }

    a.blockedOn = null;
  }

  function Qc(a) {
    if (null !== a.blockedOn) return !1;
    var b = Rc(a.topLevelType, a.eventSystemFlags, a.container, a.nativeEvent);

    if (null !== b) {
      var c = Nc(b);
      null !== c && xc(c);
      a.blockedOn = b;
      return !1;
    }

    return !0;
  }

  function Sc(a, b, c) {
    Qc(a) && c["delete"](b);
  }

  function Tc() {
    for (zc = !1; 0 < Ac.length;) {
      var a = Ac[0];

      if (null !== a.blockedOn) {
        a = Nc(a.blockedOn);
        null !== a && wc(a);
        break;
      }

      var b = Rc(a.topLevelType, a.eventSystemFlags, a.container, a.nativeEvent);
      null !== b ? a.blockedOn = b : Ac.shift();
    }

    null !== Bc && Qc(Bc) && (Bc = null);
    null !== Cc && Qc(Cc) && (Cc = null);
    null !== Dc && Qc(Dc) && (Dc = null);
    Ec.forEach(Sc);
    Fc.forEach(Sc);
  }

  function Uc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, zc || (zc = !0, r.unstable_scheduleCallback(r.unstable_NormalPriority, Tc)));
  }

  function Vc(a) {
    function b(b) {
      return Uc(b, a);
    }

    if (0 < Ac.length) {
      Uc(Ac[0], a);

      for (var c = 1; c < Ac.length; c++) {
        var d = Ac[c];
        d.blockedOn === a && (d.blockedOn = null);
      }
    }

    null !== Bc && Uc(Bc, a);
    null !== Cc && Uc(Cc, a);
    null !== Dc && Uc(Dc, a);
    Ec.forEach(b);
    Fc.forEach(b);

    for (c = 0; c < Gc.length; c++) {
      d = Gc[c], d.blockedOn === a && (d.blockedOn = null);
    }

    for (; 0 < Gc.length && (c = Gc[0], null === c.blockedOn);) {
      Pc(c), null === c.blockedOn && Gc.shift();
    }
  }

  var Wc = {},
      Yc = new Map(),
      Zc = new Map(),
      $c = ["abort", "abort", Xb, "animationEnd", Yb, "animationIteration", Zb, "animationStart", "canplay", "canPlay", "canplaythrough", "canPlayThrough", "durationchange", "durationChange", "emptied", "emptied", "encrypted", "encrypted", "ended", "ended", "error", "error", "gotpointercapture", "gotPointerCapture", "load", "load", "loadeddata", "loadedData", "loadedmetadata", "loadedMetadata", "loadstart", "loadStart", "lostpointercapture", "lostPointerCapture", "playing", "playing", "progress", "progress", "seeking", "seeking", "stalled", "stalled", "suspend", "suspend", "timeupdate", "timeUpdate", $b, "transitionEnd", "waiting", "waiting"];

  function ad(a, b) {
    for (var c = 0; c < a.length; c += 2) {
      var d = a[c],
          e = a[c + 1],
          f = "on" + (e[0].toUpperCase() + e.slice(1));
      f = {
        phasedRegistrationNames: {
          bubbled: f,
          captured: f + "Capture"
        },
        dependencies: [d],
        eventPriority: b
      };
      Zc.set(d, b);
      Yc.set(d, f);
      Wc[e] = f;
    }
  }

  ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
  ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
  ad($c, 2);

  for (var bd = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), cd = 0; cd < bd.length; cd++) {
    Zc.set(bd[cd], 0);
  }

  var dd = r.unstable_UserBlockingPriority,
      ed = r.unstable_runWithPriority,
      fd = !0;

  function F(a, b) {
    vc(b, a, !1);
  }

  function vc(a, b, c) {
    var d = Zc.get(b);

    switch (void 0 === d ? 2 : d) {
      case 0:
        d = gd.bind(null, b, 1, a);
        break;

      case 1:
        d = hd.bind(null, b, 1, a);
        break;

      default:
        d = id.bind(null, b, 1, a);
    }

    c ? a.addEventListener(b, d, !0) : a.addEventListener(b, d, !1);
  }

  function gd(a, b, c, d) {
    Ja || Ha();
    var e = id,
        f = Ja;
    Ja = !0;

    try {
      Ga(e, a, b, c, d);
    } finally {
      (Ja = f) || La();
    }
  }

  function hd(a, b, c, d) {
    ed(dd, id.bind(null, a, b, c, d));
  }

  function id(a, b, c, d) {
    if (fd) if (0 < Ac.length && -1 < Hc.indexOf(a)) a = Kc(null, a, b, c, d), Ac.push(a);else {
      var e = Rc(a, b, c, d);
      if (null === e) Lc(a, d);else if (-1 < Hc.indexOf(a)) a = Kc(e, a, b, c, d), Ac.push(a);else if (!Oc(e, a, b, c, d)) {
        Lc(a, d);
        a = rc(a, d, null, b);

        try {
          Ma(sc, a);
        } finally {
          qc(a);
        }
      }
    }
  }

  function Rc(a, b, c, d) {
    c = nc(d);
    c = tc(c);

    if (null !== c) {
      var e = dc(c);
      if (null === e) c = null;else {
        var f = e.tag;

        if (13 === f) {
          c = ec(e);
          if (null !== c) return c;
          c = null;
        } else if (3 === f) {
          if (e.stateNode.hydrate) return 3 === e.tag ? e.stateNode.containerInfo : null;
          c = null;
        } else e !== c && (c = null);
      }
    }

    a = rc(a, d, c, b);

    try {
      Ma(sc, a);
    } finally {
      qc(a);
    }

    return null;
  }

  var jd = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  },
      kd = ["Webkit", "ms", "Moz", "O"];
  Object.keys(jd).forEach(function (a) {
    kd.forEach(function (b) {
      b = b + a.charAt(0).toUpperCase() + a.substring(1);
      jd[b] = jd[a];
    });
  });

  function ld(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || jd.hasOwnProperty(a) && jd[a] ? ("" + b).trim() : b + "px";
  }

  function md(a, b) {
    a = a.style;

    for (var c in b) {
      if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"),
            e = ld(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
      }
    }
  }

  var nd = n({
    menuitem: !0
  }, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
  });

  function od(a, b) {
    if (b) {
      if (nd[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(u(137, a, ""));

      if (null != b.dangerouslySetInnerHTML) {
        if (null != b.children) throw Error(u(60));
        if (!("object" === _typeof(b.dangerouslySetInnerHTML) && "__html" in b.dangerouslySetInnerHTML)) throw Error(u(61));
      }

      if (null != b.style && "object" !== _typeof(b.style)) throw Error(u(62, ""));
    }
  }

  function pd(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;

    switch (a) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;

      default:
        return !0;
    }
  }

  var qd = Mb.html;

  function rd(a, b) {
    a = 9 === a.nodeType || 11 === a.nodeType ? a : a.ownerDocument;
    var c = cc(a);
    b = wa[b];

    for (var d = 0; d < b.length; d++) {
      uc(b[d], a, c);
    }
  }

  function sd() {}

  function td(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;

    try {
      return a.activeElement || a.body;
    } catch (b) {
      return a.body;
    }
  }

  function ud(a) {
    for (; a && a.firstChild;) {
      a = a.firstChild;
    }

    return a;
  }

  function vd(a, b) {
    var c = ud(a);
    a = 0;

    for (var d; c;) {
      if (3 === c.nodeType) {
        d = a + c.textContent.length;
        if (a <= b && d >= b) return {
          node: c,
          offset: b - a
        };
        a = d;
      }

      a: {
        for (; c;) {
          if (c.nextSibling) {
            c = c.nextSibling;
            break a;
          }

          c = c.parentNode;
        }

        c = void 0;
      }

      c = ud(c);
    }
  }

  function wd(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? wd(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
  }

  function xd() {
    for (var a = window, b = td(); b instanceof a.HTMLIFrameElement;) {
      try {
        var c = "string" === typeof b.contentWindow.location.href;
      } catch (d) {
        c = !1;
      }

      if (c) a = b.contentWindow;else break;
      b = td(a.document);
    }

    return b;
  }

  function yd(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
  }

  var zd = "$",
      Ad = "/$",
      Bd = "$?",
      Cd = "$!",
      Dd = null,
      Ed = null;

  function Fd(a, b) {
    switch (a) {
      case "button":
      case "input":
      case "select":
      case "textarea":
        return !!b.autoFocus;
    }

    return !1;
  }

  function Gd(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === _typeof(b.dangerouslySetInnerHTML) && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
  }

  var Hd = "function" === typeof setTimeout ? setTimeout : void 0,
      Id = "function" === typeof clearTimeout ? clearTimeout : void 0;

  function Jd(a) {
    for (; null != a; a = a.nextSibling) {
      var b = a.nodeType;
      if (1 === b || 3 === b) break;
    }

    return a;
  }

  function Kd(a) {
    a = a.previousSibling;

    for (var b = 0; a;) {
      if (8 === a.nodeType) {
        var c = a.data;

        if (c === zd || c === Cd || c === Bd) {
          if (0 === b) return a;
          b--;
        } else c === Ad && b++;
      }

      a = a.previousSibling;
    }

    return null;
  }

  var Ld = Math.random().toString(36).slice(2),
      Md = "__reactInternalInstance$" + Ld,
      Nd = "__reactEventHandlers$" + Ld,
      Od = "__reactContainere$" + Ld;

  function tc(a) {
    var b = a[Md];
    if (b) return b;

    for (var c = a.parentNode; c;) {
      if (b = c[Od] || c[Md]) {
        c = b.alternate;
        if (null !== b.child || null !== c && null !== c.child) for (a = Kd(a); null !== a;) {
          if (c = a[Md]) return c;
          a = Kd(a);
        }
        return b;
      }

      a = c;
      c = a.parentNode;
    }

    return null;
  }

  function Nc(a) {
    a = a[Md] || a[Od];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
  }

  function Pd(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(u(33));
  }

  function Qd(a) {
    return a[Nd] || null;
  }

  function Rd(a) {
    do {
      a = a["return"];
    } while (a && 5 !== a.tag);

    return a ? a : null;
  }

  function Sd(a, b) {
    var c = a.stateNode;
    if (!c) return null;
    var d = la(c);
    if (!d) return null;
    c = d[b];

    a: switch (b) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
        a = !d;
        break a;

      default:
        a = !1;
    }

    if (a) return null;
    if (c && "function" !== typeof c) throw Error(u(231, b, _typeof(c)));
    return c;
  }

  function Td(a, b, c) {
    if (b = Sd(a, c.dispatchConfig.phasedRegistrationNames[b])) c._dispatchListeners = ic(c._dispatchListeners, b), c._dispatchInstances = ic(c._dispatchInstances, a);
  }

  function Ud(a) {
    if (a && a.dispatchConfig.phasedRegistrationNames) {
      for (var b = a._targetInst, c = []; b;) {
        c.push(b), b = Rd(b);
      }

      for (b = c.length; 0 < b--;) {
        Td(c[b], "captured", a);
      }

      for (b = 0; b < c.length; b++) {
        Td(c[b], "bubbled", a);
      }
    }
  }

  function Vd(a, b, c) {
    a && c && c.dispatchConfig.registrationName && (b = Sd(a, c.dispatchConfig.registrationName)) && (c._dispatchListeners = ic(c._dispatchListeners, b), c._dispatchInstances = ic(c._dispatchInstances, a));
  }

  function Wd(a) {
    a && a.dispatchConfig.registrationName && Vd(a._targetInst, null, a);
  }

  function Xd(a) {
    jc(a, Ud);
  }

  var Yd = null,
      Zd = null,
      $d = null;

  function ae() {
    if ($d) return $d;
    var a,
        b = Zd,
        c = b.length,
        d,
        e = "value" in Yd ? Yd.value : Yd.textContent,
        f = e.length;

    for (a = 0; a < c && b[a] === e[a]; a++) {
      ;
    }

    var g = c - a;

    for (d = 1; d <= g && b[c - d] === e[f - d]; d++) {
      ;
    }

    return $d = e.slice(a, 1 < d ? 1 - d : void 0);
  }

  function be() {
    return !0;
  }

  function ce() {
    return !1;
  }

  function G(a, b, c, d) {
    this.dispatchConfig = a;
    this._targetInst = b;
    this.nativeEvent = c;
    a = this.constructor.Interface;

    for (var e in a) {
      a.hasOwnProperty(e) && ((b = a[e]) ? this[e] = b(c) : "target" === e ? this.target = d : this[e] = c[e]);
    }

    this.isDefaultPrevented = (null != c.defaultPrevented ? c.defaultPrevented : !1 === c.returnValue) ? be : ce;
    this.isPropagationStopped = ce;
    return this;
  }

  n(G.prototype, {
    preventDefault: function preventDefault() {
      this.defaultPrevented = !0;
      var a = this.nativeEvent;
      a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = be);
    },
    stopPropagation: function stopPropagation() {
      var a = this.nativeEvent;
      a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = be);
    },
    persist: function persist() {
      this.isPersistent = be;
    },
    isPersistent: ce,
    destructor: function destructor() {
      var a = this.constructor.Interface,
          b;

      for (b in a) {
        this[b] = null;
      }

      this.nativeEvent = this._targetInst = this.dispatchConfig = null;
      this.isPropagationStopped = this.isDefaultPrevented = ce;
      this._dispatchInstances = this._dispatchListeners = null;
    }
  });
  G.Interface = {
    type: null,
    target: null,
    currentTarget: function currentTarget() {
      return null;
    },
    eventPhase: null,
    bubbles: null,
    cancelable: null,
    timeStamp: function timeStamp(a) {
      return a.timeStamp || Date.now();
    },
    defaultPrevented: null,
    isTrusted: null
  };

  G.extend = function (a) {
    function b() {}

    function c() {
      return d.apply(this, arguments);
    }

    var d = this;
    b.prototype = d.prototype;
    var e = new b();
    n(e, c.prototype);
    c.prototype = e;
    c.prototype.constructor = c;
    c.Interface = n({}, d.Interface, a);
    c.extend = d.extend;
    de(c);
    return c;
  };

  de(G);

  function ee(a, b, c, d) {
    if (this.eventPool.length) {
      var e = this.eventPool.pop();
      this.call(e, a, b, c, d);
      return e;
    }

    return new this(a, b, c, d);
  }

  function fe(a) {
    if (!(a instanceof this)) throw Error(u(279));
    a.destructor();
    10 > this.eventPool.length && this.eventPool.push(a);
  }

  function de(a) {
    a.eventPool = [];
    a.getPooled = ee;
    a.release = fe;
  }

  var ge = G.extend({
    data: null
  }),
      he = G.extend({
    data: null
  }),
      ie = [9, 13, 27, 32],
      je = ya && "CompositionEvent" in window,
      ke = null;
  ya && "documentMode" in document && (ke = document.documentMode);
  var le = ya && "TextEvent" in window && !ke,
      me = ya && (!je || ke && 8 < ke && 11 >= ke),
      ne = String.fromCharCode(32),
      oe = {
    beforeInput: {
      phasedRegistrationNames: {
        bubbled: "onBeforeInput",
        captured: "onBeforeInputCapture"
      },
      dependencies: ["compositionend", "keypress", "textInput", "paste"]
    },
    compositionEnd: {
      phasedRegistrationNames: {
        bubbled: "onCompositionEnd",
        captured: "onCompositionEndCapture"
      },
      dependencies: "blur compositionend keydown keypress keyup mousedown".split(" ")
    },
    compositionStart: {
      phasedRegistrationNames: {
        bubbled: "onCompositionStart",
        captured: "onCompositionStartCapture"
      },
      dependencies: "blur compositionstart keydown keypress keyup mousedown".split(" ")
    },
    compositionUpdate: {
      phasedRegistrationNames: {
        bubbled: "onCompositionUpdate",
        captured: "onCompositionUpdateCapture"
      },
      dependencies: "blur compositionupdate keydown keypress keyup mousedown".split(" ")
    }
  },
      pe = !1;

  function qe(a, b) {
    switch (a) {
      case "keyup":
        return -1 !== ie.indexOf(b.keyCode);

      case "keydown":
        return 229 !== b.keyCode;

      case "keypress":
      case "mousedown":
      case "blur":
        return !0;

      default:
        return !1;
    }
  }

  function re(a) {
    a = a.detail;
    return "object" === _typeof(a) && "data" in a ? a.data : null;
  }

  var se = !1;

  function te(a, b) {
    switch (a) {
      case "compositionend":
        return re(b);

      case "keypress":
        if (32 !== b.which) return null;
        pe = !0;
        return ne;

      case "textInput":
        return a = b.data, a === ne && pe ? null : a;

      default:
        return null;
    }
  }

  function ue(a, b) {
    if (se) return "compositionend" === a || !je && qe(a, b) ? (a = ae(), $d = Zd = Yd = null, se = !1, a) : null;

    switch (a) {
      case "paste":
        return null;

      case "keypress":
        if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
          if (b["char"] && 1 < b["char"].length) return b["char"];
          if (b.which) return String.fromCharCode(b.which);
        }

        return null;

      case "compositionend":
        return me && "ko" !== b.locale ? null : b.data;

      default:
        return null;
    }
  }

  var ve = {
    eventTypes: oe,
    extractEvents: function extractEvents(a, b, c, d) {
      var e;
      if (je) b: {
        switch (a) {
          case "compositionstart":
            var f = oe.compositionStart;
            break b;

          case "compositionend":
            f = oe.compositionEnd;
            break b;

          case "compositionupdate":
            f = oe.compositionUpdate;
            break b;
        }

        f = void 0;
      } else se ? qe(a, c) && (f = oe.compositionEnd) : "keydown" === a && 229 === c.keyCode && (f = oe.compositionStart);
      f ? (me && "ko" !== c.locale && (se || f !== oe.compositionStart ? f === oe.compositionEnd && se && (e = ae()) : (Yd = d, Zd = "value" in Yd ? Yd.value : Yd.textContent, se = !0)), f = ge.getPooled(f, b, c, d), e ? f.data = e : (e = re(c), null !== e && (f.data = e)), Xd(f), e = f) : e = null;
      (a = le ? te(a, c) : ue(a, c)) ? (b = he.getPooled(oe.beforeInput, b, c, d), b.data = a, Xd(b)) : b = null;
      return null === e ? b : null === b ? e : [e, b];
    }
  },
      we = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
  };

  function xe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!we[a.type] : "textarea" === b ? !0 : !1;
  }

  var ye = {
    change: {
      phasedRegistrationNames: {
        bubbled: "onChange",
        captured: "onChangeCapture"
      },
      dependencies: "blur change click focus input keydown keyup selectionchange".split(" ")
    }
  };

  function ze(a, b, c) {
    a = G.getPooled(ye.change, a, b, c);
    a.type = "change";
    Da(c);
    Xd(a);
    return a;
  }

  var Ae = null,
      Be = null;

  function Ce(a) {
    mc(a);
  }

  function De(a) {
    var b = Pd(a);
    if (yb(b)) return a;
  }

  function Ee(a, b) {
    if ("change" === a) return b;
  }

  var Fe = !1;
  ya && (Fe = oc("input") && (!document.documentMode || 9 < document.documentMode));

  function Ge() {
    Ae && (Ae.detachEvent("onpropertychange", He), Be = Ae = null);
  }

  function He(a) {
    if ("value" === a.propertyName && De(Be)) if (a = ze(Be, a, nc(a)), Ja) mc(a);else {
      Ja = !0;

      try {
        Fa(Ce, a);
      } finally {
        Ja = !1, La();
      }
    }
  }

  function Ie(a, b, c) {
    "focus" === a ? (Ge(), Ae = b, Be = c, Ae.attachEvent("onpropertychange", He)) : "blur" === a && Ge();
  }

  function Je(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return De(Be);
  }

  function Ke(a, b) {
    if ("click" === a) return De(b);
  }

  function Le(a, b) {
    if ("input" === a || "change" === a) return De(b);
  }

  var Me = {
    eventTypes: ye,
    _isInputEventSupported: Fe,
    extractEvents: function extractEvents(a, b, c, d) {
      var e = b ? Pd(b) : window,
          f = e.nodeName && e.nodeName.toLowerCase();
      if ("select" === f || "input" === f && "file" === e.type) var g = Ee;else if (xe(e)) {
        if (Fe) g = Le;else {
          g = Je;
          var h = Ie;
        }
      } else (f = e.nodeName) && "input" === f.toLowerCase() && ("checkbox" === e.type || "radio" === e.type) && (g = Ke);
      if (g && (g = g(a, b))) return ze(g, c, d);
      h && h(a, e, b);
      "blur" === a && (a = e._wrapperState) && a.controlled && "number" === e.type && Db(e, "number", e.value);
    }
  },
      Ne = G.extend({
    view: null,
    detail: null
  }),
      Oe = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
  };

  function Pe(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Oe[a]) ? !!b[a] : !1;
  }

  function Qe() {
    return Pe;
  }

  var Re = 0,
      Se = 0,
      Te = !1,
      Ue = !1,
      Ve = Ne.extend({
    screenX: null,
    screenY: null,
    clientX: null,
    clientY: null,
    pageX: null,
    pageY: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    getModifierState: Qe,
    button: null,
    buttons: null,
    relatedTarget: function relatedTarget(a) {
      return a.relatedTarget || (a.fromElement === a.srcElement ? a.toElement : a.fromElement);
    },
    movementX: function movementX(a) {
      if ("movementX" in a) return a.movementX;
      var b = Re;
      Re = a.screenX;
      return Te ? "mousemove" === a.type ? a.screenX - b : 0 : (Te = !0, 0);
    },
    movementY: function movementY(a) {
      if ("movementY" in a) return a.movementY;
      var b = Se;
      Se = a.screenY;
      return Ue ? "mousemove" === a.type ? a.screenY - b : 0 : (Ue = !0, 0);
    }
  }),
      We = Ve.extend({
    pointerId: null,
    width: null,
    height: null,
    pressure: null,
    tangentialPressure: null,
    tiltX: null,
    tiltY: null,
    twist: null,
    pointerType: null,
    isPrimary: null
  }),
      Xe = {
    mouseEnter: {
      registrationName: "onMouseEnter",
      dependencies: ["mouseout", "mouseover"]
    },
    mouseLeave: {
      registrationName: "onMouseLeave",
      dependencies: ["mouseout", "mouseover"]
    },
    pointerEnter: {
      registrationName: "onPointerEnter",
      dependencies: ["pointerout", "pointerover"]
    },
    pointerLeave: {
      registrationName: "onPointerLeave",
      dependencies: ["pointerout", "pointerover"]
    }
  },
      Ye = {
    eventTypes: Xe,
    extractEvents: function extractEvents(a, b, c, d, e) {
      var f = "mouseover" === a || "pointerover" === a,
          g = "mouseout" === a || "pointerout" === a;
      if (f && 0 === (e & 32) && (c.relatedTarget || c.fromElement) || !g && !f) return null;
      f = d.window === d ? d : (f = d.ownerDocument) ? f.defaultView || f.parentWindow : window;

      if (g) {
        if (g = b, b = (b = c.relatedTarget || c.toElement) ? tc(b) : null, null !== b) {
          var h = dc(b);
          if (b !== h || 5 !== b.tag && 6 !== b.tag) b = null;
        }
      } else g = null;

      if (g === b) return null;

      if ("mouseout" === a || "mouseover" === a) {
        var k = Ve;
        var l = Xe.mouseLeave;
        var m = Xe.mouseEnter;
        var p = "mouse";
      } else if ("pointerout" === a || "pointerover" === a) k = We, l = Xe.pointerLeave, m = Xe.pointerEnter, p = "pointer";

      a = null == g ? f : Pd(g);
      f = null == b ? f : Pd(b);
      l = k.getPooled(l, g, c, d);
      l.type = p + "leave";
      l.target = a;
      l.relatedTarget = f;
      c = k.getPooled(m, b, c, d);
      c.type = p + "enter";
      c.target = f;
      c.relatedTarget = a;
      d = g;
      p = b;
      if (d && p) a: {
        k = d;
        m = p;
        g = 0;

        for (a = k; a; a = Rd(a)) {
          g++;
        }

        a = 0;

        for (b = m; b; b = Rd(b)) {
          a++;
        }

        for (; 0 < g - a;) {
          k = Rd(k), g--;
        }

        for (; 0 < a - g;) {
          m = Rd(m), a--;
        }

        for (; g--;) {
          if (k === m || k === m.alternate) break a;
          k = Rd(k);
          m = Rd(m);
        }

        k = null;
      } else k = null;
      m = k;

      for (k = []; d && d !== m;) {
        g = d.alternate;
        if (null !== g && g === m) break;
        k.push(d);
        d = Rd(d);
      }

      for (d = []; p && p !== m;) {
        g = p.alternate;
        if (null !== g && g === m) break;
        d.push(p);
        p = Rd(p);
      }

      for (p = 0; p < k.length; p++) {
        Vd(k[p], "bubbled", l);
      }

      for (p = d.length; 0 < p--;) {
        Vd(d[p], "captured", c);
      }

      return 0 === (e & 64) ? [l] : [l, c];
    }
  };

  function Ze(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
  }

  var $e = "function" === typeof Object.is ? Object.is : Ze,
      af = Object.prototype.hasOwnProperty;

  function bf(a, b) {
    if ($e(a, b)) return !0;
    if ("object" !== _typeof(a) || null === a || "object" !== _typeof(b) || null === b) return !1;
    var c = Object.keys(a),
        d = Object.keys(b);
    if (c.length !== d.length) return !1;

    for (d = 0; d < c.length; d++) {
      if (!af.call(b, c[d]) || !$e(a[c[d]], b[c[d]])) return !1;
    }

    return !0;
  }

  var cf = ya && "documentMode" in document && 11 >= document.documentMode,
      df = {
    select: {
      phasedRegistrationNames: {
        bubbled: "onSelect",
        captured: "onSelectCapture"
      },
      dependencies: "blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")
    }
  },
      ef = null,
      ff = null,
      gf = null,
      hf = !1;

  function jf(a, b) {
    var c = b.window === b ? b.document : 9 === b.nodeType ? b : b.ownerDocument;
    if (hf || null == ef || ef !== td(c)) return null;
    c = ef;
    "selectionStart" in c && yd(c) ? c = {
      start: c.selectionStart,
      end: c.selectionEnd
    } : (c = (c.ownerDocument && c.ownerDocument.defaultView || window).getSelection(), c = {
      anchorNode: c.anchorNode,
      anchorOffset: c.anchorOffset,
      focusNode: c.focusNode,
      focusOffset: c.focusOffset
    });
    return gf && bf(gf, c) ? null : (gf = c, a = G.getPooled(df.select, ff, a, b), a.type = "select", a.target = ef, Xd(a), a);
  }

  var kf = {
    eventTypes: df,
    extractEvents: function extractEvents(a, b, c, d, e, f) {
      e = f || (d.window === d ? d.document : 9 === d.nodeType ? d : d.ownerDocument);

      if (!(f = !e)) {
        a: {
          e = cc(e);
          f = wa.onSelect;

          for (var g = 0; g < f.length; g++) {
            if (!e.has(f[g])) {
              e = !1;
              break a;
            }
          }

          e = !0;
        }

        f = !e;
      }

      if (f) return null;
      e = b ? Pd(b) : window;

      switch (a) {
        case "focus":
          if (xe(e) || "true" === e.contentEditable) ef = e, ff = b, gf = null;
          break;

        case "blur":
          gf = ff = ef = null;
          break;

        case "mousedown":
          hf = !0;
          break;

        case "contextmenu":
        case "mouseup":
        case "dragend":
          return hf = !1, jf(c, d);

        case "selectionchange":
          if (cf) break;

        case "keydown":
        case "keyup":
          return jf(c, d);
      }

      return null;
    }
  },
      lf = G.extend({
    animationName: null,
    elapsedTime: null,
    pseudoElement: null
  }),
      mf = G.extend({
    clipboardData: function clipboardData(a) {
      return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
  }),
      nf = Ne.extend({
    relatedTarget: null
  });

  function of(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
  }

  var pf = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  },
      qf = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  },
      rf = Ne.extend({
    key: function key(a) {
      if (a.key) {
        var b = pf[a.key] || a.key;
        if ("Unidentified" !== b) return b;
      }

      return "keypress" === a.type ? (a = of(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? qf[a.keyCode] || "Unidentified" : "";
    },
    location: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    repeat: null,
    locale: null,
    getModifierState: Qe,
    charCode: function charCode(a) {
      return "keypress" === a.type ? of(a) : 0;
    },
    keyCode: function keyCode(a) {
      return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function which(a) {
      return "keypress" === a.type ? of(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
  }),
      sf = Ve.extend({
    dataTransfer: null
  }),
      tf = Ne.extend({
    touches: null,
    targetTouches: null,
    changedTouches: null,
    altKey: null,
    metaKey: null,
    ctrlKey: null,
    shiftKey: null,
    getModifierState: Qe
  }),
      uf = G.extend({
    propertyName: null,
    elapsedTime: null,
    pseudoElement: null
  }),
      vf = Ve.extend({
    deltaX: function deltaX(a) {
      return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function deltaY(a) {
      return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: null,
    deltaMode: null
  }),
      wf = {
    eventTypes: Wc,
    extractEvents: function extractEvents(a, b, c, d) {
      var e = Yc.get(a);
      if (!e) return null;

      switch (a) {
        case "keypress":
          if (0 === of(c)) return null;

        case "keydown":
        case "keyup":
          a = rf;
          break;

        case "blur":
        case "focus":
          a = nf;
          break;

        case "click":
          if (2 === c.button) return null;

        case "auxclick":
        case "dblclick":
        case "mousedown":
        case "mousemove":
        case "mouseup":
        case "mouseout":
        case "mouseover":
        case "contextmenu":
          a = Ve;
          break;

        case "drag":
        case "dragend":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "dragstart":
        case "drop":
          a = sf;
          break;

        case "touchcancel":
        case "touchend":
        case "touchmove":
        case "touchstart":
          a = tf;
          break;

        case Xb:
        case Yb:
        case Zb:
          a = lf;
          break;

        case $b:
          a = uf;
          break;

        case "scroll":
          a = Ne;
          break;

        case "wheel":
          a = vf;
          break;

        case "copy":
        case "cut":
        case "paste":
          a = mf;
          break;

        case "gotpointercapture":
        case "lostpointercapture":
        case "pointercancel":
        case "pointerdown":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "pointerup":
          a = We;
          break;

        default:
          a = G;
      }

      b = a.getPooled(e, b, c, d);
      Xd(b);
      return b;
    }
  };
  if (pa) throw Error(u(101));
  pa = Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));
  ra();
  var xf = Nc;
  la = Qd;
  ma = xf;
  na = Pd;
  xa({
    SimpleEventPlugin: wf,
    EnterLeaveEventPlugin: Ye,
    ChangeEventPlugin: Me,
    SelectEventPlugin: kf,
    BeforeInputEventPlugin: ve
  });
  var yf = [],
      zf = -1;

  function H(a) {
    0 > zf || (a.current = yf[zf], yf[zf] = null, zf--);
  }

  function I(a, b) {
    zf++;
    yf[zf] = a.current;
    a.current = b;
  }

  var Af = {},
      J = {
    current: Af
  },
      K = {
    current: !1
  },
      Bf = Af;

  function Cf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Af;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {},
        f;

    for (f in c) {
      e[f] = b[f];
    }

    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
  }

  function L(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
  }

  function Df() {
    H(K);
    H(J);
  }

  function Ef(a, b, c) {
    if (J.current !== Af) throw Error(u(168));
    I(J, b);
    I(K, c);
  }

  function Ff(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();

    for (var e in d) {
      if (!(e in a)) throw Error(u(108, pb(b) || "Unknown", e));
    }

    return n({}, c, {}, d);
  }

  function Gf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Af;
    Bf = J.current;
    I(J, a);
    I(K, K.current);
    return !0;
  }

  function Hf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(u(169));
    c ? (a = Ff(a, b, Bf), d.__reactInternalMemoizedMergedChildContext = a, H(K), H(J), I(J, a)) : H(K);
    I(K, c);
  }

  var If = r.unstable_runWithPriority,
      Jf = r.unstable_scheduleCallback,
      Kf = r.unstable_cancelCallback,
      Lf = r.unstable_requestPaint,
      Mf = r.unstable_now,
      Nf = r.unstable_getCurrentPriorityLevel,
      Of = r.unstable_ImmediatePriority,
      Pf = r.unstable_UserBlockingPriority,
      Qf = r.unstable_NormalPriority,
      Rf = r.unstable_LowPriority,
      Sf = r.unstable_IdlePriority,
      Tf = {},
      Uf = r.unstable_shouldYield,
      Vf = void 0 !== Lf ? Lf : function () {},
      Wf = null,
      Xf = null,
      Yf = !1,
      Zf = Mf(),
      $f = 1E4 > Zf ? Mf : function () {
    return Mf() - Zf;
  };

  function ag() {
    switch (Nf()) {
      case Of:
        return 99;

      case Pf:
        return 98;

      case Qf:
        return 97;

      case Rf:
        return 96;

      case Sf:
        return 95;

      default:
        throw Error(u(332));
    }
  }

  function bg(a) {
    switch (a) {
      case 99:
        return Of;

      case 98:
        return Pf;

      case 97:
        return Qf;

      case 96:
        return Rf;

      case 95:
        return Sf;

      default:
        throw Error(u(332));
    }
  }

  function cg(a, b) {
    a = bg(a);
    return If(a, b);
  }

  function dg(a, b, c) {
    a = bg(a);
    return Jf(a, b, c);
  }

  function eg(a) {
    null === Wf ? (Wf = [a], Xf = Jf(Of, fg)) : Wf.push(a);
    return Tf;
  }

  function gg() {
    if (null !== Xf) {
      var a = Xf;
      Xf = null;
      Kf(a);
    }

    fg();
  }

  function fg() {
    if (!Yf && null !== Wf) {
      Yf = !0;
      var a = 0;

      try {
        var b = Wf;
        cg(99, function () {
          for (; a < b.length; a++) {
            var c = b[a];

            do {
              c = c(!0);
            } while (null !== c);
          }
        });
        Wf = null;
      } catch (c) {
        throw null !== Wf && (Wf = Wf.slice(a + 1)), Jf(Of, gg), c;
      } finally {
        Yf = !1;
      }
    }
  }

  function hg(a, b, c) {
    c /= 10;
    return 1073741821 - (((1073741821 - a + b / 10) / c | 0) + 1) * c;
  }

  function ig(a, b) {
    if (a && a.defaultProps) {
      b = n({}, b);
      a = a.defaultProps;

      for (var c in a) {
        void 0 === b[c] && (b[c] = a[c]);
      }
    }

    return b;
  }

  var jg = {
    current: null
  },
      kg = null,
      lg = null,
      mg = null;

  function ng() {
    mg = lg = kg = null;
  }

  function og(a) {
    var b = jg.current;
    H(jg);
    a.type._context._currentValue = b;
  }

  function pg(a, b) {
    for (; null !== a;) {
      var c = a.alternate;
      if (a.childExpirationTime < b) a.childExpirationTime = b, null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);else if (null !== c && c.childExpirationTime < b) c.childExpirationTime = b;else break;
      a = a["return"];
    }
  }

  function qg(a, b) {
    kg = a;
    mg = lg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (a.expirationTime >= b && (rg = !0), a.firstContext = null);
  }

  function sg(a, b) {
    if (mg !== a && !1 !== b && 0 !== b) {
      if ("number" !== typeof b || 1073741823 === b) mg = a, b = 1073741823;
      b = {
        context: a,
        observedBits: b,
        next: null
      };

      if (null === lg) {
        if (null === kg) throw Error(u(308));
        lg = b;
        kg.dependencies = {
          expirationTime: 0,
          firstContext: b,
          responders: null
        };
      } else lg = lg.next = b;
    }

    return a._currentValue;
  }

  var tg = !1;

  function ug(a) {
    a.updateQueue = {
      baseState: a.memoizedState,
      baseQueue: null,
      shared: {
        pending: null
      },
      effects: null
    };
  }

  function vg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
      baseState: a.baseState,
      baseQueue: a.baseQueue,
      shared: a.shared,
      effects: a.effects
    });
  }

  function wg(a, b) {
    a = {
      expirationTime: a,
      suspenseConfig: b,
      tag: 0,
      payload: null,
      callback: null,
      next: null
    };
    return a.next = a;
  }

  function xg(a, b) {
    a = a.updateQueue;

    if (null !== a) {
      a = a.shared;
      var c = a.pending;
      null === c ? b.next = b : (b.next = c.next, c.next = b);
      a.pending = b;
    }
  }

  function yg(a, b) {
    var c = a.alternate;
    null !== c && vg(c, a);
    a = a.updateQueue;
    c = a.baseQueue;
    null === c ? (a.baseQueue = b.next = b, b.next = b) : (b.next = c.next, c.next = b);
  }

  function zg(a, b, c, d) {
    var e = a.updateQueue;
    tg = !1;
    var f = e.baseQueue,
        g = e.shared.pending;

    if (null !== g) {
      if (null !== f) {
        var h = f.next;
        f.next = g.next;
        g.next = h;
      }

      f = g;
      e.shared.pending = null;
      h = a.alternate;
      null !== h && (h = h.updateQueue, null !== h && (h.baseQueue = g));
    }

    if (null !== f) {
      h = f.next;
      var k = e.baseState,
          l = 0,
          m = null,
          p = null,
          x = null;

      if (null !== h) {
        var z = h;

        do {
          g = z.expirationTime;

          if (g < d) {
            var ca = {
              expirationTime: z.expirationTime,
              suspenseConfig: z.suspenseConfig,
              tag: z.tag,
              payload: z.payload,
              callback: z.callback,
              next: null
            };
            null === x ? (p = x = ca, m = k) : x = x.next = ca;
            g > l && (l = g);
          } else {
            null !== x && (x = x.next = {
              expirationTime: 1073741823,
              suspenseConfig: z.suspenseConfig,
              tag: z.tag,
              payload: z.payload,
              callback: z.callback,
              next: null
            });
            Ag(g, z.suspenseConfig);

            a: {
              var D = a,
                  t = z;
              g = b;
              ca = c;

              switch (t.tag) {
                case 1:
                  D = t.payload;

                  if ("function" === typeof D) {
                    k = D.call(ca, k, g);
                    break a;
                  }

                  k = D;
                  break a;

                case 3:
                  D.effectTag = D.effectTag & -4097 | 64;

                case 0:
                  D = t.payload;
                  g = "function" === typeof D ? D.call(ca, k, g) : D;
                  if (null === g || void 0 === g) break a;
                  k = n({}, k, g);
                  break a;

                case 2:
                  tg = !0;
              }
            }

            null !== z.callback && (a.effectTag |= 32, g = e.effects, null === g ? e.effects = [z] : g.push(z));
          }

          z = z.next;
          if (null === z || z === h) if (g = e.shared.pending, null === g) break;else z = f.next = g.next, g.next = h, e.baseQueue = f = g, e.shared.pending = null;
        } while (1);
      }

      null === x ? m = k : x.next = p;
      e.baseState = m;
      e.baseQueue = x;
      Bg(l);
      a.expirationTime = l;
      a.memoizedState = k;
    }
  }

  function Cg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for (b = 0; b < a.length; b++) {
      var d = a[b],
          e = d.callback;

      if (null !== e) {
        d.callback = null;
        d = e;
        e = c;
        if ("function" !== typeof d) throw Error(u(191, d));
        d.call(e);
      }
    }
  }

  var Dg = Wa.ReactCurrentBatchConfig,
      Eg = new aa.Component().refs;

  function Fg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : n({}, b, c);
    a.memoizedState = c;
    0 === a.expirationTime && (a.updateQueue.baseState = c);
  }

  var Jg = {
    isMounted: function isMounted(a) {
      return (a = a._reactInternalFiber) ? dc(a) === a : !1;
    },
    enqueueSetState: function enqueueSetState(a, b, c) {
      a = a._reactInternalFiber;
      var d = Gg(),
          e = Dg.suspense;
      d = Hg(d, a, e);
      e = wg(d, e);
      e.payload = b;
      void 0 !== c && null !== c && (e.callback = c);
      xg(a, e);
      Ig(a, d);
    },
    enqueueReplaceState: function enqueueReplaceState(a, b, c) {
      a = a._reactInternalFiber;
      var d = Gg(),
          e = Dg.suspense;
      d = Hg(d, a, e);
      e = wg(d, e);
      e.tag = 1;
      e.payload = b;
      void 0 !== c && null !== c && (e.callback = c);
      xg(a, e);
      Ig(a, d);
    },
    enqueueForceUpdate: function enqueueForceUpdate(a, b) {
      a = a._reactInternalFiber;
      var c = Gg(),
          d = Dg.suspense;
      c = Hg(c, a, d);
      d = wg(c, d);
      d.tag = 2;
      void 0 !== b && null !== b && (d.callback = b);
      xg(a, d);
      Ig(a, c);
    }
  };

  function Kg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !bf(c, d) || !bf(e, f) : !0;
  }

  function Lg(a, b, c) {
    var d = !1,
        e = Af;
    var f = b.contextType;
    "object" === _typeof(f) && null !== f ? f = sg(f) : (e = L(b) ? Bf : J.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Cf(a, e) : Af);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Jg;
    a.stateNode = b;
    b._reactInternalFiber = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
  }

  function Mg(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Jg.enqueueReplaceState(b, b.state, null);
  }

  function Ng(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = Eg;
    ug(a);
    var f = b.contextType;
    "object" === _typeof(f) && null !== f ? e.context = sg(f) : (f = L(b) ? Bf : J.current, e.context = Cf(a, f));
    zg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Fg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Jg.enqueueReplaceState(e, e.state, null), zg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.effectTag |= 4);
  }

  var Og = Array.isArray;

  function Pg(a, b, c) {
    a = c.ref;

    if (null !== a && "function" !== typeof a && "object" !== _typeof(a)) {
      if (c._owner) {
        c = c._owner;

        if (c) {
          if (1 !== c.tag) throw Error(u(309));
          var d = c.stateNode;
        }

        if (!d) throw Error(u(147, a));
        var e = "" + a;
        if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;

        b = function b(a) {
          var b = d.refs;
          b === Eg && (b = d.refs = {});
          null === a ? delete b[e] : b[e] = a;
        };

        b._stringRef = e;
        return b;
      }

      if ("string" !== typeof a) throw Error(u(284));
      if (!c._owner) throw Error(u(290, a));
    }

    return a;
  }

  function Qg(a, b) {
    if ("textarea" !== a.type) throw Error(u(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b, ""));
  }

  function Rg(a) {
    function b(b, c) {
      if (a) {
        var d = b.lastEffect;
        null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
        c.nextEffect = null;
        c.effectTag = 8;
      }
    }

    function c(c, d) {
      if (!a) return null;

      for (; null !== d;) {
        b(c, d), d = d.sibling;
      }

      return null;
    }

    function d(a, b) {
      for (a = new Map(); null !== b;) {
        null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
      }

      return a;
    }

    function e(a, b) {
      a = Sg(a, b);
      a.index = 0;
      a.sibling = null;
      return a;
    }

    function f(b, c, d) {
      b.index = d;
      if (!a) return c;
      d = b.alternate;
      if (null !== d) return d = d.index, d < c ? (b.effectTag = 2, c) : d;
      b.effectTag = 2;
      return c;
    }

    function g(b) {
      a && null === b.alternate && (b.effectTag = 2);
      return b;
    }

    function h(a, b, c, d) {
      if (null === b || 6 !== b.tag) return b = Tg(c, a.mode, d), b["return"] = a, b;
      b = e(b, c);
      b["return"] = a;
      return b;
    }

    function k(a, b, c, d) {
      if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Pg(a, b, c), d["return"] = a, d;
      d = Ug(c.type, c.key, c.props, null, a.mode, d);
      d.ref = Pg(a, b, c);
      d["return"] = a;
      return d;
    }

    function l(a, b, c, d) {
      if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Vg(c, a.mode, d), b["return"] = a, b;
      b = e(b, c.children || []);
      b["return"] = a;
      return b;
    }

    function m(a, b, c, d, f) {
      if (null === b || 7 !== b.tag) return b = Wg(c, a.mode, d, f), b["return"] = a, b;
      b = e(b, c);
      b["return"] = a;
      return b;
    }

    function p(a, b, c) {
      if ("string" === typeof b || "number" === typeof b) return b = Tg("" + b, a.mode, c), b["return"] = a, b;

      if ("object" === _typeof(b) && null !== b) {
        switch (b.$$typeof) {
          case Za:
            return c = Ug(b.type, b.key, b.props, null, a.mode, c), c.ref = Pg(a, null, b), c["return"] = a, c;

          case $a:
            return b = Vg(b, a.mode, c), b["return"] = a, b;
        }

        if (Og(b) || nb(b)) return b = Wg(b, a.mode, c, null), b["return"] = a, b;
        Qg(a, b);
      }

      return null;
    }

    function x(a, b, c, d) {
      var e = null !== b ? b.key : null;
      if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);

      if ("object" === _typeof(c) && null !== c) {
        switch (c.$$typeof) {
          case Za:
            return c.key === e ? c.type === ab ? m(a, b, c.props.children, d, e) : k(a, b, c, d) : null;

          case $a:
            return c.key === e ? l(a, b, c, d) : null;
        }

        if (Og(c) || nb(c)) return null !== e ? null : m(a, b, c, d, null);
        Qg(a, c);
      }

      return null;
    }

    function z(a, b, c, d, e) {
      if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);

      if ("object" === _typeof(d) && null !== d) {
        switch (d.$$typeof) {
          case Za:
            return a = a.get(null === d.key ? c : d.key) || null, d.type === ab ? m(b, a, d.props.children, e, d.key) : k(b, a, d, e);

          case $a:
            return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
        }

        if (Og(d) || nb(d)) return a = a.get(c) || null, m(b, a, d, e, null);
        Qg(b, d);
      }

      return null;
    }

    function ca(e, g, h, k) {
      for (var l = null, t = null, m = g, y = g = 0, A = null; null !== m && y < h.length; y++) {
        m.index > y ? (A = m, m = null) : A = m.sibling;
        var q = x(e, m, h[y], k);

        if (null === q) {
          null === m && (m = A);
          break;
        }

        a && m && null === q.alternate && b(e, m);
        g = f(q, g, y);
        null === t ? l = q : t.sibling = q;
        t = q;
        m = A;
      }

      if (y === h.length) return c(e, m), l;

      if (null === m) {
        for (; y < h.length; y++) {
          m = p(e, h[y], k), null !== m && (g = f(m, g, y), null === t ? l = m : t.sibling = m, t = m);
        }

        return l;
      }

      for (m = d(e, m); y < h.length; y++) {
        A = z(m, e, y, h[y], k), null !== A && (a && null !== A.alternate && m["delete"](null === A.key ? y : A.key), g = f(A, g, y), null === t ? l = A : t.sibling = A, t = A);
      }

      a && m.forEach(function (a) {
        return b(e, a);
      });
      return l;
    }

    function D(e, g, h, l) {
      var k = nb(h);
      if ("function" !== typeof k) throw Error(u(150));
      h = k.call(h);
      if (null == h) throw Error(u(151));

      for (var m = k = null, t = g, y = g = 0, A = null, q = h.next(); null !== t && !q.done; y++, q = h.next()) {
        t.index > y ? (A = t, t = null) : A = t.sibling;
        var D = x(e, t, q.value, l);

        if (null === D) {
          null === t && (t = A);
          break;
        }

        a && t && null === D.alternate && b(e, t);
        g = f(D, g, y);
        null === m ? k = D : m.sibling = D;
        m = D;
        t = A;
      }

      if (q.done) return c(e, t), k;

      if (null === t) {
        for (; !q.done; y++, q = h.next()) {
          q = p(e, q.value, l), null !== q && (g = f(q, g, y), null === m ? k = q : m.sibling = q, m = q);
        }

        return k;
      }

      for (t = d(e, t); !q.done; y++, q = h.next()) {
        q = z(t, e, y, q.value, l), null !== q && (a && null !== q.alternate && t["delete"](null === q.key ? y : q.key), g = f(q, g, y), null === m ? k = q : m.sibling = q, m = q);
      }

      a && t.forEach(function (a) {
        return b(e, a);
      });
      return k;
    }

    return function (a, d, f, h) {
      var k = "object" === _typeof(f) && null !== f && f.type === ab && null === f.key;
      k && (f = f.props.children);
      var l = "object" === _typeof(f) && null !== f;
      if (l) switch (f.$$typeof) {
        case Za:
          a: {
            l = f.key;

            for (k = d; null !== k;) {
              if (k.key === l) {
                switch (k.tag) {
                  case 7:
                    if (f.type === ab) {
                      c(a, k.sibling);
                      d = e(k, f.props.children);
                      d["return"] = a;
                      a = d;
                      break a;
                    }

                    break;

                  default:
                    if (k.elementType === f.type) {
                      c(a, k.sibling);
                      d = e(k, f.props);
                      d.ref = Pg(a, k, f);
                      d["return"] = a;
                      a = d;
                      break a;
                    }

                }

                c(a, k);
                break;
              } else b(a, k);

              k = k.sibling;
            }

            f.type === ab ? (d = Wg(f.props.children, a.mode, h, f.key), d["return"] = a, a = d) : (h = Ug(f.type, f.key, f.props, null, a.mode, h), h.ref = Pg(a, d, f), h["return"] = a, a = h);
          }

          return g(a);

        case $a:
          a: {
            for (k = f.key; null !== d;) {
              if (d.key === k) {
                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                  c(a, d.sibling);
                  d = e(d, f.children || []);
                  d["return"] = a;
                  a = d;
                  break a;
                } else {
                  c(a, d);
                  break;
                }
              } else b(a, d);

              d = d.sibling;
            }

            d = Vg(f, a.mode, h);
            d["return"] = a;
            a = d;
          }

          return g(a);
      }
      if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d["return"] = a, a = d) : (c(a, d), d = Tg(f, a.mode, h), d["return"] = a, a = d), g(a);
      if (Og(f)) return ca(a, d, f, h);
      if (nb(f)) return D(a, d, f, h);
      l && Qg(a, f);
      if ("undefined" === typeof f && !k) switch (a.tag) {
        case 1:
        case 0:
          throw a = a.type, Error(u(152, a.displayName || a.name || "Component"));
      }
      return c(a, d);
    };
  }

  var Xg = Rg(!0),
      Yg = Rg(!1),
      Zg = {},
      $g = {
    current: Zg
  },
      ah = {
    current: Zg
  },
      bh = {
    current: Zg
  };

  function ch(a) {
    if (a === Zg) throw Error(u(174));
    return a;
  }

  function dh(a, b) {
    I(bh, b);
    I(ah, a);
    I($g, Zg);
    a = b.nodeType;

    switch (a) {
      case 9:
      case 11:
        b = (b = b.documentElement) ? b.namespaceURI : Ob(null, "");
        break;

      default:
        a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = Ob(b, a);
    }

    H($g);
    I($g, b);
  }

  function eh() {
    H($g);
    H(ah);
    H(bh);
  }

  function fh(a) {
    ch(bh.current);
    var b = ch($g.current);
    var c = Ob(b, a.type);
    b !== c && (I(ah, a), I($g, c));
  }

  function gh(a) {
    ah.current === a && (H($g), H(ah));
  }

  var M = {
    current: 0
  };

  function hh(a) {
    for (var b = a; null !== b;) {
      if (13 === b.tag) {
        var c = b.memoizedState;
        if (null !== c && (c = c.dehydrated, null === c || c.data === Bd || c.data === Cd)) return b;
      } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
        if (0 !== (b.effectTag & 64)) return b;
      } else if (null !== b.child) {
        b.child["return"] = b;
        b = b.child;
        continue;
      }

      if (b === a) break;

      for (; null === b.sibling;) {
        if (null === b["return"] || b["return"] === a) return null;
        b = b["return"];
      }

      b.sibling["return"] = b["return"];
      b = b.sibling;
    }

    return null;
  }

  function ih(a, b) {
    return {
      responder: a,
      props: b
    };
  }

  var jh = Wa.ReactCurrentDispatcher,
      kh = Wa.ReactCurrentBatchConfig,
      lh = 0,
      N = null,
      O = null,
      P = null,
      mh = !1;

  function Q() {
    throw Error(u(321));
  }

  function nh(a, b) {
    if (null === b) return !1;

    for (var c = 0; c < b.length && c < a.length; c++) {
      if (!$e(a[c], b[c])) return !1;
    }

    return !0;
  }

  function oh(a, b, c, d, e, f) {
    lh = f;
    N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.expirationTime = 0;
    jh.current = null === a || null === a.memoizedState ? ph : qh;
    a = c(d, e);

    if (b.expirationTime === lh) {
      f = 0;

      do {
        b.expirationTime = 0;
        if (!(25 > f)) throw Error(u(301));
        f += 1;
        P = O = null;
        b.updateQueue = null;
        jh.current = rh;
        a = c(d, e);
      } while (b.expirationTime === lh);
    }

    jh.current = sh;
    b = null !== O && null !== O.next;
    lh = 0;
    P = O = N = null;
    mh = !1;
    if (b) throw Error(u(300));
    return a;
  }

  function th() {
    var a = {
      memoizedState: null,
      baseState: null,
      baseQueue: null,
      queue: null,
      next: null
    };
    null === P ? N.memoizedState = P = a : P = P.next = a;
    return P;
  }

  function uh() {
    if (null === O) {
      var a = N.alternate;
      a = null !== a ? a.memoizedState : null;
    } else a = O.next;

    var b = null === P ? N.memoizedState : P.next;
    if (null !== b) P = b, O = a;else {
      if (null === a) throw Error(u(310));
      O = a;
      a = {
        memoizedState: O.memoizedState,
        baseState: O.baseState,
        baseQueue: O.baseQueue,
        queue: O.queue,
        next: null
      };
      null === P ? N.memoizedState = P = a : P = P.next = a;
    }
    return P;
  }

  function vh(a, b) {
    return "function" === typeof b ? b(a) : b;
  }

  function wh(a) {
    var b = uh(),
        c = b.queue;
    if (null === c) throw Error(u(311));
    c.lastRenderedReducer = a;
    var d = O,
        e = d.baseQueue,
        f = c.pending;

    if (null !== f) {
      if (null !== e) {
        var g = e.next;
        e.next = f.next;
        f.next = g;
      }

      d.baseQueue = e = f;
      c.pending = null;
    }

    if (null !== e) {
      e = e.next;
      d = d.baseState;
      var h = g = f = null,
          k = e;

      do {
        var l = k.expirationTime;

        if (l < lh) {
          var m = {
            expirationTime: k.expirationTime,
            suspenseConfig: k.suspenseConfig,
            action: k.action,
            eagerReducer: k.eagerReducer,
            eagerState: k.eagerState,
            next: null
          };
          null === h ? (g = h = m, f = d) : h = h.next = m;
          l > N.expirationTime && (N.expirationTime = l, Bg(l));
        } else null !== h && (h = h.next = {
          expirationTime: 1073741823,
          suspenseConfig: k.suspenseConfig,
          action: k.action,
          eagerReducer: k.eagerReducer,
          eagerState: k.eagerState,
          next: null
        }), Ag(l, k.suspenseConfig), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);

        k = k.next;
      } while (null !== k && k !== e);

      null === h ? f = d : h.next = g;
      $e(d, b.memoizedState) || (rg = !0);
      b.memoizedState = d;
      b.baseState = f;
      b.baseQueue = h;
      c.lastRenderedState = d;
    }

    return [b.memoizedState, c.dispatch];
  }

  function xh(a) {
    var b = uh(),
        c = b.queue;
    if (null === c) throw Error(u(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch,
        e = c.pending,
        f = b.memoizedState;

    if (null !== e) {
      c.pending = null;
      var g = e = e.next;

      do {
        f = a(f, g.action), g = g.next;
      } while (g !== e);

      $e(f, b.memoizedState) || (rg = !0);
      b.memoizedState = f;
      null === b.baseQueue && (b.baseState = f);
      c.lastRenderedState = f;
    }

    return [f, d];
  }

  function yh(a) {
    var b = th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
      pending: null,
      dispatch: null,
      lastRenderedReducer: vh,
      lastRenderedState: a
    };
    a = a.dispatch = zh.bind(null, N, a);
    return [b.memoizedState, a];
  }

  function Ah(a, b, c, d) {
    a = {
      tag: a,
      create: b,
      destroy: c,
      deps: d,
      next: null
    };
    b = N.updateQueue;
    null === b ? (b = {
      lastEffect: null
    }, N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
  }

  function Bh() {
    return uh().memoizedState;
  }

  function Ch(a, b, c, d) {
    var e = th();
    N.effectTag |= a;
    e.memoizedState = Ah(1 | b, c, void 0, void 0 === d ? null : d);
  }

  function Dh(a, b, c, d) {
    var e = uh();
    d = void 0 === d ? null : d;
    var f = void 0;

    if (null !== O) {
      var g = O.memoizedState;
      f = g.destroy;

      if (null !== d && nh(d, g.deps)) {
        Ah(b, c, f, d);
        return;
      }
    }

    N.effectTag |= a;
    e.memoizedState = Ah(1 | b, c, f, d);
  }

  function Eh(a, b) {
    return Ch(516, 4, a, b);
  }

  function Fh(a, b) {
    return Dh(516, 4, a, b);
  }

  function Gh(a, b) {
    return Dh(4, 2, a, b);
  }

  function Hh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function () {
      b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function () {
      b.current = null;
    };
  }

  function Ih(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([a]) : null;
    return Dh(4, 2, Hh.bind(null, b, a), c);
  }

  function Jh() {}

  function Kh(a, b) {
    th().memoizedState = [a, void 0 === b ? null : b];
    return a;
  }

  function Lh(a, b) {
    var c = uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && nh(b, d[1])) return d[0];
    c.memoizedState = [a, b];
    return a;
  }

  function Mh(a, b) {
    var c = uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && nh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [a, b];
    return a;
  }

  function Nh(a, b, c) {
    var d = ag();
    cg(98 > d ? 98 : d, function () {
      a(!0);
    });
    cg(97 < d ? 97 : d, function () {
      var d = kh.suspense;
      kh.suspense = void 0 === b ? null : b;

      try {
        a(!1), c();
      } finally {
        kh.suspense = d;
      }
    });
  }

  function zh(a, b, c) {
    var d = Gg(),
        e = Dg.suspense;
    d = Hg(d, a, e);
    e = {
      expirationTime: d,
      suspenseConfig: e,
      action: c,
      eagerReducer: null,
      eagerState: null,
      next: null
    };
    var f = b.pending;
    null === f ? e.next = e : (e.next = f.next, f.next = e);
    b.pending = e;
    f = a.alternate;
    if (a === N || null !== f && f === N) mh = !0, e.expirationTime = lh, N.expirationTime = lh;else {
      if (0 === a.expirationTime && (null === f || 0 === f.expirationTime) && (f = b.lastRenderedReducer, null !== f)) try {
        var g = b.lastRenderedState,
            h = f(g, c);
        e.eagerReducer = f;
        e.eagerState = h;
        if ($e(h, g)) return;
      } catch (k) {} finally {}
      Ig(a, d);
    }
  }

  var sh = {
    readContext: sg,
    useCallback: Q,
    useContext: Q,
    useEffect: Q,
    useImperativeHandle: Q,
    useLayoutEffect: Q,
    useMemo: Q,
    useReducer: Q,
    useRef: Q,
    useState: Q,
    useDebugValue: Q,
    useResponder: Q,
    useDeferredValue: Q,
    useTransition: Q
  },
      ph = {
    readContext: sg,
    useCallback: Kh,
    useContext: sg,
    useEffect: Eh,
    useImperativeHandle: function useImperativeHandle(a, b, c) {
      c = null !== c && void 0 !== c ? c.concat([a]) : null;
      return Ch(4, 2, Hh.bind(null, b, a), c);
    },
    useLayoutEffect: function useLayoutEffect(a, b) {
      return Ch(4, 2, a, b);
    },
    useMemo: function useMemo(a, b) {
      var c = th();
      b = void 0 === b ? null : b;
      a = a();
      c.memoizedState = [a, b];
      return a;
    },
    useReducer: function useReducer(a, b, c) {
      var d = th();
      b = void 0 !== c ? c(b) : b;
      d.memoizedState = d.baseState = b;
      a = d.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: a,
        lastRenderedState: b
      };
      a = a.dispatch = zh.bind(null, N, a);
      return [d.memoizedState, a];
    },
    useRef: function useRef(a) {
      var b = th();
      a = {
        current: a
      };
      return b.memoizedState = a;
    },
    useState: yh,
    useDebugValue: Jh,
    useResponder: ih,
    useDeferredValue: function useDeferredValue(a, b) {
      var c = yh(a),
          d = c[0],
          e = c[1];
      Eh(function () {
        var c = kh.suspense;
        kh.suspense = void 0 === b ? null : b;

        try {
          e(a);
        } finally {
          kh.suspense = c;
        }
      }, [a, b]);
      return d;
    },
    useTransition: function useTransition(a) {
      var b = yh(!1),
          c = b[0];
      b = b[1];
      return [Kh(Nh.bind(null, b, a), [b, a]), c];
    }
  },
      qh = {
    readContext: sg,
    useCallback: Lh,
    useContext: sg,
    useEffect: Fh,
    useImperativeHandle: Ih,
    useLayoutEffect: Gh,
    useMemo: Mh,
    useReducer: wh,
    useRef: Bh,
    useState: function useState() {
      return wh(vh);
    },
    useDebugValue: Jh,
    useResponder: ih,
    useDeferredValue: function useDeferredValue(a, b) {
      var c = wh(vh),
          d = c[0],
          e = c[1];
      Fh(function () {
        var c = kh.suspense;
        kh.suspense = void 0 === b ? null : b;

        try {
          e(a);
        } finally {
          kh.suspense = c;
        }
      }, [a, b]);
      return d;
    },
    useTransition: function useTransition(a) {
      var b = wh(vh),
          c = b[0];
      b = b[1];
      return [Lh(Nh.bind(null, b, a), [b, a]), c];
    }
  },
      rh = {
    readContext: sg,
    useCallback: Lh,
    useContext: sg,
    useEffect: Fh,
    useImperativeHandle: Ih,
    useLayoutEffect: Gh,
    useMemo: Mh,
    useReducer: xh,
    useRef: Bh,
    useState: function useState() {
      return xh(vh);
    },
    useDebugValue: Jh,
    useResponder: ih,
    useDeferredValue: function useDeferredValue(a, b) {
      var c = xh(vh),
          d = c[0],
          e = c[1];
      Fh(function () {
        var c = kh.suspense;
        kh.suspense = void 0 === b ? null : b;

        try {
          e(a);
        } finally {
          kh.suspense = c;
        }
      }, [a, b]);
      return d;
    },
    useTransition: function useTransition(a) {
      var b = xh(vh),
          c = b[0];
      b = b[1];
      return [Lh(Nh.bind(null, b, a), [b, a]), c];
    }
  },
      Oh = null,
      Ph = null,
      Qh = !1;

  function Rh(a, b) {
    var c = Sh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c["return"] = a;
    c.effectTag = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
  }

  function Th(a, b) {
    switch (a.tag) {
      case 5:
        var c = a.type;
        b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
        return null !== b ? (a.stateNode = b, !0) : !1;

      case 6:
        return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;

      case 13:
        return !1;

      default:
        return !1;
    }
  }

  function Uh(a) {
    if (Qh) {
      var b = Ph;

      if (b) {
        var c = b;

        if (!Th(a, b)) {
          b = Jd(c.nextSibling);

          if (!b || !Th(a, b)) {
            a.effectTag = a.effectTag & -1025 | 2;
            Qh = !1;
            Oh = a;
            return;
          }

          Rh(Oh, c);
        }

        Oh = a;
        Ph = Jd(b.firstChild);
      } else a.effectTag = a.effectTag & -1025 | 2, Qh = !1, Oh = a;
    }
  }

  function Vh(a) {
    for (a = a["return"]; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;) {
      a = a["return"];
    }

    Oh = a;
  }

  function Wh(a) {
    if (a !== Oh) return !1;
    if (!Qh) return Vh(a), Qh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !Gd(b, a.memoizedProps)) for (b = Ph; b;) {
      Rh(a, b), b = Jd(b.nextSibling);
    }
    Vh(a);

    if (13 === a.tag) {
      a = a.memoizedState;
      a = null !== a ? a.dehydrated : null;
      if (!a) throw Error(u(317));

      a: {
        a = a.nextSibling;

        for (b = 0; a;) {
          if (8 === a.nodeType) {
            var c = a.data;

            if (c === Ad) {
              if (0 === b) {
                Ph = Jd(a.nextSibling);
                break a;
              }

              b--;
            } else c !== zd && c !== Cd && c !== Bd || b++;
          }

          a = a.nextSibling;
        }

        Ph = null;
      }
    } else Ph = Oh ? Jd(a.stateNode.nextSibling) : null;

    return !0;
  }

  function Xh() {
    Ph = Oh = null;
    Qh = !1;
  }

  var Yh = Wa.ReactCurrentOwner,
      rg = !1;

  function R(a, b, c, d) {
    b.child = null === a ? Yg(b, null, c, d) : Xg(b, a.child, c, d);
  }

  function Zh(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    qg(b, e);
    d = oh(a, b, c, d, f, e);
    if (null !== a && !rg) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), $h(a, b, e);
    b.effectTag |= 1;
    R(a, b, d, e);
    return b.child;
  }

  function ai(a, b, c, d, e, f) {
    if (null === a) {
      var g = c.type;
      if ("function" === typeof g && !bi(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ci(a, b, g, d, e, f);
      a = Ug(c.type, null, d, null, b.mode, f);
      a.ref = b.ref;
      a["return"] = b;
      return b.child = a;
    }

    g = a.child;
    if (e < f && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : bf, c(e, d) && a.ref === b.ref)) return $h(a, b, f);
    b.effectTag |= 1;
    a = Sg(g, d);
    a.ref = b.ref;
    a["return"] = b;
    return b.child = a;
  }

  function ci(a, b, c, d, e, f) {
    return null !== a && bf(a.memoizedProps, d) && a.ref === b.ref && (rg = !1, e < f) ? (b.expirationTime = a.expirationTime, $h(a, b, f)) : di(a, b, c, d, f);
  }

  function ei(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.effectTag |= 128;
  }

  function di(a, b, c, d, e) {
    var f = L(c) ? Bf : J.current;
    f = Cf(b, f);
    qg(b, e);
    c = oh(a, b, c, d, f, e);
    if (null !== a && !rg) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), $h(a, b, e);
    b.effectTag |= 1;
    R(a, b, c, e);
    return b.child;
  }

  function fi(a, b, c, d, e) {
    if (L(c)) {
      var f = !0;
      Gf(b);
    } else f = !1;

    qg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), Lg(b, c, d), Ng(b, c, d, e), d = !0;else if (null === a) {
      var g = b.stateNode,
          h = b.memoizedProps;
      g.props = h;
      var k = g.context,
          l = c.contextType;
      "object" === _typeof(l) && null !== l ? l = sg(l) : (l = L(c) ? Bf : J.current, l = Cf(b, l));
      var m = c.getDerivedStateFromProps,
          p = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
      p || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Mg(b, g, d, l);
      tg = !1;
      var x = b.memoizedState;
      g.state = x;
      zg(b, d, g, e);
      k = b.memoizedState;
      h !== d || x !== k || K.current || tg ? ("function" === typeof m && (Fg(b, c, m, d), k = b.memoizedState), (h = tg || Kg(b, c, h, d, x, k, l)) ? (p || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.effectTag |= 4)) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), d = !1);
    } else g = b.stateNode, vg(a, b), h = b.memoizedProps, g.props = b.type === b.elementType ? h : ig(b.type, h), k = g.context, l = c.contextType, "object" === _typeof(l) && null !== l ? l = sg(l) : (l = L(c) ? Bf : J.current, l = Cf(b, l)), m = c.getDerivedStateFromProps, (p = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Mg(b, g, d, l), tg = !1, k = b.memoizedState, g.state = k, zg(b, d, g, e), x = b.memoizedState, h !== d || k !== x || K.current || tg ? ("function" === typeof m && (Fg(b, c, m, d), x = b.memoizedState), (m = tg || Kg(b, c, h, d, k, x, l)) ? (p || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, l), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, l)), "function" === typeof g.componentDidUpdate && (b.effectTag |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.effectTag |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = l, d = m) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 256), d = !1);
    return gi(a, b, c, d, f, e);
  }

  function gi(a, b, c, d, e, f) {
    ei(a, b);
    var g = 0 !== (b.effectTag & 64);
    if (!d && !g) return e && Hf(b, c, !1), $h(a, b, f);
    d = b.stateNode;
    Yh.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.effectTag |= 1;
    null !== a && g ? (b.child = Xg(b, a.child, null, f), b.child = Xg(b, null, h, f)) : R(a, b, h, f);
    b.memoizedState = d.state;
    e && Hf(b, c, !0);
    return b.child;
  }

  function hi(a) {
    var b = a.stateNode;
    b.pendingContext ? Ef(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Ef(a, b.context, !1);
    dh(a, b.containerInfo);
  }

  var ii = {
    dehydrated: null,
    retryTime: 0
  };

  function ji(a, b, c) {
    var d = b.mode,
        e = b.pendingProps,
        f = M.current,
        g = !1,
        h;
    (h = 0 !== (b.effectTag & 64)) || (h = 0 !== (f & 2) && (null === a || null !== a.memoizedState));
    h ? (g = !0, b.effectTag &= -65) : null !== a && null === a.memoizedState || void 0 === e.fallback || !0 === e.unstable_avoidThisFallback || (f |= 1);
    I(M, f & 1);

    if (null === a) {
      void 0 !== e.fallback && Uh(b);

      if (g) {
        g = e.fallback;
        e = Wg(null, d, 0, null);
        e["return"] = b;
        if (0 === (b.mode & 2)) for (a = null !== b.memoizedState ? b.child.child : b.child, e.child = a; null !== a;) {
          a["return"] = e, a = a.sibling;
        }
        c = Wg(g, d, c, null);
        c["return"] = b;
        e.sibling = c;
        b.memoizedState = ii;
        b.child = e;
        return c;
      }

      d = e.children;
      b.memoizedState = null;
      return b.child = Yg(b, null, d, c);
    }

    if (null !== a.memoizedState) {
      a = a.child;
      d = a.sibling;

      if (g) {
        e = e.fallback;
        c = Sg(a, a.pendingProps);
        c["return"] = b;
        if (0 === (b.mode & 2) && (g = null !== b.memoizedState ? b.child.child : b.child, g !== a.child)) for (c.child = g; null !== g;) {
          g["return"] = c, g = g.sibling;
        }
        d = Sg(d, e);
        d["return"] = b;
        c.sibling = d;
        c.childExpirationTime = 0;
        b.memoizedState = ii;
        b.child = c;
        return d;
      }

      c = Xg(b, a.child, e.children, c);
      b.memoizedState = null;
      return b.child = c;
    }

    a = a.child;

    if (g) {
      g = e.fallback;
      e = Wg(null, d, 0, null);
      e["return"] = b;
      e.child = a;
      null !== a && (a["return"] = e);
      if (0 === (b.mode & 2)) for (a = null !== b.memoizedState ? b.child.child : b.child, e.child = a; null !== a;) {
        a["return"] = e, a = a.sibling;
      }
      c = Wg(g, d, c, null);
      c["return"] = b;
      e.sibling = c;
      c.effectTag |= 2;
      e.childExpirationTime = 0;
      b.memoizedState = ii;
      b.child = e;
      return c;
    }

    b.memoizedState = null;
    return b.child = Xg(b, a, e.children, c);
  }

  function ki(a, b) {
    a.expirationTime < b && (a.expirationTime = b);
    var c = a.alternate;
    null !== c && c.expirationTime < b && (c.expirationTime = b);
    pg(a["return"], b);
  }

  function li(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
      isBackwards: b,
      rendering: null,
      renderingStartTime: 0,
      last: d,
      tail: c,
      tailExpiration: 0,
      tailMode: e,
      lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailExpiration = 0, g.tailMode = e, g.lastEffect = f);
  }

  function mi(a, b, c) {
    var d = b.pendingProps,
        e = d.revealOrder,
        f = d.tail;
    R(a, b, d.children, c);
    d = M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.effectTag |= 64;else {
      if (null !== a && 0 !== (a.effectTag & 64)) a: for (a = b.child; null !== a;) {
        if (13 === a.tag) null !== a.memoizedState && ki(a, c);else if (19 === a.tag) ki(a, c);else if (null !== a.child) {
          a.child["return"] = a;
          a = a.child;
          continue;
        }
        if (a === b) break a;

        for (; null === a.sibling;) {
          if (null === a["return"] || a["return"] === b) break a;
          a = a["return"];
        }

        a.sibling["return"] = a["return"];
        a = a.sibling;
      }
      d &= 1;
    }
    I(M, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;else switch (e) {
      case "forwards":
        c = b.child;

        for (e = null; null !== c;) {
          a = c.alternate, null !== a && null === hh(a) && (e = c), c = c.sibling;
        }

        c = e;
        null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
        li(b, !1, e, c, f, b.lastEffect);
        break;

      case "backwards":
        c = null;
        e = b.child;

        for (b.child = null; null !== e;) {
          a = e.alternate;

          if (null !== a && null === hh(a)) {
            b.child = e;
            break;
          }

          a = e.sibling;
          e.sibling = c;
          c = e;
          e = a;
        }

        li(b, !0, c, null, f, b.lastEffect);
        break;

      case "together":
        li(b, !1, null, null, void 0, b.lastEffect);
        break;

      default:
        b.memoizedState = null;
    }
    return b.child;
  }

  function $h(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    var d = b.expirationTime;
    0 !== d && Bg(d);
    if (b.childExpirationTime < c) return null;
    if (null !== a && b.child !== a.child) throw Error(u(153));

    if (null !== b.child) {
      a = b.child;
      c = Sg(a, a.pendingProps);
      b.child = c;

      for (c["return"] = b; null !== a.sibling;) {
        a = a.sibling, c = c.sibling = Sg(a, a.pendingProps), c["return"] = b;
      }

      c.sibling = null;
    }

    return b.child;
  }

  var ni, oi, pi, qi;

  ni = function ni(a, b) {
    for (var c = b.child; null !== c;) {
      if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);else if (4 !== c.tag && null !== c.child) {
        c.child["return"] = c;
        c = c.child;
        continue;
      }
      if (c === b) break;

      for (; null === c.sibling;) {
        if (null === c["return"] || c["return"] === b) return;
        c = c["return"];
      }

      c.sibling["return"] = c["return"];
      c = c.sibling;
    }
  };

  oi = function oi() {};

  pi = function pi(a, b, c, d, e) {
    var f = a.memoizedProps;

    if (f !== d) {
      var g = b.stateNode;
      ch($g.current);
      a = null;

      switch (c) {
        case "input":
          f = zb(g, f);
          d = zb(g, d);
          a = [];
          break;

        case "option":
          f = Gb(g, f);
          d = Gb(g, d);
          a = [];
          break;

        case "select":
          f = n({}, f, {
            value: void 0
          });
          d = n({}, d, {
            value: void 0
          });
          a = [];
          break;

        case "textarea":
          f = Ib(g, f);
          d = Ib(g, d);
          a = [];
          break;

        default:
          "function" !== typeof f.onClick && "function" === typeof d.onClick && (g.onclick = sd);
      }

      od(c, d);
      var h, k;
      c = null;

      for (h in f) {
        if (!d.hasOwnProperty(h) && f.hasOwnProperty(h) && null != f[h]) if ("style" === h) for (k in g = f[h], g) {
          g.hasOwnProperty(k) && (c || (c = {}), c[k] = "");
        } else "dangerouslySetInnerHTML" !== h && "children" !== h && "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && "autoFocus" !== h && (va.hasOwnProperty(h) ? a || (a = []) : (a = a || []).push(h, null));
      }

      for (h in d) {
        var l = d[h];
        g = null != f ? f[h] : void 0;
        if (d.hasOwnProperty(h) && l !== g && (null != l || null != g)) if ("style" === h) {
          if (g) {
            for (k in g) {
              !g.hasOwnProperty(k) || l && l.hasOwnProperty(k) || (c || (c = {}), c[k] = "");
            }

            for (k in l) {
              l.hasOwnProperty(k) && g[k] !== l[k] && (c || (c = {}), c[k] = l[k]);
            }
          } else c || (a || (a = []), a.push(h, c)), c = l;
        } else "dangerouslySetInnerHTML" === h ? (l = l ? l.__html : void 0, g = g ? g.__html : void 0, null != l && g !== l && (a = a || []).push(h, l)) : "children" === h ? g === l || "string" !== typeof l && "number" !== typeof l || (a = a || []).push(h, "" + l) : "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && (va.hasOwnProperty(h) ? (null != l && rd(e, h), a || g === l || (a = [])) : (a = a || []).push(h, l));
      }

      c && (a = a || []).push("style", c);
      e = a;
      if (b.updateQueue = e) b.effectTag |= 4;
    }
  };

  qi = function qi(a, b, c, d) {
    c !== d && (b.effectTag |= 4);
  };

  function ri(a, b) {
    switch (a.tailMode) {
      case "hidden":
        b = a.tail;

        for (var c = null; null !== b;) {
          null !== b.alternate && (c = b), b = b.sibling;
        }

        null === c ? a.tail = null : c.sibling = null;
        break;

      case "collapsed":
        c = a.tail;

        for (var d = null; null !== c;) {
          null !== c.alternate && (d = c), c = c.sibling;
        }

        null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
  }

  function si(a, b, c) {
    var d = b.pendingProps;

    switch (b.tag) {
      case 2:
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return null;

      case 1:
        return L(b.type) && Df(), null;

      case 3:
        return eh(), H(K), H(J), c = b.stateNode, c.pendingContext && (c.context = c.pendingContext, c.pendingContext = null), null !== a && null !== a.child || !Wh(b) || (b.effectTag |= 4), oi(b), null;

      case 5:
        gh(b);
        c = ch(bh.current);
        var e = b.type;
        if (null !== a && null != b.stateNode) pi(a, b, e, d, c), a.ref !== b.ref && (b.effectTag |= 128);else {
          if (!d) {
            if (null === b.stateNode) throw Error(u(166));
            return null;
          }

          a = ch($g.current);

          if (Wh(b)) {
            d = b.stateNode;
            e = b.type;
            var f = b.memoizedProps;
            d[Md] = b;
            d[Nd] = f;

            switch (e) {
              case "iframe":
              case "object":
              case "embed":
                F("load", d);
                break;

              case "video":
              case "audio":
                for (a = 0; a < ac.length; a++) {
                  F(ac[a], d);
                }

                break;

              case "source":
                F("error", d);
                break;

              case "img":
              case "image":
              case "link":
                F("error", d);
                F("load", d);
                break;

              case "form":
                F("reset", d);
                F("submit", d);
                break;

              case "details":
                F("toggle", d);
                break;

              case "input":
                Ab(d, f);
                F("invalid", d);
                rd(c, "onChange");
                break;

              case "select":
                d._wrapperState = {
                  wasMultiple: !!f.multiple
                };
                F("invalid", d);
                rd(c, "onChange");
                break;

              case "textarea":
                Jb(d, f), F("invalid", d), rd(c, "onChange");
            }

            od(e, f);
            a = null;

            for (var g in f) {
              if (f.hasOwnProperty(g)) {
                var h = f[g];
                "children" === g ? "string" === typeof h ? d.textContent !== h && (a = ["children", h]) : "number" === typeof h && d.textContent !== "" + h && (a = ["children", "" + h]) : va.hasOwnProperty(g) && null != h && rd(c, g);
              }
            }

            switch (e) {
              case "input":
                xb(d);
                Eb(d, f, !0);
                break;

              case "textarea":
                xb(d);
                Lb(d);
                break;

              case "select":
              case "option":
                break;

              default:
                "function" === typeof f.onClick && (d.onclick = sd);
            }

            c = a;
            b.updateQueue = c;
            null !== c && (b.effectTag |= 4);
          } else {
            g = 9 === c.nodeType ? c : c.ownerDocument;
            a === qd && (a = Nb(e));
            a === qd ? "script" === e ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(e, {
              is: d.is
            }) : (a = g.createElement(e), "select" === e && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, e);
            a[Md] = b;
            a[Nd] = d;
            ni(a, b, !1, !1);
            b.stateNode = a;
            g = pd(e, d);

            switch (e) {
              case "iframe":
              case "object":
              case "embed":
                F("load", a);
                h = d;
                break;

              case "video":
              case "audio":
                for (h = 0; h < ac.length; h++) {
                  F(ac[h], a);
                }

                h = d;
                break;

              case "source":
                F("error", a);
                h = d;
                break;

              case "img":
              case "image":
              case "link":
                F("error", a);
                F("load", a);
                h = d;
                break;

              case "form":
                F("reset", a);
                F("submit", a);
                h = d;
                break;

              case "details":
                F("toggle", a);
                h = d;
                break;

              case "input":
                Ab(a, d);
                h = zb(a, d);
                F("invalid", a);
                rd(c, "onChange");
                break;

              case "option":
                h = Gb(a, d);
                break;

              case "select":
                a._wrapperState = {
                  wasMultiple: !!d.multiple
                };
                h = n({}, d, {
                  value: void 0
                });
                F("invalid", a);
                rd(c, "onChange");
                break;

              case "textarea":
                Jb(a, d);
                h = Ib(a, d);
                F("invalid", a);
                rd(c, "onChange");
                break;

              default:
                h = d;
            }

            od(e, h);
            var k = h;

            for (f in k) {
              if (k.hasOwnProperty(f)) {
                var l = k[f];
                "style" === f ? md(a, l) : "dangerouslySetInnerHTML" === f ? (l = l ? l.__html : void 0, null != l && Qb(a, l)) : "children" === f ? "string" === typeof l ? ("textarea" !== e || "" !== l) && Rb(a, l) : "number" === typeof l && Rb(a, "" + l) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (va.hasOwnProperty(f) ? null != l && rd(c, f) : null != l && Xa(a, f, l, g));
              }
            }

            switch (e) {
              case "input":
                xb(a);
                Eb(a, d, !1);
                break;

              case "textarea":
                xb(a);
                Lb(a);
                break;

              case "option":
                null != d.value && a.setAttribute("value", "" + rb(d.value));
                break;

              case "select":
                a.multiple = !!d.multiple;
                c = d.value;
                null != c ? Hb(a, !!d.multiple, c, !1) : null != d.defaultValue && Hb(a, !!d.multiple, d.defaultValue, !0);
                break;

              default:
                "function" === typeof h.onClick && (a.onclick = sd);
            }

            Fd(e, d) && (b.effectTag |= 4);
          }

          null !== b.ref && (b.effectTag |= 128);
        }
        return null;

      case 6:
        if (a && null != b.stateNode) qi(a, b, a.memoizedProps, d);else {
          if ("string" !== typeof d && null === b.stateNode) throw Error(u(166));
          c = ch(bh.current);
          ch($g.current);
          Wh(b) ? (c = b.stateNode, d = b.memoizedProps, c[Md] = b, c.nodeValue !== d && (b.effectTag |= 4)) : (c = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), c[Md] = b, b.stateNode = c);
        }
        return null;

      case 13:
        H(M);
        d = b.memoizedState;
        if (0 !== (b.effectTag & 64)) return b.expirationTime = c, b;
        c = null !== d;
        d = !1;
        null === a ? void 0 !== b.memoizedProps.fallback && Wh(b) : (e = a.memoizedState, d = null !== e, c || null === e || (e = a.child.sibling, null !== e && (f = b.firstEffect, null !== f ? (b.firstEffect = e, e.nextEffect = f) : (b.firstEffect = b.lastEffect = e, e.nextEffect = null), e.effectTag = 8)));
        if (c && !d && 0 !== (b.mode & 2)) if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (M.current & 1)) S === ti && (S = ui);else {
          if (S === ti || S === ui) S = vi;
          0 !== wi && null !== T && (xi(T, U), yi(T, wi));
        }
        if (c || d) b.effectTag |= 4;
        return null;

      case 4:
        return eh(), oi(b), null;

      case 10:
        return og(b), null;

      case 17:
        return L(b.type) && Df(), null;

      case 19:
        H(M);
        d = b.memoizedState;
        if (null === d) return null;
        e = 0 !== (b.effectTag & 64);
        f = d.rendering;

        if (null === f) {
          if (e) ri(d, !1);else {
            if (S !== ti || null !== a && 0 !== (a.effectTag & 64)) for (f = b.child; null !== f;) {
              a = hh(f);

              if (null !== a) {
                b.effectTag |= 64;
                ri(d, !1);
                e = a.updateQueue;
                null !== e && (b.updateQueue = e, b.effectTag |= 4);
                null === d.lastEffect && (b.firstEffect = null);
                b.lastEffect = d.lastEffect;

                for (d = b.child; null !== d;) {
                  e = d, f = c, e.effectTag &= 2, e.nextEffect = null, e.firstEffect = null, e.lastEffect = null, a = e.alternate, null === a ? (e.childExpirationTime = 0, e.expirationTime = f, e.child = null, e.memoizedProps = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null) : (e.childExpirationTime = a.childExpirationTime, e.expirationTime = a.expirationTime, e.child = a.child, e.memoizedProps = a.memoizedProps, e.memoizedState = a.memoizedState, e.updateQueue = a.updateQueue, f = a.dependencies, e.dependencies = null === f ? null : {
                    expirationTime: f.expirationTime,
                    firstContext: f.firstContext,
                    responders: f.responders
                  }), d = d.sibling;
                }

                I(M, M.current & 1 | 2);
                return b.child;
              }

              f = f.sibling;
            }
          }
        } else {
          if (!e) if (a = hh(f), null !== a) {
            if (b.effectTag |= 64, e = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.effectTag |= 4), ri(d, !0), null === d.tail && "hidden" === d.tailMode && !f.alternate) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
          } else 2 * $f() - d.renderingStartTime > d.tailExpiration && 1 < c && (b.effectTag |= 64, e = !0, ri(d, !1), b.expirationTime = b.childExpirationTime = c - 1);
          d.isBackwards ? (f.sibling = b.child, b.child = f) : (c = d.last, null !== c ? c.sibling = f : b.child = f, d.last = f);
        }

        return null !== d.tail ? (0 === d.tailExpiration && (d.tailExpiration = $f() + 500), c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = $f(), c.sibling = null, b = M.current, I(M, e ? b & 1 | 2 : b & 1), c) : null;
    }

    throw Error(u(156, b.tag));
  }

  function zi(a) {
    switch (a.tag) {
      case 1:
        L(a.type) && Df();
        var b = a.effectTag;
        return b & 4096 ? (a.effectTag = b & -4097 | 64, a) : null;

      case 3:
        eh();
        H(K);
        H(J);
        b = a.effectTag;
        if (0 !== (b & 64)) throw Error(u(285));
        a.effectTag = b & -4097 | 64;
        return a;

      case 5:
        return gh(a), null;

      case 13:
        return H(M), b = a.effectTag, b & 4096 ? (a.effectTag = b & -4097 | 64, a) : null;

      case 19:
        return H(M), null;

      case 4:
        return eh(), null;

      case 10:
        return og(a), null;

      default:
        return null;
    }
  }

  function Ai(a, b) {
    return {
      value: a,
      source: b,
      stack: qb(b)
    };
  }

  var Bi = "function" === typeof WeakSet ? WeakSet : Set;

  function Ci(a, b) {
    var c = b.source,
        d = b.stack;
    null === d && null !== c && (d = qb(c));
    null !== c && pb(c.type);
    b = b.value;
    null !== a && 1 === a.tag && pb(a.type);

    try {
      console.error(b);
    } catch (e) {
      setTimeout(function () {
        throw e;
      });
    }
  }

  function Di(a, b) {
    try {
      b.props = a.memoizedProps, b.state = a.memoizedState, b.componentWillUnmount();
    } catch (c) {
      Ei(a, c);
    }
  }

  function Fi(a) {
    var b = a.ref;
    if (null !== b) if ("function" === typeof b) try {
      b(null);
    } catch (c) {
      Ei(a, c);
    } else b.current = null;
  }

  function Gi(a, b) {
    switch (b.tag) {
      case 0:
      case 11:
      case 15:
      case 22:
        return;

      case 1:
        if (b.effectTag & 256 && null !== a) {
          var c = a.memoizedProps,
              d = a.memoizedState;
          a = b.stateNode;
          b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : ig(b.type, c), d);
          a.__reactInternalSnapshotBeforeUpdate = b;
        }

        return;

      case 3:
      case 5:
      case 6:
      case 4:
      case 17:
        return;
    }

    throw Error(u(163));
  }

  function Hi(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;

    if (null !== b) {
      var c = b = b.next;

      do {
        if ((c.tag & a) === a) {
          var d = c.destroy;
          c.destroy = void 0;
          void 0 !== d && d();
        }

        c = c.next;
      } while (c !== b);
    }
  }

  function Ii(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;

    if (null !== b) {
      var c = b = b.next;

      do {
        if ((c.tag & a) === a) {
          var d = c.create;
          c.destroy = d();
        }

        c = c.next;
      } while (c !== b);
    }
  }

  function Ji(a, b, c) {
    switch (c.tag) {
      case 0:
      case 11:
      case 15:
      case 22:
        Ii(3, c);
        return;

      case 1:
        a = c.stateNode;
        if (c.effectTag & 4) if (null === b) a.componentDidMount();else {
          var d = c.elementType === c.type ? b.memoizedProps : ig(c.type, b.memoizedProps);
          a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate);
        }
        b = c.updateQueue;
        null !== b && Cg(c, b, a);
        return;

      case 3:
        b = c.updateQueue;

        if (null !== b) {
          a = null;
          if (null !== c.child) switch (c.child.tag) {
            case 5:
              a = c.child.stateNode;
              break;

            case 1:
              a = c.child.stateNode;
          }
          Cg(c, b, a);
        }

        return;

      case 5:
        a = c.stateNode;
        null === b && c.effectTag & 4 && Fd(c.type, c.memoizedProps) && a.focus();
        return;

      case 6:
        return;

      case 4:
        return;

      case 12:
        return;

      case 13:
        null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Vc(c))));
        return;

      case 19:
      case 17:
      case 20:
      case 21:
        return;
    }

    throw Error(u(163));
  }

  function Ki(a, b, c) {
    "function" === typeof Li && Li(b);

    switch (b.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
      case 22:
        a = b.updateQueue;

        if (null !== a && (a = a.lastEffect, null !== a)) {
          var d = a.next;
          cg(97 < c ? 97 : c, function () {
            var a = d;

            do {
              var c = a.destroy;

              if (void 0 !== c) {
                var g = b;

                try {
                  c();
                } catch (h) {
                  Ei(g, h);
                }
              }

              a = a.next;
            } while (a !== d);
          });
        }

        break;

      case 1:
        Fi(b);
        c = b.stateNode;
        "function" === typeof c.componentWillUnmount && Di(b, c);
        break;

      case 5:
        Fi(b);
        break;

      case 4:
        Mi(a, b, c);
    }
  }

  function Ni(a) {
    var b = a.alternate;
    a["return"] = null;
    a.child = null;
    a.memoizedState = null;
    a.updateQueue = null;
    a.dependencies = null;
    a.alternate = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.pendingProps = null;
    a.memoizedProps = null;
    a.stateNode = null;
    null !== b && Ni(b);
  }

  function Oi(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
  }

  function Pi(a) {
    a: {
      for (var b = a["return"]; null !== b;) {
        if (Oi(b)) {
          var c = b;
          break a;
        }

        b = b["return"];
      }

      throw Error(u(160));
    }

    b = c.stateNode;

    switch (c.tag) {
      case 5:
        var d = !1;
        break;

      case 3:
        b = b.containerInfo;
        d = !0;
        break;

      case 4:
        b = b.containerInfo;
        d = !0;
        break;

      default:
        throw Error(u(161));
    }

    c.effectTag & 16 && (Rb(b, ""), c.effectTag &= -17);

    a: b: for (c = a;;) {
      for (; null === c.sibling;) {
        if (null === c["return"] || Oi(c["return"])) {
          c = null;
          break a;
        }

        c = c["return"];
      }

      c.sibling["return"] = c["return"];

      for (c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;) {
        if (c.effectTag & 2) continue b;
        if (null === c.child || 4 === c.tag) continue b;else c.child["return"] = c, c = c.child;
      }

      if (!(c.effectTag & 2)) {
        c = c.stateNode;
        break a;
      }
    }

    d ? Qi(a, c, b) : Ri(a, c, b);
  }

  function Qi(a, b, c) {
    var d = a.tag,
        e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = sd));else if (4 !== d && (a = a.child, null !== a)) for (Qi(a, b, c), a = a.sibling; null !== a;) {
      Qi(a, b, c), a = a.sibling;
    }
  }

  function Ri(a, b, c) {
    var d = a.tag,
        e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);else if (4 !== d && (a = a.child, null !== a)) for (Ri(a, b, c), a = a.sibling; null !== a;) {
      Ri(a, b, c), a = a.sibling;
    }
  }

  function Mi(a, b, c) {
    for (var d = b, e = !1, f, g;;) {
      if (!e) {
        e = d["return"];

        a: for (;;) {
          if (null === e) throw Error(u(160));
          f = e.stateNode;

          switch (e.tag) {
            case 5:
              g = !1;
              break a;

            case 3:
              f = f.containerInfo;
              g = !0;
              break a;

            case 4:
              f = f.containerInfo;
              g = !0;
              break a;
          }

          e = e["return"];
        }

        e = !0;
      }

      if (5 === d.tag || 6 === d.tag) {
        a: for (var h = a, k = d, l = c, m = k;;) {
          if (Ki(h, m, l), null !== m.child && 4 !== m.tag) m.child["return"] = m, m = m.child;else {
            if (m === k) break a;

            for (; null === m.sibling;) {
              if (null === m["return"] || m["return"] === k) break a;
              m = m["return"];
            }

            m.sibling["return"] = m["return"];
            m = m.sibling;
          }
        }

        g ? (h = f, k = d.stateNode, 8 === h.nodeType ? h.parentNode.removeChild(k) : h.removeChild(k)) : f.removeChild(d.stateNode);
      } else if (4 === d.tag) {
        if (null !== d.child) {
          f = d.stateNode.containerInfo;
          g = !0;
          d.child["return"] = d;
          d = d.child;
          continue;
        }
      } else if (Ki(a, d, c), null !== d.child) {
        d.child["return"] = d;
        d = d.child;
        continue;
      }

      if (d === b) break;

      for (; null === d.sibling;) {
        if (null === d["return"] || d["return"] === b) return;
        d = d["return"];
        4 === d.tag && (e = !1);
      }

      d.sibling["return"] = d["return"];
      d = d.sibling;
    }
  }

  function Si(a, b) {
    switch (b.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
      case 22:
        Hi(3, b);
        return;

      case 1:
        return;

      case 5:
        var c = b.stateNode;

        if (null != c) {
          var d = b.memoizedProps,
              e = null !== a ? a.memoizedProps : d;
          a = b.type;
          var f = b.updateQueue;
          b.updateQueue = null;

          if (null !== f) {
            c[Nd] = d;
            "input" === a && "radio" === d.type && null != d.name && Bb(c, d);
            pd(a, e);
            b = pd(a, d);

            for (e = 0; e < f.length; e += 2) {
              var g = f[e],
                  h = f[e + 1];
              "style" === g ? md(c, h) : "dangerouslySetInnerHTML" === g ? Qb(c, h) : "children" === g ? Rb(c, h) : Xa(c, g, h, b);
            }

            switch (a) {
              case "input":
                Cb(c, d);
                break;

              case "textarea":
                Kb(c, d);
                break;

              case "select":
                b = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, a = d.value, null != a ? Hb(c, !!d.multiple, a, !1) : b !== !!d.multiple && (null != d.defaultValue ? Hb(c, !!d.multiple, d.defaultValue, !0) : Hb(c, !!d.multiple, d.multiple ? [] : "", !1));
            }
          }
        }

        return;

      case 6:
        if (null === b.stateNode) throw Error(u(162));
        b.stateNode.nodeValue = b.memoizedProps;
        return;

      case 3:
        b = b.stateNode;
        b.hydrate && (b.hydrate = !1, Vc(b.containerInfo));
        return;

      case 12:
        return;

      case 13:
        c = b;
        null === b.memoizedState ? d = !1 : (d = !0, c = b.child, Ti = $f());
        if (null !== c) a: for (a = c;;) {
          if (5 === a.tag) f = a.stateNode, d ? (f = f.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (f = a.stateNode, e = a.memoizedProps.style, e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null, f.style.display = ld("display", e));else if (6 === a.tag) a.stateNode.nodeValue = d ? "" : a.memoizedProps;else if (13 === a.tag && null !== a.memoizedState && null === a.memoizedState.dehydrated) {
            f = a.child.sibling;
            f["return"] = a;
            a = f;
            continue;
          } else if (null !== a.child) {
            a.child["return"] = a;
            a = a.child;
            continue;
          }
          if (a === c) break;

          for (; null === a.sibling;) {
            if (null === a["return"] || a["return"] === c) break a;
            a = a["return"];
          }

          a.sibling["return"] = a["return"];
          a = a.sibling;
        }
        Ui(b);
        return;

      case 19:
        Ui(b);
        return;

      case 17:
        return;
    }

    throw Error(u(163));
  }

  function Ui(a) {
    var b = a.updateQueue;

    if (null !== b) {
      a.updateQueue = null;
      var c = a.stateNode;
      null === c && (c = a.stateNode = new Bi());
      b.forEach(function (b) {
        var d = Vi.bind(null, a, b);
        c.has(b) || (c.add(b), b.then(d, d));
      });
    }
  }

  var Wi = "function" === typeof WeakMap ? WeakMap : Map;

  function Xi(a, b, c) {
    c = wg(c, null);
    c.tag = 3;
    c.payload = {
      element: null
    };
    var d = b.value;

    c.callback = function () {
      Yi || (Yi = !0, Zi = d);
      Ci(a, b);
    };

    return c;
  }

  function $i(a, b, c) {
    c = wg(c, null);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;

    if ("function" === typeof d) {
      var e = b.value;

      c.payload = function () {
        Ci(a, b);
        return d(e);
      };
    }

    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function () {
      "function" !== typeof d && (null === aj ? aj = new Set([this]) : aj.add(this), Ci(a, b));
      var c = b.stack;
      this.componentDidCatch(b.value, {
        componentStack: null !== c ? c : ""
      });
    });
    return c;
  }

  var bj = Math.ceil,
      cj = Wa.ReactCurrentDispatcher,
      dj = Wa.ReactCurrentOwner,
      V = 0,
      ej = 8,
      fj = 16,
      gj = 32,
      ti = 0,
      hj = 1,
      ij = 2,
      ui = 3,
      vi = 4,
      jj = 5,
      W = V,
      T = null,
      X = null,
      U = 0,
      S = ti,
      kj = null,
      lj = 1073741823,
      mj = 1073741823,
      nj = null,
      wi = 0,
      oj = !1,
      Ti = 0,
      pj = 500,
      Y = null,
      Yi = !1,
      Zi = null,
      aj = null,
      qj = !1,
      rj = null,
      sj = 90,
      tj = null,
      uj = 0,
      vj = null,
      wj = 0;

  function Gg() {
    return (W & (fj | gj)) !== V ? 1073741821 - ($f() / 10 | 0) : 0 !== wj ? wj : wj = 1073741821 - ($f() / 10 | 0);
  }

  function Hg(a, b, c) {
    b = b.mode;
    if (0 === (b & 2)) return 1073741823;
    var d = ag();
    if (0 === (b & 4)) return 99 === d ? 1073741823 : 1073741822;
    if ((W & fj) !== V) return U;
    if (null !== c) a = hg(a, c.timeoutMs | 0 || 5E3, 250);else switch (d) {
      case 99:
        a = 1073741823;
        break;

      case 98:
        a = hg(a, 150, 100);
        break;

      case 97:
      case 96:
        a = hg(a, 5E3, 250);
        break;

      case 95:
        a = 2;
        break;

      default:
        throw Error(u(326));
    }
    null !== T && a === U && --a;
    return a;
  }

  function Ig(a, b) {
    if (50 < uj) throw uj = 0, vj = null, Error(u(185));
    a = xj(a, b);

    if (null !== a) {
      var c = ag();
      1073741823 === b ? (W & ej) !== V && (W & (fj | gj)) === V ? yj(a) : (Z(a), W === V && gg()) : Z(a);
      (W & 4) === V || 98 !== c && 99 !== c || (null === tj ? tj = new Map([[a, b]]) : (c = tj.get(a), (void 0 === c || c > b) && tj.set(a, b)));
    }
  }

  function xj(a, b) {
    a.expirationTime < b && (a.expirationTime = b);
    var c = a.alternate;
    null !== c && c.expirationTime < b && (c.expirationTime = b);
    var d = a["return"],
        e = null;
    if (null === d && 3 === a.tag) e = a.stateNode;else for (; null !== d;) {
      c = d.alternate;
      d.childExpirationTime < b && (d.childExpirationTime = b);
      null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);

      if (null === d["return"] && 3 === d.tag) {
        e = d.stateNode;
        break;
      }

      d = d["return"];
    }
    null !== e && (T === e && (Bg(b), S === vi && xi(e, U)), yi(e, b));
    return e;
  }

  function zj(a) {
    var b = a.lastExpiredTime;
    if (0 !== b) return b;
    b = a.firstPendingTime;
    if (!Aj(a, b)) return b;
    var c = a.lastPingedTime;
    a = a.nextKnownPendingLevel;
    a = c > a ? c : a;
    return 2 >= a && b !== a ? 0 : a;
  }

  function Z(a) {
    if (0 !== a.lastExpiredTime) a.callbackExpirationTime = 1073741823, a.callbackPriority = 99, a.callbackNode = eg(yj.bind(null, a));else {
      var b = zj(a),
          c = a.callbackNode;
      if (0 === b) null !== c && (a.callbackNode = null, a.callbackExpirationTime = 0, a.callbackPriority = 90);else {
        var d = Gg();
        1073741823 === b ? d = 99 : 1 === b || 2 === b ? d = 95 : (d = 10 * (1073741821 - b) - 10 * (1073741821 - d), d = 0 >= d ? 99 : 250 >= d ? 98 : 5250 >= d ? 97 : 95);

        if (null !== c) {
          var e = a.callbackPriority;
          if (a.callbackExpirationTime === b && e >= d) return;
          c !== Tf && Kf(c);
        }

        a.callbackExpirationTime = b;
        a.callbackPriority = d;
        b = 1073741823 === b ? eg(yj.bind(null, a)) : dg(d, Bj.bind(null, a), {
          timeout: 10 * (1073741821 - b) - $f()
        });
        a.callbackNode = b;
      }
    }
  }

  function Bj(a, b) {
    wj = 0;
    if (b) return b = Gg(), Cj(a, b), Z(a), null;
    var c = zj(a);

    if (0 !== c) {
      b = a.callbackNode;
      if ((W & (fj | gj)) !== V) throw Error(u(327));
      Dj();
      a === T && c === U || Ej(a, c);

      if (null !== X) {
        var d = W;
        W |= fj;
        var e = Fj();

        do {
          try {
            Gj();
            break;
          } catch (h) {
            Hj(a, h);
          }
        } while (1);

        ng();
        W = d;
        cj.current = e;
        if (S === hj) throw b = kj, Ej(a, c), xi(a, c), Z(a), b;
        if (null === X) switch (e = a.finishedWork = a.current.alternate, a.finishedExpirationTime = c, d = S, T = null, d) {
          case ti:
          case hj:
            throw Error(u(345));

          case ij:
            Cj(a, 2 < c ? 2 : c);
            break;

          case ui:
            xi(a, c);
            d = a.lastSuspendedTime;
            c === d && (a.nextKnownPendingLevel = Ij(e));

            if (1073741823 === lj && (e = Ti + pj - $f(), 10 < e)) {
              if (oj) {
                var f = a.lastPingedTime;

                if (0 === f || f >= c) {
                  a.lastPingedTime = c;
                  Ej(a, c);
                  break;
                }
              }

              f = zj(a);
              if (0 !== f && f !== c) break;

              if (0 !== d && d !== c) {
                a.lastPingedTime = d;
                break;
              }

              a.timeoutHandle = Hd(Jj.bind(null, a), e);
              break;
            }

            Jj(a);
            break;

          case vi:
            xi(a, c);
            d = a.lastSuspendedTime;
            c === d && (a.nextKnownPendingLevel = Ij(e));

            if (oj && (e = a.lastPingedTime, 0 === e || e >= c)) {
              a.lastPingedTime = c;
              Ej(a, c);
              break;
            }

            e = zj(a);
            if (0 !== e && e !== c) break;

            if (0 !== d && d !== c) {
              a.lastPingedTime = d;
              break;
            }

            1073741823 !== mj ? d = 10 * (1073741821 - mj) - $f() : 1073741823 === lj ? d = 0 : (d = 10 * (1073741821 - lj) - 5E3, e = $f(), c = 10 * (1073741821 - c) - e, d = e - d, 0 > d && (d = 0), d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * bj(d / 1960)) - d, c < d && (d = c));

            if (10 < d) {
              a.timeoutHandle = Hd(Jj.bind(null, a), d);
              break;
            }

            Jj(a);
            break;

          case jj:
            if (1073741823 !== lj && null !== nj) {
              f = lj;
              var g = nj;
              d = g.busyMinDurationMs | 0;
              0 >= d ? d = 0 : (e = g.busyDelayMs | 0, f = $f() - (10 * (1073741821 - f) - (g.timeoutMs | 0 || 5E3)), d = f <= e ? 0 : e + d - f);

              if (10 < d) {
                xi(a, c);
                a.timeoutHandle = Hd(Jj.bind(null, a), d);
                break;
              }
            }

            Jj(a);
            break;

          default:
            throw Error(u(329));
        }
        Z(a);
        if (a.callbackNode === b) return Bj.bind(null, a);
      }
    }

    return null;
  }

  function yj(a) {
    var b = a.lastExpiredTime;
    b = 0 !== b ? b : 1073741823;
    if ((W & (fj | gj)) !== V) throw Error(u(327));
    Dj();
    a === T && b === U || Ej(a, b);

    if (null !== X) {
      var c = W;
      W |= fj;
      var d = Fj();

      do {
        try {
          Kj();
          break;
        } catch (e) {
          Hj(a, e);
        }
      } while (1);

      ng();
      W = c;
      cj.current = d;
      if (S === hj) throw c = kj, Ej(a, b), xi(a, b), Z(a), c;
      if (null !== X) throw Error(u(261));
      a.finishedWork = a.current.alternate;
      a.finishedExpirationTime = b;
      T = null;
      Jj(a);
      Z(a);
    }

    return null;
  }

  function Lj() {
    if (null !== tj) {
      var a = tj;
      tj = null;
      a.forEach(function (a, c) {
        Cj(c, a);
        Z(c);
      });
      gg();
    }
  }

  function Mj(a, b) {
    var c = W;
    W |= 1;

    try {
      return a(b);
    } finally {
      W = c, W === V && gg();
    }
  }

  function Nj(a, b) {
    var c = W;
    W &= -2;
    W |= ej;

    try {
      return a(b);
    } finally {
      W = c, W === V && gg();
    }
  }

  function Ej(a, b) {
    a.finishedWork = null;
    a.finishedExpirationTime = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, Id(c));
    if (null !== X) for (c = X["return"]; null !== c;) {
      var d = c;

      switch (d.tag) {
        case 1:
          d = d.type.childContextTypes;
          null !== d && void 0 !== d && Df();
          break;

        case 3:
          eh();
          H(K);
          H(J);
          break;

        case 5:
          gh(d);
          break;

        case 4:
          eh();
          break;

        case 13:
          H(M);
          break;

        case 19:
          H(M);
          break;

        case 10:
          og(d);
      }

      c = c["return"];
    }
    T = a;
    X = Sg(a.current, null);
    U = b;
    S = ti;
    kj = null;
    mj = lj = 1073741823;
    nj = null;
    wi = 0;
    oj = !1;
  }

  function Hj(a, b) {
    do {
      try {
        ng();
        jh.current = sh;
        if (mh) for (var c = N.memoizedState; null !== c;) {
          var d = c.queue;
          null !== d && (d.pending = null);
          c = c.next;
        }
        lh = 0;
        P = O = N = null;
        mh = !1;
        if (null === X || null === X["return"]) return S = hj, kj = b, X = null;

        a: {
          var e = a,
              f = X["return"],
              g = X,
              h = b;
          b = U;
          g.effectTag |= 2048;
          g.firstEffect = g.lastEffect = null;

          if (null !== h && "object" === _typeof(h) && "function" === typeof h.then) {
            var k = h;

            if (0 === (g.mode & 2)) {
              var l = g.alternate;
              l ? (g.updateQueue = l.updateQueue, g.memoizedState = l.memoizedState, g.expirationTime = l.expirationTime) : (g.updateQueue = null, g.memoizedState = null);
            }

            var m = 0 !== (M.current & 1),
                p = f;

            do {
              var x;

              if (x = 13 === p.tag) {
                var z = p.memoizedState;
                if (null !== z) x = null !== z.dehydrated ? !0 : !1;else {
                  var ca = p.memoizedProps;
                  x = void 0 === ca.fallback ? !1 : !0 !== ca.unstable_avoidThisFallback ? !0 : m ? !1 : !0;
                }
              }

              if (x) {
                var D = p.updateQueue;

                if (null === D) {
                  var t = new Set();
                  t.add(k);
                  p.updateQueue = t;
                } else D.add(k);

                if (0 === (p.mode & 2)) {
                  p.effectTag |= 64;
                  g.effectTag &= -2981;
                  if (1 === g.tag) if (null === g.alternate) g.tag = 17;else {
                    var y = wg(1073741823, null);
                    y.tag = 2;
                    xg(g, y);
                  }
                  g.expirationTime = 1073741823;
                  break a;
                }

                h = void 0;
                g = b;
                var A = e.pingCache;
                null === A ? (A = e.pingCache = new Wi(), h = new Set(), A.set(k, h)) : (h = A.get(k), void 0 === h && (h = new Set(), A.set(k, h)));

                if (!h.has(g)) {
                  h.add(g);
                  var q = Oj.bind(null, e, k, g);
                  k.then(q, q);
                }

                p.effectTag |= 4096;
                p.expirationTime = b;
                break a;
              }

              p = p["return"];
            } while (null !== p);

            h = Error((pb(g.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display." + qb(g));
          }

          S !== jj && (S = ij);
          h = Ai(h, g);
          p = f;

          do {
            switch (p.tag) {
              case 3:
                k = h;
                p.effectTag |= 4096;
                p.expirationTime = b;
                var B = Xi(p, k, b);
                yg(p, B);
                break a;

              case 1:
                k = h;
                var w = p.type,
                    ub = p.stateNode;

                if (0 === (p.effectTag & 64) && ("function" === typeof w.getDerivedStateFromError || null !== ub && "function" === typeof ub.componentDidCatch && (null === aj || !aj.has(ub)))) {
                  p.effectTag |= 4096;
                  p.expirationTime = b;
                  var vb = $i(p, k, b);
                  yg(p, vb);
                  break a;
                }

            }

            p = p["return"];
          } while (null !== p);
        }

        X = Pj(X);
      } catch (Xc) {
        b = Xc;
        continue;
      }

      break;
    } while (1);
  }

  function Fj() {
    var a = cj.current;
    cj.current = sh;
    return null === a ? sh : a;
  }

  function Ag(a, b) {
    a < lj && 2 < a && (lj = a);
    null !== b && a < mj && 2 < a && (mj = a, nj = b);
  }

  function Bg(a) {
    a > wi && (wi = a);
  }

  function Kj() {
    for (; null !== X;) {
      X = Qj(X);
    }
  }

  function Gj() {
    for (; null !== X && !Uf();) {
      X = Qj(X);
    }
  }

  function Qj(a) {
    var b = Rj(a.alternate, a, U);
    a.memoizedProps = a.pendingProps;
    null === b && (b = Pj(a));
    dj.current = null;
    return b;
  }

  function Pj(a) {
    X = a;

    do {
      var b = X.alternate;
      a = X["return"];

      if (0 === (X.effectTag & 2048)) {
        b = si(b, X, U);

        if (1 === U || 1 !== X.childExpirationTime) {
          for (var c = 0, d = X.child; null !== d;) {
            var e = d.expirationTime,
                f = d.childExpirationTime;
            e > c && (c = e);
            f > c && (c = f);
            d = d.sibling;
          }

          X.childExpirationTime = c;
        }

        if (null !== b) return b;
        null !== a && 0 === (a.effectTag & 2048) && (null === a.firstEffect && (a.firstEffect = X.firstEffect), null !== X.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = X.firstEffect), a.lastEffect = X.lastEffect), 1 < X.effectTag && (null !== a.lastEffect ? a.lastEffect.nextEffect = X : a.firstEffect = X, a.lastEffect = X));
      } else {
        b = zi(X);
        if (null !== b) return b.effectTag &= 2047, b;
        null !== a && (a.firstEffect = a.lastEffect = null, a.effectTag |= 2048);
      }

      b = X.sibling;
      if (null !== b) return b;
      X = a;
    } while (null !== X);

    S === ti && (S = jj);
    return null;
  }

  function Ij(a) {
    var b = a.expirationTime;
    a = a.childExpirationTime;
    return b > a ? b : a;
  }

  function Jj(a) {
    var b = ag();
    cg(99, Sj.bind(null, a, b));
    return null;
  }

  function Sj(a, b) {
    do {
      Dj();
    } while (null !== rj);

    if ((W & (fj | gj)) !== V) throw Error(u(327));
    var c = a.finishedWork,
        d = a.finishedExpirationTime;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedExpirationTime = 0;
    if (c === a.current) throw Error(u(177));
    a.callbackNode = null;
    a.callbackExpirationTime = 0;
    a.callbackPriority = 90;
    a.nextKnownPendingLevel = 0;
    var e = Ij(c);
    a.firstPendingTime = e;
    d <= a.lastSuspendedTime ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : d <= a.firstSuspendedTime && (a.firstSuspendedTime = d - 1);
    d <= a.lastPingedTime && (a.lastPingedTime = 0);
    d <= a.lastExpiredTime && (a.lastExpiredTime = 0);
    a === T && (X = T = null, U = 0);
    1 < c.effectTag ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, e = c.firstEffect) : e = c : e = c.firstEffect;

    if (null !== e) {
      var f = W;
      W |= gj;
      dj.current = null;
      Dd = fd;
      var g = xd();

      if (yd(g)) {
        if ("selectionStart" in g) var h = {
          start: g.selectionStart,
          end: g.selectionEnd
        };else a: {
          h = (h = g.ownerDocument) && h.defaultView || window;
          var k = h.getSelection && h.getSelection();

          if (k && 0 !== k.rangeCount) {
            h = k.anchorNode;
            var l = k.anchorOffset,
                m = k.focusNode;
            k = k.focusOffset;

            try {
              h.nodeType, m.nodeType;
            } catch (wb) {
              h = null;
              break a;
            }

            var p = 0,
                x = -1,
                z = -1,
                ca = 0,
                D = 0,
                t = g,
                y = null;

            b: for (;;) {
              for (var A;;) {
                t !== h || 0 !== l && 3 !== t.nodeType || (x = p + l);
                t !== m || 0 !== k && 3 !== t.nodeType || (z = p + k);
                3 === t.nodeType && (p += t.nodeValue.length);
                if (null === (A = t.firstChild)) break;
                y = t;
                t = A;
              }

              for (;;) {
                if (t === g) break b;
                y === h && ++ca === l && (x = p);
                y === m && ++D === k && (z = p);
                if (null !== (A = t.nextSibling)) break;
                t = y;
                y = t.parentNode;
              }

              t = A;
            }

            h = -1 === x || -1 === z ? null : {
              start: x,
              end: z
            };
          } else h = null;
        }
        h = h || {
          start: 0,
          end: 0
        };
      } else h = null;

      Ed = {
        activeElementDetached: null,
        focusedElem: g,
        selectionRange: h
      };
      fd = !1;
      Y = e;

      do {
        try {
          Tj();
        } catch (wb) {
          if (null === Y) throw Error(u(330));
          Ei(Y, wb);
          Y = Y.nextEffect;
        }
      } while (null !== Y);

      Y = e;

      do {
        try {
          for (g = a, h = b; null !== Y;) {
            var q = Y.effectTag;
            q & 16 && Rb(Y.stateNode, "");

            if (q & 128) {
              var B = Y.alternate;

              if (null !== B) {
                var w = B.ref;
                null !== w && ("function" === typeof w ? w(null) : w.current = null);
              }
            }

            switch (q & 1038) {
              case 2:
                Pi(Y);
                Y.effectTag &= -3;
                break;

              case 6:
                Pi(Y);
                Y.effectTag &= -3;
                Si(Y.alternate, Y);
                break;

              case 1024:
                Y.effectTag &= -1025;
                break;

              case 1028:
                Y.effectTag &= -1025;
                Si(Y.alternate, Y);
                break;

              case 4:
                Si(Y.alternate, Y);
                break;

              case 8:
                l = Y, Mi(g, l, h), Ni(l);
            }

            Y = Y.nextEffect;
          }
        } catch (wb) {
          if (null === Y) throw Error(u(330));
          Ei(Y, wb);
          Y = Y.nextEffect;
        }
      } while (null !== Y);

      w = Ed;
      B = xd();
      q = w.focusedElem;
      h = w.selectionRange;

      if (B !== q && q && q.ownerDocument && wd(q.ownerDocument.documentElement, q)) {
        null !== h && yd(q) && (B = h.start, w = h.end, void 0 === w && (w = B), "selectionStart" in q ? (q.selectionStart = B, q.selectionEnd = Math.min(w, q.value.length)) : (w = (B = q.ownerDocument || document) && B.defaultView || window, w.getSelection && (w = w.getSelection(), l = q.textContent.length, g = Math.min(h.start, l), h = void 0 === h.end ? g : Math.min(h.end, l), !w.extend && g > h && (l = h, h = g, g = l), l = vd(q, g), m = vd(q, h), l && m && (1 !== w.rangeCount || w.anchorNode !== l.node || w.anchorOffset !== l.offset || w.focusNode !== m.node || w.focusOffset !== m.offset) && (B = B.createRange(), B.setStart(l.node, l.offset), w.removeAllRanges(), g > h ? (w.addRange(B), w.extend(m.node, m.offset)) : (B.setEnd(m.node, m.offset), w.addRange(B))))));
        B = [];

        for (w = q; w = w.parentNode;) {
          1 === w.nodeType && B.push({
            element: w,
            left: w.scrollLeft,
            top: w.scrollTop
          });
        }

        "function" === typeof q.focus && q.focus();

        for (q = 0; q < B.length; q++) {
          w = B[q], w.element.scrollLeft = w.left, w.element.scrollTop = w.top;
        }
      }

      fd = !!Dd;
      Ed = Dd = null;
      a.current = c;
      Y = e;

      do {
        try {
          for (q = a; null !== Y;) {
            var ub = Y.effectTag;
            ub & 36 && Ji(q, Y.alternate, Y);

            if (ub & 128) {
              B = void 0;
              var vb = Y.ref;

              if (null !== vb) {
                var Xc = Y.stateNode;

                switch (Y.tag) {
                  case 5:
                    B = Xc;
                    break;

                  default:
                    B = Xc;
                }

                "function" === typeof vb ? vb(B) : vb.current = B;
              }
            }

            Y = Y.nextEffect;
          }
        } catch (wb) {
          if (null === Y) throw Error(u(330));
          Ei(Y, wb);
          Y = Y.nextEffect;
        }
      } while (null !== Y);

      Y = null;
      Vf();
      W = f;
    } else a.current = c;

    if (qj) qj = !1, rj = a, sj = b;else for (Y = e; null !== Y;) {
      b = Y.nextEffect, Y.nextEffect = null, Y = b;
    }
    b = a.firstPendingTime;
    0 === b && (aj = null);
    1073741823 === b ? a === vj ? uj++ : (uj = 0, vj = a) : uj = 0;
    "function" === typeof Uj && Uj(c.stateNode, d);
    Z(a);
    if (Yi) throw Yi = !1, a = Zi, Zi = null, a;
    if ((W & ej) !== V) return null;
    gg();
    return null;
  }

  function Tj() {
    for (; null !== Y;) {
      var a = Y.effectTag;
      0 !== (a & 256) && Gi(Y.alternate, Y);
      0 === (a & 512) || qj || (qj = !0, dg(97, function () {
        Dj();
        return null;
      }));
      Y = Y.nextEffect;
    }
  }

  function Dj() {
    if (90 !== sj) {
      var a = 97 < sj ? 97 : sj;
      sj = 90;
      return cg(a, Vj);
    }
  }

  function Vj() {
    if (null === rj) return !1;
    var a = rj;
    rj = null;
    if ((W & (fj | gj)) !== V) throw Error(u(331));
    var b = W;
    W |= gj;

    for (a = a.current.firstEffect; null !== a;) {
      try {
        var c = a;
        if (0 !== (c.effectTag & 512)) switch (c.tag) {
          case 0:
          case 11:
          case 15:
          case 22:
            Hi(5, c), Ii(5, c);
        }
      } catch (d) {
        if (null === a) throw Error(u(330));
        Ei(a, d);
      }

      c = a.nextEffect;
      a.nextEffect = null;
      a = c;
    }

    W = b;
    gg();
    return !0;
  }

  function Wj(a, b, c) {
    b = Ai(c, b);
    b = Xi(a, b, 1073741823);
    xg(a, b);
    a = xj(a, 1073741823);
    null !== a && Z(a);
  }

  function Ei(a, b) {
    if (3 === a.tag) Wj(a, a, b);else for (var c = a["return"]; null !== c;) {
      if (3 === c.tag) {
        Wj(c, a, b);
        break;
      } else if (1 === c.tag) {
        var d = c.stateNode;

        if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === aj || !aj.has(d))) {
          a = Ai(b, a);
          a = $i(c, a, 1073741823);
          xg(c, a);
          c = xj(c, 1073741823);
          null !== c && Z(c);
          break;
        }
      }

      c = c["return"];
    }
  }

  function Oj(a, b, c) {
    var d = a.pingCache;
    null !== d && d["delete"](b);
    T === a && U === c ? S === vi || S === ui && 1073741823 === lj && $f() - Ti < pj ? Ej(a, U) : oj = !0 : Aj(a, c) && (b = a.lastPingedTime, 0 !== b && b < c || (a.lastPingedTime = c, Z(a)));
  }

  function Vi(a, b) {
    var c = a.stateNode;
    null !== c && c["delete"](b);
    b = 0;
    0 === b && (b = Gg(), b = Hg(b, a, null));
    a = xj(a, b);
    null !== a && Z(a);
  }

  var Rj;

  Rj = function Rj(a, b, c) {
    var d = b.expirationTime;

    if (null !== a) {
      var e = b.pendingProps;
      if (a.memoizedProps !== e || K.current) rg = !0;else {
        if (d < c) {
          rg = !1;

          switch (b.tag) {
            case 3:
              hi(b);
              Xh();
              break;

            case 5:
              fh(b);
              if (b.mode & 4 && 1 !== c && e.hidden) return b.expirationTime = b.childExpirationTime = 1, null;
              break;

            case 1:
              L(b.type) && Gf(b);
              break;

            case 4:
              dh(b, b.stateNode.containerInfo);
              break;

            case 10:
              d = b.memoizedProps.value;
              e = b.type._context;
              I(jg, e._currentValue);
              e._currentValue = d;
              break;

            case 13:
              if (null !== b.memoizedState) {
                d = b.child.childExpirationTime;
                if (0 !== d && d >= c) return ji(a, b, c);
                I(M, M.current & 1);
                b = $h(a, b, c);
                return null !== b ? b.sibling : null;
              }

              I(M, M.current & 1);
              break;

            case 19:
              d = b.childExpirationTime >= c;

              if (0 !== (a.effectTag & 64)) {
                if (d) return mi(a, b, c);
                b.effectTag |= 64;
              }

              e = b.memoizedState;
              null !== e && (e.rendering = null, e.tail = null);
              I(M, M.current);
              if (!d) return null;
          }

          return $h(a, b, c);
        }

        rg = !1;
      }
    } else rg = !1;

    b.expirationTime = 0;

    switch (b.tag) {
      case 2:
        d = b.type;
        null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
        a = b.pendingProps;
        e = Cf(b, J.current);
        qg(b, c);
        e = oh(null, b, d, a, e, c);
        b.effectTag |= 1;

        if ("object" === _typeof(e) && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
          b.tag = 1;
          b.memoizedState = null;
          b.updateQueue = null;

          if (L(d)) {
            var f = !0;
            Gf(b);
          } else f = !1;

          b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
          ug(b);
          var g = d.getDerivedStateFromProps;
          "function" === typeof g && Fg(b, d, g, a);
          e.updater = Jg;
          b.stateNode = e;
          e._reactInternalFiber = b;
          Ng(b, d, a, c);
          b = gi(null, b, d, !0, f, c);
        } else b.tag = 0, R(null, b, e, c), b = b.child;

        return b;

      case 16:
        a: {
          e = b.elementType;
          null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
          a = b.pendingProps;
          ob(e);
          if (1 !== e._status) throw e._result;
          e = e._result;
          b.type = e;
          f = b.tag = Xj(e);
          a = ig(e, a);

          switch (f) {
            case 0:
              b = di(null, b, e, a, c);
              break a;

            case 1:
              b = fi(null, b, e, a, c);
              break a;

            case 11:
              b = Zh(null, b, e, a, c);
              break a;

            case 14:
              b = ai(null, b, e, ig(e.type, a), d, c);
              break a;
          }

          throw Error(u(306, e, ""));
        }

        return b;

      case 0:
        return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), di(a, b, d, e, c);

      case 1:
        return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), fi(a, b, d, e, c);

      case 3:
        hi(b);
        d = b.updateQueue;
        if (null === a || null === d) throw Error(u(282));
        d = b.pendingProps;
        e = b.memoizedState;
        e = null !== e ? e.element : null;
        vg(a, b);
        zg(b, d, null, c);
        d = b.memoizedState.element;
        if (d === e) Xh(), b = $h(a, b, c);else {
          if (e = b.stateNode.hydrate) Ph = Jd(b.stateNode.containerInfo.firstChild), Oh = b, e = Qh = !0;
          if (e) for (c = Yg(b, null, d, c), b.child = c; c;) {
            c.effectTag = c.effectTag & -3 | 1024, c = c.sibling;
          } else R(a, b, d, c), Xh();
          b = b.child;
        }
        return b;

      case 5:
        return fh(b), null === a && Uh(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Gd(d, e) ? g = null : null !== f && Gd(d, f) && (b.effectTag |= 16), ei(a, b), b.mode & 4 && 1 !== c && e.hidden ? (b.expirationTime = b.childExpirationTime = 1, b = null) : (R(a, b, g, c), b = b.child), b;

      case 6:
        return null === a && Uh(b), null;

      case 13:
        return ji(a, b, c);

      case 4:
        return dh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Xg(b, null, d, c) : R(a, b, d, c), b.child;

      case 11:
        return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), Zh(a, b, d, e, c);

      case 7:
        return R(a, b, b.pendingProps, c), b.child;

      case 8:
        return R(a, b, b.pendingProps.children, c), b.child;

      case 12:
        return R(a, b, b.pendingProps.children, c), b.child;

      case 10:
        a: {
          d = b.type._context;
          e = b.pendingProps;
          g = b.memoizedProps;
          f = e.value;
          var h = b.type._context;
          I(jg, h._currentValue);
          h._currentValue = f;
          if (null !== g) if (h = g.value, f = $e(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
            if (g.children === e.children && !K.current) {
              b = $h(a, b, c);
              break a;
            }
          } else for (h = b.child, null !== h && (h["return"] = b); null !== h;) {
            var k = h.dependencies;

            if (null !== k) {
              g = h.child;

              for (var l = k.firstContext; null !== l;) {
                if (l.context === d && 0 !== (l.observedBits & f)) {
                  1 === h.tag && (l = wg(c, null), l.tag = 2, xg(h, l));
                  h.expirationTime < c && (h.expirationTime = c);
                  l = h.alternate;
                  null !== l && l.expirationTime < c && (l.expirationTime = c);
                  pg(h["return"], c);
                  k.expirationTime < c && (k.expirationTime = c);
                  break;
                }

                l = l.next;
              }
            } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;

            if (null !== g) g["return"] = h;else for (g = h; null !== g;) {
              if (g === b) {
                g = null;
                break;
              }

              h = g.sibling;

              if (null !== h) {
                h["return"] = g["return"];
                g = h;
                break;
              }

              g = g["return"];
            }
            h = g;
          }
          R(a, b, e.children, c);
          b = b.child;
        }

        return b;

      case 9:
        return e = b.type, f = b.pendingProps, d = f.children, qg(b, c), e = sg(e, f.unstable_observedBits), d = d(e), b.effectTag |= 1, R(a, b, d, c), b.child;

      case 14:
        return e = b.type, f = ig(e, b.pendingProps), f = ig(e.type, f), ai(a, b, e, f, d, c);

      case 15:
        return ci(a, b, b.type, b.pendingProps, d, c);

      case 17:
        return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), b.tag = 1, L(d) ? (a = !0, Gf(b)) : a = !1, qg(b, c), Lg(b, d, e), Ng(b, d, e, c), gi(null, b, d, !0, a, c);

      case 19:
        return mi(a, b, c);
    }

    throw Error(u(156, b.tag));
  };

  var Uj = null,
      Li = null;

  function Yj(a) {
    if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
    var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (b.isDisabled || !b.supportsFiber) return !0;

    try {
      var c = b.inject(a);

      Uj = function Uj(a) {
        try {
          b.onCommitFiberRoot(c, a, void 0, 64 === (a.current.effectTag & 64));
        } catch (e) {}
      };

      Li = function Li(a) {
        try {
          b.onCommitFiberUnmount(c, a);
        } catch (e) {}
      };
    } catch (d) {}

    return !0;
  }

  function Zj(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this["return"] = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.effectTag = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childExpirationTime = this.expirationTime = 0;
    this.alternate = null;
  }

  function Sh(a, b, c, d) {
    return new Zj(a, b, c, d);
  }

  function bi(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
  }

  function Xj(a) {
    if ("function" === typeof a) return bi(a) ? 1 : 0;

    if (void 0 !== a && null !== a) {
      a = a.$$typeof;
      if (a === gb) return 11;
      if (a === jb) return 14;
    }

    return 2;
  }

  function Sg(a, b) {
    var c = a.alternate;
    null === c ? (c = Sh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.effectTag = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childExpirationTime = a.childExpirationTime;
    c.expirationTime = a.expirationTime;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
      expirationTime: b.expirationTime,
      firstContext: b.firstContext,
      responders: b.responders
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
  }

  function Ug(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) bi(a) && (g = 1);else if ("string" === typeof a) g = 5;else a: switch (a) {
      case ab:
        return Wg(c.children, e, f, b);

      case fb:
        g = 8;
        e |= 7;
        break;

      case bb:
        g = 8;
        e |= 1;
        break;

      case cb:
        return a = Sh(12, c, b, e | 8), a.elementType = cb, a.type = cb, a.expirationTime = f, a;

      case hb:
        return a = Sh(13, c, b, e), a.type = hb, a.elementType = hb, a.expirationTime = f, a;

      case ib:
        return a = Sh(19, c, b, e), a.elementType = ib, a.expirationTime = f, a;

      default:
        if ("object" === _typeof(a) && null !== a) switch (a.$$typeof) {
          case db:
            g = 10;
            break a;

          case eb:
            g = 9;
            break a;

          case gb:
            g = 11;
            break a;

          case jb:
            g = 14;
            break a;

          case kb:
            g = 16;
            d = null;
            break a;

          case lb:
            g = 22;
            break a;
        }
        throw Error(u(130, null == a ? a : _typeof(a), ""));
    }
    b = Sh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.expirationTime = f;
    return b;
  }

  function Wg(a, b, c, d) {
    a = Sh(7, a, d, b);
    a.expirationTime = c;
    return a;
  }

  function Tg(a, b, c) {
    a = Sh(6, a, null, b);
    a.expirationTime = c;
    return a;
  }

  function Vg(a, b, c) {
    b = Sh(4, null !== a.children ? a.children : [], a.key, b);
    b.expirationTime = c;
    b.stateNode = {
      containerInfo: a.containerInfo,
      pendingChildren: null,
      implementation: a.implementation
    };
    return b;
  }

  function ak(a, b, c) {
    this.tag = b;
    this.current = null;
    this.containerInfo = a;
    this.pingCache = this.pendingChildren = null;
    this.finishedExpirationTime = 0;
    this.finishedWork = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 90;
    this.lastExpiredTime = this.lastPingedTime = this.nextKnownPendingLevel = this.lastSuspendedTime = this.firstSuspendedTime = this.firstPendingTime = 0;
  }

  function Aj(a, b) {
    var c = a.firstSuspendedTime;
    a = a.lastSuspendedTime;
    return 0 !== c && c >= b && a <= b;
  }

  function xi(a, b) {
    var c = a.firstSuspendedTime,
        d = a.lastSuspendedTime;
    c < b && (a.firstSuspendedTime = b);
    if (d > b || 0 === c) a.lastSuspendedTime = b;
    b <= a.lastPingedTime && (a.lastPingedTime = 0);
    b <= a.lastExpiredTime && (a.lastExpiredTime = 0);
  }

  function yi(a, b) {
    b > a.firstPendingTime && (a.firstPendingTime = b);
    var c = a.firstSuspendedTime;
    0 !== c && (b >= c ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : b >= a.lastSuspendedTime && (a.lastSuspendedTime = b + 1), b > a.nextKnownPendingLevel && (a.nextKnownPendingLevel = b));
  }

  function Cj(a, b) {
    var c = a.lastExpiredTime;
    if (0 === c || c > b) a.lastExpiredTime = b;
  }

  function bk(a, b, c, d) {
    var e = b.current,
        f = Gg(),
        g = Dg.suspense;
    f = Hg(f, e, g);

    a: if (c) {
      c = c._reactInternalFiber;

      b: {
        if (dc(c) !== c || 1 !== c.tag) throw Error(u(170));
        var h = c;

        do {
          switch (h.tag) {
            case 3:
              h = h.stateNode.context;
              break b;

            case 1:
              if (L(h.type)) {
                h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                break b;
              }

          }

          h = h["return"];
        } while (null !== h);

        throw Error(u(171));
      }

      if (1 === c.tag) {
        var k = c.type;

        if (L(k)) {
          c = Ff(c, k, h);
          break a;
        }
      }

      c = h;
    } else c = Af;

    null === b.context ? b.context = c : b.pendingContext = c;
    b = wg(f, g);
    b.payload = {
      element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    xg(e, b);
    Ig(e, f);
    return f;
  }

  function ck(a) {
    a = a.current;
    if (!a.child) return null;

    switch (a.child.tag) {
      case 5:
        return a.child.stateNode;

      default:
        return a.child.stateNode;
    }
  }

  function dk(a, b) {
    a = a.memoizedState;
    null !== a && null !== a.dehydrated && a.retryTime < b && (a.retryTime = b);
  }

  function ek(a, b) {
    dk(a, b);
    (a = a.alternate) && dk(a, b);
  }

  function fk(a, b, c) {
    c = null != c && !0 === c.hydrate;
    var d = new ak(a, b, c),
        e = Sh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    d.current = e;
    e.stateNode = d;
    ug(e);
    a[Od] = d.current;
    c && 0 !== b && Jc(a, 9 === a.nodeType ? a : a.ownerDocument);
    this._internalRoot = d;
  }

  fk.prototype.render = function (a) {
    bk(a, this._internalRoot, null, null);
  };

  fk.prototype.unmount = function () {
    var a = this._internalRoot,
        b = a.containerInfo;
    bk(null, a, null, function () {
      b[Od] = null;
    });
  };

  function gk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
  }

  function hk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for (var c; c = a.lastChild;) {
      a.removeChild(c);
    }
    return new fk(a, 0, b ? {
      hydrate: !0
    } : void 0);
  }

  function ik(a, b, c, d, e) {
    var f = c._reactRootContainer;

    if (f) {
      var g = f._internalRoot;

      if ("function" === typeof e) {
        var h = e;

        e = function e() {
          var a = ck(g);
          h.call(a);
        };
      }

      bk(b, g, a, e);
    } else {
      f = c._reactRootContainer = hk(c, d);
      g = f._internalRoot;

      if ("function" === typeof e) {
        var k = e;

        e = function e() {
          var a = ck(g);
          k.call(a);
        };
      }

      Nj(function () {
        bk(b, g, a, e);
      });
    }

    return ck(g);
  }

  function jk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
      $$typeof: $a,
      key: null == d ? null : "" + d,
      children: a,
      containerInfo: b,
      implementation: c
    };
  }

  wc = function wc(a) {
    if (13 === a.tag) {
      var b = hg(Gg(), 150, 100);
      Ig(a, b);
      ek(a, b);
    }
  };

  xc = function xc(a) {
    13 === a.tag && (Ig(a, 3), ek(a, 3));
  };

  yc = function yc(a) {
    if (13 === a.tag) {
      var b = Gg();
      b = Hg(b, a, null);
      Ig(a, b);
      ek(a, b);
    }
  };

  za = function za(a, b, c) {
    switch (b) {
      case "input":
        Cb(a, c);
        b = c.name;

        if ("radio" === c.type && null != b) {
          for (c = a; c.parentNode;) {
            c = c.parentNode;
          }

          c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');

          for (b = 0; b < c.length; b++) {
            var d = c[b];

            if (d !== a && d.form === a.form) {
              var e = Qd(d);
              if (!e) throw Error(u(90));
              yb(d);
              Cb(d, e);
            }
          }
        }

        break;

      case "textarea":
        Kb(a, c);
        break;

      case "select":
        b = c.value, null != b && Hb(a, !!c.multiple, b, !1);
    }
  };

  Fa = Mj;

  Ga = function Ga(a, b, c, d, e) {
    var f = W;
    W |= 4;

    try {
      return cg(98, a.bind(null, b, c, d, e));
    } finally {
      W = f, W === V && gg();
    }
  };

  Ha = function Ha() {
    (W & (1 | fj | gj)) === V && (Lj(), Dj());
  };

  Ia = function Ia(a, b) {
    var c = W;
    W |= 2;

    try {
      return a(b);
    } finally {
      W = c, W === V && gg();
    }
  };

  function kk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!gk(b)) throw Error(u(200));
    return jk(a, b, null, c);
  }

  var lk = {
    Events: [Nc, Pd, Qd, xa, ta, Xd, function (a) {
      jc(a, Wd);
    }, Da, Ea, id, mc, Dj, {
      current: !1
    }]
  };

  (function (a) {
    var b = a.findFiberByHostInstance;
    return Yj(n({}, a, {
      overrideHookState: null,
      overrideProps: null,
      setSuspenseHandler: null,
      scheduleUpdate: null,
      currentDispatcherRef: Wa.ReactCurrentDispatcher,
      findHostInstanceByFiber: function findHostInstanceByFiber(a) {
        a = hc(a);
        return null === a ? null : a.stateNode;
      },
      findFiberByHostInstance: function findFiberByHostInstance(a) {
        return b ? b(a) : null;
      },
      findHostInstancesForRefresh: null,
      scheduleRefresh: null,
      scheduleRoot: null,
      setRefreshHandler: null,
      getCurrentFiber: null
    }));
  })({
    findFiberByHostInstance: tc,
    bundleType: 0,
    version: "16.13.1",
    rendererPackageName: "react-dom"
  });

  exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = lk;
  exports.createPortal = kk;

  exports.findDOMNode = function (a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternalFiber;

    if (void 0 === b) {
      if ("function" === typeof a.render) throw Error(u(188));
      throw Error(u(268, Object.keys(a)));
    }

    a = hc(b);
    a = null === a ? null : a.stateNode;
    return a;
  };

  exports.flushSync = function (a, b) {
    if ((W & (fj | gj)) !== V) throw Error(u(187));
    var c = W;
    W |= 1;

    try {
      return cg(99, a.bind(null, b));
    } finally {
      W = c, gg();
    }
  };

  exports.hydrate = function (a, b, c) {
    if (!gk(b)) throw Error(u(200));
    return ik(null, a, b, !0, c);
  };

  exports.render = function (a, b, c) {
    if (!gk(b)) throw Error(u(200));
    return ik(null, a, b, !1, c);
  };

  exports.unmountComponentAtNode = function (a) {
    if (!gk(a)) throw Error(u(40));
    return a._reactRootContainer ? (Nj(function () {
      ik(null, null, a, !1, function () {
        a._reactRootContainer = null;
        a[Od] = null;
      });
    }), !0) : !1;
  };

  exports.unstable_batchedUpdates = Mj;

  exports.unstable_createPortal = function (a, b) {
    return kk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
  };

  exports.unstable_renderSubtreeIntoContainer = function (a, b, c, d) {
    if (!gk(c)) throw Error(u(200));
    if (null == a || void 0 === a._reactInternalFiber) throw Error(u(38));
    return ik(a, b, c, !1, d);
  };

  exports.version = "16.13.1";
  /***/
},
/* 34 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /*
  object-assign
  (c) Sindre Sorhus
  @license MIT
  */

  /* eslint-disable no-unused-vars */

  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var propIsEnumerable = Object.prototype.propertyIsEnumerable;

  function toObject(val) {
    if (val === null || val === undefined) {
      throw new TypeError('Object.assign cannot be called with null or undefined');
    }

    return Object(val);
  }

  function shouldUseNative() {
    try {
      if (!Object.assign) {
        return false;
      } // Detect buggy property enumeration order in older V8 versions.
      // https://bugs.chromium.org/p/v8/issues/detail?id=4118


      var test1 = new String('abc'); // eslint-disable-line no-new-wrappers

      test1[5] = 'de';

      if (Object.getOwnPropertyNames(test1)[0] === '5') {
        return false;
      } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


      var test2 = {};

      for (var i = 0; i < 10; i++) {
        test2['_' + String.fromCharCode(i)] = i;
      }

      var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
        return test2[n];
      });

      if (order2.join('') !== '0123456789') {
        return false;
      } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


      var test3 = {};
      'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
        test3[letter] = letter;
      });

      if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
        return false;
      }

      return true;
    } catch (err) {
      // We don't expect any of the above to throw, but better to be safe.
      return false;
    }
  }

  module.exports = shouldUseNative() ? Object.assign : function (target, source) {
    var from;
    var to = toObject(target);
    var symbols;

    for (var s = 1; s < arguments.length; s++) {
      from = Object(arguments[s]);

      for (var key in from) {
        if (hasOwnProperty.call(from, key)) {
          to[key] = from[key];
        }
      }

      if (getOwnPropertySymbols) {
        symbols = getOwnPropertySymbols(from);

        for (var i = 0; i < symbols.length; i++) {
          if (propIsEnumerable.call(from, symbols[i])) {
            to[symbols[i]] = from[symbols[i]];
          }
        }
      }
    }

    return to;
  };
  /***/
},
/* 35 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  if (true) {
    module.exports = __webpack_require__(36);
  } else {}
  /***/

},
/* 36 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /** @license React v0.19.1
   * scheduler.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }

  var _f, g, h, k, l;

  if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var p = null,
        q = null,
        t = function t() {
      if (null !== p) try {
        var a = exports.unstable_now();
        p(!0, a);
        p = null;
      } catch (b) {
        throw setTimeout(t, 0), b;
      }
    },
        u = Date.now();

    exports.unstable_now = function () {
      return Date.now() - u;
    };

    _f = function f(a) {
      null !== p ? setTimeout(_f, 0, a) : (p = a, setTimeout(t, 0));
    };

    g = function g(a, b) {
      q = setTimeout(a, b);
    };

    h = function h() {
      clearTimeout(q);
    };

    k = function k() {
      return !1;
    };

    l = exports.unstable_forceFrameRate = function () {};
  } else {
    var w = window.performance,
        x = window.Date,
        y = window.setTimeout,
        z = window.clearTimeout;

    if ("undefined" !== typeof console) {
      var A = window.cancelAnimationFrame;
      "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
      "function" !== typeof A && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
    }

    if ("object" === _typeof(w) && "function" === typeof w.now) exports.unstable_now = function () {
      return w.now();
    };else {
      var B = x.now();

      exports.unstable_now = function () {
        return x.now() - B;
      };
    }
    var C = !1,
        D = null,
        E = -1,
        F = 5,
        G = 0;

    k = function k() {
      return exports.unstable_now() >= G;
    };

    l = function l() {};

    exports.unstable_forceFrameRate = function (a) {
      0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported") : F = 0 < a ? Math.floor(1E3 / a) : 5;
    };

    var H = new MessageChannel(),
        I = H.port2;

    H.port1.onmessage = function () {
      if (null !== D) {
        var a = exports.unstable_now();
        G = a + F;

        try {
          D(!0, a) ? I.postMessage(null) : (C = !1, D = null);
        } catch (b) {
          throw I.postMessage(null), b;
        }
      } else C = !1;
    };

    _f = function _f(a) {
      D = a;
      C || (C = !0, I.postMessage(null));
    };

    g = function g(a, b) {
      E = y(function () {
        a(exports.unstable_now());
      }, b);
    };

    h = function h() {
      z(E);
      E = -1;
    };
  }

  function J(a, b) {
    var c = a.length;
    a.push(b);

    a: for (;;) {
      var d = c - 1 >>> 1,
          e = a[d];
      if (void 0 !== e && 0 < K(e, b)) a[d] = b, a[c] = e, c = d;else break a;
    }
  }

  function L(a) {
    a = a[0];
    return void 0 === a ? null : a;
  }

  function M(a) {
    var b = a[0];

    if (void 0 !== b) {
      var c = a.pop();

      if (c !== b) {
        a[0] = c;

        a: for (var d = 0, e = a.length; d < e;) {
          var m = 2 * (d + 1) - 1,
              n = a[m],
              v = m + 1,
              r = a[v];
          if (void 0 !== n && 0 > K(n, c)) void 0 !== r && 0 > K(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);else if (void 0 !== r && 0 > K(r, c)) a[d] = r, a[v] = c, d = v;else break a;
        }
      }

      return b;
    }

    return null;
  }

  function K(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
  }

  var N = [],
      O = [],
      P = 1,
      Q = null,
      R = 3,
      S = !1,
      T = !1,
      U = !1;

  function V(a) {
    for (var b = L(O); null !== b;) {
      if (null === b.callback) M(O);else if (b.startTime <= a) M(O), b.sortIndex = b.expirationTime, J(N, b);else break;
      b = L(O);
    }
  }

  function W(a) {
    U = !1;
    V(a);
    if (!T) if (null !== L(N)) T = !0, _f(X);else {
      var b = L(O);
      null !== b && g(W, b.startTime - a);
    }
  }

  function X(a, b) {
    T = !1;
    U && (U = !1, h());
    S = !0;
    var c = R;

    try {
      V(b);

      for (Q = L(N); null !== Q && (!(Q.expirationTime > b) || a && !k());) {
        var d = Q.callback;

        if (null !== d) {
          Q.callback = null;
          R = Q.priorityLevel;
          var e = d(Q.expirationTime <= b);
          b = exports.unstable_now();
          "function" === typeof e ? Q.callback = e : Q === L(N) && M(N);
          V(b);
        } else M(N);

        Q = L(N);
      }

      if (null !== Q) var m = !0;else {
        var n = L(O);
        null !== n && g(W, n.startTime - b);
        m = !1;
      }
      return m;
    } finally {
      Q = null, R = c, S = !1;
    }
  }

  function Y(a) {
    switch (a) {
      case 1:
        return -1;

      case 2:
        return 250;

      case 5:
        return 1073741823;

      case 4:
        return 1E4;

      default:
        return 5E3;
    }
  }

  var Z = l;
  exports.unstable_IdlePriority = 5;
  exports.unstable_ImmediatePriority = 1;
  exports.unstable_LowPriority = 4;
  exports.unstable_NormalPriority = 3;
  exports.unstable_Profiling = null;
  exports.unstable_UserBlockingPriority = 2;

  exports.unstable_cancelCallback = function (a) {
    a.callback = null;
  };

  exports.unstable_continueExecution = function () {
    T || S || (T = !0, _f(X));
  };

  exports.unstable_getCurrentPriorityLevel = function () {
    return R;
  };

  exports.unstable_getFirstCallbackNode = function () {
    return L(N);
  };

  exports.unstable_next = function (a) {
    switch (R) {
      case 1:
      case 2:
      case 3:
        var b = 3;
        break;

      default:
        b = R;
    }

    var c = R;
    R = b;

    try {
      return a();
    } finally {
      R = c;
    }
  };

  exports.unstable_pauseExecution = function () {};

  exports.unstable_requestPaint = Z;

  exports.unstable_runWithPriority = function (a, b) {
    switch (a) {
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
        break;

      default:
        a = 3;
    }

    var c = R;
    R = a;

    try {
      return b();
    } finally {
      R = c;
    }
  };

  exports.unstable_scheduleCallback = function (a, b, c) {
    var d = exports.unstable_now();

    if ("object" === _typeof(c) && null !== c) {
      var e = c.delay;
      e = "number" === typeof e && 0 < e ? d + e : d;
      c = "number" === typeof c.timeout ? c.timeout : Y(a);
    } else c = Y(a), e = d;

    c = e + c;
    a = {
      id: P++,
      callback: b,
      priorityLevel: a,
      startTime: e,
      expirationTime: c,
      sortIndex: -1
    };
    e > d ? (a.sortIndex = e, J(O, a), null === L(N) && a === L(O) && (U ? h() : U = !0, g(W, e - d))) : (a.sortIndex = c, J(N, a), T || S || (T = !0, _f(X)));
    return a;
  };

  exports.unstable_shouldYield = function () {
    var a = exports.unstable_now();
    V(a);
    var b = L(N);
    return b !== Q && null !== Q && null !== b && null !== b.callback && b.startTime <= a && b.expirationTime < Q.expirationTime || k();
  };

  exports.unstable_wrapCallback = function (a) {
    var b = R;
    return function () {
      var c = R;
      R = b;

      try {
        return a.apply(this, arguments);
      } finally {
        R = c;
      }
    };
  };
  /***/

},
/* 37 */

/***/
function (module, exports, __webpack_require__) {
  var arrayLikeToArray = __webpack_require__(13);

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return arrayLikeToArray(arr);
  }

  module.exports = _arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;
  /***/
},
/* 38 */

/***/
function (module, exports) {
  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
  }

  module.exports = _iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
  /***/
},
/* 39 */

/***/
function (module, exports) {
  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  module.exports = _nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;
  /***/
},
/* 40 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  __webpack_require__.r(__webpack_exports__);
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "default", function () {
    return invariant;
  });

  var isProduction = "production" === 'production';
  var prefix = 'Invariant failed';

  function invariant(condition, message) {
    if (condition) {
      return;
    }

    if (isProduction) {
      throw new Error(prefix);
    }

    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? prefix + ": " + provided : prefix;
    throw new Error(value);
  }
  /***/

},
/* 41 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  __webpack_require__.r(__webpack_exports__);
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "MultiDrag", function () {
    return MultiDragPlugin;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "Sortable", function () {
    return Sortable;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "Swap", function () {
    return SwapPlugin;
  });
  /**!
   * Sortable 1.15.0
   * @author	RubaXa   <trash@rubaxa.org>
   * @author	owenm    <owen23355@gmail.com>
   * @license MIT
   */


  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);

      if (enumerableOnly) {
        symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      }

      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};

    var target = _objectWithoutPropertiesLoose(source, excluded);

    var key, i;

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
  }

  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var version = "1.15.0";

  function userAgent(pattern) {
    if (typeof window !== 'undefined' && window.navigator) {
      return !! /*@__PURE__*/navigator.userAgent.match(pattern);
    }
  }

  var IE11OrLess = userAgent(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i);
  var Edge = userAgent(/Edge/i);
  var FireFox = userAgent(/firefox/i);
  var Safari = userAgent(/safari/i) && !userAgent(/chrome/i) && !userAgent(/android/i);
  var IOS = userAgent(/iP(ad|od|hone)/i);
  var ChromeForAndroid = userAgent(/chrome/i) && userAgent(/android/i);
  var captureMode = {
    capture: false,
    passive: false
  };

  function on(el, event, fn) {
    el.addEventListener(event, fn, !IE11OrLess && captureMode);
  }

  function off(el, event, fn) {
    el.removeEventListener(event, fn, !IE11OrLess && captureMode);
  }

  function matches(
  /**HTMLElement*/
  el,
  /**String*/
  selector) {
    if (!selector) return;
    selector[0] === '>' && (selector = selector.substring(1));

    if (el) {
      try {
        if (el.matches) {
          return el.matches(selector);
        } else if (el.msMatchesSelector) {
          return el.msMatchesSelector(selector);
        } else if (el.webkitMatchesSelector) {
          return el.webkitMatchesSelector(selector);
        }
      } catch (_) {
        return false;
      }
    }

    return false;
  }

  function getParentOrHost(el) {
    return el.host && el !== document && el.host.nodeType ? el.host : el.parentNode;
  }

  function closest(
  /**HTMLElement*/
  el,
  /**String*/
  selector,
  /**HTMLElement*/
  ctx, includeCTX) {
    if (el) {
      ctx = ctx || document;

      do {
        if (selector != null && (selector[0] === '>' ? el.parentNode === ctx && matches(el, selector) : matches(el, selector)) || includeCTX && el === ctx) {
          return el;
        }

        if (el === ctx) break;
        /* jshint boss:true */
      } while (el = getParentOrHost(el));
    }

    return null;
  }

  var R_SPACE = /\s+/g;

  function toggleClass(el, name, state) {
    if (el && name) {
      if (el.classList) {
        el.classList[state ? 'add' : 'remove'](name);
      } else {
        var className = (' ' + el.className + ' ').replace(R_SPACE, ' ').replace(' ' + name + ' ', ' ');
        el.className = (className + (state ? ' ' + name : '')).replace(R_SPACE, ' ');
      }
    }
  }

  function css(el, prop, val) {
    var style = el && el.style;

    if (style) {
      if (val === void 0) {
        if (document.defaultView && document.defaultView.getComputedStyle) {
          val = document.defaultView.getComputedStyle(el, '');
        } else if (el.currentStyle) {
          val = el.currentStyle;
        }

        return prop === void 0 ? val : val[prop];
      } else {
        if (!(prop in style) && prop.indexOf('webkit') === -1) {
          prop = '-webkit-' + prop;
        }

        style[prop] = val + (typeof val === 'string' ? '' : 'px');
      }
    }
  }

  function matrix(el, selfOnly) {
    var appliedTransforms = '';

    if (typeof el === 'string') {
      appliedTransforms = el;
    } else {
      do {
        var transform = css(el, 'transform');

        if (transform && transform !== 'none') {
          appliedTransforms = transform + ' ' + appliedTransforms;
        }
        /* jshint boss:true */

      } while (!selfOnly && (el = el.parentNode));
    }

    var matrixFn = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
    /*jshint -W056 */

    return matrixFn && new matrixFn(appliedTransforms);
  }

  function find(ctx, tagName, iterator) {
    if (ctx) {
      var list = ctx.getElementsByTagName(tagName),
          i = 0,
          n = list.length;

      if (iterator) {
        for (; i < n; i++) {
          iterator(list[i], i);
        }
      }

      return list;
    }

    return [];
  }

  function getWindowScrollingElement() {
    var scrollingElement = document.scrollingElement;

    if (scrollingElement) {
      return scrollingElement;
    } else {
      return document.documentElement;
    }
  }
  /**
   * Returns the "bounding client rect" of given element
   * @param  {HTMLElement} el                       The element whose boundingClientRect is wanted
   * @param  {[Boolean]} relativeToContainingBlock  Whether the rect should be relative to the containing block of (including) the container
   * @param  {[Boolean]} relativeToNonStaticParent  Whether the rect should be relative to the relative parent of (including) the contaienr
   * @param  {[Boolean]} undoScale                  Whether the container's scale() should be undone
   * @param  {[HTMLElement]} container              The parent the element will be placed in
   * @return {Object}                               The boundingClientRect of el, with specified adjustments
   */


  function getRect(el, relativeToContainingBlock, relativeToNonStaticParent, undoScale, container) {
    if (!el.getBoundingClientRect && el !== window) return;
    var elRect, top, left, bottom, right, height, width;

    if (el !== window && el.parentNode && el !== getWindowScrollingElement()) {
      elRect = el.getBoundingClientRect();
      top = elRect.top;
      left = elRect.left;
      bottom = elRect.bottom;
      right = elRect.right;
      height = elRect.height;
      width = elRect.width;
    } else {
      top = 0;
      left = 0;
      bottom = window.innerHeight;
      right = window.innerWidth;
      height = window.innerHeight;
      width = window.innerWidth;
    }

    if ((relativeToContainingBlock || relativeToNonStaticParent) && el !== window) {
      // Adjust for translate()
      container = container || el.parentNode; // solves #1123 (see: https://stackoverflow.com/a/37953806/6088312)
      // Not needed on <= IE11

      if (!IE11OrLess) {
        do {
          if (container && container.getBoundingClientRect && (css(container, 'transform') !== 'none' || relativeToNonStaticParent && css(container, 'position') !== 'static')) {
            var containerRect = container.getBoundingClientRect(); // Set relative to edges of padding box of container

            top -= containerRect.top + parseInt(css(container, 'border-top-width'));
            left -= containerRect.left + parseInt(css(container, 'border-left-width'));
            bottom = top + elRect.height;
            right = left + elRect.width;
            break;
          }
          /* jshint boss:true */

        } while (container = container.parentNode);
      }
    }

    if (undoScale && el !== window) {
      // Adjust for scale()
      var elMatrix = matrix(container || el),
          scaleX = elMatrix && elMatrix.a,
          scaleY = elMatrix && elMatrix.d;

      if (elMatrix) {
        top /= scaleY;
        left /= scaleX;
        width /= scaleX;
        height /= scaleY;
        bottom = top + height;
        right = left + width;
      }
    }

    return {
      top: top,
      left: left,
      bottom: bottom,
      right: right,
      width: width,
      height: height
    };
  }
  /**
   * Checks if a side of an element is scrolled past a side of its parents
   * @param  {HTMLElement}  el           The element who's side being scrolled out of view is in question
   * @param  {String}       elSide       Side of the element in question ('top', 'left', 'right', 'bottom')
   * @param  {String}       parentSide   Side of the parent in question ('top', 'left', 'right', 'bottom')
   * @return {HTMLElement}               The parent scroll element that the el's side is scrolled past, or null if there is no such element
   */


  function isScrolledPast(el, elSide, parentSide) {
    var parent = getParentAutoScrollElement(el, true),
        elSideVal = getRect(el)[elSide];
    /* jshint boss:true */

    while (parent) {
      var parentSideVal = getRect(parent)[parentSide],
          visible = void 0;

      if (parentSide === 'top' || parentSide === 'left') {
        visible = elSideVal >= parentSideVal;
      } else {
        visible = elSideVal <= parentSideVal;
      }

      if (!visible) return parent;
      if (parent === getWindowScrollingElement()) break;
      parent = getParentAutoScrollElement(parent, false);
    }

    return false;
  }
  /**
   * Gets nth child of el, ignoring hidden children, sortable's elements (does not ignore clone if it's visible)
   * and non-draggable elements
   * @param  {HTMLElement} el       The parent element
   * @param  {Number} childNum      The index of the child
   * @param  {Object} options       Parent Sortable's options
   * @return {HTMLElement}          The child at index childNum, or null if not found
   */


  function getChild(el, childNum, options, includeDragEl) {
    var currentChild = 0,
        i = 0,
        children = el.children;

    while (i < children.length) {
      if (children[i].style.display !== 'none' && children[i] !== Sortable.ghost && (includeDragEl || children[i] !== Sortable.dragged) && closest(children[i], options.draggable, el, false)) {
        if (currentChild === childNum) {
          return children[i];
        }

        currentChild++;
      }

      i++;
    }

    return null;
  }
  /**
   * Gets the last child in the el, ignoring ghostEl or invisible elements (clones)
   * @param  {HTMLElement} el       Parent element
   * @param  {selector} selector    Any other elements that should be ignored
   * @return {HTMLElement}          The last child, ignoring ghostEl
   */


  function lastChild(el, selector) {
    var last = el.lastElementChild;

    while (last && (last === Sortable.ghost || css(last, 'display') === 'none' || selector && !matches(last, selector))) {
      last = last.previousElementSibling;
    }

    return last || null;
  }
  /**
   * Returns the index of an element within its parent for a selected set of
   * elements
   * @param  {HTMLElement} el
   * @param  {selector} selector
   * @return {number}
   */


  function index(el, selector) {
    var index = 0;

    if (!el || !el.parentNode) {
      return -1;
    }
    /* jshint boss:true */


    while (el = el.previousElementSibling) {
      if (el.nodeName.toUpperCase() !== 'TEMPLATE' && el !== Sortable.clone && (!selector || matches(el, selector))) {
        index++;
      }
    }

    return index;
  }
  /**
   * Returns the scroll offset of the given element, added with all the scroll offsets of parent elements.
   * The value is returned in real pixels.
   * @param  {HTMLElement} el
   * @return {Array}             Offsets in the format of [left, top]
   */


  function getRelativeScrollOffset(el) {
    var offsetLeft = 0,
        offsetTop = 0,
        winScroller = getWindowScrollingElement();

    if (el) {
      do {
        var elMatrix = matrix(el),
            scaleX = elMatrix.a,
            scaleY = elMatrix.d;
        offsetLeft += el.scrollLeft * scaleX;
        offsetTop += el.scrollTop * scaleY;
      } while (el !== winScroller && (el = el.parentNode));
    }

    return [offsetLeft, offsetTop];
  }
  /**
   * Returns the index of the object within the given array
   * @param  {Array} arr   Array that may or may not hold the object
   * @param  {Object} obj  An object that has a key-value pair unique to and identical to a key-value pair in the object you want to find
   * @return {Number}      The index of the object in the array, or -1
   */


  function indexOfObject(arr, obj) {
    for (var i in arr) {
      if (!arr.hasOwnProperty(i)) continue;

      for (var key in obj) {
        if (obj.hasOwnProperty(key) && obj[key] === arr[i][key]) return Number(i);
      }
    }

    return -1;
  }

  function getParentAutoScrollElement(el, includeSelf) {
    // skip to window
    if (!el || !el.getBoundingClientRect) return getWindowScrollingElement();
    var elem = el;
    var gotSelf = false;

    do {
      // we don't need to get elem css if it isn't even overflowing in the first place (performance)
      if (elem.clientWidth < elem.scrollWidth || elem.clientHeight < elem.scrollHeight) {
        var elemCSS = css(elem);

        if (elem.clientWidth < elem.scrollWidth && (elemCSS.overflowX == 'auto' || elemCSS.overflowX == 'scroll') || elem.clientHeight < elem.scrollHeight && (elemCSS.overflowY == 'auto' || elemCSS.overflowY == 'scroll')) {
          if (!elem.getBoundingClientRect || elem === document.body) return getWindowScrollingElement();
          if (gotSelf || includeSelf) return elem;
          gotSelf = true;
        }
      }
      /* jshint boss:true */

    } while (elem = elem.parentNode);

    return getWindowScrollingElement();
  }

  function extend(dst, src) {
    if (dst && src) {
      for (var key in src) {
        if (src.hasOwnProperty(key)) {
          dst[key] = src[key];
        }
      }
    }

    return dst;
  }

  function isRectEqual(rect1, rect2) {
    return Math.round(rect1.top) === Math.round(rect2.top) && Math.round(rect1.left) === Math.round(rect2.left) && Math.round(rect1.height) === Math.round(rect2.height) && Math.round(rect1.width) === Math.round(rect2.width);
  }

  var _throttleTimeout;

  function throttle(callback, ms) {
    return function () {
      if (!_throttleTimeout) {
        var args = arguments,
            _this = this;

        if (args.length === 1) {
          callback.call(_this, args[0]);
        } else {
          callback.apply(_this, args);
        }

        _throttleTimeout = setTimeout(function () {
          _throttleTimeout = void 0;
        }, ms);
      }
    };
  }

  function cancelThrottle() {
    clearTimeout(_throttleTimeout);
    _throttleTimeout = void 0;
  }

  function scrollBy(el, x, y) {
    el.scrollLeft += x;
    el.scrollTop += y;
  }

  function clone(el) {
    var Polymer = window.Polymer;
    var $ = window.jQuery || window.Zepto;

    if (Polymer && Polymer.dom) {
      return Polymer.dom(el).cloneNode(true);
    } else if ($) {
      return $(el).clone(true)[0];
    } else {
      return el.cloneNode(true);
    }
  }

  function setRect(el, rect) {
    css(el, 'position', 'absolute');
    css(el, 'top', rect.top);
    css(el, 'left', rect.left);
    css(el, 'width', rect.width);
    css(el, 'height', rect.height);
  }

  function unsetRect(el) {
    css(el, 'position', '');
    css(el, 'top', '');
    css(el, 'left', '');
    css(el, 'width', '');
    css(el, 'height', '');
  }

  var expando = 'Sortable' + new Date().getTime();

  function AnimationStateManager() {
    var animationStates = [],
        animationCallbackId;
    return {
      captureAnimationState: function captureAnimationState() {
        animationStates = [];
        if (!this.options.animation) return;
        var children = [].slice.call(this.el.children);
        children.forEach(function (child) {
          if (css(child, 'display') === 'none' || child === Sortable.ghost) return;
          animationStates.push({
            target: child,
            rect: getRect(child)
          });

          var fromRect = _objectSpread2({}, animationStates[animationStates.length - 1].rect); // If animating: compensate for current animation


          if (child.thisAnimationDuration) {
            var childMatrix = matrix(child, true);

            if (childMatrix) {
              fromRect.top -= childMatrix.f;
              fromRect.left -= childMatrix.e;
            }
          }

          child.fromRect = fromRect;
        });
      },
      addAnimationState: function addAnimationState(state) {
        animationStates.push(state);
      },
      removeAnimationState: function removeAnimationState(target) {
        animationStates.splice(indexOfObject(animationStates, {
          target: target
        }), 1);
      },
      animateAll: function animateAll(callback) {
        var _this = this;

        if (!this.options.animation) {
          clearTimeout(animationCallbackId);
          if (typeof callback === 'function') callback();
          return;
        }

        var animating = false,
            animationTime = 0;
        animationStates.forEach(function (state) {
          var time = 0,
              target = state.target,
              fromRect = target.fromRect,
              toRect = getRect(target),
              prevFromRect = target.prevFromRect,
              prevToRect = target.prevToRect,
              animatingRect = state.rect,
              targetMatrix = matrix(target, true);

          if (targetMatrix) {
            // Compensate for current animation
            toRect.top -= targetMatrix.f;
            toRect.left -= targetMatrix.e;
          }

          target.toRect = toRect;

          if (target.thisAnimationDuration) {
            // Could also check if animatingRect is between fromRect and toRect
            if (isRectEqual(prevFromRect, toRect) && !isRectEqual(fromRect, toRect) && // Make sure animatingRect is on line between toRect & fromRect
            (animatingRect.top - toRect.top) / (animatingRect.left - toRect.left) === (fromRect.top - toRect.top) / (fromRect.left - toRect.left)) {
              // If returning to same place as started from animation and on same axis
              time = calculateRealTime(animatingRect, prevFromRect, prevToRect, _this.options);
            }
          } // if fromRect != toRect: animate


          if (!isRectEqual(toRect, fromRect)) {
            target.prevFromRect = fromRect;
            target.prevToRect = toRect;

            if (!time) {
              time = _this.options.animation;
            }

            _this.animate(target, animatingRect, toRect, time);
          }

          if (time) {
            animating = true;
            animationTime = Math.max(animationTime, time);
            clearTimeout(target.animationResetTimer);
            target.animationResetTimer = setTimeout(function () {
              target.animationTime = 0;
              target.prevFromRect = null;
              target.fromRect = null;
              target.prevToRect = null;
              target.thisAnimationDuration = null;
            }, time);
            target.thisAnimationDuration = time;
          }
        });
        clearTimeout(animationCallbackId);

        if (!animating) {
          if (typeof callback === 'function') callback();
        } else {
          animationCallbackId = setTimeout(function () {
            if (typeof callback === 'function') callback();
          }, animationTime);
        }

        animationStates = [];
      },
      animate: function animate(target, currentRect, toRect, duration) {
        if (duration) {
          css(target, 'transition', '');
          css(target, 'transform', '');
          var elMatrix = matrix(this.el),
              scaleX = elMatrix && elMatrix.a,
              scaleY = elMatrix && elMatrix.d,
              translateX = (currentRect.left - toRect.left) / (scaleX || 1),
              translateY = (currentRect.top - toRect.top) / (scaleY || 1);
          target.animatingX = !!translateX;
          target.animatingY = !!translateY;
          css(target, 'transform', 'translate3d(' + translateX + 'px,' + translateY + 'px,0)');
          this.forRepaintDummy = repaint(target); // repaint

          css(target, 'transition', 'transform ' + duration + 'ms' + (this.options.easing ? ' ' + this.options.easing : ''));
          css(target, 'transform', 'translate3d(0,0,0)');
          typeof target.animated === 'number' && clearTimeout(target.animated);
          target.animated = setTimeout(function () {
            css(target, 'transition', '');
            css(target, 'transform', '');
            target.animated = false;
            target.animatingX = false;
            target.animatingY = false;
          }, duration);
        }
      }
    };
  }

  function repaint(target) {
    return target.offsetWidth;
  }

  function calculateRealTime(animatingRect, fromRect, toRect, options) {
    return Math.sqrt(Math.pow(fromRect.top - animatingRect.top, 2) + Math.pow(fromRect.left - animatingRect.left, 2)) / Math.sqrt(Math.pow(fromRect.top - toRect.top, 2) + Math.pow(fromRect.left - toRect.left, 2)) * options.animation;
  }

  var plugins = [];
  var defaults = {
    initializeByDefault: true
  };
  var PluginManager = {
    mount: function mount(plugin) {
      // Set default static properties
      for (var option in defaults) {
        if (defaults.hasOwnProperty(option) && !(option in plugin)) {
          plugin[option] = defaults[option];
        }
      }

      plugins.forEach(function (p) {
        if (p.pluginName === plugin.pluginName) {
          throw "Sortable: Cannot mount plugin ".concat(plugin.pluginName, " more than once");
        }
      });
      plugins.push(plugin);
    },
    pluginEvent: function pluginEvent(eventName, sortable, evt) {
      var _this = this;

      this.eventCanceled = false;

      evt.cancel = function () {
        _this.eventCanceled = true;
      };

      var eventNameGlobal = eventName + 'Global';
      plugins.forEach(function (plugin) {
        if (!sortable[plugin.pluginName]) return; // Fire global events if it exists in this sortable

        if (sortable[plugin.pluginName][eventNameGlobal]) {
          sortable[plugin.pluginName][eventNameGlobal](_objectSpread2({
            sortable: sortable
          }, evt));
        } // Only fire plugin event if plugin is enabled in this sortable,
        // and plugin has event defined


        if (sortable.options[plugin.pluginName] && sortable[plugin.pluginName][eventName]) {
          sortable[plugin.pluginName][eventName](_objectSpread2({
            sortable: sortable
          }, evt));
        }
      });
    },
    initializePlugins: function initializePlugins(sortable, el, defaults, options) {
      plugins.forEach(function (plugin) {
        var pluginName = plugin.pluginName;
        if (!sortable.options[pluginName] && !plugin.initializeByDefault) return;
        var initialized = new plugin(sortable, el, sortable.options);
        initialized.sortable = sortable;
        initialized.options = sortable.options;
        sortable[pluginName] = initialized; // Add default options from plugin

        _extends(defaults, initialized.defaults);
      });

      for (var option in sortable.options) {
        if (!sortable.options.hasOwnProperty(option)) continue;
        var modified = this.modifyOption(sortable, option, sortable.options[option]);

        if (typeof modified !== 'undefined') {
          sortable.options[option] = modified;
        }
      }
    },
    getEventProperties: function getEventProperties(name, sortable) {
      var eventProperties = {};
      plugins.forEach(function (plugin) {
        if (typeof plugin.eventProperties !== 'function') return;

        _extends(eventProperties, plugin.eventProperties.call(sortable[plugin.pluginName], name));
      });
      return eventProperties;
    },
    modifyOption: function modifyOption(sortable, name, value) {
      var modifiedValue;
      plugins.forEach(function (plugin) {
        // Plugin must exist on the Sortable
        if (!sortable[plugin.pluginName]) return; // If static option listener exists for this option, call in the context of the Sortable's instance of this plugin

        if (plugin.optionListeners && typeof plugin.optionListeners[name] === 'function') {
          modifiedValue = plugin.optionListeners[name].call(sortable[plugin.pluginName], value);
        }
      });
      return modifiedValue;
    }
  };

  function dispatchEvent(_ref) {
    var sortable = _ref.sortable,
        rootEl = _ref.rootEl,
        name = _ref.name,
        targetEl = _ref.targetEl,
        cloneEl = _ref.cloneEl,
        toEl = _ref.toEl,
        fromEl = _ref.fromEl,
        oldIndex = _ref.oldIndex,
        newIndex = _ref.newIndex,
        oldDraggableIndex = _ref.oldDraggableIndex,
        newDraggableIndex = _ref.newDraggableIndex,
        originalEvent = _ref.originalEvent,
        putSortable = _ref.putSortable,
        extraEventProperties = _ref.extraEventProperties;
    sortable = sortable || rootEl && rootEl[expando];
    if (!sortable) return;
    var evt,
        options = sortable.options,
        onName = 'on' + name.charAt(0).toUpperCase() + name.substr(1); // Support for new CustomEvent feature

    if (window.CustomEvent && !IE11OrLess && !Edge) {
      evt = new CustomEvent(name, {
        bubbles: true,
        cancelable: true
      });
    } else {
      evt = document.createEvent('Event');
      evt.initEvent(name, true, true);
    }

    evt.to = toEl || rootEl;
    evt.from = fromEl || rootEl;
    evt.item = targetEl || rootEl;
    evt.clone = cloneEl;
    evt.oldIndex = oldIndex;
    evt.newIndex = newIndex;
    evt.oldDraggableIndex = oldDraggableIndex;
    evt.newDraggableIndex = newDraggableIndex;
    evt.originalEvent = originalEvent;
    evt.pullMode = putSortable ? putSortable.lastPutMode : undefined;

    var allEventProperties = _objectSpread2(_objectSpread2({}, extraEventProperties), PluginManager.getEventProperties(name, sortable));

    for (var option in allEventProperties) {
      evt[option] = allEventProperties[option];
    }

    if (rootEl) {
      rootEl.dispatchEvent(evt);
    }

    if (options[onName]) {
      options[onName].call(sortable, evt);
    }
  }

  var _excluded = ["evt"];

  var pluginEvent = function pluginEvent(eventName, sortable) {
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        originalEvent = _ref.evt,
        data = _objectWithoutProperties(_ref, _excluded);

    PluginManager.pluginEvent.bind(Sortable)(eventName, sortable, _objectSpread2({
      dragEl: dragEl,
      parentEl: parentEl,
      ghostEl: ghostEl,
      rootEl: rootEl,
      nextEl: nextEl,
      lastDownEl: lastDownEl,
      cloneEl: cloneEl,
      cloneHidden: cloneHidden,
      dragStarted: moved,
      putSortable: putSortable,
      activeSortable: Sortable.active,
      originalEvent: originalEvent,
      oldIndex: oldIndex,
      oldDraggableIndex: oldDraggableIndex,
      newIndex: newIndex,
      newDraggableIndex: newDraggableIndex,
      hideGhostForTarget: _hideGhostForTarget,
      unhideGhostForTarget: _unhideGhostForTarget,
      cloneNowHidden: function cloneNowHidden() {
        cloneHidden = true;
      },
      cloneNowShown: function cloneNowShown() {
        cloneHidden = false;
      },
      dispatchSortableEvent: function dispatchSortableEvent(name) {
        _dispatchEvent({
          sortable: sortable,
          name: name,
          originalEvent: originalEvent
        });
      }
    }, data));
  };

  function _dispatchEvent(info) {
    dispatchEvent(_objectSpread2({
      putSortable: putSortable,
      cloneEl: cloneEl,
      targetEl: dragEl,
      rootEl: rootEl,
      oldIndex: oldIndex,
      oldDraggableIndex: oldDraggableIndex,
      newIndex: newIndex,
      newDraggableIndex: newDraggableIndex
    }, info));
  }

  var dragEl,
      parentEl,
      ghostEl,
      rootEl,
      nextEl,
      lastDownEl,
      cloneEl,
      cloneHidden,
      oldIndex,
      newIndex,
      oldDraggableIndex,
      newDraggableIndex,
      activeGroup,
      putSortable,
      awaitingDragStarted = false,
      ignoreNextClick = false,
      sortables = [],
      tapEvt,
      touchEvt,
      lastDx,
      lastDy,
      tapDistanceLeft,
      tapDistanceTop,
      moved,
      lastTarget,
      lastDirection,
      pastFirstInvertThresh = false,
      isCircumstantialInvert = false,
      targetMoveDistance,
      // For positioning ghost absolutely
  ghostRelativeParent,
      ghostRelativeParentInitialScroll = [],
      // (left, top)
  _silent = false,
      savedInputChecked = [];
  /** @const */

  var documentExists = typeof document !== 'undefined',
      PositionGhostAbsolutely = IOS,
      CSSFloatProperty = Edge || IE11OrLess ? 'cssFloat' : 'float',
      // This will not pass for IE9, because IE9 DnD only works on anchors
  supportDraggable = documentExists && !ChromeForAndroid && !IOS && 'draggable' in document.createElement('div'),
      supportCssPointerEvents = function () {
    if (!documentExists) return; // false when <= IE11

    if (IE11OrLess) {
      return false;
    }

    var el = document.createElement('x');
    el.style.cssText = 'pointer-events:auto';
    return el.style.pointerEvents === 'auto';
  }(),
      _detectDirection = function _detectDirection(el, options) {
    var elCSS = css(el),
        elWidth = parseInt(elCSS.width) - parseInt(elCSS.paddingLeft) - parseInt(elCSS.paddingRight) - parseInt(elCSS.borderLeftWidth) - parseInt(elCSS.borderRightWidth),
        child1 = getChild(el, 0, options),
        child2 = getChild(el, 1, options),
        firstChildCSS = child1 && css(child1),
        secondChildCSS = child2 && css(child2),
        firstChildWidth = firstChildCSS && parseInt(firstChildCSS.marginLeft) + parseInt(firstChildCSS.marginRight) + getRect(child1).width,
        secondChildWidth = secondChildCSS && parseInt(secondChildCSS.marginLeft) + parseInt(secondChildCSS.marginRight) + getRect(child2).width;

    if (elCSS.display === 'flex') {
      return elCSS.flexDirection === 'column' || elCSS.flexDirection === 'column-reverse' ? 'vertical' : 'horizontal';
    }

    if (elCSS.display === 'grid') {
      return elCSS.gridTemplateColumns.split(' ').length <= 1 ? 'vertical' : 'horizontal';
    }

    if (child1 && firstChildCSS["float"] && firstChildCSS["float"] !== 'none') {
      var touchingSideChild2 = firstChildCSS["float"] === 'left' ? 'left' : 'right';
      return child2 && (secondChildCSS.clear === 'both' || secondChildCSS.clear === touchingSideChild2) ? 'vertical' : 'horizontal';
    }

    return child1 && (firstChildCSS.display === 'block' || firstChildCSS.display === 'flex' || firstChildCSS.display === 'table' || firstChildCSS.display === 'grid' || firstChildWidth >= elWidth && elCSS[CSSFloatProperty] === 'none' || child2 && elCSS[CSSFloatProperty] === 'none' && firstChildWidth + secondChildWidth > elWidth) ? 'vertical' : 'horizontal';
  },
      _dragElInRowColumn = function _dragElInRowColumn(dragRect, targetRect, vertical) {
    var dragElS1Opp = vertical ? dragRect.left : dragRect.top,
        dragElS2Opp = vertical ? dragRect.right : dragRect.bottom,
        dragElOppLength = vertical ? dragRect.width : dragRect.height,
        targetS1Opp = vertical ? targetRect.left : targetRect.top,
        targetS2Opp = vertical ? targetRect.right : targetRect.bottom,
        targetOppLength = vertical ? targetRect.width : targetRect.height;
    return dragElS1Opp === targetS1Opp || dragElS2Opp === targetS2Opp || dragElS1Opp + dragElOppLength / 2 === targetS1Opp + targetOppLength / 2;
  },

  /**
   * Detects first nearest empty sortable to X and Y position using emptyInsertThreshold.
   * @param  {Number} x      X position
   * @param  {Number} y      Y position
   * @return {HTMLElement}   Element of the first found nearest Sortable
   */
  _detectNearestEmptySortable = function _detectNearestEmptySortable(x, y) {
    var ret;
    sortables.some(function (sortable) {
      var threshold = sortable[expando].options.emptyInsertThreshold;
      if (!threshold || lastChild(sortable)) return;
      var rect = getRect(sortable),
          insideHorizontally = x >= rect.left - threshold && x <= rect.right + threshold,
          insideVertically = y >= rect.top - threshold && y <= rect.bottom + threshold;

      if (insideHorizontally && insideVertically) {
        return ret = sortable;
      }
    });
    return ret;
  },
      _prepareGroup = function _prepareGroup(options) {
    function toFn(value, pull) {
      return function (to, from, dragEl, evt) {
        var sameGroup = to.options.group.name && from.options.group.name && to.options.group.name === from.options.group.name;

        if (value == null && (pull || sameGroup)) {
          // Default pull value
          // Default pull and put value if same group
          return true;
        } else if (value == null || value === false) {
          return false;
        } else if (pull && value === 'clone') {
          return value;
        } else if (typeof value === 'function') {
          return toFn(value(to, from, dragEl, evt), pull)(to, from, dragEl, evt);
        } else {
          var otherGroup = (pull ? to : from).options.group.name;
          return value === true || typeof value === 'string' && value === otherGroup || value.join && value.indexOf(otherGroup) > -1;
        }
      };
    }

    var group = {};
    var originalGroup = options.group;

    if (!originalGroup || _typeof(originalGroup) != 'object') {
      originalGroup = {
        name: originalGroup
      };
    }

    group.name = originalGroup.name;
    group.checkPull = toFn(originalGroup.pull, true);
    group.checkPut = toFn(originalGroup.put);
    group.revertClone = originalGroup.revertClone;
    options.group = group;
  },
      _hideGhostForTarget = function _hideGhostForTarget() {
    if (!supportCssPointerEvents && ghostEl) {
      css(ghostEl, 'display', 'none');
    }
  },
      _unhideGhostForTarget = function _unhideGhostForTarget() {
    if (!supportCssPointerEvents && ghostEl) {
      css(ghostEl, 'display', '');
    }
  }; // #1184 fix - Prevent click event on fallback if dragged but item not changed position


  if (documentExists && !ChromeForAndroid) {
    document.addEventListener('click', function (evt) {
      if (ignoreNextClick) {
        evt.preventDefault();
        evt.stopPropagation && evt.stopPropagation();
        evt.stopImmediatePropagation && evt.stopImmediatePropagation();
        ignoreNextClick = false;
        return false;
      }
    }, true);
  }

  var nearestEmptyInsertDetectEvent = function nearestEmptyInsertDetectEvent(evt) {
    if (dragEl) {
      evt = evt.touches ? evt.touches[0] : evt;

      var nearest = _detectNearestEmptySortable(evt.clientX, evt.clientY);

      if (nearest) {
        // Create imitation event
        var event = {};

        for (var i in evt) {
          if (evt.hasOwnProperty(i)) {
            event[i] = evt[i];
          }
        }

        event.target = event.rootEl = nearest;
        event.preventDefault = void 0;
        event.stopPropagation = void 0;

        nearest[expando]._onDragOver(event);
      }
    }
  };

  var _checkOutsideTargetEl = function _checkOutsideTargetEl(evt) {
    if (dragEl) {
      dragEl.parentNode[expando]._isOutsideThisEl(evt.target);
    }
  };
  /**
   * @class  Sortable
   * @param  {HTMLElement}  el
   * @param  {Object}       [options]
   */


  function Sortable(el, options) {
    if (!(el && el.nodeType && el.nodeType === 1)) {
      throw "Sortable: `el` must be an HTMLElement, not ".concat({}.toString.call(el));
    }

    this.el = el; // root element

    this.options = options = _extends({}, options); // Export instance

    el[expando] = this;
    var defaults = {
      group: null,
      sort: true,
      disabled: false,
      store: null,
      handle: null,
      draggable: /^[uo]l$/i.test(el.nodeName) ? '>li' : '>*',
      swapThreshold: 1,
      // percentage; 0 <= x <= 1
      invertSwap: false,
      // invert always
      invertedSwapThreshold: null,
      // will be set to same as swapThreshold if default
      removeCloneOnHide: true,
      direction: function direction() {
        return _detectDirection(el, this.options);
      },
      ghostClass: 'sortable-ghost',
      chosenClass: 'sortable-chosen',
      dragClass: 'sortable-drag',
      ignore: 'a, img',
      filter: null,
      preventOnFilter: true,
      animation: 0,
      easing: null,
      setData: function setData(dataTransfer, dragEl) {
        dataTransfer.setData('Text', dragEl.textContent);
      },
      dropBubble: false,
      dragoverBubble: false,
      dataIdAttr: 'data-id',
      delay: 0,
      delayOnTouchOnly: false,
      touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
      forceFallback: false,
      fallbackClass: 'sortable-fallback',
      fallbackOnBody: false,
      fallbackTolerance: 0,
      fallbackOffset: {
        x: 0,
        y: 0
      },
      supportPointer: Sortable.supportPointer !== false && 'PointerEvent' in window && !Safari,
      emptyInsertThreshold: 5
    };
    PluginManager.initializePlugins(this, el, defaults); // Set default options

    for (var name in defaults) {
      !(name in options) && (options[name] = defaults[name]);
    }

    _prepareGroup(options); // Bind all private methods


    for (var fn in this) {
      if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
        this[fn] = this[fn].bind(this);
      }
    } // Setup drag mode


    this.nativeDraggable = options.forceFallback ? false : supportDraggable;

    if (this.nativeDraggable) {
      // Touch start threshold cannot be greater than the native dragstart threshold
      this.options.touchStartThreshold = 1;
    } // Bind events


    if (options.supportPointer) {
      on(el, 'pointerdown', this._onTapStart);
    } else {
      on(el, 'mousedown', this._onTapStart);
      on(el, 'touchstart', this._onTapStart);
    }

    if (this.nativeDraggable) {
      on(el, 'dragover', this);
      on(el, 'dragenter', this);
    }

    sortables.push(this.el); // Restore sorting

    options.store && options.store.get && this.sort(options.store.get(this) || []); // Add animation state manager

    _extends(this, AnimationStateManager());
  }

  Sortable.prototype =
  /** @lends Sortable.prototype */
  {
    constructor: Sortable,
    _isOutsideThisEl: function _isOutsideThisEl(target) {
      if (!this.el.contains(target) && target !== this.el) {
        lastTarget = null;
      }
    },
    _getDirection: function _getDirection(evt, target) {
      return typeof this.options.direction === 'function' ? this.options.direction.call(this, evt, target, dragEl) : this.options.direction;
    },
    _onTapStart: function _onTapStart(
    /** Event|TouchEvent */
    evt) {
      if (!evt.cancelable) return;

      var _this = this,
          el = this.el,
          options = this.options,
          preventOnFilter = options.preventOnFilter,
          type = evt.type,
          touch = evt.touches && evt.touches[0] || evt.pointerType && evt.pointerType === 'touch' && evt,
          target = (touch || evt).target,
          originalTarget = evt.target.shadowRoot && (evt.path && evt.path[0] || evt.composedPath && evt.composedPath()[0]) || target,
          filter = options.filter;

      _saveInputCheckedState(el); // Don't trigger start event when an element is been dragged, otherwise the evt.oldindex always wrong when set option.group.


      if (dragEl) {
        return;
      }

      if (/mousedown|pointerdown/.test(type) && evt.button !== 0 || options.disabled) {
        return; // only left button and enabled
      } // cancel dnd if original target is content editable


      if (originalTarget.isContentEditable) {
        return;
      } // Safari ignores further event handling after mousedown


      if (!this.nativeDraggable && Safari && target && target.tagName.toUpperCase() === 'SELECT') {
        return;
      }

      target = closest(target, options.draggable, el, false);

      if (target && target.animated) {
        return;
      }

      if (lastDownEl === target) {
        // Ignoring duplicate `down`
        return;
      } // Get the index of the dragged element within its parent


      oldIndex = index(target);
      oldDraggableIndex = index(target, options.draggable); // Check filter

      if (typeof filter === 'function') {
        if (filter.call(this, evt, target, this)) {
          _dispatchEvent({
            sortable: _this,
            rootEl: originalTarget,
            name: 'filter',
            targetEl: target,
            toEl: el,
            fromEl: el
          });

          pluginEvent('filter', _this, {
            evt: evt
          });
          preventOnFilter && evt.cancelable && evt.preventDefault();
          return; // cancel dnd
        }
      } else if (filter) {
        filter = filter.split(',').some(function (criteria) {
          criteria = closest(originalTarget, criteria.trim(), el, false);

          if (criteria) {
            _dispatchEvent({
              sortable: _this,
              rootEl: criteria,
              name: 'filter',
              targetEl: target,
              fromEl: el,
              toEl: el
            });

            pluginEvent('filter', _this, {
              evt: evt
            });
            return true;
          }
        });

        if (filter) {
          preventOnFilter && evt.cancelable && evt.preventDefault();
          return; // cancel dnd
        }
      }

      if (options.handle && !closest(originalTarget, options.handle, el, false)) {
        return;
      } // Prepare `dragstart`


      this._prepareDragStart(evt, touch, target);
    },
    _prepareDragStart: function _prepareDragStart(
    /** Event */
    evt,
    /** Touch */
    touch,
    /** HTMLElement */
    target) {
      var _this = this,
          el = _this.el,
          options = _this.options,
          ownerDocument = el.ownerDocument,
          dragStartFn;

      if (target && !dragEl && target.parentNode === el) {
        var dragRect = getRect(target);
        rootEl = el;
        dragEl = target;
        parentEl = dragEl.parentNode;
        nextEl = dragEl.nextSibling;
        lastDownEl = target;
        activeGroup = options.group;
        Sortable.dragged = dragEl;
        tapEvt = {
          target: dragEl,
          clientX: (touch || evt).clientX,
          clientY: (touch || evt).clientY
        };
        tapDistanceLeft = tapEvt.clientX - dragRect.left;
        tapDistanceTop = tapEvt.clientY - dragRect.top;
        this._lastX = (touch || evt).clientX;
        this._lastY = (touch || evt).clientY;
        dragEl.style['will-change'] = 'all';

        dragStartFn = function dragStartFn() {
          pluginEvent('delayEnded', _this, {
            evt: evt
          });

          if (Sortable.eventCanceled) {
            _this._onDrop();

            return;
          } // Delayed drag has been triggered
          // we can re-enable the events: touchmove/mousemove


          _this._disableDelayedDragEvents();

          if (!FireFox && _this.nativeDraggable) {
            dragEl.draggable = true;
          } // Bind the events: dragstart/dragend


          _this._triggerDragStart(evt, touch); // Drag start event


          _dispatchEvent({
            sortable: _this,
            name: 'choose',
            originalEvent: evt
          }); // Chosen item


          toggleClass(dragEl, options.chosenClass, true);
        }; // Disable "draggable"


        options.ignore.split(',').forEach(function (criteria) {
          find(dragEl, criteria.trim(), _disableDraggable);
        });
        on(ownerDocument, 'dragover', nearestEmptyInsertDetectEvent);
        on(ownerDocument, 'mousemove', nearestEmptyInsertDetectEvent);
        on(ownerDocument, 'touchmove', nearestEmptyInsertDetectEvent);
        on(ownerDocument, 'mouseup', _this._onDrop);
        on(ownerDocument, 'touchend', _this._onDrop);
        on(ownerDocument, 'touchcancel', _this._onDrop); // Make dragEl draggable (must be before delay for FireFox)

        if (FireFox && this.nativeDraggable) {
          this.options.touchStartThreshold = 4;
          dragEl.draggable = true;
        }

        pluginEvent('delayStart', this, {
          evt: evt
        }); // Delay is impossible for native DnD in Edge or IE

        if (options.delay && (!options.delayOnTouchOnly || touch) && (!this.nativeDraggable || !(Edge || IE11OrLess))) {
          if (Sortable.eventCanceled) {
            this._onDrop();

            return;
          } // If the user moves the pointer or let go the click or touch
          // before the delay has been reached:
          // disable the delayed drag


          on(ownerDocument, 'mouseup', _this._disableDelayedDrag);
          on(ownerDocument, 'touchend', _this._disableDelayedDrag);
          on(ownerDocument, 'touchcancel', _this._disableDelayedDrag);
          on(ownerDocument, 'mousemove', _this._delayedDragTouchMoveHandler);
          on(ownerDocument, 'touchmove', _this._delayedDragTouchMoveHandler);
          options.supportPointer && on(ownerDocument, 'pointermove', _this._delayedDragTouchMoveHandler);
          _this._dragStartTimer = setTimeout(dragStartFn, options.delay);
        } else {
          dragStartFn();
        }
      }
    },
    _delayedDragTouchMoveHandler: function _delayedDragTouchMoveHandler(
    /** TouchEvent|PointerEvent **/
    e) {
      var touch = e.touches ? e.touches[0] : e;

      if (Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1))) {
        this._disableDelayedDrag();
      }
    },
    _disableDelayedDrag: function _disableDelayedDrag() {
      dragEl && _disableDraggable(dragEl);
      clearTimeout(this._dragStartTimer);

      this._disableDelayedDragEvents();
    },
    _disableDelayedDragEvents: function _disableDelayedDragEvents() {
      var ownerDocument = this.el.ownerDocument;
      off(ownerDocument, 'mouseup', this._disableDelayedDrag);
      off(ownerDocument, 'touchend', this._disableDelayedDrag);
      off(ownerDocument, 'touchcancel', this._disableDelayedDrag);
      off(ownerDocument, 'mousemove', this._delayedDragTouchMoveHandler);
      off(ownerDocument, 'touchmove', this._delayedDragTouchMoveHandler);
      off(ownerDocument, 'pointermove', this._delayedDragTouchMoveHandler);
    },
    _triggerDragStart: function _triggerDragStart(
    /** Event */
    evt,
    /** Touch */
    touch) {
      touch = touch || evt.pointerType == 'touch' && evt;

      if (!this.nativeDraggable || touch) {
        if (this.options.supportPointer) {
          on(document, 'pointermove', this._onTouchMove);
        } else if (touch) {
          on(document, 'touchmove', this._onTouchMove);
        } else {
          on(document, 'mousemove', this._onTouchMove);
        }
      } else {
        on(dragEl, 'dragend', this);
        on(rootEl, 'dragstart', this._onDragStart);
      }

      try {
        if (document.selection) {
          // Timeout neccessary for IE9
          _nextTick(function () {
            document.selection.empty();
          });
        } else {
          window.getSelection().removeAllRanges();
        }
      } catch (err) {}
    },
    _dragStarted: function _dragStarted(fallback, evt) {
      awaitingDragStarted = false;

      if (rootEl && dragEl) {
        pluginEvent('dragStarted', this, {
          evt: evt
        });

        if (this.nativeDraggable) {
          on(document, 'dragover', _checkOutsideTargetEl);
        }

        var options = this.options; // Apply effect

        !fallback && toggleClass(dragEl, options.dragClass, false);
        toggleClass(dragEl, options.ghostClass, true);
        Sortable.active = this;
        fallback && this._appendGhost(); // Drag start event

        _dispatchEvent({
          sortable: this,
          name: 'start',
          originalEvent: evt
        });
      } else {
        this._nulling();
      }
    },
    _emulateDragOver: function _emulateDragOver() {
      if (touchEvt) {
        this._lastX = touchEvt.clientX;
        this._lastY = touchEvt.clientY;

        _hideGhostForTarget();

        var target = document.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
        var parent = target;

        while (target && target.shadowRoot) {
          target = target.shadowRoot.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
          if (target === parent) break;
          parent = target;
        }

        dragEl.parentNode[expando]._isOutsideThisEl(target);

        if (parent) {
          do {
            if (parent[expando]) {
              var inserted = void 0;
              inserted = parent[expando]._onDragOver({
                clientX: touchEvt.clientX,
                clientY: touchEvt.clientY,
                target: target,
                rootEl: parent
              });

              if (inserted && !this.options.dragoverBubble) {
                break;
              }
            }

            target = parent; // store last element
          }
          /* jshint boss:true */
          while (parent = parent.parentNode);
        }

        _unhideGhostForTarget();
      }
    },
    _onTouchMove: function _onTouchMove(
    /**TouchEvent*/
    evt) {
      if (tapEvt) {
        var options = this.options,
            fallbackTolerance = options.fallbackTolerance,
            fallbackOffset = options.fallbackOffset,
            touch = evt.touches ? evt.touches[0] : evt,
            ghostMatrix = ghostEl && matrix(ghostEl, true),
            scaleX = ghostEl && ghostMatrix && ghostMatrix.a,
            scaleY = ghostEl && ghostMatrix && ghostMatrix.d,
            relativeScrollOffset = PositionGhostAbsolutely && ghostRelativeParent && getRelativeScrollOffset(ghostRelativeParent),
            dx = (touch.clientX - tapEvt.clientX + fallbackOffset.x) / (scaleX || 1) + (relativeScrollOffset ? relativeScrollOffset[0] - ghostRelativeParentInitialScroll[0] : 0) / (scaleX || 1),
            dy = (touch.clientY - tapEvt.clientY + fallbackOffset.y) / (scaleY || 1) + (relativeScrollOffset ? relativeScrollOffset[1] - ghostRelativeParentInitialScroll[1] : 0) / (scaleY || 1); // only set the status to dragging, when we are actually dragging

        if (!Sortable.active && !awaitingDragStarted) {
          if (fallbackTolerance && Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) < fallbackTolerance) {
            return;
          }

          this._onDragStart(evt, true);
        }

        if (ghostEl) {
          if (ghostMatrix) {
            ghostMatrix.e += dx - (lastDx || 0);
            ghostMatrix.f += dy - (lastDy || 0);
          } else {
            ghostMatrix = {
              a: 1,
              b: 0,
              c: 0,
              d: 1,
              e: dx,
              f: dy
            };
          }

          var cssMatrix = "matrix(".concat(ghostMatrix.a, ",").concat(ghostMatrix.b, ",").concat(ghostMatrix.c, ",").concat(ghostMatrix.d, ",").concat(ghostMatrix.e, ",").concat(ghostMatrix.f, ")");
          css(ghostEl, 'webkitTransform', cssMatrix);
          css(ghostEl, 'mozTransform', cssMatrix);
          css(ghostEl, 'msTransform', cssMatrix);
          css(ghostEl, 'transform', cssMatrix);
          lastDx = dx;
          lastDy = dy;
          touchEvt = touch;
        }

        evt.cancelable && evt.preventDefault();
      }
    },
    _appendGhost: function _appendGhost() {
      // Bug if using scale(): https://stackoverflow.com/questions/2637058
      // Not being adjusted for
      if (!ghostEl) {
        var container = this.options.fallbackOnBody ? document.body : rootEl,
            rect = getRect(dragEl, true, PositionGhostAbsolutely, true, container),
            options = this.options; // Position absolutely

        if (PositionGhostAbsolutely) {
          // Get relatively positioned parent
          ghostRelativeParent = container;

          while (css(ghostRelativeParent, 'position') === 'static' && css(ghostRelativeParent, 'transform') === 'none' && ghostRelativeParent !== document) {
            ghostRelativeParent = ghostRelativeParent.parentNode;
          }

          if (ghostRelativeParent !== document.body && ghostRelativeParent !== document.documentElement) {
            if (ghostRelativeParent === document) ghostRelativeParent = getWindowScrollingElement();
            rect.top += ghostRelativeParent.scrollTop;
            rect.left += ghostRelativeParent.scrollLeft;
          } else {
            ghostRelativeParent = getWindowScrollingElement();
          }

          ghostRelativeParentInitialScroll = getRelativeScrollOffset(ghostRelativeParent);
        }

        ghostEl = dragEl.cloneNode(true);
        toggleClass(ghostEl, options.ghostClass, false);
        toggleClass(ghostEl, options.fallbackClass, true);
        toggleClass(ghostEl, options.dragClass, true);
        css(ghostEl, 'transition', '');
        css(ghostEl, 'transform', '');
        css(ghostEl, 'box-sizing', 'border-box');
        css(ghostEl, 'margin', 0);
        css(ghostEl, 'top', rect.top);
        css(ghostEl, 'left', rect.left);
        css(ghostEl, 'width', rect.width);
        css(ghostEl, 'height', rect.height);
        css(ghostEl, 'opacity', '0.8');
        css(ghostEl, 'position', PositionGhostAbsolutely ? 'absolute' : 'fixed');
        css(ghostEl, 'zIndex', '100000');
        css(ghostEl, 'pointerEvents', 'none');
        Sortable.ghost = ghostEl;
        container.appendChild(ghostEl); // Set transform-origin

        css(ghostEl, 'transform-origin', tapDistanceLeft / parseInt(ghostEl.style.width) * 100 + '% ' + tapDistanceTop / parseInt(ghostEl.style.height) * 100 + '%');
      }
    },
    _onDragStart: function _onDragStart(
    /**Event*/
    evt,
    /**boolean*/
    fallback) {
      var _this = this;

      var dataTransfer = evt.dataTransfer;
      var options = _this.options;
      pluginEvent('dragStart', this, {
        evt: evt
      });

      if (Sortable.eventCanceled) {
        this._onDrop();

        return;
      }

      pluginEvent('setupClone', this);

      if (!Sortable.eventCanceled) {
        cloneEl = clone(dragEl);
        cloneEl.removeAttribute("id");
        cloneEl.draggable = false;
        cloneEl.style['will-change'] = '';

        this._hideClone();

        toggleClass(cloneEl, this.options.chosenClass, false);
        Sortable.clone = cloneEl;
      } // #1143: IFrame support workaround


      _this.cloneId = _nextTick(function () {
        pluginEvent('clone', _this);
        if (Sortable.eventCanceled) return;

        if (!_this.options.removeCloneOnHide) {
          rootEl.insertBefore(cloneEl, dragEl);
        }

        _this._hideClone();

        _dispatchEvent({
          sortable: _this,
          name: 'clone'
        });
      });
      !fallback && toggleClass(dragEl, options.dragClass, true); // Set proper drop events

      if (fallback) {
        ignoreNextClick = true;
        _this._loopId = setInterval(_this._emulateDragOver, 50);
      } else {
        // Undo what was set in _prepareDragStart before drag started
        off(document, 'mouseup', _this._onDrop);
        off(document, 'touchend', _this._onDrop);
        off(document, 'touchcancel', _this._onDrop);

        if (dataTransfer) {
          dataTransfer.effectAllowed = 'move';
          options.setData && options.setData.call(_this, dataTransfer, dragEl);
        }

        on(document, 'drop', _this); // #1276 fix:

        css(dragEl, 'transform', 'translateZ(0)');
      }

      awaitingDragStarted = true;
      _this._dragStartId = _nextTick(_this._dragStarted.bind(_this, fallback, evt));
      on(document, 'selectstart', _this);
      moved = true;

      if (Safari) {
        css(document.body, 'user-select', 'none');
      }
    },
    // Returns true - if no further action is needed (either inserted or another condition)
    _onDragOver: function _onDragOver(
    /**Event*/
    evt) {
      var el = this.el,
          target = evt.target,
          dragRect,
          targetRect,
          revert,
          options = this.options,
          group = options.group,
          activeSortable = Sortable.active,
          isOwner = activeGroup === group,
          canSort = options.sort,
          fromSortable = putSortable || activeSortable,
          vertical,
          _this = this,
          completedFired = false;

      if (_silent) return;

      function dragOverEvent(name, extra) {
        pluginEvent(name, _this, _objectSpread2({
          evt: evt,
          isOwner: isOwner,
          axis: vertical ? 'vertical' : 'horizontal',
          revert: revert,
          dragRect: dragRect,
          targetRect: targetRect,
          canSort: canSort,
          fromSortable: fromSortable,
          target: target,
          completed: completed,
          onMove: function onMove(target, after) {
            return _onMove(rootEl, el, dragEl, dragRect, target, getRect(target), evt, after);
          },
          changed: changed
        }, extra));
      } // Capture animation state


      function capture() {
        dragOverEvent('dragOverAnimationCapture');

        _this.captureAnimationState();

        if (_this !== fromSortable) {
          fromSortable.captureAnimationState();
        }
      } // Return invocation when dragEl is inserted (or completed)


      function completed(insertion) {
        dragOverEvent('dragOverCompleted', {
          insertion: insertion
        });

        if (insertion) {
          // Clones must be hidden before folding animation to capture dragRectAbsolute properly
          if (isOwner) {
            activeSortable._hideClone();
          } else {
            activeSortable._showClone(_this);
          }

          if (_this !== fromSortable) {
            // Set ghost class to new sortable's ghost class
            toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : activeSortable.options.ghostClass, false);
            toggleClass(dragEl, options.ghostClass, true);
          }

          if (putSortable !== _this && _this !== Sortable.active) {
            putSortable = _this;
          } else if (_this === Sortable.active && putSortable) {
            putSortable = null;
          } // Animation


          if (fromSortable === _this) {
            _this._ignoreWhileAnimating = target;
          }

          _this.animateAll(function () {
            dragOverEvent('dragOverAnimationComplete');
            _this._ignoreWhileAnimating = null;
          });

          if (_this !== fromSortable) {
            fromSortable.animateAll();
            fromSortable._ignoreWhileAnimating = null;
          }
        } // Null lastTarget if it is not inside a previously swapped element


        if (target === dragEl && !dragEl.animated || target === el && !target.animated) {
          lastTarget = null;
        } // no bubbling and not fallback


        if (!options.dragoverBubble && !evt.rootEl && target !== document) {
          dragEl.parentNode[expando]._isOutsideThisEl(evt.target); // Do not detect for empty insert if already inserted


          !insertion && nearestEmptyInsertDetectEvent(evt);
        }

        !options.dragoverBubble && evt.stopPropagation && evt.stopPropagation();
        return completedFired = true;
      } // Call when dragEl has been inserted


      function changed() {
        newIndex = index(dragEl);
        newDraggableIndex = index(dragEl, options.draggable);

        _dispatchEvent({
          sortable: _this,
          name: 'change',
          toEl: el,
          newIndex: newIndex,
          newDraggableIndex: newDraggableIndex,
          originalEvent: evt
        });
      }

      if (evt.preventDefault !== void 0) {
        evt.cancelable && evt.preventDefault();
      }

      target = closest(target, options.draggable, el, true);
      dragOverEvent('dragOver');
      if (Sortable.eventCanceled) return completedFired;

      if (dragEl.contains(evt.target) || target.animated && target.animatingX && target.animatingY || _this._ignoreWhileAnimating === target) {
        return completed(false);
      }

      ignoreNextClick = false;

      if (activeSortable && !options.disabled && (isOwner ? canSort || (revert = parentEl !== rootEl) // Reverting item into the original list
      : putSortable === this || (this.lastPutMode = activeGroup.checkPull(this, activeSortable, dragEl, evt)) && group.checkPut(this, activeSortable, dragEl, evt))) {
        vertical = this._getDirection(evt, target) === 'vertical';
        dragRect = getRect(dragEl);
        dragOverEvent('dragOverValid');
        if (Sortable.eventCanceled) return completedFired;

        if (revert) {
          parentEl = rootEl; // actualization

          capture();

          this._hideClone();

          dragOverEvent('revert');

          if (!Sortable.eventCanceled) {
            if (nextEl) {
              rootEl.insertBefore(dragEl, nextEl);
            } else {
              rootEl.appendChild(dragEl);
            }
          }

          return completed(true);
        }

        var elLastChild = lastChild(el, options.draggable);

        if (!elLastChild || _ghostIsLast(evt, vertical, this) && !elLastChild.animated) {
          // Insert to end of list
          // If already at end of list: Do not insert
          if (elLastChild === dragEl) {
            return completed(false);
          } // if there is a last element, it is the target


          if (elLastChild && el === evt.target) {
            target = elLastChild;
          }

          if (target) {
            targetRect = getRect(target);
          }

          if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, !!target) !== false) {
            capture();

            if (elLastChild && elLastChild.nextSibling) {
              // the last draggable element is not the last node
              el.insertBefore(dragEl, elLastChild.nextSibling);
            } else {
              el.appendChild(dragEl);
            }

            parentEl = el; // actualization

            changed();
            return completed(true);
          }
        } else if (elLastChild && _ghostIsFirst(evt, vertical, this)) {
          // Insert to start of list
          var firstChild = getChild(el, 0, options, true);

          if (firstChild === dragEl) {
            return completed(false);
          }

          target = firstChild;
          targetRect = getRect(target);

          if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, false) !== false) {
            capture();
            el.insertBefore(dragEl, firstChild);
            parentEl = el; // actualization

            changed();
            return completed(true);
          }
        } else if (target.parentNode === el) {
          targetRect = getRect(target);
          var direction = 0,
              targetBeforeFirstSwap,
              differentLevel = dragEl.parentNode !== el,
              differentRowCol = !_dragElInRowColumn(dragEl.animated && dragEl.toRect || dragRect, target.animated && target.toRect || targetRect, vertical),
              side1 = vertical ? 'top' : 'left',
              scrolledPastTop = isScrolledPast(target, 'top', 'top') || isScrolledPast(dragEl, 'top', 'top'),
              scrollBefore = scrolledPastTop ? scrolledPastTop.scrollTop : void 0;

          if (lastTarget !== target) {
            targetBeforeFirstSwap = targetRect[side1];
            pastFirstInvertThresh = false;
            isCircumstantialInvert = !differentRowCol && options.invertSwap || differentLevel;
          }

          direction = _getSwapDirection(evt, target, targetRect, vertical, differentRowCol ? 1 : options.swapThreshold, options.invertedSwapThreshold == null ? options.swapThreshold : options.invertedSwapThreshold, isCircumstantialInvert, lastTarget === target);
          var sibling;

          if (direction !== 0) {
            // Check if target is beside dragEl in respective direction (ignoring hidden elements)
            var dragIndex = index(dragEl);

            do {
              dragIndex -= direction;
              sibling = parentEl.children[dragIndex];
            } while (sibling && (css(sibling, 'display') === 'none' || sibling === ghostEl));
          } // If dragEl is already beside target: Do not insert


          if (direction === 0 || sibling === target) {
            return completed(false);
          }

          lastTarget = target;
          lastDirection = direction;
          var nextSibling = target.nextElementSibling,
              after = false;
          after = direction === 1;

          var moveVector = _onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, after);

          if (moveVector !== false) {
            if (moveVector === 1 || moveVector === -1) {
              after = moveVector === 1;
            }

            _silent = true;
            setTimeout(_unsilent, 30);
            capture();

            if (after && !nextSibling) {
              el.appendChild(dragEl);
            } else {
              target.parentNode.insertBefore(dragEl, after ? nextSibling : target);
            } // Undo chrome's scroll adjustment (has no effect on other browsers)


            if (scrolledPastTop) {
              scrollBy(scrolledPastTop, 0, scrollBefore - scrolledPastTop.scrollTop);
            }

            parentEl = dragEl.parentNode; // actualization
            // must be done before animation

            if (targetBeforeFirstSwap !== undefined && !isCircumstantialInvert) {
              targetMoveDistance = Math.abs(targetBeforeFirstSwap - getRect(target)[side1]);
            }

            changed();
            return completed(true);
          }
        }

        if (el.contains(dragEl)) {
          return completed(false);
        }
      }

      return false;
    },
    _ignoreWhileAnimating: null,
    _offMoveEvents: function _offMoveEvents() {
      off(document, 'mousemove', this._onTouchMove);
      off(document, 'touchmove', this._onTouchMove);
      off(document, 'pointermove', this._onTouchMove);
      off(document, 'dragover', nearestEmptyInsertDetectEvent);
      off(document, 'mousemove', nearestEmptyInsertDetectEvent);
      off(document, 'touchmove', nearestEmptyInsertDetectEvent);
    },
    _offUpEvents: function _offUpEvents() {
      var ownerDocument = this.el.ownerDocument;
      off(ownerDocument, 'mouseup', this._onDrop);
      off(ownerDocument, 'touchend', this._onDrop);
      off(ownerDocument, 'pointerup', this._onDrop);
      off(ownerDocument, 'touchcancel', this._onDrop);
      off(document, 'selectstart', this);
    },
    _onDrop: function _onDrop(
    /**Event*/
    evt) {
      var el = this.el,
          options = this.options; // Get the index of the dragged element within its parent

      newIndex = index(dragEl);
      newDraggableIndex = index(dragEl, options.draggable);
      pluginEvent('drop', this, {
        evt: evt
      });
      parentEl = dragEl && dragEl.parentNode; // Get again after plugin event

      newIndex = index(dragEl);
      newDraggableIndex = index(dragEl, options.draggable);

      if (Sortable.eventCanceled) {
        this._nulling();

        return;
      }

      awaitingDragStarted = false;
      isCircumstantialInvert = false;
      pastFirstInvertThresh = false;
      clearInterval(this._loopId);
      clearTimeout(this._dragStartTimer);

      _cancelNextTick(this.cloneId);

      _cancelNextTick(this._dragStartId); // Unbind events


      if (this.nativeDraggable) {
        off(document, 'drop', this);
        off(el, 'dragstart', this._onDragStart);
      }

      this._offMoveEvents();

      this._offUpEvents();

      if (Safari) {
        css(document.body, 'user-select', '');
      }

      css(dragEl, 'transform', '');

      if (evt) {
        if (moved) {
          evt.cancelable && evt.preventDefault();
          !options.dropBubble && evt.stopPropagation();
        }

        ghostEl && ghostEl.parentNode && ghostEl.parentNode.removeChild(ghostEl);

        if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== 'clone') {
          // Remove clone(s)
          cloneEl && cloneEl.parentNode && cloneEl.parentNode.removeChild(cloneEl);
        }

        if (dragEl) {
          if (this.nativeDraggable) {
            off(dragEl, 'dragend', this);
          }

          _disableDraggable(dragEl);

          dragEl.style['will-change'] = ''; // Remove classes
          // ghostClass is added in dragStarted

          if (moved && !awaitingDragStarted) {
            toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : this.options.ghostClass, false);
          }

          toggleClass(dragEl, this.options.chosenClass, false); // Drag stop event

          _dispatchEvent({
            sortable: this,
            name: 'unchoose',
            toEl: parentEl,
            newIndex: null,
            newDraggableIndex: null,
            originalEvent: evt
          });

          if (rootEl !== parentEl) {
            if (newIndex >= 0) {
              // Add event
              _dispatchEvent({
                rootEl: parentEl,
                name: 'add',
                toEl: parentEl,
                fromEl: rootEl,
                originalEvent: evt
              }); // Remove event


              _dispatchEvent({
                sortable: this,
                name: 'remove',
                toEl: parentEl,
                originalEvent: evt
              }); // drag from one list and drop into another


              _dispatchEvent({
                rootEl: parentEl,
                name: 'sort',
                toEl: parentEl,
                fromEl: rootEl,
                originalEvent: evt
              });

              _dispatchEvent({
                sortable: this,
                name: 'sort',
                toEl: parentEl,
                originalEvent: evt
              });
            }

            putSortable && putSortable.save();
          } else {
            if (newIndex !== oldIndex) {
              if (newIndex >= 0) {
                // drag & drop within the same list
                _dispatchEvent({
                  sortable: this,
                  name: 'update',
                  toEl: parentEl,
                  originalEvent: evt
                });

                _dispatchEvent({
                  sortable: this,
                  name: 'sort',
                  toEl: parentEl,
                  originalEvent: evt
                });
              }
            }
          }

          if (Sortable.active) {
            /* jshint eqnull:true */
            if (newIndex == null || newIndex === -1) {
              newIndex = oldIndex;
              newDraggableIndex = oldDraggableIndex;
            }

            _dispatchEvent({
              sortable: this,
              name: 'end',
              toEl: parentEl,
              originalEvent: evt
            }); // Save sorting


            this.save();
          }
        }
      }

      this._nulling();
    },
    _nulling: function _nulling() {
      pluginEvent('nulling', this);
      rootEl = dragEl = parentEl = ghostEl = nextEl = cloneEl = lastDownEl = cloneHidden = tapEvt = touchEvt = moved = newIndex = newDraggableIndex = oldIndex = oldDraggableIndex = lastTarget = lastDirection = putSortable = activeGroup = Sortable.dragged = Sortable.ghost = Sortable.clone = Sortable.active = null;
      savedInputChecked.forEach(function (el) {
        el.checked = true;
      });
      savedInputChecked.length = lastDx = lastDy = 0;
    },
    handleEvent: function handleEvent(
    /**Event*/
    evt) {
      switch (evt.type) {
        case 'drop':
        case 'dragend':
          this._onDrop(evt);

          break;

        case 'dragenter':
        case 'dragover':
          if (dragEl) {
            this._onDragOver(evt);

            _globalDragOver(evt);
          }

          break;

        case 'selectstart':
          evt.preventDefault();
          break;
      }
    },

    /**
     * Serializes the item into an array of string.
     * @returns {String[]}
     */
    toArray: function toArray() {
      var order = [],
          el,
          children = this.el.children,
          i = 0,
          n = children.length,
          options = this.options;

      for (; i < n; i++) {
        el = children[i];

        if (closest(el, options.draggable, this.el, false)) {
          order.push(el.getAttribute(options.dataIdAttr) || _generateId(el));
        }
      }

      return order;
    },

    /**
     * Sorts the elements according to the array.
     * @param  {String[]}  order  order of the items
     */
    sort: function sort(order, useAnimation) {
      var items = {},
          rootEl = this.el;
      this.toArray().forEach(function (id, i) {
        var el = rootEl.children[i];

        if (closest(el, this.options.draggable, rootEl, false)) {
          items[id] = el;
        }
      }, this);
      useAnimation && this.captureAnimationState();
      order.forEach(function (id) {
        if (items[id]) {
          rootEl.removeChild(items[id]);
          rootEl.appendChild(items[id]);
        }
      });
      useAnimation && this.animateAll();
    },

    /**
     * Save the current sorting
     */
    save: function save() {
      var store = this.options.store;
      store && store.set && store.set(this);
    },

    /**
     * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
     * @param   {HTMLElement}  el
     * @param   {String}       [selector]  default: `options.draggable`
     * @returns {HTMLElement|null}
     */
    closest: function closest$1(el, selector) {
      return closest(el, selector || this.options.draggable, this.el, false);
    },

    /**
     * Set/get option
     * @param   {string} name
     * @param   {*}      [value]
     * @returns {*}
     */
    option: function option(name, value) {
      var options = this.options;

      if (value === void 0) {
        return options[name];
      } else {
        var modifiedValue = PluginManager.modifyOption(this, name, value);

        if (typeof modifiedValue !== 'undefined') {
          options[name] = modifiedValue;
        } else {
          options[name] = value;
        }

        if (name === 'group') {
          _prepareGroup(options);
        }
      }
    },

    /**
     * Destroy
     */
    destroy: function destroy() {
      pluginEvent('destroy', this);
      var el = this.el;
      el[expando] = null;
      off(el, 'mousedown', this._onTapStart);
      off(el, 'touchstart', this._onTapStart);
      off(el, 'pointerdown', this._onTapStart);

      if (this.nativeDraggable) {
        off(el, 'dragover', this);
        off(el, 'dragenter', this);
      } // Remove draggable attributes


      Array.prototype.forEach.call(el.querySelectorAll('[draggable]'), function (el) {
        el.removeAttribute('draggable');
      });

      this._onDrop();

      this._disableDelayedDragEvents();

      sortables.splice(sortables.indexOf(this.el), 1);
      this.el = el = null;
    },
    _hideClone: function _hideClone() {
      if (!cloneHidden) {
        pluginEvent('hideClone', this);
        if (Sortable.eventCanceled) return;
        css(cloneEl, 'display', 'none');

        if (this.options.removeCloneOnHide && cloneEl.parentNode) {
          cloneEl.parentNode.removeChild(cloneEl);
        }

        cloneHidden = true;
      }
    },
    _showClone: function _showClone(putSortable) {
      if (putSortable.lastPutMode !== 'clone') {
        this._hideClone();

        return;
      }

      if (cloneHidden) {
        pluginEvent('showClone', this);
        if (Sortable.eventCanceled) return; // show clone at dragEl or original position

        if (dragEl.parentNode == rootEl && !this.options.group.revertClone) {
          rootEl.insertBefore(cloneEl, dragEl);
        } else if (nextEl) {
          rootEl.insertBefore(cloneEl, nextEl);
        } else {
          rootEl.appendChild(cloneEl);
        }

        if (this.options.group.revertClone) {
          this.animate(dragEl, cloneEl);
        }

        css(cloneEl, 'display', '');
        cloneHidden = false;
      }
    }
  };

  function _globalDragOver(
  /**Event*/
  evt) {
    if (evt.dataTransfer) {
      evt.dataTransfer.dropEffect = 'move';
    }

    evt.cancelable && evt.preventDefault();
  }

  function _onMove(fromEl, toEl, dragEl, dragRect, targetEl, targetRect, originalEvent, willInsertAfter) {
    var evt,
        sortable = fromEl[expando],
        onMoveFn = sortable.options.onMove,
        retVal; // Support for new CustomEvent feature

    if (window.CustomEvent && !IE11OrLess && !Edge) {
      evt = new CustomEvent('move', {
        bubbles: true,
        cancelable: true
      });
    } else {
      evt = document.createEvent('Event');
      evt.initEvent('move', true, true);
    }

    evt.to = toEl;
    evt.from = fromEl;
    evt.dragged = dragEl;
    evt.draggedRect = dragRect;
    evt.related = targetEl || toEl;
    evt.relatedRect = targetRect || getRect(toEl);
    evt.willInsertAfter = willInsertAfter;
    evt.originalEvent = originalEvent;
    fromEl.dispatchEvent(evt);

    if (onMoveFn) {
      retVal = onMoveFn.call(sortable, evt, originalEvent);
    }

    return retVal;
  }

  function _disableDraggable(el) {
    el.draggable = false;
  }

  function _unsilent() {
    _silent = false;
  }

  function _ghostIsFirst(evt, vertical, sortable) {
    var rect = getRect(getChild(sortable.el, 0, sortable.options, true));
    var spacer = 10;
    return vertical ? evt.clientX < rect.left - spacer || evt.clientY < rect.top && evt.clientX < rect.right : evt.clientY < rect.top - spacer || evt.clientY < rect.bottom && evt.clientX < rect.left;
  }

  function _ghostIsLast(evt, vertical, sortable) {
    var rect = getRect(lastChild(sortable.el, sortable.options.draggable));
    var spacer = 10;
    return vertical ? evt.clientX > rect.right + spacer || evt.clientX <= rect.right && evt.clientY > rect.bottom && evt.clientX >= rect.left : evt.clientX > rect.right && evt.clientY > rect.top || evt.clientX <= rect.right && evt.clientY > rect.bottom + spacer;
  }

  function _getSwapDirection(evt, target, targetRect, vertical, swapThreshold, invertedSwapThreshold, invertSwap, isLastTarget) {
    var mouseOnAxis = vertical ? evt.clientY : evt.clientX,
        targetLength = vertical ? targetRect.height : targetRect.width,
        targetS1 = vertical ? targetRect.top : targetRect.left,
        targetS2 = vertical ? targetRect.bottom : targetRect.right,
        invert = false;

    if (!invertSwap) {
      // Never invert or create dragEl shadow when target movemenet causes mouse to move past the end of regular swapThreshold
      if (isLastTarget && targetMoveDistance < targetLength * swapThreshold) {
        // multiplied only by swapThreshold because mouse will already be inside target by (1 - threshold) * targetLength / 2
        // check if past first invert threshold on side opposite of lastDirection
        if (!pastFirstInvertThresh && (lastDirection === 1 ? mouseOnAxis > targetS1 + targetLength * invertedSwapThreshold / 2 : mouseOnAxis < targetS2 - targetLength * invertedSwapThreshold / 2)) {
          // past first invert threshold, do not restrict inverted threshold to dragEl shadow
          pastFirstInvertThresh = true;
        }

        if (!pastFirstInvertThresh) {
          // dragEl shadow (target move distance shadow)
          if (lastDirection === 1 ? mouseOnAxis < targetS1 + targetMoveDistance // over dragEl shadow
          : mouseOnAxis > targetS2 - targetMoveDistance) {
            return -lastDirection;
          }
        } else {
          invert = true;
        }
      } else {
        // Regular
        if (mouseOnAxis > targetS1 + targetLength * (1 - swapThreshold) / 2 && mouseOnAxis < targetS2 - targetLength * (1 - swapThreshold) / 2) {
          return _getInsertDirection(target);
        }
      }
    }

    invert = invert || invertSwap;

    if (invert) {
      // Invert of regular
      if (mouseOnAxis < targetS1 + targetLength * invertedSwapThreshold / 2 || mouseOnAxis > targetS2 - targetLength * invertedSwapThreshold / 2) {
        return mouseOnAxis > targetS1 + targetLength / 2 ? 1 : -1;
      }
    }

    return 0;
  }
  /**
   * Gets the direction dragEl must be swapped relative to target in order to make it
   * seem that dragEl has been "inserted" into that element's position
   * @param  {HTMLElement} target       The target whose position dragEl is being inserted at
   * @return {Number}                   Direction dragEl must be swapped
   */


  function _getInsertDirection(target) {
    if (index(dragEl) < index(target)) {
      return 1;
    } else {
      return -1;
    }
  }
  /**
   * Generate id
   * @param   {HTMLElement} el
   * @returns {String}
   * @private
   */


  function _generateId(el) {
    var str = el.tagName + el.className + el.src + el.href + el.textContent,
        i = str.length,
        sum = 0;

    while (i--) {
      sum += str.charCodeAt(i);
    }

    return sum.toString(36);
  }

  function _saveInputCheckedState(root) {
    savedInputChecked.length = 0;
    var inputs = root.getElementsByTagName('input');
    var idx = inputs.length;

    while (idx--) {
      var el = inputs[idx];
      el.checked && savedInputChecked.push(el);
    }
  }

  function _nextTick(fn) {
    return setTimeout(fn, 0);
  }

  function _cancelNextTick(id) {
    return clearTimeout(id);
  } // Fixed #973:


  if (documentExists) {
    on(document, 'touchmove', function (evt) {
      if ((Sortable.active || awaitingDragStarted) && evt.cancelable) {
        evt.preventDefault();
      }
    });
  } // Export utils


  Sortable.utils = {
    on: on,
    off: off,
    css: css,
    find: find,
    is: function is(el, selector) {
      return !!closest(el, selector, el, false);
    },
    extend: extend,
    throttle: throttle,
    closest: closest,
    toggleClass: toggleClass,
    clone: clone,
    index: index,
    nextTick: _nextTick,
    cancelNextTick: _cancelNextTick,
    detectDirection: _detectDirection,
    getChild: getChild
  };
  /**
   * Get the Sortable instance of an element
   * @param  {HTMLElement} element The element
   * @return {Sortable|undefined}         The instance of Sortable
   */

  Sortable.get = function (element) {
    return element[expando];
  };
  /**
   * Mount a plugin to Sortable
   * @param  {...SortablePlugin|SortablePlugin[]} plugins       Plugins being mounted
   */


  Sortable.mount = function () {
    for (var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++) {
      plugins[_key] = arguments[_key];
    }

    if (plugins[0].constructor === Array) plugins = plugins[0];
    plugins.forEach(function (plugin) {
      if (!plugin.prototype || !plugin.prototype.constructor) {
        throw "Sortable: Mounted plugin must be a constructor function, not ".concat({}.toString.call(plugin));
      }

      if (plugin.utils) Sortable.utils = _objectSpread2(_objectSpread2({}, Sortable.utils), plugin.utils);
      PluginManager.mount(plugin);
    });
  };
  /**
   * Create sortable instance
   * @param {HTMLElement}  el
   * @param {Object}      [options]
   */


  Sortable.create = function (el, options) {
    return new Sortable(el, options);
  }; // Export


  Sortable.version = version;
  var autoScrolls = [],
      scrollEl,
      scrollRootEl,
      scrolling = false,
      lastAutoScrollX,
      lastAutoScrollY,
      touchEvt$1,
      pointerElemChangedInterval;

  function AutoScrollPlugin() {
    function AutoScroll() {
      this.defaults = {
        scroll: true,
        forceAutoScrollFallback: false,
        scrollSensitivity: 30,
        scrollSpeed: 10,
        bubbleScroll: true
      }; // Bind all private methods

      for (var fn in this) {
        if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
          this[fn] = this[fn].bind(this);
        }
      }
    }

    AutoScroll.prototype = {
      dragStarted: function dragStarted(_ref) {
        var originalEvent = _ref.originalEvent;

        if (this.sortable.nativeDraggable) {
          on(document, 'dragover', this._handleAutoScroll);
        } else {
          if (this.options.supportPointer) {
            on(document, 'pointermove', this._handleFallbackAutoScroll);
          } else if (originalEvent.touches) {
            on(document, 'touchmove', this._handleFallbackAutoScroll);
          } else {
            on(document, 'mousemove', this._handleFallbackAutoScroll);
          }
        }
      },
      dragOverCompleted: function dragOverCompleted(_ref2) {
        var originalEvent = _ref2.originalEvent; // For when bubbling is canceled and using fallback (fallback 'touchmove' always reached)

        if (!this.options.dragOverBubble && !originalEvent.rootEl) {
          this._handleAutoScroll(originalEvent);
        }
      },
      drop: function drop() {
        if (this.sortable.nativeDraggable) {
          off(document, 'dragover', this._handleAutoScroll);
        } else {
          off(document, 'pointermove', this._handleFallbackAutoScroll);
          off(document, 'touchmove', this._handleFallbackAutoScroll);
          off(document, 'mousemove', this._handleFallbackAutoScroll);
        }

        clearPointerElemChangedInterval();
        clearAutoScrolls();
        cancelThrottle();
      },
      nulling: function nulling() {
        touchEvt$1 = scrollRootEl = scrollEl = scrolling = pointerElemChangedInterval = lastAutoScrollX = lastAutoScrollY = null;
        autoScrolls.length = 0;
      },
      _handleFallbackAutoScroll: function _handleFallbackAutoScroll(evt) {
        this._handleAutoScroll(evt, true);
      },
      _handleAutoScroll: function _handleAutoScroll(evt, fallback) {
        var _this = this;

        var x = (evt.touches ? evt.touches[0] : evt).clientX,
            y = (evt.touches ? evt.touches[0] : evt).clientY,
            elem = document.elementFromPoint(x, y);
        touchEvt$1 = evt; // IE does not seem to have native autoscroll,
        // Edge's autoscroll seems too conditional,
        // MACOS Safari does not have autoscroll,
        // Firefox and Chrome are good

        if (fallback || this.options.forceAutoScrollFallback || Edge || IE11OrLess || Safari) {
          autoScroll(evt, this.options, elem, fallback); // Listener for pointer element change

          var ogElemScroller = getParentAutoScrollElement(elem, true);

          if (scrolling && (!pointerElemChangedInterval || x !== lastAutoScrollX || y !== lastAutoScrollY)) {
            pointerElemChangedInterval && clearPointerElemChangedInterval(); // Detect for pointer elem change, emulating native DnD behaviour

            pointerElemChangedInterval = setInterval(function () {
              var newElem = getParentAutoScrollElement(document.elementFromPoint(x, y), true);

              if (newElem !== ogElemScroller) {
                ogElemScroller = newElem;
                clearAutoScrolls();
              }

              autoScroll(evt, _this.options, newElem, fallback);
            }, 10);
            lastAutoScrollX = x;
            lastAutoScrollY = y;
          }
        } else {
          // if DnD is enabled (and browser has good autoscrolling), first autoscroll will already scroll, so get parent autoscroll of first autoscroll
          if (!this.options.bubbleScroll || getParentAutoScrollElement(elem, true) === getWindowScrollingElement()) {
            clearAutoScrolls();
            return;
          }

          autoScroll(evt, this.options, getParentAutoScrollElement(elem, false), false);
        }
      }
    };
    return _extends(AutoScroll, {
      pluginName: 'scroll',
      initializeByDefault: true
    });
  }

  function clearAutoScrolls() {
    autoScrolls.forEach(function (autoScroll) {
      clearInterval(autoScroll.pid);
    });
    autoScrolls = [];
  }

  function clearPointerElemChangedInterval() {
    clearInterval(pointerElemChangedInterval);
  }

  var autoScroll = throttle(function (evt, options, rootEl, isFallback) {
    // Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=505521
    if (!options.scroll) return;
    var x = (evt.touches ? evt.touches[0] : evt).clientX,
        y = (evt.touches ? evt.touches[0] : evt).clientY,
        sens = options.scrollSensitivity,
        speed = options.scrollSpeed,
        winScroller = getWindowScrollingElement();
    var scrollThisInstance = false,
        scrollCustomFn; // New scroll root, set scrollEl

    if (scrollRootEl !== rootEl) {
      scrollRootEl = rootEl;
      clearAutoScrolls();
      scrollEl = options.scroll;
      scrollCustomFn = options.scrollFn;

      if (scrollEl === true) {
        scrollEl = getParentAutoScrollElement(rootEl, true);
      }
    }

    var layersOut = 0;
    var currentParent = scrollEl;

    do {
      var el = currentParent,
          rect = getRect(el),
          top = rect.top,
          bottom = rect.bottom,
          left = rect.left,
          right = rect.right,
          width = rect.width,
          height = rect.height,
          canScrollX = void 0,
          canScrollY = void 0,
          scrollWidth = el.scrollWidth,
          scrollHeight = el.scrollHeight,
          elCSS = css(el),
          scrollPosX = el.scrollLeft,
          scrollPosY = el.scrollTop;

      if (el === winScroller) {
        canScrollX = width < scrollWidth && (elCSS.overflowX === 'auto' || elCSS.overflowX === 'scroll' || elCSS.overflowX === 'visible');
        canScrollY = height < scrollHeight && (elCSS.overflowY === 'auto' || elCSS.overflowY === 'scroll' || elCSS.overflowY === 'visible');
      } else {
        canScrollX = width < scrollWidth && (elCSS.overflowX === 'auto' || elCSS.overflowX === 'scroll');
        canScrollY = height < scrollHeight && (elCSS.overflowY === 'auto' || elCSS.overflowY === 'scroll');
      }

      var vx = canScrollX && (Math.abs(right - x) <= sens && scrollPosX + width < scrollWidth) - (Math.abs(left - x) <= sens && !!scrollPosX);
      var vy = canScrollY && (Math.abs(bottom - y) <= sens && scrollPosY + height < scrollHeight) - (Math.abs(top - y) <= sens && !!scrollPosY);

      if (!autoScrolls[layersOut]) {
        for (var i = 0; i <= layersOut; i++) {
          if (!autoScrolls[i]) {
            autoScrolls[i] = {};
          }
        }
      }

      if (autoScrolls[layersOut].vx != vx || autoScrolls[layersOut].vy != vy || autoScrolls[layersOut].el !== el) {
        autoScrolls[layersOut].el = el;
        autoScrolls[layersOut].vx = vx;
        autoScrolls[layersOut].vy = vy;
        clearInterval(autoScrolls[layersOut].pid);

        if (vx != 0 || vy != 0) {
          scrollThisInstance = true;
          /* jshint loopfunc:true */

          autoScrolls[layersOut].pid = setInterval(function () {
            // emulate drag over during autoscroll (fallback), emulating native DnD behaviour
            if (isFallback && this.layer === 0) {
              Sortable.active._onTouchMove(touchEvt$1); // To move ghost if it is positioned absolutely

            }

            var scrollOffsetY = autoScrolls[this.layer].vy ? autoScrolls[this.layer].vy * speed : 0;
            var scrollOffsetX = autoScrolls[this.layer].vx ? autoScrolls[this.layer].vx * speed : 0;

            if (typeof scrollCustomFn === 'function') {
              if (scrollCustomFn.call(Sortable.dragged.parentNode[expando], scrollOffsetX, scrollOffsetY, evt, touchEvt$1, autoScrolls[this.layer].el) !== 'continue') {
                return;
              }
            }

            scrollBy(autoScrolls[this.layer].el, scrollOffsetX, scrollOffsetY);
          }.bind({
            layer: layersOut
          }), 24);
        }
      }

      layersOut++;
    } while (options.bubbleScroll && currentParent !== winScroller && (currentParent = getParentAutoScrollElement(currentParent, false)));

    scrolling = scrollThisInstance; // in case another function catches scrolling as false in between when it is not
  }, 30);

  var drop = function drop(_ref) {
    var originalEvent = _ref.originalEvent,
        putSortable = _ref.putSortable,
        dragEl = _ref.dragEl,
        activeSortable = _ref.activeSortable,
        dispatchSortableEvent = _ref.dispatchSortableEvent,
        hideGhostForTarget = _ref.hideGhostForTarget,
        unhideGhostForTarget = _ref.unhideGhostForTarget;
    if (!originalEvent) return;
    var toSortable = putSortable || activeSortable;
    hideGhostForTarget();
    var touch = originalEvent.changedTouches && originalEvent.changedTouches.length ? originalEvent.changedTouches[0] : originalEvent;
    var target = document.elementFromPoint(touch.clientX, touch.clientY);
    unhideGhostForTarget();

    if (toSortable && !toSortable.el.contains(target)) {
      dispatchSortableEvent('spill');
      this.onSpill({
        dragEl: dragEl,
        putSortable: putSortable
      });
    }
  };

  function Revert() {}

  Revert.prototype = {
    startIndex: null,
    dragStart: function dragStart(_ref2) {
      var oldDraggableIndex = _ref2.oldDraggableIndex;
      this.startIndex = oldDraggableIndex;
    },
    onSpill: function onSpill(_ref3) {
      var dragEl = _ref3.dragEl,
          putSortable = _ref3.putSortable;
      this.sortable.captureAnimationState();

      if (putSortable) {
        putSortable.captureAnimationState();
      }

      var nextSibling = getChild(this.sortable.el, this.startIndex, this.options);

      if (nextSibling) {
        this.sortable.el.insertBefore(dragEl, nextSibling);
      } else {
        this.sortable.el.appendChild(dragEl);
      }

      this.sortable.animateAll();

      if (putSortable) {
        putSortable.animateAll();
      }
    },
    drop: drop
  };

  _extends(Revert, {
    pluginName: 'revertOnSpill'
  });

  function Remove() {}

  Remove.prototype = {
    onSpill: function onSpill(_ref4) {
      var dragEl = _ref4.dragEl,
          putSortable = _ref4.putSortable;
      var parentSortable = putSortable || this.sortable;
      parentSortable.captureAnimationState();
      dragEl.parentNode && dragEl.parentNode.removeChild(dragEl);
      parentSortable.animateAll();
    },
    drop: drop
  };

  _extends(Remove, {
    pluginName: 'removeOnSpill'
  });

  var lastSwapEl;

  function SwapPlugin() {
    function Swap() {
      this.defaults = {
        swapClass: 'sortable-swap-highlight'
      };
    }

    Swap.prototype = {
      dragStart: function dragStart(_ref) {
        var dragEl = _ref.dragEl;
        lastSwapEl = dragEl;
      },
      dragOverValid: function dragOverValid(_ref2) {
        var completed = _ref2.completed,
            target = _ref2.target,
            onMove = _ref2.onMove,
            activeSortable = _ref2.activeSortable,
            changed = _ref2.changed,
            cancel = _ref2.cancel;
        if (!activeSortable.options.swap) return;
        var el = this.sortable.el,
            options = this.options;

        if (target && target !== el) {
          var prevSwapEl = lastSwapEl;

          if (onMove(target) !== false) {
            toggleClass(target, options.swapClass, true);
            lastSwapEl = target;
          } else {
            lastSwapEl = null;
          }

          if (prevSwapEl && prevSwapEl !== lastSwapEl) {
            toggleClass(prevSwapEl, options.swapClass, false);
          }
        }

        changed();
        completed(true);
        cancel();
      },
      drop: function drop(_ref3) {
        var activeSortable = _ref3.activeSortable,
            putSortable = _ref3.putSortable,
            dragEl = _ref3.dragEl;
        var toSortable = putSortable || this.sortable;
        var options = this.options;
        lastSwapEl && toggleClass(lastSwapEl, options.swapClass, false);

        if (lastSwapEl && (options.swap || putSortable && putSortable.options.swap)) {
          if (dragEl !== lastSwapEl) {
            toSortable.captureAnimationState();
            if (toSortable !== activeSortable) activeSortable.captureAnimationState();
            swapNodes(dragEl, lastSwapEl);
            toSortable.animateAll();
            if (toSortable !== activeSortable) activeSortable.animateAll();
          }
        }
      },
      nulling: function nulling() {
        lastSwapEl = null;
      }
    };
    return _extends(Swap, {
      pluginName: 'swap',
      eventProperties: function eventProperties() {
        return {
          swapItem: lastSwapEl
        };
      }
    });
  }

  function swapNodes(n1, n2) {
    var p1 = n1.parentNode,
        p2 = n2.parentNode,
        i1,
        i2;
    if (!p1 || !p2 || p1.isEqualNode(n2) || p2.isEqualNode(n1)) return;
    i1 = index(n1);
    i2 = index(n2);

    if (p1.isEqualNode(p2) && i1 < i2) {
      i2++;
    }

    p1.insertBefore(n2, p1.children[i1]);
    p2.insertBefore(n1, p2.children[i2]);
  }

  var multiDragElements = [],
      multiDragClones = [],
      lastMultiDragSelect,
      // for selection with modifier key down (SHIFT)
  multiDragSortable,
      initialFolding = false,
      // Initial multi-drag fold when drag started
  folding = false,
      // Folding any other time
  dragStarted = false,
      dragEl$1,
      clonesFromRect,
      clonesHidden;

  function MultiDragPlugin() {
    function MultiDrag(sortable) {
      // Bind all private methods
      for (var fn in this) {
        if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
          this[fn] = this[fn].bind(this);
        }
      }

      if (!sortable.options.avoidImplicitDeselect) {
        if (sortable.options.supportPointer) {
          on(document, 'pointerup', this._deselectMultiDrag);
        } else {
          on(document, 'mouseup', this._deselectMultiDrag);
          on(document, 'touchend', this._deselectMultiDrag);
        }
      }

      on(document, 'keydown', this._checkKeyDown);
      on(document, 'keyup', this._checkKeyUp);
      this.defaults = {
        selectedClass: 'sortable-selected',
        multiDragKey: null,
        avoidImplicitDeselect: false,
        setData: function setData(dataTransfer, dragEl) {
          var data = '';

          if (multiDragElements.length && multiDragSortable === sortable) {
            multiDragElements.forEach(function (multiDragElement, i) {
              data += (!i ? '' : ', ') + multiDragElement.textContent;
            });
          } else {
            data = dragEl.textContent;
          }

          dataTransfer.setData('Text', data);
        }
      };
    }

    MultiDrag.prototype = {
      multiDragKeyDown: false,
      isMultiDrag: false,
      delayStartGlobal: function delayStartGlobal(_ref) {
        var dragged = _ref.dragEl;
        dragEl$1 = dragged;
      },
      delayEnded: function delayEnded() {
        this.isMultiDrag = ~multiDragElements.indexOf(dragEl$1);
      },
      setupClone: function setupClone(_ref2) {
        var sortable = _ref2.sortable,
            cancel = _ref2.cancel;
        if (!this.isMultiDrag) return;

        for (var i = 0; i < multiDragElements.length; i++) {
          multiDragClones.push(clone(multiDragElements[i]));
          multiDragClones[i].sortableIndex = multiDragElements[i].sortableIndex;
          multiDragClones[i].draggable = false;
          multiDragClones[i].style['will-change'] = '';
          toggleClass(multiDragClones[i], this.options.selectedClass, false);
          multiDragElements[i] === dragEl$1 && toggleClass(multiDragClones[i], this.options.chosenClass, false);
        }

        sortable._hideClone();

        cancel();
      },
      clone: function clone(_ref3) {
        var sortable = _ref3.sortable,
            rootEl = _ref3.rootEl,
            dispatchSortableEvent = _ref3.dispatchSortableEvent,
            cancel = _ref3.cancel;
        if (!this.isMultiDrag) return;

        if (!this.options.removeCloneOnHide) {
          if (multiDragElements.length && multiDragSortable === sortable) {
            insertMultiDragClones(true, rootEl);
            dispatchSortableEvent('clone');
            cancel();
          }
        }
      },
      showClone: function showClone(_ref4) {
        var cloneNowShown = _ref4.cloneNowShown,
            rootEl = _ref4.rootEl,
            cancel = _ref4.cancel;
        if (!this.isMultiDrag) return;
        insertMultiDragClones(false, rootEl);
        multiDragClones.forEach(function (clone) {
          css(clone, 'display', '');
        });
        cloneNowShown();
        clonesHidden = false;
        cancel();
      },
      hideClone: function hideClone(_ref5) {
        var _this = this;

        var sortable = _ref5.sortable,
            cloneNowHidden = _ref5.cloneNowHidden,
            cancel = _ref5.cancel;
        if (!this.isMultiDrag) return;
        multiDragClones.forEach(function (clone) {
          css(clone, 'display', 'none');

          if (_this.options.removeCloneOnHide && clone.parentNode) {
            clone.parentNode.removeChild(clone);
          }
        });
        cloneNowHidden();
        clonesHidden = true;
        cancel();
      },
      dragStartGlobal: function dragStartGlobal(_ref6) {
        var sortable = _ref6.sortable;

        if (!this.isMultiDrag && multiDragSortable) {
          multiDragSortable.multiDrag._deselectMultiDrag();
        }

        multiDragElements.forEach(function (multiDragElement) {
          multiDragElement.sortableIndex = index(multiDragElement);
        }); // Sort multi-drag elements

        multiDragElements = multiDragElements.sort(function (a, b) {
          return a.sortableIndex - b.sortableIndex;
        });
        dragStarted = true;
      },
      dragStarted: function dragStarted(_ref7) {
        var _this2 = this;

        var sortable = _ref7.sortable;
        if (!this.isMultiDrag) return;

        if (this.options.sort) {
          // Capture rects,
          // hide multi drag elements (by positioning them absolute),
          // set multi drag elements rects to dragRect,
          // show multi drag elements,
          // animate to rects,
          // unset rects & remove from DOM
          sortable.captureAnimationState();

          if (this.options.animation) {
            multiDragElements.forEach(function (multiDragElement) {
              if (multiDragElement === dragEl$1) return;
              css(multiDragElement, 'position', 'absolute');
            });
            var dragRect = getRect(dragEl$1, false, true, true);
            multiDragElements.forEach(function (multiDragElement) {
              if (multiDragElement === dragEl$1) return;
              setRect(multiDragElement, dragRect);
            });
            folding = true;
            initialFolding = true;
          }
        }

        sortable.animateAll(function () {
          folding = false;
          initialFolding = false;

          if (_this2.options.animation) {
            multiDragElements.forEach(function (multiDragElement) {
              unsetRect(multiDragElement);
            });
          } // Remove all auxiliary multidrag items from el, if sorting enabled


          if (_this2.options.sort) {
            removeMultiDragElements();
          }
        });
      },
      dragOver: function dragOver(_ref8) {
        var target = _ref8.target,
            completed = _ref8.completed,
            cancel = _ref8.cancel;

        if (folding && ~multiDragElements.indexOf(target)) {
          completed(false);
          cancel();
        }
      },
      revert: function revert(_ref9) {
        var fromSortable = _ref9.fromSortable,
            rootEl = _ref9.rootEl,
            sortable = _ref9.sortable,
            dragRect = _ref9.dragRect;

        if (multiDragElements.length > 1) {
          // Setup unfold animation
          multiDragElements.forEach(function (multiDragElement) {
            sortable.addAnimationState({
              target: multiDragElement,
              rect: folding ? getRect(multiDragElement) : dragRect
            });
            unsetRect(multiDragElement);
            multiDragElement.fromRect = dragRect;
            fromSortable.removeAnimationState(multiDragElement);
          });
          folding = false;
          insertMultiDragElements(!this.options.removeCloneOnHide, rootEl);
        }
      },
      dragOverCompleted: function dragOverCompleted(_ref10) {
        var sortable = _ref10.sortable,
            isOwner = _ref10.isOwner,
            insertion = _ref10.insertion,
            activeSortable = _ref10.activeSortable,
            parentEl = _ref10.parentEl,
            putSortable = _ref10.putSortable;
        var options = this.options;

        if (insertion) {
          // Clones must be hidden before folding animation to capture dragRectAbsolute properly
          if (isOwner) {
            activeSortable._hideClone();
          }

          initialFolding = false; // If leaving sort:false root, or already folding - Fold to new location

          if (options.animation && multiDragElements.length > 1 && (folding || !isOwner && !activeSortable.options.sort && !putSortable)) {
            // Fold: Set all multi drag elements's rects to dragEl's rect when multi-drag elements are invisible
            var dragRectAbsolute = getRect(dragEl$1, false, true, true);
            multiDragElements.forEach(function (multiDragElement) {
              if (multiDragElement === dragEl$1) return;
              setRect(multiDragElement, dragRectAbsolute); // Move element(s) to end of parentEl so that it does not interfere with multi-drag clones insertion if they are inserted
              // while folding, and so that we can capture them again because old sortable will no longer be fromSortable

              parentEl.appendChild(multiDragElement);
            });
            folding = true;
          } // Clones must be shown (and check to remove multi drags) after folding when interfering multiDragElements are moved out


          if (!isOwner) {
            // Only remove if not folding (folding will remove them anyways)
            if (!folding) {
              removeMultiDragElements();
            }

            if (multiDragElements.length > 1) {
              var clonesHiddenBefore = clonesHidden;

              activeSortable._showClone(sortable); // Unfold animation for clones if showing from hidden


              if (activeSortable.options.animation && !clonesHidden && clonesHiddenBefore) {
                multiDragClones.forEach(function (clone) {
                  activeSortable.addAnimationState({
                    target: clone,
                    rect: clonesFromRect
                  });
                  clone.fromRect = clonesFromRect;
                  clone.thisAnimationDuration = null;
                });
              }
            } else {
              activeSortable._showClone(sortable);
            }
          }
        }
      },
      dragOverAnimationCapture: function dragOverAnimationCapture(_ref11) {
        var dragRect = _ref11.dragRect,
            isOwner = _ref11.isOwner,
            activeSortable = _ref11.activeSortable;
        multiDragElements.forEach(function (multiDragElement) {
          multiDragElement.thisAnimationDuration = null;
        });

        if (activeSortable.options.animation && !isOwner && activeSortable.multiDrag.isMultiDrag) {
          clonesFromRect = _extends({}, dragRect);
          var dragMatrix = matrix(dragEl$1, true);
          clonesFromRect.top -= dragMatrix.f;
          clonesFromRect.left -= dragMatrix.e;
        }
      },
      dragOverAnimationComplete: function dragOverAnimationComplete() {
        if (folding) {
          folding = false;
          removeMultiDragElements();
        }
      },
      drop: function drop(_ref12) {
        var evt = _ref12.originalEvent,
            rootEl = _ref12.rootEl,
            parentEl = _ref12.parentEl,
            sortable = _ref12.sortable,
            dispatchSortableEvent = _ref12.dispatchSortableEvent,
            oldIndex = _ref12.oldIndex,
            putSortable = _ref12.putSortable;
        var toSortable = putSortable || this.sortable;
        if (!evt) return;
        var options = this.options,
            children = parentEl.children; // Multi-drag selection

        if (!dragStarted) {
          if (options.multiDragKey && !this.multiDragKeyDown) {
            this._deselectMultiDrag();
          }

          toggleClass(dragEl$1, options.selectedClass, !~multiDragElements.indexOf(dragEl$1));

          if (!~multiDragElements.indexOf(dragEl$1)) {
            multiDragElements.push(dragEl$1);
            dispatchEvent({
              sortable: sortable,
              rootEl: rootEl,
              name: 'select',
              targetEl: dragEl$1,
              originalEvent: evt
            }); // Modifier activated, select from last to dragEl

            if (evt.shiftKey && lastMultiDragSelect && sortable.el.contains(lastMultiDragSelect)) {
              var lastIndex = index(lastMultiDragSelect),
                  currentIndex = index(dragEl$1);

              if (~lastIndex && ~currentIndex && lastIndex !== currentIndex) {
                // Must include lastMultiDragSelect (select it), in case modified selection from no selection
                // (but previous selection existed)
                var n, i;

                if (currentIndex > lastIndex) {
                  i = lastIndex;
                  n = currentIndex;
                } else {
                  i = currentIndex;
                  n = lastIndex + 1;
                }

                for (; i < n; i++) {
                  if (~multiDragElements.indexOf(children[i])) continue;
                  toggleClass(children[i], options.selectedClass, true);
                  multiDragElements.push(children[i]);
                  dispatchEvent({
                    sortable: sortable,
                    rootEl: rootEl,
                    name: 'select',
                    targetEl: children[i],
                    originalEvent: evt
                  });
                }
              }
            } else {
              lastMultiDragSelect = dragEl$1;
            }

            multiDragSortable = toSortable;
          } else {
            multiDragElements.splice(multiDragElements.indexOf(dragEl$1), 1);
            lastMultiDragSelect = null;
            dispatchEvent({
              sortable: sortable,
              rootEl: rootEl,
              name: 'deselect',
              targetEl: dragEl$1,
              originalEvent: evt
            });
          }
        } // Multi-drag drop


        if (dragStarted && this.isMultiDrag) {
          folding = false; // Do not "unfold" after around dragEl if reverted

          if ((parentEl[expando].options.sort || parentEl !== rootEl) && multiDragElements.length > 1) {
            var dragRect = getRect(dragEl$1),
                multiDragIndex = index(dragEl$1, ':not(.' + this.options.selectedClass + ')');
            if (!initialFolding && options.animation) dragEl$1.thisAnimationDuration = null;
            toSortable.captureAnimationState();

            if (!initialFolding) {
              if (options.animation) {
                dragEl$1.fromRect = dragRect;
                multiDragElements.forEach(function (multiDragElement) {
                  multiDragElement.thisAnimationDuration = null;

                  if (multiDragElement !== dragEl$1) {
                    var rect = folding ? getRect(multiDragElement) : dragRect;
                    multiDragElement.fromRect = rect; // Prepare unfold animation

                    toSortable.addAnimationState({
                      target: multiDragElement,
                      rect: rect
                    });
                  }
                });
              } // Multi drag elements are not necessarily removed from the DOM on drop, so to reinsert
              // properly they must all be removed


              removeMultiDragElements();
              multiDragElements.forEach(function (multiDragElement) {
                if (children[multiDragIndex]) {
                  parentEl.insertBefore(multiDragElement, children[multiDragIndex]);
                } else {
                  parentEl.appendChild(multiDragElement);
                }

                multiDragIndex++;
              }); // If initial folding is done, the elements may have changed position because they are now
              // unfolding around dragEl, even though dragEl may not have his index changed, so update event
              // must be fired here as Sortable will not.

              if (oldIndex === index(dragEl$1)) {
                var update = false;
                multiDragElements.forEach(function (multiDragElement) {
                  if (multiDragElement.sortableIndex !== index(multiDragElement)) {
                    update = true;
                    return;
                  }
                });

                if (update) {
                  dispatchSortableEvent('update');
                }
              }
            } // Must be done after capturing individual rects (scroll bar)


            multiDragElements.forEach(function (multiDragElement) {
              unsetRect(multiDragElement);
            });
            toSortable.animateAll();
          }

          multiDragSortable = toSortable;
        } // Remove clones if necessary


        if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== 'clone') {
          multiDragClones.forEach(function (clone) {
            clone.parentNode && clone.parentNode.removeChild(clone);
          });
        }
      },
      nullingGlobal: function nullingGlobal() {
        this.isMultiDrag = dragStarted = false;
        multiDragClones.length = 0;
      },
      destroyGlobal: function destroyGlobal() {
        this._deselectMultiDrag();

        off(document, 'pointerup', this._deselectMultiDrag);
        off(document, 'mouseup', this._deselectMultiDrag);
        off(document, 'touchend', this._deselectMultiDrag);
        off(document, 'keydown', this._checkKeyDown);
        off(document, 'keyup', this._checkKeyUp);
      },
      _deselectMultiDrag: function _deselectMultiDrag(evt) {
        if (typeof dragStarted !== "undefined" && dragStarted) return; // Only deselect if selection is in this sortable

        if (multiDragSortable !== this.sortable) return; // Only deselect if target is not item in this sortable

        if (evt && closest(evt.target, this.options.draggable, this.sortable.el, false)) return; // Only deselect if left click

        if (evt && evt.button !== 0) return;

        while (multiDragElements.length) {
          var el = multiDragElements[0];
          toggleClass(el, this.options.selectedClass, false);
          multiDragElements.shift();
          dispatchEvent({
            sortable: this.sortable,
            rootEl: this.sortable.el,
            name: 'deselect',
            targetEl: el,
            originalEvent: evt
          });
        }
      },
      _checkKeyDown: function _checkKeyDown(evt) {
        if (evt.key === this.options.multiDragKey) {
          this.multiDragKeyDown = true;
        }
      },
      _checkKeyUp: function _checkKeyUp(evt) {
        if (evt.key === this.options.multiDragKey) {
          this.multiDragKeyDown = false;
        }
      }
    };
    return _extends(MultiDrag, {
      // Static methods & properties
      pluginName: 'multiDrag',
      utils: {
        /**
         * Selects the provided multi-drag item
         * @param  {HTMLElement} el    The element to be selected
         */
        select: function select(el) {
          var sortable = el.parentNode[expando];
          if (!sortable || !sortable.options.multiDrag || ~multiDragElements.indexOf(el)) return;

          if (multiDragSortable && multiDragSortable !== sortable) {
            multiDragSortable.multiDrag._deselectMultiDrag();

            multiDragSortable = sortable;
          }

          toggleClass(el, sortable.options.selectedClass, true);
          multiDragElements.push(el);
        },

        /**
         * Deselects the provided multi-drag item
         * @param  {HTMLElement} el    The element to be deselected
         */
        deselect: function deselect(el) {
          var sortable = el.parentNode[expando],
              index = multiDragElements.indexOf(el);
          if (!sortable || !sortable.options.multiDrag || !~index) return;
          toggleClass(el, sortable.options.selectedClass, false);
          multiDragElements.splice(index, 1);
        }
      },
      eventProperties: function eventProperties() {
        var _this3 = this;

        var oldIndicies = [],
            newIndicies = [];
        multiDragElements.forEach(function (multiDragElement) {
          oldIndicies.push({
            multiDragElement: multiDragElement,
            index: multiDragElement.sortableIndex
          }); // multiDragElements will already be sorted if folding

          var newIndex;

          if (folding && multiDragElement !== dragEl$1) {
            newIndex = -1;
          } else if (folding) {
            newIndex = index(multiDragElement, ':not(.' + _this3.options.selectedClass + ')');
          } else {
            newIndex = index(multiDragElement);
          }

          newIndicies.push({
            multiDragElement: multiDragElement,
            index: newIndex
          });
        });
        return {
          items: _toConsumableArray(multiDragElements),
          clones: [].concat(multiDragClones),
          oldIndicies: oldIndicies,
          newIndicies: newIndicies
        };
      },
      optionListeners: {
        multiDragKey: function multiDragKey(key) {
          key = key.toLowerCase();

          if (key === 'ctrl') {
            key = 'Control';
          } else if (key.length > 1) {
            key = key.charAt(0).toUpperCase() + key.substr(1);
          }

          return key;
        }
      }
    });
  }

  function insertMultiDragElements(clonesInserted, rootEl) {
    multiDragElements.forEach(function (multiDragElement, i) {
      var target = rootEl.children[multiDragElement.sortableIndex + (clonesInserted ? Number(i) : 0)];

      if (target) {
        rootEl.insertBefore(multiDragElement, target);
      } else {
        rootEl.appendChild(multiDragElement);
      }
    });
  }
  /**
   * Insert multi-drag clones
   * @param  {[Boolean]} elementsInserted  Whether the multi-drag elements are inserted
   * @param  {HTMLElement} rootEl
   */


  function insertMultiDragClones(elementsInserted, rootEl) {
    multiDragClones.forEach(function (clone, i) {
      var target = rootEl.children[clone.sortableIndex + (elementsInserted ? Number(i) : 0)];

      if (target) {
        rootEl.insertBefore(clone, target);
      } else {
        rootEl.appendChild(clone);
      }
    });
  }

  function removeMultiDragElements() {
    multiDragElements.forEach(function (multiDragElement) {
      if (multiDragElement === dragEl$1) return;
      multiDragElement.parentNode && multiDragElement.parentNode.removeChild(multiDragElement);
    });
  }

  Sortable.mount(new AutoScrollPlugin());
  Sortable.mount(Remove, Revert);
  /* harmony default export */

  __webpack_exports__["default"] = Sortable;
  /***/
},
/* 42 */

/***/
function (module, exports) {
  module.exports = function (module) {
    if (!module.webpackPolyfill) {
      module.deprecate = function () {};

      module.paths = []; // module.parent = undefined by default

      if (!module.children) module.children = [];
      Object.defineProperty(module, "loaded", {
        enumerable: true,
        get: function get() {
          return module.l;
        }
      });
      Object.defineProperty(module, "id", {
        enumerable: true,
        get: function get() {
          return module.i;
        }
      });
      module.webpackPolyfill = 1;
    }

    return module;
  };
  /***/

},
/* 43 */

/***/
function (module, exports, __webpack_require__) {
  var root = __webpack_require__(15);
  /**
   * Gets the timestamp of the number of milliseconds that have elapsed since
   * the Unix epoch (1 January 1970 00:00:00 UTC).
   *
   * @static
   * @memberOf _
   * @since 2.4.0
   * @category Date
   * @returns {number} Returns the timestamp.
   * @example
   *
   * _.defer(function(stamp) {
   *   console.log(_.now() - stamp);
   * }, _.now());
   * // => Logs the number of milliseconds it took for the deferred invocation.
   */


  var now = function now() {
    return root.Date.now();
  };

  module.exports = now;
  /***/
},
/* 44 */

/***/
function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */
  (function (global) {
    function _typeof(obj) {
      "@babel/helpers - typeof";

      return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      }, _typeof(obj);
    }
    /** Detect free variable `global` from Node.js. */


    var freeGlobal = (typeof global === "undefined" ? "undefined" : _typeof(global)) == 'object' && global && global.Object === Object && global;
    module.exports = freeGlobal;
    /* WEBPACK VAR INJECTION */
  }).call(this, __webpack_require__(45));
  /***/
},
/* 45 */

/***/
function (module, exports) {
  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }

  var g; // This works in non-strict mode

  g = function () {
    return this;
  }();

  try {
    // This works if eval is allowed (see CSP)
    g = g || new Function("return this")();
  } catch (e) {
    // This works if the window reference is available
    if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === "object") g = window;
  } // g can still be undefined, but nothing to do about it...
  // We return undefined, instead of nothing here, so it's
  // easier to handle this case. if(!global) { ...}


  module.exports = g;
  /***/
},
/* 46 */

/***/
function (module, exports, __webpack_require__) {
  var baseTrim = __webpack_require__(47),
      isObject = __webpack_require__(14),
      isSymbol = __webpack_require__(49);
  /** Used as references for various `Number` constants. */


  var NAN = 0 / 0;
  /** Used to detect bad signed hexadecimal string values. */

  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
  /** Used to detect binary string values. */

  var reIsBinary = /^0b[01]+$/i;
  /** Used to detect octal string values. */

  var reIsOctal = /^0o[0-7]+$/i;
  /** Built-in method references without a dependency on `root`. */

  var freeParseInt = parseInt;
  /**
   * Converts `value` to a number.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to process.
   * @returns {number} Returns the number.
   * @example
   *
   * _.toNumber(3.2);
   * // => 3.2
   *
   * _.toNumber(Number.MIN_VALUE);
   * // => 5e-324
   *
   * _.toNumber(Infinity);
   * // => Infinity
   *
   * _.toNumber('3.2');
   * // => 3.2
   */

  function toNumber(value) {
    if (typeof value == 'number') {
      return value;
    }

    if (isSymbol(value)) {
      return NAN;
    }

    if (isObject(value)) {
      var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
      value = isObject(other) ? other + '' : other;
    }

    if (typeof value != 'string') {
      return value === 0 ? value : +value;
    }

    value = baseTrim(value);
    var isBinary = reIsBinary.test(value);
    return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
  }

  module.exports = toNumber;
  /***/
},
/* 47 */

/***/
function (module, exports, __webpack_require__) {
  var trimmedEndIndex = __webpack_require__(48);
  /** Used to match leading whitespace. */


  var reTrimStart = /^\s+/;
  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */

  function baseTrim(string) {
    return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
  }

  module.exports = baseTrim;
  /***/
},
/* 48 */

/***/
function (module, exports) {
  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;
  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */

  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}

    return index;
  }

  module.exports = trimmedEndIndex;
  /***/
},
/* 49 */

/***/
function (module, exports, __webpack_require__) {
  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }

  var baseGetTag = __webpack_require__(50),
      isObjectLike = __webpack_require__(53);
  /** `Object#toString` result references. */


  var symbolTag = '[object Symbol]';
  /**
   * Checks if `value` is classified as a `Symbol` primitive or object.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
   * @example
   *
   * _.isSymbol(Symbol.iterator);
   * // => true
   *
   * _.isSymbol('abc');
   * // => false
   */

  function isSymbol(value) {
    return _typeof(value) == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
  }

  module.exports = isSymbol;
  /***/
},
/* 50 */

/***/
function (module, exports, __webpack_require__) {
  var _Symbol = __webpack_require__(16),
      getRawTag = __webpack_require__(51),
      objectToString = __webpack_require__(52);
  /** `Object#toString` result references. */


  var nullTag = '[object Null]',
      undefinedTag = '[object Undefined]';
  /** Built-in value references. */

  var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;
  /**
   * The base implementation of `getTag` without fallbacks for buggy environments.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the `toStringTag`.
   */

  function baseGetTag(value) {
    if (value == null) {
      return value === undefined ? undefinedTag : nullTag;
    }

    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
  }

  module.exports = baseGetTag;
  /***/
},
/* 51 */

/***/
function (module, exports, __webpack_require__) {
  var _Symbol = __webpack_require__(16);
  /** Used for built-in method references. */


  var objectProto = Object.prototype;
  /** Used to check objects for own properties. */

  var hasOwnProperty = objectProto.hasOwnProperty;
  /**
   * Used to resolve the
   * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
   * of values.
   */

  var nativeObjectToString = objectProto.toString;
  /** Built-in value references. */

  var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;
  /**
   * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the raw `toStringTag`.
   */

  function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag),
        tag = value[symToStringTag];

    try {
      value[symToStringTag] = undefined;
      var unmasked = true;
    } catch (e) {}

    var result = nativeObjectToString.call(value);

    if (unmasked) {
      if (isOwn) {
        value[symToStringTag] = tag;
      } else {
        delete value[symToStringTag];
      }
    }

    return result;
  }

  module.exports = getRawTag;
  /***/
},
/* 52 */

/***/
function (module, exports) {
  /** Used for built-in method references. */
  var objectProto = Object.prototype;
  /**
   * Used to resolve the
   * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
   * of values.
   */

  var nativeObjectToString = objectProto.toString;
  /**
   * Converts `value` to a string using `Object.prototype.toString`.
   *
   * @private
   * @param {*} value The value to convert.
   * @returns {string} Returns the converted string.
   */

  function objectToString(value) {
    return nativeObjectToString.call(value);
  }

  module.exports = objectToString;
  /***/
},
/* 53 */

/***/
function (module, exports) {
  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  /**
   * Checks if `value` is object-like. A value is object-like if it's not `null`
   * and has a `typeof` result of "object".
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
   * @example
   *
   * _.isObjectLike({});
   * // => true
   *
   * _.isObjectLike([1, 2, 3]);
   * // => true
   *
   * _.isObjectLike(_.noop);
   * // => false
   *
   * _.isObjectLike(null);
   * // => false
   */


  function isObjectLike(value) {
    return value != null && _typeof(value) == 'object';
  }

  module.exports = isObjectLike;
  /***/
},
/* 54 */

/***/
function (module, exports, __webpack_require__) {
  var React = __webpack_require__(1);

  var attributesToProps = __webpack_require__(17);

  var utilities = __webpack_require__(18);

  var setStyleProp = utilities.setStyleProp;
  /**
   * Converts DOM nodes to React elements.
   *
   * @param  {DomElement[]} nodes             - DOM nodes.
   * @param  {object}       [options={}]      - Options.
   * @param  {Function}     [options.replace] - Replacer.
   * @param  {object}       [options.library] - Library (React/Preact/etc.).
   * @return {string|ReactElement|ReactElement[]}
   */

  function domToReact(nodes, options) {
    options = options || {};
    var library = options.library || React;
    var cloneElement = library.cloneElement;
    var createElement = library.createElement;
    var isValidElement = library.isValidElement;
    var result = [];
    var node;
    var hasReplace = typeof options.replace === 'function';
    var replaceElement;
    var props;
    var children;
    var data;
    var trim = options.trim;

    for (var i = 0, len = nodes.length; i < len; i++) {
      node = nodes[i]; // replace with custom React element (if present)

      if (hasReplace) {
        replaceElement = options.replace(node);

        if (isValidElement(replaceElement)) {
          // set "key" prop for sibling elements
          // https://fb.me/react-warning-keys
          if (len > 1) {
            replaceElement = cloneElement(replaceElement, {
              key: replaceElement.key || i
            });
          }

          result.push(replaceElement);
          continue;
        }
      }

      if (node.type === 'text') {
        // if trim option is enabled, skip whitespace text nodes
        if (trim) {
          data = node.data.trim();

          if (data) {
            result.push(node.data);
          }
        } else {
          result.push(node.data);
        }

        continue;
      }

      props = node.attribs;

      if (skipAttributesToProps(node)) {
        setStyleProp(props.style, props);
      } else if (props) {
        props = attributesToProps(props);
      }

      children = null;

      switch (node.type) {
        case 'script':
        case 'style':
          // prevent text in <script> or <style> from being escaped
          // https://reactjs.org/docs/dom-elements.html#dangerouslysetinnerhtml
          if (node.children[0]) {
            props.dangerouslySetInnerHTML = {
              __html: node.children[0].data
            };
          }

          break;

        case 'tag':
          // setting textarea value in children is an antipattern in React
          // https://reactjs.org/docs/forms.html#the-textarea-tag
          if (node.name === 'textarea' && node.children[0]) {
            props.defaultValue = node.children[0].data;
          } else if (node.children && node.children.length) {
            // continue recursion of creating React elements (if applicable)
            children = domToReact(node.children, options);
          }

          break;
        // skip all other cases (e.g., comment)

        default:
          continue;
      } // set "key" prop for sibling elements
      // https://fb.me/react-warning-keys


      if (len > 1) {
        props.key = i;
      }

      result.push(createElement(node.name, props, children));
    }

    return result.length === 1 ? result[0] : result;
  }
  /**
   * Determines whether DOM element attributes should be transformed to props.
   * Web Components should not have their attributes transformed except for `style`.
   *
   * @param  {DomElement} node
   * @return {boolean}
   */


  function skipAttributesToProps(node) {
    return utilities.PRESERVE_CUSTOM_ATTRIBUTES && node.type === 'tag' && utilities.isCustomComponent(node.name, node.attribs);
  }

  module.exports = domToReact;
  /***/
},
/* 55 */

/***/
function (module, exports, __webpack_require__) {
  var HTMLDOMPropertyConfig = __webpack_require__(56);

  var SVGDOMPropertyConfig = __webpack_require__(57);

  var injection = __webpack_require__(58);

  var MUST_USE_PROPERTY = injection.MUST_USE_PROPERTY;
  var HAS_BOOLEAN_VALUE = injection.HAS_BOOLEAN_VALUE;
  var HAS_NUMERIC_VALUE = injection.HAS_NUMERIC_VALUE;
  var HAS_POSITIVE_NUMERIC_VALUE = injection.HAS_POSITIVE_NUMERIC_VALUE;
  var HAS_OVERLOADED_BOOLEAN_VALUE = injection.HAS_OVERLOADED_BOOLEAN_VALUE;
  /**
   * @see https://github.com/facebook/react/blob/15-stable/src/renderers/dom/shared/DOMProperty.js#L14-L16
   *
   * @param  {Number}  value
   * @param  {Number}  bitmask
   * @return {Boolean}
   */

  function checkMask(value, bitmask) {
    return (value & bitmask) === bitmask;
  }
  /**
   * @see https://github.com/facebook/react/blob/15-stable/src/renderers/dom/shared/DOMProperty.js#L57
   *
   * @param {Object}  domPropertyConfig - HTMLDOMPropertyConfig or SVGDOMPropertyConfig
   * @param {Object}  config            - The object to be mutated
   * @param {Boolean} isSVG             - Whether the injected config is HTML or SVG (it assumes the default is HTML)
   */


  function injectDOMPropertyConfig(domPropertyConfig, config, isSVG) {
    var Properties = domPropertyConfig.Properties;
    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames;
    var attributeName;
    var propertyName;
    var propConfig;

    for (propertyName in Properties) {
      attributeName = DOMAttributeNames[propertyName] || (isSVG ? propertyName : propertyName.toLowerCase());
      propConfig = Properties[propertyName];
      config[attributeName] = {
        attributeName: attributeName,
        propertyName: propertyName,
        mustUseProperty: checkMask(propConfig, MUST_USE_PROPERTY),
        hasBooleanValue: checkMask(propConfig, HAS_BOOLEAN_VALUE),
        hasNumericValue: checkMask(propConfig, HAS_NUMERIC_VALUE),
        hasPositiveNumericValue: checkMask(propConfig, HAS_POSITIVE_NUMERIC_VALUE),
        hasOverloadedBooleanValue: checkMask(propConfig, HAS_OVERLOADED_BOOLEAN_VALUE)
      };
    }
  }
  /**
   * HTML properties config.
   *
   * @type {Object}
   */


  var html = {};
  injectDOMPropertyConfig(HTMLDOMPropertyConfig, html);
  /**
   * SVG properties config.
   *
   * @type {Object}
   */

  var svg = {};
  injectDOMPropertyConfig(SVGDOMPropertyConfig, svg, true);
  /**
   * HTML and SVG properties config.
   *
   * @type {Object}
   */

  var properties = {};
  injectDOMPropertyConfig(HTMLDOMPropertyConfig, properties);
  injectDOMPropertyConfig(SVGDOMPropertyConfig, properties, true);
  var ATTRIBUTE_NAME_START_CHAR = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
  var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
  module.exports = {
    html: html,
    svg: svg,
    properties: properties,

    /**
     * Checks whether a property name is a custom attribute.
     *
     * @see https://github.com/facebook/react/blob/15-stable/src/renderers/dom/shared/HTMLDOMPropertyConfig.js#L23-L25
     *
     * @param {String}
     * @return {Boolean}
     */
    isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$'))
  };
  /***/
},
/* 56 */

/***/
function (module, exports) {
  module.exports = {
    Properties: {
      autoFocus: 4,
      accept: 0,
      acceptCharset: 0,
      accessKey: 0,
      action: 0,
      allowFullScreen: 4,
      allowTransparency: 0,
      alt: 0,
      as: 0,
      async: 4,
      autoComplete: 0,
      autoPlay: 4,
      capture: 4,
      cellPadding: 0,
      cellSpacing: 0,
      charSet: 0,
      challenge: 0,
      checked: 5,
      cite: 0,
      classID: 0,
      className: 0,
      cols: 24,
      colSpan: 0,
      content: 0,
      contentEditable: 0,
      contextMenu: 0,
      controls: 4,
      controlsList: 0,
      coords: 0,
      crossOrigin: 0,
      data: 0,
      dateTime: 0,
      "default": 4,
      defer: 4,
      dir: 0,
      disabled: 4,
      download: 32,
      draggable: 0,
      encType: 0,
      form: 0,
      formAction: 0,
      formEncType: 0,
      formMethod: 0,
      formNoValidate: 4,
      formTarget: 0,
      frameBorder: 0,
      headers: 0,
      height: 0,
      hidden: 4,
      high: 0,
      href: 0,
      hrefLang: 0,
      htmlFor: 0,
      httpEquiv: 0,
      icon: 0,
      id: 0,
      inputMode: 0,
      integrity: 0,
      is: 0,
      keyParams: 0,
      keyType: 0,
      kind: 0,
      label: 0,
      lang: 0,
      list: 0,
      loop: 4,
      low: 0,
      manifest: 0,
      marginHeight: 0,
      marginWidth: 0,
      max: 0,
      maxLength: 0,
      media: 0,
      mediaGroup: 0,
      method: 0,
      min: 0,
      minLength: 0,
      multiple: 5,
      muted: 5,
      name: 0,
      nonce: 0,
      noValidate: 4,
      open: 4,
      optimum: 0,
      pattern: 0,
      placeholder: 0,
      playsInline: 4,
      poster: 0,
      preload: 0,
      profile: 0,
      radioGroup: 0,
      readOnly: 4,
      referrerPolicy: 0,
      rel: 0,
      required: 4,
      reversed: 4,
      role: 0,
      rows: 24,
      rowSpan: 8,
      sandbox: 0,
      scope: 0,
      scoped: 4,
      scrolling: 0,
      seamless: 4,
      selected: 5,
      shape: 0,
      size: 24,
      sizes: 0,
      span: 24,
      spellCheck: 0,
      src: 0,
      srcDoc: 0,
      srcLang: 0,
      srcSet: 0,
      start: 8,
      step: 0,
      style: 0,
      summary: 0,
      tabIndex: 0,
      target: 0,
      title: 0,
      type: 0,
      useMap: 0,
      value: 0,
      width: 0,
      wmode: 0,
      wrap: 0,
      about: 0,
      datatype: 0,
      inlist: 0,
      prefix: 0,
      property: 0,
      resource: 0,
      "typeof": 0,
      vocab: 0,
      autoCapitalize: 0,
      autoCorrect: 0,
      autoSave: 0,
      color: 0,
      itemProp: 0,
      itemScope: 4,
      itemType: 0,
      itemID: 0,
      itemRef: 0,
      results: 0,
      security: 0,
      unselectable: 0
    },
    DOMAttributeNames: {
      acceptCharset: 'accept-charset',
      className: 'class',
      htmlFor: 'for',
      httpEquiv: 'http-equiv'
    }
  };
  /***/
},
/* 57 */

/***/
function (module, exports) {
  module.exports = {
    Properties: {
      accentHeight: 0,
      accumulate: 0,
      additive: 0,
      alignmentBaseline: 0,
      allowReorder: 0,
      alphabetic: 0,
      amplitude: 0,
      arabicForm: 0,
      ascent: 0,
      attributeName: 0,
      attributeType: 0,
      autoReverse: 0,
      azimuth: 0,
      baseFrequency: 0,
      baseProfile: 0,
      baselineShift: 0,
      bbox: 0,
      begin: 0,
      bias: 0,
      by: 0,
      calcMode: 0,
      capHeight: 0,
      clip: 0,
      clipPath: 0,
      clipRule: 0,
      clipPathUnits: 0,
      colorInterpolation: 0,
      colorInterpolationFilters: 0,
      colorProfile: 0,
      colorRendering: 0,
      contentScriptType: 0,
      contentStyleType: 0,
      cursor: 0,
      cx: 0,
      cy: 0,
      d: 0,
      decelerate: 0,
      descent: 0,
      diffuseConstant: 0,
      direction: 0,
      display: 0,
      divisor: 0,
      dominantBaseline: 0,
      dur: 0,
      dx: 0,
      dy: 0,
      edgeMode: 0,
      elevation: 0,
      enableBackground: 0,
      end: 0,
      exponent: 0,
      externalResourcesRequired: 0,
      fill: 0,
      fillOpacity: 0,
      fillRule: 0,
      filter: 0,
      filterRes: 0,
      filterUnits: 0,
      floodColor: 0,
      floodOpacity: 0,
      focusable: 0,
      fontFamily: 0,
      fontSize: 0,
      fontSizeAdjust: 0,
      fontStretch: 0,
      fontStyle: 0,
      fontVariant: 0,
      fontWeight: 0,
      format: 0,
      from: 0,
      fx: 0,
      fy: 0,
      g1: 0,
      g2: 0,
      glyphName: 0,
      glyphOrientationHorizontal: 0,
      glyphOrientationVertical: 0,
      glyphRef: 0,
      gradientTransform: 0,
      gradientUnits: 0,
      hanging: 0,
      horizAdvX: 0,
      horizOriginX: 0,
      ideographic: 0,
      imageRendering: 0,
      "in": 0,
      in2: 0,
      intercept: 0,
      k: 0,
      k1: 0,
      k2: 0,
      k3: 0,
      k4: 0,
      kernelMatrix: 0,
      kernelUnitLength: 0,
      kerning: 0,
      keyPoints: 0,
      keySplines: 0,
      keyTimes: 0,
      lengthAdjust: 0,
      letterSpacing: 0,
      lightingColor: 0,
      limitingConeAngle: 0,
      local: 0,
      markerEnd: 0,
      markerMid: 0,
      markerStart: 0,
      markerHeight: 0,
      markerUnits: 0,
      markerWidth: 0,
      mask: 0,
      maskContentUnits: 0,
      maskUnits: 0,
      mathematical: 0,
      mode: 0,
      numOctaves: 0,
      offset: 0,
      opacity: 0,
      operator: 0,
      order: 0,
      orient: 0,
      orientation: 0,
      origin: 0,
      overflow: 0,
      overlinePosition: 0,
      overlineThickness: 0,
      paintOrder: 0,
      panose1: 0,
      pathLength: 0,
      patternContentUnits: 0,
      patternTransform: 0,
      patternUnits: 0,
      pointerEvents: 0,
      points: 0,
      pointsAtX: 0,
      pointsAtY: 0,
      pointsAtZ: 0,
      preserveAlpha: 0,
      preserveAspectRatio: 0,
      primitiveUnits: 0,
      r: 0,
      radius: 0,
      refX: 0,
      refY: 0,
      renderingIntent: 0,
      repeatCount: 0,
      repeatDur: 0,
      requiredExtensions: 0,
      requiredFeatures: 0,
      restart: 0,
      result: 0,
      rotate: 0,
      rx: 0,
      ry: 0,
      scale: 0,
      seed: 0,
      shapeRendering: 0,
      slope: 0,
      spacing: 0,
      specularConstant: 0,
      specularExponent: 0,
      speed: 0,
      spreadMethod: 0,
      startOffset: 0,
      stdDeviation: 0,
      stemh: 0,
      stemv: 0,
      stitchTiles: 0,
      stopColor: 0,
      stopOpacity: 0,
      strikethroughPosition: 0,
      strikethroughThickness: 0,
      string: 0,
      stroke: 0,
      strokeDasharray: 0,
      strokeDashoffset: 0,
      strokeLinecap: 0,
      strokeLinejoin: 0,
      strokeMiterlimit: 0,
      strokeOpacity: 0,
      strokeWidth: 0,
      surfaceScale: 0,
      systemLanguage: 0,
      tableValues: 0,
      targetX: 0,
      targetY: 0,
      textAnchor: 0,
      textDecoration: 0,
      textRendering: 0,
      textLength: 0,
      to: 0,
      transform: 0,
      u1: 0,
      u2: 0,
      underlinePosition: 0,
      underlineThickness: 0,
      unicode: 0,
      unicodeBidi: 0,
      unicodeRange: 0,
      unitsPerEm: 0,
      vAlphabetic: 0,
      vHanging: 0,
      vIdeographic: 0,
      vMathematical: 0,
      values: 0,
      vectorEffect: 0,
      version: 0,
      vertAdvY: 0,
      vertOriginX: 0,
      vertOriginY: 0,
      viewBox: 0,
      viewTarget: 0,
      visibility: 0,
      widths: 0,
      wordSpacing: 0,
      writingMode: 0,
      x: 0,
      xHeight: 0,
      x1: 0,
      x2: 0,
      xChannelSelector: 0,
      xlinkActuate: 0,
      xlinkArcrole: 0,
      xlinkHref: 0,
      xlinkRole: 0,
      xlinkShow: 0,
      xlinkTitle: 0,
      xlinkType: 0,
      xmlBase: 0,
      xmlns: 0,
      xmlnsXlink: 0,
      xmlLang: 0,
      xmlSpace: 0,
      y: 0,
      y1: 0,
      y2: 0,
      yChannelSelector: 0,
      z: 0,
      zoomAndPan: 0
    },
    DOMAttributeNames: {
      accentHeight: 'accent-height',
      alignmentBaseline: 'alignment-baseline',
      arabicForm: 'arabic-form',
      baselineShift: 'baseline-shift',
      capHeight: 'cap-height',
      clipPath: 'clip-path',
      clipRule: 'clip-rule',
      colorInterpolation: 'color-interpolation',
      colorInterpolationFilters: 'color-interpolation-filters',
      colorProfile: 'color-profile',
      colorRendering: 'color-rendering',
      dominantBaseline: 'dominant-baseline',
      enableBackground: 'enable-background',
      fillOpacity: 'fill-opacity',
      fillRule: 'fill-rule',
      floodColor: 'flood-color',
      floodOpacity: 'flood-opacity',
      fontFamily: 'font-family',
      fontSize: 'font-size',
      fontSizeAdjust: 'font-size-adjust',
      fontStretch: 'font-stretch',
      fontStyle: 'font-style',
      fontVariant: 'font-variant',
      fontWeight: 'font-weight',
      glyphName: 'glyph-name',
      glyphOrientationHorizontal: 'glyph-orientation-horizontal',
      glyphOrientationVertical: 'glyph-orientation-vertical',
      horizAdvX: 'horiz-adv-x',
      horizOriginX: 'horiz-origin-x',
      imageRendering: 'image-rendering',
      letterSpacing: 'letter-spacing',
      lightingColor: 'lighting-color',
      markerEnd: 'marker-end',
      markerMid: 'marker-mid',
      markerStart: 'marker-start',
      overlinePosition: 'overline-position',
      overlineThickness: 'overline-thickness',
      paintOrder: 'paint-order',
      panose1: 'panose-1',
      pointerEvents: 'pointer-events',
      renderingIntent: 'rendering-intent',
      shapeRendering: 'shape-rendering',
      stopColor: 'stop-color',
      stopOpacity: 'stop-opacity',
      strikethroughPosition: 'strikethrough-position',
      strikethroughThickness: 'strikethrough-thickness',
      strokeDasharray: 'stroke-dasharray',
      strokeDashoffset: 'stroke-dashoffset',
      strokeLinecap: 'stroke-linecap',
      strokeLinejoin: 'stroke-linejoin',
      strokeMiterlimit: 'stroke-miterlimit',
      strokeOpacity: 'stroke-opacity',
      strokeWidth: 'stroke-width',
      textAnchor: 'text-anchor',
      textDecoration: 'text-decoration',
      textRendering: 'text-rendering',
      underlinePosition: 'underline-position',
      underlineThickness: 'underline-thickness',
      unicodeBidi: 'unicode-bidi',
      unicodeRange: 'unicode-range',
      unitsPerEm: 'units-per-em',
      vAlphabetic: 'v-alphabetic',
      vHanging: 'v-hanging',
      vIdeographic: 'v-ideographic',
      vMathematical: 'v-mathematical',
      vectorEffect: 'vector-effect',
      vertAdvY: 'vert-adv-y',
      vertOriginX: 'vert-origin-x',
      vertOriginY: 'vert-origin-y',
      wordSpacing: 'word-spacing',
      writingMode: 'writing-mode',
      xHeight: 'x-height',
      xlinkActuate: 'xlink:actuate',
      xlinkArcrole: 'xlink:arcrole',
      xlinkHref: 'xlink:href',
      xlinkRole: 'xlink:role',
      xlinkShow: 'xlink:show',
      xlinkTitle: 'xlink:title',
      xlinkType: 'xlink:type',
      xmlBase: 'xml:base',
      xmlnsXlink: 'xmlns:xlink',
      xmlLang: 'xml:lang',
      xmlSpace: 'xml:space'
    }
  };
  /***/
},
/* 58 */

/***/
function (module, exports) {
  module.exports = {
    MUST_USE_PROPERTY: 1,
    HAS_BOOLEAN_VALUE: 4,
    HAS_NUMERIC_VALUE: 8,
    HAS_POSITIVE_NUMERIC_VALUE: 24,
    HAS_OVERLOADED_BOOLEAN_VALUE: 32
  };
  /***/
},
/* 59 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var __importDefault = this && this.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };

  exports.__esModule = true;

  var style_to_object_1 = __importDefault(__webpack_require__(60));

  var utilities_1 = __webpack_require__(62);

  function StyleToJS(style, options) {
    var output = {};

    if (!style || typeof style !== 'string') {
      return output;
    }

    style_to_object_1["default"](style, function (property, value) {
      if (property && value) {
        output[utilities_1.camelCase(property, options)] = value;
      }
    });
    return output;
  }

  exports["default"] = StyleToJS;
  /***/
},
/* 60 */

/***/
function (module, exports, __webpack_require__) {
  var parse = __webpack_require__(61);
  /**
   * Parses inline style to object.
   *
   * @example
   * // returns { 'line-height': '42' }
   * StyleToObject('line-height: 42;');
   *
   * @param  {String}      style      - The inline style.
   * @param  {Function}    [iterator] - The iterator function.
   * @return {null|Object}
   */


  function StyleToObject(style, iterator) {
    var output = null;

    if (!style || typeof style !== 'string') {
      return output;
    }

    var declaration;
    var declarations = parse(style);
    var hasIterator = typeof iterator === 'function';
    var property;
    var value;

    for (var i = 0, len = declarations.length; i < len; i++) {
      declaration = declarations[i];
      property = declaration.property;
      value = declaration.value;

      if (hasIterator) {
        iterator(property, value, declaration);
      } else if (value) {
        output || (output = {});
        output[property] = value;
      }
    }

    return output;
  }

  module.exports = StyleToObject;
  /***/
},
/* 61 */

/***/
function (module, exports) {
  // http://www.w3.org/TR/CSS21/grammar.html
  // https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
  var COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;
  var NEWLINE_REGEX = /\n/g;
  var WHITESPACE_REGEX = /^\s*/; // declaration

  var PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
  var COLON_REGEX = /^:\s*/;
  var VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
  var SEMICOLON_REGEX = /^[;\s]*/; // https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill

  var TRIM_REGEX = /^\s+|\s+$/g; // strings

  var NEWLINE = '\n';
  var FORWARD_SLASH = '/';
  var ASTERISK = '*';
  var EMPTY_STRING = ''; // types

  var TYPE_COMMENT = 'comment';
  var TYPE_DECLARATION = 'declaration';
  /**
   * @param {String} style
   * @param {Object} [options]
   * @return {Object[]}
   * @throws {TypeError}
   * @throws {Error}
   */

  module.exports = function (style, options) {
    if (typeof style !== 'string') {
      throw new TypeError('First argument must be a string');
    }

    if (!style) return [];
    options = options || {};
    /**
     * Positional.
     */

    var lineno = 1;
    var column = 1;
    /**
     * Update lineno and column based on `str`.
     *
     * @param {String} str
     */

    function updatePosition(str) {
      var lines = str.match(NEWLINE_REGEX);
      if (lines) lineno += lines.length;
      var i = str.lastIndexOf(NEWLINE);
      column = ~i ? str.length - i : column + str.length;
    }
    /**
     * Mark position and patch `node.position`.
     *
     * @return {Function}
     */


    function position() {
      var start = {
        line: lineno,
        column: column
      };
      return function (node) {
        node.position = new Position(start);
        whitespace();
        return node;
      };
    }
    /**
     * Store position information for a node.
     *
     * @constructor
     * @property {Object} start
     * @property {Object} end
     * @property {undefined|String} source
     */


    function Position(start) {
      this.start = start;
      this.end = {
        line: lineno,
        column: column
      };
      this.source = options.source;
    }
    /**
     * Non-enumerable source string.
     */


    Position.prototype.content = style;
    var errorsList = [];
    /**
     * Error `msg`.
     *
     * @param {String} msg
     * @throws {Error}
     */

    function error(msg) {
      var err = new Error(options.source + ':' + lineno + ':' + column + ': ' + msg);
      err.reason = msg;
      err.filename = options.source;
      err.line = lineno;
      err.column = column;
      err.source = style;

      if (options.silent) {
        errorsList.push(err);
      } else {
        throw err;
      }
    }
    /**
     * Match `re` and return captures.
     *
     * @param {RegExp} re
     * @return {undefined|Array}
     */


    function match(re) {
      var m = re.exec(style);
      if (!m) return;
      var str = m[0];
      updatePosition(str);
      style = style.slice(str.length);
      return m;
    }
    /**
     * Parse whitespace.
     */


    function whitespace() {
      match(WHITESPACE_REGEX);
    }
    /**
     * Parse comments.
     *
     * @param {Object[]} [rules]
     * @return {Object[]}
     */


    function comments(rules) {
      var c;
      rules = rules || [];

      while (c = comment()) {
        if (c !== false) {
          rules.push(c);
        }
      }

      return rules;
    }
    /**
     * Parse comment.
     *
     * @return {Object}
     * @throws {Error}
     */


    function comment() {
      var pos = position();
      if (FORWARD_SLASH != style.charAt(0) || ASTERISK != style.charAt(1)) return;
      var i = 2;

      while (EMPTY_STRING != style.charAt(i) && (ASTERISK != style.charAt(i) || FORWARD_SLASH != style.charAt(i + 1))) {
        ++i;
      }

      i += 2;

      if (EMPTY_STRING === style.charAt(i - 1)) {
        return error('End of comment missing');
      }

      var str = style.slice(2, i - 2);
      column += 2;
      updatePosition(str);
      style = style.slice(i);
      column += 2;
      return pos({
        type: TYPE_COMMENT,
        comment: str
      });
    }
    /**
     * Parse declaration.
     *
     * @return {Object}
     * @throws {Error}
     */


    function declaration() {
      var pos = position(); // prop

      var prop = match(PROPERTY_REGEX);
      if (!prop) return;
      comment(); // :

      if (!match(COLON_REGEX)) return error("property missing ':'"); // val

      var val = match(VALUE_REGEX);
      var ret = pos({
        type: TYPE_DECLARATION,
        property: trim(prop[0].replace(COMMENT_REGEX, EMPTY_STRING)),
        value: val ? trim(val[0].replace(COMMENT_REGEX, EMPTY_STRING)) : EMPTY_STRING
      }); // ;

      match(SEMICOLON_REGEX);
      return ret;
    }
    /**
     * Parse declarations.
     *
     * @return {Object[]}
     */


    function declarations() {
      var decls = [];
      comments(decls); // declarations

      var decl;

      while (decl = declaration()) {
        if (decl !== false) {
          decls.push(decl);
          comments(decls);
        }
      }

      return decls;
    }

    whitespace();
    return declarations();
  };
  /**
   * Trim `str`.
   *
   * @param {String} str
   * @return {String}
   */


  function trim(str) {
    return str ? str.replace(TRIM_REGEX, EMPTY_STRING) : EMPTY_STRING;
  }
  /***/

},
/* 62 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  exports.__esModule = true;
  exports.camelCase = void 0;
  var CUSTOM_PROPERTY_REGEX = /^--[a-zA-Z0-9-]+$/;
  var HYPHEN_REGEX = /-([a-z])/g;
  var NO_HYPHEN_REGEX = /^[^-]+$/;
  var VENDOR_PREFIX_REGEX = /^-(webkit|moz|ms|o|khtml)-/;

  var skipCamelCase = function skipCamelCase(property) {
    return !property || NO_HYPHEN_REGEX.test(property) || CUSTOM_PROPERTY_REGEX.test(property);
  };

  var capitalize = function capitalize(match, character) {
    return character.toUpperCase();
  };

  var trimHyphen = function trimHyphen(match, prefix) {
    return prefix + "-";
  };

  var camelCase = function camelCase(property, options) {
    if (options === void 0) {
      options = {};
    }

    if (skipCamelCase(property)) {
      return property;
    }

    property = property.toLowerCase();

    if (!options.reactCompat) {
      property = property.replace(VENDOR_PREFIX_REGEX, trimHyphen);
    }

    return property.replace(HYPHEN_REGEX, capitalize);
  };

  exports.camelCase = camelCase;
  /***/
},
/* 63 */

/***/
function (module, exports, __webpack_require__) {
  var domparser = __webpack_require__(64);

  var utilities = __webpack_require__(19);

  var formatDOM = utilities.formatDOM;
  var isIE9 = utilities.isIE(9);
  var DIRECTIVE_REGEX = /<(![a-zA-Z\s]+)>/; // e.g., <!doctype html>

  /**
   * Parses HTML and reformats DOM nodes output.
   *
   * @param  {String} html - The HTML string.
   * @return {Array}       - The formatted DOM nodes.
   */

  function parseDOM(html) {
    if (typeof html !== 'string') {
      throw new TypeError('First argument must be a string');
    }

    if (!html) {
      return [];
    } // match directive


    var match = html.match(DIRECTIVE_REGEX);
    var directive;

    if (match && match[1]) {
      directive = match[1]; // remove directive in IE9 because DOMParser uses
      // MIME type 'text/xml' instead of 'text/html'

      if (isIE9) {
        html = html.replace(match[0], '');
      }
    }

    return formatDOM(domparser(html), null, directive);
  }

  module.exports = parseDOM;
  /***/
},
/* 64 */

/***/
function (module, exports, __webpack_require__) {
  var utilities = __webpack_require__(19); // constants


  var HTML = 'html';
  var HEAD = 'head';
  var BODY = 'body';
  var FIRST_TAG_REGEX = /<([a-zA-Z]+[0-9]?)/; // e.g., <h1>

  var HEAD_TAG_REGEX = /<head.*>/i;
  var BODY_TAG_REGEX = /<body.*>/i; // http://www.w3.org/TR/html/syntax.html#void-elements

  var VOID_ELEMENTS_REGEX = /<(area|base|br|col|embed|hr|img|input|keygen|link|menuitem|meta|param|source|track|wbr)(.*?)\/?>/gi; // detect IE browser

  var isIE9 = utilities.isIE(9);
  var isIE = isIE9 || utilities.isIE(); // falls back to `parseFromString` if `createHTMLDocument` cannot be used

  var parseFromDocument = function parseFromDocument() {
    throw new Error('This browser does not support `document.implementation.createHTMLDocument`');
  };

  var parseFromString = function parseFromString() {
    throw new Error('This browser does not support `DOMParser.prototype.parseFromString`');
  };
  /**
   * DOMParser (performance: slow).
   *
   * @see https://developer.mozilla.org/docs/Web/API/DOMParser#Parsing_an_SVG_or_HTML_document
   */


  if (typeof window.DOMParser === 'function') {
    var domParser = new window.DOMParser(); // IE9 does not support 'text/html' MIME type
    // https://msdn.microsoft.com/en-us/library/ff975278(v=vs.85).aspx

    var mimeType = isIE9 ? 'text/xml' : 'text/html';
    /**
     * Creates an HTML document using `DOMParser.parseFromString`.
     *
     * @param  {string} html      - The HTML string.
     * @param  {string} [tagName] - The element to render the HTML (with 'body' as fallback).
     * @return {HTMLDocument}
     */

    parseFromString = function parseFromString(html, tagName) {
      if (tagName) {
        html = '<' + tagName + '>' + html + '</' + tagName + '>';
      } // because IE9 only supports MIME type 'text/xml', void elements need to be self-closed


      if (isIE9) {
        html = html.replace(VOID_ELEMENTS_REGEX, '<$1$2$3/>');
      }

      return domParser.parseFromString(html, mimeType);
    };

    parseFromDocument = parseFromString;
  }
  /**
   * DOMImplementation (performance: fair).
   *
   * @see https://developer.mozilla.org/docs/Web/API/DOMImplementation/createHTMLDocument
   */


  if (document.implementation) {
    // title parameter is required in IE
    // https://msdn.microsoft.com/en-us/library/ff975457(v=vs.85).aspx
    var doc = document.implementation.createHTMLDocument(isIE ? 'html-dom-parser' : undefined);
    /**
     * Use HTML document created by `document.implementation.createHTMLDocument`.
     *
     * @param  {string} html      - The HTML string.
     * @param  {string} [tagName] - The element to render the HTML (with 'body' as fallback).
     * @return {HTMLDocument}
     */

    parseFromDocument = function parseFromDocument(html, tagName) {
      if (tagName) {
        doc.documentElement.getElementsByTagName(tagName)[0].innerHTML = html;
        return doc;
      }

      try {
        doc.documentElement.innerHTML = html;
        return doc; // fallback when certain elements in `documentElement` are read-only (IE9)
      } catch (err) {
        if (parseFromString) {
          return parseFromString(html);
        }
      }
    };
  }
  /**
   * Template (performance: fast).
   *
   * @see https://developer.mozilla.org/docs/Web/HTML/Element/template
   */


  var template = document.createElement('template');
  var parseFromTemplate;

  if (template.content) {
    /**
     * Uses a template element (content fragment) to parse HTML.
     *
     * @param  {string} html - The HTML string.
     * @return {NodeList}
     */
    parseFromTemplate = function parseFromTemplate(html) {
      template.innerHTML = html;
      return template.content.childNodes;
    };
  }
  /**
   * Parses HTML string to DOM nodes.
   *
   * @param  {string} html - The HTML string.
   * @return {NodeList|Array}
   */


  function domparser(html) {
    var firstTagName;
    var match = html.match(FIRST_TAG_REGEX);

    if (match && match[1]) {
      firstTagName = match[1].toLowerCase();
    }

    var doc;
    var element;
    var elements;

    switch (firstTagName) {
      case HTML:
        doc = parseFromString(html); // the created document may come with filler head/body elements,
        // so make sure to remove them if they don't actually exist

        if (!HEAD_TAG_REGEX.test(html)) {
          element = doc.getElementsByTagName(HEAD)[0];

          if (element) {
            element.parentNode.removeChild(element);
          }
        }

        if (!BODY_TAG_REGEX.test(html)) {
          element = doc.getElementsByTagName(BODY)[0];

          if (element) {
            element.parentNode.removeChild(element);
          }
        }

        return doc.getElementsByTagName(HTML);

      case HEAD:
      case BODY:
        elements = parseFromDocument(html).getElementsByTagName(firstTagName); // if there's a sibling element, then return both elements

        if (BODY_TAG_REGEX.test(html) && HEAD_TAG_REGEX.test(html)) {
          return elements[0].parentNode.childNodes;
        }

        return elements;
      // low-level tag or text

      default:
        if (parseFromTemplate) {
          return parseFromTemplate(html);
        }

        return parseFromDocument(html, BODY).getElementsByTagName(BODY)[0].childNodes;
    }
  }

  module.exports = domparser;
  /***/
},
/* 65 */

/***/
function (module, exports) {
  /**
   * SVG elements are case-sensitive.
   *
   * @see {@link https://developer.mozilla.org/docs/Web/SVG/Element#SVG_elements_A_to_Z}
   */
  var CASE_SENSITIVE_TAG_NAMES = ['animateMotion', 'animateTransform', 'clipPath', 'feBlend', 'feColorMatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDropShadow', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussainBlur', 'feImage', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence', 'foreignObject', 'linearGradient', 'radialGradient', 'textPath'];
  module.exports = {
    CASE_SENSITIVE_TAG_NAMES: CASE_SENSITIVE_TAG_NAMES
  };
  /***/
},
/* 66 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict"; // ESM COMPAT FLAG

  __webpack_require__.r(__webpack_exports__); // EXPORTS


  __webpack_require__.d(__webpack_exports__, "Accordion", function () {
    return (
      /* reexport */
      Accordion_Accordion
    );
  });

  __webpack_require__.d(__webpack_exports__, "Alert", function () {
    return (
      /* reexport */
      Alert_Alert
    );
  });

  __webpack_require__.d(__webpack_exports__, "Avatar", function () {
    return (
      /* reexport */
      Avatar_Avatar
    );
  });

  __webpack_require__.d(__webpack_exports__, "AvatarGroup", function () {
    return (
      /* reexport */
      AvatarGroup_AvatarGroup
    );
  });

  __webpack_require__.d(__webpack_exports__, "Badge", function () {
    return (
      /* reexport */
      Badge
    );
  });

  __webpack_require__.d(__webpack_exports__, "Banner", function () {
    return (
      /* reexport */
      Banner_Banner
    );
  });

  __webpack_require__.d(__webpack_exports__, "Breadcrumbs", function () {
    return (
      /* reexport */
      Breadcrumbs_Breadcrumbs
    );
  });

  __webpack_require__.d(__webpack_exports__, "Button", function () {
    return (
      /* reexport */
      Button
    );
  });

  __webpack_require__.d(__webpack_exports__, "Card", function () {
    return (
      /* reexport */
      Card_Card
    );
  });

  __webpack_require__.d(__webpack_exports__, "Carousel", function () {
    return (
      /* reexport */
      Carousel_Carousel
    );
  });

  __webpack_require__.d(__webpack_exports__, "Chart", function () {
    return (
      /* reexport */
      Chart_Chart
    );
  });

  __webpack_require__.d(__webpack_exports__, "Choice", function () {
    return (
      /* reexport */
      Choice_Choice
    );
  });

  __webpack_require__.d(__webpack_exports__, "Description", function () {
    return (
      /* reexport */
      Description_Description
    );
  });

  __webpack_require__.d(__webpack_exports__, "Dot", function () {
    return (
      /* reexport */
      Dot_Dot
    );
  });

  __webpack_require__.d(__webpack_exports__, "Drawer", function () {
    return (
      /* reexport */
      Drawer_Drawer
    );
  });

  __webpack_require__.d(__webpack_exports__, "Dropdown", function () {
    return (
      /* reexport */
      Dropdown_Dropdown
    );
  });

  __webpack_require__.d(__webpack_exports__, "OptionsDropdown", function () {
    return (
      /* reexport */
      OptionsDropdown_OptionsDropdown
    );
  });

  __webpack_require__.d(__webpack_exports__, "SelectDropdown", function () {
    return (
      /* reexport */
      SelectDropdown_SelectDropdown
    );
  });

  __webpack_require__.d(__webpack_exports__, "CopyButton", function () {
    return (
      /* reexport */
      CopyButton_CopyButton
    );
  });

  __webpack_require__.d(__webpack_exports__, "CopyText", function () {
    return (
      /* reexport */
      CopyText_CopyText
    );
  });

  __webpack_require__.d(__webpack_exports__, "CopyTextCard", function () {
    return (
      /* reexport */
      CopyTextCard_CopyTextCard
    );
  });

  __webpack_require__.d(__webpack_exports__, "DataCard", function () {
    return (
      /* reexport */
      DataCard_DataCard
    );
  });

  __webpack_require__.d(__webpack_exports__, "EmptyState", function () {
    return (
      /* reexport */
      EmptyState_EmptyState
    );
  });

  __webpack_require__.d(__webpack_exports__, "ExpandableCard", function () {
    return (
      /* reexport */
      ExpandableCard_ExpandableCard
    );
  });

  __webpack_require__.d(__webpack_exports__, "FormSection", function () {
    return (
      /* reexport */
      FormSection_FormSection
    );
  });

  __webpack_require__.d(__webpack_exports__, "Frame", function () {
    return (
      /* reexport */
      Frame_Frame
    );
  });

  __webpack_require__.d(__webpack_exports__, "Grid", function () {
    return (
      /* reexport */
      Grid_Grid
    );
  });

  __webpack_require__.d(__webpack_exports__, "HelpLink", function () {
    return (
      /* reexport */
      HelpLink_HelpLink
    );
  });

  __webpack_require__.d(__webpack_exports__, "Hero", function () {
    return (
      /* reexport */
      Hero_Hero
    );
  });

  __webpack_require__.d(__webpack_exports__, "Hint", function () {
    return (
      /* reexport */
      Hint_Hint
    );
  });

  __webpack_require__.d(__webpack_exports__, "Icon", function () {
    return (
      /* reexport */
      Icon_Icon
    );
  });

  __webpack_require__.d(__webpack_exports__, "IconCard", function () {
    return (
      /* reexport */
      IconCard_IconCard
    );
  });

  __webpack_require__.d(__webpack_exports__, "IconList", function () {
    return (
      /* reexport */
      IconList_IconList
    );
  });

  __webpack_require__.d(__webpack_exports__, "Indicator", function () {
    return (
      /* reexport */
      Indicator_Indicator
    );
  });

  __webpack_require__.d(__webpack_exports__, "Input", function () {
    return (
      /* reexport */
      Input_Input
    );
  });

  __webpack_require__.d(__webpack_exports__, "Label", function () {
    return (
      /* reexport */
      Label
    );
  });

  __webpack_require__.d(__webpack_exports__, "Link", function () {
    return (
      /* reexport */
      Link_Link
    );
  });

  __webpack_require__.d(__webpack_exports__, "List", function () {
    return (
      /* reexport */
      List_List
    );
  });

  __webpack_require__.d(__webpack_exports__, "Loader", function () {
    return (
      /* reexport */
      Loader_Loader
    );
  });

  __webpack_require__.d(__webpack_exports__, "MediaTile", function () {
    return (
      /* reexport */
      MediaTile_MediaTile
    );
  });

  __webpack_require__.d(__webpack_exports__, "MediaTiles", function () {
    return (
      /* reexport */
      MediaTiles_MediaTiles
    );
  });

  __webpack_require__.d(__webpack_exports__, "Modal", function () {
    return (
      /* reexport */
      Modal_Modal
    );
  });

  __webpack_require__.d(__webpack_exports__, "NextBestAction", function () {
    return (
      /* reexport */
      NextBestAction_NextBestAction
    );
  });

  __webpack_require__.d(__webpack_exports__, "PageHeading", function () {
    return (
      /* reexport */
      PageHeading_PageHeading
    );
  });

  __webpack_require__.d(__webpack_exports__, "Pagination", function () {
    return (
      /* reexport */
      Pagination_Pagination
    );
  });

  __webpack_require__.d(__webpack_exports__, "Panel", function () {
    return (
      /* reexport */
      Panel_Panel
    );
  });

  __webpack_require__.d(__webpack_exports__, "PanelControls", function () {
    return (
      /* reexport */
      PanelControls_PanelControls
    );
  });

  __webpack_require__.d(__webpack_exports__, "Popover", function () {
    return (
      /* reexport */
      Popover_Popover
    );
  });

  __webpack_require__.d(__webpack_exports__, "ProgressBar", function () {
    return (
      /* reexport */
      ProgressBar_ProgressBar
    );
  });

  __webpack_require__.d(__webpack_exports__, "Property", function () {
    return (
      /* reexport */
      Property_Property
    );
  });

  __webpack_require__.d(__webpack_exports__, "SampleComponent", function () {
    return (
      /* reexport */
      SampleComponent_SampleComponent
    );
  });

  __webpack_require__.d(__webpack_exports__, "Search", function () {
    return (
      /* reexport */
      Search_Search
    );
  });

  __webpack_require__.d(__webpack_exports__, "Select", function () {
    return (
      /* reexport */
      Select_Select
    );
  });

  __webpack_require__.d(__webpack_exports__, "Tabs", function () {
    return (
      /* reexport */
      Tabs_Tabs
    );
  });

  __webpack_require__.d(__webpack_exports__, "TabsItem", function () {
    return (
      /* reexport */
      TabsItem_TabsItem
    );
  });

  __webpack_require__.d(__webpack_exports__, "TabsPane", function () {
    return (
      /* reexport */
      TabsPane_TabsPane
    );
  });

  __webpack_require__.d(__webpack_exports__, "Sortable", function () {
    return (
      /* reexport */
      Sortable_Sortable
    );
  });

  __webpack_require__.d(__webpack_exports__, "StatBox", function () {
    return (
      /* reexport */
      StatBox_StatBox
    );
  });

  __webpack_require__.d(__webpack_exports__, "Table", function () {
    return (
      /* reexport */
      Table_Table
    );
  });

  __webpack_require__.d(__webpack_exports__, "Tag", function () {
    return (
      /* reexport */
      Tag_Tag
    );
  });

  __webpack_require__.d(__webpack_exports__, "Textarea", function () {
    return (
      /* reexport */
      Textarea_Textarea
    );
  });

  __webpack_require__.d(__webpack_exports__, "Toast", function () {
    return (
      /* reexport */
      Toast_Toast
    );
  });

  __webpack_require__.d(__webpack_exports__, "Checkbox", function () {
    return (
      /* reexport */
      Checkbox_Checkbox
    );
  });

  __webpack_require__.d(__webpack_exports__, "Radio", function () {
    return (
      /* reexport */
      Radio_Radio
    );
  });

  __webpack_require__.d(__webpack_exports__, "Switch", function () {
    return (
      /* reexport */
      Switch_Switch
    );
  });

  __webpack_require__.d(__webpack_exports__, "Toggle", function () {
    return (
      /* reexport */
      Toggle_Toggle
    );
  });

  __webpack_require__.d(__webpack_exports__, "Toolbar", function () {
    return (
      /* reexport */
      Toolbar_Toolbar
    );
  });

  __webpack_require__.d(__webpack_exports__, "ToolbarEditor", function () {
    return (
      /* reexport */
      ToolbarEditor_ToolbarEditor
    );
  });

  __webpack_require__.d(__webpack_exports__, "Tooltip", function () {
    return (
      /* reexport */
      Tooltip_Tooltip
    );
  });

  __webpack_require__.d(__webpack_exports__, "TransactionCard", function () {
    return (
      /* reexport */
      TransactionCard_TransactionCard
    );
  });

  __webpack_require__.d(__webpack_exports__, "Type", function () {
    return (
      /* reexport */
      Type_Type
    );
  });

  __webpack_require__.d(__webpack_exports__, "Typeahead", function () {
    return (
      /* reexport */
      Typeahead_Typeahead
    );
  });

  __webpack_require__.d(__webpack_exports__, "UploadCard", function () {
    return (
      /* reexport */
      UploadCard_UploadCard
    );
  });

  __webpack_require__.d(__webpack_exports__, "SageClassnames", function () {
    return (
      /* reexport */
      SageClassnames
    );
  });

  __webpack_require__.d(__webpack_exports__, "SageTokens", function () {
    return (
      /* reexport */
      SageTokens
    );
  });

  __webpack_require__.d(__webpack_exports__, "useSageBreakpoint", function () {
    return (
      /* reexport */
      breakpoint_provider_useSageBreakpoint
    );
  });

  __webpack_require__.d(__webpack_exports__, "SageBreakpointProvider", function () {
    return (
      /* reexport */
      breakpoint_provider_SageBreakpointProvider
    );
  }); // NAMESPACE OBJECT: ./lib/configs/dictionary/tokens.js


  var tokens_namespaceObject = {};

  __webpack_require__.r(tokens_namespaceObject);

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_PRIMARY_100_HEX", function () {
    return COLOR_BASE_PRIMARY_100_HEX;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_PRIMARY_100_CODE", function () {
    return COLOR_BASE_PRIMARY_100_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_PRIMARY_100_CLASSNAME", function () {
    return COLOR_BASE_PRIMARY_100_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_PRIMARY_200_HEX", function () {
    return COLOR_BASE_PRIMARY_200_HEX;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_PRIMARY_200_CODE", function () {
    return COLOR_BASE_PRIMARY_200_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_PRIMARY_200_CLASSNAME", function () {
    return COLOR_BASE_PRIMARY_200_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_PRIMARY_300_HEX", function () {
    return COLOR_BASE_PRIMARY_300_HEX;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_PRIMARY_300_CODE", function () {
    return COLOR_BASE_PRIMARY_300_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_PRIMARY_300_CLASSNAME", function () {
    return COLOR_BASE_PRIMARY_300_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_PRIMARY_400_HEX", function () {
    return COLOR_BASE_PRIMARY_400_HEX;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_PRIMARY_400_CODE", function () {
    return COLOR_BASE_PRIMARY_400_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_PRIMARY_400_CLASSNAME", function () {
    return COLOR_BASE_PRIMARY_400_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_PRIMARY_500_HEX", function () {
    return COLOR_BASE_PRIMARY_500_HEX;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_PRIMARY_500_CODE", function () {
    return COLOR_BASE_PRIMARY_500_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_PRIMARY_500_CLASSNAME", function () {
    return COLOR_BASE_PRIMARY_500_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_SAGE_100_HEX", function () {
    return COLOR_BASE_SAGE_100_HEX;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_SAGE_100_CODE", function () {
    return COLOR_BASE_SAGE_100_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_SAGE_100_CLASSNAME", function () {
    return COLOR_BASE_SAGE_100_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_SAGE_200_HEX", function () {
    return COLOR_BASE_SAGE_200_HEX;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_SAGE_200_CODE", function () {
    return COLOR_BASE_SAGE_200_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_SAGE_200_CLASSNAME", function () {
    return COLOR_BASE_SAGE_200_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_SAGE_300_HEX", function () {
    return COLOR_BASE_SAGE_300_HEX;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_SAGE_300_CODE", function () {
    return COLOR_BASE_SAGE_300_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_SAGE_300_CLASSNAME", function () {
    return COLOR_BASE_SAGE_300_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_SAGE_400_HEX", function () {
    return COLOR_BASE_SAGE_400_HEX;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_SAGE_400_CODE", function () {
    return COLOR_BASE_SAGE_400_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_SAGE_400_CLASSNAME", function () {
    return COLOR_BASE_SAGE_400_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_SAGE_500_HEX", function () {
    return COLOR_BASE_SAGE_500_HEX;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_SAGE_500_CODE", function () {
    return COLOR_BASE_SAGE_500_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_SAGE_500_CLASSNAME", function () {
    return COLOR_BASE_SAGE_500_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_YELLOW_100_HEX", function () {
    return COLOR_BASE_YELLOW_100_HEX;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_YELLOW_100_CODE", function () {
    return COLOR_BASE_YELLOW_100_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_YELLOW_100_CLASSNAME", function () {
    return COLOR_BASE_YELLOW_100_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_YELLOW_200_HEX", function () {
    return COLOR_BASE_YELLOW_200_HEX;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_YELLOW_200_CODE", function () {
    return COLOR_BASE_YELLOW_200_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_YELLOW_200_CLASSNAME", function () {
    return COLOR_BASE_YELLOW_200_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_YELLOW_300_HEX", function () {
    return COLOR_BASE_YELLOW_300_HEX;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_YELLOW_300_CODE", function () {
    return COLOR_BASE_YELLOW_300_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_YELLOW_300_CLASSNAME", function () {
    return COLOR_BASE_YELLOW_300_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_YELLOW_400_HEX", function () {
    return COLOR_BASE_YELLOW_400_HEX;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_YELLOW_400_CODE", function () {
    return COLOR_BASE_YELLOW_400_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_YELLOW_400_CLASSNAME", function () {
    return COLOR_BASE_YELLOW_400_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_YELLOW_500_HEX", function () {
    return COLOR_BASE_YELLOW_500_HEX;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_YELLOW_500_CODE", function () {
    return COLOR_BASE_YELLOW_500_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_YELLOW_500_CLASSNAME", function () {
    return COLOR_BASE_YELLOW_500_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_RED_100_HEX", function () {
    return COLOR_BASE_RED_100_HEX;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_RED_100_CODE", function () {
    return COLOR_BASE_RED_100_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_RED_100_CLASSNAME", function () {
    return COLOR_BASE_RED_100_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_RED_200_HEX", function () {
    return COLOR_BASE_RED_200_HEX;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_RED_200_CODE", function () {
    return COLOR_BASE_RED_200_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_RED_200_CLASSNAME", function () {
    return COLOR_BASE_RED_200_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_RED_300_HEX", function () {
    return COLOR_BASE_RED_300_HEX;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_RED_300_CODE", function () {
    return COLOR_BASE_RED_300_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_RED_300_CLASSNAME", function () {
    return COLOR_BASE_RED_300_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_RED_400_HEX", function () {
    return COLOR_BASE_RED_400_HEX;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_RED_400_CODE", function () {
    return COLOR_BASE_RED_400_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_RED_400_CLASSNAME", function () {
    return COLOR_BASE_RED_400_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_RED_500_HEX", function () {
    return COLOR_BASE_RED_500_HEX;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_RED_500_CODE", function () {
    return COLOR_BASE_RED_500_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_RED_500_CLASSNAME", function () {
    return COLOR_BASE_RED_500_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_ORANGE_100_HEX", function () {
    return COLOR_BASE_ORANGE_100_HEX;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_ORANGE_100_CODE", function () {
    return COLOR_BASE_ORANGE_100_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_ORANGE_100_CLASSNAME", function () {
    return COLOR_BASE_ORANGE_100_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_ORANGE_200_HEX", function () {
    return COLOR_BASE_ORANGE_200_HEX;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_ORANGE_200_CODE", function () {
    return COLOR_BASE_ORANGE_200_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_ORANGE_200_CLASSNAME", function () {
    return COLOR_BASE_ORANGE_200_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_ORANGE_300_HEX", function () {
    return COLOR_BASE_ORANGE_300_HEX;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_ORANGE_300_CODE", function () {
    return COLOR_BASE_ORANGE_300_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_ORANGE_300_CLASSNAME", function () {
    return COLOR_BASE_ORANGE_300_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_ORANGE_400_HEX", function () {
    return COLOR_BASE_ORANGE_400_HEX;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_ORANGE_400_CODE", function () {
    return COLOR_BASE_ORANGE_400_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_ORANGE_400_CLASSNAME", function () {
    return COLOR_BASE_ORANGE_400_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_ORANGE_500_HEX", function () {
    return COLOR_BASE_ORANGE_500_HEX;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_ORANGE_500_CODE", function () {
    return COLOR_BASE_ORANGE_500_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_ORANGE_500_CLASSNAME", function () {
    return COLOR_BASE_ORANGE_500_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_PURPLE_100_HEX", function () {
    return COLOR_BASE_PURPLE_100_HEX;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_PURPLE_100_CODE", function () {
    return COLOR_BASE_PURPLE_100_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_PURPLE_100_CLASSNAME", function () {
    return COLOR_BASE_PURPLE_100_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_PURPLE_200_HEX", function () {
    return COLOR_BASE_PURPLE_200_HEX;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_PURPLE_200_CODE", function () {
    return COLOR_BASE_PURPLE_200_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_PURPLE_200_CLASSNAME", function () {
    return COLOR_BASE_PURPLE_200_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_PURPLE_300_HEX", function () {
    return COLOR_BASE_PURPLE_300_HEX;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_PURPLE_300_CODE", function () {
    return COLOR_BASE_PURPLE_300_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_PURPLE_300_CLASSNAME", function () {
    return COLOR_BASE_PURPLE_300_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_PURPLE_400_HEX", function () {
    return COLOR_BASE_PURPLE_400_HEX;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_PURPLE_400_CODE", function () {
    return COLOR_BASE_PURPLE_400_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_PURPLE_400_CLASSNAME", function () {
    return COLOR_BASE_PURPLE_400_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_PURPLE_500_HEX", function () {
    return COLOR_BASE_PURPLE_500_HEX;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_PURPLE_500_CODE", function () {
    return COLOR_BASE_PURPLE_500_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_PURPLE_500_CLASSNAME", function () {
    return COLOR_BASE_PURPLE_500_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_CHARCOAL_100_HEX", function () {
    return COLOR_BASE_CHARCOAL_100_HEX;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_CHARCOAL_100_CODE", function () {
    return COLOR_BASE_CHARCOAL_100_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_CHARCOAL_100_CLASSNAME", function () {
    return COLOR_BASE_CHARCOAL_100_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_CHARCOAL_200_HEX", function () {
    return COLOR_BASE_CHARCOAL_200_HEX;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_CHARCOAL_200_CODE", function () {
    return COLOR_BASE_CHARCOAL_200_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_CHARCOAL_200_CLASSNAME", function () {
    return COLOR_BASE_CHARCOAL_200_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_CHARCOAL_300_HEX", function () {
    return COLOR_BASE_CHARCOAL_300_HEX;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_CHARCOAL_300_CODE", function () {
    return COLOR_BASE_CHARCOAL_300_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_CHARCOAL_300_CLASSNAME", function () {
    return COLOR_BASE_CHARCOAL_300_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_CHARCOAL_400_HEX", function () {
    return COLOR_BASE_CHARCOAL_400_HEX;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_CHARCOAL_400_CODE", function () {
    return COLOR_BASE_CHARCOAL_400_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_CHARCOAL_400_CLASSNAME", function () {
    return COLOR_BASE_CHARCOAL_400_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_CHARCOAL_500_HEX", function () {
    return COLOR_BASE_CHARCOAL_500_HEX;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_CHARCOAL_500_CODE", function () {
    return COLOR_BASE_CHARCOAL_500_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_CHARCOAL_500_CLASSNAME", function () {
    return COLOR_BASE_CHARCOAL_500_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_GREY_100_HEX", function () {
    return COLOR_BASE_GREY_100_HEX;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_GREY_100_CODE", function () {
    return COLOR_BASE_GREY_100_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_GREY_100_CLASSNAME", function () {
    return COLOR_BASE_GREY_100_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_GREY_200_HEX", function () {
    return COLOR_BASE_GREY_200_HEX;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_GREY_200_CODE", function () {
    return COLOR_BASE_GREY_200_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_GREY_200_CLASSNAME", function () {
    return COLOR_BASE_GREY_200_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_GREY_300_HEX", function () {
    return COLOR_BASE_GREY_300_HEX;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_GREY_300_CODE", function () {
    return COLOR_BASE_GREY_300_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_GREY_300_CLASSNAME", function () {
    return COLOR_BASE_GREY_300_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_GREY_400_HEX", function () {
    return COLOR_BASE_GREY_400_HEX;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_GREY_400_CODE", function () {
    return COLOR_BASE_GREY_400_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_GREY_400_CLASSNAME", function () {
    return COLOR_BASE_GREY_400_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_GREY_500_HEX", function () {
    return COLOR_BASE_GREY_500_HEX;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_GREY_500_CODE", function () {
    return COLOR_BASE_GREY_500_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_GREY_500_CLASSNAME", function () {
    return COLOR_BASE_GREY_500_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_WHITE_100_HEX", function () {
    return COLOR_BASE_WHITE_100_HEX;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_WHITE_100_CODE", function () {
    return COLOR_BASE_WHITE_100_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_WHITE_100_CLASSNAME", function () {
    return COLOR_BASE_WHITE_100_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_WHITE_200_HEX", function () {
    return COLOR_BASE_WHITE_200_HEX;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_WHITE_200_CODE", function () {
    return COLOR_BASE_WHITE_200_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_WHITE_200_CLASSNAME", function () {
    return COLOR_BASE_WHITE_200_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_WHITE_300_HEX", function () {
    return COLOR_BASE_WHITE_300_HEX;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_WHITE_300_CODE", function () {
    return COLOR_BASE_WHITE_300_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_WHITE_300_CLASSNAME", function () {
    return COLOR_BASE_WHITE_300_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_WHITE_400_HEX", function () {
    return COLOR_BASE_WHITE_400_HEX;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_WHITE_400_CODE", function () {
    return COLOR_BASE_WHITE_400_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_WHITE_400_CLASSNAME", function () {
    return COLOR_BASE_WHITE_400_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_WHITE_500_HEX", function () {
    return COLOR_BASE_WHITE_500_HEX;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_WHITE_500_CODE", function () {
    return COLOR_BASE_WHITE_500_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_WHITE_500_CLASSNAME", function () {
    return COLOR_BASE_WHITE_500_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_BLACK_100_HEX", function () {
    return COLOR_BASE_BLACK_100_HEX;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_BLACK_100_CODE", function () {
    return COLOR_BASE_BLACK_100_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_BLACK_100_CLASSNAME", function () {
    return COLOR_BASE_BLACK_100_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_BLACK_200_HEX", function () {
    return COLOR_BASE_BLACK_200_HEX;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_BLACK_200_CODE", function () {
    return COLOR_BASE_BLACK_200_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_BLACK_200_CLASSNAME", function () {
    return COLOR_BASE_BLACK_200_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_BLACK_300_HEX", function () {
    return COLOR_BASE_BLACK_300_HEX;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_BLACK_300_CODE", function () {
    return COLOR_BASE_BLACK_300_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_BLACK_300_CLASSNAME", function () {
    return COLOR_BASE_BLACK_300_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_BLACK_400_HEX", function () {
    return COLOR_BASE_BLACK_400_HEX;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_BLACK_400_CODE", function () {
    return COLOR_BASE_BLACK_400_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_BLACK_400_CLASSNAME", function () {
    return COLOR_BASE_BLACK_400_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_BLACK_500_HEX", function () {
    return COLOR_BASE_BLACK_500_HEX;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_BLACK_500_CODE", function () {
    return COLOR_BASE_BLACK_500_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_BASE_BLACK_500_CLASSNAME", function () {
    return COLOR_BASE_BLACK_500_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR", function () {
    return COLOR;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS_DRAFT_DEFAULT_FOREGROUND", function () {
    return COLOR_COMBOS_DRAFT_DEFAULT_FOREGROUND;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS_DRAFT_DEFAULT_FOREGROUND_ACCENT", function () {
    return COLOR_COMBOS_DRAFT_DEFAULT_FOREGROUND_ACCENT;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS_DRAFT_DEFAULT_BACKGROUND", function () {
    return COLOR_COMBOS_DRAFT_DEFAULT_BACKGROUND;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS_DRAFT_DEFAULT_BACKGROUND_ACCENT", function () {
    return COLOR_COMBOS_DRAFT_DEFAULT_BACKGROUND_ACCENT;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS_DRAFT_DEFAULT_ICON_BACKGROUND_ACCENT", function () {
    return COLOR_COMBOS_DRAFT_DEFAULT_ICON_BACKGROUND_ACCENT;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS_DRAFT_SUBTLE_FOREGROUND", function () {
    return COLOR_COMBOS_DRAFT_SUBTLE_FOREGROUND;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS_DRAFT_SUBTLE_FOREGROUND_ACCENT", function () {
    return COLOR_COMBOS_DRAFT_SUBTLE_FOREGROUND_ACCENT;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS_DRAFT_SUBTLE_BACKGROUND", function () {
    return COLOR_COMBOS_DRAFT_SUBTLE_BACKGROUND;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS_DRAFT_BOLD_FOREGROUND", function () {
    return COLOR_COMBOS_DRAFT_BOLD_FOREGROUND;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS_DRAFT_BOLD_BACKGROUND", function () {
    return COLOR_COMBOS_DRAFT_BOLD_BACKGROUND;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS_PUBLISHED_DEFAULT_FOREGROUND", function () {
    return COLOR_COMBOS_PUBLISHED_DEFAULT_FOREGROUND;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS_PUBLISHED_DEFAULT_FOREGROUND_ACCENT", function () {
    return COLOR_COMBOS_PUBLISHED_DEFAULT_FOREGROUND_ACCENT;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS_PUBLISHED_DEFAULT_BACKGROUND", function () {
    return COLOR_COMBOS_PUBLISHED_DEFAULT_BACKGROUND;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS_PUBLISHED_DEFAULT_BACKGROUND_ACCENT", function () {
    return COLOR_COMBOS_PUBLISHED_DEFAULT_BACKGROUND_ACCENT;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS_PUBLISHED_DEFAULT_ICON_BACKGROUND_ACCENT", function () {
    return COLOR_COMBOS_PUBLISHED_DEFAULT_ICON_BACKGROUND_ACCENT;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS_PUBLISHED_SUBTLE_FOREGROUND", function () {
    return COLOR_COMBOS_PUBLISHED_SUBTLE_FOREGROUND;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS_PUBLISHED_SUBTLE_FOREGROUND_ACCENT", function () {
    return COLOR_COMBOS_PUBLISHED_SUBTLE_FOREGROUND_ACCENT;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS_PUBLISHED_SUBTLE_BACKGROUND", function () {
    return COLOR_COMBOS_PUBLISHED_SUBTLE_BACKGROUND;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS_PUBLISHED_BOLD_FOREGROUND", function () {
    return COLOR_COMBOS_PUBLISHED_BOLD_FOREGROUND;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS_PUBLISHED_BOLD_BACKGROUND", function () {
    return COLOR_COMBOS_PUBLISHED_BOLD_BACKGROUND;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS_INFO_DEFAULT_FOREGROUND", function () {
    return COLOR_COMBOS_INFO_DEFAULT_FOREGROUND;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS_INFO_DEFAULT_FOREGROUND_ACCENT", function () {
    return COLOR_COMBOS_INFO_DEFAULT_FOREGROUND_ACCENT;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS_INFO_DEFAULT_BACKGROUND", function () {
    return COLOR_COMBOS_INFO_DEFAULT_BACKGROUND;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS_INFO_DEFAULT_BACKGROUND_ACCENT", function () {
    return COLOR_COMBOS_INFO_DEFAULT_BACKGROUND_ACCENT;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS_INFO_DEFAULT_ICON_BACKGROUND_ACCENT", function () {
    return COLOR_COMBOS_INFO_DEFAULT_ICON_BACKGROUND_ACCENT;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS_INFO_SUBTLE_FOREGROUND", function () {
    return COLOR_COMBOS_INFO_SUBTLE_FOREGROUND;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS_INFO_SUBTLE_FOREGROUND_ACCENT", function () {
    return COLOR_COMBOS_INFO_SUBTLE_FOREGROUND_ACCENT;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS_INFO_SUBTLE_BACKGROUND", function () {
    return COLOR_COMBOS_INFO_SUBTLE_BACKGROUND;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS_INFO_BOLD_FOREGROUND", function () {
    return COLOR_COMBOS_INFO_BOLD_FOREGROUND;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS_INFO_BOLD_BACKGROUND", function () {
    return COLOR_COMBOS_INFO_BOLD_BACKGROUND;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS_LOCKED_DEFAULT_FOREGROUND", function () {
    return COLOR_COMBOS_LOCKED_DEFAULT_FOREGROUND;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS_LOCKED_DEFAULT_FOREGROUND_ACCENT", function () {
    return COLOR_COMBOS_LOCKED_DEFAULT_FOREGROUND_ACCENT;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS_LOCKED_DEFAULT_BACKGROUND", function () {
    return COLOR_COMBOS_LOCKED_DEFAULT_BACKGROUND;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS_LOCKED_DEFAULT_BACKGROUND_ACCENT", function () {
    return COLOR_COMBOS_LOCKED_DEFAULT_BACKGROUND_ACCENT;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS_LOCKED_DEFAULT_ICON_BACKGROUND_ACCENT", function () {
    return COLOR_COMBOS_LOCKED_DEFAULT_ICON_BACKGROUND_ACCENT;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS_LOCKED_SUBTLE_FOREGROUND", function () {
    return COLOR_COMBOS_LOCKED_SUBTLE_FOREGROUND;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS_LOCKED_SUBTLE_FOREGROUND_ACCENT", function () {
    return COLOR_COMBOS_LOCKED_SUBTLE_FOREGROUND_ACCENT;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS_LOCKED_SUBTLE_BACKGROUND", function () {
    return COLOR_COMBOS_LOCKED_SUBTLE_BACKGROUND;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS_LOCKED_BOLD_FOREGROUND", function () {
    return COLOR_COMBOS_LOCKED_BOLD_FOREGROUND;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS_LOCKED_BOLD_BACKGROUND", function () {
    return COLOR_COMBOS_LOCKED_BOLD_BACKGROUND;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS_WARNING_DEFAULT_FOREGROUND", function () {
    return COLOR_COMBOS_WARNING_DEFAULT_FOREGROUND;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS_WARNING_DEFAULT_FOREGROUND_ACCENT", function () {
    return COLOR_COMBOS_WARNING_DEFAULT_FOREGROUND_ACCENT;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS_WARNING_DEFAULT_BACKGROUND", function () {
    return COLOR_COMBOS_WARNING_DEFAULT_BACKGROUND;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS_WARNING_DEFAULT_BACKGROUND_ACCENT", function () {
    return COLOR_COMBOS_WARNING_DEFAULT_BACKGROUND_ACCENT;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS_WARNING_DEFAULT_ICON_BACKGROUND_ACCENT", function () {
    return COLOR_COMBOS_WARNING_DEFAULT_ICON_BACKGROUND_ACCENT;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS_WARNING_SUBTLE_FOREGROUND", function () {
    return COLOR_COMBOS_WARNING_SUBTLE_FOREGROUND;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS_WARNING_SUBTLE_FOREGROUND_ACCENT", function () {
    return COLOR_COMBOS_WARNING_SUBTLE_FOREGROUND_ACCENT;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS_WARNING_SUBTLE_BACKGROUND", function () {
    return COLOR_COMBOS_WARNING_SUBTLE_BACKGROUND;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS_WARNING_BOLD_FOREGROUND", function () {
    return COLOR_COMBOS_WARNING_BOLD_FOREGROUND;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS_WARNING_BOLD_BACKGROUND", function () {
    return COLOR_COMBOS_WARNING_BOLD_BACKGROUND;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS_DANGER_DEFAULT_FOREGROUND", function () {
    return COLOR_COMBOS_DANGER_DEFAULT_FOREGROUND;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS_DANGER_DEFAULT_FOREGROUND_ACCENT", function () {
    return COLOR_COMBOS_DANGER_DEFAULT_FOREGROUND_ACCENT;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS_DANGER_DEFAULT_BACKGROUND", function () {
    return COLOR_COMBOS_DANGER_DEFAULT_BACKGROUND;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS_DANGER_DEFAULT_BACKGROUND_ACCENT", function () {
    return COLOR_COMBOS_DANGER_DEFAULT_BACKGROUND_ACCENT;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS_DANGER_DEFAULT_ICON_BACKGROUND_ACCENT", function () {
    return COLOR_COMBOS_DANGER_DEFAULT_ICON_BACKGROUND_ACCENT;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS_DANGER_SUBTLE_FOREGROUND", function () {
    return COLOR_COMBOS_DANGER_SUBTLE_FOREGROUND;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS_DANGER_SUBTLE_FOREGROUND_ACCENT", function () {
    return COLOR_COMBOS_DANGER_SUBTLE_FOREGROUND_ACCENT;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS_DANGER_SUBTLE_BACKGROUND", function () {
    return COLOR_COMBOS_DANGER_SUBTLE_BACKGROUND;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS_DANGER_BOLD_FOREGROUND", function () {
    return COLOR_COMBOS_DANGER_BOLD_FOREGROUND;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS_DANGER_BOLD_BACKGROUND", function () {
    return COLOR_COMBOS_DANGER_BOLD_BACKGROUND;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS_PRIMARY_DEFAULT_FOREGROUND", function () {
    return COLOR_COMBOS_PRIMARY_DEFAULT_FOREGROUND;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS_PRIMARY_DEFAULT_FOREGROUND_ACCENT", function () {
    return COLOR_COMBOS_PRIMARY_DEFAULT_FOREGROUND_ACCENT;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS_PRIMARY_DEFAULT_BACKGROUND", function () {
    return COLOR_COMBOS_PRIMARY_DEFAULT_BACKGROUND;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS_PRIMARY_SUBTLE_FOREGROUND", function () {
    return COLOR_COMBOS_PRIMARY_SUBTLE_FOREGROUND;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS_PRIMARY_SUBTLE_FOREGROUND_ACCENT", function () {
    return COLOR_COMBOS_PRIMARY_SUBTLE_FOREGROUND_ACCENT;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS_PRIMARY_SUBTLE_BACKGROUND", function () {
    return COLOR_COMBOS_PRIMARY_SUBTLE_BACKGROUND;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS_PRIMARY_BOLD_FOREGROUND", function () {
    return COLOR_COMBOS_PRIMARY_BOLD_FOREGROUND;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS_PRIMARY_BOLD_BACKGROUND", function () {
    return COLOR_COMBOS_PRIMARY_BOLD_BACKGROUND;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_COMBOS", function () {
    return COLOR_COMBOS;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_CORE_PRIMARY", function () {
    return COLOR_CORE_PRIMARY;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_CORE_SAGE", function () {
    return COLOR_CORE_SAGE;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_CORE_YELLOW", function () {
    return COLOR_CORE_YELLOW;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_CORE_RED", function () {
    return COLOR_CORE_RED;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_CORE_ORANGE", function () {
    return COLOR_CORE_ORANGE;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_CORE_PURPLE", function () {
    return COLOR_CORE_PURPLE;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_CORE_CHARCOAL", function () {
    return COLOR_CORE_CHARCOAL;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_CORE_GREY", function () {
    return COLOR_CORE_GREY;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_CORE_WHITE", function () {
    return COLOR_CORE_WHITE;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_CORE_BLACK", function () {
    return COLOR_CORE_BLACK;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_CORE", function () {
    return COLOR_CORE;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_CUSTOM_LABEL_PRIMARY_ICON_BACKGROUND_ACCENT", function () {
    return COLOR_CUSTOM_LABEL_PRIMARY_ICON_BACKGROUND_ACCENT;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_CUSTOM_LABEL_WARNING_BACKGROUND_ACCENT", function () {
    return COLOR_CUSTOM_LABEL_WARNING_BACKGROUND_ACCENT;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_CUSTOM_LABEL_DANGER_BACKGROUND_ACCENT", function () {
    return COLOR_CUSTOM_LABEL_DANGER_BACKGROUND_ACCENT;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_CUSTOM_LABEL_DANGER_ICON_BACKGROUND_ACCENT", function () {
    return COLOR_CUSTOM_LABEL_DANGER_ICON_BACKGROUND_ACCENT;
  });

  __webpack_require__.d(tokens_namespaceObject, "COLOR_CUSTOM", function () {
    return COLOR_CUSTOM;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_E_CODE", function () {
    return CONTENT_GRID_TEMPLATE_E_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_E_SYMBOL", function () {
    return CONTENT_GRID_TEMPLATE_E_SYMBOL;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_E_CLASSNAME", function () {
    return CONTENT_GRID_TEMPLATE_E_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_I_CODE", function () {
    return CONTENT_GRID_TEMPLATE_I_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_I_SYMBOL", function () {
    return CONTENT_GRID_TEMPLATE_I_SYMBOL;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_I_CLASSNAME", function () {
    return CONTENT_GRID_TEMPLATE_I_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_S_CODE", function () {
    return CONTENT_GRID_TEMPLATE_S_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_S_SYMBOL", function () {
    return CONTENT_GRID_TEMPLATE_S_SYMBOL;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_S_CLASSNAME", function () {
    return CONTENT_GRID_TEMPLATE_S_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_T_CODE", function () {
    return CONTENT_GRID_TEMPLATE_T_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_T_SYMBOL", function () {
    return CONTENT_GRID_TEMPLATE_T_SYMBOL;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_T_CLASSNAME", function () {
    return CONTENT_GRID_TEMPLATE_T_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_M_CODE", function () {
    return CONTENT_GRID_TEMPLATE_M_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_M_SYMBOL", function () {
    return CONTENT_GRID_TEMPLATE_M_SYMBOL;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_M_CLASSNAME", function () {
    return CONTENT_GRID_TEMPLATE_M_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_O_CODE", function () {
    return CONTENT_GRID_TEMPLATE_O_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_O_SYMBOL", function () {
    return CONTENT_GRID_TEMPLATE_O_SYMBOL;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_O_CLASSNAME", function () {
    return CONTENT_GRID_TEMPLATE_O_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_SE_CODE", function () {
    return CONTENT_GRID_TEMPLATE_SE_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_SE_SYMBOL", function () {
    return CONTENT_GRID_TEMPLATE_SE_SYMBOL;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_SE_CLASSNAME", function () {
    return CONTENT_GRID_TEMPLATE_SE_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_SI_CODE", function () {
    return CONTENT_GRID_TEMPLATE_SI_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_SI_SYMBOL", function () {
    return CONTENT_GRID_TEMPLATE_SI_SYMBOL;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_SI_CLASSNAME", function () {
    return CONTENT_GRID_TEMPLATE_SI_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_SS_CODE", function () {
    return CONTENT_GRID_TEMPLATE_SS_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_SS_SYMBOL", function () {
    return CONTENT_GRID_TEMPLATE_SS_SYMBOL;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_SS_CLASSNAME", function () {
    return CONTENT_GRID_TEMPLATE_SS_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_OT_CODE", function () {
    return CONTENT_GRID_TEMPLATE_OT_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_OT_SYMBOL", function () {
    return CONTENT_GRID_TEMPLATE_OT_SYMBOL;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_OT_CLASSNAME", function () {
    return CONTENT_GRID_TEMPLATE_OT_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_OM_CODE", function () {
    return CONTENT_GRID_TEMPLATE_OM_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_OM_SYMBOL", function () {
    return CONTENT_GRID_TEMPLATE_OM_SYMBOL;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_OM_CLASSNAME", function () {
    return CONTENT_GRID_TEMPLATE_OM_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_OO_CODE", function () {
    return CONTENT_GRID_TEMPLATE_OO_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_OO_SYMBOL", function () {
    return CONTENT_GRID_TEMPLATE_OO_SYMBOL;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_OO_CLASSNAME", function () {
    return CONTENT_GRID_TEMPLATE_OO_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_ET_CODE", function () {
    return CONTENT_GRID_TEMPLATE_ET_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_ET_SYMBOL", function () {
    return CONTENT_GRID_TEMPLATE_ET_SYMBOL;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_ET_CLASSNAME", function () {
    return CONTENT_GRID_TEMPLATE_ET_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_EM_CODE", function () {
    return CONTENT_GRID_TEMPLATE_EM_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_EM_SYMBOL", function () {
    return CONTENT_GRID_TEMPLATE_EM_SYMBOL;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_EM_CLASSNAME", function () {
    return CONTENT_GRID_TEMPLATE_EM_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_EO_CODE", function () {
    return CONTENT_GRID_TEMPLATE_EO_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_EO_SYMBOL", function () {
    return CONTENT_GRID_TEMPLATE_EO_SYMBOL;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_EO_CLASSNAME", function () {
    return CONTENT_GRID_TEMPLATE_EO_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_IT_CODE", function () {
    return CONTENT_GRID_TEMPLATE_IT_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_IT_SYMBOL", function () {
    return CONTENT_GRID_TEMPLATE_IT_SYMBOL;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_IT_CLASSNAME", function () {
    return CONTENT_GRID_TEMPLATE_IT_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_IM_CODE", function () {
    return CONTENT_GRID_TEMPLATE_IM_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_IM_SYMBOL", function () {
    return CONTENT_GRID_TEMPLATE_IM_SYMBOL;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_IM_CLASSNAME", function () {
    return CONTENT_GRID_TEMPLATE_IM_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_IO_CODE", function () {
    return CONTENT_GRID_TEMPLATE_IO_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_IO_SYMBOL", function () {
    return CONTENT_GRID_TEMPLATE_IO_SYMBOL;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_IO_CLASSNAME", function () {
    return CONTENT_GRID_TEMPLATE_IO_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_ST_CODE", function () {
    return CONTENT_GRID_TEMPLATE_ST_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_ST_SYMBOL", function () {
    return CONTENT_GRID_TEMPLATE_ST_SYMBOL;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_ST_CLASSNAME", function () {
    return CONTENT_GRID_TEMPLATE_ST_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_SM_CODE", function () {
    return CONTENT_GRID_TEMPLATE_SM_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_SM_SYMBOL", function () {
    return CONTENT_GRID_TEMPLATE_SM_SYMBOL;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_SM_CLASSNAME", function () {
    return CONTENT_GRID_TEMPLATE_SM_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_SO_CODE", function () {
    return CONTENT_GRID_TEMPLATE_SO_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_SO_SYMBOL", function () {
    return CONTENT_GRID_TEMPLATE_SO_SYMBOL;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_SO_CLASSNAME", function () {
    return CONTENT_GRID_TEMPLATE_SO_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_TE_CODE", function () {
    return CONTENT_GRID_TEMPLATE_TE_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_TE_SYMBOL", function () {
    return CONTENT_GRID_TEMPLATE_TE_SYMBOL;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_TE_CLASSNAME", function () {
    return CONTENT_GRID_TEMPLATE_TE_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_TI_CODE", function () {
    return CONTENT_GRID_TEMPLATE_TI_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_TI_SYMBOL", function () {
    return CONTENT_GRID_TEMPLATE_TI_SYMBOL;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_TI_CLASSNAME", function () {
    return CONTENT_GRID_TEMPLATE_TI_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_TS_CODE", function () {
    return CONTENT_GRID_TEMPLATE_TS_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_TS_SYMBOL", function () {
    return CONTENT_GRID_TEMPLATE_TS_SYMBOL;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_TS_CLASSNAME", function () {
    return CONTENT_GRID_TEMPLATE_TS_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_ME_CODE", function () {
    return CONTENT_GRID_TEMPLATE_ME_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_ME_SYMBOL", function () {
    return CONTENT_GRID_TEMPLATE_ME_SYMBOL;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_ME_CLASSNAME", function () {
    return CONTENT_GRID_TEMPLATE_ME_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_MI_CODE", function () {
    return CONTENT_GRID_TEMPLATE_MI_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_MI_SYMBOL", function () {
    return CONTENT_GRID_TEMPLATE_MI_SYMBOL;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_MI_CLASSNAME", function () {
    return CONTENT_GRID_TEMPLATE_MI_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_MS_CODE", function () {
    return CONTENT_GRID_TEMPLATE_MS_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_MS_SYMBOL", function () {
    return CONTENT_GRID_TEMPLATE_MS_SYMBOL;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_MS_CLASSNAME", function () {
    return CONTENT_GRID_TEMPLATE_MS_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_OE_CODE", function () {
    return CONTENT_GRID_TEMPLATE_OE_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_OE_SYMBOL", function () {
    return CONTENT_GRID_TEMPLATE_OE_SYMBOL;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_OE_CLASSNAME", function () {
    return CONTENT_GRID_TEMPLATE_OE_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_OI_CODE", function () {
    return CONTENT_GRID_TEMPLATE_OI_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_OI_SYMBOL", function () {
    return CONTENT_GRID_TEMPLATE_OI_SYMBOL;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_OI_CLASSNAME", function () {
    return CONTENT_GRID_TEMPLATE_OI_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_OS_CODE", function () {
    return CONTENT_GRID_TEMPLATE_OS_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_OS_SYMBOL", function () {
    return CONTENT_GRID_TEMPLATE_OS_SYMBOL;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_OS_CLASSNAME", function () {
    return CONTENT_GRID_TEMPLATE_OS_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_ETE_CODE", function () {
    return CONTENT_GRID_TEMPLATE_ETE_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_ETE_SYMBOL", function () {
    return CONTENT_GRID_TEMPLATE_ETE_SYMBOL;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_ETE_CLASSNAME", function () {
    return CONTENT_GRID_TEMPLATE_ETE_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_ETI_CODE", function () {
    return CONTENT_GRID_TEMPLATE_ETI_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_ETI_SYMBOL", function () {
    return CONTENT_GRID_TEMPLATE_ETI_SYMBOL;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_ETI_CLASSNAME", function () {
    return CONTENT_GRID_TEMPLATE_ETI_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_ETS_CODE", function () {
    return CONTENT_GRID_TEMPLATE_ETS_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_ETS_SYMBOL", function () {
    return CONTENT_GRID_TEMPLATE_ETS_SYMBOL;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_ETS_CLASSNAME", function () {
    return CONTENT_GRID_TEMPLATE_ETS_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_EME_CODE", function () {
    return CONTENT_GRID_TEMPLATE_EME_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_EME_SYMBOL", function () {
    return CONTENT_GRID_TEMPLATE_EME_SYMBOL;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_EME_CLASSNAME", function () {
    return CONTENT_GRID_TEMPLATE_EME_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_EMI_CODE", function () {
    return CONTENT_GRID_TEMPLATE_EMI_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_EMI_SYMBOL", function () {
    return CONTENT_GRID_TEMPLATE_EMI_SYMBOL;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_EMI_CLASSNAME", function () {
    return CONTENT_GRID_TEMPLATE_EMI_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_EMS_CODE", function () {
    return CONTENT_GRID_TEMPLATE_EMS_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_EMS_SYMBOL", function () {
    return CONTENT_GRID_TEMPLATE_EMS_SYMBOL;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_EMS_CLASSNAME", function () {
    return CONTENT_GRID_TEMPLATE_EMS_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_EOE_CODE", function () {
    return CONTENT_GRID_TEMPLATE_EOE_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_EOE_SYMBOL", function () {
    return CONTENT_GRID_TEMPLATE_EOE_SYMBOL;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_EOE_CLASSNAME", function () {
    return CONTENT_GRID_TEMPLATE_EOE_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_EOI_CODE", function () {
    return CONTENT_GRID_TEMPLATE_EOI_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_EOI_SYMBOL", function () {
    return CONTENT_GRID_TEMPLATE_EOI_SYMBOL;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_EOI_CLASSNAME", function () {
    return CONTENT_GRID_TEMPLATE_EOI_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_EOS_CODE", function () {
    return CONTENT_GRID_TEMPLATE_EOS_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_EOS_SYMBOL", function () {
    return CONTENT_GRID_TEMPLATE_EOS_SYMBOL;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_EOS_CLASSNAME", function () {
    return CONTENT_GRID_TEMPLATE_EOS_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_ITE_CODE", function () {
    return CONTENT_GRID_TEMPLATE_ITE_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_ITE_SYMBOL", function () {
    return CONTENT_GRID_TEMPLATE_ITE_SYMBOL;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_ITE_CLASSNAME", function () {
    return CONTENT_GRID_TEMPLATE_ITE_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_ITI_CODE", function () {
    return CONTENT_GRID_TEMPLATE_ITI_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_ITI_SYMBOL", function () {
    return CONTENT_GRID_TEMPLATE_ITI_SYMBOL;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_ITI_CLASSNAME", function () {
    return CONTENT_GRID_TEMPLATE_ITI_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_ITS_CODE", function () {
    return CONTENT_GRID_TEMPLATE_ITS_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_ITS_SYMBOL", function () {
    return CONTENT_GRID_TEMPLATE_ITS_SYMBOL;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_ITS_CLASSNAME", function () {
    return CONTENT_GRID_TEMPLATE_ITS_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_IME_CODE", function () {
    return CONTENT_GRID_TEMPLATE_IME_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_IME_SYMBOL", function () {
    return CONTENT_GRID_TEMPLATE_IME_SYMBOL;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_IME_CLASSNAME", function () {
    return CONTENT_GRID_TEMPLATE_IME_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_IMI_CODE", function () {
    return CONTENT_GRID_TEMPLATE_IMI_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_IMI_SYMBOL", function () {
    return CONTENT_GRID_TEMPLATE_IMI_SYMBOL;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_IMI_CLASSNAME", function () {
    return CONTENT_GRID_TEMPLATE_IMI_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_IMS_CODE", function () {
    return CONTENT_GRID_TEMPLATE_IMS_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_IMS_SYMBOL", function () {
    return CONTENT_GRID_TEMPLATE_IMS_SYMBOL;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_IMS_CLASSNAME", function () {
    return CONTENT_GRID_TEMPLATE_IMS_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_IOE_CODE", function () {
    return CONTENT_GRID_TEMPLATE_IOE_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_IOE_SYMBOL", function () {
    return CONTENT_GRID_TEMPLATE_IOE_SYMBOL;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_IOE_CLASSNAME", function () {
    return CONTENT_GRID_TEMPLATE_IOE_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_IOI_CODE", function () {
    return CONTENT_GRID_TEMPLATE_IOI_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_IOI_SYMBOL", function () {
    return CONTENT_GRID_TEMPLATE_IOI_SYMBOL;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_IOI_CLASSNAME", function () {
    return CONTENT_GRID_TEMPLATE_IOI_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_IOS_CODE", function () {
    return CONTENT_GRID_TEMPLATE_IOS_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_IOS_SYMBOL", function () {
    return CONTENT_GRID_TEMPLATE_IOS_SYMBOL;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_IOS_CLASSNAME", function () {
    return CONTENT_GRID_TEMPLATE_IOS_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_STE_CODE", function () {
    return CONTENT_GRID_TEMPLATE_STE_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_STE_SYMBOL", function () {
    return CONTENT_GRID_TEMPLATE_STE_SYMBOL;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_STE_CLASSNAME", function () {
    return CONTENT_GRID_TEMPLATE_STE_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_STI_CODE", function () {
    return CONTENT_GRID_TEMPLATE_STI_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_STI_SYMBOL", function () {
    return CONTENT_GRID_TEMPLATE_STI_SYMBOL;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_STI_CLASSNAME", function () {
    return CONTENT_GRID_TEMPLATE_STI_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_STS_CODE", function () {
    return CONTENT_GRID_TEMPLATE_STS_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_STS_SYMBOL", function () {
    return CONTENT_GRID_TEMPLATE_STS_SYMBOL;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_STS_CLASSNAME", function () {
    return CONTENT_GRID_TEMPLATE_STS_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_SME_CODE", function () {
    return CONTENT_GRID_TEMPLATE_SME_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_SME_SYMBOL", function () {
    return CONTENT_GRID_TEMPLATE_SME_SYMBOL;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_SME_CLASSNAME", function () {
    return CONTENT_GRID_TEMPLATE_SME_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_SMI_CODE", function () {
    return CONTENT_GRID_TEMPLATE_SMI_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_SMI_SYMBOL", function () {
    return CONTENT_GRID_TEMPLATE_SMI_SYMBOL;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_SMI_CLASSNAME", function () {
    return CONTENT_GRID_TEMPLATE_SMI_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_SMS_CODE", function () {
    return CONTENT_GRID_TEMPLATE_SMS_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_SMS_SYMBOL", function () {
    return CONTENT_GRID_TEMPLATE_SMS_SYMBOL;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_SMS_CLASSNAME", function () {
    return CONTENT_GRID_TEMPLATE_SMS_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_SOE_CODE", function () {
    return CONTENT_GRID_TEMPLATE_SOE_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_SOE_SYMBOL", function () {
    return CONTENT_GRID_TEMPLATE_SOE_SYMBOL;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_SOE_CLASSNAME", function () {
    return CONTENT_GRID_TEMPLATE_SOE_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_SOI_CODE", function () {
    return CONTENT_GRID_TEMPLATE_SOI_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_SOI_SYMBOL", function () {
    return CONTENT_GRID_TEMPLATE_SOI_SYMBOL;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_SOI_CLASSNAME", function () {
    return CONTENT_GRID_TEMPLATE_SOI_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_SOS_CODE", function () {
    return CONTENT_GRID_TEMPLATE_SOS_CODE;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_SOS_SYMBOL", function () {
    return CONTENT_GRID_TEMPLATE_SOS_SYMBOL;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE_SOS_CLASSNAME", function () {
    return CONTENT_GRID_TEMPLATE_SOS_CLASSNAME;
  });

  __webpack_require__.d(tokens_namespaceObject, "CONTENT_GRID_TEMPLATE", function () {
    return CONTENT_GRID_TEMPLATE;
  }); // EXTERNAL MODULE: /__w/sage-lib/sage-lib/node_modules/@babel/runtime/helpers/extends.js


  var helpers_extends = __webpack_require__(2);

  var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends); // EXTERNAL MODULE: /__w/sage-lib/sage-lib/node_modules/@babel/runtime/helpers/objectWithoutProperties.js


  var objectWithoutProperties = __webpack_require__(5);

  var objectWithoutProperties_default = /*#__PURE__*/__webpack_require__.n(objectWithoutProperties); // EXTERNAL MODULE: external "react"


  var external_react_ = __webpack_require__(1);

  var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_); // EXTERNAL MODULE: /__w/sage-lib/sage-lib/node_modules/prop-types/index.js


  var prop_types = __webpack_require__(0);

  var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types); // EXTERNAL MODULE: /__w/sage-lib/sage-lib/node_modules/classnames/index.js


  var classnames = __webpack_require__(4);

  var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames); // CONCATENATED MODULE: ./lib/Accordion/Accordion.jsx


  var _excluded = ["className", "children", "id", "onlyOnePanelExpanded"];

  var Accordion_Accordion = function Accordion(_ref) {
    var className = _ref.className,
        children = _ref.children,
        id = _ref.id,
        onlyOnePanelExpanded = _ref.onlyOnePanelExpanded,
        rest = objectWithoutProperties_default()(_ref, _excluded);
    var classNames = classnames_default()('sage-accordion', className, {
      'sage-accordion--one-panel-expanded': onlyOnePanelExpanded
    });
    return /*#__PURE__*/external_react_default.a.createElement("div", extends_default()({
      className: classNames
    }, rest), children);
  };

  Accordion_Accordion.defaultProps = {
    children: null,
    className: '',
    id: '',
    onlyOnePanelExpanded: false
  };
  Accordion_Accordion.propTypes = {
    children: prop_types_default.a.node,
    className: prop_types_default.a.string,
    id: prop_types_default.a.string,
    onlyOnePanelExpanded: prop_types_default.a.bool
  }; // CONCATENATED MODULE: ./lib/Accordion/index.js
  // EXTERNAL MODULE: /__w/sage-lib/sage-lib/node_modules/@babel/runtime/helpers/defineProperty.js

  var defineProperty = __webpack_require__(3);

  var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty); // EXTERNAL MODULE: /__w/sage-lib/sage-lib/node_modules/@babel/runtime/helpers/slicedToArray.js


  var slicedToArray = __webpack_require__(6);

  var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray); // CONCATENATED MODULE: ./lib/configs/dictionary/tokens.js
  //
  // Sage Dictionary tokens
  //
  // Note: The contents of this file are generated by Style Dictionary
  // and should not be modified directly here.
  // See `/style-dictionary` directory for tokens and configurations.
  //
  // ----------
  //
  // Category: COLOR
  //
  // ----------
  //
  // Type: BASE
  //
  //
  // Static vars for COLOR BASE
  //


  var COLOR_BASE_PRIMARY_100_HEX = '#e6f4fe';
  var COLOR_BASE_PRIMARY_100_CODE = 'primary-100';
  var COLOR_BASE_PRIMARY_100_CLASSNAME = 't-sage--color-primary-100';
  var COLOR_BASE_PRIMARY_200_HEX = '#8ecafb';
  var COLOR_BASE_PRIMARY_200_CODE = 'primary-200';
  var COLOR_BASE_PRIMARY_200_CLASSNAME = 't-sage--color-primary-200';
  var COLOR_BASE_PRIMARY_300_HEX = '#0072ef';
  var COLOR_BASE_PRIMARY_300_CODE = 'primary-300';
  var COLOR_BASE_PRIMARY_300_CLASSNAME = 't-sage--color-primary-300';
  var COLOR_BASE_PRIMARY_400_HEX = '#054fb8';
  var COLOR_BASE_PRIMARY_400_CODE = 'primary-400';
  var COLOR_BASE_PRIMARY_400_CLASSNAME = 't-sage--color-primary-400';
  var COLOR_BASE_PRIMARY_500_HEX = '#07265f';
  var COLOR_BASE_PRIMARY_500_CODE = 'primary-500';
  var COLOR_BASE_PRIMARY_500_CLASSNAME = 't-sage--color-primary-500';
  var COLOR_BASE_SAGE_100_HEX = '#ddf8f0';
  var COLOR_BASE_SAGE_100_CODE = 'sage-100';
  var COLOR_BASE_SAGE_100_CLASSNAME = 't-sage--color-sage-100';
  var COLOR_BASE_SAGE_200_HEX = '#86d5bc';
  var COLOR_BASE_SAGE_200_CODE = 'sage-200';
  var COLOR_BASE_SAGE_200_CLASSNAME = 't-sage--color-sage-200';
  var COLOR_BASE_SAGE_300_HEX = '#23856d';
  var COLOR_BASE_SAGE_300_CODE = 'sage-300';
  var COLOR_BASE_SAGE_300_CLASSNAME = 't-sage--color-sage-300';
  var COLOR_BASE_SAGE_400_HEX = '#225d53';
  var COLOR_BASE_SAGE_400_CODE = 'sage-400';
  var COLOR_BASE_SAGE_400_CLASSNAME = 't-sage--color-sage-400';
  var COLOR_BASE_SAGE_500_HEX = '#183e3b';
  var COLOR_BASE_SAGE_500_CODE = 'sage-500';
  var COLOR_BASE_SAGE_500_CLASSNAME = 't-sage--color-sage-500';
  var COLOR_BASE_YELLOW_100_HEX = '#fef8e1';
  var COLOR_BASE_YELLOW_100_CODE = 'yellow-100';
  var COLOR_BASE_YELLOW_100_CLASSNAME = 't-sage--color-yellow-100';
  var COLOR_BASE_YELLOW_200_HEX = '#fad980';
  var COLOR_BASE_YELLOW_200_CODE = 'yellow-200';
  var COLOR_BASE_YELLOW_200_CLASSNAME = 't-sage--color-yellow-200';
  var COLOR_BASE_YELLOW_300_HEX = '#ffc505';
  var COLOR_BASE_YELLOW_300_CODE = 'yellow-300';
  var COLOR_BASE_YELLOW_300_CLASSNAME = 't-sage--color-yellow-300';
  var COLOR_BASE_YELLOW_400_HEX = '#c56a02';
  var COLOR_BASE_YELLOW_400_CODE = 'yellow-400';
  var COLOR_BASE_YELLOW_400_CLASSNAME = 't-sage--color-yellow-400';
  var COLOR_BASE_YELLOW_500_HEX = '#8c3b08';
  var COLOR_BASE_YELLOW_500_CODE = 'yellow-500';
  var COLOR_BASE_YELLOW_500_CLASSNAME = 't-sage--color-yellow-500';
  var COLOR_BASE_RED_100_HEX = '#fff0f0';
  var COLOR_BASE_RED_100_CODE = 'red-100';
  var COLOR_BASE_RED_100_CLASSNAME = 't-sage--color-red-100';
  var COLOR_BASE_RED_200_HEX = '#fdb0aa';
  var COLOR_BASE_RED_200_CODE = 'red-200';
  var COLOR_BASE_RED_200_CLASSNAME = 't-sage--color-red-200';
  var COLOR_BASE_RED_300_HEX = '#cf3c32';
  var COLOR_BASE_RED_300_CODE = 'red-300';
  var COLOR_BASE_RED_300_CLASSNAME = 't-sage--color-red-300';
  var COLOR_BASE_RED_400_HEX = '#99221e';
  var COLOR_BASE_RED_400_CODE = 'red-400';
  var COLOR_BASE_RED_400_CLASSNAME = 't-sage--color-red-400';
  var COLOR_BASE_RED_500_HEX = '#5e0d0d';
  var COLOR_BASE_RED_500_CODE = 'red-500';
  var COLOR_BASE_RED_500_CLASSNAME = 't-sage--color-red-500';
  var COLOR_BASE_ORANGE_100_HEX = '#fef1e1';
  var COLOR_BASE_ORANGE_100_CODE = 'orange-100';
  var COLOR_BASE_ORANGE_100_CLASSNAME = 't-sage--color-orange-100';
  var COLOR_BASE_ORANGE_200_HEX = '#ffb36b';
  var COLOR_BASE_ORANGE_200_CODE = 'orange-200';
  var COLOR_BASE_ORANGE_200_CLASSNAME = 't-sage--color-orange-200';
  var COLOR_BASE_ORANGE_300_HEX = '#fb7e09';
  var COLOR_BASE_ORANGE_300_CODE = 'orange-300';
  var COLOR_BASE_ORANGE_300_CLASSNAME = 't-sage--color-orange-300';
  var COLOR_BASE_ORANGE_400_HEX = '#b3501e';
  var COLOR_BASE_ORANGE_400_CODE = 'orange-400';
  var COLOR_BASE_ORANGE_400_CLASSNAME = 't-sage--color-orange-400';
  var COLOR_BASE_ORANGE_500_HEX = '#5a260c';
  var COLOR_BASE_ORANGE_500_CODE = 'orange-500';
  var COLOR_BASE_ORANGE_500_CLASSNAME = 't-sage--color-orange-500';
  var COLOR_BASE_PURPLE_100_HEX = '#eee4f6';
  var COLOR_BASE_PURPLE_100_CODE = 'purple-100';
  var COLOR_BASE_PURPLE_100_CLASSNAME = 't-sage--color-purple-100';
  var COLOR_BASE_PURPLE_200_HEX = '#d9c2ef';
  var COLOR_BASE_PURPLE_200_CODE = 'purple-200';
  var COLOR_BASE_PURPLE_200_CLASSNAME = 't-sage--color-purple-200';
  var COLOR_BASE_PURPLE_300_HEX = '#8e5ad8';
  var COLOR_BASE_PURPLE_300_CODE = 'purple-300';
  var COLOR_BASE_PURPLE_300_CLASSNAME = 't-sage--color-purple-300';
  var COLOR_BASE_PURPLE_400_HEX = '#50348a';
  var COLOR_BASE_PURPLE_400_CODE = 'purple-400';
  var COLOR_BASE_PURPLE_400_CLASSNAME = 't-sage--color-purple-400';
  var COLOR_BASE_PURPLE_500_HEX = '#381c5e';
  var COLOR_BASE_PURPLE_500_CODE = 'purple-500';
  var COLOR_BASE_PURPLE_500_CLASSNAME = 't-sage--color-purple-500';
  var COLOR_BASE_CHARCOAL_100_HEX = '#8d939a';
  var COLOR_BASE_CHARCOAL_100_CODE = 'charcoal-100';
  var COLOR_BASE_CHARCOAL_100_CLASSNAME = 't-sage--color-charcoal-100';
  var COLOR_BASE_CHARCOAL_200_HEX = '#60666c';
  var COLOR_BASE_CHARCOAL_200_CODE = 'charcoal-200';
  var COLOR_BASE_CHARCOAL_200_CLASSNAME = 't-sage--color-charcoal-200';
  var COLOR_BASE_CHARCOAL_300_HEX = '#43474b';
  var COLOR_BASE_CHARCOAL_300_CODE = 'charcoal-300';
  var COLOR_BASE_CHARCOAL_300_CLASSNAME = 't-sage--color-charcoal-300';
  var COLOR_BASE_CHARCOAL_400_HEX = '#202327';
  var COLOR_BASE_CHARCOAL_400_CODE = 'charcoal-400';
  var COLOR_BASE_CHARCOAL_400_CLASSNAME = 't-sage--color-charcoal-400';
  var COLOR_BASE_CHARCOAL_500_HEX = '#040506';
  var COLOR_BASE_CHARCOAL_500_CODE = 'charcoal-500';
  var COLOR_BASE_CHARCOAL_500_CLASSNAME = 't-sage--color-charcoal-500';
  var COLOR_BASE_GREY_100_HEX = '#f9fafa';
  var COLOR_BASE_GREY_100_CODE = 'grey-100';
  var COLOR_BASE_GREY_100_CLASSNAME = 't-sage--color-grey-100';
  var COLOR_BASE_GREY_200_HEX = '#f6f8f8';
  var COLOR_BASE_GREY_200_CODE = 'grey-200';
  var COLOR_BASE_GREY_200_CLASSNAME = 't-sage--color-grey-200';
  var COLOR_BASE_GREY_300_HEX = '#eceeef';
  var COLOR_BASE_GREY_300_CODE = 'grey-300';
  var COLOR_BASE_GREY_300_CLASSNAME = 't-sage--color-grey-300';
  var COLOR_BASE_GREY_400_HEX = '#d3d5d9';
  var COLOR_BASE_GREY_400_CODE = 'grey-400';
  var COLOR_BASE_GREY_400_CLASSNAME = 't-sage--color-grey-400';
  var COLOR_BASE_GREY_500_HEX = '#b5bac0';
  var COLOR_BASE_GREY_500_CODE = 'grey-500';
  var COLOR_BASE_GREY_500_CLASSNAME = 't-sage--color-grey-500';
  var COLOR_BASE_WHITE_100_HEX = '#fff';
  var COLOR_BASE_WHITE_100_CODE = 'white-100';
  var COLOR_BASE_WHITE_100_CLASSNAME = 't-sage--color-white-100';
  var COLOR_BASE_WHITE_200_HEX = '#fff';
  var COLOR_BASE_WHITE_200_CODE = 'white-200';
  var COLOR_BASE_WHITE_200_CLASSNAME = 't-sage--color-white-200';
  var COLOR_BASE_WHITE_300_HEX = '#fff';
  var COLOR_BASE_WHITE_300_CODE = 'white-300';
  var COLOR_BASE_WHITE_300_CLASSNAME = 't-sage--color-white-300';
  var COLOR_BASE_WHITE_400_HEX = '#fff';
  var COLOR_BASE_WHITE_400_CODE = 'white-400';
  var COLOR_BASE_WHITE_400_CLASSNAME = 't-sage--color-white-400';
  var COLOR_BASE_WHITE_500_HEX = '#fff';
  var COLOR_BASE_WHITE_500_CODE = 'white-500';
  var COLOR_BASE_WHITE_500_CLASSNAME = 't-sage--color-white-500';
  var COLOR_BASE_BLACK_100_HEX = '#000';
  var COLOR_BASE_BLACK_100_CODE = 'black-100';
  var COLOR_BASE_BLACK_100_CLASSNAME = 't-sage--color-black-100';
  var COLOR_BASE_BLACK_200_HEX = '#000';
  var COLOR_BASE_BLACK_200_CODE = 'black-200';
  var COLOR_BASE_BLACK_200_CLASSNAME = 't-sage--color-black-200';
  var COLOR_BASE_BLACK_300_HEX = '#000';
  var COLOR_BASE_BLACK_300_CODE = 'black-300';
  var COLOR_BASE_BLACK_300_CLASSNAME = 't-sage--color-black-300';
  var COLOR_BASE_BLACK_400_HEX = '#000';
  var COLOR_BASE_BLACK_400_CODE = 'black-400';
  var COLOR_BASE_BLACK_400_CLASSNAME = 't-sage--color-black-400';
  var COLOR_BASE_BLACK_500_HEX = '#000';
  var COLOR_BASE_BLACK_500_CODE = 'black-500';
  var COLOR_BASE_BLACK_500_CLASSNAME = 't-sage--color-black-500'; //
  // Map for COLOR BASE
  //

  var COLOR = {
    PRIMARY: {
      100: {
        HEX: COLOR_BASE_PRIMARY_100_HEX,
        CODE: COLOR_BASE_PRIMARY_100_CODE,
        CLASSNAME: COLOR_BASE_PRIMARY_100_CLASSNAME
      },
      200: {
        HEX: COLOR_BASE_PRIMARY_200_HEX,
        CODE: COLOR_BASE_PRIMARY_200_CODE,
        CLASSNAME: COLOR_BASE_PRIMARY_200_CLASSNAME
      },
      300: {
        HEX: COLOR_BASE_PRIMARY_300_HEX,
        CODE: COLOR_BASE_PRIMARY_300_CODE,
        CLASSNAME: COLOR_BASE_PRIMARY_300_CLASSNAME
      },
      400: {
        HEX: COLOR_BASE_PRIMARY_400_HEX,
        CODE: COLOR_BASE_PRIMARY_400_CODE,
        CLASSNAME: COLOR_BASE_PRIMARY_400_CLASSNAME
      },
      500: {
        HEX: COLOR_BASE_PRIMARY_500_HEX,
        CODE: COLOR_BASE_PRIMARY_500_CODE,
        CLASSNAME: COLOR_BASE_PRIMARY_500_CLASSNAME
      }
    },
    SAGE: {
      100: {
        HEX: COLOR_BASE_SAGE_100_HEX,
        CODE: COLOR_BASE_SAGE_100_CODE,
        CLASSNAME: COLOR_BASE_SAGE_100_CLASSNAME
      },
      200: {
        HEX: COLOR_BASE_SAGE_200_HEX,
        CODE: COLOR_BASE_SAGE_200_CODE,
        CLASSNAME: COLOR_BASE_SAGE_200_CLASSNAME
      },
      300: {
        HEX: COLOR_BASE_SAGE_300_HEX,
        CODE: COLOR_BASE_SAGE_300_CODE,
        CLASSNAME: COLOR_BASE_SAGE_300_CLASSNAME
      },
      400: {
        HEX: COLOR_BASE_SAGE_400_HEX,
        CODE: COLOR_BASE_SAGE_400_CODE,
        CLASSNAME: COLOR_BASE_SAGE_400_CLASSNAME
      },
      500: {
        HEX: COLOR_BASE_SAGE_500_HEX,
        CODE: COLOR_BASE_SAGE_500_CODE,
        CLASSNAME: COLOR_BASE_SAGE_500_CLASSNAME
      }
    },
    YELLOW: {
      100: {
        HEX: COLOR_BASE_YELLOW_100_HEX,
        CODE: COLOR_BASE_YELLOW_100_CODE,
        CLASSNAME: COLOR_BASE_YELLOW_100_CLASSNAME
      },
      200: {
        HEX: COLOR_BASE_YELLOW_200_HEX,
        CODE: COLOR_BASE_YELLOW_200_CODE,
        CLASSNAME: COLOR_BASE_YELLOW_200_CLASSNAME
      },
      300: {
        HEX: COLOR_BASE_YELLOW_300_HEX,
        CODE: COLOR_BASE_YELLOW_300_CODE,
        CLASSNAME: COLOR_BASE_YELLOW_300_CLASSNAME
      },
      400: {
        HEX: COLOR_BASE_YELLOW_400_HEX,
        CODE: COLOR_BASE_YELLOW_400_CODE,
        CLASSNAME: COLOR_BASE_YELLOW_400_CLASSNAME
      },
      500: {
        HEX: COLOR_BASE_YELLOW_500_HEX,
        CODE: COLOR_BASE_YELLOW_500_CODE,
        CLASSNAME: COLOR_BASE_YELLOW_500_CLASSNAME
      }
    },
    RED: {
      100: {
        HEX: COLOR_BASE_RED_100_HEX,
        CODE: COLOR_BASE_RED_100_CODE,
        CLASSNAME: COLOR_BASE_RED_100_CLASSNAME
      },
      200: {
        HEX: COLOR_BASE_RED_200_HEX,
        CODE: COLOR_BASE_RED_200_CODE,
        CLASSNAME: COLOR_BASE_RED_200_CLASSNAME
      },
      300: {
        HEX: COLOR_BASE_RED_300_HEX,
        CODE: COLOR_BASE_RED_300_CODE,
        CLASSNAME: COLOR_BASE_RED_300_CLASSNAME
      },
      400: {
        HEX: COLOR_BASE_RED_400_HEX,
        CODE: COLOR_BASE_RED_400_CODE,
        CLASSNAME: COLOR_BASE_RED_400_CLASSNAME
      },
      500: {
        HEX: COLOR_BASE_RED_500_HEX,
        CODE: COLOR_BASE_RED_500_CODE,
        CLASSNAME: COLOR_BASE_RED_500_CLASSNAME
      }
    },
    ORANGE: {
      100: {
        HEX: COLOR_BASE_ORANGE_100_HEX,
        CODE: COLOR_BASE_ORANGE_100_CODE,
        CLASSNAME: COLOR_BASE_ORANGE_100_CLASSNAME
      },
      200: {
        HEX: COLOR_BASE_ORANGE_200_HEX,
        CODE: COLOR_BASE_ORANGE_200_CODE,
        CLASSNAME: COLOR_BASE_ORANGE_200_CLASSNAME
      },
      300: {
        HEX: COLOR_BASE_ORANGE_300_HEX,
        CODE: COLOR_BASE_ORANGE_300_CODE,
        CLASSNAME: COLOR_BASE_ORANGE_300_CLASSNAME
      },
      400: {
        HEX: COLOR_BASE_ORANGE_400_HEX,
        CODE: COLOR_BASE_ORANGE_400_CODE,
        CLASSNAME: COLOR_BASE_ORANGE_400_CLASSNAME
      },
      500: {
        HEX: COLOR_BASE_ORANGE_500_HEX,
        CODE: COLOR_BASE_ORANGE_500_CODE,
        CLASSNAME: COLOR_BASE_ORANGE_500_CLASSNAME
      }
    },
    PURPLE: {
      100: {
        HEX: COLOR_BASE_PURPLE_100_HEX,
        CODE: COLOR_BASE_PURPLE_100_CODE,
        CLASSNAME: COLOR_BASE_PURPLE_100_CLASSNAME
      },
      200: {
        HEX: COLOR_BASE_PURPLE_200_HEX,
        CODE: COLOR_BASE_PURPLE_200_CODE,
        CLASSNAME: COLOR_BASE_PURPLE_200_CLASSNAME
      },
      300: {
        HEX: COLOR_BASE_PURPLE_300_HEX,
        CODE: COLOR_BASE_PURPLE_300_CODE,
        CLASSNAME: COLOR_BASE_PURPLE_300_CLASSNAME
      },
      400: {
        HEX: COLOR_BASE_PURPLE_400_HEX,
        CODE: COLOR_BASE_PURPLE_400_CODE,
        CLASSNAME: COLOR_BASE_PURPLE_400_CLASSNAME
      },
      500: {
        HEX: COLOR_BASE_PURPLE_500_HEX,
        CODE: COLOR_BASE_PURPLE_500_CODE,
        CLASSNAME: COLOR_BASE_PURPLE_500_CLASSNAME
      }
    },
    CHARCOAL: {
      100: {
        HEX: COLOR_BASE_CHARCOAL_100_HEX,
        CODE: COLOR_BASE_CHARCOAL_100_CODE,
        CLASSNAME: COLOR_BASE_CHARCOAL_100_CLASSNAME
      },
      200: {
        HEX: COLOR_BASE_CHARCOAL_200_HEX,
        CODE: COLOR_BASE_CHARCOAL_200_CODE,
        CLASSNAME: COLOR_BASE_CHARCOAL_200_CLASSNAME
      },
      300: {
        HEX: COLOR_BASE_CHARCOAL_300_HEX,
        CODE: COLOR_BASE_CHARCOAL_300_CODE,
        CLASSNAME: COLOR_BASE_CHARCOAL_300_CLASSNAME
      },
      400: {
        HEX: COLOR_BASE_CHARCOAL_400_HEX,
        CODE: COLOR_BASE_CHARCOAL_400_CODE,
        CLASSNAME: COLOR_BASE_CHARCOAL_400_CLASSNAME
      },
      500: {
        HEX: COLOR_BASE_CHARCOAL_500_HEX,
        CODE: COLOR_BASE_CHARCOAL_500_CODE,
        CLASSNAME: COLOR_BASE_CHARCOAL_500_CLASSNAME
      }
    },
    GREY: {
      100: {
        HEX: COLOR_BASE_GREY_100_HEX,
        CODE: COLOR_BASE_GREY_100_CODE,
        CLASSNAME: COLOR_BASE_GREY_100_CLASSNAME
      },
      200: {
        HEX: COLOR_BASE_GREY_200_HEX,
        CODE: COLOR_BASE_GREY_200_CODE,
        CLASSNAME: COLOR_BASE_GREY_200_CLASSNAME
      },
      300: {
        HEX: COLOR_BASE_GREY_300_HEX,
        CODE: COLOR_BASE_GREY_300_CODE,
        CLASSNAME: COLOR_BASE_GREY_300_CLASSNAME
      },
      400: {
        HEX: COLOR_BASE_GREY_400_HEX,
        CODE: COLOR_BASE_GREY_400_CODE,
        CLASSNAME: COLOR_BASE_GREY_400_CLASSNAME
      },
      500: {
        HEX: COLOR_BASE_GREY_500_HEX,
        CODE: COLOR_BASE_GREY_500_CODE,
        CLASSNAME: COLOR_BASE_GREY_500_CLASSNAME
      }
    },
    WHITE: {
      100: {
        HEX: COLOR_BASE_WHITE_100_HEX,
        CODE: COLOR_BASE_WHITE_100_CODE,
        CLASSNAME: COLOR_BASE_WHITE_100_CLASSNAME
      },
      200: {
        HEX: COLOR_BASE_WHITE_200_HEX,
        CODE: COLOR_BASE_WHITE_200_CODE,
        CLASSNAME: COLOR_BASE_WHITE_200_CLASSNAME
      },
      300: {
        HEX: COLOR_BASE_WHITE_300_HEX,
        CODE: COLOR_BASE_WHITE_300_CODE,
        CLASSNAME: COLOR_BASE_WHITE_300_CLASSNAME
      },
      400: {
        HEX: COLOR_BASE_WHITE_400_HEX,
        CODE: COLOR_BASE_WHITE_400_CODE,
        CLASSNAME: COLOR_BASE_WHITE_400_CLASSNAME
      },
      500: {
        HEX: COLOR_BASE_WHITE_500_HEX,
        CODE: COLOR_BASE_WHITE_500_CODE,
        CLASSNAME: COLOR_BASE_WHITE_500_CLASSNAME
      }
    },
    BLACK: {
      100: {
        HEX: COLOR_BASE_BLACK_100_HEX,
        CODE: COLOR_BASE_BLACK_100_CODE,
        CLASSNAME: COLOR_BASE_BLACK_100_CLASSNAME
      },
      200: {
        HEX: COLOR_BASE_BLACK_200_HEX,
        CODE: COLOR_BASE_BLACK_200_CODE,
        CLASSNAME: COLOR_BASE_BLACK_200_CLASSNAME
      },
      300: {
        HEX: COLOR_BASE_BLACK_300_HEX,
        CODE: COLOR_BASE_BLACK_300_CODE,
        CLASSNAME: COLOR_BASE_BLACK_300_CLASSNAME
      },
      400: {
        HEX: COLOR_BASE_BLACK_400_HEX,
        CODE: COLOR_BASE_BLACK_400_CODE,
        CLASSNAME: COLOR_BASE_BLACK_400_CLASSNAME
      },
      500: {
        HEX: COLOR_BASE_BLACK_500_HEX,
        CODE: COLOR_BASE_BLACK_500_CODE,
        CLASSNAME: COLOR_BASE_BLACK_500_CLASSNAME
      }
    }
  }; //
  // Type: COMBOS
  //
  //
  // Static vars for COLOR COMBOS
  //

  var COLOR_COMBOS_DRAFT_DEFAULT_FOREGROUND = '#202327';
  var COLOR_COMBOS_DRAFT_DEFAULT_FOREGROUND_ACCENT = '#040506';
  var COLOR_COMBOS_DRAFT_DEFAULT_BACKGROUND = '#eceeef';
  var COLOR_COMBOS_DRAFT_DEFAULT_BACKGROUND_ACCENT = '#d3d5d9';
  var COLOR_COMBOS_DRAFT_DEFAULT_ICON_BACKGROUND_ACCENT = '#60666c';
  var COLOR_COMBOS_DRAFT_SUBTLE_FOREGROUND = '#60666c';
  var COLOR_COMBOS_DRAFT_SUBTLE_FOREGROUND_ACCENT = '#8d939a';
  var COLOR_COMBOS_DRAFT_SUBTLE_BACKGROUND = '#8d939a';
  var COLOR_COMBOS_DRAFT_BOLD_FOREGROUND = '#f6f8f8';
  var COLOR_COMBOS_DRAFT_BOLD_BACKGROUND = '#202327';
  var COLOR_COMBOS_PUBLISHED_DEFAULT_FOREGROUND = '#225d53';
  var COLOR_COMBOS_PUBLISHED_DEFAULT_FOREGROUND_ACCENT = '#183e3b';
  var COLOR_COMBOS_PUBLISHED_DEFAULT_BACKGROUND = '#ddf8f0';
  var COLOR_COMBOS_PUBLISHED_DEFAULT_BACKGROUND_ACCENT = '#86d5bc';
  var COLOR_COMBOS_PUBLISHED_DEFAULT_ICON_BACKGROUND_ACCENT = '#23856d';
  var COLOR_COMBOS_PUBLISHED_SUBTLE_FOREGROUND = '#225d53';
  var COLOR_COMBOS_PUBLISHED_SUBTLE_FOREGROUND_ACCENT = '#23856d';
  var COLOR_COMBOS_PUBLISHED_SUBTLE_BACKGROUND = '#23856d';
  var COLOR_COMBOS_PUBLISHED_BOLD_FOREGROUND = '#fff';
  var COLOR_COMBOS_PUBLISHED_BOLD_BACKGROUND = '#23856d';
  var COLOR_COMBOS_INFO_DEFAULT_FOREGROUND = '#054fb8';
  var COLOR_COMBOS_INFO_DEFAULT_FOREGROUND_ACCENT = '#07265f';
  var COLOR_COMBOS_INFO_DEFAULT_BACKGROUND = '#e6f4fe';
  var COLOR_COMBOS_INFO_DEFAULT_BACKGROUND_ACCENT = '#8ecafb';
  var COLOR_COMBOS_INFO_DEFAULT_ICON_BACKGROUND_ACCENT = '#0072ef';
  var COLOR_COMBOS_INFO_SUBTLE_FOREGROUND = '#054fb8';
  var COLOR_COMBOS_INFO_SUBTLE_FOREGROUND_ACCENT = '#0072ef';
  var COLOR_COMBOS_INFO_SUBTLE_BACKGROUND = '#8ecafb';
  var COLOR_COMBOS_INFO_BOLD_FOREGROUND = '#e6f4fe';
  var COLOR_COMBOS_INFO_BOLD_BACKGROUND = '#0072ef';
  var COLOR_COMBOS_LOCKED_DEFAULT_FOREGROUND = '#50348a';
  var COLOR_COMBOS_LOCKED_DEFAULT_FOREGROUND_ACCENT = '#381c5e';
  var COLOR_COMBOS_LOCKED_DEFAULT_BACKGROUND = '#eee4f6';
  var COLOR_COMBOS_LOCKED_DEFAULT_BACKGROUND_ACCENT = '#d9c2ef';
  var COLOR_COMBOS_LOCKED_DEFAULT_ICON_BACKGROUND_ACCENT = '#8e5ad8';
  var COLOR_COMBOS_LOCKED_SUBTLE_FOREGROUND = '#50348a';
  var COLOR_COMBOS_LOCKED_SUBTLE_FOREGROUND_ACCENT = '#8e5ad8';
  var COLOR_COMBOS_LOCKED_SUBTLE_BACKGROUND = '#d9c2ef';
  var COLOR_COMBOS_LOCKED_BOLD_FOREGROUND = '#eee4f6';
  var COLOR_COMBOS_LOCKED_BOLD_BACKGROUND = '#8e5ad8';
  var COLOR_COMBOS_WARNING_DEFAULT_FOREGROUND = '#c56a02';
  var COLOR_COMBOS_WARNING_DEFAULT_FOREGROUND_ACCENT = '#8c3b08';
  var COLOR_COMBOS_WARNING_DEFAULT_BACKGROUND = '#fef8e1';
  var COLOR_COMBOS_WARNING_DEFAULT_BACKGROUND_ACCENT = '#fad980';
  var COLOR_COMBOS_WARNING_DEFAULT_ICON_BACKGROUND_ACCENT = '#c56a02';
  var COLOR_COMBOS_WARNING_SUBTLE_FOREGROUND = '#c56a02';
  var COLOR_COMBOS_WARNING_SUBTLE_FOREGROUND_ACCENT = '#ffc505';
  var COLOR_COMBOS_WARNING_SUBTLE_BACKGROUND = '#ffc505';
  var COLOR_COMBOS_WARNING_BOLD_FOREGROUND = '#fff';
  var COLOR_COMBOS_WARNING_BOLD_BACKGROUND = '#ffc505';
  var COLOR_COMBOS_DANGER_DEFAULT_FOREGROUND = '#99221e';
  var COLOR_COMBOS_DANGER_DEFAULT_FOREGROUND_ACCENT = '#5e0d0d';
  var COLOR_COMBOS_DANGER_DEFAULT_BACKGROUND = '#fff0f0';
  var COLOR_COMBOS_DANGER_DEFAULT_BACKGROUND_ACCENT = '#fdb0aa';
  var COLOR_COMBOS_DANGER_DEFAULT_ICON_BACKGROUND_ACCENT = '#cf3c32';
  var COLOR_COMBOS_DANGER_SUBTLE_FOREGROUND = '#99221e';
  var COLOR_COMBOS_DANGER_SUBTLE_FOREGROUND_ACCENT = '#fdb0aa';
  var COLOR_COMBOS_DANGER_SUBTLE_BACKGROUND = '#fdb0aa';
  var COLOR_COMBOS_DANGER_BOLD_FOREGROUND = '#fff0f0';
  var COLOR_COMBOS_DANGER_BOLD_BACKGROUND = '#fdb0aa';
  var COLOR_COMBOS_PRIMARY_DEFAULT_FOREGROUND = '#fff';
  var COLOR_COMBOS_PRIMARY_DEFAULT_FOREGROUND_ACCENT = '#fff';
  var COLOR_COMBOS_PRIMARY_DEFAULT_BACKGROUND = '#8ecafb';
  var COLOR_COMBOS_PRIMARY_SUBTLE_FOREGROUND = '#fff';
  var COLOR_COMBOS_PRIMARY_SUBTLE_FOREGROUND_ACCENT = '#fff';
  var COLOR_COMBOS_PRIMARY_SUBTLE_BACKGROUND = '#8ecafb';
  var COLOR_COMBOS_PRIMARY_BOLD_FOREGROUND = '#fff';
  var COLOR_COMBOS_PRIMARY_BOLD_BACKGROUND = '#8ecafb'; //
  // Map for COLOR COMBOS
  //

  var COLOR_COMBOS = {
    DRAFT: {
      DEFAULT: {
        FOREGROUND: COLOR_COMBOS_DRAFT_DEFAULT_FOREGROUND,
        FOREGROUND_ACCENT: COLOR_COMBOS_DRAFT_DEFAULT_FOREGROUND_ACCENT,
        BACKGROUND: COLOR_COMBOS_DRAFT_DEFAULT_BACKGROUND,
        BACKGROUND_ACCENT: COLOR_COMBOS_DRAFT_DEFAULT_BACKGROUND_ACCENT,
        ICON_BACKGROUND_ACCENT: COLOR_COMBOS_DRAFT_DEFAULT_ICON_BACKGROUND_ACCENT
      },
      SUBTLE: {
        FOREGROUND: COLOR_COMBOS_DRAFT_SUBTLE_FOREGROUND,
        FOREGROUND_ACCENT: COLOR_COMBOS_DRAFT_SUBTLE_FOREGROUND_ACCENT,
        BACKGROUND: COLOR_COMBOS_DRAFT_SUBTLE_BACKGROUND
      },
      BOLD: {
        FOREGROUND: COLOR_COMBOS_DRAFT_BOLD_FOREGROUND,
        BACKGROUND: COLOR_COMBOS_DRAFT_BOLD_BACKGROUND
      }
    },
    PUBLISHED: {
      DEFAULT: {
        FOREGROUND: COLOR_COMBOS_PUBLISHED_DEFAULT_FOREGROUND,
        FOREGROUND_ACCENT: COLOR_COMBOS_PUBLISHED_DEFAULT_FOREGROUND_ACCENT,
        BACKGROUND: COLOR_COMBOS_PUBLISHED_DEFAULT_BACKGROUND,
        BACKGROUND_ACCENT: COLOR_COMBOS_PUBLISHED_DEFAULT_BACKGROUND_ACCENT,
        ICON_BACKGROUND_ACCENT: COLOR_COMBOS_PUBLISHED_DEFAULT_ICON_BACKGROUND_ACCENT
      },
      SUBTLE: {
        FOREGROUND: COLOR_COMBOS_PUBLISHED_SUBTLE_FOREGROUND,
        FOREGROUND_ACCENT: COLOR_COMBOS_PUBLISHED_SUBTLE_FOREGROUND_ACCENT,
        BACKGROUND: COLOR_COMBOS_PUBLISHED_SUBTLE_BACKGROUND
      },
      BOLD: {
        FOREGROUND: COLOR_COMBOS_PUBLISHED_BOLD_FOREGROUND,
        BACKGROUND: COLOR_COMBOS_PUBLISHED_BOLD_BACKGROUND
      }
    },
    INFO: {
      DEFAULT: {
        FOREGROUND: COLOR_COMBOS_INFO_DEFAULT_FOREGROUND,
        FOREGROUND_ACCENT: COLOR_COMBOS_INFO_DEFAULT_FOREGROUND_ACCENT,
        BACKGROUND: COLOR_COMBOS_INFO_DEFAULT_BACKGROUND,
        BACKGROUND_ACCENT: COLOR_COMBOS_INFO_DEFAULT_BACKGROUND_ACCENT,
        ICON_BACKGROUND_ACCENT: COLOR_COMBOS_INFO_DEFAULT_ICON_BACKGROUND_ACCENT
      },
      SUBTLE: {
        FOREGROUND: COLOR_COMBOS_INFO_SUBTLE_FOREGROUND,
        FOREGROUND_ACCENT: COLOR_COMBOS_INFO_SUBTLE_FOREGROUND_ACCENT,
        BACKGROUND: COLOR_COMBOS_INFO_SUBTLE_BACKGROUND
      },
      BOLD: {
        FOREGROUND: COLOR_COMBOS_INFO_BOLD_FOREGROUND,
        BACKGROUND: COLOR_COMBOS_INFO_BOLD_BACKGROUND
      }
    },
    LOCKED: {
      DEFAULT: {
        FOREGROUND: COLOR_COMBOS_LOCKED_DEFAULT_FOREGROUND,
        FOREGROUND_ACCENT: COLOR_COMBOS_LOCKED_DEFAULT_FOREGROUND_ACCENT,
        BACKGROUND: COLOR_COMBOS_LOCKED_DEFAULT_BACKGROUND,
        BACKGROUND_ACCENT: COLOR_COMBOS_LOCKED_DEFAULT_BACKGROUND_ACCENT,
        ICON_BACKGROUND_ACCENT: COLOR_COMBOS_LOCKED_DEFAULT_ICON_BACKGROUND_ACCENT
      },
      SUBTLE: {
        FOREGROUND: COLOR_COMBOS_LOCKED_SUBTLE_FOREGROUND,
        FOREGROUND_ACCENT: COLOR_COMBOS_LOCKED_SUBTLE_FOREGROUND_ACCENT,
        BACKGROUND: COLOR_COMBOS_LOCKED_SUBTLE_BACKGROUND
      },
      BOLD: {
        FOREGROUND: COLOR_COMBOS_LOCKED_BOLD_FOREGROUND,
        BACKGROUND: COLOR_COMBOS_LOCKED_BOLD_BACKGROUND
      }
    },
    WARNING: {
      DEFAULT: {
        FOREGROUND: COLOR_COMBOS_WARNING_DEFAULT_FOREGROUND,
        FOREGROUND_ACCENT: COLOR_COMBOS_WARNING_DEFAULT_FOREGROUND_ACCENT,
        BACKGROUND: COLOR_COMBOS_WARNING_DEFAULT_BACKGROUND,
        BACKGROUND_ACCENT: COLOR_COMBOS_WARNING_DEFAULT_BACKGROUND_ACCENT,
        ICON_BACKGROUND_ACCENT: COLOR_COMBOS_WARNING_DEFAULT_ICON_BACKGROUND_ACCENT
      },
      SUBTLE: {
        FOREGROUND: COLOR_COMBOS_WARNING_SUBTLE_FOREGROUND,
        FOREGROUND_ACCENT: COLOR_COMBOS_WARNING_SUBTLE_FOREGROUND_ACCENT,
        BACKGROUND: COLOR_COMBOS_WARNING_SUBTLE_BACKGROUND
      },
      BOLD: {
        FOREGROUND: COLOR_COMBOS_WARNING_BOLD_FOREGROUND,
        BACKGROUND: COLOR_COMBOS_WARNING_BOLD_BACKGROUND
      }
    },
    DANGER: {
      DEFAULT: {
        FOREGROUND: COLOR_COMBOS_DANGER_DEFAULT_FOREGROUND,
        FOREGROUND_ACCENT: COLOR_COMBOS_DANGER_DEFAULT_FOREGROUND_ACCENT,
        BACKGROUND: COLOR_COMBOS_DANGER_DEFAULT_BACKGROUND,
        BACKGROUND_ACCENT: COLOR_COMBOS_DANGER_DEFAULT_BACKGROUND_ACCENT,
        ICON_BACKGROUND_ACCENT: COLOR_COMBOS_DANGER_DEFAULT_ICON_BACKGROUND_ACCENT
      },
      SUBTLE: {
        FOREGROUND: COLOR_COMBOS_DANGER_SUBTLE_FOREGROUND,
        FOREGROUND_ACCENT: COLOR_COMBOS_DANGER_SUBTLE_FOREGROUND_ACCENT,
        BACKGROUND: COLOR_COMBOS_DANGER_SUBTLE_BACKGROUND
      },
      BOLD: {
        FOREGROUND: COLOR_COMBOS_DANGER_BOLD_FOREGROUND,
        BACKGROUND: COLOR_COMBOS_DANGER_BOLD_BACKGROUND
      }
    },
    PRIMARY: {
      DEFAULT: {
        FOREGROUND: COLOR_COMBOS_PRIMARY_DEFAULT_FOREGROUND,
        FOREGROUND_ACCENT: COLOR_COMBOS_PRIMARY_DEFAULT_FOREGROUND_ACCENT,
        BACKGROUND: COLOR_COMBOS_PRIMARY_DEFAULT_BACKGROUND
      },
      SUBTLE: {
        FOREGROUND: COLOR_COMBOS_PRIMARY_SUBTLE_FOREGROUND,
        FOREGROUND_ACCENT: COLOR_COMBOS_PRIMARY_SUBTLE_FOREGROUND_ACCENT,
        BACKGROUND: COLOR_COMBOS_PRIMARY_SUBTLE_BACKGROUND
      },
      BOLD: {
        FOREGROUND: COLOR_COMBOS_PRIMARY_BOLD_FOREGROUND,
        BACKGROUND: COLOR_COMBOS_PRIMARY_BOLD_BACKGROUND
      }
    }
  }; //
  // Type: CORE
  //
  //
  // Static vars for COLOR CORE
  //

  var COLOR_CORE_PRIMARY = '#0072ef';
  var COLOR_CORE_SAGE = '#23856d';
  var COLOR_CORE_YELLOW = '#ffc505';
  var COLOR_CORE_RED = '#cf3c32';
  var COLOR_CORE_ORANGE = '#fb7e09';
  var COLOR_CORE_PURPLE = '#8e5ad8';
  var COLOR_CORE_CHARCOAL = '#43474b';
  var COLOR_CORE_GREY = '#8d939a';
  var COLOR_CORE_WHITE = '#fff';
  var COLOR_CORE_BLACK = '#000'; //
  // Map for COLOR CORE
  //

  var COLOR_CORE = {
    PRIMARY: COLOR_CORE_PRIMARY,
    SAGE: COLOR_CORE_SAGE,
    YELLOW: COLOR_CORE_YELLOW,
    RED: COLOR_CORE_RED,
    ORANGE: COLOR_CORE_ORANGE,
    PURPLE: COLOR_CORE_PURPLE,
    CHARCOAL: COLOR_CORE_CHARCOAL,
    GREY: COLOR_CORE_GREY,
    WHITE: COLOR_CORE_WHITE,
    BLACK: COLOR_CORE_BLACK
  }; //
  // Type: CUSTOM
  //
  //
  // Static vars for COLOR CUSTOM
  //

  var COLOR_CUSTOM_LABEL_PRIMARY_ICON_BACKGROUND_ACCENT = '#3e92ee';
  var COLOR_CUSTOM_LABEL_WARNING_BACKGROUND_ACCENT = '#f9df8b';
  var COLOR_CUSTOM_LABEL_DANGER_BACKGROUND_ACCENT = '#f3988c';
  var COLOR_CUSTOM_LABEL_DANGER_ICON_BACKGROUND_ACCENT = '#da665e'; //
  // Map for COLOR CUSTOM
  //

  var COLOR_CUSTOM = {
    LABEL_PRIMARY_ICON_BACKGROUND_ACCENT: COLOR_CUSTOM_LABEL_PRIMARY_ICON_BACKGROUND_ACCENT,
    LABEL_WARNING_BACKGROUND_ACCENT: COLOR_CUSTOM_LABEL_WARNING_BACKGROUND_ACCENT,
    LABEL_DANGER_BACKGROUND_ACCENT: COLOR_CUSTOM_LABEL_DANGER_BACKGROUND_ACCENT,
    LABEL_DANGER_ICON_BACKGROUND_ACCENT: COLOR_CUSTOM_LABEL_DANGER_ICON_BACKGROUND_ACCENT
  }; // ----------
  //
  // Category: CONTENT
  //
  // ----------
  //
  // Type: GRID_TEMPLATE
  //
  //
  // Static vars for CONTENT GRID_TEMPLATE
  //

  var CONTENT_GRID_TEMPLATE_E_CODE = '.';
  var CONTENT_GRID_TEMPLATE_E_SYMBOL = 'e';
  var CONTENT_GRID_TEMPLATE_E_CLASSNAME = 'sage-grid-template-e';
  var CONTENT_GRID_TEMPLATE_I_CODE = '..';
  var CONTENT_GRID_TEMPLATE_I_SYMBOL = 'i';
  var CONTENT_GRID_TEMPLATE_I_CLASSNAME = 'sage-grid-template-i';
  var CONTENT_GRID_TEMPLATE_S_CODE = '...';
  var CONTENT_GRID_TEMPLATE_S_SYMBOL = 's';
  var CONTENT_GRID_TEMPLATE_S_CLASSNAME = 'sage-grid-template-s';
  var CONTENT_GRID_TEMPLATE_T_CODE = '-';
  var CONTENT_GRID_TEMPLATE_T_SYMBOL = 't';
  var CONTENT_GRID_TEMPLATE_T_CLASSNAME = 'sage-grid-template-t';
  var CONTENT_GRID_TEMPLATE_M_CODE = '--';
  var CONTENT_GRID_TEMPLATE_M_SYMBOL = 'm';
  var CONTENT_GRID_TEMPLATE_M_CLASSNAME = 'sage-grid-template-m';
  var CONTENT_GRID_TEMPLATE_O_CODE = '---';
  var CONTENT_GRID_TEMPLATE_O_SYMBOL = 'o';
  var CONTENT_GRID_TEMPLATE_O_CLASSNAME = 'sage-grid-template-o';
  var CONTENT_GRID_TEMPLATE_SE_CODE = '....';
  var CONTENT_GRID_TEMPLATE_SE_SYMBOL = 'se';
  var CONTENT_GRID_TEMPLATE_SE_CLASSNAME = 'sage-grid-template-se';
  var CONTENT_GRID_TEMPLATE_SI_CODE = '.....';
  var CONTENT_GRID_TEMPLATE_SI_SYMBOL = 'si';
  var CONTENT_GRID_TEMPLATE_SI_CLASSNAME = 'sage-grid-template-si';
  var CONTENT_GRID_TEMPLATE_SS_CODE = '......';
  var CONTENT_GRID_TEMPLATE_SS_SYMBOL = 'ss';
  var CONTENT_GRID_TEMPLATE_SS_CLASSNAME = 'sage-grid-template-ss';
  var CONTENT_GRID_TEMPLATE_OT_CODE = '----';
  var CONTENT_GRID_TEMPLATE_OT_SYMBOL = 'ot';
  var CONTENT_GRID_TEMPLATE_OT_CLASSNAME = 'sage-grid-template-ot';
  var CONTENT_GRID_TEMPLATE_OM_CODE = '-----';
  var CONTENT_GRID_TEMPLATE_OM_SYMBOL = 'om';
  var CONTENT_GRID_TEMPLATE_OM_CLASSNAME = 'sage-grid-template-om';
  var CONTENT_GRID_TEMPLATE_OO_CODE = '------';
  var CONTENT_GRID_TEMPLATE_OO_SYMBOL = 'oo';
  var CONTENT_GRID_TEMPLATE_OO_CLASSNAME = 'sage-grid-template-oo';
  var CONTENT_GRID_TEMPLATE_ET_CODE = '.-';
  var CONTENT_GRID_TEMPLATE_ET_SYMBOL = 'et';
  var CONTENT_GRID_TEMPLATE_ET_CLASSNAME = 'sage-grid-template-et';
  var CONTENT_GRID_TEMPLATE_EM_CODE = '.--';
  var CONTENT_GRID_TEMPLATE_EM_SYMBOL = 'em';
  var CONTENT_GRID_TEMPLATE_EM_CLASSNAME = 'sage-grid-template-em';
  var CONTENT_GRID_TEMPLATE_EO_CODE = '.---';
  var CONTENT_GRID_TEMPLATE_EO_SYMBOL = 'eo';
  var CONTENT_GRID_TEMPLATE_EO_CLASSNAME = 'sage-grid-template-eo';
  var CONTENT_GRID_TEMPLATE_IT_CODE = '..-';
  var CONTENT_GRID_TEMPLATE_IT_SYMBOL = 'it';
  var CONTENT_GRID_TEMPLATE_IT_CLASSNAME = 'sage-grid-template-it';
  var CONTENT_GRID_TEMPLATE_IM_CODE = '..--';
  var CONTENT_GRID_TEMPLATE_IM_SYMBOL = 'im';
  var CONTENT_GRID_TEMPLATE_IM_CLASSNAME = 'sage-grid-template-im';
  var CONTENT_GRID_TEMPLATE_IO_CODE = '..---';
  var CONTENT_GRID_TEMPLATE_IO_SYMBOL = 'io';
  var CONTENT_GRID_TEMPLATE_IO_CLASSNAME = 'sage-grid-template-io';
  var CONTENT_GRID_TEMPLATE_ST_CODE = '...-';
  var CONTENT_GRID_TEMPLATE_ST_SYMBOL = 'st';
  var CONTENT_GRID_TEMPLATE_ST_CLASSNAME = 'sage-grid-template-st';
  var CONTENT_GRID_TEMPLATE_SM_CODE = '...--';
  var CONTENT_GRID_TEMPLATE_SM_SYMBOL = 'sm';
  var CONTENT_GRID_TEMPLATE_SM_CLASSNAME = 'sage-grid-template-sm';
  var CONTENT_GRID_TEMPLATE_SO_CODE = '...---';
  var CONTENT_GRID_TEMPLATE_SO_SYMBOL = 'so';
  var CONTENT_GRID_TEMPLATE_SO_CLASSNAME = 'sage-grid-template-so';
  var CONTENT_GRID_TEMPLATE_TE_CODE = '-.';
  var CONTENT_GRID_TEMPLATE_TE_SYMBOL = 'te';
  var CONTENT_GRID_TEMPLATE_TE_CLASSNAME = 'sage-grid-template-te';
  var CONTENT_GRID_TEMPLATE_TI_CODE = '-..';
  var CONTENT_GRID_TEMPLATE_TI_SYMBOL = 'ti';
  var CONTENT_GRID_TEMPLATE_TI_CLASSNAME = 'sage-grid-template-ti';
  var CONTENT_GRID_TEMPLATE_TS_CODE = '-...';
  var CONTENT_GRID_TEMPLATE_TS_SYMBOL = 'ts';
  var CONTENT_GRID_TEMPLATE_TS_CLASSNAME = 'sage-grid-template-ts';
  var CONTENT_GRID_TEMPLATE_ME_CODE = '--.';
  var CONTENT_GRID_TEMPLATE_ME_SYMBOL = 'me';
  var CONTENT_GRID_TEMPLATE_ME_CLASSNAME = 'sage-grid-template-me';
  var CONTENT_GRID_TEMPLATE_MI_CODE = '--..';
  var CONTENT_GRID_TEMPLATE_MI_SYMBOL = 'mi';
  var CONTENT_GRID_TEMPLATE_MI_CLASSNAME = 'sage-grid-template-mi';
  var CONTENT_GRID_TEMPLATE_MS_CODE = '--...';
  var CONTENT_GRID_TEMPLATE_MS_SYMBOL = 'ms';
  var CONTENT_GRID_TEMPLATE_MS_CLASSNAME = 'sage-grid-template-ms';
  var CONTENT_GRID_TEMPLATE_OE_CODE = '---.';
  var CONTENT_GRID_TEMPLATE_OE_SYMBOL = 'oe';
  var CONTENT_GRID_TEMPLATE_OE_CLASSNAME = 'sage-grid-template-oe';
  var CONTENT_GRID_TEMPLATE_OI_CODE = '---..';
  var CONTENT_GRID_TEMPLATE_OI_SYMBOL = 'oi';
  var CONTENT_GRID_TEMPLATE_OI_CLASSNAME = 'sage-grid-template-oi';
  var CONTENT_GRID_TEMPLATE_OS_CODE = '---...';
  var CONTENT_GRID_TEMPLATE_OS_SYMBOL = 'os';
  var CONTENT_GRID_TEMPLATE_OS_CLASSNAME = 'sage-grid-template-os';
  var CONTENT_GRID_TEMPLATE_ETE_CODE = '.-.';
  var CONTENT_GRID_TEMPLATE_ETE_SYMBOL = 'ete';
  var CONTENT_GRID_TEMPLATE_ETE_CLASSNAME = 'sage-grid-template-ete';
  var CONTENT_GRID_TEMPLATE_ETI_CODE = '.-..';
  var CONTENT_GRID_TEMPLATE_ETI_SYMBOL = 'eti';
  var CONTENT_GRID_TEMPLATE_ETI_CLASSNAME = 'sage-grid-template-eti';
  var CONTENT_GRID_TEMPLATE_ETS_CODE = '.-...';
  var CONTENT_GRID_TEMPLATE_ETS_SYMBOL = 'ets';
  var CONTENT_GRID_TEMPLATE_ETS_CLASSNAME = 'sage-grid-template-ets';
  var CONTENT_GRID_TEMPLATE_EME_CODE = '.--.';
  var CONTENT_GRID_TEMPLATE_EME_SYMBOL = 'eme';
  var CONTENT_GRID_TEMPLATE_EME_CLASSNAME = 'sage-grid-template-eme';
  var CONTENT_GRID_TEMPLATE_EMI_CODE = '.--..';
  var CONTENT_GRID_TEMPLATE_EMI_SYMBOL = 'emi';
  var CONTENT_GRID_TEMPLATE_EMI_CLASSNAME = 'sage-grid-template-emi';
  var CONTENT_GRID_TEMPLATE_EMS_CODE = '.--...';
  var CONTENT_GRID_TEMPLATE_EMS_SYMBOL = 'ems';
  var CONTENT_GRID_TEMPLATE_EMS_CLASSNAME = 'sage-grid-template-ems';
  var CONTENT_GRID_TEMPLATE_EOE_CODE = '.---.';
  var CONTENT_GRID_TEMPLATE_EOE_SYMBOL = 'eoe';
  var CONTENT_GRID_TEMPLATE_EOE_CLASSNAME = 'sage-grid-template-eoe';
  var CONTENT_GRID_TEMPLATE_EOI_CODE = '.---..';
  var CONTENT_GRID_TEMPLATE_EOI_SYMBOL = 'eoi';
  var CONTENT_GRID_TEMPLATE_EOI_CLASSNAME = 'sage-grid-template-eoi';
  var CONTENT_GRID_TEMPLATE_EOS_CODE = '.---...';
  var CONTENT_GRID_TEMPLATE_EOS_SYMBOL = 'eos';
  var CONTENT_GRID_TEMPLATE_EOS_CLASSNAME = 'sage-grid-template-eos';
  var CONTENT_GRID_TEMPLATE_ITE_CODE = '..-.';
  var CONTENT_GRID_TEMPLATE_ITE_SYMBOL = 'ite';
  var CONTENT_GRID_TEMPLATE_ITE_CLASSNAME = 'sage-grid-template-ite';
  var CONTENT_GRID_TEMPLATE_ITI_CODE = '..-..';
  var CONTENT_GRID_TEMPLATE_ITI_SYMBOL = 'iti';
  var CONTENT_GRID_TEMPLATE_ITI_CLASSNAME = 'sage-grid-template-iti';
  var CONTENT_GRID_TEMPLATE_ITS_CODE = '..-...';
  var CONTENT_GRID_TEMPLATE_ITS_SYMBOL = 'its';
  var CONTENT_GRID_TEMPLATE_ITS_CLASSNAME = 'sage-grid-template-its';
  var CONTENT_GRID_TEMPLATE_IME_CODE = '..--.';
  var CONTENT_GRID_TEMPLATE_IME_SYMBOL = 'ime';
  var CONTENT_GRID_TEMPLATE_IME_CLASSNAME = 'sage-grid-template-ime';
  var CONTENT_GRID_TEMPLATE_IMI_CODE = '..--..';
  var CONTENT_GRID_TEMPLATE_IMI_SYMBOL = 'imi';
  var CONTENT_GRID_TEMPLATE_IMI_CLASSNAME = 'sage-grid-template-imi';
  var CONTENT_GRID_TEMPLATE_IMS_CODE = '..--...';
  var CONTENT_GRID_TEMPLATE_IMS_SYMBOL = 'ims';
  var CONTENT_GRID_TEMPLATE_IMS_CLASSNAME = 'sage-grid-template-ims';
  var CONTENT_GRID_TEMPLATE_IOE_CODE = '..---.';
  var CONTENT_GRID_TEMPLATE_IOE_SYMBOL = 'ioe';
  var CONTENT_GRID_TEMPLATE_IOE_CLASSNAME = 'sage-grid-template-ioe';
  var CONTENT_GRID_TEMPLATE_IOI_CODE = '..---..';
  var CONTENT_GRID_TEMPLATE_IOI_SYMBOL = 'ioi';
  var CONTENT_GRID_TEMPLATE_IOI_CLASSNAME = 'sage-grid-template-ioi';
  var CONTENT_GRID_TEMPLATE_IOS_CODE = '..---...';
  var CONTENT_GRID_TEMPLATE_IOS_SYMBOL = 'ios';
  var CONTENT_GRID_TEMPLATE_IOS_CLASSNAME = 'sage-grid-template-ios';
  var CONTENT_GRID_TEMPLATE_STE_CODE = '...-.';
  var CONTENT_GRID_TEMPLATE_STE_SYMBOL = 'ste';
  var CONTENT_GRID_TEMPLATE_STE_CLASSNAME = 'sage-grid-template-ste';
  var CONTENT_GRID_TEMPLATE_STI_CODE = '...-..';
  var CONTENT_GRID_TEMPLATE_STI_SYMBOL = 'sti';
  var CONTENT_GRID_TEMPLATE_STI_CLASSNAME = 'sage-grid-template-sti';
  var CONTENT_GRID_TEMPLATE_STS_CODE = '...-...';
  var CONTENT_GRID_TEMPLATE_STS_SYMBOL = 'sts';
  var CONTENT_GRID_TEMPLATE_STS_CLASSNAME = 'sage-grid-template-sts';
  var CONTENT_GRID_TEMPLATE_SME_CODE = '...--.';
  var CONTENT_GRID_TEMPLATE_SME_SYMBOL = 'sme';
  var CONTENT_GRID_TEMPLATE_SME_CLASSNAME = 'sage-grid-template-sme';
  var CONTENT_GRID_TEMPLATE_SMI_CODE = '...--..';
  var CONTENT_GRID_TEMPLATE_SMI_SYMBOL = 'smi';
  var CONTENT_GRID_TEMPLATE_SMI_CLASSNAME = 'sage-grid-template-smi';
  var CONTENT_GRID_TEMPLATE_SMS_CODE = '...--...';
  var CONTENT_GRID_TEMPLATE_SMS_SYMBOL = 'sms';
  var CONTENT_GRID_TEMPLATE_SMS_CLASSNAME = 'sage-grid-template-sms';
  var CONTENT_GRID_TEMPLATE_SOE_CODE = '...---.';
  var CONTENT_GRID_TEMPLATE_SOE_SYMBOL = 'soe';
  var CONTENT_GRID_TEMPLATE_SOE_CLASSNAME = 'sage-grid-template-soe';
  var CONTENT_GRID_TEMPLATE_SOI_CODE = '...---..';
  var CONTENT_GRID_TEMPLATE_SOI_SYMBOL = 'soi';
  var CONTENT_GRID_TEMPLATE_SOI_CLASSNAME = 'sage-grid-template-soi';
  var CONTENT_GRID_TEMPLATE_SOS_CODE = '...---...';
  var CONTENT_GRID_TEMPLATE_SOS_SYMBOL = 'sos';
  var CONTENT_GRID_TEMPLATE_SOS_CLASSNAME = 'sage-grid-template-sos'; //
  // Map for CONTENT GRID_TEMPLATE
  //

  var CONTENT_GRID_TEMPLATE = {
    E: {
      CODE: CONTENT_GRID_TEMPLATE_E_CODE,
      SYMBOL: CONTENT_GRID_TEMPLATE_E_SYMBOL,
      CLASSNAME: CONTENT_GRID_TEMPLATE_E_CLASSNAME
    },
    I: {
      CODE: CONTENT_GRID_TEMPLATE_I_CODE,
      SYMBOL: CONTENT_GRID_TEMPLATE_I_SYMBOL,
      CLASSNAME: CONTENT_GRID_TEMPLATE_I_CLASSNAME
    },
    S: {
      CODE: CONTENT_GRID_TEMPLATE_S_CODE,
      SYMBOL: CONTENT_GRID_TEMPLATE_S_SYMBOL,
      CLASSNAME: CONTENT_GRID_TEMPLATE_S_CLASSNAME
    },
    T: {
      CODE: CONTENT_GRID_TEMPLATE_T_CODE,
      SYMBOL: CONTENT_GRID_TEMPLATE_T_SYMBOL,
      CLASSNAME: CONTENT_GRID_TEMPLATE_T_CLASSNAME
    },
    M: {
      CODE: CONTENT_GRID_TEMPLATE_M_CODE,
      SYMBOL: CONTENT_GRID_TEMPLATE_M_SYMBOL,
      CLASSNAME: CONTENT_GRID_TEMPLATE_M_CLASSNAME
    },
    O: {
      CODE: CONTENT_GRID_TEMPLATE_O_CODE,
      SYMBOL: CONTENT_GRID_TEMPLATE_O_SYMBOL,
      CLASSNAME: CONTENT_GRID_TEMPLATE_O_CLASSNAME
    },
    SE: {
      CODE: CONTENT_GRID_TEMPLATE_SE_CODE,
      SYMBOL: CONTENT_GRID_TEMPLATE_SE_SYMBOL,
      CLASSNAME: CONTENT_GRID_TEMPLATE_SE_CLASSNAME
    },
    SI: {
      CODE: CONTENT_GRID_TEMPLATE_SI_CODE,
      SYMBOL: CONTENT_GRID_TEMPLATE_SI_SYMBOL,
      CLASSNAME: CONTENT_GRID_TEMPLATE_SI_CLASSNAME
    },
    SS: {
      CODE: CONTENT_GRID_TEMPLATE_SS_CODE,
      SYMBOL: CONTENT_GRID_TEMPLATE_SS_SYMBOL,
      CLASSNAME: CONTENT_GRID_TEMPLATE_SS_CLASSNAME
    },
    OT: {
      CODE: CONTENT_GRID_TEMPLATE_OT_CODE,
      SYMBOL: CONTENT_GRID_TEMPLATE_OT_SYMBOL,
      CLASSNAME: CONTENT_GRID_TEMPLATE_OT_CLASSNAME
    },
    OM: {
      CODE: CONTENT_GRID_TEMPLATE_OM_CODE,
      SYMBOL: CONTENT_GRID_TEMPLATE_OM_SYMBOL,
      CLASSNAME: CONTENT_GRID_TEMPLATE_OM_CLASSNAME
    },
    OO: {
      CODE: CONTENT_GRID_TEMPLATE_OO_CODE,
      SYMBOL: CONTENT_GRID_TEMPLATE_OO_SYMBOL,
      CLASSNAME: CONTENT_GRID_TEMPLATE_OO_CLASSNAME
    },
    ET: {
      CODE: CONTENT_GRID_TEMPLATE_ET_CODE,
      SYMBOL: CONTENT_GRID_TEMPLATE_ET_SYMBOL,
      CLASSNAME: CONTENT_GRID_TEMPLATE_ET_CLASSNAME
    },
    EM: {
      CODE: CONTENT_GRID_TEMPLATE_EM_CODE,
      SYMBOL: CONTENT_GRID_TEMPLATE_EM_SYMBOL,
      CLASSNAME: CONTENT_GRID_TEMPLATE_EM_CLASSNAME
    },
    EO: {
      CODE: CONTENT_GRID_TEMPLATE_EO_CODE,
      SYMBOL: CONTENT_GRID_TEMPLATE_EO_SYMBOL,
      CLASSNAME: CONTENT_GRID_TEMPLATE_EO_CLASSNAME
    },
    IT: {
      CODE: CONTENT_GRID_TEMPLATE_IT_CODE,
      SYMBOL: CONTENT_GRID_TEMPLATE_IT_SYMBOL,
      CLASSNAME: CONTENT_GRID_TEMPLATE_IT_CLASSNAME
    },
    IM: {
      CODE: CONTENT_GRID_TEMPLATE_IM_CODE,
      SYMBOL: CONTENT_GRID_TEMPLATE_IM_SYMBOL,
      CLASSNAME: CONTENT_GRID_TEMPLATE_IM_CLASSNAME
    },
    IO: {
      CODE: CONTENT_GRID_TEMPLATE_IO_CODE,
      SYMBOL: CONTENT_GRID_TEMPLATE_IO_SYMBOL,
      CLASSNAME: CONTENT_GRID_TEMPLATE_IO_CLASSNAME
    },
    ST: {
      CODE: CONTENT_GRID_TEMPLATE_ST_CODE,
      SYMBOL: CONTENT_GRID_TEMPLATE_ST_SYMBOL,
      CLASSNAME: CONTENT_GRID_TEMPLATE_ST_CLASSNAME
    },
    SM: {
      CODE: CONTENT_GRID_TEMPLATE_SM_CODE,
      SYMBOL: CONTENT_GRID_TEMPLATE_SM_SYMBOL,
      CLASSNAME: CONTENT_GRID_TEMPLATE_SM_CLASSNAME
    },
    SO: {
      CODE: CONTENT_GRID_TEMPLATE_SO_CODE,
      SYMBOL: CONTENT_GRID_TEMPLATE_SO_SYMBOL,
      CLASSNAME: CONTENT_GRID_TEMPLATE_SO_CLASSNAME
    },
    TE: {
      CODE: CONTENT_GRID_TEMPLATE_TE_CODE,
      SYMBOL: CONTENT_GRID_TEMPLATE_TE_SYMBOL,
      CLASSNAME: CONTENT_GRID_TEMPLATE_TE_CLASSNAME
    },
    TI: {
      CODE: CONTENT_GRID_TEMPLATE_TI_CODE,
      SYMBOL: CONTENT_GRID_TEMPLATE_TI_SYMBOL,
      CLASSNAME: CONTENT_GRID_TEMPLATE_TI_CLASSNAME
    },
    TS: {
      CODE: CONTENT_GRID_TEMPLATE_TS_CODE,
      SYMBOL: CONTENT_GRID_TEMPLATE_TS_SYMBOL,
      CLASSNAME: CONTENT_GRID_TEMPLATE_TS_CLASSNAME
    },
    ME: {
      CODE: CONTENT_GRID_TEMPLATE_ME_CODE,
      SYMBOL: CONTENT_GRID_TEMPLATE_ME_SYMBOL,
      CLASSNAME: CONTENT_GRID_TEMPLATE_ME_CLASSNAME
    },
    MI: {
      CODE: CONTENT_GRID_TEMPLATE_MI_CODE,
      SYMBOL: CONTENT_GRID_TEMPLATE_MI_SYMBOL,
      CLASSNAME: CONTENT_GRID_TEMPLATE_MI_CLASSNAME
    },
    MS: {
      CODE: CONTENT_GRID_TEMPLATE_MS_CODE,
      SYMBOL: CONTENT_GRID_TEMPLATE_MS_SYMBOL,
      CLASSNAME: CONTENT_GRID_TEMPLATE_MS_CLASSNAME
    },
    OE: {
      CODE: CONTENT_GRID_TEMPLATE_OE_CODE,
      SYMBOL: CONTENT_GRID_TEMPLATE_OE_SYMBOL,
      CLASSNAME: CONTENT_GRID_TEMPLATE_OE_CLASSNAME
    },
    OI: {
      CODE: CONTENT_GRID_TEMPLATE_OI_CODE,
      SYMBOL: CONTENT_GRID_TEMPLATE_OI_SYMBOL,
      CLASSNAME: CONTENT_GRID_TEMPLATE_OI_CLASSNAME
    },
    OS: {
      CODE: CONTENT_GRID_TEMPLATE_OS_CODE,
      SYMBOL: CONTENT_GRID_TEMPLATE_OS_SYMBOL,
      CLASSNAME: CONTENT_GRID_TEMPLATE_OS_CLASSNAME
    },
    ETE: {
      CODE: CONTENT_GRID_TEMPLATE_ETE_CODE,
      SYMBOL: CONTENT_GRID_TEMPLATE_ETE_SYMBOL,
      CLASSNAME: CONTENT_GRID_TEMPLATE_ETE_CLASSNAME
    },
    ETI: {
      CODE: CONTENT_GRID_TEMPLATE_ETI_CODE,
      SYMBOL: CONTENT_GRID_TEMPLATE_ETI_SYMBOL,
      CLASSNAME: CONTENT_GRID_TEMPLATE_ETI_CLASSNAME
    },
    ETS: {
      CODE: CONTENT_GRID_TEMPLATE_ETS_CODE,
      SYMBOL: CONTENT_GRID_TEMPLATE_ETS_SYMBOL,
      CLASSNAME: CONTENT_GRID_TEMPLATE_ETS_CLASSNAME
    },
    EME: {
      CODE: CONTENT_GRID_TEMPLATE_EME_CODE,
      SYMBOL: CONTENT_GRID_TEMPLATE_EME_SYMBOL,
      CLASSNAME: CONTENT_GRID_TEMPLATE_EME_CLASSNAME
    },
    EMI: {
      CODE: CONTENT_GRID_TEMPLATE_EMI_CODE,
      SYMBOL: CONTENT_GRID_TEMPLATE_EMI_SYMBOL,
      CLASSNAME: CONTENT_GRID_TEMPLATE_EMI_CLASSNAME
    },
    EMS: {
      CODE: CONTENT_GRID_TEMPLATE_EMS_CODE,
      SYMBOL: CONTENT_GRID_TEMPLATE_EMS_SYMBOL,
      CLASSNAME: CONTENT_GRID_TEMPLATE_EMS_CLASSNAME
    },
    EOE: {
      CODE: CONTENT_GRID_TEMPLATE_EOE_CODE,
      SYMBOL: CONTENT_GRID_TEMPLATE_EOE_SYMBOL,
      CLASSNAME: CONTENT_GRID_TEMPLATE_EOE_CLASSNAME
    },
    EOI: {
      CODE: CONTENT_GRID_TEMPLATE_EOI_CODE,
      SYMBOL: CONTENT_GRID_TEMPLATE_EOI_SYMBOL,
      CLASSNAME: CONTENT_GRID_TEMPLATE_EOI_CLASSNAME
    },
    EOS: {
      CODE: CONTENT_GRID_TEMPLATE_EOS_CODE,
      SYMBOL: CONTENT_GRID_TEMPLATE_EOS_SYMBOL,
      CLASSNAME: CONTENT_GRID_TEMPLATE_EOS_CLASSNAME
    },
    ITE: {
      CODE: CONTENT_GRID_TEMPLATE_ITE_CODE,
      SYMBOL: CONTENT_GRID_TEMPLATE_ITE_SYMBOL,
      CLASSNAME: CONTENT_GRID_TEMPLATE_ITE_CLASSNAME
    },
    ITI: {
      CODE: CONTENT_GRID_TEMPLATE_ITI_CODE,
      SYMBOL: CONTENT_GRID_TEMPLATE_ITI_SYMBOL,
      CLASSNAME: CONTENT_GRID_TEMPLATE_ITI_CLASSNAME
    },
    ITS: {
      CODE: CONTENT_GRID_TEMPLATE_ITS_CODE,
      SYMBOL: CONTENT_GRID_TEMPLATE_ITS_SYMBOL,
      CLASSNAME: CONTENT_GRID_TEMPLATE_ITS_CLASSNAME
    },
    IME: {
      CODE: CONTENT_GRID_TEMPLATE_IME_CODE,
      SYMBOL: CONTENT_GRID_TEMPLATE_IME_SYMBOL,
      CLASSNAME: CONTENT_GRID_TEMPLATE_IME_CLASSNAME
    },
    IMI: {
      CODE: CONTENT_GRID_TEMPLATE_IMI_CODE,
      SYMBOL: CONTENT_GRID_TEMPLATE_IMI_SYMBOL,
      CLASSNAME: CONTENT_GRID_TEMPLATE_IMI_CLASSNAME
    },
    IMS: {
      CODE: CONTENT_GRID_TEMPLATE_IMS_CODE,
      SYMBOL: CONTENT_GRID_TEMPLATE_IMS_SYMBOL,
      CLASSNAME: CONTENT_GRID_TEMPLATE_IMS_CLASSNAME
    },
    IOE: {
      CODE: CONTENT_GRID_TEMPLATE_IOE_CODE,
      SYMBOL: CONTENT_GRID_TEMPLATE_IOE_SYMBOL,
      CLASSNAME: CONTENT_GRID_TEMPLATE_IOE_CLASSNAME
    },
    IOI: {
      CODE: CONTENT_GRID_TEMPLATE_IOI_CODE,
      SYMBOL: CONTENT_GRID_TEMPLATE_IOI_SYMBOL,
      CLASSNAME: CONTENT_GRID_TEMPLATE_IOI_CLASSNAME
    },
    IOS: {
      CODE: CONTENT_GRID_TEMPLATE_IOS_CODE,
      SYMBOL: CONTENT_GRID_TEMPLATE_IOS_SYMBOL,
      CLASSNAME: CONTENT_GRID_TEMPLATE_IOS_CLASSNAME
    },
    STE: {
      CODE: CONTENT_GRID_TEMPLATE_STE_CODE,
      SYMBOL: CONTENT_GRID_TEMPLATE_STE_SYMBOL,
      CLASSNAME: CONTENT_GRID_TEMPLATE_STE_CLASSNAME
    },
    STI: {
      CODE: CONTENT_GRID_TEMPLATE_STI_CODE,
      SYMBOL: CONTENT_GRID_TEMPLATE_STI_SYMBOL,
      CLASSNAME: CONTENT_GRID_TEMPLATE_STI_CLASSNAME
    },
    STS: {
      CODE: CONTENT_GRID_TEMPLATE_STS_CODE,
      SYMBOL: CONTENT_GRID_TEMPLATE_STS_SYMBOL,
      CLASSNAME: CONTENT_GRID_TEMPLATE_STS_CLASSNAME
    },
    SME: {
      CODE: CONTENT_GRID_TEMPLATE_SME_CODE,
      SYMBOL: CONTENT_GRID_TEMPLATE_SME_SYMBOL,
      CLASSNAME: CONTENT_GRID_TEMPLATE_SME_CLASSNAME
    },
    SMI: {
      CODE: CONTENT_GRID_TEMPLATE_SMI_CODE,
      SYMBOL: CONTENT_GRID_TEMPLATE_SMI_SYMBOL,
      CLASSNAME: CONTENT_GRID_TEMPLATE_SMI_CLASSNAME
    },
    SMS: {
      CODE: CONTENT_GRID_TEMPLATE_SMS_CODE,
      SYMBOL: CONTENT_GRID_TEMPLATE_SMS_SYMBOL,
      CLASSNAME: CONTENT_GRID_TEMPLATE_SMS_CLASSNAME
    },
    SOE: {
      CODE: CONTENT_GRID_TEMPLATE_SOE_CODE,
      SYMBOL: CONTENT_GRID_TEMPLATE_SOE_SYMBOL,
      CLASSNAME: CONTENT_GRID_TEMPLATE_SOE_CLASSNAME
    },
    SOI: {
      CODE: CONTENT_GRID_TEMPLATE_SOI_CODE,
      SYMBOL: CONTENT_GRID_TEMPLATE_SOI_SYMBOL,
      CLASSNAME: CONTENT_GRID_TEMPLATE_SOI_CLASSNAME
    },
    SOS: {
      CODE: CONTENT_GRID_TEMPLATE_SOS_CODE,
      SYMBOL: CONTENT_GRID_TEMPLATE_SOS_SYMBOL,
      CLASSNAME: CONTENT_GRID_TEMPLATE_SOS_CLASSNAME
    }
  }; // CONCATENATED MODULE: ./lib/configs/dictionary/index.js

  var SageDictionary = tokens_namespaceObject; // CONCATENATED MODULE: ./lib/configs/tokens/colors.js
  // TOKENS_COLORS.GREY --> `'grey'`

  var TOKENS_COLORS = {
    INHERIT: 'inherit'
  };
  Object.keys(SageDictionary.COLOR_CORE).forEach(function (colorName) {
    TOKENS_COLORS[colorName] = colorName.toLowerCase();
  }); // TOKENS_COLOR_PALETTE.GREY_500 --> `#b5bac0`

  var TOKENS_COLOR_PALETTE = {};
  Object.keys(SageDictionary.COLOR).forEach(function (colorName) {
    Object.keys(SageDictionary.COLOR[colorName]).forEach(function (index) {
      switch (colorName) {
        case 'WHITE':
        case 'BLACK':
          TOKENS_COLOR_PALETTE["".concat(colorName)] = SageDictionary.COLOR[colorName][index].HEX;
          break;

        default:
          TOKENS_COLOR_PALETTE["".concat(colorName, "_").concat(index)] = SageDictionary.COLOR[colorName][index].HEX;
          break;
      }
    });
  }); // TOKENS_COLOR_SLIDERS.GREY_500 --> `'grey-500'`

  var TOKENS_COLOR_SLIDERS = {
    INHERIT: 'inherit'
  };
  Object.keys(SageDictionary.COLOR).forEach(function (colorName) {
    Object.keys(SageDictionary.COLOR[colorName]).forEach(function (index) {
      if (index === '500') {
        TOKENS_COLOR_SLIDERS["".concat(colorName)] = SageDictionary.COLOR[colorName][index].CODE;
      }

      TOKENS_COLOR_SLIDERS["".concat(colorName, "_").concat(index)] = SageDictionary.COLOR[colorName][index].CODE;
    });
  }); // CONCATENATED MODULE: ./lib/configs/tokens/grid_gap_options.js

  var TOKENS_GRID_GAP_OPTIONS = {
    DEFAULT: null,
    XS: 'xs',
    SM: 'sm',
    MD: 'md',
    LG: 'lg'
  }; // CONCATENATED MODULE: ./lib/configs/tokens/grid-templates.js

  var TOKENS_GRID_TEMPLATES = {};
  Object.keys(SageDictionary.CONTENT_GRID_TEMPLATE).forEach(function (template) {
    TOKENS_GRID_TEMPLATES[template] = SageDictionary.CONTENT_GRID_TEMPLATE[template].SYMBOL;
  }); // CONCATENATED MODULE: ./lib/configs/tokens/icons.js

  var TOKENS_ICONS = {
    ACCESS_KEY: 'access-key',
    ADD: 'add',
    ADD_CIRCLE: 'add-circle',
    ADD_IMAGE: 'add-image',
    ADD_SMALL: 'add-small',
    AI_WRITER: 'ai-writer',
    AI_WRITER_FILLED: 'ai-writer-filled',
    ALIGN_CENTER: 'align-center',
    ALIGN_JUSTIFY: 'align-justify',
    ALIGN_LEFT: 'align-left',
    ALIGN_RIGHT: 'align-right',
    ARCHIVE: 'archive',
    ARROW_CORNER: 'arrow-corner',
    ARROW_DOWN: 'arrow-down',
    ARROW_LEFT: 'arrow-left',
    ARROW_RIGHT: 'arrow-right',
    ARROW_UP: 'arrow-up',
    ASSESSMENT: 'assessment',
    AT_SIGN: 'at-sign',
    ATTACH: 'attach',
    AUTOMATIONS: 'automations',
    BAN: 'ban',
    BANK: 'bank',
    BELL: 'bell',
    BLOG: 'blog',
    BOLD: 'bold',
    BROADCAST: 'broadcast',
    CALENDAR_DATE: 'calendar-date',
    CALENDAR_SCHEDULE: 'calendar-schedule',
    CALENDAR_SIMPLE: 'calendar-simple',
    CARD_AMEX: 'card-amex',
    CARD_ANDROID: 'card-android',
    CARD_APPLE: 'card-apple',
    CARD_DISCOVER: 'card-discover',
    CARD_GENERIC: 'card-generic',
    CARD_GPAY: 'card-gpay',
    CARD_MASTERCARD: 'card-mastercard',
    CARD_PAYPAL: 'card-paypal',
    CARD_STRIPE: 'card-stripe',
    CARD_UPDATE: 'card-update',
    CARD_VISA: 'card-visa',
    CARET_DOWN: 'caret-down',
    CARET_LEFT: 'caret-left',
    CARET_RIGHT: 'caret-right',
    CARET_UP: 'caret-up',
    CART: 'cart',
    CART_ADD: 'cart-add',
    CERTIFICATE: 'certificate',
    CHART: 'chart',
    CHART_FILLED: 'chart-filled',
    CHECK: 'check',
    CHECK_CIRCLE: 'check-circle',
    CHECK_CIRCLE_FILLED: 'check-circle-filled',
    CIRCLE_1: 'circle-1',
    CIRCLE_2: 'circle-2',
    CIRCLE_3: 'circle-3',
    CIRCLE_4: 'circle-4',
    CIRCLE_5: 'circle-5',
    CIRCLE_6: 'circle-6',
    CIRCLE_7: 'circle-7',
    CIRCLE_8: 'circle-8',
    CIRCLE_9: 'circle-9',
    CLOCK: 'clock',
    CLOSED_CAPTIONS: 'closed-captions',
    CODE: 'code',
    COLOR: 'color',
    COMMENT: 'comment',
    CONNECT: 'connect',
    CONVERSATION: 'conversation',
    CONTACT: 'contact',
    COLUMNS: 'columns',
    COPY: 'copy',
    COUPON: 'coupon',
    COURSE: 'course',
    CREATOR_STUDIO: 'creator-studio',
    CREATOR_STUDIO_FILLED: 'creator-studio-filled',
    CREDIT_CARD: 'credit-card',
    CUSTOM_FIELD: 'custom-field',
    CUSTOMIZE: 'customize',
    DANGER: 'danger',
    DANGER_FILLED: 'danger-filled',
    DELETE_CIRCLE: 'delete-circle',
    DELETE_KEY: 'delete-key',
    DELETE_X: 'delete-x',
    DOLLAR: 'dollar',
    DOT_MENU_HORIZONTAL: 'dot-menu-horizontal',
    DOWN_SMALL: 'down-small',
    DOWNLOAD: 'download',
    DOWNSELL: 'downsell',
    DRAFT: 'draft',
    DROP: 'drop',
    DUPLICATE: 'duplicate',
    EDITOR: 'editor',
    EDITOR_FILLED: 'editor-filled',
    EMAIL_ACTIVITY: 'email-activity',
    EMOJI: 'emoji',
    ENLARGE: 'enlarge',
    ENLARGE_VERTICAL: 'enlarge-vertical',
    EXPAND: 'expand',
    FAVORITE: 'favorite',
    FEEDBACK: 'feedback',
    FILE: 'file',
    FILE_MONEY: 'file-money',
    FILTER: 'filter',
    FLAG: 'flag',
    FOLDER: 'folder',
    FOLDER_GROUP: 'folder-group',
    FORM: 'form',
    FORM_FIELD: 'form-field',
    FULLSCREEN: 'fullscreen',
    FUNNEL: 'funnel',
    GEAR: 'gear',
    GEAR_FILLED: 'gear-filled',
    GRANT_OFFER: 'grant-offer',
    HANDLE: 'handle',
    HANDLE_2: 'handle-2',
    HANDLE_2_VERTICAL: 'handle-2-vertical',
    HASHTAG: 'hashtag',
    HEADING_LARGE: 'heading-large',
    HEADING_SMALL: 'heading-small',
    HEADSET: 'headset',
    HELP: 'help',
    HELP_FILLED: 'help-filled',
    HOME: 'home',
    HOME_ALT: 'home-alt',
    HOME_FILLED: 'home-filled',
    HORIZONTAL_LINE: 'horizontal-line',
    IMAGE: 'image',
    INFO_CIRCLE: 'info-circle',
    INFO_CIRCLE_FILLED: 'info-circle-filled',
    ITALIC: 'italic',
    KAJABI: 'kajabi',
    KAJABI_FILLED: 'kajabi-filled',
    LAB: 'lab',
    LAUNCH: 'launch',
    LAYOUT_GRID: 'layout-grid',
    LAYOUT_LIST: 'layout-list',
    LEFT_SMALL: 'left-small',
    LIST_BULLET: 'list-bullet',
    LIST_DETAILS: 'list-details',
    LIST_NUMBERS: 'list-numbers',
    LOCATION: 'location',
    LOCK: 'lock',
    LOCK_ALT: 'lock-alt',
    LOGO_FACEBOOK: 'logo-facebook',
    LOGO_FACEBOOK_ROUND: 'logo-facebook-round',
    LOGO_INSTAGRAM: 'logo-instagram',
    LOGO_LINKEDIN: 'logo-linkedin',
    LOGO_TIKTOK: 'logo-tiktok',
    LOGO_TWITTER: 'logo-twitter',
    LOGO_YOUTUBE: 'logo-youtube',
    LOOP: 'loop',
    MAIL: 'mail',
    MAPPED: 'mapped',
    MARGIN_LEFT: 'margin-left',
    MARGIN_RIGHT: 'margin-right',
    MARKER: 'marker',
    MARKER_FILLED: 'marker-filled',
    MEGAPHONE: 'megaphone',
    MEGAPHONE_FILLED: 'megaphone-filled',
    MENU: 'menu',
    MENU_ALT: 'menu-alt',
    MENU_BORDERED: 'menu-bordered',
    MERGE: 'merge',
    MICROPHONE: 'microphone',
    MICROPHONE_OFF: 'microphone-off',
    MONITOR: 'monitor',
    MONITOR_FILLED: 'monitor-filled',
    MOVE_LEFT: 'move-left',
    MOVE_RIGHT: 'move-right',
    MULTI_PAY: 'multi-pay',
    NEWSLETTER: 'newsletter',
    NULL: 'null',
    ONE_OFF_SESSION: 'one-off-session',
    ONE_TIME: 'one-time',
    PACKAGE: 'package',
    PAUSE: 'pause',
    PAYOUT: 'payout',
    PEN: 'pen',
    PHONE_PORTRAIT: 'phone-portrait',
    PHONE_TOOLBAR: 'phone-toolbar',
    PLAY: 'play',
    PLAY_CIRCLE: 'play-circle',
    PLAY_OUTLINE: 'play-outline',
    PLUG: 'plug',
    PRESENT: 'present',
    PREVIEW_OFF: 'preview-off',
    PREVIEW_ON: 'preview-on',
    PRODUCT: 'product',
    PRODUCT_FILLED: 'product-filled',
    QUESTION_CIRCLE: 'question-circle',
    QUOTE: 'quote',
    REDO: 'redo',
    REFRESH: 'refresh',
    REMOVE: 'remove',
    REMOVE_CIRCLE: 'remove-circle',
    RENAME: 'rename',
    RESET_PASSWORD: 'reset-password',
    RESTORE: 'restore',
    RIGHT_SMALL: 'right-small',
    ROUND_DOLLAR: 'round-dollar',
    ROWS: 'rows',
    SCREEN_SHARE_OFF: 'screen-share-off',
    SCREEN_SHARE_ON: 'screen-share-on',
    SEARCH: 'search',
    SEARCH_SMALL: 'search-small',
    SEND_MESSAGE: 'send-message',
    SEQUENCES: 'sequences',
    SHARE: 'share',
    SKIPPED: 'skipped',
    SLASH_DIVIDER: 'slash-divider',
    SPEAKER: 'speaker',
    STACK: 'stack',
    STAR: 'star',
    STOP: 'stop',
    STOPWATCH: 'stopwatch',
    STRIKETHROUGH: 'strikethrough',
    SUBSCRIPT: 'subscript',
    SUBSCRIPTIONS: 'subscriptions',
    SUPERSCRIPT: 'superscript',
    SUPER_ADMIN: 'super-admin',
    SYNC: 'sync',
    TABLET_LANDSCAPE: 'tablet-landscape',
    TABLET_PORTRAIT: 'tablet-portrait',
    TAG: 'tag',
    TAG_FILLED: 'tag-filled',
    TEXT_STYLES: 'text-styles',
    THEME_STORE: 'theme-store',
    THUMB_DOWN: 'thumb-down',
    THUMB_DOWN_FILLED: 'thumb-down-filled',
    THUMB_UP: 'thumb-up',
    THUMB_UP_FILLED: 'thumb-up-filled',
    TRASH: 'trash',
    UNDERLINE: 'underline',
    UNDO: 'undo',
    UNLOCK: 'unlock',
    UNMAPPED: 'unmapped',
    UP_SMALL: 'up-small',
    UPLOAD: 'upload',
    URL: 'url',
    USER: 'user',
    USER_CIRCLE: 'user-circle',
    USER_CIRCLE_FILLED: 'user-circle-filled',
    USER_STAR: 'user-star',
    USER_STAR_FILLED: 'user-star-filled',
    USERS: 'users',
    USERS_ALT: 'users-alt',
    VIDEO_OFF: 'video-off',
    VIDEO_ON: 'video-on',
    WARNING: 'warning',
    WARNING_FILLED: 'warning-filled',
    WINDOW_PARAGRAPH: 'window-paragraph',
    WORLD: 'world'
  }; // CONCATENATED MODULE: ./lib/configs/tokens/recharts.js

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
        defineProperty_default()(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }

    return target;
  }

  var gridConfigs = {
    stroke: TOKENS_COLOR_PALETTE.GREY_300
  };
  var tickConfigs = {
    fill: TOKENS_COLOR_PALETTE.CHARCOAL_100,
    fontSize: 12
  };
  var TOKENS_RECHARTS = {
    BarChart: {
      barGap: 8,
      barCategoryGap: 16
    },
    CartesianGrid: {
      stroke: TOKENS_COLOR_PALETTE.GREY_400,
      vertical: false
    },
    Tooltip: {
      cursor: false
    },
    XAxis: {
      axisLine: _objectSpread({}, gridConfigs),
      tickLine: false,
      tick: _objectSpread({}, tickConfigs)
    },
    YAxis: {
      axisLine: false,
      tickLine: false,
      tick: _objectSpread({}, tickConfigs)
    }
  }; // CONCATENATED MODULE: ./lib/configs/tokens/spacers.js

  var TOKENS_SPACERS = {
    '3XS': '3xs',
    XXXS: '3xs',
    '2XS': '2xs',
    XXS: '2xs',
    XS: 'xs',
    SM: 'sm',
    MD: 'md',
    LG: 'lg',
    XL: 'xl',
    '2XL': '2xl',
    XXL: '2xl'
  }; // CONCATENATED MODULE: ./lib/configs/tokens/z-indexes.js
  // Keep in sync with `packages/sage-assets/lib/stylesheets/tokens/_z_index.scss`

  var TOKENS_Z_INDEXES = {
    NEGATIVE: -1,
    DEFAULT: 0,
    RAISED: 1000,
    ALERT: 2000,
    UNDERLAY: 3000,
    NAV: 4000,
    OVERLAY: 5000,
    MODAL: 6000,
    PRIORITY: 8000,
    NUCLEAR: 9000
  }; // CONCATENATED MODULE: ./lib/configs/tokens/breakpoints.js
  //
  // NOTE: Keep in sync with `sage-assets/.../tokens/_breakpoints.scss`
  //

  var SAGE_BREAKPOINT_VALUES = {
    XS_MAX: '544px',
    SM_MIN: '545px',
    SM_MAX: '767px',
    MD_MIN: '768px',
    MD_MAX: '991px',
    LG_MIN: '992px',
    LG_MAX: '1199px',
    XL_MIN: '1200px',
    XL_MAX: '1439px',
    XXL_MIN: '1440px'
  };
  var SAGE_BREAKPOINT_QUERIES = {
    xs: "(max-width: ".concat(SAGE_BREAKPOINT_VALUES.XS_MAX, ")"),
    sm: "(max-width: ".concat(SAGE_BREAKPOINT_VALUES.SM_MAX, ")"),
    md: "(max-width: ".concat(SAGE_BREAKPOINT_VALUES.MD_MAX, ")"),
    lg: "(max-width: ".concat(SAGE_BREAKPOINT_VALUES.LG_MAX, ")"),
    xl: "(max-width: ".concat(SAGE_BREAKPOINT_VALUES.XL_MAX, ")")
  }; // CONCATENATED MODULE: ./lib/configs/tokens/index.js

  var SageTokens = {
    BREAKPOINTS: SAGE_BREAKPOINT_VALUES,
    BREAKPOINT_QUERIES: SAGE_BREAKPOINT_QUERIES,
    COLORS: TOKENS_COLORS,
    COLOR_PALETTE: TOKENS_COLOR_PALETTE,
    COLOR_SLIDERS: TOKENS_COLOR_SLIDERS,
    GRID_GAP_OPTIONS: TOKENS_GRID_GAP_OPTIONS,
    GRID_TEMPLATES: TOKENS_GRID_TEMPLATES,
    ICONS: TOKENS_ICONS,
    RECHARTS: TOKENS_RECHARTS,
    SPACERS: TOKENS_SPACERS,
    Z_INDEXES: TOKENS_Z_INDEXES
  }; // CONCATENATED MODULE: ./lib/configs/classnames/spacers.js
  // Generates spacer classnames from spacer tokens such as:
  // CLASSNAMES_SPACERS.3XS_TOP ---> `sage-spacer-top-3xs`
  // Note that `MD` is default so CLASSNAMES_SPACERS.MD_TOP will return `sage-spacer-top` (no `-md`)

  var spacerClassPrefix = 'sage-spacer';
  var CLASSNAMES_SPACERS = {};
  Object.keys(SageTokens.SPACERS).forEach(function (spacerToken) {
    var spacerClassSuffix = SageTokens.SPACERS[spacerToken] === SageTokens.SPACERS.MD ? '' : "-".concat(SageTokens.SPACERS[spacerToken]);
    CLASSNAMES_SPACERS["".concat(spacerToken, "_TOP")] = "".concat(spacerClassPrefix, "-top").concat(spacerClassSuffix);
    CLASSNAMES_SPACERS["".concat(spacerToken, "_RIGHT")] = "".concat(spacerClassPrefix, "-right").concat(spacerClassSuffix);
    CLASSNAMES_SPACERS["".concat(spacerToken, "_BOTTOM")] = "".concat(spacerClassPrefix, "-bottom").concat(spacerClassSuffix);
    CLASSNAMES_SPACERS["".concat(spacerToken, "_LEFT")] = "".concat(spacerClassPrefix, "-left").concat(spacerClassSuffix);
  }); // CONCATENATED MODULE: ./lib/configs/classnames/type.js

  var typeClassPrefix = 't-sage';
  var CLASSNAMES_TYPE = {
    HEADING_1: "".concat(typeClassPrefix, "-heading-1"),
    HEADING_2: "".concat(typeClassPrefix, "-heading-2"),
    HEADING_3: "".concat(typeClassPrefix, "-heading-3"),
    HEADING_4: "".concat(typeClassPrefix, "-heading-4"),
    HEADING_5: "".concat(typeClassPrefix, "-heading-5"),
    HEADING_6: "".concat(typeClassPrefix, "-heading-6"),
    BODY: "".concat(typeClassPrefix, "-body"),
    BODY_BOLD: "".concat(typeClassPrefix, "-body-bold"),
    BODY_MED: "".concat(typeClassPrefix, "-body-med"),
    BODY_SEMI: "".concat(typeClassPrefix, "-body-semi"),
    BODY_SMALL: "".concat(typeClassPrefix, "-body-small"),
    BODY_SMALL_BOLD: "".concat(typeClassPrefix, "-body-small-bold"),
    BODY_SMALL_MED: "".concat(typeClassPrefix, "-body-small-med"),
    BODY_SMALL_SEMI: "".concat(typeClassPrefix, "-body-small-semi"),
    BODY_XSMALL: "".concat(typeClassPrefix, "-body-xsmall"),
    BODY_XSMALL_BOLD: "".concat(typeClassPrefix, "-body-xsmall-bold"),
    BODY_XSMALL_MED: "".concat(typeClassPrefix, "-body-xsmall-med"),
    BODY_XSMALL_SEMI: "".concat(typeClassPrefix, "-body-xsmall-semi")
  }; // Generates Sage Color classes from the color sliders token set such as
  // CLASSNAMES_TYPE_COLORS.RED_200 ---> `t-sage--color-red-200`

  var CLASSNAMES_TYPE_COLORS = {};
  Object.keys(SageDictionary.COLOR).forEach(function (colorName) {
    Object.keys(SageDictionary.COLOR[colorName]).forEach(function (index) {
      if (index === '300') {
        CLASSNAMES_TYPE_COLORS["".concat(colorName)] = SageDictionary.COLOR[colorName][index].CLASSNAME;
      }

      CLASSNAMES_TYPE_COLORS["".concat(colorName, "_").concat(index)] = SageDictionary.COLOR[colorName][index].CLASSNAME;
    });
  });
  var CLASSNAME_TRUNCATE_TEXT = "".concat(typeClassPrefix, "--truncate");
  var CLASSNAME_STRIKETHROUGH = "".concat(typeClassPrefix, "--strikethrough");
  var CLASSNAME_TYPE_ALIGN_CENTER = 't-sage--align-center';
  var CLASSNAME_TYPE_ALIGN_RIGHT = 't-sage--align-right';
  var CLASSNAME_TYPE_BLOCK = 'sage-type'; // CONCATENATED MODULE: ./lib/configs/classnames/grid-templates.js
  // CLASSNAMES_GRID_TEMPLATES.ETE --> `sage-grid-template-ete`

  var CLASSNAMES_GRID_TEMPLATES = {};
  Object.keys(SageDictionary.CONTENT_GRID_TEMPLATE).forEach(function (template) {
    CLASSNAMES_GRID_TEMPLATES[template] = SageDictionary.CONTENT_GRID_TEMPLATE[template].CLASSNAME;
  });

  var grid_templates_lookupGridTemplateClassname = function lookupGridTemplateClassname(gridTemplate) {
    var matchingClassname = null;
    Object.keys(SageDictionary.CONTENT_GRID_TEMPLATE).forEach(function (gridTemplateToken) {
      if (SageDictionary.CONTENT_GRID_TEMPLATE[gridTemplateToken].SYMBOL === gridTemplate) {
        matchingClassname = CLASSNAMES_GRID_TEMPLATES[gridTemplateToken];
      }
    });
    return matchingClassname;
  }; // CONCATENATED MODULE: ./lib/configs/classnames/links.js


  var CLASSNAMES_LINK = {
    LAUNCH: 'sage-link sage-link--launch',
    SUBTEXT: 'sage-link sage-link--subtext'
  }; // CONCATENATED MODULE: ./lib/configs/classnames/index.js

  function classnames_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function classnames_objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? classnames_ownKeys(Object(source), !0).forEach(function (key) {
        defineProperty_default()(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : classnames_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }

    return target;
  }

  var SageClassnames = {
    SPACERS: classnames_objectSpread({}, CLASSNAMES_SPACERS),
    TYPE: classnames_objectSpread({}, CLASSNAMES_TYPE),
    TYPE_ALIGN_CENTER: CLASSNAME_TYPE_ALIGN_CENTER,
    TYPE_ALIGN_RIGHT: CLASSNAME_TYPE_ALIGN_RIGHT,
    TYPE_BLOCK: CLASSNAME_TYPE_BLOCK,
    TYPE_COLORS: classnames_objectSpread({}, CLASSNAMES_TYPE_COLORS),
    TYPE_STRIKETHROUGH: CLASSNAME_STRIKETHROUGH,
    TRUNCATE_TEXT: CLASSNAME_TRUNCATE_TEXT,
    GRID_TEMPLATES: classnames_objectSpread({}, CLASSNAMES_GRID_TEMPLATES),
    LINK: classnames_objectSpread({}, CLASSNAMES_LINK),
    CARD_GRID: 'sage-card-grid',
    PANEL_GRID: 'sage-panel-grid',
    lookupGridTemplate: grid_templates_lookupGridTemplateClassname
  }; // CONCATENATED MODULE: ./lib/configs/index.js
  // EXTERNAL MODULE: /__w/sage-lib/sage-lib/node_modules/react-dom/index.js

  var react_dom = __webpack_require__(20);

  var react_dom_default = /*#__PURE__*/__webpack_require__.n(react_dom); // CONCATENATED MODULE: ./lib/Tooltip/configs.js


  var TOOLTIP_SIZES = {
    DEFAULT: null,
    SMALL: 'small',
    LARGE: 'large'
  };
  var TOOLTIP_POSITIONS = {
    DEFAULT: 'top',
    TOP: 'top',
    RIGHT: 'right',
    BOTTOM: 'bottom',
    LEFT: 'left'
  };
  var TOOLTIP_THEMES = {
    DEFAULT: null,
    LIGHT: 'light'
  }; // CONCATENATED MODULE: ./lib/Tooltip/TooltipElement.jsx

  var TOOLTIP_DISTANCE = 8;

  var TooltipElement_TooltipElement = function TooltipElement(_ref) {
    var _classnames;

    var content = _ref.content,
        parentDomRect = _ref.parentDomRect,
        position = _ref.position,
        size = _ref.size,
        theme = _ref.theme;
    var tooltipRef = Object(external_react_["useRef"])(null);

    var _useState = Object(external_react_["useState"])({
      top: null,
      left: null
    }),
        _useState2 = slicedToArray_default()(_useState, 2),
        coordinates = _useState2[0],
        setCoordinates = _useState2[1];

    var classNames = classnames_default()('sage-tooltip', (_classnames = {
      'sage-tooltip--static': !parentDomRect
    }, defineProperty_default()(_classnames, "sage-tooltip--".concat(position), position), defineProperty_default()(_classnames, "sage-tooltip--".concat(size), size), defineProperty_default()(_classnames, "sage-tooltip--".concat(theme), theme), _classnames));
    Object(external_react_["useLayoutEffect"])(function () {
      if (!parentDomRect) {
        return;
      }

      var left = 0,
          top = 0;

      switch (position) {
        case TOOLTIP_POSITIONS.LEFT:
          top = (parentDomRect.top + parentDomRect.bottom) / 2 - tooltipRef.current.offsetHeight / 2;
          left = parentDomRect.left - TOOLTIP_DISTANCE - tooltipRef.current.offsetWidth;

          if (parentDomRect.left - tooltipRef.current.offsetWidth < 0) {
            left = TOOLTIP_DISTANCE;
          }

          break;

        case TOOLTIP_POSITIONS.RIGHT:
          top = (parentDomRect.top + parentDomRect.bottom) / 2 - tooltipRef.current.offsetHeight / 2;
          left = parentDomRect.right + TOOLTIP_DISTANCE;
          /* eslint-disable max-len */

          if (parentDomRect.right + tooltipRef.current.offsetWidth > document.documentElement.clientWidth) {
            left = document.documentElement.clientWidth - tooltipRef.current.offsetWidth - TOOLTIP_DISTANCE;
          }
          /* eslint-enable max-len */


          break;

        case TOOLTIP_POSITIONS.BOTTOM:
          top = parentDomRect.bottom + TOOLTIP_DISTANCE;
          left = parentDomRect.left + (parentDomRect.width - tooltipRef.current.offsetWidth) / 2;
          break;

        case TOOLTIP_POSITIONS.TOP:
          top = parentDomRect.top - tooltipRef.current.offsetHeight - TOOLTIP_DISTANCE;
          left = parentDomRect.left + (parentDomRect.width - tooltipRef.current.offsetWidth) / 2;
          break;

        default:
          // top and left remain at 0
          break;
      }

      setCoordinates({
        top: top + window.pageYOffset,
        left: left + window.pageXOffset
      });
    }, [tooltipRef.current]);
    return /*#__PURE__*/external_react_default.a.createElement("div", {
      role: "tooltip",
      ref: tooltipRef,
      className: classNames,
      style: parentDomRect ? coordinates : {}
    }, content);
  };

  TooltipElement_TooltipElement.POSITIONS = TOOLTIP_POSITIONS;
  TooltipElement_TooltipElement.SIZES = TOOLTIP_SIZES;
  TooltipElement_TooltipElement.THEMES = TOOLTIP_THEMES;
  TooltipElement_TooltipElement.defaultProps = {
    parentDomRect: null,
    position: TOOLTIP_POSITIONS.DEFAULT,
    size: TOOLTIP_SIZES.DEFAULT,
    theme: TOOLTIP_THEMES.DEFAULT
  };
  TooltipElement_TooltipElement.propTypes = {
    content: prop_types_default.a.oneOfType([prop_types_default.a.node, prop_types_default.a.string]).isRequired,
    parentDomRect: prop_types_default.a.shape({
      bottom: prop_types_default.a.number,
      left: prop_types_default.a.number,
      right: prop_types_default.a.number,
      top: prop_types_default.a.number,
      width: prop_types_default.a.number
    }),
    position: prop_types_default.a.oneOf(Object.values(TOOLTIP_POSITIONS)),
    size: prop_types_default.a.oneOf(Object.values(TOOLTIP_SIZES)),
    theme: prop_types_default.a.oneOf(Object.values(TOOLTIP_THEMES))
  }; // CONCATENATED MODULE: ./lib/Tooltip/Tooltip.jsx

  var Tooltip_excluded = ["children", "content", "position", "size", "theme"];

  function Tooltip_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function Tooltip_objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? Tooltip_ownKeys(Object(source), !0).forEach(function (key) {
        defineProperty_default()(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Tooltip_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }

    return target;
  }

  var Tooltip_Tooltip = function Tooltip(_ref) {
    var children = _ref.children,
        content = _ref.content,
        position = _ref.position,
        size = _ref.size,
        theme = _ref.theme,
        rest = objectWithoutProperties_default()(_ref, Tooltip_excluded);

    var _useState = Object(external_react_["useState"])(false),
        _useState2 = slicedToArray_default()(_useState, 2),
        active = _useState2[0],
        setActive = _useState2[1];

    var _useState3 = Object(external_react_["useState"])(null),
        _useState4 = slicedToArray_default()(_useState3, 2),
        parentDomRect = _useState4[0],
        setParentDomRect = _useState4[1];

    function handleActivate(evt) {
      setParentDomRect(evt.target.getBoundingClientRect());
      setActive(true);
    }

    function handleDeactivate() {
      setActive(false);
    }

    return /*#__PURE__*/external_react_default.a.createElement(external_react_default.a.Fragment, null, external_react_["Children"].map(children, function (child) {
      return /*#__PURE__*/Object(external_react_["cloneElement"])(child, Tooltip_objectSpread({
        onMouseEnter: handleActivate,
        onFocus: handleActivate,
        onMouseLeave: handleDeactivate,
        onBlur: handleDeactivate
      }, rest));
    }), active && /*#__PURE__*/react_dom_default.a.createPortal( /*#__PURE__*/external_react_default.a.createElement(TooltipElement_TooltipElement, {
      content: content,
      parentDomRect: parentDomRect,
      position: position,
      size: size,
      theme: theme
    }), document.body));
  };

  Tooltip_Tooltip.Element = TooltipElement_TooltipElement;
  Tooltip_Tooltip.POSITIONS = TOOLTIP_POSITIONS;
  Tooltip_Tooltip.SIZES = TOOLTIP_SIZES;
  Tooltip_Tooltip.THEMES = TOOLTIP_THEMES;
  Tooltip_Tooltip.defaultProps = {
    position: TOOLTIP_POSITIONS.DEFAULT,
    size: TOOLTIP_SIZES.DEFAULT,
    theme: TOOLTIP_THEMES.DEFAULT
  };
  Tooltip_Tooltip.propTypes = {
    children: prop_types_default.a.node.isRequired,
    content: prop_types_default.a.oneOfType([prop_types_default.a.node, prop_types_default.a.string]).isRequired,
    position: prop_types_default.a.oneOf(Object.values(TOOLTIP_POSITIONS)),
    size: prop_types_default.a.oneOf(Object.values(TOOLTIP_SIZES)),
    theme: prop_types_default.a.oneOf(Object.values(TOOLTIP_THEMES))
  }; // CONCATENATED MODULE: ./lib/Tooltip/index.js
  // CONCATENATED MODULE: ./lib/Link/configs.js

  var LINK_ICON_POSITIONS = {
    LEFT: 'left',
    RIGHT: 'right'
  };
  var LINK_COLORS = {
    PRIMARY: 'primary',
    SECONDARY: 'secondary',
    DANGER: 'danger'
  }; // CONCATENATED MODULE: ./lib/Link/Link.jsx

  var Link_excluded = ["className", "children", "icon", "iconPosition", "removeUnderline", "small", "style", "suppressDefaultClass", "tag", "tooltip", "truncate"];

  function Link_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function Link_objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? Link_ownKeys(Object(source), !0).forEach(function (key) {
        defineProperty_default()(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Link_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }

    return target;
  }

  var tagPropTypes = prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.elementType]);

  var Link_Link = function Link(_ref) {
    var _linkClasses;

    var className = _ref.className,
        children = _ref.children,
        icon = _ref.icon,
        iconPosition = _ref.iconPosition,
        removeUnderline = _ref.removeUnderline,
        small = _ref.small,
        style = _ref.style,
        suppressDefaultClass = _ref.suppressDefaultClass,
        tag = _ref.tag,
        tooltip = _ref.tooltip,
        truncate = _ref.truncate,
        rest = objectWithoutProperties_default()(_ref, Link_excluded);
    var linkClasses = (_linkClasses = {
      'sage-link': true
    }, defineProperty_default()(_linkClasses, "sage-link--".concat(style), style), defineProperty_default()(_linkClasses, 'sage-link--small', small), defineProperty_default()(_linkClasses, 'sage-link--remove-underline', removeUnderline), defineProperty_default()(_linkClasses, "sage-link--icon-".concat(iconPosition, "-").concat(icon), icon && iconPosition), _linkClasses);
    var classNames = classnames_default()(className, !suppressDefaultClass && linkClasses);
    var SelfTag = tag || 'a';
    return /*#__PURE__*/external_react_default.a.createElement(external_react_default.a.Fragment, null, tooltip ? /*#__PURE__*/external_react_default.a.createElement(Tooltip_Tooltip, tooltip, /*#__PURE__*/external_react_default.a.createElement(SelfTag, extends_default()({
      className: classNames
    }, rest), truncate ? /*#__PURE__*/external_react_default.a.createElement("span", {
      className: "t-sage--truncate"
    }, children) : children)) : /*#__PURE__*/external_react_default.a.createElement(SelfTag, extends_default()({
      className: classNames
    }, rest), truncate ? /*#__PURE__*/external_react_default.a.createElement("span", {
      className: "t-sage--truncate"
    }, children) : children));
  };

  Link_Link.CLASSNAMES = Link_objectSpread({}, SageClassnames.LINK);
  Link_Link.COLORS = LINK_COLORS;
  Link_Link.ICON_POSITIONS = LINK_ICON_POSITIONS;
  Link_Link.defaultProps = {
    className: null,
    children: null,
    icon: null,
    iconPosition: null,
    removeUnderline: false,
    small: false,
    style: Link_Link.COLORS.PRIMARY,
    suppressDefaultClass: false,
    tag: null,
    tooltip: null,
    truncate: false
  };
  Link_Link.tagPropTypes = tagPropTypes;
  Link_Link.propTypes = {
    className: prop_types_default.a.string,
    children: prop_types_default.a.node,
    icon: prop_types_default.a.oneOf(Object.values(SageTokens.ICONS)),
    iconPosition: prop_types_default.a.oneOf(Object.values(Link_Link.ICON_POSITIONS)),
    removeUnderline: prop_types_default.a.bool,
    small: prop_types_default.a.bool,
    style: prop_types_default.a.oneOf(Object.values(Link_Link.COLORS)),
    suppressDefaultClass: prop_types_default.a.bool,
    tag: tagPropTypes,
    tooltip: prop_types_default.a.shape({
      position: prop_types_default.a.oneOf(Object.values(Tooltip_Tooltip.POSITIONS)),
      size: prop_types_default.a.oneOf(Object.values(Tooltip_Tooltip.SIZES)),
      theme: prop_types_default.a.oneOf(Object.values(Tooltip_Tooltip.THEMES))
    }),
    truncate: prop_types_default.a.bool
  }; // CONCATENATED MODULE: ./lib/Link/index.js
  // CONCATENATED MODULE: ./lib/Loader/configs.js

  var LOADER_TYPES = {
    BAR: 'bar',
    SPINNER: 'spinner',
    SPINNER_IN_BUTTON: 'spinner-in-button',
    SUCCESS: 'success'
  }; // CONCATENATED MODULE: ./lib/Loader/Loader.jsx

  var Loader_excluded = ["fillSpace", "hideWhenDone", "label", "loading", "type", "className"];

  var Loader_Loader = function Loader(_ref) {
    var _classnames;

    var fillSpace = _ref.fillSpace,
        hideWhenDone = _ref.hideWhenDone,
        label = _ref.label,
        loading = _ref.loading,
        type = _ref.type,
        className = _ref.className,
        rest = objectWithoutProperties_default()(_ref, Loader_excluded);
    var classNames = classnames_default()('sage-loader', className, (_classnames = {
      'sage-loader--fill': fillSpace
    }, defineProperty_default()(_classnames, "sage-loader--".concat(type), type), defineProperty_default()(_classnames, 'visually-hidden', !loading && hideWhenDone), _classnames));
    var ariaAttrs = {
      'aria-hidden': !loading,
      'aria-busy': true,
      'aria-live': 'polite'
    };
    return /*#__PURE__*/external_react_default.a.createElement("div", extends_default()({
      className: classNames,
      "data-loading": loading
    }, ariaAttrs, rest), type === LOADER_TYPES.SPINNER_IN_BUTTON && /*#__PURE__*/external_react_default.a.createElement("svg", {
      className: "sage-loader__spinner sage-loader__spinner--loading-button",
      viewBox: "25 25 50 50",
      "aria-hidden": "true"
    }, /*#__PURE__*/external_react_default.a.createElement("circle", {
      className: "sage-loader__spinner-path sage-loader__spinner-path--loading-button",
      cx: "50",
      cy: "50",
      r: "20",
      fill: "none",
      stroke: "0072EF",
      strokeWidth: "4"
    })), type === LOADER_TYPES.SPINNER && /*#__PURE__*/external_react_default.a.createElement("svg", {
      className: "sage-loader__spinner",
      viewBox: "25 25 50 50"
    }, /*#__PURE__*/external_react_default.a.createElement("circle", {
      className: "sage-loader__spinner-path",
      cx: "50",
      cy: "50",
      r: "20",
      fill: "none",
      stroke: "0072EF",
      strokeWidth: "2"
    })), type === LOADER_TYPES.SUCCESS && /*#__PURE__*/external_react_default.a.createElement("svg", {
      className: "sage-loader__success",
      width: "48",
      height: "48",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/external_react_default.a.createElement("circle", {
      cx: "24",
      cy: "24",
      r: "21",
      fill: "#0072EF"
    }), /*#__PURE__*/external_react_default.a.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M34.707 17.293a1 1 0 0 1 0 1.414l-13 13a1 1 0 0 1-1.414 0l-7-7a1 1 0 0 1 1.414-1.414L21 29.586l12.293-12.293a1 1 0 0 1 1.414 0Z",
      fill: "#fff"
    })), label ? /*#__PURE__*/external_react_default.a.createElement("p", {
      className: "sage-loader__text t-sage-body-small"
    }, label) : /*#__PURE__*/external_react_default.a.createElement("span", {
      className: "visually-hidden"
    }, label));
  };

  Loader_Loader.TYPES = LOADER_TYPES;
  Loader_Loader.defaultProps = {
    className: '',
    fillSpace: false,
    label: 'Loading...',
    hideWhenDone: true,
    type: LOADER_TYPES.SPINNER
  };
  Loader_Loader.propTypes = {
    className: prop_types_default.a.string,
    fillSpace: prop_types_default.a.bool,
    hideWhenDone: prop_types_default.a.bool,
    label: prop_types_default.a.string,
    loading: prop_types_default.a.bool.isRequired,
    type: prop_types_default.a.oneOf(Object.values(LOADER_TYPES))
  }; // CONCATENATED MODULE: ./lib/Loader/index.js
  // CONCATENATED MODULE: ./lib/Button/configs.js

  var BUTTON_COLORS = {
    ACCENT: 'accent',
    PRIMARY: 'primary',
    SECONDARY: 'secondary',
    DANGER: 'danger'
  };
  var BUTTON_ICON_POSITIONS = {
    LEFT: 'left',
    RIGHT: 'right'
  };
  var BUTTON_GROUP_GAP_OPTIONS = {
    XS: null,
    SM: 'sm',
    MD: 'md',
    LG: 'lg'
  };
  var BUTTON_GROUP_ALIGN_OPTIONS = {
    CENTER: 'center',
    NONE: 'none',
    END: 'end',
    SPACEBETWEEN: 'space-between'
  };
  var BUTTON_DEFAULT_LOADING_TEXT = 'Loading...'; // CONCATENATED MODULE: ./lib/Button/ButtonGroup.jsx

  var ButtonGroup_excluded = ["align", "alignEnd", "borderTop", "children", "className", "gap", "wrap"];

  var ButtonGroup_ButtonGroup = function ButtonGroup(_ref) {
    var _classnames;

    var align = _ref.align,
        alignEnd = _ref.alignEnd,
        borderTop = _ref.borderTop,
        children = _ref.children,
        className = _ref.className,
        gap = _ref.gap,
        wrap = _ref.wrap,
        rest = objectWithoutProperties_default()(_ref, ButtonGroup_excluded);
    var classNames = classnames_default()('sage-btn-group', className, (_classnames = {
      'sage-btn-group--align-end': alignEnd
    }, defineProperty_default()(_classnames, "sage-btn-group--align-".concat(align), align), defineProperty_default()(_classnames, 'sage-btn-group--border-top', borderTop), defineProperty_default()(_classnames, "sage-grid-gap-".concat(gap), gap), defineProperty_default()(_classnames, 'sage-btn-group--wrap', wrap), _classnames));
    return /*#__PURE__*/external_react_default.a.createElement("div", extends_default()({
      className: classNames
    }, rest), children);
  };

  ButtonGroup_ButtonGroup.ALIGN_OPTIONS = BUTTON_GROUP_ALIGN_OPTIONS;
  ButtonGroup_ButtonGroup.GAP_OPTIONS = BUTTON_GROUP_GAP_OPTIONS;
  ButtonGroup_ButtonGroup.defaultProps = {
    align: ButtonGroup_ButtonGroup.ALIGN_OPTIONS.NONE,
    alignEnd: false,
    borderTop: false,
    className: null,
    children: null,
    gap: ButtonGroup_ButtonGroup.GAP_OPTIONS.XS,
    wrap: false
  };
  ButtonGroup_ButtonGroup.propTypes = {
    align: prop_types_default.a.oneOf(Object.values(ButtonGroup_ButtonGroup.ALIGN_OPTIONS)),
    alignEnd: prop_types_default.a.bool,
    borderTop: prop_types_default.a.bool,
    className: prop_types_default.a.string,
    children: prop_types_default.a.node,
    gap: prop_types_default.a.oneOf(Object.values(ButtonGroup_ButtonGroup.GAP_OPTIONS)),
    wrap: prop_types_default.a.bool
  }; // CONCATENATED MODULE: ./lib/Button/Button.jsx

  var Button_excluded = ["alignEnd", "children", "className", "customContentClassName", "color", "disabled", "disclosure", "fullWidth", "hasCustomContent", "icon", "iconOnly", "iconPosition", "linkTag", "loading", "onClick", "selected", "small", "subtle"];
  var Button = /*#__PURE__*/external_react_default.a.forwardRef(function (_ref, ref) {
    var _classnames;

    var alignEnd = _ref.alignEnd,
        children = _ref.children,
        className = _ref.className,
        customContentClassName = _ref.customContentClassName,
        color = _ref.color,
        disabled = _ref.disabled,
        disclosure = _ref.disclosure,
        fullWidth = _ref.fullWidth,
        hasCustomContent = _ref.hasCustomContent,
        icon = _ref.icon,
        iconOnly = _ref.iconOnly,
        iconPosition = _ref.iconPosition,
        linkTag = _ref.linkTag,
        loading = _ref.loading,
        onClick = _ref.onClick,
        selected = _ref.selected,
        small = _ref.small,
        subtle = _ref.subtle,
        rest = objectWithoutProperties_default()(_ref, Button_excluded);
    var to = rest.to,
        href = rest.href;
    var isLink = to || href;
    var TagName = isLink ? Link_Link : 'button';
    var blockName = 'sage-btn';
    var classNames = classnames_default()(blockName, className, (_classnames = {}, defineProperty_default()(_classnames, "".concat(blockName, "--align-end"), alignEnd), defineProperty_default()(_classnames, "".concat(blockName, "--").concat(color), color), defineProperty_default()(_classnames, "".concat(blockName, "--full-width"), fullWidth), defineProperty_default()(_classnames, "".concat(blockName, "--disclosure"), disclosure), defineProperty_default()(_classnames, "".concat(blockName, "--selected"), selected), defineProperty_default()(_classnames, "".concat(blockName, "--small"), small), defineProperty_default()(_classnames, "".concat(blockName, "--subtle"), subtle), defineProperty_default()(_classnames, "".concat(blockName, "--is-loading"), loading), defineProperty_default()(_classnames, "".concat(blockName, "--icon-").concat(iconPosition, "-").concat(icon), icon && !iconOnly), defineProperty_default()(_classnames, "".concat(blockName, "--icon-only-").concat(icon), icon && iconOnly), defineProperty_default()(_classnames, "disabled", isLink && disabled), _classnames));

    if (loading) {
      rest['aria-busy'] = true;
      rest['aria-label'] = rest['aria-label'] || BUTTON_DEFAULT_LOADING_TEXT;
      rest['aria-live'] = 'polite';
    }

    var generatedClassNames = 'sage-btn__truncate-text';

    if (iconOnly) {
      generatedClassNames = 'visually-hidden';
    }

    if (hasCustomContent) {
      generatedClassNames = classnames_default()('sage-btn__custom-content', customContentClassName);
    }

    if (isLink) {
      rest.suppressDefaultClass = true;
    }

    return /*#__PURE__*/external_react_default.a.createElement(TagName, extends_default()({
      ref: ref,
      className: classNames,
      "aria-disabled": isLink && disabled,
      disabled: !isLink && disabled,
      tag: isLink ? linkTag : null,
      suppressDefaultClass: isLink,
      onClick: onClick
    }, rest), /*#__PURE__*/external_react_default.a.createElement("span", {
      className: generatedClassNames
    }, children), !hasCustomContent && /*#__PURE__*/external_react_default.a.createElement(Loader_Loader, {
      loading: loading,
      type: Loader_Loader.TYPES.SPINNER_IN_BUTTON,
      label: null
    }));
  });
  Button.Group = ButtonGroup_ButtonGroup;
  Button.COLORS = BUTTON_COLORS;
  Button.ICON_POSITIONS = BUTTON_ICON_POSITIONS;
  Button.defaultProps = {
    alignEnd: false,
    children: null,
    className: '',
    customContentClassName: null,
    color: Button.COLORS.PRIMARY,
    disabled: false,
    disclosure: false,
    fullWidth: false,
    hasCustomContent: false,
    icon: null,
    iconOnly: false,
    iconPosition: Button.ICON_POSITIONS.LEFT,
    linkTag: null,
    loading: false,
    onClick: null,
    selected: false,
    small: false,
    subtle: false,
    type: 'button'
  };
  Button.propTypes = {
    alignEnd: prop_types_default.a.bool,
    children: prop_types_default.a.node,
    className: prop_types_default.a.string,
    color: prop_types_default.a.oneOf(Object.values(Button.COLORS)),
    customContentClassName: prop_types_default.a.string,
    disabled: prop_types_default.a.bool,
    disclosure: prop_types_default.a.bool,
    fullWidth: prop_types_default.a.bool,
    hasCustomContent: prop_types_default.a.bool,
    icon: prop_types_default.a.oneOf(Object.values(SageTokens.ICONS)),
    iconOnly: prop_types_default.a.bool,
    iconPosition: prop_types_default.a.oneOf(Object.values(Button.ICON_POSITIONS)),
    linkTag: Link_Link.tagPropTypes,
    loading: prop_types_default.a.bool,
    onClick: prop_types_default.a.func,
    selected: prop_types_default.a.bool,
    small: prop_types_default.a.bool,
    subtle: prop_types_default.a.bool,
    type: prop_types_default.a.string
  }; // CONCATENATED MODULE: ./lib/Button/index.js
  // CONCATENATED MODULE: ./lib/Icon/configs.js

  var ICON_SIZES = {
    XS: 'xs',
    SM: 'sm',
    MD: 'md',
    LG: 'lg',
    XL: 'xl',
    '2XL': '2xl',
    XXL: '2xl',
    '3XL': '3xl',
    XXXL: '3xl',
    '4XL': '4xl',
    XXXXL: '4xl'
  };
  var ICON_CARD_COLORS = {
    DANGER: 'danger',
    DRAFT: 'draft',
    INFO: 'info',
    LOCKED: 'locked',
    PUBLISHED: 'published',
    WARNING: 'warning',
    PRIMARY: 'primary'
  }; // NOTE: Keep these in sync with `packages/sage-assets/lib/stylesheets/tokens/_line_height.scss`

  var ICON_ADJACENT_TYPES = {
    HEADING_1: 'h1',
    HEADING_2: 'h2',
    HEADING_3: 'h3',
    HEADING_4: 'h4',
    HEADING_5: 'h5',
    HEADING_6: 'h6',
    BODY: 'body',
    BODY_SMALL: 'body-sm',
    BODY_XSMALL: 'body-xs'
  }; // CONCATENATED MODULE: ./lib/Icon/Icon.jsx

  var Icon_excluded = ["adjacentType", "backgroundHeight", "backgroundWidth", "cardColor", "circular", "className", "color", "icon", "label", "size"];

  var Icon_Icon = function Icon(_ref) {
    var _classnames, _classnames2;

    var adjacentType = _ref.adjacentType,
        backgroundHeight = _ref.backgroundHeight,
        backgroundWidth = _ref.backgroundWidth,
        cardColor = _ref.cardColor,
        circular = _ref.circular,
        className = _ref.className,
        color = _ref.color,
        icon = _ref.icon,
        label = _ref.label,
        size = _ref.size,
        rest = objectWithoutProperties_default()(_ref, Icon_excluded);
    var classNames = classnames_default()(className, 'sage-icon', (_classnames = {}, defineProperty_default()(_classnames, "sage-icon-".concat(icon), icon && (!size || size === ICON_SIZES.MD)), defineProperty_default()(_classnames, "sage-icon-".concat(icon, "-").concat(size), icon && size), defineProperty_default()(_classnames, "t-sage--color-".concat(color), color), defineProperty_default()(_classnames, "sage-icon--adjacent-type-".concat(adjacentType), adjacentType), _classnames));
    var wrapperClassNames = classnames_default()('sage-icon-background', (_classnames2 = {
      'sage-icon-background--custom-size': backgroundHeight || backgroundWidth
    }, defineProperty_default()(_classnames2, "sage-icon-background--".concat(cardColor), cardColor), defineProperty_default()(_classnames2, "sage-icon-background--".concat(size), size), defineProperty_default()(_classnames2, 'sage-icon-background--circular', circular), _classnames2));
    var attributes = {};

    if (!label || label === '') {
      attributes['aria-hidden'] = true;
    } else {
      attributes['aria-label'] = label;
    }

    var renderIcon = function renderIcon() {
      return /*#__PURE__*/external_react_default.a.createElement("i", extends_default()({
        className: classNames
      }, attributes, rest));
    };

    var setBackgroundDimensions = function setBackgroundDimensions() {
      var props = {};
      backgroundHeight = backgroundHeight || backgroundWidth;
      backgroundWidth = backgroundWidth || backgroundHeight;

      if (circular) {
        backgroundWidth = backgroundHeight;
      }

      props['--sage-icon-background-height'] = backgroundHeight;
      props['--sage-icon-background-width'] = backgroundWidth;
      return props;
    };

    return cardColor ? /*#__PURE__*/external_react_default.a.createElement("div", {
      style: setBackgroundDimensions(),
      className: wrapperClassNames
    }, renderIcon()) : renderIcon();
  };

  Icon_Icon.ADJACENT_TYPES = ICON_ADJACENT_TYPES;
  Icon_Icon.CARD_COLORS = ICON_CARD_COLORS;
  Icon_Icon.COLORS = SageTokens.COLOR_SLIDERS;
  Icon_Icon.ICONS = SageTokens.ICONS;
  Icon_Icon.SIZES = ICON_SIZES;
  Icon_Icon.defaultProps = {
    adjacentType: null,
    backgroundHeight: null,
    backgroundWidth: null,
    cardColor: null,
    circular: false,
    className: '',
    color: SageTokens.COLOR_SLIDERS.INHERIT,
    label: '',
    size: null
  };
  Icon_Icon.propTypes = {
    adjacentType: prop_types_default.a.oneOf(Object.values(Icon_Icon.ADJACENT_TYPES)),
    backgroundHeight: prop_types_default.a.string,
    backgroundWidth: prop_types_default.a.string,
    cardColor: prop_types_default.a.oneOf(Object.values(Icon_Icon.CARD_COLORS)),
    circular: prop_types_default.a.bool,
    className: prop_types_default.a.string,
    color: prop_types_default.a.oneOf(Object.values(Icon_Icon.COLORS)),
    icon: prop_types_default.a.oneOf(Object.values(Icon_Icon.ICONS)).isRequired,
    label: prop_types_default.a.string,
    size: prop_types_default.a.oneOf(Object.values(Icon_Icon.SIZES))
  }; // CONCATENATED MODULE: ./lib/Icon/index.js
  // CONCATENATED MODULE: ./lib/Alert/configs.js

  var ALERT_COLORS = {
    DEFAULT: 'default',
    INFO: 'info',
    SUCCESS: 'success',
    WARNING: 'warning',
    DANGER: 'danger',
    APPROACHING: 'approaching',
    REACHED: 'reached',
    EXCEEDED: 'exceeded'
  };
  var ALERT_PRIMARY_ACTION_CLASSNAME = 'sage-alert__primary-action'; // CONCATENATED MODULE: ./lib/Alert/Alert.jsx

  var Alert_excluded = ["actions", "className", "color", "description", "dismissable", "icon", "onDismiss", "small", "title", "titleAddon"];

  var Alert_Alert = function Alert(_ref) {
    var _classnames;

    var actions = _ref.actions,
        className = _ref.className,
        color = _ref.color,
        description = _ref.description,
        dismissable = _ref.dismissable,
        icon = _ref.icon,
        onDismiss = _ref.onDismiss,
        small = _ref.small,
        title = _ref.title,
        titleAddon = _ref.titleAddon,
        rest = objectWithoutProperties_default()(_ref, Alert_excluded);

    var _useState = Object(external_react_["useState"])(false),
        _useState2 = slicedToArray_default()(_useState, 2),
        selfDismissed = _useState2[0],
        setSelfDismissed = _useState2[1];

    var classNames = classnames_default()('sage-alert', className, (_classnames = {}, defineProperty_default()(_classnames, "sage-alert--".concat(color), color), defineProperty_default()(_classnames, 'sage-alert--dismissable', dismissable), defineProperty_default()(_classnames, 'sage-alert--small', small), _classnames));

    var handleDismiss = function handleDismiss() {
      setSelfDismissed(true);
      if (onDismiss) onDismiss();
    };

    var getDefaultIcon = function getDefaultIcon() {
      switch (color) {
        case ALERT_COLORS.WARNING:
          return SageTokens.ICONS.WARNING_FILLED;

        case ALERT_COLORS.APPROACHING:
          return SageTokens.ICONS.WARNING_FILLED;

        case ALERT_COLORS.DANGER:
          return SageTokens.ICONS.DANGER_FILLED;

        case ALERT_COLORS.EXCEEDED:
          return SageTokens.ICONS.DANGER_FILLED;

        case ALERT_COLORS.REACHED:
          return SageTokens.ICONS.FLAG;

        case ALERT_COLORS.SUCCESS:
          return SageTokens.ICONS.CHECK_CIRCLE_FILLED;

        case ALERT_COLORS.INFO:
        default:
          return SageTokens.ICONS.INFO_CIRCLE_FILLED;
      }
    };

    return !selfDismissed ? /*#__PURE__*/external_react_default.a.createElement("div", extends_default()({
      className: classNames
    }, rest), /*#__PURE__*/external_react_default.a.createElement(Icon_Icon, {
      icon: icon || getDefaultIcon(),
      className: "sage-alert__icon"
    }), /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-alert__copy"
    }, title && /*#__PURE__*/external_react_default.a.createElement("h3", {
      className: "sage-alert__title"
    }, title, /*#__PURE__*/external_react_default.a.createElement("span", {
      className: "sage-alert__title--add-on"
    }, " ", titleAddon)), description && /*#__PURE__*/external_react_default.a.createElement("p", {
      className: "sage-alert__desc"
    }, description)), actions && /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-alert__actions"
    }, actions), dismissable && /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-alert__close"
    }, /*#__PURE__*/external_react_default.a.createElement(Button, {
      className: "sage-alert__close-btn",
      color: Button.COLORS.PRIMARY,
      icon: SageTokens.ICONS.REMOVE,
      iconOnly: true,
      subtle: true,
      value: "Close",
      onClick: handleDismiss,
      "aria-label": "Close Alert"
    }))) : null;
  };

  Alert_Alert.COLORS = ALERT_COLORS;
  Alert_Alert.PRIMARY_ACTION_CLASSNAME = ALERT_PRIMARY_ACTION_CLASSNAME;
  Alert_Alert.defaultProps = {
    actions: null,
    className: '',
    description: null,
    dismissable: false,
    icon: null,
    onDismiss: null,
    small: false,
    title: null,
    titleAddon: null
  };
  Alert_Alert.propTypes = {
    actions: prop_types_default.a.node,
    className: prop_types_default.a.string,
    color: prop_types_default.a.oneOf(Object.values(ALERT_COLORS)).isRequired,
    description: prop_types_default.a.string,
    dismissable: prop_types_default.a.bool,
    icon: prop_types_default.a.oneOf(Object.values(SageTokens.ICONS)),
    onDismiss: prop_types_default.a.func,
    small: prop_types_default.a.bool,
    title: prop_types_default.a.string,
    titleAddon: prop_types_default.a.string
  }; // CONCATENATED MODULE: ./lib/Alert/index.js
  // CONCATENATED MODULE: ./lib/Avatar/configs.js

  var AVATAR_COLORS = {
    DEFAULT: null,
    CHARCOAL: 'grey',
    PURPLE: 'purple',
    SAGE: 'sage',
    YELLOW: 'yellow',
    ORANGE: 'orange',
    RED: 'red'
  }; // CONCATENATED MODULE: ./lib/Avatar/Avatar.jsx

  var Avatar_excluded = ["badge", "badgeBackgroundColor", "badgeForegroundColor", "badgeIcon", "className", "centered", "color", "image", "useFallbackGraphic", "size"];

  var Avatar_Avatar = function Avatar(_ref) {
    var badge = _ref.badge,
        badgeBackgroundColor = _ref.badgeBackgroundColor,
        badgeForegroundColor = _ref.badgeForegroundColor,
        badgeIcon = _ref.badgeIcon,
        className = _ref.className,
        centered = _ref.centered,
        color = _ref.color,
        image = _ref.image,
        useFallbackGraphic = _ref.useFallbackGraphic,
        size = _ref.size,
        rest = objectWithoutProperties_default()(_ref, Avatar_excluded);
    var classNames = classnames_default()('sage-avatar', className, defineProperty_default()({
      'sage-avatar--centered': centered,
      'sage-avatar--custom-badge': badgeBackgroundColor || badgeIcon || badgeForegroundColor
    }, "sage-avatar--".concat(color), color));
    var badgeClassnames = classnames_default()('sage-avatar__badge', {
      'sage-avatar__badge--custom-bg': badgeBackgroundColor
    });
    var style = {};

    if (size) {
      style.width = size;
      style.height = size;
    }

    var setBadgeSize = function setBadgeSize() {
      var badgeIconSize = 'xs';
      var avatarSizeAsInteger = size.replace(/[^0-9]/g, '');

      if (avatarSizeAsInteger >= 32 && avatarSizeAsInteger < 48) {
        badgeIconSize = Icon_Icon.SIZES.SM;
      } else if (avatarSizeAsInteger >= 48 && avatarSizeAsInteger < 64) {
        badgeIconSize = Icon_Icon.SIZES.MD;
      } else if (avatarSizeAsInteger >= 64 && avatarSizeAsInteger < 80) {
        badgeIconSize = Icon_Icon.SIZES.LG;
      } else if (avatarSizeAsInteger >= 80 && avatarSizeAsInteger < 96) {
        badgeIconSize = Icon_Icon.SIZES.XL;
      } else if (avatarSizeAsInteger >= 96 && avatarSizeAsInteger < 112) {
        badgeIconSize = Icon_Icon.SIZES.XXL;
      } else if (avatarSizeAsInteger >= 112 && avatarSizeAsInteger < 128) {
        badgeIconSize = Icon_Icon.SIZES.XXXL;
      } else if (avatarSizeAsInteger >= 128) {
        badgeIconSize = Icon_Icon.SIZES.XXXXL;
      }

      return badgeIconSize;
    };

    return /*#__PURE__*/external_react_default.a.createElement("div", extends_default()({
      className: classNames,
      style: style
    }, rest), badge && /*#__PURE__*/external_react_default.a.createElement("div", {
      className: badgeClassnames,
      style: {
        '--badge-custom-bg-color': badgeBackgroundColor || ''
      }
    }, /*#__PURE__*/external_react_default.a.createElement(Icon_Icon, {
      icon: badgeIcon || Icon_Icon.ICONS.CHECK_CIRCLE_FILLED,
      color: badgeForegroundColor || Icon_Icon.COLORS.PRIMARY_300,
      size: setBadgeSize()
    })), image.src && /*#__PURE__*/external_react_default.a.createElement("img", {
      alt: image.alt || '',
      className: "sage-avatar__image",
      src: image.src,
      id: image.id
    }), (!image.src || useFallbackGraphic) && /*#__PURE__*/external_react_default.a.createElement("svg", {
      className: "sage-avatar__graphic",
      viewBox: "0 0 28 28"
    }, /*#__PURE__*/external_react_default.a.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19.038 14.594a8.167 8.167 0 1 0-10.077 0C3.767 16.236 0 21.094 0 26.834a1.167 1.167 0 1 0 2.333 0c0-5.8 4.701-10.5 10.5-10.5h2.334c5.799 0 10.5 4.7 10.5 10.5a1.167 1.167 0 1 0 2.333 0c0-5.74-3.766-10.598-8.962-12.24ZM8.167 8.167a5.833 5.833 0 1 1 11.666 0 5.833 5.833 0 0 1-11.666 0Z",
      fill: "#054FB8"
    })));
  };

  Avatar_Avatar.COLORS = AVATAR_COLORS;
  Avatar_Avatar.defaultProps = {
    badge: false,
    badgeBackgroundColor: null,
    badgeForegroundColor: null,
    badgeIcon: null,
    centered: false,
    className: '',
    color: AVATAR_COLORS.DEFAULT,
    image: {},
    size: null,
    useFallbackGraphic: true
  };
  Avatar_Avatar.propTypes = {
    badge: prop_types_default.a.bool,
    badgeBackgroundColor: prop_types_default.a.string,
    badgeForegroundColor: prop_types_default.a.oneOf(Object.values(SageTokens.COLOR_SLIDERS)),
    badgeIcon: prop_types_default.a.oneOf(Object.values(SageTokens.ICONS)),
    centered: prop_types_default.a.bool,
    className: prop_types_default.a.string,
    color: prop_types_default.a.oneOf(Object.values(AVATAR_COLORS)),
    image: prop_types_default.a.shape({
      alt: prop_types_default.a.string,
      src: prop_types_default.a.string,
      id: prop_types_default.a.string
    }),
    size: prop_types_default.a.string,
    useFallbackGraphic: prop_types_default.a.bool
  }; // CONCATENATED MODULE: ./lib/Avatar/index.js
  // EXTERNAL MODULE: /__w/sage-lib/sage-lib/node_modules/react-uuid/uuid.js

  var uuid = __webpack_require__(7);

  var uuid_default = /*#__PURE__*/__webpack_require__.n(uuid); // CONCATENATED MODULE: ./lib/AvatarGroup/AvatarGroup.jsx


  var AvatarGroup_excluded = ["className", "items"];

  var AvatarGroup_AvatarGroup = function AvatarGroup(_ref) {
    var className = _ref.className,
        items = _ref.items,
        rest = objectWithoutProperties_default()(_ref, AvatarGroup_excluded);
    var classNames = classnames_default()('sage-avatar-group', className, defineProperty_default()({}, "sage-avatar-group--".concat(items.length < 4 ? items.length : 4, "-up"), items.length > 1));
    return /*#__PURE__*/external_react_default.a.createElement("div", extends_default()({
      className: classNames
    }, rest), items.map(function (configs, i) {
      return i < 4 && /*#__PURE__*/external_react_default.a.createElement(Avatar_Avatar, extends_default()({
        key: uuid_default()()
      }, configs));
    }));
  };

  AvatarGroup_AvatarGroup.defaultProps = {
    className: '',
    items: []
  };
  AvatarGroup_AvatarGroup.propTypes = {
    className: prop_types_default.a.string,
    items: prop_types_default.a.arrayOf(prop_types_default.a.shape({
      initials: prop_types_default.a.string
    }))
  }; // CONCATENATED MODULE: ./lib/AvatarGroup/index.js
  // CONCATENATED MODULE: ./lib/Badge/configs.js

  var BADGE_COLORS = {
    DANGER: 'danger',
    DRAFT: 'draft',
    INFO: 'info',
    LOCKED: 'locked',
    PUBLISHED: 'published',
    SUCCESS: 'published',
    // dupe alias for common usage or other contexts
    WARNING: 'warning'
  };
  var BADGE_GROUP_ALIGN_OPTIONS = {
    CENTER: 'center',
    NONE: 'none',
    END: 'end',
    SPACEBETWEEN: 'space-between'
  };
  var BADGE_GROUP_GAP_OPTIONS = {
    NONE: null,
    XS: 'xs',
    SM: 'sm',
    MD: 'md',
    LG: 'lg'
  }; // CONCATENATED MODULE: ./lib/Badge/Badge.jsx

  var Badge_excluded = ["className", "color", "containerAttributes", "dot", "isDropdown", "isInteractive", "isStatus", "large", "value"];
  var Badge = /*#__PURE__*/external_react_default.a.forwardRef(function (_ref, ref) {
    var _classnames;

    var className = _ref.className,
        color = _ref.color,
        containerAttributes = _ref.containerAttributes,
        dot = _ref.dot,
        isDropdown = _ref.isDropdown,
        isInteractive = _ref.isInteractive,
        isStatus = _ref.isStatus,
        large = _ref.large,
        value = _ref.value,
        rest = objectWithoutProperties_default()(_ref, Badge_excluded);
    var TagName = isInteractive ? 'button' : 'span';
    var classNames = classnames_default()('sage-badge', className, (_classnames = {}, defineProperty_default()(_classnames, "sage-badge--".concat(color), color), defineProperty_default()(_classnames, 'sage-badge--interactive', isInteractive), defineProperty_default()(_classnames, 'sage-badge--large', large), _classnames));
    return /*#__PURE__*/external_react_default.a.createElement("span", extends_default()({
      className: classNames,
      ref: ref
    }, containerAttributes), dot && /*#__PURE__*/external_react_default.a.createElement(external_react_default.a.Fragment, null, dot), /*#__PURE__*/external_react_default.a.createElement(TagName, extends_default()({
      className: "sage-badge__value",
      type: isInteractive ? 'button' : null
    }, rest), /*#__PURE__*/external_react_default.a.createElement("span", {
      className: "sage-badge__value-text"
    }, value)), isInteractive === true && /*#__PURE__*/external_react_default.a.createElement("span", {
      className: "sage-badge__decor-icon sage-badge__decor-icon--down-small"
    }));
  });
  Badge.COLORS = BADGE_COLORS;
  Badge.defaultProps = {
    className: null,
    color: BADGE_COLORS.DRAFT,
    containerAttributes: null,
    dot: null,
    isInteractive: null,
    isDropdown: false,
    isStatus: false,
    large: false
  };
  Badge.propTypes = {
    className: prop_types_default.a.string,
    color: prop_types_default.a.oneOf(Object.values(BADGE_COLORS)),
    containerAttributes: prop_types_default.a.shape({}),
    dot: prop_types_default.a.node,
    isInteractive: prop_types_default.a.bool,
    isDropdown: prop_types_default.a.bool,
    isStatus: prop_types_default.a.bool,
    large: prop_types_default.a.bool,
    value: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.node]).isRequired
  }; // CONCATENATED MODULE: ./lib/Badge/index.js
  // CONCATENATED MODULE: ./lib/Banner/configs.js

  var BANNER_TYPES = {
    DEFAULT: 'default',
    SECONDARY: 'secondary',
    WARNING: 'warning',
    DANGER: 'danger'
  }; // CONCATENATED MODULE: ./lib/Banner/BannerContent.jsx

  var BannerContent_excluded = ["active", "bannerContext", "children", "className", "dismissable", "id", "link", "text", "type"];

  var BannerContent_BannerContent = function BannerContent(_ref) {
    var _classnames;

    var active = _ref.active,
        bannerContext = _ref.bannerContext,
        children = _ref.children,
        className = _ref.className,
        dismissable = _ref.dismissable,
        id = _ref.id,
        link = _ref.link,
        text = _ref.text,
        type = _ref.type,
        rest = objectWithoutProperties_default()(_ref, BannerContent_excluded);
    var classNames = classnames_default()('sage-banner', className, (_classnames = {}, defineProperty_default()(_classnames, "sage-banner--".concat(type), type), defineProperty_default()(_classnames, 'sage-banner--active', active), _classnames));
    return /*#__PURE__*/external_react_default.a.createElement("div", extends_default()({
      className: classNames
    }, rest, {
      id: id
    }), text && /*#__PURE__*/external_react_default.a.createElement("p", {
      className: "sage-banner__text"
    }, text), link && /*#__PURE__*/external_react_default.a.createElement(Button, {
      className: "sage-banner__link",
      subtle: true,
      href: "#"
    }, "banner link"), children, dismissable && /*#__PURE__*/external_react_default.a.createElement(Button, {
      className: "sage-banner__close",
      icon: SageTokens.ICONS.REMOVE,
      iconOnly: true,
      subtle: true
    }, "Dismiss"));
  };

  BannerContent_BannerContent.TYPES = BANNER_TYPES;
  BannerContent_BannerContent.defaultProps = {
    active: false,
    bannerContext: null,
    children: null,
    className: null,
    dismissable: null,
    id: null,
    link: null,
    text: null,
    type: null
  };
  BannerContent_BannerContent.propTypes = {
    active: prop_types_default.a.bool,
    bannerContext: prop_types_default.a.string,
    children: prop_types_default.a.node,
    className: prop_types_default.a.string,
    dismissable: prop_types_default.a.bool,
    id: prop_types_default.a.string,
    link: prop_types_default.a.string,
    text: prop_types_default.a.string,
    type: prop_types_default.a.oneOf(Object.values(BannerContent_BannerContent.TYPES))
  }; // CONCATENATED MODULE: ./lib/Banner/BannerWrapper.jsx

  var BannerWrapper_excluded = ["active", "bannerContext", "children", "className", "dismissable", "id", "link", "text", "type"];

  var BannerWrapper_BannerWrapper = function BannerWrapper(_ref) {
    var active = _ref.active,
        bannerContext = _ref.bannerContext,
        children = _ref.children,
        className = _ref.className,
        dismissable = _ref.dismissable,
        id = _ref.id,
        link = _ref.link,
        text = _ref.text,
        type = _ref.type,
        rest = objectWithoutProperties_default()(_ref, BannerWrapper_excluded);
    var classNames = classnames_default()('sage-banner-wrapper', defineProperty_default()({}, "sage-banner-wrapper--context-".concat(bannerContext), bannerContext));
    return /*#__PURE__*/external_react_default.a.createElement("div", {
      className: classNames
    }, /*#__PURE__*/external_react_default.a.createElement(BannerContent_BannerContent, extends_default()({
      active: active,
      bannerContext: bannerContext,
      className: className,
      dismissable: dismissable,
      id: id,
      link: link,
      text: text,
      type: type
    }, rest), children));
  };

  BannerWrapper_BannerWrapper.defaultProps = {
    active: false,
    bannerContext: null,
    children: null,
    className: null,
    dismissable: null,
    id: null,
    link: null,
    text: null,
    type: null
  };
  BannerWrapper_BannerWrapper.propTypes = {
    active: prop_types_default.a.bool,
    bannerContext: prop_types_default.a.string,
    children: prop_types_default.a.node,
    className: prop_types_default.a.string,
    dismissable: prop_types_default.a.bool,
    id: prop_types_default.a.string,
    link: prop_types_default.a.string,
    text: prop_types_default.a.string,
    type: prop_types_default.a.string
  }; // CONCATENATED MODULE: ./lib/Banner/Banner.jsx

  var Banner_excluded = ["active", "bannerContext"];

  var Banner_Banner = function Banner(_ref) {
    var active = _ref.active,
        bannerContext = _ref.bannerContext,
        rest = objectWithoutProperties_default()(_ref, Banner_excluded);
    return bannerContext !== null ? /*#__PURE__*/external_react_default.a.createElement(BannerWrapper_BannerWrapper, extends_default()({
      bannerContext: bannerContext,
      active: active
    }, rest)) : /*#__PURE__*/external_react_default.a.createElement(BannerContent_BannerContent, extends_default()({
      bannerContext: bannerContext,
      active: active
    }, rest));
  };

  Banner_Banner.TYPES = BANNER_TYPES; // Defining all default props and prop types explicitly to populate story table

  Banner_Banner.defaultProps = {
    active: false,
    bannerContext: null,
    dismissable: true,
    link: null,
    text: null,
    type: Banner_Banner.TYPES.DEFAULT
  };
  Banner_Banner.propTypes = {
    active: prop_types_default.a.bool,
    bannerContext: prop_types_default.a.string,
    dismissable: prop_types_default.a.bool,
    link: prop_types_default.a.string,
    text: prop_types_default.a.string,
    type: prop_types_default.a.oneOf(Object.values(BANNER_TYPES))
  }; // CONCATENATED MODULE: ./lib/Banner/index.js
  // CONCATENATED MODULE: ./lib/Breadcrumbs/configs.js

  var breadcrumbItemPropTypes = prop_types_default.a.shape({
    current: prop_types_default.a.bool,
    disabled: prop_types_default.a.bool,
    label: prop_types_default.a.string,
    linkTag: Link_Link.tagPropTypes
  }); // CONCATENATED MODULE: ./lib/Breadcrumbs/Breadcrumbs.jsx

  var Breadcrumbs_excluded = ["className", "icon", "isProgressbar", "items"],
      _excluded2 = ["current", "disabled", "label", "linkTag"];

  var Breadcrumbs_Breadcrumbs = function Breadcrumbs(_ref) {
    var className = _ref.className,
        icon = _ref.icon,
        isProgressbar = _ref.isProgressbar,
        items = _ref.items,
        rest = objectWithoutProperties_default()(_ref, Breadcrumbs_excluded);
    var classNames = classnames_default()('sage-breadcrumbs', className, {
      'sage-breadcrumbs--progressbar': isProgressbar
    });
    var currentSet = false;
    var renderedItems = items.map(function (_ref2, i) {
      var current = _ref2.current,
          disabled = _ref2.disabled,
          label = _ref2.label,
          linkTag = _ref2.linkTag,
          otherProps = objectWithoutProperties_default()(_ref2, _excluded2);
      var isCurrent = current || !currentSet && items.length > 1 && i + 1 === items.length;
      currentSet = currentSet || isCurrent;
      var content = /*#__PURE__*/external_react_default.a.createElement(Link_Link, extends_default()({
        "aria-current": isCurrent ? 'page' : false,
        "aria-disabled": disabled,
        className: "sage-breadcrumbs__link ".concat(isCurrent && 'sage-breadcrumbs__link--current'),
        suppressDefaultClass: true,
        tag: linkTag
      }, otherProps), icon && items.length === 1 && i === 0 && /*#__PURE__*/external_react_default.a.createElement(Icon_Icon, {
        className: "sage-breadcrumbs__icon",
        icon: icon
      }), label);
      var breadCrumbItemKey = "breadcrumbItem-".concat(i.toString());
      return items.length === 1 ? /*#__PURE__*/external_react_default.a.createElement("p", {
        key: breadCrumbItemKey,
        className: "sage-breadcrumbs__item"
      }, content) : /*#__PURE__*/external_react_default.a.createElement("li", {
        key: breadCrumbItemKey,
        className: "sage-breadcrumbs__item"
      }, content);
    });
    return /*#__PURE__*/external_react_default.a.createElement("nav", extends_default()({
      "aria-label": "Breadcrumbs",
      className: classNames
    }, rest), items.length > 1 ? /*#__PURE__*/external_react_default.a.createElement("ul", {
      className: "sage-breadcrumbs__list"
    }, renderedItems) : /*#__PURE__*/external_react_default.a.createElement(external_react_default.a.Fragment, null, renderedItems));
  };

  Breadcrumbs_Breadcrumbs.itemPropTypes = breadcrumbItemPropTypes;
  Breadcrumbs_Breadcrumbs.defaultProps = {
    className: null,
    icon: SageTokens.ICONS.CARET_LEFT,
    isProgressbar: false,
    items: []
  };
  Breadcrumbs_Breadcrumbs.propTypes = {
    className: prop_types_default.a.string,
    icon: prop_types_default.a.oneOf(Object.values(SageTokens.ICONS)),
    isProgressbar: prop_types_default.a.bool,
    items: prop_types_default.a.arrayOf(breadcrumbItemPropTypes)
  }; // CONCATENATED MODULE: ./lib/Breadcrumbs/index.js
  // CONCATENATED MODULE: ./lib/Card/CardBlock.jsx

  var CardBlock_excluded = ["children", "className", "sageType"];

  var CardBlock_CardBlock = function CardBlock(_ref) {
    var children = _ref.children,
        className = _ref.className,
        sageType = _ref.sageType,
        rest = objectWithoutProperties_default()(_ref, CardBlock_excluded);
    var classNames = classnames_default()('sage-card__block', className, defineProperty_default()({}, "".concat(SageClassnames.TYPE_BLOCK), sageType));
    return /*#__PURE__*/external_react_default.a.createElement("div", extends_default()({
      className: classNames
    }, rest), children);
  };

  CardBlock_CardBlock.defaultProps = {
    children: null,
    className: '',
    sageType: false
  };
  CardBlock_CardBlock.propTypes = {
    children: prop_types_default.a.node,
    className: prop_types_default.a.string,
    sageType: prop_types_default.a.bool
  }; // CONCATENATED MODULE: ./lib/Card/CardDivider.jsx

  var CardDivider_excluded = ["fullBleed", "className"];

  var CardDivider_CardDivider = function CardDivider(_ref) {
    var fullBleed = _ref.fullBleed,
        className = _ref.className,
        rest = objectWithoutProperties_default()(_ref, CardDivider_excluded);
    var classNames = classnames_default()('sage-card__divider', className, {
      'sage-card__divider--full-bleed': fullBleed
    });
    return /*#__PURE__*/external_react_default.a.createElement("hr", extends_default()({
      className: classNames
    }, rest));
  };

  CardDivider_CardDivider.defaultProps = {
    fullBleed: false,
    className: null
  };
  CardDivider_CardDivider.propTypes = {
    fullBleed: prop_types_default.a.bool,
    className: prop_types_default.a.string
  }; // CONCATENATED MODULE: ./lib/Card/configs.js

  var CARD_FOOTER_ALIGNMENTS = {
    DEFAULT: null,
    SPREAD: 'spread'
  };
  var CARD_FIGURE_BLEED_OPTIONS = {
    NONE: null,
    TOP: 'bleed-top',
    SIDES: 'bleed-sides',
    BOTTOM: 'bleed-bottom'
  };
  var CARD_ROW_ALIGNMENT_OPTIONS = {
    DEFAULT: null,
    START: 'start',
    TOP: 'start'
  };
  var CARD_ROW_GAP_OPTIONS = {
    DEFAULT: null,
    XS: 'xs',
    SM: 'sm',
    MD: 'md',
    LG: 'lg'
  };
  var CARD_LIST_GAP_OPTIONS = CARD_ROW_GAP_OPTIONS;
  var CARD_HIGHLIGHT_COLORS = {
    GREY: SageTokens.COLORS.GREY,
    ORANGE: SageTokens.COLORS.ORANGE,
    PRIMARY: SageTokens.COLORS.PRIMARY,
    PURPLE: SageTokens.COLORS.PURPLE,
    RED: SageTokens.COLORS.RED,
    SAGE: SageTokens.COLORS.SAGE,
    YELLOW: SageTokens.COLORS.YELLOW
  };
  var CARD_HIGHLIGHT_POSITIONS = {
    TOP: 'top',
    RIGHT: 'right',
    BOTTOM: 'bottom',
    LEFT: 'left'
  };
  var CARD_LIST_BLOCK_SPACING = {
    DEFAULT: false,
    SM: 'sm'
  }; // CONCATENATED MODULE: ./lib/Card/CardFigure.jsx

  var CardFigure_excluded = ["children", "className", "bleed", "isWistia"];

  var CardFigure_CardFigure = function CardFigure(_ref) {
    var children = _ref.children,
        className = _ref.className,
        bleed = _ref.bleed,
        isWistia = _ref.isWistia,
        rest = objectWithoutProperties_default()(_ref, CardFigure_excluded);
    var classNames = classnames_default()('sage-card__figure', className, defineProperty_default()({
      'sage-card__figure--wistia': isWistia
    }, "sage-card__figure--".concat(bleed), bleed));
    return /*#__PURE__*/external_react_default.a.createElement("div", extends_default()({
      className: classNames
    }, rest), children);
  };

  CardFigure_CardFigure.BLEED_OPTIONS = CARD_FIGURE_BLEED_OPTIONS;
  CardFigure_CardFigure.defaultProps = {
    bleed: CARD_FIGURE_BLEED_OPTIONS.NONE,
    children: null,
    className: null,
    isWistia: false
  };
  CardFigure_CardFigure.propTypes = {
    bleed: prop_types_default.a.oneOf(Object.values(CARD_FIGURE_BLEED_OPTIONS)),
    children: prop_types_default.a.node,
    className: prop_types_default.a.string,
    isWistia: prop_types_default.a.bool
  }; // CONCATENATED MODULE: ./lib/Card/CardFooter.jsx

  var CardFooter_excluded = ["align", "children"];

  var CardFooter_CardFooter = function CardFooter(_ref) {
    var align = _ref.align,
        children = _ref.children,
        rest = objectWithoutProperties_default()(_ref, CardFooter_excluded);
    return /*#__PURE__*/external_react_default.a.createElement("div", extends_default()({
      className: "sage-card__footer ".concat(align ? "sage-card__footer--align-".concat(align) : '')
    }, rest), children);
  };

  CardFooter_CardFooter.ALIGNMENTS = CARD_FOOTER_ALIGNMENTS;
  CardFooter_CardFooter.defaultProps = {
    align: null,
    children: null
  };
  CardFooter_CardFooter.propTypes = {
    align: prop_types_default.a.oneOf(Object.values(CARD_FOOTER_ALIGNMENTS)),
    children: prop_types_default.a.node
  }; // CONCATENATED MODULE: ./lib/Card/CardHighlight.jsx

  var CardHighlight_CardHighlight = function CardHighlight(_ref) {
    var _classnames;

    var children = _ref.children,
        className = _ref.className,
        color = _ref.color,
        customColor = _ref.customColor,
        position = _ref.position,
        value = _ref.value;
    var hasContent = value || children;
    var classNames = classnames_default()('sage-card-highlight', className, (_classnames = {}, defineProperty_default()(_classnames, "sage-card-highlight--".concat(color), color && !customColor), defineProperty_default()(_classnames, "sage-card-highlight--".concat(position), position), _classnames));
    return /*#__PURE__*/external_react_default.a.createElement("span", {
      className: classNames,
      "aria-hidden": !hasContent,
      "aria-label": value,
      style: customColor && customColor !== '' && {
        '--color': customColor
      }
    }, children && /*#__PURE__*/external_react_default.a.createElement("span", {
      className: "visually-hidden"
    }, children));
  };

  CardHighlight_CardHighlight.COLORS = CARD_HIGHLIGHT_COLORS;
  CardHighlight_CardHighlight.POSITIONS = CARD_HIGHLIGHT_POSITIONS;
  CardHighlight_CardHighlight.defaultProps = {
    children: null,
    className: null,
    color: CARD_HIGHLIGHT_COLORS.PRIMARY,
    customColor: null,
    position: CARD_HIGHLIGHT_POSITIONS.LEFT,
    value: null
  };
  CardHighlight_CardHighlight.propTypes = {
    children: prop_types_default.a.node,
    className: prop_types_default.a.string,
    color: prop_types_default.a.oneOf(Object.values(CARD_HIGHLIGHT_COLORS)),
    customColor: prop_types_default.a.string,
    position: prop_types_default.a.oneOf(Object.values(CARD_HIGHLIGHT_POSITIONS)),
    value: prop_types_default.a.string
  }; // CONCATENATED MODULE: ./lib/Card/CardImage.jsx

  var CardImage_excluded = ["src", "alt"];

  var CardImage_CardImage = function CardImage(_ref) {
    var src = _ref.src,
        alt = _ref.alt,
        rest = objectWithoutProperties_default()(_ref, CardImage_excluded);
    return /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-card__img"
    }, /*#__PURE__*/external_react_default.a.createElement("img", extends_default()({
      src: src,
      alt: alt
    }, rest)));
  };

  CardImage_CardImage.propTypes = {
    alt: prop_types_default.a.string.isRequired,
    src: prop_types_default.a.string.isRequired
  }; // CONCATENATED MODULE: ./lib/Card/CardListItem.jsx

  var CardListItem_excluded = ["children", "className", "gridTemplate", "gap"];

  var CardListItem_CardListItem = function CardListItem(_ref) {
    var _classnames;

    var children = _ref.children,
        className = _ref.className,
        gridTemplate = _ref.gridTemplate,
        gap = _ref.gap,
        rest = objectWithoutProperties_default()(_ref, CardListItem_excluded);
    var classNames = classnames_default()('sage-card__list-item', className, (_classnames = {}, defineProperty_default()(_classnames, "".concat(SageClassnames.lookupGridTemplate(gridTemplate)), gridTemplate), defineProperty_default()(_classnames, "sage-grid-gap-".concat(gap), gap), _classnames));
    return /*#__PURE__*/external_react_default.a.createElement("li", extends_default()({
      className: classNames
    }, rest), children);
  };

  CardListItem_CardListItem.defaultProps = {
    children: null,
    className: '',
    gridTemplate: null,
    gap: CARD_LIST_GAP_OPTIONS.DEFAULT
  };
  CardListItem_CardListItem.propTypes = {
    children: prop_types_default.a.node,
    className: prop_types_default.a.string,
    gridTemplate: prop_types_default.a.oneOf(Object.values(SageTokens.GRID_TEMPLATES)),
    gap: prop_types_default.a.oneOf(Object.values(CARD_LIST_GAP_OPTIONS))
  }; // CONCATENATED MODULE: ./lib/Card/CardList.jsx

  var CardList_excluded = ["children", "className", "hideFirstBorder", "itemClassName", "itemGridTemplate", "items", "blockSpacing", "wrapItems"];

  var CardList_CardList = function CardList(_ref) {
    var _classnames;

    var children = _ref.children,
        className = _ref.className,
        hideFirstBorder = _ref.hideFirstBorder,
        itemClassName = _ref.itemClassName,
        itemGridTemplate = _ref.itemGridTemplate,
        items = _ref.items,
        blockSpacing = _ref.blockSpacing,
        wrapItems = _ref.wrapItems,
        rest = objectWithoutProperties_default()(_ref, CardList_excluded);
    var classNames = classnames_default()('sage-card__list', className, (_classnames = {}, defineProperty_default()(_classnames, "sage-card__list--block-space-".concat(blockSpacing), blockSpacing), defineProperty_default()(_classnames, 'sage-card__list--hide-first-border', hideFirstBorder), _classnames));
    return /*#__PURE__*/external_react_default.a.createElement("ul", extends_default()({
      className: classNames
    }, rest), items && items.map(function (item) {
      return wrapItems ? /*#__PURE__*/external_react_default.a.createElement(CardListItem_CardListItem, {
        key: uuid_default()(),
        className: itemClassName,
        gridTemplate: itemGridTemplate
      }, item) : /*#__PURE__*/external_react_default.a.createElement(external_react_default.a.Fragment, {
        key: uuid_default()()
      }, item);
    }), children);
  };

  CardList_CardList.SPACING = CARD_LIST_BLOCK_SPACING;
  CardList_CardList.defaultProps = {
    children: null,
    className: '',
    hideFirstBorder: false,
    itemClassName: null,
    itemGridTemplate: null,
    items: [],
    blockSpacing: CARD_LIST_BLOCK_SPACING.DEFAULT,
    wrapItems: true
  };
  CardList_CardList.propTypes = {
    children: prop_types_default.a.node,
    className: prop_types_default.a.string,
    hideFirstBorder: prop_types_default.a.bool,
    items: prop_types_default.a.arrayOf(prop_types_default.a.node),
    itemClassName: prop_types_default.a.string,
    itemGridTemplate: prop_types_default.a.oneOf(Object.values(SageTokens.GRID_TEMPLATES)),
    blockSpacing: prop_types_default.a.oneOf(Object.values(CARD_LIST_BLOCK_SPACING)),
    wrapItems: prop_types_default.a.bool
  }; // CONCATENATED MODULE: ./lib/Card/CardRow.jsx

  var CardRow_excluded = ["children", "className", "gridTemplate", "verticalAlign", "gap"];

  var CardRow_CardRow = function CardRow(_ref) {
    var _classnames;

    var children = _ref.children,
        className = _ref.className,
        gridTemplate = _ref.gridTemplate,
        verticalAlign = _ref.verticalAlign,
        gap = _ref.gap,
        rest = objectWithoutProperties_default()(_ref, CardRow_excluded);
    var classNames = classnames_default()('sage-card__row', className, (_classnames = {}, defineProperty_default()(_classnames, "".concat(SageClassnames.lookupGridTemplate(gridTemplate)), gridTemplate), defineProperty_default()(_classnames, "sage-card__row--vertical-align-".concat(verticalAlign), verticalAlign), defineProperty_default()(_classnames, "sage-grid-gap-".concat(gap), gap), _classnames));
    return /*#__PURE__*/external_react_default.a.createElement("div", extends_default()({
      className: classNames
    }, rest), children);
  };

  CardRow_CardRow.GAP_OPTIONS = CARD_ROW_GAP_OPTIONS;
  CardRow_CardRow.ALIGNMENT_OPTIONS = CARD_ROW_ALIGNMENT_OPTIONS;
  CardRow_CardRow.defaultProps = {
    children: null,
    className: '',
    gridTemplate: null,
    verticalAlign: CardRow_CardRow.ALIGNMENT_OPTIONS.DEFAULT,
    gap: CardRow_CardRow.GAP_OPTIONS.DEFAULT
  };
  CardRow_CardRow.propTypes = {
    children: prop_types_default.a.node,
    className: prop_types_default.a.string,
    gap: prop_types_default.a.oneOf(Object.values(CardRow_CardRow.GAP_OPTIONS)),
    gridTemplate: prop_types_default.a.oneOf(Object.values(SageTokens.GRID_TEMPLATES)),
    verticalAlign: prop_types_default.a.oneOf(Object.values(CardRow_CardRow.ALIGNMENT_OPTIONS))
  }; // CONCATENATED MODULE: ./lib/Card/CardStack.jsx

  var CardStack_excluded = ["children", "className"];

  var CardStack_CardStack = function CardStack(_ref) {
    var children = _ref.children,
        className = _ref.className,
        rest = objectWithoutProperties_default()(_ref, CardStack_excluded);
    return /*#__PURE__*/external_react_default.a.createElement("div", extends_default()({
      className: "sage-card__stack ".concat(className || '')
    }, rest), children);
  };

  CardStack_CardStack.defaultProps = {
    children: null,
    className: ''
  };
  CardStack_CardStack.propTypes = {
    children: prop_types_default.a.node,
    className: prop_types_default.a.string
  }; // CONCATENATED MODULE: ./lib/Card/CardTitle.jsx

  var CardTitle_excluded = ["children", "tag"];

  var CardTitle_CardTitle = function CardTitle(_ref) {
    var children = _ref.children,
        tag = _ref.tag,
        rest = objectWithoutProperties_default()(_ref, CardTitle_excluded);
    var TagName = tag || 'h3';
    return /*#__PURE__*/external_react_default.a.createElement(TagName, extends_default()({
      className: "sage-card__title"
    }, rest), children);
  };

  CardTitle_CardTitle.defaultProps = {
    children: null,
    tag: null
  };
  CardTitle_CardTitle.propTypes = {
    children: prop_types_default.a.node,
    tag: prop_types_default.a.string
  }; // CONCATENATED MODULE: ./lib/Card/Card.jsx

  var Card_excluded = ["compact", "children", "className", "clearPaddingBottom", "clearPaddingLeft", "clearPaddingRight", "clearPaddingTop", "interactive", "loading", "borderDashed"];

  var Card_Card = function Card(_ref) {
    var compact = _ref.compact,
        children = _ref.children,
        className = _ref.className,
        clearPaddingBottom = _ref.clearPaddingBottom,
        clearPaddingLeft = _ref.clearPaddingLeft,
        clearPaddingRight = _ref.clearPaddingRight,
        clearPaddingTop = _ref.clearPaddingTop,
        interactive = _ref.interactive,
        loading = _ref.loading,
        borderDashed = _ref.borderDashed,
        rest = objectWithoutProperties_default()(_ref, Card_excluded);
    var classNames = classnames_default()('sage-card', className, {
      'sage-card--border-dashed': borderDashed,
      'sage-card--compact': compact,
      'sage-card--clear-padding-bottom': clearPaddingBottom,
      'sage-card--clear-padding-left': clearPaddingLeft,
      'sage-card--clear-padding-right': clearPaddingRight,
      'sage-card--clear-padding-top': clearPaddingTop,
      'sage-card--interactive': interactive
    });
    return /*#__PURE__*/external_react_default.a.createElement("div", extends_default()({
      className: classNames
    }, rest), loading ? /*#__PURE__*/external_react_default.a.createElement(Loader_Loader, {
      loading: true,
      fillSpace: true,
      type: Loader_Loader.TYPES.SPINNER
    }) : children);
  };

  Card_Card.Block = CardBlock_CardBlock;
  Card_Card.Divider = CardDivider_CardDivider;
  Card_Card.Figure = CardFigure_CardFigure;
  Card_Card.Footer = CardFooter_CardFooter;
  Card_Card.Highlight = CardHighlight_CardHighlight;
  Card_Card.Image = CardImage_CardImage;
  Card_Card.List = CardList_CardList;
  Card_Card.Row = CardRow_CardRow;
  Card_Card.Stack = CardStack_CardStack;
  Card_Card.Title = CardTitle_CardTitle;
  Card_Card.defaultProps = {
    compact: false,
    children: null,
    className: null,
    clearPaddingBottom: false,
    clearPaddingLeft: false,
    clearPaddingRight: false,
    clearPaddingTop: false,
    interactive: false,
    loading: false,
    borderDashed: false
  };
  Card_Card.propTypes = {
    compact: prop_types_default.a.bool,
    children: prop_types_default.a.node,
    className: prop_types_default.a.string,
    clearPaddingBottom: prop_types_default.a.bool,
    clearPaddingLeft: prop_types_default.a.bool,
    clearPaddingRight: prop_types_default.a.bool,
    clearPaddingTop: prop_types_default.a.bool,
    interactive: prop_types_default.a.bool,
    loading: prop_types_default.a.bool,
    borderDashed: prop_types_default.a.bool
  }; // CONCATENATED MODULE: ./lib/Card/index.js
  // EXTERNAL MODULE: /__w/sage-lib/sage-lib/node_modules/tiny-slider/dist/tiny-slider.js

  var tiny_slider = __webpack_require__(21); // CONCATENATED MODULE: ./lib/Carousel/CarouselArrow.jsx


  var CarouselArrow_CarouselArrow = function CarouselArrow(_ref) {
    var _classnames;

    var disabled = _ref.disabled,
        icon = _ref.icon,
        id = _ref.id,
        onClickCallback = _ref.onClickCallback;
    var baseClass = 'sage-carousel__arrow';
    var classNames = classnames_default()(baseClass, (_classnames = {}, defineProperty_default()(_classnames, "".concat(baseClass, "--").concat(id), id), defineProperty_default()(_classnames, "".concat(baseClass, "--disabled"), disabled), _classnames));
    return (
      /*#__PURE__*/
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events
      external_react_default.a.createElement("div", {
        className: classNames,
        onClick: onClickCallback,
        role: "button",
        tabIndex: -1
      }, /*#__PURE__*/external_react_default.a.createElement(Icon_Icon, {
        icon: icon,
        size: "lg"
      }))
    );
  };

  CarouselArrow_CarouselArrow.defaultProps = {
    disabled: false
  };
  CarouselArrow_CarouselArrow.propTypes = {
    disabled: prop_types_default.a.bool,
    icon: prop_types_default.a.string.isRequired,
    id: prop_types_default.a.string.isRequired,
    onClickCallback: prop_types_default.a.func.isRequired
  }; // CONCATENATED MODULE: ./lib/Carousel/CarouselSlide.jsx

  var CarouselSlide_CarouselSlide = function CarouselSlide(_ref) {
    var content = _ref.content,
        index = _ref.index,
        length = _ref.length;
    return /*#__PURE__*/external_react_default.a.createElement("div", {
      "aria-label": "".concat(index + 1, " of ").concat(length),
      "aria-roledescription": "slide",
      className: "sage-carousel__slide",
      role: "group"
    }, content);
  };

  CarouselSlide_CarouselSlide.defaultProps = {
    content: null
  };
  CarouselSlide_CarouselSlide.propTypes = {
    content: prop_types_default.a.node,
    index: prop_types_default.a.number.isRequired,
    length: prop_types_default.a.number.isRequired
  }; // CONCATENATED MODULE: ./lib/Indicator/Indicator.jsx

  var Indicator_Indicator = function Indicator(_ref) {
    var className = _ref.className,
        currentItem = _ref.currentItem,
        label = _ref.label,
        numItems = _ref.numItems,
        preposition = _ref.preposition,
        showText = _ref.showText;
    var classNames;
    var baseClass = 'sage-indicator';
    var items = [];

    for (var i = 0; i <= numItems - 1; i += 1) {
      if (i === currentItem - 1) {
        classNames = classnames_default()(baseClass, "".concat(baseClass, "--current"));
      } else {
        classNames = classnames_default()(baseClass);
      }

      items.push( /*#__PURE__*/external_react_default.a.createElement("li", {
        className: classNames,
        key: i
      }, /*#__PURE__*/external_react_default.a.createElement("span", {
        className: "visually-hidden"
      }, "".concat(label, " ").concat(i))));
    }

    return /*#__PURE__*/external_react_default.a.createElement(external_react_default.a.Fragment, null, showText ? /*#__PURE__*/external_react_default.a.createElement("p", {
      className: "sage-indicator-text"
    }, label, " ", currentItem, " ", preposition, " ", numItems) : /*#__PURE__*/external_react_default.a.createElement("ul", {
      className: "sage-indicator-list ".concat(className),
      "aria-label": "Showing ".concat(label, " ").concat(currentItem, " ").concat(preposition, " ").concat(numItems)
    }, items));
  };

  Indicator_Indicator.defaultProps = {
    className: null,
    currentItem: null,
    label: null,
    numItems: 0,
    preposition: 'of',
    showText: null
  };
  Indicator_Indicator.propTypes = {
    className: prop_types_default.a.string,
    currentItem: prop_types_default.a.number,
    label: prop_types_default.a.string,
    numItems: prop_types_default.a.number,
    preposition: prop_types_default.a.string,
    showText: prop_types_default.a.bool
  }; // CONCATENATED MODULE: ./lib/Indicator/index.js
  // CONCATENATED MODULE: ./lib/Carousel/Carousel.jsx

  function Carousel_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function Carousel_objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? Carousel_ownKeys(Object(source), !0).forEach(function (key) {
        defineProperty_default()(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Carousel_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }

    return target;
  }

  var Carousel_Carousel = function Carousel(_ref) {
    var children = _ref.children,
        options = _ref.options;

    var _useState = Object(external_react_["useState"])(0),
        _useState2 = slicedToArray_default()(_useState, 2),
        slidesIndex = _useState2[0],
        setSlidesIndex = _useState2[1];

    var _useState3 = Object(external_react_["useState"])(0),
        _useState4 = slicedToArray_default()(_useState3, 2),
        slidesLength = _useState4[0],
        setSlidesLength = _useState4[1];

    var _useState5 = Object(external_react_["useState"])(null),
        _useState6 = slicedToArray_default()(_useState5, 2),
        slides = _useState6[0],
        setSlides = _useState6[1];

    var _useState7 = Object(external_react_["useState"])(null),
        _useState8 = slicedToArray_default()(_useState7, 2),
        mySlider = _useState8[0],
        setMySlider = _useState8[1];

    var _useState9 = Object(external_react_["useState"])(false),
        _useState10 = slicedToArray_default()(_useState9, 2),
        looping = _useState10[0],
        setLooping = _useState10[1];

    var _useState11 = Object(external_react_["useState"])(false),
        _useState12 = slicedToArray_default()(_useState11, 2),
        arrowPrevDisabled = _useState12[0],
        setArrowPrevDisabled = _useState12[1];

    var _useState13 = Object(external_react_["useState"])(false),
        _useState14 = slicedToArray_default()(_useState13, 2),
        arrowNextDisabled = _useState14[0],
        setArrowNextDisabled = _useState14[1];

    function handlePrevArrowClick() {
      if (!looping) {
        if (slidesIndex !== 0) setSlidesIndex(slidesIndex - 1);
      } else {
        mySlider.goTo('prev');
      }
    }

    function handleNextArrowClick() {
      if (!looping) {
        if (slidesIndex !== slidesLength - 1) setSlidesIndex(slidesIndex + 1);
      } else {
        mySlider.goTo('next');
      }
    }

    Object(external_react_["useEffect"])(function () {
      var childrenArray = children.props.children;
      var childrenLength = childrenArray.length;
      setSlides(childrenArray.map(function (item, index) {
        return /*#__PURE__*/external_react_default.a.createElement(CarouselSlide_CarouselSlide, {
          content: item,
          index: index,
          length: childrenLength
        });
      }));
      setSlidesLength(childrenLength);
    }, [children]);
    Object(external_react_["useEffect"])(function () {
      setMySlider(Object(tiny_slider["tns"])(Carousel_objectSpread(Carousel_objectSpread({}, options), {}, {
        container: '.sage-carousel__carousel',
        controls: false,
        nav: false
      })));
      setLooping(!(options.loop !== undefined && !options.loop));
      setSlidesIndex(options.startIndex !== undefined ? options.startIndex : 0);
    }, [options, slides]);
    Object(external_react_["useEffect"])(function () {
      if (mySlider) {
        if (!looping) {
          if (slidesIndex === 0) setArrowPrevDisabled(true);else setArrowPrevDisabled(false);
          if (slidesIndex === slidesLength - 1) setArrowNextDisabled(true);else setArrowNextDisabled(false);
        }

        mySlider.goTo(slidesIndex);
      }
    }, [mySlider, looping, slidesIndex, slidesLength]);
    Object(external_react_["useEffect"])(function () {
      if (mySlider) {
        mySlider.events.on('dragEnd', function () {
          setSlidesIndex(mySlider.getInfo().index);
        });
      }
    }, [mySlider]);
    return /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-carousel",
      "aria-roledescription": "carousel"
    }, /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-carousel__container"
    }, /*#__PURE__*/external_react_default.a.createElement(CarouselArrow_CarouselArrow, {
      disabled: arrowPrevDisabled,
      icon: "caret-left",
      id: "prev",
      onClickCallback: function onClickCallback() {
        return handlePrevArrowClick;
      }
    }), /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-carousel__sizer"
    }, /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-carousel__carousel"
    }, slides)), /*#__PURE__*/external_react_default.a.createElement(CarouselArrow_CarouselArrow, {
      disabled: arrowNextDisabled,
      icon: "caret-right",
      id: "next",
      onClickCallback: function onClickCallback() {
        return handleNextArrowClick;
      }
    })), !looping && /*#__PURE__*/external_react_default.a.createElement(Indicator_Indicator, {
      className: "sage-carousel__indicator",
      currentItem: slidesIndex + 1,
      numItems: slidesLength
    }));
  };

  Carousel_Carousel.defaultProps = {
    children: null,
    options: null
  };
  Carousel_Carousel.propTypes = {
    children: prop_types_default.a.node,
    options: prop_types_default.a.shape({
      loop: prop_types_default.a.bool,
      startIndex: prop_types_default.a.number
    })
  }; // CONCATENATED MODULE: ./lib/Carousel/index.js
  // CONCATENATED MODULE: ./lib/EmptyState/configs.js

  var EMPTY_STATE_SCOPES = {
    DEFAULT: null,
    PAGE: 'page',
    COMPACT: 'compact'
  }; // CONCATENATED MODULE: ./lib/EmptyState/EmptyState.jsx

  var EmptyState_excluded = ["actions", "centerVertical", "children", "graphic", "icon", "scope", "text", "title", "titleTag", "video"];

  var EmptyState_EmptyState = function EmptyState(_ref) {
    var actions = _ref.actions,
        centerVertical = _ref.centerVertical,
        children = _ref.children,
        graphic = _ref.graphic,
        icon = _ref.icon,
        scope = _ref.scope,
        text = _ref.text,
        title = _ref.title,
        titleTag = _ref.titleTag,
        video = _ref.video,
        rest = objectWithoutProperties_default()(_ref, EmptyState_excluded);
    var className = classnames_default()('sage-empty-state', defineProperty_default()({
      'sage-empty-state--center': centerVertical
    }, "sage-empty-state--".concat(scope), scope));
    var TitleTag = titleTag || 'h2';
    return /*#__PURE__*/external_react_default.a.createElement("section", extends_default()({
      className: className
    }, rest), graphic && /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-empty-state__graphic"
    }, graphic), icon && /*#__PURE__*/external_react_default.a.createElement(Icon_Icon, {
      icon: icon,
      size: Icon_Icon.SIZES.XXXL,
      className: "sage-empty-state__icon"
    }), /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-empty-state__content"
    }, title && /*#__PURE__*/external_react_default.a.createElement(TitleTag, {
      className: "sage-empty-state__title"
    }, title), text && (typeof text === 'string' ? /*#__PURE__*/external_react_default.a.createElement("p", {
      className: "sage-empty-state__text"
    }, text) : /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-empty-state__text"
    }, text)), actions && /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-empty-state__actions"
    }, /*#__PURE__*/external_react_default.a.createElement(Button.Group, {
      gap: Button.Group.GAP_OPTIONS.SM
    }, actions)), video && /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-empty-state__video"
    }, video), children));
  };

  EmptyState_EmptyState.SCOPES = EMPTY_STATE_SCOPES;
  EmptyState_EmptyState.defaultProps = {
    actions: null,
    centerVertical: false,
    children: null,
    graphic: null,
    icon: null,
    scope: EmptyState_EmptyState.SCOPES.DEFAULT,
    text: null,
    title: null,
    titleTag: 'h2',
    video: null
  };
  EmptyState_EmptyState.propTypes = {
    actions: prop_types_default.a.node,
    centerVertical: prop_types_default.a.bool,
    children: prop_types_default.a.node,
    graphic: prop_types_default.a.node,
    icon: prop_types_default.a.oneOf(Object.values(SageTokens.ICONS)),
    scope: prop_types_default.a.oneOf(Object.values(EmptyState_EmptyState.SCOPES)),
    text: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.node]),
    title: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.node]),
    titleTag: prop_types_default.a.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']),
    video: prop_types_default.a.node
  }; // CONCATENATED MODULE: ./lib/EmptyState/index.js
  // CONCATENATED MODULE: ./lib/Chart/parts/Legend.jsx

  var Legend_Legend = function Legend(_ref) {
    var payload = _ref.payload;
    return /*#__PURE__*/external_react_default.a.createElement("ul", {
      className: "sage-chart-legend"
    }, payload.map(function (_ref2) {
      var value = _ref2.value,
          color = _ref2.color;
      return /*#__PURE__*/external_react_default.a.createElement("li", {
        className: "sage-chart-legend__item",
        key: "item-".concat(value),
        style: {
          '--item-color': color
        }
      }, value);
    }));
  };

  Legend_Legend.defaultProps = {
    payload: []
  };
  Legend_Legend.propTypes = {
    payload: prop_types_default.a.arrayOf(prop_types_default.a.shape({
      value: prop_types_default.a.string,
      color: prop_types_default.a.string
    }))
  }; // CONCATENATED MODULE: ./lib/Chart/configs.js

  var CHART_TYPES = {
    BAR: 'bar',
    DONUT: 'donut'
  };
  var dataPropTypes = {
    name: prop_types_default.a.string.isRequired,
    value: prop_types_default.a.number
  }; // CONCATENATED MODULE: ./lib/Chart/parts/Summary.jsx

  var Summary_excluded = ["caption", "chartType", "className", "centered", "label", "value"];

  var Summary_Summary = function Summary(_ref) {
    var caption = _ref.caption,
        chartType = _ref.chartType,
        className = _ref.className,
        centered = _ref.centered,
        label = _ref.label,
        value = _ref.value,
        rest = objectWithoutProperties_default()(_ref, Summary_excluded);
    var classNames = classnames_default()('sage-chart-summary', className, defineProperty_default()({
      'sage-chart-summary--centered': centered
    }, "sage-chart-summary--".concat(chartType), chartType));
    return /*#__PURE__*/external_react_default.a.createElement("p", extends_default()({
      className: classNames
    }, rest), label && /*#__PURE__*/external_react_default.a.createElement("span", {
      className: "sage-chart-summary__label"
    }, label), /*#__PURE__*/external_react_default.a.createElement("em", {
      className: "sage-chart-summary__value"
    }, value), caption && /*#__PURE__*/external_react_default.a.createElement("span", {
      className: "sage-chart-summary__caption"
    }, caption));
  };

  Summary_Summary.defaultProps = {
    caption: null,
    centered: true,
    chartType: null,
    className: null,
    label: null
  };
  Summary_Summary.propTypes = {
    caption: prop_types_default.a.string,
    chartType: prop_types_default.a.oneOf(Object.values(CHART_TYPES)),
    centered: prop_types_default.a.bool,
    className: prop_types_default.a.string,
    label: prop_types_default.a.string,
    value: prop_types_default.a.string.isRequired
  }; // EXTERNAL MODULE: /__w/sage-lib/sage-lib/node_modules/@babel/runtime/helpers/toConsumableArray.js

  var toConsumableArray = __webpack_require__(9);

  var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray); // CONCATENATED MODULE: ./lib/Chart/utilities.js


  var defaultValueFormatterFn = function defaultValueFormatterFn(val) {
    return new Intl.NumberFormat().format(val);
  };

  var defaultTooltipContentFormatterFn = function defaultTooltipContentFormatterFn(_ref) {
    var name = _ref.name,
        value = _ref.value;
    return "".concat(name, " : ").concat(defaultValueFormatterFn(value));
  };

  var getCentered = function getCentered(isCentered) {
    return isCentered ? {
      cx: '50%',
      cy: '50%'
    } : {};
  };

  var utilities_getDataEntries = function getDataEntries(data, entriesLimit) {
    if (entriesLimit && data.length > entriesLimit) {
      var topEntries = data.slice(0, entriesLimit);
      var remainingValue = data.slice(entriesLimit).reduce(function (acc, curr) {
        return acc + curr.value;
      }, 0);
      return [].concat(toConsumableArray_default()(topEntries), [{
        name: 'Other',
        value: remainingValue
      }]);
    }

    return toConsumableArray_default()(data);
  };

  var getDonutRadiuses = function getDonutRadiuses(size, stroke) {
    return {
      innerRadius: (size - stroke) / 2,
      outerRadius: size / 2
    };
  };

  var getDonutStartPosition = function getDonutStartPosition(position) {
    var endAngle = -360;
    var startAngle;

    switch (position) {
      case 'right':
        startAngle = 0;
        break;

      case 'bottom':
        startAngle = 270;
        break;

      case 'left':
        startAngle = 180;
        break;

      case 'top':
      default:
        startAngle = 90;
        break;
    }

    return {
      startAngle: startAngle,
      endAngle: endAngle
    };
  };

  var getTotal = function getTotal(data) {
    return data.reduce(function (acc, curr) {
      return acc + curr.value;
    }, 0);
  }; // CONCATENATED MODULE: ./lib/Chart/parts/Tooltip.jsx


  var parts_Tooltip_Tooltip = function Tooltip(_ref) {
    var active = _ref.active,
        payload = _ref.payload,
        contentFormatterFn = _ref.contentFormatterFn;
    return active && payload && payload.length > 0 ? /*#__PURE__*/external_react_default.a.createElement(TooltipElement_TooltipElement, {
      content: /*#__PURE__*/external_react_default.a.createElement(external_react_default.a.Fragment, null, payload.map(function (_ref2) {
        var name = _ref2.name,
            value = _ref2.value;
        return /*#__PURE__*/external_react_default.a.createElement(external_react_default.a.Fragment, {
          key: uuid_default()()
        }, contentFormatterFn({
          name: name,
          value: value
        }), /*#__PURE__*/external_react_default.a.createElement("br", null));
      })),
      position: null,
      theme: TooltipElement_TooltipElement.THEMES.LIGHT
    }) : null;
  };

  parts_Tooltip_Tooltip.defaultProps = {
    active: false,
    contentFormatterFn: defaultTooltipContentFormatterFn,
    payload: null
  };
  parts_Tooltip_Tooltip.propTypes = {
    active: prop_types_default.a.bool,
    contentFormatterFn: prop_types_default.a.func,
    payload: prop_types_default.a.arrayOf(prop_types_default.a.shape({
      name: prop_types_default.a.string,
      value: prop_types_default.a.number
    }))
  }; // CONCATENATED MODULE: ./lib/Chart/parts/index.js
  // CONCATENATED MODULE: ./lib/Chart/types/Bar.jsx

  var Bar_excluded = ["aspect", "bars", "chartingFramework", "data", "showLegend", "tooltipContentFormatterFn", "valueFormatterFn", "width"],
      Bar_excluded2 = ["dataKey", "fill"];

  function Bar_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function Bar_objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? Bar_ownKeys(Object(source), !0).forEach(function (key) {
        defineProperty_default()(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Bar_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }

    return target;
  }

  var Bar_Bar = function Bar(_ref) {
    var aspect = _ref.aspect,
        bars = _ref.bars,
        chartingFramework = _ref.chartingFramework,
        data = _ref.data,
        showLegend = _ref.showLegend,
        tooltipContentFormatterFn = _ref.tooltipContentFormatterFn,
        valueFormatterFn = _ref.valueFormatterFn,
        width = _ref.width,
        rest = objectWithoutProperties_default()(_ref, Bar_excluded);

    var _rest = Bar_objectSpread({}, rest),
        BarChart = _rest.BarChart,
        CartesianGrid = _rest.CartesianGrid,
        Tooltip = _rest.Tooltip,
        XAxis = _rest.XAxis,
        YAxis = _rest.YAxis;

    var Recharts = chartingFramework;
    return /*#__PURE__*/external_react_default.a.createElement(external_react_default.a.Fragment, null, /*#__PURE__*/external_react_default.a.createElement(Recharts.ResponsiveContainer, {
      width: width,
      aspect: aspect
    }, /*#__PURE__*/external_react_default.a.createElement(Recharts.BarChart, extends_default()({
      data: data
    }, SageTokens.RECHARTS.BarChart, BarChart), Tooltip !== false && /*#__PURE__*/external_react_default.a.createElement(Recharts.Tooltip, extends_default()({}, SageTokens.RECHARTS.Tooltip, {
      content: /*#__PURE__*/external_react_default.a.createElement(parts_Tooltip_Tooltip, {
        contentFormatterFn: tooltipContentFormatterFn
      })
    }, Tooltip)), CartesianGrid !== false && /*#__PURE__*/external_react_default.a.createElement(Recharts.CartesianGrid, extends_default()({}, SageTokens.RECHARTS.CartesianGrid, CartesianGrid)), XAxis !== false && /*#__PURE__*/external_react_default.a.createElement(Recharts.XAxis, extends_default()({
      dataKey: "name"
    }, SageTokens.RECHARTS.XAxis, XAxis)), YAxis !== false && /*#__PURE__*/external_react_default.a.createElement(Recharts.YAxis, extends_default()({}, SageTokens.RECHARTS.XAxis, YAxis)), showLegend && /*#__PURE__*/external_react_default.a.createElement(Recharts.Legend, {
      content: /*#__PURE__*/external_react_default.a.createElement(Legend_Legend, null)
    }), bars.map(function (_ref2) {
      var dataKey = _ref2.dataKey,
          fill = _ref2.fill,
          rest = objectWithoutProperties_default()(_ref2, Bar_excluded2);
      return /*#__PURE__*/external_react_default.a.createElement(Recharts.Bar, extends_default()({
        key: dataKey,
        dataKey: dataKey,
        fill: fill
      }, rest));
    }))));
  };

  Bar_Bar.defaultProps = {
    aspect: 1.8,
    bars: [{
      dataKey: 'value',
      fill: SageTokens.COLOR_PALETTE.SAGE_100,
      name: 'Value'
    }],
    showLegend: false,
    tooltipContentFormatterFn: defaultTooltipContentFormatterFn,
    valueFormatterFn: defaultValueFormatterFn,
    width: 720
  };
  Bar_Bar.propTypes = {
    aspect: prop_types_default.a.number,
    bars: prop_types_default.a.arrayOf(prop_types_default.a.shape({
      dataKey: prop_types_default.a.string,
      fill: prop_types_default.a.string,
      name: prop_types_default.a.string
    })),
    chartingFramework: prop_types_default.a.shape({}).isRequired,
    data: prop_types_default.a.arrayOf(prop_types_default.a.shape({
      name: prop_types_default.a.string.isRequired,
      value: prop_types_default.a.number
    })).isRequired,
    showLegend: prop_types_default.a.bool,
    tooltipContentFormatterFn: prop_types_default.a.func,
    valueFormatterFn: prop_types_default.a.func,
    width: prop_types_default.a.number
  }; // CONCATENATED MODULE: ./lib/Chart/types/Donut.jsx

  var Donut_excluded = ["centered", "chartingFramework", "combineDataAfterItem", "donutDiameter", "donutWidth", "data", "paddingInline", "paddingBlock", "startPosition", "showSummary", "summary", "tooltipContentFormatterFn", "valueFormatterFn"];

  function Donut_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function Donut_objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? Donut_ownKeys(Object(source), !0).forEach(function (key) {
        defineProperty_default()(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Donut_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }

    return target;
  }

  var Donut_Donut = function Donut(_ref) {
    var centered = _ref.centered,
        chartingFramework = _ref.chartingFramework,
        combineDataAfterItem = _ref.combineDataAfterItem,
        donutDiameter = _ref.donutDiameter,
        donutWidth = _ref.donutWidth,
        data = _ref.data,
        paddingInline = _ref.paddingInline,
        paddingBlock = _ref.paddingBlock,
        startPosition = _ref.startPosition,
        showSummary = _ref.showSummary,
        summary = _ref.summary,
        tooltipContentFormatterFn = _ref.tooltipContentFormatterFn,
        valueFormatterFn = _ref.valueFormatterFn,
        rest = objectWithoutProperties_default()(_ref, Donut_excluded);
    var propConfigs = Donut_objectSpread(Donut_objectSpread(Donut_objectSpread({}, getDonutRadiuses(donutDiameter, donutWidth)), getDonutStartPosition(startPosition)), getCentered(centered));

    var _rest = Donut_objectSpread({}, rest),
        Tooltip = _rest.Tooltip,
        PieChart = _rest.PieChart,
        Pie = _rest.Pie;

    var _useState = Object(external_react_["useState"])(utilities_getDataEntries(data, combineDataAfterItem)),
        _useState2 = slicedToArray_default()(_useState, 1),
        selfData = _useState2[0];

    var Recharts = chartingFramework;
    return /*#__PURE__*/external_react_default.a.createElement(external_react_default.a.Fragment, null, /*#__PURE__*/external_react_default.a.createElement(Recharts.ResponsiveContainer, {
      width: donutDiameter + paddingInline,
      aspect: 1
    }, /*#__PURE__*/external_react_default.a.createElement(Recharts.PieChart, PieChart, /*#__PURE__*/external_react_default.a.createElement(Recharts.Pie, extends_default()({
      data: selfData,
      dataKey: "value",
      nameKey: "name"
    }, propConfigs, Pie)), Tooltip !== false && /*#__PURE__*/external_react_default.a.createElement(Recharts.Tooltip, extends_default()({}, SageTokens.RECHARTS.Tooltip, {
      content: /*#__PURE__*/external_react_default.a.createElement(parts_Tooltip_Tooltip, {
        contentFormatterFn: tooltipContentFormatterFn
      })
    }, Tooltip)))), showSummary && /*#__PURE__*/external_react_default.a.createElement(Summary_Summary, extends_default()({
      chartType: "donut",
      value: valueFormatterFn(getTotal(selfData))
    }, summary)));
  };

  Donut_Donut.defaultProps = {
    centered: true,
    combineDataAfterItem: 3,
    donutDiameter: 192,
    donutWidth: 48,
    paddingInline: 64,
    paddingBlock: 64,
    startPosition: 'top',
    showSummary: true,
    summary: null,
    tooltipContentFormatterFn: defaultTooltipContentFormatterFn,
    valueFormatterFn: defaultValueFormatterFn
  };
  Donut_Donut.propTypes = {
    centered: prop_types_default.a.bool,
    chartingFramework: prop_types_default.a.shape({}).isRequired,
    combineDataAfterItem: prop_types_default.a.number,
    donutDiameter: prop_types_default.a.number,
    donutWidth: prop_types_default.a.number,
    data: prop_types_default.a.arrayOf(prop_types_default.a.shape({
      name: prop_types_default.a.string.isRequired,
      value: prop_types_default.a.number.isRequired
    })).isRequired,
    paddingInline: prop_types_default.a.number,
    paddingBlock: prop_types_default.a.number,
    showSummary: prop_types_default.a.bool,
    startPosition: prop_types_default.a.string,
    summary: prop_types_default.a.shape({
      caption: prop_types_default.a.string,
      centered: prop_types_default.a.bool,
      label: prop_types_default.a.string,
      value: prop_types_default.a.string
    }),
    tooltipContentFormatterFn: prop_types_default.a.func,
    valueFormatterFn: prop_types_default.a.func
  }; // CONCATENATED MODULE: ./lib/Chart/types/index.js
  // CONCATENATED MODULE: ./lib/Chart/Chart.jsx

  var Chart_Chart = function Chart(_ref) {
    var configs = _ref.configs,
        framework = _ref.framework,
        data = _ref.data,
        noDataText = _ref.noDataText,
        loading = _ref.loading,
        containerStyles = _ref.containerStyles,
        type = _ref.type;

    var renderChart = function renderChart() {
      if (!data) {
        return /*#__PURE__*/external_react_default.a.createElement(EmptyState_EmptyState, {
          scope: EmptyState_EmptyState.SCOPES.COMPACT,
          icon: SageTokens.ICONS.CHART,
          text: noDataText
        });
      }

      var chart = null;

      switch (type) {
        case CHART_TYPES.BAR:
          chart = /*#__PURE__*/external_react_default.a.createElement(Bar_Bar, extends_default()({
            data: data,
            chartingFramework: framework
          }, configs));
          break;

        case CHART_TYPES.DONUT:
          chart = /*#__PURE__*/external_react_default.a.createElement(Donut_Donut, extends_default()({
            data: data,
            chartingFramework: framework
          }, configs));
          break;

        default:
          break;
      }

      return chart;
    };

    return /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-chart-container",
      style: containerStyles
    }, loading ? /*#__PURE__*/external_react_default.a.createElement(Loader_Loader, {
      loading: true,
      type: Loader_Loader.TYPES.SPINNER
    }) : renderChart());
  };

  Chart_Chart.TYPES = CHART_TYPES;
  Chart_Chart.defaultProps = {
    configs: null,
    containerStyles: null,
    data: null,
    loading: true,
    noDataText: 'No data is available for this chart.'
  };
  Chart_Chart.propTypes = {
    configs: prop_types_default.a.shape({}),
    containerStyles: prop_types_default.a.shape({}),
    data: prop_types_default.a.arrayOf(prop_types_default.a.shape(dataPropTypes)),
    framework: prop_types_default.a.shape({}).isRequired,
    loading: prop_types_default.a.bool,
    noDataText: prop_types_default.a.string,
    type: prop_types_default.a.oneOf(Object.values(Chart_Chart.TYPES)).isRequired
  }; // CONCATENATED MODULE: ./lib/Chart/index.js
  // CONCATENATED MODULE: ./lib/Choice/configs.js

  var TYPES = {
    ARROW: 'arrow',
    GRAPHIC: 'graphic',
    ICON: 'icon',
    RADIO: 'radio'
  };
  var ICON_ALIGNMENTS = {
    DEFAULT: null,
    START: 'start'
  }; // CONCATENATED MODULE: ./lib/Choice/Choice.jsx

  var Choice_excluded = ["alignCenter", "children", "className", "customContentClassName", "disabled", "graphic", "icon", "isActive", "linkText", "radioConfigs", "subtext", "target", "text", "type", "verticalAlignIcon"];

  function Choice_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function Choice_objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? Choice_ownKeys(Object(source), !0).forEach(function (key) {
        defineProperty_default()(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Choice_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }

    return target;
  }

  var Choice_Choice = function Choice(_ref) {
    var _classnames, _classnames2;

    var alignCenter = _ref.alignCenter,
        children = _ref.children,
        className = _ref.className,
        customContentClassName = _ref.customContentClassName,
        disabled = _ref.disabled,
        graphic = _ref.graphic,
        icon = _ref.icon,
        isActive = _ref.isActive,
        linkText = _ref.linkText,
        radioConfigs = _ref.radioConfigs,
        subtext = _ref.subtext,
        target = _ref.target,
        text = _ref.text,
        type = _ref.type,
        verticalAlignIcon = _ref.verticalAlignIcon,
        rest = objectWithoutProperties_default()(_ref, Choice_excluded);
    var baseClass = 'sage-choice';
    var isIconType = type && type === TYPES.ICON;
    var isRadioType = type && type === TYPES.RADIO;
    var classNames = classnames_default()(baseClass, className, (_classnames = {}, defineProperty_default()(_classnames, "".concat(baseClass, "--active"), isActive), defineProperty_default()(_classnames, "".concat(baseClass, "--align-center"), isIconType && alignCenter), defineProperty_default()(_classnames, "".concat(baseClass, "--").concat(type), type && !isIconType), defineProperty_default()(_classnames, "".concat(baseClass, "--icon-").concat(icon), isIconType && icon), defineProperty_default()(_classnames, "".concat(baseClass, "--vertical-align-icon-").concat(verticalAlignIcon), verticalAlignIcon && (isIconType || isRadioType)), _classnames));
    var contentClassNames = classnames_default()("".concat(baseClass, "__content"), (_classnames2 = {}, defineProperty_default()(_classnames2, "".concat(baseClass, "__content--custom"), children), defineProperty_default()(_classnames2, "".concat(customContentClassName), customContentClassName), _classnames2));
    var hasRadioConfigs = !!radioConfigs;
    var isLabel = hasRadioConfigs;
    var isLink = ('href' in rest);
    var isButton = !isLink && !isLabel;
    var TagName = children ? 'div' : 'button';
    if (isLabel) TagName = 'label';
    if (isLink) TagName = 'a';
    var attrs = Choice_objectSpread(Choice_objectSpread(Choice_objectSpread({
      'aria-controls': target,
      'aria-disabled': TagName === 'div' ? disabled : null,
      'aria-selected': isActive,
      className: classNames,
      'data-js-tabs-target': target,
      disabled: TagName !== 'div' && disabled,
      tabIndex: TagName === 'div' ? '0' : null,
      role: 'tab'
    }, hasRadioConfigs && {
      htmlFor: radioConfigs.id
    }), isButton && {
      type: 'button'
    }), rest);
    return /*#__PURE__*/external_react_default.a.createElement(TagName, extends_default()({
      className: classNames
    }, attrs), hasRadioConfigs && /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-choice__radio visually-hidden"
    }, /*#__PURE__*/external_react_default.a.createElement("input", extends_default()({}, radioConfigs, {
      checked: isActive,
      type: "radio"
    }))), graphic && /*#__PURE__*/external_react_default.a.createElement("span", {
      className: "sage-choice__graphic"
    }, /*#__PURE__*/external_react_default.a.createElement("img", {
      src: graphic,
      alt: ""
    })), /*#__PURE__*/external_react_default.a.createElement("div", {
      className: contentClassNames
    }, text && /*#__PURE__*/external_react_default.a.createElement("em", {
      className: "sage-choice__text"
    }, text), subtext && /*#__PURE__*/external_react_default.a.createElement("span", {
      className: "sage-choice__subtext"
    }, subtext), children), linkText && /*#__PURE__*/external_react_default.a.createElement("span", {
      className: "sage-choice__link-text"
    }, linkText));
  };

  Choice_Choice.TYPES = TYPES;
  Choice_Choice.ICON_ALIGNMENTS = ICON_ALIGNMENTS;
  Choice_Choice.defaultProps = {
    alignCenter: false,
    children: null,
    className: '',
    customContentClassName: '',
    disabled: false,
    graphic: null,
    icon: null,
    isActive: false,
    linkText: null,
    radioConfigs: null,
    subtext: null,
    target: null,
    text: null,
    type: null,
    verticalAlignIcon: ICON_ALIGNMENTS.DEFAULT
  };
  Choice_Choice.propTypes = {
    alignCenter: prop_types_default.a.bool,
    children: prop_types_default.a.node,
    className: prop_types_default.a.string,
    customContentClassName: prop_types_default.a.string,
    disabled: prop_types_default.a.bool,
    graphic: prop_types_default.a.string,
    icon: prop_types_default.a.oneOf(Object.values(SageTokens.ICONS)),
    isActive: prop_types_default.a.bool,
    linkText: prop_types_default.a.string,
    radioConfigs: prop_types_default.a.shape({
      name: prop_types_default.a.string.isRequired,
      id: prop_types_default.a.string.isRequired,
      onChange: prop_types_default.a.func.isRequired,
      value: prop_types_default.a.string.isRequired
    }),
    subtext: prop_types_default.a.string,
    target: prop_types_default.a.string,
    text: prop_types_default.a.string,
    type: prop_types_default.a.oneOf(Object.values(Choice_Choice.TYPES)),
    verticalAlignIcon: prop_types_default.a.oneOf(Object.values(Choice_Choice.ICON_ALIGNMENTS))
  }; // CONCATENATED MODULE: ./lib/Choice/index.js
  // CONCATENATED MODULE: ./lib/Description/configs.js

  var LAYOUT_TYPES = {
    INLINE: 'inline',
    STACKED: 'stacked'
  }; // CONCATENATED MODULE: ./lib/Description/Description.jsx

  var Description_excluded = ["actionWidth", "children", "className", "noDividers", "layout", "items", "titleWidth"];

  var Description_Description = function Description(_ref) {
    var actionWidth = _ref.actionWidth,
        children = _ref.children,
        className = _ref.className,
        noDividers = _ref.noDividers,
        layout = _ref.layout,
        items = _ref.items,
        titleWidth = _ref.titleWidth,
        rest = objectWithoutProperties_default()(_ref, Description_excluded);
    var classNames = classnames_default()('sage-description', className, defineProperty_default()({
      'sage-description--no-dividers': noDividers
    }, "sage-description--".concat(layout), layout));

    var renderItem = function renderItem(_ref2) {
      var title = _ref2.title,
          data = _ref2.data,
          action = _ref2.action;
      var iconOnly = true;

      if (action && action.value) {
        iconOnly = false;
      }

      if (action && action.iconOnly !== undefined) {
        iconOnly = action.iconOnly;
      }

      return /*#__PURE__*/external_react_default.a.createElement(external_react_default.a.Fragment, null, title && /*#__PURE__*/external_react_default.a.createElement("dt", {
        className: "sage-description__title"
      }, title), data && /*#__PURE__*/external_react_default.a.createElement("dd", {
        className: "sage-description__data"
      }, data, action && /*#__PURE__*/external_react_default.a.createElement("span", {
        className: "sage-description__action"
      }, /*#__PURE__*/external_react_default.a.createElement(Button, extends_default()({
        color: Button.COLORS.PRIMARY,
        subtle: true,
        icon: SageTokens.ICONS.CARET_RIGHT,
        iconPosition: !iconOnly && Button.ICON_POSITIONS.RIGHT,
        iconOnly: iconOnly
      }, action.attributes), action.value || 'View more'))));
    };

    var renderItems = function renderItems() {
      if (!items || items.length === 0) {
        return null;
      }

      var hasActions = false;
      items.forEach(function (item) {
        if (item.action) {
          hasActions = true;
        }
      });
      return items.map(function (item) {
        if (!item) {
          return null;
        }

        var termGroupClassnames = classnames_default()('sage-description__term-group', {
          'sage-description__term-group--no-action': !hasActions,
          'sage-description__term-group--hide-title': item.hideTitle
        });
        return /*#__PURE__*/external_react_default.a.createElement("div", {
          key: item.id || uuid_default()(),
          id: item.id,
          className: termGroupClassnames
        }, renderItem(item));
      });
    };

    var getCustomProps = function getCustomProps() {
      var props = {};

      if (actionWidth) {
        props['--sage-description-action-width'] = actionWidth;
      }

      if (titleWidth) {
        props['--sage-description-title-width'] = titleWidth;
      }

      return props;
    };

    return /*#__PURE__*/external_react_default.a.createElement("dl", extends_default()({
      className: classNames,
      style: getCustomProps()
    }, rest), renderItems(), children);
  };

  Description_Description.LAYOUT = LAYOUT_TYPES;
  Description_Description.defaultProps = {
    actionWidth: null,
    children: null,
    className: null,
    items: [],
    layout: null,
    noDividers: false,
    titleWidth: null
  };
  Description_Description.propTypes = {
    actionWidth: prop_types_default.a.string,
    children: prop_types_default.a.node,
    className: prop_types_default.a.string,
    items: prop_types_default.a.arrayOf(prop_types_default.a.shape({
      action: prop_types_default.a.shape({
        attributes: prop_types_default.a.shape({}),
        iconOnly: prop_types_default.a.bool,
        value: prop_types_default.a.string
      }),
      data: prop_types_default.a.node,
      id: prop_types_default.a.string,
      title: prop_types_default.a.string
    })),
    layout: prop_types_default.a.oneOf(Object.values(LAYOUT_TYPES)),
    noDividers: prop_types_default.a.bool,
    titleWidth: prop_types_default.a.string
  }; // CONCATENATED MODULE: ./lib/Description/index.js
  // CONCATENATED MODULE: ./lib/Dot/configs.js

  var DOT_COLORS = {
    DEFAULT: 'sage',
    CHARCOAL: 'charcoal',
    PURPLE: 'purple',
    SAGE: 'sage',
    YELLOW: 'yellow',
    ORANGE: 'orange',
    RED: 'red',
    GREY: 'grey'
  }; // CONCATENATED MODULE: ./lib/Dot/Dot.jsx

  var Dot_excluded = ["children", "className", "color", "label"];

  var Dot_Dot = function Dot(_ref) {
    var children = _ref.children,
        className = _ref.className,
        color = _ref.color,
        label = _ref.label,
        rest = objectWithoutProperties_default()(_ref, Dot_excluded);
    var customColor = !Object.values(DOT_COLORS).includes(color);
    var classNames = classnames_default()('sage-dot', className, defineProperty_default()({
      'sage-dot--color-custom': customColor
    }, "sage-dot--color-".concat(color), !customColor && color));
    var style = {};

    if (customColor) {
      style['--sage-dot-color'] = color;
    }

    var attrs = {};

    if (label) {
      attrs['aria-label'] = label;
    } else {
      attrs['aria-hidden'] = true;
    }

    return /*#__PURE__*/external_react_default.a.createElement("span", extends_default()({
      className: classNames,
      style: style
    }, attrs, rest), children);
  };

  Dot_Dot.COLORS = DOT_COLORS;
  Dot_Dot.defaultProps = {
    children: null,
    className: null,
    color: Dot_Dot.COLORS.DEFAULT,
    label: null
  };
  Dot_Dot.propTypes = {
    children: prop_types_default.a.node,
    className: prop_types_default.a.string,
    color: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.oneOf(Object.values(Dot_Dot.COLORS))]),
    label: prop_types_default.a.string
  }; // CONCATENATED MODULE: ./lib/Dot/index.js
  // CONCATENATED MODULE: ./lib/Modal/configs.js

  var MODAL_CONTENT_GAP_OPTIONS = {
    DEFAULT: null,
    XS: 'xs',
    SM: 'sm',
    MD: 'md',
    LG: 'lg'
  };
  var MODAL_CONTENT_SPACINGS = {
    CARD: 'card',
    DEFAULT: null,
    PANEL: 'panel'
  };
  var MODAL_ANIMATION_DIRECTIONS = {
    TOP: 'top',
    BOTTOM: 'bottom',
    LEFT: 'left',
    RIGHT: 'right'
  };
  var MODAL_ANIMATION_PRESETS = {
    'data-sage-animate': true,
    'data-sage-animate-direction': MODAL_ANIMATION_DIRECTIONS.TOP
  };
  var MODAL_SIZES = {
    XS: 'xs',
    SM: 'sm',
    MD: 'md',
    LG: 'lg'
  }; // CONCATENATED MODULE: ./lib/Modal/ModalBody.jsx

  var ModalBody_excluded = ["children", "className", "gap", "spacing"];

  var ModalBody_ModalBody = function ModalBody(_ref) {
    var _classnames;

    var children = _ref.children,
        className = _ref.className,
        gap = _ref.gap,
        spacing = _ref.spacing,
        rest = objectWithoutProperties_default()(_ref, ModalBody_excluded);
    var classNames = classnames_default()('sage-modal__content', className, (_classnames = {}, defineProperty_default()(_classnames, "sage-grid-gap-".concat(gap), gap), defineProperty_default()(_classnames, "sage-modal__content--spacing-".concat(spacing), spacing), _classnames));
    return /*#__PURE__*/external_react_default.a.createElement("div", extends_default()({
      className: classNames
    }, rest), children);
  };

  ModalBody_ModalBody.GAP_OPTIONS = MODAL_CONTENT_GAP_OPTIONS;
  ModalBody_ModalBody.SPACINGS = MODAL_CONTENT_SPACINGS;
  ModalBody_ModalBody.defaultProps = {
    children: null,
    className: '',
    gap: MODAL_CONTENT_GAP_OPTIONS.DEFAULT,
    spacing: ModalBody_ModalBody.SPACINGS.DEFAULT
  };
  ModalBody_ModalBody.propTypes = {
    children: prop_types_default.a.node,
    className: prop_types_default.a.string,
    gap: prop_types_default.a.oneOf(Object.values(ModalBody_ModalBody.GAP_OPTIONS)),
    spacing: prop_types_default.a.oneOf(Object.values(ModalBody_ModalBody.SPACINGS))
  }; // CONCATENATED MODULE: ./lib/Modal/ModalFooterAside.jsx

  var ModalFooterAside_excluded = ["children", "className"];

  var ModalFooterAside_ModalFooterAside = function ModalFooterAside(_ref) {
    var children = _ref.children,
        className = _ref.className,
        rest = objectWithoutProperties_default()(_ref, ModalFooterAside_excluded);
    var classNames = classnames_default()('sage-modal__footer-aside', className);
    return /*#__PURE__*/external_react_default.a.createElement("div", extends_default()({
      className: classNames
    }, rest), children);
  };

  ModalFooterAside_ModalFooterAside.defaultProps = {
    children: null,
    className: ''
  };
  ModalFooterAside_ModalFooterAside.propTypes = {
    children: prop_types_default.a.node,
    className: prop_types_default.a.string
  }; // CONCATENATED MODULE: ./lib/Modal/ModalFooter.jsx

  var ModalFooter_excluded = ["children", "className"];

  var ModalFooter_ModalFooter = function ModalFooter(_ref) {
    var children = _ref.children,
        className = _ref.className,
        rest = objectWithoutProperties_default()(_ref, ModalFooter_excluded);
    var classNames = classnames_default()('sage-modal__footer', className);
    return /*#__PURE__*/external_react_default.a.createElement("footer", extends_default()({
      className: classNames
    }, rest), children);
  };

  ModalFooter_ModalFooter.Aside = ModalFooterAside_ModalFooterAside;
  ModalFooter_ModalFooter.defaultProps = {
    children: null,
    className: ''
  };
  ModalFooter_ModalFooter.propTypes = {
    children: prop_types_default.a.node,
    className: prop_types_default.a.string
  }; // CONCATENATED MODULE: ./lib/Popover/configs.js

  var POPOVER_POSITIONS = {
    TOP: 'top',
    RIGHT: 'right',
    BOTTOM: 'bottom',
    LEFT: 'left',
    TOP_RIGHT: 'top-right',
    BOTTOM_RIGHT: 'bottom-right'
  }; // CONCATENATED MODULE: ./lib/Popover/Popover.jsx

  var Popover_excluded = ["className", "children", "customContentClassName", "icon", "iconOnly", "label", "media", "moreLinkURL", "moreLinkText", "position", "title"];

  var Popover_Popover = function Popover(_ref) {
    var className = _ref.className,
        children = _ref.children,
        customContentClassName = _ref.customContentClassName,
        icon = _ref.icon,
        iconOnly = _ref.iconOnly,
        label = _ref.label,
        media = _ref.media,
        moreLinkURL = _ref.moreLinkURL,
        moreLinkText = _ref.moreLinkText,
        position = _ref.position,
        title = _ref.title,
        rest = objectWithoutProperties_default()(_ref, Popover_excluded);

    var _useState = Object(external_react_["useState"])(false),
        _useState2 = slicedToArray_default()(_useState, 2),
        selfActive = _useState2[0],
        setSelfActive = _useState2[1];

    var handleExpandClick = function handleExpandClick() {
      setSelfActive(true);
    };

    var handleCloseClick = function handleCloseClick() {
      setSelfActive(false);
    };

    var handleKeydown = function handleKeydown(ev) {
      if (selfActive && ev.keyCode === 27) {
        setSelfActive(false);
      }
    };

    var classNames = classnames_default()('sage-popover', className, defineProperty_default()({
      'sage-popover--is-expanded': selfActive
    }, "sage-popover--".concat(position), position));
    var contentClassNames = classnames_default()('sage-popover__content', customContentClassName, {
      'sage-popover__content--custom': customContentClassName
    });
    var id = uuid_default()();
    return /*#__PURE__*/external_react_default.a.createElement("div", extends_default()({
      id: id,
      className: classNames,
      role: "button",
      onKeyDown: handleKeydown,
      tabIndex: -1
    }, rest), /*#__PURE__*/external_react_default.a.createElement(Button, {
      "aria-controls": id,
      "aria-expanded": selfActive,
      "aria-haspopup": true,
      className: "sage-popover__button",
      color: Button.COLORS.SECONDARY,
      icon: icon,
      iconOnly: iconOnly,
      onClick: handleExpandClick,
      subtle: true
    }, label), /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-popover__overlay",
      "aria-label": "Exit popover",
      onClick: handleCloseClick,
      role: "button",
      onKeyDown: handleKeydown,
      tabIndex: -1
    }), /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-popover__panel"
    }, media && /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-popoever__media"
    }, media), /*#__PURE__*/external_react_default.a.createElement("div", {
      className: contentClassNames
    }, title && /*#__PURE__*/external_react_default.a.createElement("h5", {
      className: "sage-popover__title"
    }, title), children), moreLinkURL && /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-popover__actions"
    }, /*#__PURE__*/external_react_default.a.createElement(Button, {
      color: Button.COLORS.PRIMARY,
      href: moreLinkURL,
      target: "_blank",
      rel: "noopener",
      icon: SageTokens.ICONS.LAUNCH,
      iconPosition: Button.ICON_POSITIONS.RIGHT,
      subtle: true
    }, moreLinkText))));
  };

  Popover_Popover.POSITIONS = POPOVER_POSITIONS;
  Popover_Popover.defaultProps = {
    className: null,
    children: null,
    customContentClassName: null,
    icon: SageTokens.ICONS.QUESTION_CIRCLE,
    iconOnly: true,
    label: 'Learn more',
    media: null,
    moreLinkURL: null,
    moreLinkText: 'Learn more',
    position: Popover_Popover.POSITIONS.BOTTOM,
    title: null
  };
  Popover_Popover.propTypes = {
    className: prop_types_default.a.string,
    children: prop_types_default.a.node,
    customContentClassName: prop_types_default.a.string,
    icon: prop_types_default.a.oneOf(Object.values(SageTokens.ICONS)),
    iconOnly: prop_types_default.a.bool,
    label: prop_types_default.a.string,
    media: prop_types_default.a.node,
    moreLinkURL: prop_types_default.a.string,
    moreLinkText: prop_types_default.a.string,
    position: prop_types_default.a.oneOf(Object.values(Popover_Popover.POSITIONS)),
    title: prop_types_default.a.string
  }; // CONCATENATED MODULE: ./lib/Popover/index.js
  // CONCATENATED MODULE: ./lib/Modal/ModalHeaderActions.jsx

  var ModalHeaderActions_excluded = ["children", "className"];

  var ModalHeaderActions_ModalHeaderActions = function ModalHeaderActions(_ref) {
    var children = _ref.children,
        className = _ref.className,
        rest = objectWithoutProperties_default()(_ref, ModalHeaderActions_excluded);
    var classNames = classnames_default()('sage-modal__header-actions', className);
    return /*#__PURE__*/external_react_default.a.createElement("div", extends_default()({
      className: classNames
    }, rest), children);
  };

  ModalHeaderActions_ModalHeaderActions.defaultProps = {
    children: null,
    className: ''
  };
  ModalHeaderActions_ModalHeaderActions.propTypes = {
    children: prop_types_default.a.node,
    className: prop_types_default.a.string
  }; // CONCATENATED MODULE: ./lib/Modal/ModalHeaderAside.jsx

  var ModalHeaderAside_excluded = ["children", "className"];

  var ModalHeaderAside_ModalHeaderAside = function ModalHeaderAside(_ref) {
    var children = _ref.children,
        className = _ref.className,
        rest = objectWithoutProperties_default()(_ref, ModalHeaderAside_excluded);
    var classNames = classnames_default()('sage-modal__header-aside', className);
    return /*#__PURE__*/external_react_default.a.createElement("div", extends_default()({
      className: classNames
    }, rest), children);
  };

  ModalHeaderAside_ModalHeaderAside.defaultProps = {
    children: null,
    className: ''
  };
  ModalHeaderAside_ModalHeaderAside.propTypes = {
    children: prop_types_default.a.node,
    className: prop_types_default.a.string
  }; // CONCATENATED MODULE: ./lib/Modal/ModalHeader.jsx

  var ModalHeader_excluded = ["actions", "aside", "children", "className", "customHeader", "headerProgressBar", "icon", "image", "popover", "subheader", "title"];

  var ModalHeader_ModalHeader = function ModalHeader(_ref) {
    var actions = _ref.actions,
        aside = _ref.aside,
        children = _ref.children,
        className = _ref.className,
        customHeader = _ref.customHeader,
        headerProgressBar = _ref.headerProgressBar,
        icon = _ref.icon,
        image = _ref.image,
        popover = _ref.popover,
        subheader = _ref.subheader,
        title = _ref.title,
        rest = objectWithoutProperties_default()(_ref, ModalHeader_excluded);
    var classNames = classnames_default()('sage-modal__header', className, {
      'sage-modal__header--has-header-actions': actions
    });
    var headerActionsClassNames = classnames_default()(SageClassnames.TYPE.HEADING_4, 'sage-modal__title', className);
    return /*#__PURE__*/external_react_default.a.createElement("header", extends_default()({
      className: classNames
    }, rest), /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-modal__header-text"
    }, /*#__PURE__*/external_react_default.a.createElement(Card_Card.Row, {
      gridTemplate: icon || image ? SageTokens.GRID_TEMPLATES.ETE : SageTokens.GRID_TEMPLATES.TE
    }, icon && /*#__PURE__*/external_react_default.a.createElement(Icon_Icon, {
      className: "sage-modal__header-icon",
      icon: icon.name,
      color: icon.color
    }), image && /*#__PURE__*/external_react_default.a.createElement("img", {
      src: image.src,
      alt: image.alt || ''
    }), customHeader || /*#__PURE__*/external_react_default.a.createElement("h1", {
      className: headerActionsClassNames
    }, title), actions && /*#__PURE__*/external_react_default.a.createElement(ModalHeaderActions_ModalHeaderActions, null, actions), aside && /*#__PURE__*/external_react_default.a.createElement(ModalHeaderAside_ModalHeaderAside, null, aside)), subheader && /*#__PURE__*/external_react_default.a.createElement(Card_Card.Row, null, /*#__PURE__*/external_react_default.a.createElement("h2", {
      className: SageClassnames.TYPE.HEADING_6
    }, subheader), popover && /*#__PURE__*/external_react_default.a.createElement(Popover_Popover, {
      title: popover.title,
      iconOnly: true,
      icon: SageTokens.ICONS.QUESTION_CIRCLE,
      moreLinkText: popover.linkText,
      moreLinkURL: popover.link
    }, popover.content)), children), headerProgressBar && /*#__PURE__*/external_react_default.a.createElement(external_react_default.a.Fragment, null, headerProgressBar));
  };

  ModalHeader_ModalHeader.Aside = ModalHeaderAside_ModalHeaderAside;
  ModalHeader_ModalHeader.Actions = ModalHeaderActions_ModalHeaderActions;
  ModalHeader_ModalHeader.defaultProps = {
    actions: null,
    aside: null,
    children: null,
    className: null,
    customHeader: null,
    headerProgressBar: null,
    icon: null,
    image: null,
    popover: null,
    subheader: null,
    title: null
  };
  ModalHeader_ModalHeader.propTypes = {
    actions: prop_types_default.a.node,
    aside: prop_types_default.a.node,
    children: prop_types_default.a.node,
    className: prop_types_default.a.string,
    customHeader: prop_types_default.a.node,
    headerProgressBar: prop_types_default.a.node,
    icon: prop_types_default.a.shape({
      color: prop_types_default.a.oneOf(Object.values(Icon_Icon.COLORS)),
      name: prop_types_default.a.oneOf(Object.values(Icon_Icon.ICONS))
    }),
    image: prop_types_default.a.shape({
      alt: prop_types_default.a.string,
      src: prop_types_default.a.string
    }),
    popover: prop_types_default.a.shape({
      content: prop_types_default.a.node,
      link: prop_types_default.a.string,
      linkText: prop_types_default.a.string,
      title: prop_types_default.a.string
    }),
    subheader: prop_types_default.a.string,
    title: prop_types_default.a.string
  }; // CONCATENATED MODULE: ./lib/Modal/Modal.jsx

  var Modal_excluded = ["active", "allowScroll", "animation", "children", "className", "containerClassName", "disableBackgroundBlur", "disableBackgroundDismiss", "fullScreen", "id", "large", "onExit", "size"];

  var Modal_Modal = function Modal(_ref) {
    var active = _ref.active,
        allowScroll = _ref.allowScroll,
        animation = _ref.animation,
        children = _ref.children,
        className = _ref.className,
        containerClassName = _ref.containerClassName,
        disableBackgroundBlur = _ref.disableBackgroundBlur,
        disableBackgroundDismiss = _ref.disableBackgroundDismiss,
        fullScreen = _ref.fullScreen,
        id = _ref.id,
        large = _ref.large,
        onExit = _ref.onExit,
        size = _ref.size,
        rest = objectWithoutProperties_default()(_ref, Modal_excluded);

    var _useState = Object(external_react_["useState"])(null),
        _useState2 = slicedToArray_default()(_useState, 2),
        mouseDownSrc = _useState2[0],
        setMouseDownSrc = _useState2[1];

    var classNames = classnames_default()('sage-modal', className, defineProperty_default()({
      'sage-modal--active': active,
      'sage-modal--scrollable': allowScroll,
      'sage-modal--large': large,
      'sage-modal--fullscreen': fullScreen,
      'sage-modal--no-blur': disableBackgroundBlur,
      'sage-modal--no-background-dismiss': disableBackgroundDismiss
    }, "sage-modal--size-".concat(size), size));
    Object(external_react_["useEffect"])(function () {
      if (active) {
        document.body.classList.add('sage-page--has-open-modal');
      }

      return function () {
        document.body.classList.remove('sage-page--has-open-modal');
      };
    });
    var animationAttributes = {};

    if (animation) {
      animationAttributes = MODAL_ANIMATION_PRESETS;

      if (animation.direction) {
        animationAttributes['data-sage-animate-direction'] = animation.direction;
      }
    }

    var handleMouseDown = function handleMouseDown(evt) {
      return setMouseDownSrc(evt.target);
    };

    var handleMouseUp = function handleMouseUp(evt) {
      if (evt.target === evt.currentTarget && evt.target === mouseDownSrc) {
        onExit(true);
      }

      setMouseDownSrc(null);
    };

    var handleBackgroundKeypress = function handleBackgroundKeypress() {// TODO: Add keypress handling
      // console.log(e.keyCode);
    };

    var attrs = {};

    if (!disableBackgroundDismiss) {
      attrs.onMouseDown = handleMouseDown;
      attrs.onMouseUp = handleMouseUp;
      attrs.onKeyPress = handleBackgroundKeypress;
      attrs.role = 'button';
      attrs.tabIndex = '0';
    }

    return /*#__PURE__*/external_react_default.a.createElement("div", extends_default()({
      className: classNames,
      id: id,
      open: active
    }, animationAttributes, attrs), /*#__PURE__*/external_react_default.a.createElement("div", extends_default()({
      className: "sage-modal__container ".concat(containerClassName || ''),
      "aria-modal": "true"
    }, rest), children));
  };

  Modal_Modal.Body = ModalBody_ModalBody;
  Modal_Modal.Footer = ModalFooter_ModalFooter;
  Modal_Modal.FooterAside = ModalFooterAside_ModalFooterAside;
  Modal_Modal.Header = ModalHeader_ModalHeader;
  Modal_Modal.HeaderAside = ModalHeaderAside_ModalHeaderAside;
  Modal_Modal.ANIMATION_PRESETS = MODAL_ANIMATION_PRESETS;
  Modal_Modal.ANIMATION_DIRECTIONS = MODAL_ANIMATION_DIRECTIONS;
  Modal_Modal.SIZES = MODAL_SIZES;
  Modal_Modal.defaultProps = {
    active: false,
    animation: null,
    allowScroll: false,
    children: null,
    containerClassName: null,
    className: '',
    fullScreen: false,
    large: false,
    id: null,
    disableBackgroundBlur: false,
    disableBackgroundDismiss: false,
    onExit: function onExit(val) {
      return val;
    },
    size: null
  };
  Modal_Modal.propTypes = {
    active: prop_types_default.a.bool,
    allowScroll: prop_types_default.a.bool,
    animation: prop_types_default.a.oneOfType([prop_types_default.a.bool, prop_types_default.a.shape({
      direction: prop_types_default.a.oneOf(Object.values(Modal_Modal.ANIMATION_DIRECTIONS))
    })]),
    children: prop_types_default.a.node,
    containerClassName: prop_types_default.a.string,
    className: prop_types_default.a.string,
    disableBackgroundBlur: prop_types_default.a.bool,
    disableBackgroundDismiss: prop_types_default.a.bool,
    fullScreen: prop_types_default.a.bool,
    id: prop_types_default.a.string,
    large: prop_types_default.a.bool,
    onExit: prop_types_default.a.func,
    size: prop_types_default.a.oneOf(Object.values(Modal_Modal.SIZES))
  }; // CONCATENATED MODULE: ./lib/Modal/index.js
  // CONCATENATED MODULE: ./lib/Drawer/configs.js

  var DRAWER_START_EXPAND = 'SAGE_DRAWER_START_EXPAND';
  var DRAWER_END_EXPAND = 'SAGE_DRAWER_END_EXPAND';
  var DRAWER_START_COLLAPSE = 'SAGE_DRAWER_START_COLLAPSE';
  var DRAWER_END_COLLAPSE = 'SAGE_DRAWER_END_COLLAPSE'; // CONCATENATED MODULE: ./lib/Drawer/Drawer.jsx

  function Drawer_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function Drawer_objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? Drawer_ownKeys(Object(source), !0).forEach(function (key) {
        defineProperty_default()(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Drawer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }

    return target;
  }

  var Drawer_Drawer = function Drawer(_ref) {
    var active = _ref.active,
        children = _ref.children,
        className = _ref.className,
        customHeader = _ref.customHeader,
        disableBackgroundDismiss = _ref.disableBackgroundDismiss,
        expanded = _ref.expanded,
        expandedSize = _ref.expandedSize,
        onExpandChange = _ref.onExpandChange,
        id = _ref.id,
        onExit = _ref.onExit,
        showClose = _ref.showClose,
        size = _ref.size,
        title = _ref.title;
    Object(external_react_["useEffect"])(function () {
      if (onExpandChange) {
        // Trigger outwards that a change to expanded was detected
        onExpandChange(expanded ? DRAWER_START_EXPAND : DRAWER_START_COLLAPSE); // Wait for CSS transition to end

        setTimeout(function () {
          onExpandChange(expanded ? DRAWER_END_EXPAND : DRAWER_END_COLLAPSE);
        }, 750);
      }
    }, [expanded]);
    var classNames = classnames_default()('sage-drawer', className, {
      'sage-drawer--expanded': expanded
    });
    var localStyles = {};

    if (size) {
      localStyles['--sage-drawer-size'] = size;
    }

    if (expandedSize) {
      localStyles['--sage-drawer-expanded-size'] = expandedSize;
    }

    return /*#__PURE__*/external_react_default.a.createElement(Modal_Modal, {
      active: active,
      animation: {
        direction: Modal_Modal.ANIMATION_DIRECTIONS.LEFT
      },
      className: classNames,
      disableBackgroundDismiss: disableBackgroundDismiss,
      id: id,
      onExit: onExit,
      styles: Drawer_objectSpread({}, localStyles)
    }, (customHeader || title || showClose) && /*#__PURE__*/external_react_default.a.createElement(Modal_Modal.Header, {
      customHeader: customHeader ? /*#__PURE__*/external_react_default.a.createElement("div", {
        className: "sage-drawer__header"
      }, customHeader) : null,
      title: title,
      aside: showClose && /*#__PURE__*/external_react_default.a.createElement(Button, {
        className: "sage-drawer__close",
        color: Button.COLORS.SECONDARY,
        iconOnly: true,
        icon: SageTokens.ICONS.REMOVE,
        onClick: onExit,
        subtle: true
      }, "Close Drawer")
    }), /*#__PURE__*/external_react_default.a.createElement(Modal_Modal.Body, {
      spacing: Modal_Modal.Body.SPACINGS.PANEL
    }, children));
  };

  Drawer_Drawer.START_EXPAND = DRAWER_START_EXPAND;
  Drawer_Drawer.END_EXPAND = DRAWER_END_EXPAND;
  Drawer_Drawer.START_COLLAPSE = DRAWER_START_COLLAPSE;
  Drawer_Drawer.END_COLLAPSE = DRAWER_END_COLLAPSE;
  Drawer_Drawer.defaultProps = {
    active: false,
    children: null,
    className: null,
    customHeader: null,
    disableBackgroundDismiss: true,
    expanded: false,
    expandedSize: null,
    onExit: function onExit(val) {
      return val;
    },
    onExpandChange: function onExpandChange(expanded) {
      return expanded;
    },
    showClose: true,
    size: null,
    title: null
  };
  Drawer_Drawer.propTypes = {
    active: prop_types_default.a.bool,
    children: prop_types_default.a.node,
    className: prop_types_default.a.string,
    customHeader: prop_types_default.a.node,
    disableBackgroundDismiss: prop_types_default.a.bool,
    expanded: prop_types_default.a.bool,
    expandedSize: prop_types_default.a.string,
    id: prop_types_default.a.string.isRequired,
    onExit: prop_types_default.a.func,
    onExpandChange: prop_types_default.a.func,
    showClose: prop_types_default.a.bool,
    size: prop_types_default.a.string,
    title: prop_types_default.a.string
  }; // CONCATENATED MODULE: ./lib/Drawer/index.js
  // EXTERNAL MODULE: /__w/sage-lib/sage-lib/node_modules/debounce/index.js

  var debounce = __webpack_require__(22); // CONCATENATED MODULE: ./lib/Toggle/configs.js


  var TOGGLE_POSITIONS = {
    DEFAULT: null,
    RIGHT: 'right'
  };
  var TOGGLE_TYPES = {
    RADIO: 'radio',
    CHECKBOX: 'checkbox'
  };
  var TOGGLE_STYLES = {
    DEFAULT: null,
    SWITCH: 'switch'
  }; // CONCATENATED MODULE: ./lib/Toggle/Toggle.jsx

  var Toggle_excluded = ["checked", "className", "customContent", "disabled", "hasBorder", "hasError", "hideText", "id", "itemInList", "label", "message", "name", "onChange", "partialSelection", "required", "standalone", "togglePosition", "toggleStyle", "type", "value"];

  var Toggle_Toggle = function Toggle(_ref) {
    var _classnames;

    var checked = _ref.checked,
        className = _ref.className,
        customContent = _ref.customContent,
        disabled = _ref.disabled,
        hasBorder = _ref.hasBorder,
        hasError = _ref.hasError,
        hideText = _ref.hideText,
        id = _ref.id,
        itemInList = _ref.itemInList,
        label = _ref.label,
        message = _ref.message,
        name = _ref.name,
        onChange = _ref.onChange,
        partialSelection = _ref.partialSelection,
        required = _ref.required,
        standalone = _ref.standalone,
        togglePosition = _ref.togglePosition,
        toggleStyle = _ref.toggleStyle,
        type = _ref.type,
        value = _ref.value,
        rest = objectWithoutProperties_default()(_ref, Toggle_excluded);

    var handleChange = function handleChange(e) {
      var newValue = e.target.value;

      if (onChange) {
        onChange(newValue, checked, e);
      }
    };

    var baseClass = "sage-".concat(toggleStyle || type);
    var classNames = classnames_default()(baseClass, className, (_classnames = {}, defineProperty_default()(_classnames, "".concat(baseClass, "--has-border"), hasBorder), defineProperty_default()(_classnames, "".concat(baseClass, "--custom"), type === Toggle.TYPES.CHECKBOX || Toggle.TYPES.RADIO ? customContent : null), defineProperty_default()(_classnames, "".concat(baseClass, "--error"), hasError), defineProperty_default()(_classnames, "".concat(baseClass, "--toggle-").concat(togglePosition), togglePosition), defineProperty_default()(_classnames, "".concat(baseClass, "--partial-selection"), partialSelection && type === Toggle.TYPES.CHECKBOX), _classnames));
    var labelClassNames = classnames_default()("".concat(baseClass, "__label"), defineProperty_default()({}, "".concat(baseClass, "__label--hide-text"), hideText));

    if (standalone) {
      var standaloneClassnames = classnames_default()(baseClass, "".concat(baseClass, "--standalone"), className, defineProperty_default()({}, "".concat(baseClass, "--partial-selection"), partialSelection && type === Toggle.TYPES.CHECKBOX));
      return /*#__PURE__*/external_react_default.a.createElement("input", extends_default()({
        checked: checked,
        className: standaloneClassnames,
        disabled: disabled,
        id: id,
        name: name,
        onChange: handleChange,
        required: required,
        type: type,
        value: value
      }, rest));
    }

    var Tag = itemInList ? 'li' : 'div';

    var renderCustomContent = function renderCustomContent() {
      if (type === Toggle.TYPES.CHECKBOX || Toggle.TYPES.RADIO) {
        return /*#__PURE__*/external_react_default.a.createElement("div", {
          className: "".concat(baseClass, "__custom-content")
        }, customContent);
      }

      return null;
    };

    return /*#__PURE__*/external_react_default.a.createElement(Tag, {
      className: classNames
    }, /*#__PURE__*/external_react_default.a.createElement("input", extends_default()({
      checked: checked,
      className: "".concat(baseClass, "__input"),
      disabled: disabled,
      id: id,
      name: name,
      onChange: handleChange,
      required: required,
      type: type,
      value: value
    }, rest)), /*#__PURE__*/external_react_default.a.createElement("label", {
      className: labelClassNames,
      htmlFor: id
    }, label), message && /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "".concat(baseClass, "__message")
    }, message), renderCustomContent());
  };

  Toggle_Toggle.POSITIONS = TOGGLE_POSITIONS;
  Toggle_Toggle.STYLES = TOGGLE_STYLES;
  Toggle_Toggle.TYPES = TOGGLE_TYPES;
  Toggle_Toggle.defaultProps = {
    checked: false,
    className: null,
    customContent: null,
    disabled: false,
    hasBorder: false,
    hasError: false,
    hideText: false,
    message: null,
    onChange: function onChange(v) {
      return v;
    },
    partialSelection: false,
    itemInList: false,
    required: false,
    standalone: false,
    togglePosition: Toggle_Toggle.POSITIONS.DEFAULT,
    toggleStyle: Toggle_Toggle.TYPES.DEFAULT,
    value: ''
  };
  Toggle_Toggle.propTypes = {
    checked: prop_types_default.a.bool,
    className: prop_types_default.a.string,
    customContent: prop_types_default.a.node,
    disabled: prop_types_default.a.bool,
    hasBorder: prop_types_default.a.bool,
    hasError: prop_types_default.a.bool,
    hideText: prop_types_default.a.bool,
    id: prop_types_default.a.string.isRequired,
    itemInList: prop_types_default.a.bool,
    label: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.node]).isRequired,
    message: prop_types_default.a.string,
    name: prop_types_default.a.string.isRequired,
    onChange: prop_types_default.a.func,
    partialSelection: prop_types_default.a.bool,
    required: prop_types_default.a.bool,
    standalone: prop_types_default.a.bool,
    togglePosition: prop_types_default.a.oneOf(Object.values(Toggle_Toggle.POSITIONS)),
    toggleStyle: prop_types_default.a.oneOf(Object.values(Toggle_Toggle.STYLES)),
    type: prop_types_default.a.oneOf(Object.values(Toggle_Toggle.TYPES)).isRequired,
    value: prop_types_default.a.string
  }; // CONCATENATED MODULE: ./lib/Toggle/Checkbox.jsx

  var Checkbox_excluded = ["checked", "className", "customContent", "disabled", "hasError", "id", "itemInList", "label", "message", "name", "onChange", "partialSelection", "required", "standalone", "value"];

  var Checkbox_Checkbox = function Checkbox(_ref) {
    var checked = _ref.checked,
        className = _ref.className,
        customContent = _ref.customContent,
        disabled = _ref.disabled,
        hasError = _ref.hasError,
        id = _ref.id,
        itemInList = _ref.itemInList,
        label = _ref.label,
        message = _ref.message,
        name = _ref.name,
        onChange = _ref.onChange,
        partialSelection = _ref.partialSelection,
        required = _ref.required,
        standalone = _ref.standalone,
        value = _ref.value,
        rest = objectWithoutProperties_default()(_ref, Checkbox_excluded);
    return /*#__PURE__*/external_react_default.a.createElement(Toggle_Toggle, extends_default()({
      checked: checked,
      className: className,
      customContent: customContent,
      disabled: disabled,
      hasBorder: false,
      hasError: hasError,
      hideText: false,
      id: id,
      itemInList: itemInList,
      label: label,
      message: message,
      name: name,
      onChange: onChange,
      partialSelection: partialSelection,
      required: required,
      standalone: standalone,
      togglePosition: Toggle_Toggle.POSITIONS.DEFAULT,
      toggleStyle: Toggle_Toggle.STYLES.DEFAULT,
      type: Toggle_Toggle.TYPES.CHECKBOX,
      value: value
    }, rest));
  };

  Checkbox_Checkbox.defaultProps = {
    checked: false,
    className: null,
    customContent: null,
    disabled: false,
    hasError: false,
    message: null,
    onChange: function onChange(v) {
      return v;
    },
    partialSelection: false,
    itemInList: false,
    required: false,
    standalone: false,
    value: ''
  };
  Checkbox_Checkbox.propTypes = {
    checked: prop_types_default.a.bool,
    className: prop_types_default.a.string,
    customContent: prop_types_default.a.node,
    disabled: prop_types_default.a.bool,
    hasError: prop_types_default.a.bool,
    id: prop_types_default.a.string.isRequired,
    itemInList: prop_types_default.a.bool,
    label: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.node]).isRequired,
    message: prop_types_default.a.string,
    name: prop_types_default.a.string.isRequired,
    onChange: prop_types_default.a.func,
    partialSelection: prop_types_default.a.bool,
    required: prop_types_default.a.bool,
    standalone: prop_types_default.a.bool,
    value: prop_types_default.a.string
  }; // CONCATENATED MODULE: ./lib/Toggle/Radio.jsx

  var Radio_excluded = ["checked", "className", "customContent", "disabled", "hasBorder", "hasError", "id", "itemInList", "label", "message", "name", "onChange", "required", "standalone", "value"];

  var Radio_Radio = function Radio(_ref) {
    var checked = _ref.checked,
        className = _ref.className,
        customContent = _ref.customContent,
        disabled = _ref.disabled,
        hasBorder = _ref.hasBorder,
        hasError = _ref.hasError,
        id = _ref.id,
        itemInList = _ref.itemInList,
        label = _ref.label,
        message = _ref.message,
        name = _ref.name,
        onChange = _ref.onChange,
        required = _ref.required,
        standalone = _ref.standalone,
        value = _ref.value,
        rest = objectWithoutProperties_default()(_ref, Radio_excluded);
    return /*#__PURE__*/external_react_default.a.createElement(Toggle_Toggle, extends_default()({
      checked: checked,
      className: className,
      customContent: customContent,
      disabled: disabled,
      hasBorder: hasBorder,
      hasError: hasError,
      hideText: false,
      id: id,
      itemInList: itemInList,
      label: label,
      message: message,
      name: name,
      onChange: onChange,
      partialSelection: false,
      required: required,
      standalone: standalone,
      togglePosition: Toggle_Toggle.POSITIONS.DEFAULT,
      toggleStyle: Toggle_Toggle.STYLES.DEFAULT,
      type: Toggle_Toggle.TYPES.RADIO,
      value: value
    }, rest));
  };

  Radio_Radio.defaultProps = {
    checked: false,
    className: null,
    customContent: null,
    disabled: false,
    hasBorder: false,
    hasError: false,
    message: null,
    onChange: function onChange(v) {
      return v;
    },
    itemInList: false,
    required: false,
    standalone: false,
    value: ''
  };
  Radio_Radio.propTypes = {
    checked: prop_types_default.a.bool,
    className: prop_types_default.a.string,
    customContent: prop_types_default.a.node,
    disabled: prop_types_default.a.bool,
    hasBorder: prop_types_default.a.bool,
    hasError: prop_types_default.a.bool,
    id: prop_types_default.a.string.isRequired,
    itemInList: prop_types_default.a.bool,
    label: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.node]).isRequired,
    message: prop_types_default.a.string,
    name: prop_types_default.a.string.isRequired,
    onChange: prop_types_default.a.func,
    required: prop_types_default.a.bool,
    standalone: prop_types_default.a.bool,
    value: prop_types_default.a.string
  }; // CONCATENATED MODULE: ./lib/Toggle/Switch.jsx

  var Switch_excluded = ["checked", "className", "customContent", "disabled", "hasBorder", "hasError", "hideText", "id", "itemInList", "label", "message", "name", "onChange", "required", "togglePosition", "type", "value"];

  var Switch_Switch = function Switch(_ref) {
    var checked = _ref.checked,
        className = _ref.className,
        customContent = _ref.customContent,
        disabled = _ref.disabled,
        hasBorder = _ref.hasBorder,
        hasError = _ref.hasError,
        hideText = _ref.hideText,
        id = _ref.id,
        itemInList = _ref.itemInList,
        label = _ref.label,
        message = _ref.message,
        name = _ref.name,
        onChange = _ref.onChange,
        required = _ref.required,
        togglePosition = _ref.togglePosition,
        type = _ref.type,
        value = _ref.value,
        rest = objectWithoutProperties_default()(_ref, Switch_excluded);
    return /*#__PURE__*/external_react_default.a.createElement(Toggle_Toggle, extends_default()({
      checked: checked,
      className: className,
      customContent: customContent,
      disabled: disabled,
      hasBorder: hasBorder,
      hasError: hasError,
      hideText: hideText,
      id: id,
      itemInList: itemInList,
      label: label,
      message: message,
      name: name,
      onChange: onChange,
      partialSelection: false,
      required: required,
      standalone: false,
      togglePosition: togglePosition,
      toggleStyle: Toggle_Toggle.STYLES.SWITCH,
      type: type,
      value: value
    }, rest));
  };

  Switch_Switch.defaultProps = {
    checked: false,
    className: null,
    customContent: null,
    disabled: false,
    hasBorder: false,
    hasError: false,
    hideText: false,
    message: null,
    onChange: function onChange(v) {
      return v;
    },
    itemInList: false,
    required: false,
    togglePosition: Toggle_Toggle.POSITIONS.DEFAULT,
    type: Toggle_Toggle.TYPES.CHECKBOX,
    value: ''
  };
  Switch_Switch.propTypes = {
    checked: prop_types_default.a.bool,
    className: prop_types_default.a.string,
    customContent: prop_types_default.a.node,
    disabled: prop_types_default.a.bool,
    hasBorder: prop_types_default.a.bool,
    hasError: prop_types_default.a.bool,
    hideText: prop_types_default.a.bool,
    id: prop_types_default.a.string.isRequired,
    itemInList: prop_types_default.a.bool,
    label: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.node]).isRequired,
    message: prop_types_default.a.string,
    name: prop_types_default.a.string.isRequired,
    onChange: prop_types_default.a.func,
    required: prop_types_default.a.bool,
    togglePosition: prop_types_default.a.oneOf(Object.values(Toggle_Toggle.POSITIONS)),
    type: prop_types_default.a.oneOf(Object.values(Toggle_Toggle.TYPES)),
    value: prop_types_default.a.string
  }; // CONCATENATED MODULE: ./lib/Toggle/index.js
  // CONCATENATED MODULE: ./lib/Search/Search.jsx

  var Search_excluded = ["className", "contained", "disabled", "hideLabel", "id", "label", "onClear", "onChange", "placeholder", "value"];

  var Search_Search = function Search(_ref) {
    var className = _ref.className,
        contained = _ref.contained,
        disabled = _ref.disabled,
        hideLabel = _ref.hideLabel,
        id = _ref.id,
        label = _ref.label,
        onClear = _ref.onClear,
        onChange = _ref.onChange,
        placeholder = _ref.placeholder,
        value = _ref.value,
        rest = objectWithoutProperties_default()(_ref, Search_excluded);
    var classNames = classnames_default()('sage-search', className, {
      'sage-search--contained': contained,
      'sage-search--has-text': value.length > 0
    });
    var labelClassnames = classnames_default()('sage-search__label', className, {
      'visually-hidden': hideLabel
    });
    return /*#__PURE__*/external_react_default.a.createElement("div", {
      className: classNames
    }, label && /*#__PURE__*/external_react_default.a.createElement("label", {
      htmlFor: id,
      className: labelClassnames
    }, label), /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-search__field-wrapper"
    }, /*#__PURE__*/external_react_default.a.createElement("input", extends_default()({
      className: "sage-search__input",
      type: "search",
      onChange: onChange,
      disabled: disabled,
      id: id,
      placeholder: "".concat(placeholder, "\u2026"),
      value: value // Prevents the default Kajabi-Products Search.js from binding to this input
      ,
      "data-kjb-disable-search": true
    }, rest)), onClear && /*#__PURE__*/external_react_default.a.createElement(Button, {
      className: "sage-search__reset-button",
      color: Button.COLORS.SECONDARY,
      icon: SageTokens.ICONS.REMOVE,
      iconOnly: true,
      onClick: onClear,
      subtle: true
    }, "Clear Search Input")));
  };

  Search_Search.defaultProps = {
    className: null,
    contained: false,
    disabled: false,
    hideLabel: false,
    onClear: null,
    placeholder: 'Search'
  };
  Search_Search.propTypes = {
    className: prop_types_default.a.string,
    contained: prop_types_default.a.bool,
    disabled: prop_types_default.a.bool,
    hideLabel: prop_types_default.a.bool,
    id: prop_types_default.a.string.isRequired,
    label: prop_types_default.a.string.isRequired,
    onChange: prop_types_default.a.func.isRequired,
    onClear: prop_types_default.a.func,
    placeholder: prop_types_default.a.string,
    value: prop_types_default.a.string.isRequired
  }; // CONCATENATED MODULE: ./lib/Search/index.js
  // CONCATENATED MODULE: ./lib/Dropdown/DropdownItemSearch.jsx

  var DropdownItemSearch_DropdownItemSearch = function DropdownItemSearch(_ref) {
    var onChangeSearchTerms = _ref.onChangeSearchTerms,
        onEnter = _ref.onEnter,
        placeholder = _ref.placeholder,
        selectedValue = _ref.selectedValue;

    var _useState = Object(external_react_["useState"])(''),
        _useState2 = slicedToArray_default()(_useState, 2),
        value = _useState2[0],
        updateValue = _useState2[1];

    Object(external_react_["useEffect"])(function () {
      if (selectedValue) {
        updateValue(selectedValue);
      }
    }, [selectedValue]);

    var onChange = function onChange(e) {
      updateValue(e.target.value);
      onChangeSearchTerms(e.target.value);
    };

    var onKeyUp = function onKeyUp(e) {
      if (e.key === 'Enter') {
        onEnter(e.target.value);
      }
    };

    return /*#__PURE__*/external_react_default.a.createElement(Search_Search, {
      value: value,
      onChange: onChange,
      onKeyUp: onKeyUp,
      placeholder: placeholder,
      role: "none"
    });
  };

  DropdownItemSearch_DropdownItemSearch.defaultProps = {
    onChangeSearchTerms: function onChangeSearchTerms(evt) {
      return evt;
    },
    onEnter: function onEnter(evt) {
      return evt;
    },
    placeholder: 'Find',
    selectedValue: ''
  };
  DropdownItemSearch_DropdownItemSearch.propTypes = {
    onChangeSearchTerms: prop_types_default.a.func,
    onEnter: prop_types_default.a.func,
    placeholder: prop_types_default.a.string,
    selectedValue: prop_types_default.a.string
  }; // CONCATENATED MODULE: ./lib/Dropdown/DropdownItemList.jsx

  /* eslint-disable react/no-array-index-key */

  var DropdownItemList_DropdownItemList = function DropdownItemList(_ref) {
    var allowMultiselect = _ref.allowMultiselect,
        customSearchFilter = _ref.customSearchFilter,
        filterActions = _ref.filterActions,
        groupId = _ref.groupId,
        items = _ref.items,
        localSelectedItems = _ref.localSelectedItems,
        onExit = _ref.onExit,
        onSearch = _ref.onSearch,
        searchable = _ref.searchable,
        searchPlaceholder = _ref.searchPlaceholder;

    var _useState = Object(external_react_["useState"])(''),
        _useState2 = slicedToArray_default()(_useState, 2),
        searchTerms = _useState2[0],
        updateSearchTerms = _useState2[1];

    var _useState3 = Object(external_react_["useState"])(items),
        _useState4 = slicedToArray_default()(_useState3, 2),
        filteredItems = _useState4[0],
        updateFilteredItem = _useState4[1];

    Object(external_react_["useEffect"])(function () {
      var refilter = function refilter(filterItems, filterSearchTerms) {
        if (!filterSearchTerms || filterSearchTerms === '') {
          return filterItems;
        }

        var refilteredItems = [];

        if (customSearchFilter) {
          refilteredItems = customSearchFilter(items, searchTerms);
        } else {
          refilteredItems = items.filter(function (_ref2) {
            var label = _ref2.label;
            return label.toUpperCase().includes(searchTerms.toUpperCase());
          });
        }

        return refilteredItems;
      };

      var refilteredItems = refilter(items, searchTerms);
      updateFilteredItem(refilteredItems);
    }, [customSearchFilter, items, searchTerms]);

    var onChangeSearchTerms = function onChangeSearchTerms(value) {
      updateSearchTerms(value);
      onSearch(value);
    };

    return /*#__PURE__*/external_react_default.a.createElement(external_react_default.a.Fragment, null, searchable && /*#__PURE__*/external_react_default.a.createElement(DropdownItemSearch_DropdownItemSearch, {
      placeholder: searchPlaceholder,
      onChangeSearchTerms: onChangeSearchTerms
    }), /*#__PURE__*/external_react_default.a.createElement("ul", {
      className: "sage-dropdown__menu",
      role: "menu"
    }, localSelectedItems.length > 0 && localSelectedItems.map(function (item, i) {
      return /*#__PURE__*/external_react_default.a.createElement(DropdownItem_DropdownItem, extends_default()({
        borderAfter: i === localSelectedItems.length - 1,
        groupId: groupId,
        hasCheckbox: false,
        key: "item.id-".concat(i, "-").concat(item.key, "-").concat(item.label, "-selected-key"),
        onExit: onExit
      }, item));
    }), filteredItems.map(function (item, i) {
      return /*#__PURE__*/external_react_default.a.createElement(DropdownItem_DropdownItem, extends_default()({
        groupId: groupId,
        hasCheckbox: allowMultiselect,
        key: "item.id-".concat(i, "-").concat(item.label, "-key"),
        onExit: onExit
      }, item));
    }), searchTerms !== '' && !items.some(function (item) {
      return item.label === searchTerms;
    }) && filterActions));
  };

  var itemsPropTypes = prop_types_default.a.arrayOf(prop_types_default.a.shape({
    id: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]),
    label: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.node]).isRequired
  }));
  DropdownItemList_DropdownItemList.itemsPropTypes = itemsPropTypes;
  DropdownItemList_DropdownItemList.defaultProps = {
    allowMultiselect: false,
    customSearchFilter: null,
    filterActions: null,
    groupId: null,
    items: [],
    localSelectedItems: [],
    onExit: function onExit(evt) {
      return evt;
    },
    onSearch: function onSearch(evt) {
      return evt;
    },
    searchable: false,
    searchPlaceholder: 'Find'
  };
  DropdownItemList_DropdownItemList.propTypes = {
    allowMultiselect: prop_types_default.a.bool,
    customSearchFilter: prop_types_default.a.func,
    filterActions: prop_types_default.a.node,
    groupId: prop_types_default.a.string,
    items: itemsPropTypes,
    localSelectedItems: itemsPropTypes,
    onExit: prop_types_default.a.func,
    onSearch: prop_types_default.a.func,
    searchable: prop_types_default.a.bool,
    searchPlaceholder: prop_types_default.a.string
  }; // CONCATENATED MODULE: ./lib/Dropdown/configs.js

  var DROPDOWN_ITEM_COLORS = {
    DANGER: 'danger',
    MUTED: 'muted',
    PRIMARY: 'primary',
    DEFAULT: null
  };
  var DROPDOWN_PANEL_SIZES = {
    DEFAULT: false,
    SMALL: 'small'
  };
  var DROPDOWN_PANEL_TYPES = {
    CHECKBOX: 'checkbox',
    CHOICE: 'choice',
    DROPDOWN: 'dropdown',
    SEARCHABLE: 'searchable',
    STATUS: 'status'
  };
  var DROPDOWN_POSITIONS = {
    DEFAULT: null,
    LEFT: 'left',
    RIGHT: 'right',
    CENTER: 'center'
  }; // CONCATENATED MODULE: ./lib/Dropdown/OptionsDropdown.jsx

  var OptionsDropdown_OptionsDropdown = function OptionsDropdown(_ref) {
    var align = _ref.align,
        className = _ref.className,
        exitPanelHandler = _ref.exitPanelHandler,
        isPinned = _ref.isPinned,
        onEscapeHook = _ref.onEscapeHook,
        panelMaxWidth = _ref.panelMaxWidth,
        panelSize = _ref.panelSize,
        options = _ref.options,
        triggerButtonSubtle = _ref.triggerButtonSubtle;
    return /*#__PURE__*/external_react_default.a.createElement(Dropdown_Dropdown, {
      align: align,
      className: className,
      exitPanelHandler: exitPanelHandler,
      icon: SageTokens.ICONS.DOT_MENU_HORIZONTAL,
      isLabelVisible: false,
      isPinned: isPinned,
      label: "Options",
      onEscapeHook: onEscapeHook,
      panelMaxWidth: panelMaxWidth,
      panelSize: panelSize,
      triggerModifier: "options",
      triggerButtonSubtle: triggerButtonSubtle
    }, /*#__PURE__*/external_react_default.a.createElement(Dropdown_Dropdown.ItemList, {
      items: options
    }));
  };

  OptionsDropdown_OptionsDropdown.PANEL_SIZES = DROPDOWN_PANEL_SIZES;
  OptionsDropdown_OptionsDropdown.POSITIONS = DROPDOWN_POSITIONS;
  OptionsDropdown_OptionsDropdown.defaultProps = {
    align: DROPDOWN_POSITIONS.DEFAULT,
    className: null,
    exitPanelHandler: function exitPanelHandler(evt) {
      return evt;
    },
    isPinned: true,
    onEscapeHook: function onEscapeHook() {
      return false;
    },
    panelMaxWidth: null,
    panelSize: DROPDOWN_PANEL_SIZES.DEFAULT,
    options: null,
    triggerButtonSubtle: true
  };
  OptionsDropdown_OptionsDropdown.propTypes = {
    align: prop_types_default.a.oneOf(Object.values(DROPDOWN_POSITIONS)),
    className: prop_types_default.a.string,
    exitPanelHandler: prop_types_default.a.func,
    isPinned: prop_types_default.a.bool,
    onEscapeHook: prop_types_default.a.func,
    panelMaxWidth: prop_types_default.a.string,
    panelSize: prop_types_default.a.oneOf(Object.values(DROPDOWN_PANEL_SIZES)),
    options: DropdownItemList_DropdownItemList.itemsPropTypes,
    triggerButtonSubtle: prop_types_default.a.bool
  }; // CONCATENATED MODULE: ./lib/Dropdown/DropdownItem.jsx

  var DropdownItem_excluded = ["borderAfter", "borderBefore", "color", "customComponent", "disabled", "hasCheckbox", "href", "icon", "id", "isActive", "isHeading", "isLabelVisible", "itemTag", "label", "groupId", "onClick", "onExit", "options", "payload", "to", "tooltip"];

  function DropdownItem_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function DropdownItem_objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? DropdownItem_ownKeys(Object(source), !0).forEach(function (key) {
        defineProperty_default()(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : DropdownItem_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }

    return target;
  }

  var DropdownItem_DropdownItem = function DropdownItem(_ref) {
    var _classnames;

    var borderAfter = _ref.borderAfter,
        borderBefore = _ref.borderBefore,
        color = _ref.color,
        customComponent = _ref.customComponent,
        disabled = _ref.disabled,
        hasCheckbox = _ref.hasCheckbox,
        href = _ref.href,
        icon = _ref.icon,
        id = _ref.id,
        isActive = _ref.isActive,
        isHeading = _ref.isHeading,
        isLabelVisible = _ref.isLabelVisible,
        itemTag = _ref.itemTag,
        label = _ref.label,
        groupId = _ref.groupId,
        onClick = _ref.onClick,
        onExit = _ref.onExit,
        options = _ref.options,
        payload = _ref.payload,
        to = _ref.to,
        tooltip = _ref.tooltip,
        rest = objectWithoutProperties_default()(_ref, DropdownItem_excluded);
    var classNames = classnames_default()('sage-dropdown__item', {
      'sage-dropdown__item--active': isActive,
      'sage-dropdown__item--disabled': disabled,
      'sage-dropdown__item--heading': isHeading,
      'sage-dropdown__item--with-options': options,
      'sage-dropdown__item--border-before': borderBefore,
      'sage-dropdown__item--border-after': borderAfter
    });
    var controlClassNames = classnames_default()('sage-dropdown__item-control', (_classnames = {}, defineProperty_default()(_classnames, "sage-dropdown__item-control--icon-".concat(icon), icon), defineProperty_default()(_classnames, "sage-dropdown__item-control--".concat(color), color), _classnames));

    var handleClick = function handleClick(e) {
      if (onClick) {
        onClick(e);
      }

      var modifiedPayload;

      if (payload) {
        modifiedPayload = DropdownItem_objectSpread({
          icon: icon,
          id: id,
          label: label
        }, payload);
      } else {
        modifiedPayload = {
          id: id
        };
      }

      if (onExit) {
        onExit(modifiedPayload);
      }
    };

    var onExitSubmenu = function onExitSubmenu(data) {
      onExit(DropdownItem_objectSpread(DropdownItem_objectSpread({}, data), {}, {
        parentPayload: payload
      }));
    };

    var fieldId = "".concat(groupId, "-checkbox-").concat(id);

    var renderOptions = function renderOptions() {
      return /*#__PURE__*/external_react_default.a.createElement(OptionsDropdown_OptionsDropdown, {
        className: "sage-dropdown__item-options",
        id: "".concat(groupId, "-").concat(id, "-options"),
        exitPanelHandler: onExitSubmenu,
        options: options
      });
    };

    var renderItem = function renderItem() {
      if (isHeading) {
        return /*#__PURE__*/external_react_default.a.createElement(external_react_default.a.Fragment, null, label);
      }

      var CustomComponent = customComponent;

      if (hasCheckbox) {
        return /*#__PURE__*/external_react_default.a.createElement("label", {
          className: controlClassNames,
          htmlFor: fieldId
        }, /*#__PURE__*/external_react_default.a.createElement(Checkbox_Checkbox, extends_default()({
          checked: !!isActive,
          className: "sage-dropdown__item-checkbox",
          disabled: disabled,
          id: fieldId,
          label: label,
          name: fieldId,
          onChange: handleClick,
          role: "menuitem",
          standalone: true,
          value: label
        }, rest)), /*#__PURE__*/external_react_default.a.createElement("span", {
          className: "sage-dropdown__item-label",
          title: label
        }, label));
      }

      if (href || to) {
        return /*#__PURE__*/external_react_default.a.createElement(Link_Link, extends_default()({
          className: controlClassNames,
          href: href,
          to: to,
          role: "menuitem",
          onClick: handleClick,
          disabled: disabled,
          tag: itemTag,
          suppressDefaultClass: true
        }, rest), !customComponent && isLabelVisible && /*#__PURE__*/external_react_default.a.createElement("span", {
          className: "sage-dropdown__item-label",
          title: label
        }, label), customComponent && /*#__PURE__*/external_react_default.a.createElement(CustomComponent, payload));
      }

      return /*#__PURE__*/external_react_default.a.createElement("button", extends_default()({
        className: controlClassNames,
        type: "button",
        onClick: handleClick,
        role: "menuitem",
        disabled: disabled
      }, rest), !customComponent && isLabelVisible && /*#__PURE__*/external_react_default.a.createElement("span", {
        className: "sage-dropdown__item-label",
        title: label
      }, label), customComponent && /*#__PURE__*/external_react_default.a.createElement(CustomComponent, payload));
    };

    return /*#__PURE__*/external_react_default.a.createElement(external_react_default.a.Fragment, null, tooltip ? /*#__PURE__*/external_react_default.a.createElement(Tooltip_Tooltip, tooltip, /*#__PURE__*/external_react_default.a.createElement("li", {
      className: classNames,
      role: "none"
    }, renderItem(), options && renderOptions())) : /*#__PURE__*/external_react_default.a.createElement("li", {
      className: classNames,
      role: "none"
    }, renderItem(), options && renderOptions()));
  };

  DropdownItem_DropdownItem.COLORS = DROPDOWN_ITEM_COLORS;
  DropdownItem_DropdownItem.defaultProps = {
    borderAfter: false,
    borderBefore: false,
    color: null,
    customComponent: null,
    disabled: false,
    groupId: 'dropdown',
    hasCheckbox: false,
    href: null,
    icon: null,
    isActive: false,
    isHeading: false,
    isLabelVisible: true,
    itemTag: null,
    onClick: null,
    onExit: null,
    options: null,
    payload: null,
    to: null,
    tooltip: null
  };
  DropdownItem_DropdownItem.propTypes = {
    borderAfter: prop_types_default.a.bool,
    borderBefore: prop_types_default.a.bool,
    color: prop_types_default.a.oneOf(Object.values(DROPDOWN_ITEM_COLORS)),
    customComponent: prop_types_default.a.elementType,
    disabled: prop_types_default.a.bool,
    groupId: prop_types_default.a.string,
    hasCheckbox: prop_types_default.a.bool,
    href: prop_types_default.a.string,
    icon: prop_types_default.a.oneOf(Object.values(SageTokens.ICONS)),
    id: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]).isRequired,
    isActive: prop_types_default.a.bool,
    isHeading: prop_types_default.a.bool,
    isLabelVisible: prop_types_default.a.bool,
    itemTag: Link_Link.tagPropTypes,
    label: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.node]).isRequired,
    onClick: prop_types_default.a.func,
    onExit: prop_types_default.a.func,
    options: prop_types_default.a.arrayOf(prop_types_default.a.shape({
      id: prop_types_default.a.number,
      label: prop_types_default.a.string
    })),
    payload: prop_types_default.a.oneOfType([prop_types_default.a.node, prop_types_default.a.object, prop_types_default.a.string, prop_types_default.a.func]),
    to: prop_types_default.a.string,
    tooltip: prop_types_default.a.shape({
      position: prop_types_default.a.oneOf(Object.values(Tooltip_Tooltip.POSITIONS)),
      size: prop_types_default.a.oneOf(Object.values(Tooltip_Tooltip.SIZES)),
      theme: prop_types_default.a.oneOf(Object.values(Tooltip_Tooltip.THEMES))
    })
  }; // CONCATENATED MODULE: ./lib/Dropdown/DropdownPanel.jsx

  function DropdownPanel_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function DropdownPanel_objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? DropdownPanel_ownKeys(Object(source), !0).forEach(function (key) {
        defineProperty_default()(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : DropdownPanel_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }

    return target;
  }
  /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */

  /* eslint-disable jsx-a11y/click-events-have-key-events */


  var DropdownPanel_DropdownPanel = function DropdownPanel(_ref) {
    var children = _ref.children,
        coords = _ref.coords,
        maxWidth = _ref.maxWidth,
        modifier = _ref.modifier,
        onClickScreen = _ref.onClickScreen,
        onExit = _ref.onExit;
    var menuEl = Object(external_react_["useRef"])(null);
    var classNames = classnames_default()('sage-dropdown__panel', defineProperty_default()({}, "sage-dropdown__panel--".concat(modifier), modifier));

    var handlePanelClick = function handlePanelClick(e) {
      if (e.target === menuEl.current) {
        onClickScreen();
      }
    };

    var positioningCoords = DropdownPanel_objectSpread({}, coords);
    return /*#__PURE__*/external_react_default.a.createElement("div", {
      ref: menuEl,
      className: classNames,
      onClick: handlePanelClick,
      role: "dialog",
      style: DropdownPanel_objectSpread({
        maxWidth: maxWidth
      }, positioningCoords)
    }, children && /*#__PURE__*/external_react_default.a.cloneElement(children, {
      onExit: onExit
    }));
  };

  DropdownPanel_DropdownPanel.defaultProps = {
    coords: null,
    children: null,
    maxWidth: null,
    modifier: null,
    onClickScreen: function onClickScreen(evt) {
      return evt;
    },
    onExit: function onExit(evt) {
      return evt;
    }
  };
  DropdownPanel_DropdownPanel.propTypes = {
    children: prop_types_default.a.node,
    coords: prop_types_default.a.shape({
      top: prop_types_default.a.number,
      left: prop_types_default.a.oneOfType([prop_types_default.a.number, prop_types_default.a.string]),
      right: prop_types_default.a.oneOfType([prop_types_default.a.number, prop_types_default.a.string])
    }),
    maxWidth: prop_types_default.a.string,
    modifier: prop_types_default.a.string,
    onClickScreen: prop_types_default.a.func,
    onExit: prop_types_default.a.func
  }; // CONCATENATED MODULE: ./lib/Dropdown/DropdownTriggerDefault.jsx

  var DropdownTriggerDefault_DropdownTriggerDefault = function DropdownTriggerDefault(_ref) {
    var className = _ref.className,
        disabled = _ref.disabled,
        disclosure = _ref.disclosure,
        icon = _ref.icon,
        isLabelVisible = _ref.isLabelVisible,
        label = _ref.label,
        onClick = _ref.onClick,
        subtle = _ref.subtle;
    return /*#__PURE__*/external_react_default.a.createElement(Button, {
      className: className,
      color: Button.COLORS.SECONDARY,
      disabled: disabled,
      disclosure: disclosure,
      icon: icon,
      iconOnly: !isLabelVisible,
      onClick: onClick,
      type: "button",
      subtle: subtle
    }, label);
  };

  DropdownTriggerDefault_DropdownTriggerDefault.defaultProps = {
    className: '',
    disabled: false,
    disclosure: false,
    isLabelVisible: true,
    icon: null,
    subtle: false
  };
  DropdownTriggerDefault_DropdownTriggerDefault.propTypes = {
    className: prop_types_default.a.string,
    disabled: prop_types_default.a.bool,
    disclosure: prop_types_default.a.bool,
    onClick: prop_types_default.a.func.isRequired,
    label: prop_types_default.a.string.isRequired,
    icon: prop_types_default.a.oneOf(Object.values(SageTokens.ICONS)),
    isLabelVisible: prop_types_default.a.bool,
    subtle: prop_types_default.a.bool
  }; // CONCATENATED MODULE: ./lib/Dropdown/DropdownTrigger.jsx

  function DropdownTrigger_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function DropdownTrigger_objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? DropdownTrigger_ownKeys(Object(source), !0).forEach(function (key) {
        defineProperty_default()(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : DropdownTrigger_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }

    return target;
  }

  var DropdownTrigger_DropdownTrigger = function DropdownTrigger(_ref) {
    var _classnames;

    var children = _ref.children,
        disabled = _ref.disabled,
        disclosure = _ref.disclosure,
        icon = _ref.icon,
        isLabelVisible = _ref.isLabelVisible,
        label = _ref.label,
        modifier = _ref.modifier,
        onClickTrigger = _ref.onClickTrigger,
        subtleButton = _ref.subtleButton,
        triggerClassnames = _ref.triggerClassnames,
        width = _ref.width;

    var onClick = function onClick() {
      onClickTrigger();
    };

    var classNames = classnames_default()('sage-dropdown__trigger', (_classnames = {}, defineProperty_default()(_classnames, "sage-dropdown__trigger--".concat(modifier), modifier), defineProperty_default()(_classnames, 'sage-dropdown__trigger--custom-width', width), _classnames));
    var styles = {};

    if (width) {
      styles['--sage-dropdown-trigger-width'] = width;
    }

    return /*#__PURE__*/external_react_default.a.createElement("div", {
      className: classNames,
      style: DropdownTrigger_objectSpread({}, styles)
    }, children ? /*#__PURE__*/external_react_default.a.cloneElement(children, {
      onClick: onClick
    }) : /*#__PURE__*/external_react_default.a.createElement(DropdownTriggerDefault_DropdownTriggerDefault, {
      className: triggerClassnames,
      disabled: disabled,
      disclosure: disclosure,
      icon: icon,
      isLabelVisible: isLabelVisible,
      label: label,
      onClick: onClickTrigger,
      subtle: subtleButton
    }));
  };

  DropdownTrigger_DropdownTrigger.defaultProps = {
    children: null,
    disabled: false,
    disclosure: false,
    icon: null,
    isLabelVisible: true,
    modifier: null,
    label: null,
    subtleButton: false,
    triggerClassnames: '',
    width: null
  };
  DropdownTrigger_DropdownTrigger.propTypes = {
    children: prop_types_default.a.node,
    disabled: prop_types_default.a.bool,
    disclosure: prop_types_default.a.bool,
    icon: prop_types_default.a.string,
    isLabelVisible: prop_types_default.a.bool,
    label: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.node]),
    modifier: prop_types_default.a.string,
    onClickTrigger: prop_types_default.a.func.isRequired,
    subtleButton: prop_types_default.a.bool,
    triggerClassnames: prop_types_default.a.string,
    width: prop_types_default.a.string
  }; // CONCATENATED MODULE: ./lib/Dropdown/DropdownTriggerSelect.jsx

  var DropdownTriggerSelect_DropdownTriggerSelect = function DropdownTriggerSelect(_ref) {
    var disabled = _ref.disabled,
        defaultIcon = _ref.defaultIcon,
        label = _ref.label,
        icon = _ref.icon,
        onClick = _ref.onClick,
        selectedValue = _ref.selectedValue;
    return /*#__PURE__*/external_react_default.a.createElement(external_react_default.a.Fragment, null, /*#__PURE__*/external_react_default.a.createElement(Button, {
      color: Button.COLORS.SECONDARY,
      className: "sage-dropdown__trigger-selected-value",
      disabled: disabled,
      icon: SageTokens.ICONS.CARET_DOWN,
      iconPosition: Button.ICON_POSITIONS.RIGHT,
      type: "button",
      onClick: onClick
    }, icon && /*#__PURE__*/external_react_default.a.createElement(Icon_Icon, {
      icon: icon,
      className: SageClassnames.SPACERS.XS_RIGHT
    }), selectedValue), /*#__PURE__*/external_react_default.a.createElement("span", {
      className: "sage-dropdown__trigger-label"
    }, defaultIcon && /*#__PURE__*/external_react_default.a.createElement(Icon_Icon, {
      icon: defaultIcon,
      className: SageClassnames.SPACERS.XS_RIGHT
    }), label));
  };

  DropdownTriggerSelect_DropdownTriggerSelect.defaultProps = {
    defaultIcon: null,
    disabled: false,
    icon: null,
    onClick: null,
    selectedValue: ' '
  };
  DropdownTriggerSelect_DropdownTriggerSelect.propTypes = {
    defaultIcon: prop_types_default.a.oneOf(Object.values(SageTokens.ICONS)),
    disabled: prop_types_default.a.bool,
    icon: prop_types_default.a.oneOf(Object.values(SageTokens.ICONS)),
    onClick: prop_types_default.a.func,
    label: prop_types_default.a.string.isRequired,
    selectedValue: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.node])
  }; // CONCATENATED MODULE: ./lib/Dropdown/Dropdown.jsx

  var Dropdown_Dropdown = function Dropdown(_ref) {
    var _classnames;

    var align = _ref.align,
        children = _ref.children,
        className = _ref.className,
        clickTriggerHandler = _ref.clickTriggerHandler,
        closePanelOnExit = _ref.closePanelOnExit,
        contained = _ref.contained,
        customized = _ref.customized,
        customTrigger = _ref.customTrigger,
        disabled = _ref.disabled,
        disclosure = _ref.disclosure,
        exitPanelHandler = _ref.exitPanelHandler,
        icon = _ref.icon,
        isLabelVisible = _ref.isLabelVisible,
        isPinned = _ref.isPinned,
        label = _ref.label,
        onEscapeHook = _ref.onEscapeHook,
        panelModifier = _ref.panelModifier,
        panelMaxWidth = _ref.panelMaxWidth,
        panelSize = _ref.panelSize,
        panelStateToken = _ref.panelStateToken,
        panelType = _ref.panelType,
        triggerButtonSubtle = _ref.triggerButtonSubtle,
        triggerClassnames = _ref.triggerClassnames,
        triggerModifier = _ref.triggerModifier,
        triggerWidth = _ref.triggerWidth;

    var _useState = Object(external_react_["useState"])(false),
        _useState2 = slicedToArray_default()(_useState, 2),
        isActive = _useState2[0],
        setActive = _useState2[1];

    var _useState3 = Object(external_react_["useState"])(null),
        _useState4 = slicedToArray_default()(_useState3, 2),
        coords = _useState4[0],
        updateCoords = _useState4[1];

    var wrapperRef = Object(external_react_["useRef"])(null);
    var topBoxOffset = 2;
    var inlineBoxOffset = -6;

    var onClickTrigger = function onClickTrigger() {
      if (!isActive && clickTriggerHandler) {
        clickTriggerHandler();
      }

      if (!disabled) {
        setActive(!isActive);
      }
    };

    var setPanelCoords = function setPanelCoords() {
      var rect = wrapperRef.current.getBoundingClientRect();
      updateCoords({
        top: rect.bottom + topBoxOffset,
        left: align !== 'right' ? rect.left + inlineBoxOffset : 'intitial',
        right: align === 'right' ? window.innerWidth - rect.right + inlineBoxOffset : 'intitial'
      });
    };

    var onUpdate = Object(external_react_["useCallback"])(Object(debounce["debounce"])(function () {
      return setPanelCoords();
    }, 20), []); // eslint-disable-line

    Object(external_react_["useEffect"])(function () {
      if (!wrapperRef) {
        return false;
      }

      if (isActive && isPinned) {
        setPanelCoords();
        window.addEventListener('scroll', onUpdate);
        window.addEventListener('resize', onUpdate);
      } else {
        window.removeEventListener('scroll', onUpdate);
        window.removeEventListener('resize', onUpdate);
      }

      return function () {
        window.removeEventListener('scroll', onUpdate);
        window.removeEventListener('resize', onUpdate);
      };
    }, [wrapperRef, isActive, isPinned, onUpdate]);
    Object(external_react_["useEffect"])(function () {
      if (panelStateToken) {
        setActive(!isActive);
      }
    }, [panelStateToken]);
    var a11yAttrs = {
      'aria-expanded': isActive
    };

    if (disabled) {
      a11yAttrs['aria-disabled'] = true;
    }

    var onExit = function onExit() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (closePanelOnExit && !data.suppressExit) {
        setActive(false);
      }

      if (exitPanelHandler) {
        exitPanelHandler(data);
      }
    };

    var onClickScreen = function onClickScreen() {
      setActive(false);
      onEscapeHook();
    };

    var classNames = classnames_default()('sage-dropdown', className, (_classnames = {}, defineProperty_default()(_classnames, "sage-dropdown--anchor-".concat(align), align), defineProperty_default()(_classnames, 'sage-dropdown--active', isActive), defineProperty_default()(_classnames, 'sage-dropdown--contained', contained), defineProperty_default()(_classnames, 'sage-dropdown--customized', customized), defineProperty_default()(_classnames, 'sage-dropdown--disabled', disabled), defineProperty_default()(_classnames, 'sage-dropdown--pinned', isPinned), defineProperty_default()(_classnames, "sage-dropdown--".concat(panelSize), panelSize), defineProperty_default()(_classnames, "sage-dropdown--".concat(panelType), panelType), _classnames));
    return /*#__PURE__*/external_react_default.a.createElement("div", extends_default()({
      ref: wrapperRef,
      className: classNames
    }, a11yAttrs), isActive && /*#__PURE__*/external_react_default.a.createElement("div", {
      "aria-hidden": "true",
      className: "sage-dropdown__screen",
      onClick: onClickScreen
    }), /*#__PURE__*/external_react_default.a.createElement(DropdownTrigger_DropdownTrigger, {
      disabled: disabled,
      disclosure: disclosure,
      icon: icon,
      isLabelVisible: isLabelVisible,
      label: label,
      modifier: triggerModifier,
      onClickTrigger: onClickTrigger,
      subtleButton: triggerButtonSubtle,
      triggerClassnames: triggerClassnames,
      width: triggerWidth
    }, customTrigger), isActive && /*#__PURE__*/external_react_default.a.createElement(DropdownPanel_DropdownPanel, {
      maxWidth: panelMaxWidth,
      modifier: panelModifier,
      onClickScreen: onClickScreen,
      onExit: onExit,
      coords: coords
    }, children));
  };

  Dropdown_Dropdown.Item = DropdownItem_DropdownItem;
  Dropdown_Dropdown.ItemSearch = DropdownItemSearch_DropdownItemSearch;
  Dropdown_Dropdown.ItemList = DropdownItemList_DropdownItemList;
  Dropdown_Dropdown.Panel = DropdownPanel_DropdownPanel;
  Dropdown_Dropdown.Trigger = DropdownTrigger_DropdownTrigger;
  Dropdown_Dropdown.TriggerSelect = DropdownTriggerSelect_DropdownTriggerSelect;
  Dropdown_Dropdown.ITEM_COLORS = DROPDOWN_ITEM_COLORS;
  Dropdown_Dropdown.PANEL_SIZES = DROPDOWN_PANEL_SIZES;
  Dropdown_Dropdown.PANEL_TYPES = DROPDOWN_PANEL_TYPES;
  Dropdown_Dropdown.POSITIONS = DROPDOWN_POSITIONS;
  Dropdown_Dropdown.defaultProps = {
    align: DROPDOWN_POSITIONS.DEFAULT,
    children: null,
    className: null,
    clickTriggerHandler: null,
    closePanelOnExit: true,
    contained: false,
    customTrigger: null,
    customized: false,
    exitPanelHandler: null,
    disabled: false,
    disclosure: false,
    icon: null,
    isLabelVisible: true,
    isPinned: false,
    label: null,
    onEscapeHook: function onEscapeHook() {
      return false;
    },
    panelMaxWidth: null,
    panelModifier: 'default',
    panelSize: DROPDOWN_PANEL_SIZES.DEFAULT,
    panelStateToken: null,
    panelType: null,
    triggerButtonSubtle: false,
    triggerClassnames: '',
    triggerModifier: 'default',
    triggerWidth: null
  };
  Dropdown_Dropdown.propTypes = {
    align: prop_types_default.a.oneOf(Object.values(Dropdown_Dropdown.POSITIONS)),
    children: prop_types_default.a.node,
    className: prop_types_default.a.string,
    clickTriggerHandler: prop_types_default.a.func,
    closePanelOnExit: prop_types_default.a.bool,
    contained: prop_types_default.a.bool,
    customized: prop_types_default.a.bool,
    customTrigger: prop_types_default.a.node,
    disabled: prop_types_default.a.bool,
    disclosure: prop_types_default.a.bool,
    exitPanelHandler: prop_types_default.a.func,
    icon: prop_types_default.a.oneOf(Object.values(SageTokens.ICONS)),
    isLabelVisible: prop_types_default.a.bool,
    isPinned: prop_types_default.a.bool,
    label: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.node]),
    onEscapeHook: prop_types_default.a.func,
    panelMaxWidth: prop_types_default.a.string,
    panelModifier: prop_types_default.a.string,
    panelSize: prop_types_default.a.oneOf(Object.values(Dropdown_Dropdown.PANEL_SIZES)),
    panelType: prop_types_default.a.oneOf(Object.values(Dropdown_Dropdown.PANEL_TYPES)),
    panelStateToken: prop_types_default.a.string,
    triggerButtonSubtle: prop_types_default.a.bool,
    triggerClassnames: prop_types_default.a.string,
    triggerModifier: prop_types_default.a.string,
    triggerWidth: prop_types_default.a.string
  }; // EXTERNAL MODULE: /__w/sage-lib/sage-lib/node_modules/@babel/runtime/helpers/typeof.js

  var helpers_typeof = __webpack_require__(8);

  var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof); // CONCATENATED MODULE: ./lib/Label/configs.js


  var LABEL_COLORS = {
    DANGER: 'danger',
    DRAFT: 'draft',
    INFO: 'info',
    LOCKED: 'locked',
    PUBLISHED: 'published',
    SUCCESS: 'published',
    // dupe alias for common usage or other contexts
    WARNING: 'warning'
  };
  var LABEL_STYLES = {
    DEFAULT: null,
    SUBTLE: 'subtle',
    BOLD: 'bold'
  };
  var LABEL_INTERACTIVE_TYPES = {
    DEFAULT: true,
    DROPDOWN: 'dropdown',
    SECONDARY_BUTTON: 'secondary_button'
  };
  var LABEL_GROUP_ALIGN_OPTIONS = {
    CENTER: 'center',
    NONE: 'none',
    END: 'end',
    SPACEBETWEEN: 'space-between'
  };
  var LABEL_GROUP_GAP_OPTIONS = {
    NONE: null,
    XS: 'xs',
    SM: 'sm',
    MD: 'md',
    LG: 'lg'
  }; // CONCATENATED MODULE: ./lib/Label/LabelSecondaryButton.jsx

  var LabelSecondaryButton_excluded = ["icon", "label"];

  var LabelSecondaryButton_LabelSecondaryButton = function LabelSecondaryButton(_ref) {
    var icon = _ref.icon,
        label = _ref.label,
        rest = objectWithoutProperties_default()(_ref, LabelSecondaryButton_excluded);
    return /*#__PURE__*/external_react_default.a.createElement(Button, extends_default()({
      color: Button.COLORS.SECONDARY,
      icon: icon,
      iconOnly: true,
      subtle: true
    }, rest), "Remove");
  };

  LabelSecondaryButton_LabelSecondaryButton.defaultProps = {
    icon: SageTokens.ICONS.REMOVE,
    label: 'Remove'
  };
  LabelSecondaryButton_LabelSecondaryButton.propTypes = {
    label: prop_types_default.a.string,
    icon: prop_types_default.a.oneOf(Object.values(SageTokens.ICONS))
  }; // CONCATENATED MODULE: ./lib/Label/LabelGroup.jsx

  var LabelGroup_excluded = ["align", "children", "className", "gap"];

  var LabelGroup_LabelGroup = function LabelGroup(_ref) {
    var _classnames;

    var align = _ref.align,
        children = _ref.children,
        className = _ref.className,
        gap = _ref.gap,
        rest = objectWithoutProperties_default()(_ref, LabelGroup_excluded);
    var classNames = classnames_default()('sage-label-group', className, (_classnames = {}, defineProperty_default()(_classnames, "sage-label-group--align-".concat(align), align), defineProperty_default()(_classnames, "sage-grid-gap-".concat(gap), gap), _classnames));
    return /*#__PURE__*/external_react_default.a.createElement("div", extends_default()({
      className: classNames
    }, rest), children);
  };

  LabelGroup_LabelGroup.ALIGN_OPTIONS = LABEL_GROUP_ALIGN_OPTIONS;
  LabelGroup_LabelGroup.GAP_OPTIONS = LABEL_GROUP_GAP_OPTIONS;
  LabelGroup_LabelGroup.defaultProps = {
    align: LabelGroup_LabelGroup.ALIGN_OPTIONS.NONE,
    className: null,
    children: null,
    gap: LabelGroup_LabelGroup.GAP_OPTIONS.NONE
  };
  LabelGroup_LabelGroup.propTypes = {
    align: prop_types_default.a.oneOf(Object.values(LabelGroup_LabelGroup.ALIGN_OPTIONS)),
    children: prop_types_default.a.node,
    className: prop_types_default.a.string,
    gap: prop_types_default.a.oneOf(Object.values(LabelGroup_LabelGroup.GAP_OPTIONS))
  }; // CONCATENATED MODULE: ./lib/Label/Label.jsx

  var Label_excluded = ["className", "color", "customIconColor", "containerAttributes", "icon", "interactiveType", "isDropdown", "isStatus", "secondaryButton", "style", "value"];
  var Label = /*#__PURE__*/external_react_default.a.forwardRef(function (_ref, ref) {
    var _classnames;

    var className = _ref.className,
        color = _ref.color,
        customIconColor = _ref.customIconColor,
        containerAttributes = _ref.containerAttributes,
        icon = _ref.icon,
        interactiveType = _ref.interactiveType,
        isDropdown = _ref.isDropdown,
        isStatus = _ref.isStatus,
        secondaryButton = _ref.secondaryButton,
        style = _ref.style,
        value = _ref.value,
        rest = objectWithoutProperties_default()(_ref, Label_excluded);
    var TagName = interactiveType ? 'button' : 'span';
    var classNames = classnames_default()('sage-label', className, (_classnames = {}, defineProperty_default()(_classnames, "sage-label--".concat(color), color), defineProperty_default()(_classnames, "sage-label--".concat(style), style), defineProperty_default()(_classnames, 'sage-label--interactive', interactiveType), defineProperty_default()(_classnames, 'sage-label--interactive-right-cta-affordance', interactiveType && interactiveType !== LABEL_INTERACTIVE_TYPES.DEFAULT), defineProperty_default()(_classnames, "sage-label--icon-".concat(icon), icon), defineProperty_default()(_classnames, 'sage-label--icon--custom-color', customIconColor), _classnames));

    var setCustomIconColor = function setCustomIconColor() {
      var props = {};

      if (customIconColor) {
        props['--sage-label-custom-icon-color'] = customIconColor;
      }

      return props;
    };

    return /*#__PURE__*/external_react_default.a.createElement("span", extends_default()({
      className: classNames,
      ref: ref,
      style: setCustomIconColor()
    }, containerAttributes), /*#__PURE__*/external_react_default.a.createElement(TagName, extends_default()({
      className: "sage-label__value",
      type: interactiveType ? 'button' : null
    }, rest), /*#__PURE__*/external_react_default.a.createElement("span", {
      className: "sage-label__value-text"
    }, value)), interactiveType === LABEL_INTERACTIVE_TYPES.SECONDARY_BUTTON && secondaryButton, interactiveType === LABEL_INTERACTIVE_TYPES.DROPDOWN && /*#__PURE__*/external_react_default.a.createElement("span", {
      className: "sage-label__decor-icon sage-label__decor-icon--down-small"
    }));
  });
  Label.COLORS = LABEL_COLORS;
  Label.STYLES = LABEL_STYLES;
  Label.INTERACTIVE_TYPES = LABEL_INTERACTIVE_TYPES;
  Label.SecondaryButton = LabelSecondaryButton_LabelSecondaryButton;
  Label.Group = LabelGroup_LabelGroup;
  Label.defaultProps = {
    className: null,
    color: LABEL_COLORS.DRAFT,
    customIconColor: null,
    icon: null,
    interactiveType: null,
    isDropdown: false,
    isStatus: false,
    containerAttributes: null,
    secondaryButton: null,
    style: LABEL_STYLES.DEFAULT
  };
  Label.propTypes = {
    className: prop_types_default.a.string,
    color: prop_types_default.a.oneOf(Object.values(LABEL_COLORS)),
    customIconColor: prop_types_default.a.string,
    icon: prop_types_default.a.oneOf(Object.values(SageTokens.ICONS)),
    interactiveType: prop_types_default.a.oneOf(Object.values(LABEL_INTERACTIVE_TYPES)),
    isDropdown: prop_types_default.a.bool,
    isStatus: prop_types_default.a.bool,
    containerAttributes: prop_types_default.a.shape({}),
    secondaryButton: prop_types_default.a.node,
    style: prop_types_default.a.oneOf(Object.values(LABEL_STYLES)),
    value: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.node]).isRequired
  }; // CONCATENATED MODULE: ./lib/Label/index.js
  // CONCATENATED MODULE: ./lib/Dropdown/SelectDropdown.jsx

  function SelectDropdown_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function SelectDropdown_objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? SelectDropdown_ownKeys(Object(source), !0).forEach(function (key) {
        defineProperty_default()(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SelectDropdown_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }

    return target;
  }
  /* eslint-disable react-hooks/exhaustive-deps */


  var SelectDropdown_SelectDropdown = function SelectDropdown(_ref) {
    var align = _ref.align,
        allowDeselect = _ref.allowDeselect,
        allowMultiselect = _ref.allowMultiselect,
        className = _ref.className,
        closePanelOnExit = _ref.closePanelOnExit,
        contained = _ref.contained,
        customized = _ref.customized,
        defaultIcon = _ref.defaultIcon,
        disabled = _ref.disabled,
        filterActions = _ref.filterActions,
        id = _ref.id,
        initialSelectedValue = _ref.initialSelectedValue,
        items = _ref.items,
        label = _ref.label,
        localSelectedItems = _ref.localSelectedItems,
        onChangeHook = _ref.onChangeHook,
        onDeselect = _ref.onDeselect,
        onEscapeHook = _ref.onEscapeHook,
        onSearch = _ref.onSearch,
        onSelect = _ref.onSelect,
        panelSize = _ref.panelSize,
        resetToken = _ref.resetToken,
        searchable = _ref.searchable,
        searchPlaceholder = _ref.searchPlaceholder,
        selectionBecomesLabel = _ref.selectionBecomesLabel,
        showSelectionsAsLabels = _ref.showSelectionsAsLabels,
        triggerWidth = _ref.triggerWidth;
    var emptySelectedValue = /*#__PURE__*/external_react_default.a.createElement(external_react_default.a.Fragment, null, "\xA0");

    var setClassNames = function setClassNames(_hasSelectedValue) {
      return classnames_default()(className, {
        'sage-dropdown--value-selected': _hasSelectedValue,
        'sage-dropdown--contained': contained
      });
    };

    var displaySelectedValue = function displaySelectedValue() {
      if (!initialSelectedValue) {
        return emptySelectedValue;
      }

      if (initialSelectedValue.label) {
        return initialSelectedValue.label;
      }

      return initialSelectedValue;
    };

    var _useState = Object(external_react_["useState"])({
      classNames: setClassNames(!!initialSelectedValue),
      hasSelectedValue: !!initialSelectedValue,
      icon: defaultIcon,
      selectedValue: displaySelectedValue()
    }),
        _useState2 = slicedToArray_default()(_useState, 2),
        configs = _useState2[0],
        setConfigs = _useState2[1];

    var deselectValue = function deselectValue() {
      setConfigs({
        classNames: setClassNames(false),
        hasSelectedValue: false,
        icon: defaultIcon,
        selectedValue: emptySelectedValue
      });

      if (onDeselect) {
        onDeselect();
      }
    };

    var changeValue = function changeValue(data) {
      var selectedValue = configs.selectedValue,
          icon = configs.icon,
          hasSelectedValue = configs.hasSelectedValue;

      if (onChangeHook) {
        data = onChangeHook(data);
      }

      if (selectionBecomesLabel && !allowMultiselect) {
        // retrieve the selected value and icon if possible
        switch (typeof_default()(data)) {
          case 'object':
            selectedValue = data.label || null;
            icon = data.icon || null;
            break;

          case 'string':
            selectedValue = data;
            break;

          case 'number':
            selectedValue = String(data);
            break;

          default:
            break;
        } // Selecting same item as currently selected deselects it


        if (allowDeselect && selectedValue === configs.selectedValue) {
          deselectValue();
          return;
        } // Ensure a safe value is put into the selectedvalue


        if (!selectedValue) {
          selectedValue = emptySelectedValue;
          hasSelectedValue = false;
        } else {
          hasSelectedValue = true;
        }

        setConfigs({
          classNames: setClassNames(selectedValue !== emptySelectedValue),
          hasSelectedValue: hasSelectedValue,
          icon: icon,
          selectedValue: selectedValue
        });
      }

      if (onSelect) {
        onSelect(data);
      }
    }; // When reset token changes, deselect current selection


    Object(external_react_["useEffect"])(function () {
      if (resetToken) {
        deselectValue();
      }
    }, [resetToken]);
    Object(external_react_["useEffect"])(function () {
      if (selectionBecomesLabel && allowMultiselect) {
        var lastSelectedLabel,
            numSelected = 0;
        localSelectedItems.forEach(function (item) {
          if (item.isActive) {
            numSelected += 1;
            lastSelectedLabel = item.label;
          }
        });
        var selectedValue, hasSelectedValue;

        if (numSelected > 1) {
          selectedValue = "".concat(numSelected, " items");
          hasSelectedValue = true;
        } else if (numSelected === 1) {
          selectedValue = lastSelectedLabel;
          hasSelectedValue = true;
        } else {
          selectedValue = initialSelectedValue || emptySelectedValue;
          hasSelectedValue = initialSelectedValue !== null;
        }

        setConfigs({
          classNames: setClassNames(hasSelectedValue),
          icon: configs.icon,
          selectedValue: selectedValue,
          hasSelectedValue: hasSelectedValue
        });
      } else if (selectionBecomesLabel && !allowMultiselect) {
        var _selectedValue = configs.selectedValue,
            _hasSelectedValue2 = configs.hasSelectedValue;

        if (initialSelectedValue && !_hasSelectedValue2) {
          _hasSelectedValue2 = true;
          _selectedValue = initialSelectedValue;
        }

        setConfigs(SelectDropdown_objectSpread(SelectDropdown_objectSpread({}, configs), {}, {
          classNames: setClassNames(_hasSelectedValue2),
          hasSelectedValue: _hasSelectedValue2,
          selectedValue: _selectedValue
        }));
      }
    }, [initialSelectedValue, items, selectionBecomesLabel, allowMultiselect]);

    var renderDropdown = function renderDropdown() {
      return /*#__PURE__*/external_react_default.a.createElement(Dropdown_Dropdown, {
        align: align,
        className: configs.classNames,
        closePanelOnExit: closePanelOnExit,
        contained: contained,
        customized: customized,
        customTrigger: /*#__PURE__*/external_react_default.a.createElement(DropdownTriggerSelect_DropdownTriggerSelect, {
          disabled: disabled,
          defaultIcon: defaultIcon,
          label: label,
          icon: configs.icon,
          selectedValue: configs.selectedValue
        }),
        disabled: disabled,
        exitPanelHandler: changeValue,
        label: emptySelectedValue,
        onEscapeHook: onEscapeHook,
        panelModifier: "select",
        panelSize: panelSize,
        triggerModifier: "select",
        triggerWidth: triggerWidth
      }, /*#__PURE__*/external_react_default.a.createElement(Dropdown_Dropdown.ItemList, {
        allowMultiselect: allowMultiselect,
        filterActions: filterActions,
        groupId: id,
        items: items,
        localSelectedItems: localSelectedItems,
        onSearch: onSearch,
        searchable: searchable || allowMultiselect,
        searchPlaceholder: searchPlaceholder
      }));
    };

    return allowMultiselect && showSelectionsAsLabels ? /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-dropdown-combo"
    }, renderDropdown(), /*#__PURE__*/external_react_default.a.createElement(Label.Group, null, items.map(function (_ref2) {
      var id = _ref2.id,
          isActive = _ref2.isActive,
          label = _ref2.label,
          payload = _ref2.payload;
      return isActive &&
      /*#__PURE__*/
      // TODO this needs to be change to a tag
      external_react_default.a.createElement(Label, {
        key: id,
        interactiveType: Label.INTERACTIVE_TYPES.SECONDARY_BUTTON,
        secondaryButton: /*#__PURE__*/external_react_default.a.createElement(Label.SecondaryButton, {
          onClick: function onClick() {
            return changeValue(payload || {
              id: id
            });
          }
        }),
        value: label
      });
    }))) : renderDropdown();
  };

  SelectDropdown_SelectDropdown.PANEL_SIZES = DROPDOWN_PANEL_SIZES;
  SelectDropdown_SelectDropdown.POSITIONS = DROPDOWN_POSITIONS;
  SelectDropdown_SelectDropdown.defaultProps = {
    align: DROPDOWN_POSITIONS.DEFAULT,
    allowDeselect: false,
    allowMultiselect: false,
    className: null,
    closePanelOnExit: true,
    contained: true,
    customized: false,
    defaultIcon: null,
    disabled: false,
    filterActions: null,
    id: uuid_default()(),
    initialSelectedValue: null,
    items: [],
    label: 'Select...',
    localSelectedItems: [],
    onChangeHook: null,
    onDeselect: null,
    onEscapeHook: function onEscapeHook() {
      return false;
    },
    onSelect: function onSelect(evt) {
      return evt;
    },
    onSearch: function onSearch(evt) {
      return evt;
    },
    panelSize: DROPDOWN_PANEL_SIZES.DEFAULT,
    resetToken: null,
    searchable: false,
    searchPlaceholder: 'Find',
    selectionBecomesLabel: true,
    showSelectionsAsLabels: false,
    triggerWidth: null
  };
  SelectDropdown_SelectDropdown.propTypes = {
    align: prop_types_default.a.oneOf(Object.values(DROPDOWN_POSITIONS)),
    allowDeselect: prop_types_default.a.bool,
    allowMultiselect: prop_types_default.a.bool,
    className: prop_types_default.a.string,
    closePanelOnExit: prop_types_default.a.bool,
    contained: prop_types_default.a.bool,
    customized: prop_types_default.a.bool,
    defaultIcon: prop_types_default.a.oneOf(Object.values(SageTokens.ICONS)),
    disabled: prop_types_default.a.bool,
    filterActions: prop_types_default.a.node,
    label: prop_types_default.a.string,
    id: prop_types_default.a.string,
    initialSelectedValue: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.shape({
      id: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]),
      label: prop_types_default.a.string
    })]),
    items: prop_types_default.a.arrayOf(prop_types_default.a.shape({
      id: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]),
      label: prop_types_default.a.string
    })),
    localSelectedItems: prop_types_default.a.arrayOf(prop_types_default.a.shape({})),
    onChangeHook: prop_types_default.a.func,
    onDeselect: prop_types_default.a.func,
    onEscapeHook: prop_types_default.a.func,
    onSearch: prop_types_default.a.func,
    onSelect: prop_types_default.a.func,
    panelSize: prop_types_default.a.oneOf(Object.values(DROPDOWN_PANEL_SIZES)),
    resetToken: prop_types_default.a.oneOfType([prop_types_default.a.bool, prop_types_default.a.number, prop_types_default.a.string]),
    searchable: prop_types_default.a.bool,
    searchPlaceholder: prop_types_default.a.string,
    selectionBecomesLabel: prop_types_default.a.bool,
    showSelectionsAsLabels: prop_types_default.a.bool,
    triggerWidth: prop_types_default.a.string
  }; // CONCATENATED MODULE: ./lib/Dropdown/index.js
  // CONCATENATED MODULE: ./lib/CopyText/CopyText.jsx

  var CopyText_CopyText = function CopyText(_ref) {
    var children = _ref.children,
        className = _ref.className,
        semibold = _ref.semibold;
    var classNames = classnames_default()('sage-copy-text', className, {
      'sage-copy-text--semibold': semibold
    });
    return /*#__PURE__*/external_react_default.a.createElement("span", {
      className: classNames
    }, children);
  };

  CopyText_CopyText.defaultProps = {
    children: null,
    className: null,
    semibold: false
  };
  CopyText_CopyText.propTypes = {
    children: prop_types_default.a.node,
    className: prop_types_default.a.string,
    semibold: prop_types_default.a.bool
  }; // CONCATENATED MODULE: ./lib/CopyText/CopyTextCard.jsx

  var CopyTextCard_CopyTextCard = function CopyTextCard(_ref) {
    var children = _ref.children,
        className = _ref.className,
        semibold = _ref.semibold;
    var classNames = classnames_default()('sage-copy-text-card', className, {
      'sage-copy-text-card--semibold': semibold
    });
    return /*#__PURE__*/external_react_default.a.createElement("div", {
      className: classNames
    }, children);
  };

  CopyTextCard_CopyTextCard.defaultProps = {
    children: null,
    className: null,
    semibold: false
  };
  CopyTextCard_CopyTextCard.propTypes = {
    children: prop_types_default.a.node,
    className: prop_types_default.a.string,
    semibold: prop_types_default.a.bool
  }; // CONCATENATED MODULE: ./lib/CopyText/index.js
  // CONCATENATED MODULE: ./lib/CopyButton/CopyButton.jsx

  var CopyButton_CopyButton = function CopyButton(_ref) {
    var borderless = _ref.borderless,
        children = _ref.children,
        className = _ref.className,
        fillContainer = _ref.fillContainer,
        semibold = _ref.semibold;
    var classNames = classnames_default()('sage-copy-btn', className, {
      'sage-copy-btn--fill-container': fillContainer,
      'sage-copy-btn--borderless': borderless
    });
    var btnRef = Object(external_react_["useRef"])(null);

    var onClick = function onClick() {
      navigator.clipboard.writeText(btnRef.current.innerText);
    };

    return /*#__PURE__*/external_react_default.a.createElement(external_react_default.a.Fragment, null, /*#__PURE__*/external_react_default.a.createElement(Button, {
      ref: btnRef,
      className: classNames,
      color: borderless ? Button.COLORS.SECONDARY : null,
      icon: borderless ? SageTokens.ICONS.COPY : null,
      iconPosition: Button.ICON_POSITIONS.RIGHT,
      subtle: true,
      type: "button",
      onClick: onClick
    }, borderless ? children : /*#__PURE__*/external_react_default.a.createElement(CopyText_CopyText, {
      semibold: semibold
    }, children)));
  };

  CopyButton_CopyButton.defaultProps = {
    borderless: false,
    children: null,
    className: null,
    fillContainer: false,
    semibold: true
  };
  CopyButton_CopyButton.propTypes = {
    borderless: prop_types_default.a.bool,
    children: prop_types_default.a.node,
    className: prop_types_default.a.string,
    fillContainer: prop_types_default.a.bool,
    semibold: prop_types_default.a.bool
  }; // CONCATENATED MODULE: ./lib/CopyButton/index.js
  // CONCATENATED MODULE: ./lib/DataCard/DataCardBody.jsx

  var DataCardBody_excluded = ["children", "className"];

  var DataCardBody_DataCardBody = function DataCardBody(_ref) {
    var children = _ref.children,
        className = _ref.className,
        rest = objectWithoutProperties_default()(_ref, DataCardBody_excluded);
    return /*#__PURE__*/external_react_default.a.createElement("div", extends_default()({
      className: "sage-data-card__body ".concat(className || '')
    }, rest), children);
  };

  DataCardBody_DataCardBody.defaultProps = {
    children: null,
    className: ''
  };
  DataCardBody_DataCardBody.propTypes = {
    children: prop_types_default.a.node,
    className: prop_types_default.a.string
  }; // CONCATENATED MODULE: ./lib/DataCard/configs.js

  var DATA_CARD_COLORS = {
    DEFAULT: null,
    DANGER: 'danger',
    MUTED: 'muted'
  }; // CONCATENATED MODULE: ./lib/DataCard/DataCardGroup.jsx

  var DataCardGroup_excluded = ["children", "className", "color", "title", "titleTag"];

  var DataCardGroup_DataCardGroup = function DataCardGroup(_ref) {
    var children = _ref.children,
        className = _ref.className,
        color = _ref.color,
        title = _ref.title,
        titleTag = _ref.titleTag,
        rest = objectWithoutProperties_default()(_ref, DataCardGroup_excluded);
    var TitleTag = titleTag;
    var classNames = classnames_default()('sage-data-card-group', className, defineProperty_default()({}, "sage-data-card-group--".concat(color), color));
    return /*#__PURE__*/external_react_default.a.createElement("div", extends_default()({
      className: classNames
    }, rest), title ? /*#__PURE__*/external_react_default.a.createElement(external_react_default.a.Fragment, null, /*#__PURE__*/external_react_default.a.createElement(TitleTag, {
      className: "sage-data-card-group__title"
    }, title), /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-data-card-group__items"
    }, children)) : children);
  };

  DataCardGroup_DataCardGroup.defaultProps = {
    children: null,
    className: '',
    color: null,
    title: null,
    titleTag: 'h4'
  };
  DataCardGroup_DataCardGroup.propTypes = {
    children: prop_types_default.a.node,
    className: prop_types_default.a.string,
    color: prop_types_default.a.oneOf(Object.values(DATA_CARD_COLORS)),
    title: prop_types_default.a.string,
    titleTag: prop_types_default.a.string
  }; // CONCATENATED MODULE: ./lib/DataCard/DataCardHeader.jsx

  var DataCardHeader_excluded = ["children", "className", "title"];

  var DataCardHeader_DataCardHeader = function DataCardHeader(_ref) {
    var children = _ref.children,
        className = _ref.className,
        title = _ref.title,
        rest = objectWithoutProperties_default()(_ref, DataCardHeader_excluded);
    return /*#__PURE__*/external_react_default.a.createElement("div", extends_default()({
      className: "sage-data-card__header ".concat(className || '')
    }, rest), title && /*#__PURE__*/external_react_default.a.createElement("h4", {
      className: "sage-data-card__title t-sage--truncate"
    }, title), children);
  };

  DataCardHeader_DataCardHeader.defaultProps = {
    children: null,
    className: '',
    title: null
  };
  DataCardHeader_DataCardHeader.propTypes = {
    children: prop_types_default.a.node,
    className: prop_types_default.a.string,
    title: prop_types_default.a.string
  }; // CONCATENATED MODULE: ./lib/DataCard/DataCardScrollContainer.jsx

  var DataCardScrollContainer_excluded = ["children", "className"];

  var DataCardScrollContainer_DataCardScrollContainer = function DataCardScrollContainer(_ref) {
    var children = _ref.children,
        className = _ref.className,
        rest = objectWithoutProperties_default()(_ref, DataCardScrollContainer_excluded);
    return /*#__PURE__*/external_react_default.a.createElement("div", extends_default()({
      className: "sage-data-card-scroll-container ".concat(className || '')
    }, rest), /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-data-card-scroll"
    }, children));
  };

  DataCardScrollContainer_DataCardScrollContainer.defaultProps = {
    children: null,
    className: ''
  };
  DataCardScrollContainer_DataCardScrollContainer.propTypes = {
    children: prop_types_default.a.node,
    className: prop_types_default.a.string
  }; // CONCATENATED MODULE: ./lib/DataCard/DataCard.jsx

  var DataCard_excluded = ["children", "className", "color"];

  var DataCard_DataCard = function DataCard(_ref) {
    var children = _ref.children,
        className = _ref.className,
        color = _ref.color,
        rest = objectWithoutProperties_default()(_ref, DataCard_excluded);
    var classNames = classnames_default()('sage-data-card', className, defineProperty_default()({}, "sage-data-card--".concat(color), color));
    return /*#__PURE__*/external_react_default.a.createElement("div", extends_default()({
      className: classNames
    }, rest), children);
  };

  DataCard_DataCard.Body = DataCardBody_DataCardBody;
  DataCard_DataCard.Header = DataCardHeader_DataCardHeader;
  DataCard_DataCard.Group = DataCardGroup_DataCardGroup;
  DataCard_DataCard.ScrollContainer = DataCardScrollContainer_DataCardScrollContainer;
  DataCard_DataCard.COLORS = DATA_CARD_COLORS;
  DataCard_DataCard.defaultProps = {
    children: null,
    className: '',
    color: DATA_CARD_COLORS.DEFAULT
  };
  DataCard_DataCard.propTypes = {
    children: prop_types_default.a.node,
    className: prop_types_default.a.string,
    color: prop_types_default.a.oneOf(Object.values(DATA_CARD_COLORS))
  }; // CONCATENATED MODULE: ./lib/DataCard/index.js
  // CONCATENATED MODULE: ./lib/ExpandableCard/ExpandableCard.jsx

  var ExpandableCard_excluded = ["alignArrowRight", "bodyBordered", "expanded", "children", "className", "name", "onClick", "sageType", "triggerLabel"];

  var ExpandableCard_ExpandableCard = function ExpandableCard(_ref) {
    var alignArrowRight = _ref.alignArrowRight,
        bodyBordered = _ref.bodyBordered,
        expanded = _ref.expanded,
        children = _ref.children,
        className = _ref.className,
        name = _ref.name,
        onClick = _ref.onClick,
        sageType = _ref.sageType,
        triggerLabel = _ref.triggerLabel,
        rest = objectWithoutProperties_default()(_ref, ExpandableCard_excluded);

    var _useState = Object(external_react_["useState"])(expanded),
        _useState2 = slicedToArray_default()(_useState, 2),
        isExpanded = _useState2[0],
        setIsExpanded = _useState2[1];

    Object(external_react_["useEffect"])(function () {
      setIsExpanded(expanded);
    }, [expanded]);

    var handleChange = function handleChange(event) {
      setIsExpanded(!isExpanded);

      if (onClick) {
        onClick(event, !isExpanded);
      }
    };

    var id = uuid_default()();
    var containerClassnames = classnames_default()('sage-expandable-card', {
      'sage-expandable-card--align-arrow-right': alignArrowRight,
      'sage-expandable-card': !isExpanded,
      'sage-expandable-card--expanded': isExpanded
    });
    var bodyClassnames = classnames_default()(defineProperty_default()({
      'sage-expandable-card__body-bordered': bodyBordered,
      'sage-expandable-card__body': !bodyBordered
    }, "".concat(SageClassnames.TYPE_BLOCK), sageType));
    return /*#__PURE__*/external_react_default.a.createElement("div", extends_default()({
      className: "".concat(containerClassnames, " ").concat(className || '')
    }, rest), /*#__PURE__*/external_react_default.a.createElement(Button, {
      "aria-controls": id,
      "aria-expanded": isExpanded,
      className: "sage-expandable-card__trigger",
      color: "secondary",
      fullWidth: true,
      icon: SageTokens.ICONS.CARET_RIGHT,
      onClick: handleChange,
      subtle: true
    }, triggerLabel), /*#__PURE__*/external_react_default.a.createElement("div", {
      id: id,
      className: bodyClassnames
    }, children));
  };

  ExpandableCard_ExpandableCard.defaultProps = {
    alignArrowRight: false,
    bodyBordered: false,
    expanded: false,
    children: null,
    className: null,
    name: null,
    onClick: null,
    sageType: false,
    triggerLabel: null
  };
  ExpandableCard_ExpandableCard.propTypes = {
    alignArrowRight: prop_types_default.a.bool,
    bodyBordered: prop_types_default.a.bool,
    expanded: prop_types_default.a.bool,
    className: prop_types_default.a.string,
    children: prop_types_default.a.node,
    name: prop_types_default.a.string,
    onClick: prop_types_default.a.func,
    sageType: prop_types_default.a.bool,
    triggerLabel: prop_types_default.a.string
  }; // CONCATENATED MODULE: ./lib/ExpandableCard/index.js
  // CONCATENATED MODULE: ./lib/Grid/configs.js

  var CONTAINER_SIZES = {
    XS: 'xs',
    SM: 'sm',
    MD: 'md',
    LG: 'lg',
    XL: 'full',
    // TODO: Deprecated in NEXT
    FULL: 'full'
  };
  var GRID_BREAKPOINT_TOGGLES = {
    SHOW: 'show',
    HIDE: 'hide'
  };
  var HORIZONTAL_ALIGNMENT_TYPES = {
    START: 'start',
    CENTER: 'center',
    END: 'end',
    SPACE_BETWEEN: 'space-between',
    SPACE_AROUND: 'space-around',
    SPACE_EVENLY: 'space-evenly'
  };
  var VERTICAL_ALIGNMENT_TYPES = {
    START: 'start',
    CENTER: 'center',
    END: 'end',
    BASELINE: 'baseline',
    STRETCH: 'stretch'
  };

  var validNumberWithinGrid = function validNumberWithinGrid(props, propName, componentName) {
    componentName = componentName || 'ANONYMOUS';

    if (props[propName]) {
      var value = props[propName];

      if (typeof value === 'number') {
        return value >= 1 && value <= 12 ? null : new Error("".concat(propName, " in ").concat(componentName, " is not within 1 to 12"));
      }
    }

    return null;
  };

  var validBreakpoint = prop_types_default.a.oneOfType([prop_types_default.a.oneOf(Object.values(GRID_BREAKPOINT_TOGGLES)), validNumberWithinGrid]); // CONCATENATED MODULE: ./lib/Grid/GridCol.jsx

  var GridCol_excluded = ["children", "className", "large", "medium", "sageType", "size", "small", "xlarge", "verticalAlignment"];

  var GridCol_GridCol = function GridCol(_ref) {
    var _classnames;

    var children = _ref.children,
        className = _ref.className,
        large = _ref.large,
        medium = _ref.medium,
        sageType = _ref.sageType,
        size = _ref.size,
        small = _ref.small,
        xlarge = _ref.xlarge,
        verticalAlignment = _ref.verticalAlignment,
        rest = objectWithoutProperties_default()(_ref, GridCol_excluded);
    var hasInfix = size || small || medium || large || xlarge;
    var classNames = classnames_default()(className, (_classnames = {
      'sage-col': !hasInfix
    }, defineProperty_default()(_classnames, "sage-col-".concat(size), size), defineProperty_default()(_classnames, "sage-col--sm-".concat(small), small), defineProperty_default()(_classnames, "sage-col--md-".concat(medium), medium), defineProperty_default()(_classnames, "sage-col--lg-".concat(large), large), defineProperty_default()(_classnames, "sage-col--xl-".concat(xlarge), xlarge), defineProperty_default()(_classnames, "sage-col--valign-".concat(verticalAlignment), verticalAlignment), defineProperty_default()(_classnames, "".concat(SageClassnames.TYPE_BLOCK), sageType), _classnames));
    return /*#__PURE__*/external_react_default.a.createElement("div", extends_default()({
      className: classNames
    }, rest), children);
  };

  GridCol_GridCol.VERTICAL_ALIGNMENT_TYPES = VERTICAL_ALIGNMENT_TYPES;
  GridCol_GridCol.defaultProps = {
    className: null,
    children: null,
    large: null,
    medium: null,
    sageType: false,
    small: null,
    size: null,
    xlarge: null,
    verticalAlignment: null
  };
  GridCol_GridCol.propTypes = {
    className: prop_types_default.a.string,
    children: prop_types_default.a.node,
    small: validBreakpoint,
    medium: validBreakpoint,
    large: validBreakpoint,
    sageType: prop_types_default.a.bool,
    size: validNumberWithinGrid,
    xlarge: validBreakpoint,

    /**
     * Sets the vertical alignment for the grid col
     */
    verticalAlignment: prop_types_default.a.oneOf(Object.values(GridCol_GridCol.VERTICAL_ALIGNMENT_TYPES))
  }; // CONCATENATED MODULE: ./lib/Grid/GridRow.jsx

  var GridRow_excluded = ["className", "horizontalAlignment", "verticalAlignment", "spacerAbove", "spacerBelow"];

  var GridRow_GridRow = function GridRow(_ref) {
    var _classnames;

    var className = _ref.className,
        horizontalAlignment = _ref.horizontalAlignment,
        verticalAlignment = _ref.verticalAlignment,
        spacerAbove = _ref.spacerAbove,
        spacerBelow = _ref.spacerBelow,
        rest = objectWithoutProperties_default()(_ref, GridRow_excluded);
    var children = rest.children;
    var classNames = classnames_default()('sage-row', className, (_classnames = {}, defineProperty_default()(_classnames, "sage-row--align-".concat(horizontalAlignment), horizontalAlignment), defineProperty_default()(_classnames, "sage-row--valign-".concat(verticalAlignment), verticalAlignment), defineProperty_default()(_classnames, 'sage-spacer-top', spacerBelow === SageTokens.SPACERS.MD), defineProperty_default()(_classnames, "sage-spacer-top-".concat(spacerAbove), spacerAbove && spacerAbove !== SageTokens.SPACERS.MD), defineProperty_default()(_classnames, 'sage-spacer-bottom', spacerBelow === SageTokens.SPACERS.MD), defineProperty_default()(_classnames, "sage-spacer-bottom-".concat(spacerBelow), spacerBelow && spacerBelow !== SageTokens.SPACERS.MD), _classnames));
    return /*#__PURE__*/external_react_default.a.createElement("div", extends_default()({
      className: classNames
    }, rest), children);
  };

  GridRow_GridRow.HORIZONTAL_ALIGNMENT_TYPES = HORIZONTAL_ALIGNMENT_TYPES;
  GridRow_GridRow.VERTICAL_ALIGNMENT_TYPES = VERTICAL_ALIGNMENT_TYPES;
  GridRow_GridRow.defaultProps = {
    className: null,
    horizontalAlignment: null,
    verticalAlignment: null,
    spacerAbove: null,
    spacerBelow: null
  };
  GridRow_GridRow.propTypes = {
    /**
     * Sets classes passed into component on `.sage-row` element
     */
    className: prop_types_default.a.string,

    /**
     * Sets the horizontal alignment for the grid row
     */
    horizontalAlignment: prop_types_default.a.oneOf(Object.values(GridRow_GridRow.HORIZONTAL_ALIGNMENT_TYPES)),

    /**
     * Sets the vertical alignment for the grid row
     */
    verticalAlignment: prop_types_default.a.oneOf(Object.values(GridRow_GridRow.VERTICAL_ALIGNMENT_TYPES)),

    /**
     * Adds preset spacer to top of grid row
     */
    spacerAbove: prop_types_default.a.oneOf(Object.values(SageTokens.SPACERS)),

    /**
     * Adds preset spacer to bottom of grid row
     */
    spacerBelow: prop_types_default.a.oneOf(Object.values(SageTokens.SPACERS))
  }; // CONCATENATED MODULE: ./lib/Grid/Grid.jsx

  var Grid_excluded = ["children", "className", "container", "withRow"];

  function Grid_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function Grid_objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? Grid_ownKeys(Object(source), !0).forEach(function (key) {
        defineProperty_default()(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Grid_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }

    return target;
  }

  var Grid_Grid = function Grid(_ref) {
    var children = _ref.children,
        className = _ref.className,
        container = _ref.container,
        withRow = _ref.withRow,
        rest = objectWithoutProperties_default()(_ref, Grid_excluded);
    var classNames = classnames_default()(className, defineProperty_default()({
      'sage-container': container
    }, "sage-container--".concat(container), container));
    var rowProps = {};

    if (!container) {
      rowProps = Grid_objectSpread({}, rest);
    }

    var gridChildren = withRow ? /*#__PURE__*/external_react_default.a.createElement(GridRow_GridRow, rowProps, children) : /*#__PURE__*/external_react_default.a.createElement(external_react_default.a.Fragment, null, children);
    return container ? /*#__PURE__*/external_react_default.a.createElement("div", extends_default()({
      className: classNames
    }, rest), gridChildren) : /*#__PURE__*/external_react_default.a.createElement(external_react_default.a.Fragment, null, gridChildren);
  };

  Grid_Grid.Row = GridRow_GridRow;
  Grid_Grid.Col = GridCol_GridCol;
  Grid_Grid.CONTAINER_SIZES = CONTAINER_SIZES;
  Grid_Grid.GRID_BREAKPOINT_TOGGLES = GRID_BREAKPOINT_TOGGLES;
  Grid_Grid.defaultProps = {
    children: null,
    className: null,
    container: CONTAINER_SIZES.FULL,
    withRow: false
  };
  Grid_Grid.propTypes = {
    children: prop_types_default.a.node,
    className: prop_types_default.a.string,
    container: prop_types_default.a.oneOf(Object.values(CONTAINER_SIZES)),
    withRow: prop_types_default.a.bool
  }; // CONCATENATED MODULE: ./lib/Grid/index.js
  // CONCATENATED MODULE: ./lib/Panel/PanelBlock.jsx

  var PanelBlock_excluded = ["children", "className", "sageType"];

  var PanelBlock_PanelBlock = function PanelBlock(_ref) {
    var children = _ref.children,
        className = _ref.className,
        sageType = _ref.sageType,
        rest = objectWithoutProperties_default()(_ref, PanelBlock_excluded);
    var classNames = classnames_default()('sage-panel__block', className, defineProperty_default()({}, "".concat(SageClassnames.TYPE_BLOCK), sageType));
    return /*#__PURE__*/external_react_default.a.createElement("div", extends_default()({
      className: classNames
    }, rest), children);
  };

  PanelBlock_PanelBlock.defaultProps = {
    children: null,
    className: '',
    sageType: false
  };
  PanelBlock_PanelBlock.propTypes = {
    children: prop_types_default.a.node,
    className: prop_types_default.a.string,
    sageType: prop_types_default.a.bool
  }; // CONCATENATED MODULE: ./lib/Panel/PanelDivider.jsx

  var PanelDivider_excluded = ["bleed"];

  var PanelDivider_PanelDivider = function PanelDivider(_ref) {
    var bleed = _ref.bleed,
        rest = objectWithoutProperties_default()(_ref, PanelDivider_excluded);
    var classNames = classnames_default()({
      'sage-panel__divider': true,
      'sage-panel__divider--full-bleed': bleed
    });
    return /*#__PURE__*/external_react_default.a.createElement("hr", extends_default()({
      className: classNames
    }, rest));
  };

  PanelDivider_PanelDivider.defaultProps = {
    bleed: false
  };
  PanelDivider_PanelDivider.propTypes = {
    bleed: prop_types_default.a.bool
  }; // CONCATENATED MODULE: ./lib/Panel/configs.js

  var PANEL_FIGURE_BLEED_OPTIONS = {
    NONE: null,
    TOP: 'bleed-top',
    SIDES: 'bleed-sides',
    BOTTOM: 'bleed-bottom'
  };
  var PANEL_ROW_ALIGNMENT_OPTIONS = {
    DEFAULT: null,
    START: 'start',
    TOP: 'start'
  };
  var PANEL_ROW_GAP_OPTIONS = {
    DEFAULT: null,
    XS: 'xs',
    SM: 'sm',
    MD: 'md',
    LG: 'lg'
  };
  var PANEL_LIST_GAP_OPTIONS = PANEL_ROW_GAP_OPTIONS;
  var PANEL_TILE_OPTIONS_ARRAY = [2, 3, 4];
  var PANEL_LIST_BLOCK_SPACING = {
    DEFAULT: false,
    MD: 'md',
    XS: 'xs'
  };
  var PANEL_STACK_SPACINGS = {
    DEFAULT: null,
    FORM: 'form'
  }; // CONCATENATED MODULE: ./lib/Panel/PanelFigure.jsx

  var PanelFigure_excluded = ["aspectRatio", "backgroundColor", "bleed", "children", "className", "isWistia", "padded"];

  function PanelFigure_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function PanelFigure_objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? PanelFigure_ownKeys(Object(source), !0).forEach(function (key) {
        defineProperty_default()(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PanelFigure_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }

    return target;
  }

  var PanelFigure_PanelFigure = function PanelFigure(_ref) {
    var _classnames;

    var aspectRatio = _ref.aspectRatio,
        backgroundColor = _ref.backgroundColor,
        bleed = _ref.bleed,
        children = _ref.children,
        className = _ref.className,
        isWistia = _ref.isWistia,
        padded = _ref.padded,
        rest = objectWithoutProperties_default()(_ref, PanelFigure_excluded);
    var classNames = classnames_default()('sage-panel__figure', className, (_classnames = {
      'sage-panel__figure--aspect-ratio': aspectRatio
    }, defineProperty_default()(_classnames, "sage-panel__figure--".concat(bleed), bleed), defineProperty_default()(_classnames, 'sage-panel__figure--padded', padded), defineProperty_default()(_classnames, 'sage-panel__figure--wistia', isWistia), _classnames));
    var customStyles = {};

    if (aspectRatio) {
      customStyles['--sage-figure-aspect-ratio'] = aspectRatio;
    }

    if (backgroundColor) {
      customStyles['--sage-figure-background-color'] = backgroundColor;
    }

    return /*#__PURE__*/external_react_default.a.createElement("div", extends_default()({
      className: classNames
    }, rest, {
      style: PanelFigure_objectSpread(PanelFigure_objectSpread({}, customStyles), rest.styles)
    }), children);
  };

  PanelFigure_PanelFigure.BLEED_OPTIONS = PANEL_FIGURE_BLEED_OPTIONS;
  PanelFigure_PanelFigure.defaultProps = {
    aspectRatio: null,
    backgroundColor: null,
    bleed: PANEL_FIGURE_BLEED_OPTIONS.NONE,
    children: null,
    className: null,
    isWistia: false,
    padded: false
  };
  PanelFigure_PanelFigure.propTypes = {
    aspectRatio: prop_types_default.a.number,
    backgroundColor: prop_types_default.a.string,
    bleed: prop_types_default.a.oneOf(Object.values(PANEL_FIGURE_BLEED_OPTIONS)),
    children: prop_types_default.a.node,
    className: prop_types_default.a.string,
    isWistia: prop_types_default.a.bool,
    padded: prop_types_default.a.bool
  }; // CONCATENATED MODULE: ./lib/Panel/PanelFooter.jsx

  var PanelFooter_excluded = ["alignSpread", "children", "className"];

  var PanelFooter_PanelFooter = function PanelFooter(_ref) {
    var alignSpread = _ref.alignSpread,
        children = _ref.children,
        className = _ref.className,
        rest = objectWithoutProperties_default()(_ref, PanelFooter_excluded);
    var classNames = classnames_default()('sage-panel__footer', className, {
      'sage-panel__footer--align-spread': alignSpread
    });
    return /*#__PURE__*/external_react_default.a.createElement("div", extends_default()({
      className: classNames
    }, rest), children);
  };

  PanelFooter_PanelFooter.defaultProps = {
    alignSpread: false,
    children: null,
    className: ''
  };
  PanelFooter_PanelFooter.propTypes = {
    alignSpread: prop_types_default.a.bool,
    children: prop_types_default.a.node,
    className: prop_types_default.a.string
  }; // CONCATENATED MODULE: ./lib/Panel/PanelSubtext.jsx

  var PanelSubtext_excluded = ["children"];

  var PanelSubtext_PanelSubtext = function PanelSubtext(_ref) {
    var children = _ref.children,
        rest = objectWithoutProperties_default()(_ref, PanelSubtext_excluded);
    return /*#__PURE__*/external_react_default.a.createElement("div", extends_default()({
      className: "sage-panel__subtext"
    }, rest), children);
  };

  PanelSubtext_PanelSubtext.defaultProps = {
    children: null
  };
  PanelSubtext_PanelSubtext.propTypes = {
    children: prop_types_default.a.node
  }; // CONCATENATED MODULE: ./lib/Panel/PanelTitle.jsx

  var PanelTitle_excluded = ["children", "className", "tag"];

  var PanelTitle_PanelTitle = function PanelTitle(_ref) {
    var children = _ref.children,
        className = _ref.className,
        tag = _ref.tag,
        rest = objectWithoutProperties_default()(_ref, PanelTitle_excluded);
    var TagName = tag || 'h2';
    var classNames = classnames_default()('sage-panel__title', className);
    return /*#__PURE__*/external_react_default.a.createElement(TagName, extends_default()({
      className: classNames
    }, rest), children);
  };

  PanelTitle_PanelTitle.defaultProps = {
    children: null,
    className: null,
    tag: null
  };
  PanelTitle_PanelTitle.propTypes = {
    children: prop_types_default.a.node,
    className: prop_types_default.a.string,
    tag: prop_types_default.a.string
  }; // CONCATENATED MODULE: ./lib/Panel/PanelHeader.jsx

  var PanelHeader_excluded = ["children", "className", "subtext", "title", "titleTag", "titleClassName"];

  var PanelHeader_PanelHeader = function PanelHeader(_ref) {
    var children = _ref.children,
        className = _ref.className,
        subtext = _ref.subtext,
        title = _ref.title,
        titleTag = _ref.titleTag,
        titleClassName = _ref.titleClassName,
        rest = objectWithoutProperties_default()(_ref, PanelHeader_excluded);
    var hasSubtextChild = false;
    var childCount = 0;
    external_react_default.a.Children.forEach(children, function (child) {
      childCount += 1;
      if (child.type.name === 'PanelSubtext') hasSubtextChild = true;
    });
    var isCustom = false;
    if (childCount === 1 && (!hasSubtextChild || !subtext) || childCount > 1) isCustom = true;
    var classNames = classnames_default()('sage-panel__header', className, {
      'sage-panel__header--custom': isCustom
    });
    return /*#__PURE__*/external_react_default.a.createElement("header", extends_default()({
      className: classNames
    }, rest), /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-panel__header-inner"
    }, title && /*#__PURE__*/external_react_default.a.createElement(PanelTitle_PanelTitle, {
      className: titleClassName,
      tag: titleTag
    }, title), subtext && /*#__PURE__*/external_react_default.a.createElement(PanelSubtext_PanelSubtext, null, subtext)), children);
  };

  PanelHeader_PanelHeader.defaultProps = {
    children: null,
    className: null,
    subtext: null,
    title: null,
    titleTag: 'h2',
    titleClassName: null
  };
  PanelHeader_PanelHeader.propTypes = {
    children: prop_types_default.a.node,
    className: prop_types_default.a.string,
    subtext: prop_types_default.a.node,
    title: prop_types_default.a.string,
    titleTag: prop_types_default.a.string,
    titleClassName: prop_types_default.a.string
  }; // CONCATENATED MODULE: ./lib/Panel/PanelListItem.jsx

  var PanelListItem_excluded = ["children", "className", "gridTemplate", "gap"];

  var PanelListItem_PanelListItem = function PanelListItem(_ref) {
    var _classnames;

    var children = _ref.children,
        className = _ref.className,
        gridTemplate = _ref.gridTemplate,
        gap = _ref.gap,
        rest = objectWithoutProperties_default()(_ref, PanelListItem_excluded);
    var classNames = classnames_default()('sage-panel__list-item', className, (_classnames = {}, defineProperty_default()(_classnames, "".concat(SageClassnames.lookupGridTemplate(gridTemplate)), gridTemplate), defineProperty_default()(_classnames, "sage-grid-gap-".concat(gap), gap), _classnames));
    return /*#__PURE__*/external_react_default.a.createElement("li", extends_default()({
      className: classNames
    }, rest), children);
  };

  PanelListItem_PanelListItem.defaultProps = {
    children: null,
    className: '',
    gridTemplate: null,
    gap: PANEL_LIST_GAP_OPTIONS.DEFAULT
  };
  PanelListItem_PanelListItem.propTypes = {
    children: prop_types_default.a.node,
    className: prop_types_default.a.string,
    gridTemplate: prop_types_default.a.oneOf(Object.values(SageTokens.GRID_TEMPLATES)),
    gap: prop_types_default.a.oneOf(Object.values(PANEL_LIST_GAP_OPTIONS))
  }; // CONCATENATED MODULE: ./lib/Panel/PanelList.jsx

  var PanelList_excluded = ["children", "className", "hideFirstBorder", "itemClassName", "itemGridTemplate", "items", "blockSpacing", "wrapItems"];

  var PanelList_PanelList = function PanelList(_ref) {
    var _classnames;

    var children = _ref.children,
        className = _ref.className,
        hideFirstBorder = _ref.hideFirstBorder,
        itemClassName = _ref.itemClassName,
        itemGridTemplate = _ref.itemGridTemplate,
        items = _ref.items,
        blockSpacing = _ref.blockSpacing,
        wrapItems = _ref.wrapItems,
        rest = objectWithoutProperties_default()(_ref, PanelList_excluded);
    var classNames = classnames_default()('sage-panel__list', className, (_classnames = {}, defineProperty_default()(_classnames, "sage-panel__list--block-space-".concat(blockSpacing), blockSpacing), defineProperty_default()(_classnames, 'sage-panel__list--hide-first-border', hideFirstBorder), _classnames));
    return /*#__PURE__*/external_react_default.a.createElement("ul", extends_default()({
      className: classNames
    }, rest), items && items.map(function (item) {
      return wrapItems ? /*#__PURE__*/external_react_default.a.createElement(PanelListItem_PanelListItem, {
        key: uuid_default()(),
        className: itemClassName,
        gridTemplate: itemGridTemplate
      }, item) : /*#__PURE__*/external_react_default.a.createElement(external_react_default.a.Fragment, {
        key: uuid_default()()
      }, item);
    }), children);
  };

  PanelList_PanelList.SPACING = PANEL_LIST_BLOCK_SPACING;
  PanelList_PanelList.defaultProps = {
    children: null,
    className: '',
    hideFirstBorder: false,
    itemClassName: null,
    itemGridTemplate: null,
    items: [],
    blockSpacing: PANEL_LIST_BLOCK_SPACING.DEFAULT,
    wrapItems: true
  };
  PanelList_PanelList.propTypes = {
    children: prop_types_default.a.node,
    className: prop_types_default.a.string,
    hideFirstBorder: prop_types_default.a.bool,
    items: prop_types_default.a.arrayOf(prop_types_default.a.node),
    itemClassName: prop_types_default.a.string,
    itemGridTemplate: prop_types_default.a.oneOf(Object.values(SageTokens.GRID_TEMPLATES)),
    blockSpacing: prop_types_default.a.oneOf(Object.values(PANEL_LIST_BLOCK_SPACING)),
    wrapItems: prop_types_default.a.bool
  }; // CONCATENATED MODULE: ./lib/Panel/PanelRow.jsx

  var PanelRow_excluded = ["children", "className", "gridTemplate", "verticalAlign", "gap"];

  var PanelRow_PanelRow = function PanelRow(_ref) {
    var _classnames;

    var children = _ref.children,
        className = _ref.className,
        gridTemplate = _ref.gridTemplate,
        verticalAlign = _ref.verticalAlign,
        gap = _ref.gap,
        rest = objectWithoutProperties_default()(_ref, PanelRow_excluded);
    var classNames = classnames_default()('sage-panel__row', className, (_classnames = {}, defineProperty_default()(_classnames, "".concat(SageClassnames.lookupGridTemplate(gridTemplate)), gridTemplate), defineProperty_default()(_classnames, "sage-panel__row--vertical-align-".concat(verticalAlign), verticalAlign), defineProperty_default()(_classnames, "sage-grid-gap-".concat(gap), gap), _classnames));
    return /*#__PURE__*/external_react_default.a.createElement("div", extends_default()({
      className: classNames
    }, rest), children);
  };

  PanelRow_PanelRow.VERTICAL_ALIGNMENTS = PANEL_ROW_ALIGNMENT_OPTIONS;
  PanelRow_PanelRow.GAP_OPTIONS = PANEL_ROW_GAP_OPTIONS;
  PanelRow_PanelRow.defaultProps = {
    children: null,
    className: '',
    gridTemplate: null,
    verticalAlign: PANEL_ROW_ALIGNMENT_OPTIONS.DEFAULT,
    gap: PANEL_ROW_GAP_OPTIONS.DEFAULT
  };
  PanelRow_PanelRow.propTypes = {
    children: prop_types_default.a.node,
    className: prop_types_default.a.string,
    gridTemplate: prop_types_default.a.oneOf(Object.values(SageTokens.GRID_TEMPLATES)),
    verticalAlign: prop_types_default.a.oneOf(Object.values(PANEL_ROW_ALIGNMENT_OPTIONS)),
    gap: prop_types_default.a.oneOf(Object.values(PANEL_ROW_GAP_OPTIONS))
  }; // CONCATENATED MODULE: ./lib/Panel/PanelStack.jsx

  var PanelStack_excluded = ["children", "className", "spacing"];

  var PanelStack_PanelStack = function PanelStack(_ref) {
    var children = _ref.children,
        className = _ref.className,
        spacing = _ref.spacing,
        rest = objectWithoutProperties_default()(_ref, PanelStack_excluded);
    var classNames = classnames_default()('sage-panel__stack', className, defineProperty_default()({}, "sage-panel__stack--spacing-".concat(spacing), spacing));
    return /*#__PURE__*/external_react_default.a.createElement("div", extends_default()({
      className: classNames
    }, rest), children);
  };

  PanelStack_PanelStack.SPACINGS = PANEL_STACK_SPACINGS;
  PanelStack_PanelStack.defaultProps = {
    children: null,
    className: '',
    spacing: PANEL_STACK_SPACINGS.DEFAULT
  };
  PanelStack_PanelStack.propTypes = {
    children: prop_types_default.a.node,
    className: prop_types_default.a.string,
    spacing: prop_types_default.a.oneOf(Object.values(PANEL_STACK_SPACINGS))
  }; // CONCATENATED MODULE: ./lib/Panel/PanelSubtitle.jsx

  var PanelSubtitle_excluded = ["children", "tag"];

  var PanelSubtitle_PanelSubtitle = function PanelSubtitle(_ref) {
    var children = _ref.children,
        tag = _ref.tag,
        rest = objectWithoutProperties_default()(_ref, PanelSubtitle_excluded);
    var TagName = tag || 'h3';
    return /*#__PURE__*/external_react_default.a.createElement(TagName, extends_default()({
      className: "sage-panel__subtitle"
    }, rest), children);
  };

  PanelSubtitle_PanelSubtitle.defaultProps = {
    children: null,
    tag: null
  };
  PanelSubtitle_PanelSubtitle.propTypes = {
    children: prop_types_default.a.node,
    tag: prop_types_default.a.string
  }; // CONCATENATED MODULE: ./lib/Panel/PanelSubheader.jsx

  var PanelSubheader_excluded = ["children", "className", "subtext", "title", "titleTag"];

  var PanelSubheader_PanelSubheader = function PanelSubheader(_ref) {
    var children = _ref.children,
        className = _ref.className,
        subtext = _ref.subtext,
        title = _ref.title,
        titleTag = _ref.titleTag,
        rest = objectWithoutProperties_default()(_ref, PanelSubheader_excluded);
    var hasSubtextChild = false;
    var childCount = 0;
    external_react_default.a.Children.forEach(children, function (child) {
      childCount += 1;
      if (child.type.name === 'PanelSubtext') hasSubtextChild = true;
    });
    var isCustom = false;
    if (childCount === 1 && (!hasSubtextChild || !subtext) || childCount > 1) isCustom = true;
    var classNames = classnames_default()('sage-panel__subheader', className, {
      'sage-panel__subheader--custom': isCustom
    });
    return /*#__PURE__*/external_react_default.a.createElement("header", extends_default()({
      className: classNames
    }, rest), title && /*#__PURE__*/external_react_default.a.createElement(PanelSubtitle_PanelSubtitle, {
      tag: titleTag
    }, title), children, subtext && /*#__PURE__*/external_react_default.a.createElement(PanelSubtext_PanelSubtext, null, subtext));
  };

  PanelSubheader_PanelSubheader.defaultProps = {
    children: null,
    className: '',
    subtext: null,
    title: null,
    titleTag: 'h3'
  };
  PanelSubheader_PanelSubheader.propTypes = {
    children: prop_types_default.a.node,
    className: prop_types_default.a.string,
    subtext: prop_types_default.a.node,
    title: prop_types_default.a.string,
    titleTag: prop_types_default.a.string
  }; // CONCATENATED MODULE: ./lib/Panel/PanelTile.jsx

  var PanelTile_excluded = ["children", "className"];

  var PanelTile_PanelTile = function PanelTile(_ref) {
    var children = _ref.children,
        className = _ref.className,
        rest = objectWithoutProperties_default()(_ref, PanelTile_excluded);
    return /*#__PURE__*/external_react_default.a.createElement("div", extends_default()({
      className: "sage-panel__tile ".concat(className || '')
    }, rest), children);
  };

  PanelTile_PanelTile.defaultProps = {
    children: null,
    className: ''
  };
  PanelTile_PanelTile.propTypes = {
    children: prop_types_default.a.node,
    className: prop_types_default.a.string
  }; // CONCATENATED MODULE: ./lib/Panel/PanelTiles.jsx

  var PanelTiles_excluded = ["children", "className", "tileClassName", "tiles", "tilesInRow", "wrapTiles"];

  var PanelTiles_PanelTiles = function PanelTiles(_ref) {
    var children = _ref.children,
        className = _ref.className,
        tileClassName = _ref.tileClassName,
        tiles = _ref.tiles,
        tilesInRow = _ref.tilesInRow,
        wrapTiles = _ref.wrapTiles,
        rest = objectWithoutProperties_default()(_ref, PanelTiles_excluded);
    var classNames = classnames_default()('sage-panel__tiles', className, defineProperty_default()({}, "sage-panel__tiles--".concat(tilesInRow, "-up"), tilesInRow));
    return /*#__PURE__*/external_react_default.a.createElement("div", extends_default()({
      className: classNames
    }, rest), tiles && tiles.map(function (tile) {
      return wrapTiles ? /*#__PURE__*/external_react_default.a.createElement(PanelTile_PanelTile, {
        key: uuid_default()(),
        className: tileClassName
      }, tile) : /*#__PURE__*/external_react_default.a.createElement(external_react_default.a.Fragment, {
        key: uuid_default()()
      }, tile);
    }), children);
  };

  PanelTiles_PanelTiles.defaultProps = {
    children: null,
    className: null,
    tileClassName: null,
    tiles: [],
    tilesInRow: 2,
    wrapTiles: true
  };
  PanelTiles_PanelTiles.propTypes = {
    children: prop_types_default.a.node,
    className: prop_types_default.a.string,
    tileClassName: prop_types_default.a.string,
    tiles: prop_types_default.a.arrayOf(prop_types_default.a.node),
    tilesInRow: prop_types_default.a.oneOf(PANEL_TILE_OPTIONS_ARRAY),
    wrapTiles: prop_types_default.a.bool
  }; // CONCATENATED MODULE: ./lib/Panel/Panel.jsx

  var Panel_excluded = ["children", "className", "clearPaddingBoth", "clearPaddingBottom", "clearPaddingTop", "loading"];

  var Panel_Panel = function Panel(_ref) {
    var children = _ref.children,
        className = _ref.className,
        clearPaddingBoth = _ref.clearPaddingBoth,
        clearPaddingBottom = _ref.clearPaddingBottom,
        clearPaddingTop = _ref.clearPaddingTop,
        loading = _ref.loading,
        rest = objectWithoutProperties_default()(_ref, Panel_excluded);
    var classNames = classnames_default()('sage-panel', className, {
      'sage-panel--clear-padding-top': clearPaddingTop,
      'sage-panel--clear-padding-bottom': clearPaddingBottom,
      'sage-panel--clear-padding-both': clearPaddingBoth
    });
    return /*#__PURE__*/external_react_default.a.createElement("div", extends_default()({
      className: classNames
    }, rest), loading ? /*#__PURE__*/external_react_default.a.createElement(Loader_Loader, {
      loading: true,
      fillSpace: true,
      type: Loader_Loader.TYPES.SPINNER
    }) : children);
  };

  Panel_Panel.Block = PanelBlock_PanelBlock;
  Panel_Panel.Divider = PanelDivider_PanelDivider;
  Panel_Panel.Figure = PanelFigure_PanelFigure;
  Panel_Panel.Footer = PanelFooter_PanelFooter;
  Panel_Panel.Header = PanelHeader_PanelHeader;
  Panel_Panel.List = PanelList_PanelList;
  Panel_Panel.ListItem = PanelListItem_PanelListItem;
  Panel_Panel.Row = PanelRow_PanelRow;
  Panel_Panel.Stack = PanelStack_PanelStack;
  Panel_Panel.Subheader = PanelSubheader_PanelSubheader;
  Panel_Panel.Subtext = PanelSubtext_PanelSubtext;
  Panel_Panel.Subtitle = PanelSubtitle_PanelSubtitle;
  Panel_Panel.Tile = PanelTile_PanelTile;
  Panel_Panel.Tiles = PanelTiles_PanelTiles;
  Panel_Panel.Title = PanelTitle_PanelTitle;
  Panel_Panel.defaultProps = {
    children: null,
    className: null,
    clearPaddingBoth: false,
    clearPaddingBottom: false,
    clearPaddingTop: false,
    loading: false
  };
  Panel_Panel.propTypes = {
    children: prop_types_default.a.node,
    className: prop_types_default.a.string,
    clearPaddingBoth: prop_types_default.a.bool,
    clearPaddingBottom: prop_types_default.a.bool,
    clearPaddingTop: prop_types_default.a.bool,
    loading: prop_types_default.a.bool
  }; // CONCATENATED MODULE: ./lib/Panel/index.js
  // CONCATENATED MODULE: ./lib/FormSection/FormSection.jsx

  var FormSection_excluded = ["children", "subtitle", "title"];

  var FormSection_FormSection = function FormSection(_ref) {
    var children = _ref.children,
        subtitle = _ref.subtitle,
        title = _ref.title,
        rest = objectWithoutProperties_default()(_ref, FormSection_excluded);
    return /*#__PURE__*/external_react_default.a.createElement(Grid_Grid, extends_default()({
      className: "sage-form-section"
    }, rest), /*#__PURE__*/external_react_default.a.createElement(Grid_Grid.Row, null, /*#__PURE__*/external_react_default.a.createElement(Grid_Grid.Col, {
      size: 4,
      small: 12,
      large: 4
    }, /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-form-section__info"
    }, /*#__PURE__*/external_react_default.a.createElement("h3", {
      className: "sage-form-section__title"
    }, title), subtitle && /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-form-section__subtitle"
    }, subtitle))), /*#__PURE__*/external_react_default.a.createElement(Grid_Grid.Col, {
      size: 8,
      small: 12,
      large: 8
    }, /*#__PURE__*/external_react_default.a.createElement(Panel_Panel, null, /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-form-section__content"
    }, children)))));
  };

  FormSection_FormSection.defaultProps = {
    children: null,
    subtitle: null
  };
  FormSection_FormSection.propTypes = {
    children: prop_types_default.a.node,
    subtitle: prop_types_default.a.node,
    title: prop_types_default.a.string.isRequired
  }; // CONCATENATED MODULE: ./lib/FormSection/index.js
  // CONCATENATED MODULE: ./lib/Frame/configs.js
  // Keep in sync with `packages/sage-assets/lib/stylesheets/components/_frame.scss`

  var FRAME_ALIGNMENTS = {
    TOP_LEFT: 'top-left',
    TOP_CENTER: 'top-center',
    TOP_RIGHT: 'top-right',
    CENTER_LEFT: 'center-left',
    CENTER_CENTER: 'center',
    CENTER_RIGHT: 'center-right',
    BASELINE_LEFT: 'baseline-left',
    BASELINE_CENTER: 'baseline-center',
    BASELINE_RIGHT: 'baseline-right',
    BOTTOM_LEFT: 'bottom-left',
    BOTTOM_CENTER: 'bottom-center',
    BOTTOM_RIGHT: 'bottom-right',
    START_SPREAD: 'start-spread',
    CENTER_SPREAD: 'center-spread',
    END_SPREAD: 'end-spread',
    STRETCH_LEFT: 'stretch-left',
    STRETCH_CENTER: 'stretch-center',
    STRETCH_RIGHT: 'stretch-right',
    STRETCH_SPREAD: 'stretch-spread',
    SPREAD_STRETCH: 'spread-stretch'
  }; // Keep in sync with `packages/sage-assets/lib/stylesheets/components/_frame.scss`

  var FRAME_BORDERS = {
    NONE: 'none',
    DEFAULT: 'default'
  }; // Keep in sync with `packages/sage-assets/lib/stylesheets/components/_frame.scss`

  var FRAME_BORDER_RADII = {
    NONE: 'none',
    SM: 'sm',
    MD: 'md',
    LG: 'lg'
  }; // Keep in sync with `packages/sage-assets/lib/stylesheets/components/_frame.scss`

  var FRAME_DIRECTIONS = {
    VERTICAL: 'vertical',
    HORIZONTAL: 'horizontal'
  }; // Keep in sync with `packages/sage-assets/lib/stylesheets/components/_frame.scss`

  var FRAME_SPACINGS = Object.assign(SageTokens.SPACERS, {
    NONE: 'none'
  }); // Keep in sync with `packages/sage-assets/lib/stylesheets/components/_frame.scss`

  var FRAME_WIDTHS = {
    HUG: 'hug',
    FILL: 'fill',
    FLEX: 'flex',
    INITIAL: 'initial'
  }; // Keep in sync with `packages/sage-assets/lib/stylesheets/components/_frame.scss`

  var FRAME_WRAPS = {
    NONE: 'nowrap',
    WRAP: 'wrap'
  }; // CONCATENATED MODULE: ./lib/Frame/Frame.jsx

  var Frame_excluded = ["children", "className", "align", "background", "border", "borderRadius", "direction", "gap", "maxWidth", "minWidth", "padding", "tag", "width", "widthRatio", "wrap"];

  var Frame_Frame = function Frame(_ref) {
    var _classnames;

    var children = _ref.children,
        className = _ref.className,
        align = _ref.align,
        background = _ref.background,
        border = _ref.border,
        borderRadius = _ref.borderRadius,
        direction = _ref.direction,
        gap = _ref.gap,
        maxWidth = _ref.maxWidth,
        minWidth = _ref.minWidth,
        padding = _ref.padding,
        tag = _ref.tag,
        width = _ref.width,
        widthRatio = _ref.widthRatio,
        wrap = _ref.wrap,
        rest = objectWithoutProperties_default()(_ref, Frame_excluded);
    var Tag = tag;
    var hasCustomBackground = background && !Object.values(SageTokens.COLOR_SLIDERS).includes(background);
    var hasCustomWidth = width && !Object.values(FRAME_WIDTHS).includes(width);
    var hasCustomMaxWidth = maxWidth && !Object.values(FRAME_WIDTHS).includes(maxWidth);
    var hasCustomMinWidth = minWidth && !Object.values(FRAME_WIDTHS).includes(minWidth);
    var classNames = classnames_default()('sage-frame', className, (_classnames = {}, defineProperty_default()(_classnames, "sage-frame--align-".concat(align), align), defineProperty_default()(_classnames, 'sage-frame--background-custom', hasCustomBackground), defineProperty_default()(_classnames, "sage-frame--background-".concat(background), background && !hasCustomBackground), defineProperty_default()(_classnames, "sage-frame--border-".concat(border), border), defineProperty_default()(_classnames, "sage-frame--border-radius-".concat(borderRadius), borderRadius), defineProperty_default()(_classnames, "sage-frame--direction-".concat(direction), direction), defineProperty_default()(_classnames, "sage-frame--gap-".concat(gap), gap), defineProperty_default()(_classnames, "sage-frame--padding-".concat(padding), padding), defineProperty_default()(_classnames, 'sage-frame--width-custom', hasCustomWidth), defineProperty_default()(_classnames, "sage-frame--width-".concat(width), width && !hasCustomWidth), defineProperty_default()(_classnames, 'sage-frame--max-width-custom', hasCustomMaxWidth), defineProperty_default()(_classnames, "sage-frame--max-width-".concat(maxWidth), maxWidth && !hasCustomMaxWidth), defineProperty_default()(_classnames, 'sage-frame--min-width-custom', hasCustomMinWidth), defineProperty_default()(_classnames, "sage-frame--min-width-".concat(minWidth), minWidth && !hasCustomMinWidth), defineProperty_default()(_classnames, "sage-frame--wrap-".concat(wrap), wrap), _classnames));
    var style = rest.style;
    var styles = style || {};

    if (width && !Object.values(FRAME_WIDTHS).includes(width)) {
      styles['--sage-frame-width'] = width;
    }

    if (hasCustomMaxWidth) {
      styles['--sage-frame-max-width'] = maxWidth;
    }

    if (hasCustomMinWidth) {
      styles['--sage-frame-min-width'] = minWidth;
    }

    if (hasCustomBackground) {
      styles['--sage-frame-background'] = background;
    }

    if (widthRatio) {
      styles.flex = widthRatio;
    }

    return /*#__PURE__*/external_react_default.a.createElement(Tag, extends_default()({
      className: classNames
    }, rest, {
      style: styles
    }), children);
  };

  Frame_Frame.ALIGNMENTS = FRAME_ALIGNMENTS;
  Frame_Frame.BORDERS = FRAME_BORDERS;
  Frame_Frame.BORDER_RADII = FRAME_BORDER_RADII;
  Frame_Frame.DIRECTIONS = FRAME_DIRECTIONS;
  Frame_Frame.GAPS = FRAME_SPACINGS;
  Frame_Frame.PADDINGS = FRAME_SPACINGS;
  Frame_Frame.WIDTHS = FRAME_WIDTHS;
  Frame_Frame.WRAPS = FRAME_WRAPS;
  Frame_Frame.defaultProps = {
    align: null,
    background: null,
    border: null,
    borderRadius: null,
    children: null,
    className: '',
    direction: FRAME_DIRECTIONS.VERTICAL,
    gap: FRAME_SPACINGS.MD,
    maxWidth: null,
    minWidth: null,
    padding: null,
    tag: 'div',
    width: null,
    widthRatio: null,
    wrap: null
  };
  Frame_Frame.propTypes = {
    children: prop_types_default.a.node,
    className: prop_types_default.a.string,
    align: prop_types_default.a.oneOf(Object.values(FRAME_ALIGNMENTS)),
    background: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.oneOf(Object.values(SageTokens.COLOR_SLIDERS))]),
    border: prop_types_default.a.oneOf(Object.values(Frame_Frame.BORDERS)),
    borderRadius: prop_types_default.a.oneOf(Object.values(Frame_Frame.BORDER_RADII)),
    direction: prop_types_default.a.oneOf(Object.values(Frame_Frame.DIRECTIONS)),
    gap: prop_types_default.a.oneOf(Object.values(Frame_Frame.GAPS)),
    maxWidth: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.oneOf(Object.values(Frame_Frame.WIDTHS))]),
    minWidth: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.oneOf(Object.values(Frame_Frame.WIDTHS))]),
    padding: prop_types_default.a.oneOf(Object.values(Frame_Frame.PADDINGS)),
    tag: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.elementType]),
    width: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.oneOf(Object.values(Frame_Frame.WIDTHS))]),
    widthRatio: prop_types_default.a.string,
    wrap: prop_types_default.a.oneOf(Object.values(Frame_Frame.WRAPS))
  }; // CONCATENATED MODULE: ./lib/Frame/index.js
  // CONCATENATED MODULE: ./lib/HelpLink/HelpLink.jsx

  var HelpLink_excluded = ["className", "children", "labelIsVisible", "linkTag"];

  var HelpLink_HelpLink = function HelpLink(_ref) {
    var className = _ref.className,
        children = _ref.children,
        labelIsVisible = _ref.labelIsVisible,
        linkTag = _ref.linkTag,
        rest = objectWithoutProperties_default()(_ref, HelpLink_excluded);
    return /*#__PURE__*/external_react_default.a.createElement(Link_Link, extends_default()({
      className: "".concat(labelIsVisible ? 'sage-link sage-link--help' : 'sage-link sage-link--help-icon-only', " ").concat(className || ''),
      suppressDefaultClass: true,
      tag: linkTag
    }, rest), !labelIsVisible ? /*#__PURE__*/external_react_default.a.createElement("span", {
      className: "visually-hidden"
    }, children) : children);
  };

  HelpLink_HelpLink.defaultProps = {
    children: /*#__PURE__*/external_react_default.a.createElement(external_react_default.a.Fragment, null, "Learn more"),
    className: '',
    labelIsVisible: false,
    linkTag: null
  };
  HelpLink_HelpLink.propTypes = {
    children: prop_types_default.a.node,
    className: prop_types_default.a.string,
    labelIsVisible: prop_types_default.a.bool,
    linkTag: Link_Link.tagPropTypes
  }; // CONCATENATED MODULE: ./lib/HelpLink/index.js
  // CONCATENATED MODULE: ./lib/Hero/configs.js

  var HERO_SIZES = {
    SMALL: 'small',
    LARGE: 'large'
  }; // CONCATENATED MODULE: ./lib/Hero/Hero.jsx

  var Hero_excluded = ["children", "ctaAttributes", "description", "branding", "footerActions", "image", "heroSize", "title", "titleTag"];

  var Hero_Hero = function Hero(_ref) {
    var children = _ref.children,
        ctaAttributes = _ref.ctaAttributes,
        description = _ref.description,
        branding = _ref.branding,
        footerActions = _ref.footerActions,
        image = _ref.image,
        heroSize = _ref.heroSize,
        title = _ref.title,
        titleTag = _ref.titleTag,
        rest = objectWithoutProperties_default()(_ref, Hero_excluded);
    var className = classnames_default()('sage-hero', defineProperty_default()({}, "sage-hero--".concat(heroSize), heroSize));
    var TitleTag = titleTag || 'h2';
    var renderArtwork = /*#__PURE__*/external_react_default.a.createElement("span", {
      className: "sage-hero__artwork-image-container"
    }, /*#__PURE__*/external_react_default.a.createElement("img", {
      className: "sage-hero__artwork-image",
      src: image.src,
      alt: image.alt || ''
    }));
    return /*#__PURE__*/external_react_default.a.createElement("article", extends_default()({
      className: className
    }, rest), /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-hero__container"
    }, /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-hero__header"
    }, branding && /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-hero__branding"
    }, branding), title && /*#__PURE__*/external_react_default.a.createElement(TitleTag, {
      className: "sage-hero__title"
    }, title)), /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-hero__body"
    }, description && /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-hero__description"
    }, description), footerActions && /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-hero__footer-actions"
    }, /*#__PURE__*/external_react_default.a.createElement(Button.Group, {
      gap: "sm"
    }, footerActions)))), ctaAttributes ? /*#__PURE__*/external_react_default.a.createElement("a", extends_default()({
      className: "sage-hero__artwork sage-hero__artwork--cta"
    }, ctaAttributes), renderArtwork) : /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-hero__artwork"
    }, renderArtwork), children);
  };

  Hero_Hero.Sizes = HERO_SIZES;
  Hero_Hero.defaultProps = {
    branding: null,
    ctaAttributes: null,
    children: null,
    description: null,
    footerActions: null,
    image: {
      alt: null,
      src: null
    },
    heroSize: Hero_Hero.Sizes.LARGE,
    title: null,
    titleTag: 'h2'
  };
  Hero_Hero.propTypes = {
    branding: prop_types_default.a.node,
    ctaAttributes: prop_types_default.a.node,
    children: prop_types_default.a.node,
    description: prop_types_default.a.string,
    footerActions: prop_types_default.a.node,
    image: prop_types_default.a.shape({
      alt: prop_types_default.a.string,
      src: prop_types_default.a.string
    }),
    heroSize: prop_types_default.a.oneOf(Hero_Hero.Sizes),
    title: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.node]),
    titleTag: prop_types_default.a.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6'])
  }; // CONCATENATED MODULE: ./lib/Hero/index.js
  // CONCATENATED MODULE: ./lib/Hint/Hint.jsx

  var Hint_excluded = ["className", "content", "icon"];

  var Hint_Hint = function Hint(_ref) {
    var className = _ref.className,
        content = _ref.content,
        icon = _ref.icon,
        rest = objectWithoutProperties_default()(_ref, Hint_excluded);
    var classNames = classnames_default()('sage-hint', className);
    return /*#__PURE__*/external_react_default.a.createElement("div", extends_default()({
      className: classNames
    }, rest), icon && /*#__PURE__*/external_react_default.a.createElement(Icon_Icon, {
      className: "sage-hint__icon",
      icon: icon
    }), /*#__PURE__*/external_react_default.a.createElement("span", {
      className: "sage-hint__content"
    }, content));
  };

  Hint_Hint.defaultProps = {
    className: '',
    icon: null
  };
  Hint_Hint.propTypes = {
    className: prop_types_default.a.string,
    content: prop_types_default.a.string.isRequired,
    icon: prop_types_default.a.oneOf(Object.values(SageTokens.ICONS))
  }; // CONCATENATED MODULE: ./lib/Hint/index.js
  // CONCATENATED MODULE: ./lib/IconCard/IconCard.jsx

  var IconCard_excluded = ["className", "color", "icon", "label", "round", "size"];

  function IconCard_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function IconCard_objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? IconCard_ownKeys(Object(source), !0).forEach(function (key) {
        defineProperty_default()(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : IconCard_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }

    return target;
  }

  var IconCard_IconCard = function IconCard(_ref) {
    var _classnames;

    var className = _ref.className,
        color = _ref.color,
        icon = _ref.icon,
        label = _ref.label,
        round = _ref.round,
        size = _ref.size,
        rest = objectWithoutProperties_default()(_ref, IconCard_excluded);
    var classNames = classnames_default()('sage-icon-card', className, (_classnames = {}, defineProperty_default()(_classnames, "sage-icon-card--".concat(color), color), defineProperty_default()(_classnames, 'sage-icon-card--round', round), _classnames));
    return /*#__PURE__*/external_react_default.a.createElement("div", extends_default()({
      className: classNames
    }, rest), /*#__PURE__*/external_react_default.a.createElement(Icon_Icon, {
      icon: icon,
      size: size,
      label: label
    }));
  };

  IconCard_IconCard.COLORS = IconCard_objectSpread({}, Label.COLORS);
  IconCard_IconCard.ICONS = IconCard_objectSpread({}, SageTokens.ICONS);
  IconCard_IconCard.SIZES = IconCard_objectSpread({}, Icon_Icon.SIZES);
  IconCard_IconCard.defaultProps = {
    className: null,
    color: Label.COLORS.DRAFT,
    label: null,
    round: false,
    size: Icon_Icon.SIZES.XXXL
  };
  IconCard_IconCard.propTypes = {
    className: prop_types_default.a.string,
    color: prop_types_default.a.oneOf(Object.values(Label.COLORS)),
    icon: prop_types_default.a.oneOf(Object.values(SageTokens.ICONS)).isRequired,
    label: prop_types_default.a.string,
    round: prop_types_default.a.bool,
    size: prop_types_default.a.oneOf(Object.values(Icon_Icon.SIZES))
  }; // CONCATENATED MODULE: ./lib/IconCard/index.js
  // CONCATENATED MODULE: ./lib/IconList/configs.js

  var ICON_LIST_ITEM_INPUT_TYPES = {
    RADIO: 'radio',
    CHECKBOX: 'checkbox'
  }; // CONCATENATED MODULE: ./lib/IconList/IconListItemLabel.jsx

  var IconListItemLabel_excluded = ["children", "className", "htmlFor"];

  var IconListItemLabel_IconListItemLabel = function IconListItemLabel(_ref) {
    var children = _ref.children,
        className = _ref.className,
        htmlFor = _ref.htmlFor,
        rest = objectWithoutProperties_default()(_ref, IconListItemLabel_excluded);
    var classNames = classnames_default()('sage-icon-list-item__label', className);
    return /*#__PURE__*/external_react_default.a.createElement("label", extends_default()({
      className: classNames,
      htmlFor: htmlFor
    }, rest), children);
  };

  IconListItemLabel_IconListItemLabel.defaultProps = {
    children: null,
    className: null
  };
  IconListItemLabel_IconListItemLabel.propTypes = {
    children: prop_types_default.a.node,
    className: prop_types_default.a.string,
    htmlFor: prop_types_default.a.string.isRequired
  }; // CONCATENATED MODULE: ./lib/IconList/IconListItemSubtext.jsx

  var IconListItemSubtext_excluded = ["children", "className"];

  var IconListItemSubtext_IconListItemSubtext = function IconListItemSubtext(_ref) {
    var children = _ref.children,
        className = _ref.className,
        rest = objectWithoutProperties_default()(_ref, IconListItemSubtext_excluded);
    var classNames = classnames_default()('sage-icon-list-item__label-subtext', className);
    return /*#__PURE__*/external_react_default.a.createElement("div", extends_default()({
      className: classNames
    }, rest), children);
  };

  IconListItemSubtext_IconListItemSubtext.defaultProps = {
    children: null,
    className: null
  };
  IconListItemSubtext_IconListItemSubtext.propTypes = {
    children: prop_types_default.a.node,
    className: prop_types_default.a.string
  }; // CONCATENATED MODULE: ./lib/IconList/IconListItemTitle.jsx

  var IconListItemTitle_excluded = ["children", "className", "tag"];

  var IconListItemTitle_IconListItemTitle = function IconListItemTitle(_ref) {
    var children = _ref.children,
        className = _ref.className,
        tag = _ref.tag,
        rest = objectWithoutProperties_default()(_ref, IconListItemTitle_excluded);
    var classNames = classnames_default()('sage-icon-list-item__title', className);
    var TagName = tag;
    return /*#__PURE__*/external_react_default.a.createElement(TagName, extends_default()({
      className: classNames
    }, rest), children);
  };

  IconListItemTitle_IconListItemTitle.defaultProps = {
    children: null,
    className: null,
    tag: 'h4'
  };
  IconListItemTitle_IconListItemTitle.propTypes = {
    children: prop_types_default.a.node,
    className: prop_types_default.a.string,
    tag: prop_types_default.a.string
  }; // CONCATENATED MODULE: ./lib/IconList/IconListItem.jsx

  var IconListItem_excluded = ["checked", "children", "className", "icon", "iconColor", "input", "inputId", "inputName", "inputValue", "label", "onChangeInput"];

  var IconListItem_IconListItem = function IconListItem(_ref) {
    var checked = _ref.checked,
        children = _ref.children,
        className = _ref.className,
        icon = _ref.icon,
        iconColor = _ref.iconColor,
        input = _ref.input,
        inputId = _ref.inputId,
        inputName = _ref.inputName,
        inputValue = _ref.inputValue,
        label = _ref.label,
        onChangeInput = _ref.onChangeInput,
        rest = objectWithoutProperties_default()(_ref, IconListItem_excluded);
    var classNames = classnames_default()('sage-icon-list-item', className);
    var bulletContents = null;

    if (input) {
      switch (input) {
        case 'radio':
          bulletContents = /*#__PURE__*/external_react_default.a.createElement(Radio_Radio, {
            id: inputId,
            name: inputName,
            standalone: true,
            value: inputValue,
            checked: checked,
            onChange: onChangeInput,
            label: label
          });
          break;

        case 'checkbox':
          bulletContents = /*#__PURE__*/external_react_default.a.createElement(Checkbox_Checkbox, {
            id: inputId,
            name: inputName,
            standalone: true,
            value: inputValue,
            checked: checked,
            onChange: onChangeInput,
            label: label
          });
          break;

        default:
          bulletContents = null;
          break;
      }
    } else if (icon) {
      bulletContents = /*#__PURE__*/external_react_default.a.createElement(Icon_Icon, {
        icon: icon,
        size: Icon_Icon.SIZES.LG,
        color: iconColor,
        label: label
      });
    }

    return /*#__PURE__*/external_react_default.a.createElement("li", extends_default()({
      className: classNames
    }, rest), /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-icon-list-item__bullet ".concat(input ? "sage-icon-list-item__bullet--".concat(input) : '')
    }, bulletContents), /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-icon-list-item__body"
    }, children));
  };

  IconListItem_IconListItem.Label = IconListItemLabel_IconListItemLabel;
  IconListItem_IconListItem.Subtext = IconListItemSubtext_IconListItemSubtext;
  IconListItem_IconListItem.Title = IconListItemTitle_IconListItemTitle;
  IconListItem_IconListItem.INPUT_TYPES = ICON_LIST_ITEM_INPUT_TYPES;
  IconListItem_IconListItem.defaultProps = {
    checked: false,
    children: null,
    className: null,
    icon: null,
    iconColor: Icon_Icon.COLORS.CHARCOAL_100,
    input: null,
    inputId: null,
    inputName: null,
    inputValue: null,
    label: null,
    onChangeInput: function onChangeInput(val) {
      return val;
    }
  };
  IconListItem_IconListItem.propTypes = {
    checked: prop_types_default.a.bool,
    children: prop_types_default.a.node,
    className: prop_types_default.a.string,
    icon: prop_types_default.a.oneOf(Object.values(Icon_Icon.ICONS)),
    iconColor: prop_types_default.a.oneOf(Object.values(Icon_Icon.COLORS)),
    input: prop_types_default.a.oneOf(Object.values(ICON_LIST_ITEM_INPUT_TYPES)),
    inputId: prop_types_default.a.string,
    inputName: prop_types_default.a.string,
    inputValue: prop_types_default.a.string,
    label: prop_types_default.a.string,
    onChangeInput: prop_types_default.a.func
  }; // CONCATENATED MODULE: ./lib/IconList/IconList.jsx

  var IconList_excluded = ["children", "className"];

  var IconList_IconList = function IconList(_ref) {
    var children = _ref.children,
        className = _ref.className,
        rest = objectWithoutProperties_default()(_ref, IconList_excluded);
    var classNames = classnames_default()('sage-icon-list', className);
    return /*#__PURE__*/external_react_default.a.createElement("ul", extends_default()({
      className: classNames
    }, rest), children);
  };

  IconList_IconList.Item = IconListItem_IconListItem;
  IconList_IconList.ItemLabel = IconListItemLabel_IconListItemLabel;
  IconList_IconList.ItemSubtext = IconListItemSubtext_IconListItemSubtext;
  IconList_IconList.ItemTitle = IconListItemTitle_IconListItemTitle;
  IconList_IconList.defaultProps = {
    children: null,
    className: null
  };
  IconList_IconList.propTypes = {
    children: prop_types_default.a.node,
    className: prop_types_default.a.string
  }; // CONCATENATED MODULE: ./lib/IconList/index.js
  // CONCATENATED MODULE: ./lib/Input/configs.js

  var INPUT_MODE = {
    DEFAULT: null,
    NUMBERIC: 'numeric',
    TEXT: 'text'
  };
  var INPUT_TYPE = {
    DEFAULT: null,
    EMAIL: 'email',
    NUMBER: 'number',
    PASSWORD: 'password',
    TEXT: 'text'
  }; // CONCATENATED MODULE: ./lib/Input/Input.jsx

  var Input_excluded = ["autocomplete", "className", "disabled", "hasError", "hasPlaceholder", "hideLabel", "icon", "id", "inputMode", "inputType", "label", "max", "maxLength", "message", "min", "minLength", "name", "onChange", "pattern", "placeholder", "popover", "prefix", "readonly", "required", "standalone", "step", "suffix", "value"];

  function Input_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function Input_objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? Input_ownKeys(Object(source), !0).forEach(function (key) {
        defineProperty_default()(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Input_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }

    return target;
  }

  var Input_Input = function Input(_ref) {
    var autocomplete = _ref.autocomplete,
        className = _ref.className,
        disabled = _ref.disabled,
        hasError = _ref.hasError,
        hasPlaceholder = _ref.hasPlaceholder,
        hideLabel = _ref.hideLabel,
        icon = _ref.icon,
        id = _ref.id,
        inputMode = _ref.inputMode,
        inputType = _ref.inputType,
        label = _ref.label,
        max = _ref.max,
        maxLength = _ref.maxLength,
        message = _ref.message,
        min = _ref.min,
        minLength = _ref.minLength,
        name = _ref.name,
        onChange = _ref.onChange,
        pattern = _ref.pattern,
        placeholder = _ref.placeholder,
        popover = _ref.popover,
        prefix = _ref.prefix,
        readonly = _ref.readonly,
        required = _ref.required,
        standalone = _ref.standalone,
        step = _ref.step,
        suffix = _ref.suffix,
        value = _ref.value,
        rest = objectWithoutProperties_default()(_ref, Input_excluded);
    var inputPaddingOffset = 16;

    var _useState = Object(external_react_["useState"])(null),
        _useState2 = slicedToArray_default()(_useState, 2),
        fieldValue = _useState2[0],
        updateFieldValue = _useState2[1];

    var _useState3 = Object(external_react_["useState"])(rest.style || {}),
        _useState4 = slicedToArray_default()(_useState3, 2),
        inputStyles = _useState4[0],
        updateStyles = _useState4[1];

    var classNames = classnames_default()('sage-input', className, {
      'sage-form-field--error': hasError,
      'sage-input--prefixed': prefix,
      'sage-input--suffixed': suffix,
      'sage-input--standalone': standalone,
      'sage-input--has-icon': icon,
      'sage-input--has-popover': popover
    });
    var prefixRef = Object(external_react_["useRef"])(null);
    var suffixRef = Object(external_react_["useRef"])(null);

    var handleChange = function handleChange(e) {
      if (onChange) {
        onChange(e);
      } else {
        updateFieldValue(e.target.value);
      }
    };

    var labelClassnames = classnames_default()('sage-input__label', className, {
      'visually-hidden': hideLabel
    });

    var setPlaceholder = function setPlaceholder() {
      if (placeholder) {
        return placeholder;
      }

      return label;
    };

    Object(external_react_["useEffect"])(function () {
      var newInputStyles = Input_objectSpread(Input_objectSpread({}, inputStyles), {}, {
        paddingLeft: inputPaddingOffset,
        paddingRight: inputPaddingOffset
      });
      var affixUpdatesNeeded = false;

      if (prefix) {
        newInputStyles.paddingLeft = inputPaddingOffset + prefixRef.current.offsetWidth;
        affixUpdatesNeeded = true;
      }

      if (suffix) {
        newInputStyles.paddingRight = inputPaddingOffset + suffixRef.current.offsetWidth;
        affixUpdatesNeeded = true;
      }

      if (affixUpdatesNeeded) {
        updateStyles(newInputStyles);
      }
    }, [prefix, suffix]);
    return /*#__PURE__*/external_react_default.a.createElement("div", {
      className: classNames
    }, /*#__PURE__*/external_react_default.a.createElement("input", extends_default()({
      autoComplete: autocomplete,
      className: "sage-form-field sage-input__field",
      disabled: disabled,
      id: id,
      inputMode: inputMode,
      type: inputType,
      max: max,
      maxLength: maxLength,
      min: min,
      minLength: minLength,
      name: name,
      onChange: handleChange,
      pattern: pattern,
      placeholder: setPlaceholder(),
      readOnly: readonly,
      required: required,
      step: step,
      style: inputStyles,
      value: fieldValue || value
    }, rest)), label && /*#__PURE__*/external_react_default.a.createElement("label", {
      htmlFor: id,
      className: labelClassnames
    }, label), prefix && /*#__PURE__*/external_react_default.a.createElement("span", {
      "aria-label": "prefixed with ".concat(prefix),
      className: "sage-input__affix sage-input__affix--prefix",
      ref: prefixRef
    }, /*#__PURE__*/external_react_default.a.createElement("span", {
      className: "sage-input__affix-value"
    }, prefix)), suffix && /*#__PURE__*/external_react_default.a.createElement("span", {
      "aria-label": "suffixed with ".concat(suffix),
      className: "sage-input__affix sage-input__affix--suffix",
      ref: suffixRef
    }, /*#__PURE__*/external_react_default.a.createElement("span", {
      className: "sage-input__affix-value"
    }, suffix)), icon && /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-input__icon"
    }, /*#__PURE__*/external_react_default.a.createElement(Icon_Icon, {
      icon: icon
    })), message && /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-input__info"
    }, /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-input__message"
    }, message)), popover);
  };

  Input_Input.Mode = INPUT_MODE;
  Input_Input.Type = INPUT_TYPE;
  Input_Input.defaultProps = {
    autocomplete: null,
    className: null,
    disabled: false,
    hasError: false,
    hasPlaceholder: false,
    hideLabel: false,
    icon: null,
    inputMode: null,
    inputType: null,
    label: null,
    max: null,
    maxLength: null,
    message: null,
    min: null,
    minLength: null,
    name: null,
    onChange: null,
    pattern: null,
    placeholder: null,
    popover: null,
    prefix: null,
    readonly: false,
    required: false,
    standalone: false,
    step: null,
    suffix: null,
    value: ''
  };
  Input_Input.propTypes = {
    autocomplete: prop_types_default.a.string,
    className: prop_types_default.a.string,
    disabled: prop_types_default.a.bool,
    icon: prop_types_default.a.oneOf(Object.values(SageTokens.ICONS)),
    id: prop_types_default.a.string.isRequired,
    hasError: prop_types_default.a.bool,
    hasPlaceholder: prop_types_default.a.bool,
    hideLabel: prop_types_default.a.bool,
    inputMode: prop_types_default.a.oneOf(Object.values(Input_Input.Mode)),
    inputType: prop_types_default.a.oneOf(Object.values(Input_Input.Type)),
    label: prop_types_default.a.string,
    max: prop_types_default.a.string,
    maxLength: prop_types_default.a.string,
    min: prop_types_default.a.string,
    minLength: prop_types_default.a.string,
    message: prop_types_default.a.string,
    name: prop_types_default.a.string,
    onChange: prop_types_default.a.func,
    pattern: prop_types_default.a.string,
    placeholder: prop_types_default.a.string,
    popover: prop_types_default.a.node,
    prefix: prop_types_default.a.string,
    readonly: prop_types_default.a.bool,
    required: prop_types_default.a.bool,
    standalone: prop_types_default.a.bool,
    step: prop_types_default.a.string,
    suffix: prop_types_default.a.string,
    value: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number])
  }; // CONCATENATED MODULE: ./lib/Input/index.js
  // EXTERNAL MODULE: /__w/sage-lib/sage-lib/node_modules/react-sortablejs/dist/index.js

  var dist = __webpack_require__(10); // CONCATENATED MODULE: ./lib/List/ListItem.jsx


  function ListItem_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function ListItem_objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ListItem_ownKeys(Object(source), !0).forEach(function (key) {
        defineProperty_default()(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ListItem_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }

    return target;
  }

  var ListItem_ListItem = function ListItem(_ref) {
    var children = _ref.children,
        className = _ref.className,
        id = _ref.id,
        moreActions = _ref.moreActions,
        sortable = _ref.sortable;
    var classNames = classnames_default()('sage-list__item', className, {
      'sage-list__item--sortable': sortable
    });
    return /*#__PURE__*/external_react_default.a.createElement("li", {
      className: classNames,
      id: id
    }, sortable && /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-list__item-sortable-handle"
    }, /*#__PURE__*/external_react_default.a.createElement(Icon_Icon, {
      icon: Icon_Icon.ICONS.HANDLE_2_VERTICAL,
      label: "Drag to sort"
    })), /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-list__item-content"
    }, children), moreActions && /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-list__item-more-actions"
    }, /*#__PURE__*/external_react_default.a.createElement(OptionsDropdown_OptionsDropdown, extends_default()({
      align: Dropdown_Dropdown.POSITIONS.RIGHT
    }, moreActions))));
  };

  ListItem_ListItem.defaultProps = {
    children: null,
    className: null,
    id: null,
    moreActions: null,
    sortable: false
  };
  ListItem_ListItem.propTypes = {
    children: prop_types_default.a.node,
    className: prop_types_default.a.string,
    id: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]),
    moreActions: prop_types_default.a.shape(ListItem_objectSpread({}, OptionsDropdown_OptionsDropdown.propTypes)),
    sortable: prop_types_default.a.bool
  }; // CONCATENATED MODULE: ./lib/List/configs.js

  var LIST_DRAG_HANDLE_TYPES = {
    DEFAULT: 'default',
    ROW: 'row'
  }; // CONCATENATED MODULE: ./lib/List/List.jsx

  var List_excluded = ["id"];

  function List_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function List_objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? List_ownKeys(Object(source), !0).forEach(function (key) {
        defineProperty_default()(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : List_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }

    return target;
  }

  var List_List = function List(_ref) {
    var children = _ref.children,
        className = _ref.className,
        dragHandleType = _ref.dragHandleType,
        items = _ref.items,
        itemRenderer = _ref.itemRenderer,
        _onEnd = _ref.onEnd,
        _onStart = _ref.onStart,
        setList = _ref.setList,
        sortable = _ref.sortable,
        tag = _ref.tag;
    var classNames = classnames_default()('sage-list', className, {
      'sage-list--sortable': sortable,
      'sage-list--draggable-by-row': dragHandleType === LIST_DRAG_HANDLE_TYPES.ROW
    });
    var draggingClassname = 'sage-list--sortable-dragging';

    var renderItems = function renderItems() {
      if (children) {
        return children;
      }

      return /*#__PURE__*/external_react_default.a.createElement(external_react_default.a.Fragment, null, items.map(function (_ref2) {
        var id = _ref2.id,
            rest = objectWithoutProperties_default()(_ref2, List_excluded);
        return /*#__PURE__*/external_react_default.a.createElement(ListItem_ListItem, extends_default()({
          key: id,
          sortable: sortable
        }, rest), itemRenderer && itemRenderer(List_objectSpread({
          id: id
        }, rest)));
      }));
    };

    var Tag = sortable ? 'ol' : 'ul';
    Tag = tag || Tag;
    return sortable ? /*#__PURE__*/external_react_default.a.createElement(dist["ReactSortable"], {
      chosenClass: "sage-list__item--sortable-active",
      className: classNames,
      dragClass: "sage-list__item--sortable-drag"
      /*
        NOTE: This is added because Safari 13+ has a draggable api bug.
        Yet we allow the user to override if desired.
        https://github.com/SortableJS/Sortable/issues/1571
      */
      ,
      forceFallback: true,
      ghostClass: "sage-list__item--sortable-ghost",
      handle: dragHandleType === List.DRAG_HANDLE_TYPES.ROW ? false : '.sage-list__item-sortable-handle',
      list: items,
      onEnd: function onEnd(evt) {
        evt.srcElement.classList.remove(draggingClassname);

        if (_onEnd) {
          _onEnd(evt);
        }
      },
      onStart: function onStart(evt) {
        evt.srcElement.classList.add(draggingClassname);

        if (_onStart) {
          _onStart(evt);
        }
      },
      setList: setList,
      tag: Tag
    }, renderItems()) : /*#__PURE__*/external_react_default.a.createElement(Tag, {
      className: classNames
    }, renderItems());
  };

  List_List.Item = ListItem_ListItem;
  List_List.DRAG_HANDLE_TYPES = LIST_DRAG_HANDLE_TYPES;
  List_List.defaultProps = {
    children: null,
    className: null,
    items: [],
    itemRenderer: function itemRenderer() {},
    dragHandleType: List_List.DRAG_HANDLE_TYPES.DEFAULT,
    onEnd: function onEnd() {},
    onStart: function onStart() {},
    setList: function setList() {},
    sortable: false,
    tag: null
  };
  List_List.propTypes = {
    children: prop_types_default.a.node,
    className: prop_types_default.a.string,
    dragHandleType: prop_types_default.a.oneOf(Object.values(List_List.DRAG_HANDLE_TYPES)),
    items: prop_types_default.a.arrayOf(prop_types_default.a.shape(List_objectSpread({}, ListItem_ListItem.propTypes))),
    itemRenderer: prop_types_default.a.func,
    onEnd: prop_types_default.a.func,
    onStart: prop_types_default.a.func,
    setList: prop_types_default.a.func,
    // Same as useState[1]
    sortable: prop_types_default.a.bool,
    tag: prop_types_default.a.oneOf(['ul', 'ol'])
  }; // CONCATENATED MODULE: ./lib/List/index.js
  // CONCATENATED MODULE: ./lib/MediaTile/MediaTile.jsx

  var MediaTile_excluded = ["actionsDropdownItems", "actionsCustom", "caption", "children", "className", "footer", "media", "mediaConfigs", "tileLink", "title", "titleTag"];

  var MediaTile_MediaTile = function MediaTile(_ref) {
    var actionsDropdownItems = _ref.actionsDropdownItems,
        actionsCustom = _ref.actionsCustom,
        caption = _ref.caption,
        children = _ref.children,
        className = _ref.className,
        footer = _ref.footer,
        media = _ref.media,
        mediaConfigs = _ref.mediaConfigs,
        tileLink = _ref.tileLink,
        title = _ref.title,
        titleTag = _ref.titleTag,
        rest = objectWithoutProperties_default()(_ref, MediaTile_excluded);
    var classNames = classnames_default()('sage-media-tile', className, {
      'sage-media-tile--interactive': tileLink
    });
    var TitleTag = titleTag;
    return /*#__PURE__*/external_react_default.a.createElement(Panel_Panel, extends_default()({
      className: classNames
    }, rest), media && /*#__PURE__*/external_react_default.a.createElement(Panel_Panel.Figure, extends_default()({
      bleed: Panel_Panel.Figure.BLEED_OPTIONS.TOP
    }, mediaConfigs, {
      className: "sage-media-tile__media ".concat(mediaConfigs && mediaConfigs.className || '')
    }), media), /*#__PURE__*/external_react_default.a.createElement(Panel_Panel.Stack, {
      className: "sage-media-tile__content"
    }, title && /*#__PURE__*/external_react_default.a.createElement(Panel_Panel.Row, {
      className: "sage-media-tile__header"
    }, /*#__PURE__*/external_react_default.a.createElement(TitleTag, {
      className: "sage-media-tile__title"
    }, tileLink ? /*#__PURE__*/external_react_default.a.createElement(Link_Link, extends_default()({}, tileLink, {
      className: "sage-media-tile__link ".concat(tileLink.classname || ''),
      suppressDefaultClass: true
    }), title) : title), (actionsCustom || actionsDropdownItems) && /*#__PURE__*/external_react_default.a.createElement(Button.Group, {
      gap: Button.Group.GAP_OPTIONS.SM
    }, actionsCustom, actionsDropdownItems && /*#__PURE__*/external_react_default.a.createElement(OptionsDropdown_OptionsDropdown, {
      align: "right",
      options: actionsDropdownItems
    }))), children && /*#__PURE__*/external_react_default.a.createElement(Panel_Panel.Block, {
      className: "sage-media-tile__body"
    }, children), caption && /*#__PURE__*/external_react_default.a.createElement(Panel_Panel.Block, {
      className: "sage-media-tile__caption"
    }, caption)), footer && /*#__PURE__*/external_react_default.a.createElement(Panel_Panel.Footer, {
      className: "sage-media-tile__footer",
      alignSpread: true
    }, footer));
  };

  MediaTile_MediaTile.defaultProps = {
    actionsDropdownItems: null,
    actionsCustom: null,
    caption: null,
    children: null,
    className: '',
    footer: null,
    media: null,
    mediaConfigs: null,
    tileLink: null,
    title: null,
    titleTag: 'h3'
  };
  MediaTile_MediaTile.propTypes = {
    actionsDropdownItems: prop_types_default.a.arrayOf(prop_types_default.a.shape({})),
    // TODO: dropdown itme schema here
    actionsCustom: prop_types_default.a.node,
    caption: prop_types_default.a.node,
    children: prop_types_default.a.node,
    className: prop_types_default.a.string,
    footer: prop_types_default.a.node,
    media: prop_types_default.a.node,
    mediaConfigs: prop_types_default.a.shape(Panel_Panel.Figure.propTypes),
    // TODO: panel figure configs
    tileLink: prop_types_default.a.shape(Link_Link.propTypes),
    title: prop_types_default.a.string,
    titleTag: prop_types_default.a.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6'])
  }; // CONCATENATED MODULE: ./lib/MediaTile/MediaTiles.jsx

  var MediaTiles_excluded = ["children", "className", "items"];

  var MediaTiles_MediaTiles = function MediaTiles(_ref) {
    var children = _ref.children,
        className = _ref.className,
        items = _ref.items,
        rest = objectWithoutProperties_default()(_ref, MediaTiles_excluded);
    var classNames = classnames_default()('sage-media-tile-container', className);
    return /*#__PURE__*/external_react_default.a.createElement(Grid_Grid, extends_default()({
      className: classNames
    }, rest), items.map(function (item) {
      return /*#__PURE__*/external_react_default.a.createElement(MediaTile_MediaTile, extends_default()({
        key: uuid_default()()
      }, item));
    }), children);
  };

  MediaTiles_MediaTiles.defaultProps = {
    children: null,
    className: '',
    items: []
  };
  MediaTiles_MediaTiles.propTypes = {
    children: prop_types_default.a.node,
    className: prop_types_default.a.string,
    items: prop_types_default.a.arrayOf(prop_types_default.a.shape(MediaTile_MediaTile.propTypes))
  }; // CONCATENATED MODULE: ./lib/MediaTile/index.js
  // CONCATENATED MODULE: ./lib/NextBestAction/configs.js

  var NEXT_BEST_ACTION_COLORS = {
    DRAFT: 'draft',
    INFO: 'info',
    SUCCESS: 'success',
    WARNING: 'warning',
    DANGER: 'danger'
  }; // CONCATENATED MODULE: ./lib/NextBestAction/NextBestAction.jsx

  var NextBestAction_NextBestAction = function NextBestAction(_ref) {
    var _classnames;

    var actions = _ref.actions,
        cardColor = _ref.cardColor,
        className = _ref.className,
        description = _ref.description,
        dismissable = _ref.dismissable,
        graphic = _ref.graphic,
        onClickDismiss = _ref.onClickDismiss,
        title = _ref.title;
    var baseClass = 'sage-next-best-action';
    var classNames = classnames_default()(baseClass, className, (_classnames = {}, defineProperty_default()(_classnames, "".concat(baseClass, "--").concat(cardColor), cardColor), defineProperty_default()(_classnames, "".concat(baseClass, "--graphic-on-right"), graphic.onRight), _classnames));
    return /*#__PURE__*/external_react_default.a.createElement("div", {
      className: classNames
    }, graphic.element && /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-next-best-action__graphic"
    }, graphic.element), /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-next-best-action__text"
    }, title && /*#__PURE__*/external_react_default.a.createElement("h3", {
      className: "sage-next-best-action__title"
    }, title), description && /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-next-best-action__description"
    }, description), actions), dismissable && /*#__PURE__*/external_react_default.a.createElement(Button, {
      className: "sage-next-best-action__close",
      icon: "remove",
      iconOnly: true,
      onClick: onClickDismiss,
      subtle: true,
      small: true
    }, "Close"));
  };

  NextBestAction_NextBestAction.COLORS = NEXT_BEST_ACTION_COLORS;
  NextBestAction_NextBestAction.defaultProps = {
    actions: null,
    className: '',
    description: null,
    dismissable: true,
    graphic: {
      element: null,
      onRight: false
    },
    onClickDismiss: null,
    title: ''
  };
  NextBestAction_NextBestAction.propTypes = {
    actions: prop_types_default.a.node,
    cardColor: prop_types_default.a.oneOf(Object.values(NEXT_BEST_ACTION_COLORS)).isRequired,
    className: prop_types_default.a.string,
    description: prop_types_default.a.node,
    dismissable: prop_types_default.a.bool,
    graphic: prop_types_default.a.shape({
      element: prop_types_default.a.node,
      onRight: prop_types_default.a.bool
    }),
    onClickDismiss: prop_types_default.a.func,
    title: prop_types_default.a.string
  }; // CONCATENATED MODULE: ./lib/NextBestAction/index.js
  // CONCATENATED MODULE: ./lib/PageHeading/PageHeading.jsx

  var PageHeading_excluded = ["actions", "breadcrumbs", "className", "children", "help", "image", "introText", "toolbar", "secondaryText"];

  var PageHeading_PageHeading = function PageHeading(_ref) {
    var actions = _ref.actions,
        breadcrumbs = _ref.breadcrumbs,
        className = _ref.className,
        children = _ref.children,
        help = _ref.help,
        image = _ref.image,
        introText = _ref.introText,
        toolbar = _ref.toolbar,
        secondaryText = _ref.secondaryText,
        rest = objectWithoutProperties_default()(_ref, PageHeading_excluded);
    return /*#__PURE__*/external_react_default.a.createElement("div", extends_default()({
      className: classnames_default()('sage-page-heading', className, {
        'sage-page-heading--no-secondary-text': !secondaryText,
        'sage-page-heading--has-image': image.src
      })
    }, rest), breadcrumbs && /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-page-heading__crumbs"
    }, /*#__PURE__*/external_react_default.a.createElement(Breadcrumbs_Breadcrumbs, {
      items: breadcrumbs,
      className: "sage-page-heading__back"
    })), introText && /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-page-heading__intro"
    }, /*#__PURE__*/external_react_default.a.createElement("p", null, introText)), /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-page-heading__title-wrapper"
    }, /*#__PURE__*/external_react_default.a.createElement("h1", {
      className: "sage-page-heading__title"
    }, children), help && /*#__PURE__*/external_react_default.a.createElement(external_react_default.a.Fragment, null, help)), image.src && /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-page-heading__image"
    }, /*#__PURE__*/external_react_default.a.createElement("img", {
      alt: image.alt || '',
      src: image.src
    })), toolbar && /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-page-heading__toolbar"
    }, toolbar), actions && /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-page-heading__actions"
    }, /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-page-heading__actions-inner"
    }, actions)), secondaryText && /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-page-heading__secondary"
    }, secondaryText));
  };

  PageHeading_PageHeading.defaultProps = {
    actions: null,
    breadcrumbs: null,
    className: '',
    help: null,
    image: {},
    introText: null,
    toolbar: null,
    secondaryText: null
  };
  PageHeading_PageHeading.propTypes = {
    actions: prop_types_default.a.node,
    breadcrumbs: prop_types_default.a.arrayOf(Breadcrumbs_Breadcrumbs.itemPropTypes),
    children: prop_types_default.a.node.isRequired,
    className: prop_types_default.a.string,
    help: prop_types_default.a.node,
    image: prop_types_default.a.shape({
      alt: prop_types_default.a.string,
      src: prop_types_default.a.string
    }),
    introText: prop_types_default.a.string,
    secondaryText: prop_types_default.a.string,
    toolbar: prop_types_default.a.node
  }; // CONCATENATED MODULE: ./lib/PageHeading/index.js
  // EXTERNAL MODULE: /__w/sage-lib/sage-lib/node_modules/pluralize/pluralize.js

  var pluralize = __webpack_require__(23);

  var pluralize_default = /*#__PURE__*/__webpack_require__.n(pluralize); // CONCATENATED MODULE: ./lib/Pagination/configs.js


  var PAGINATION_DEFAULT_ITEMS_NOUN = 'Record';
  var PAGINATION_ARIA_LABEL = 'Pagination Navigation';
  var PAGINATION_LABEL_NEXT = 'Next';
  var PAGINATION_LABEL_PREVIOUS = 'Back'; // CONCATENATED MODULE: ./lib/Pagination/PaginationItem.jsx

  var PaginationItem_PaginationItem = function PaginationItem(_ref) {
    var children = _ref.children,
        current = _ref.current,
        disabled = _ref.disabled,
        onClick = _ref.onClick,
        url = _ref.url;
    var classNames = classnames_default()('sage-pagination__page', {
      'sage-pagination__page--current': current,
      'sage-pagination__page--disabled': disabled
    });

    var handleClick = function handleClick(evt) {
      if (onClick) {
        evt.preventDefault();
        onClick();
      }
    };

    var attrs = {};

    if (!url) {
      attrs.role = 'button';
    }

    var Tag = current ? 'span' : 'a';
    return /*#__PURE__*/external_react_default.a.createElement("li", {
      className: "sage-pagination__item"
    }, /*#__PURE__*/external_react_default.a.createElement(Tag, extends_default()({
      "aria-disabled": disabled,
      className: classNames,
      href: url || '#',
      onClick: handleClick,
      "aria-current": current
    }, attrs), /*#__PURE__*/external_react_default.a.createElement("span", {
      className: "sage-pagination__page-text"
    }, children)));
  };

  PaginationItem_PaginationItem.defaultProps = {
    children: null,
    current: false,
    disabled: false,
    onClick: null,
    url: null
  };
  PaginationItem_PaginationItem.propTypes = {
    children: prop_types_default.a.node,
    current: prop_types_default.a.bool,
    disabled: prop_types_default.a.bool,
    onClick: prop_types_default.a.func,
    url: prop_types_default.a.string
  }; // CONCATENATED MODULE: ./lib/Pagination/PaginationItemGap.jsx

  var PaginationItemGap_PaginationItemGap = function PaginationItemGap() {
    return /*#__PURE__*/external_react_default.a.createElement("li", {
      className: "sage-pagination__item"
    }, /*#__PURE__*/external_react_default.a.createElement("span", {
      className: "sage-pagination__gap"
    }, "..."));
  }; // CONCATENATED MODULE: ./lib/Pagination/Pagination.jsx


  var Pagination_Pagination = function Pagination(_ref) {
    var align = _ref.align,
        className = _ref.className,
        currentPage = _ref.currentPage,
        hideCounter = _ref.hideCounter,
        hidePageButtons = _ref.hidePageButtons,
        itemsNoun = _ref.itemsNoun,
        itemsTotalCount = _ref.itemsTotalCount,
        labels = _ref.labels,
        maxPageButtons = _ref.maxPageButtons,
        onClickPage = _ref.onClickPage,
        pageCount = _ref.pageCount,
        pageCountPrefix = _ref.pageCountPrefix,
        pageCountSuffix = _ref.pageCountSuffix,
        pageSize = _ref.pageSize,
        pageURLFn = _ref.pageURLFn; // Get a safe page count:

    var localPageCount;

    switch (true) {
      // We favor `pageCount` if it is a positive value.
      case pageCount > 0:
        localPageCount = pageCount;
        break;
      // Or, if both `itemsTotalCount` and `pageSize` are positive values
      // we can calculate the page count.

      case itemsTotalCount > 0 && pageSize > 0:
        localPageCount = Math.ceil(itemsTotalCount / pageSize);
        break;
      // But if all else fails we set page count to `1` .

      default:
        localPageCount = 1;
        break;
    } // Determine markup properties


    var hasMultiplePages = localPageCount > 1;
    var Tagname = hasMultiplePages ? 'nav' : 'div';
    var attrs = {};

    if (hasMultiplePages) {
      attrs['aria-label'] = PAGINATION_ARIA_LABEL;
      attrs.role = 'pagination';
    }

    var classNames = classnames_default()('sage-pagination', className, defineProperty_default()({
      'sage-pagination--no-counter': !itemsTotalCount || hideCounter
    }, "sage-pagination--align-".concat(align), align));

    var renderPageCount = function renderPageCount() {
      // Do not render page count if no itemsTotalCount is provided.
      if (!itemsTotalCount || hideCounter) {
        return null;
      } // Configure props to use in all cases


      var classNames = classnames_default()('sage-pagination__count', {
        'sage-pagination__count--solo': localPageCount <= 1
      });
      var entryName = pluralize_default()(itemsNoun || PAGINATION_DEFAULT_ITEMS_NOUN, itemsTotalCount); // If we have a page size provided,
      // calculate current numbers and output accordingly

      if (pageSize) {
        var first = pageSize * (currentPage - 1) + 1;
        var last = pageSize * currentPage;
        return /*#__PURE__*/external_react_default.a.createElement("span", {
          className: classNames
        }, pageCountPrefix && /*#__PURE__*/external_react_default.a.createElement("span", {
          className: "sage-pagination__count-prefix"
        }, pageCountPrefix), /*#__PURE__*/external_react_default.a.createElement("strong", null, first), " \u2013 ", /*#__PURE__*/external_react_default.a.createElement("strong", null, last), ' ', " of ", /*#__PURE__*/external_react_default.a.createElement("strong", null, itemsTotalCount), " ", entryName, pageCountSuffix && /*#__PURE__*/external_react_default.a.createElement("span", {
          className: "sage-pagination__count-suffix"
        }, pageCountSuffix));
      } // Default is to show total number of items


      return /*#__PURE__*/external_react_default.a.createElement("span", {
        className: classNames
      }, /*#__PURE__*/external_react_default.a.createElement("strong", null, itemsTotalCount), " ", entryName);
    };

    var handleInteractionProps = function handleInteractionProps(page) {
      var current = page === currentPage;

      if (pageURLFn) {
        return {
          current: current,
          url: pageURLFn(page)
        };
      }

      if (onClickPage) {
        return {
          current: current,
          onClick: function onClick() {
            return onClickPage(page);
          }
        };
      }

      return {
        current: current
      };
    };

    var renderPageItems = function renderPageItems() {
      if (localPageCount < 1 || hidePageButtons) {
        return null;
      }

      var items = [];
      var startPage = 1; // If current page is far enough from start
      // adjust start to center current page in possible buttons

      if (currentPage > maxPageButtons) {
        startPage = currentPage - Math.floor(maxPageButtons / 2);
      } // Or if current page is closer to the end
      // adjust start to be the last few items


      if (currentPage > localPageCount - maxPageButtons) {
        startPage = localPageCount - maxPageButtons;
      } // But, ensure start page is always above 0


      if (startPage < 1) {
        startPage = 1;
      } // Add page 1 and a gap if needed


      if (startPage > 1) {
        items.push( /*#__PURE__*/external_react_default.a.createElement(PaginationItem_PaginationItem, extends_default()({
          key: uuid_default()()
        }, handleInteractionProps(1)), 1));
      }

      if (startPage > 2) {
        items.push( /*#__PURE__*/external_react_default.a.createElement(PaginationItemGap_PaginationItemGap, {
          key: uuid_default()()
        }));
      }

      for (var i = startPage; i <= startPage + maxPageButtons && i <= localPageCount; i += 1) {
        items.push( /*#__PURE__*/external_react_default.a.createElement(PaginationItem_PaginationItem, extends_default()({
          key: uuid_default()()
        }, handleInteractionProps(i)), i));
      } // Add final page and a gap if needed


      if (startPage < localPageCount - maxPageButtons - 1) {
        items.push( /*#__PURE__*/external_react_default.a.createElement(PaginationItemGap_PaginationItemGap, {
          key: uuid_default()()
        }));
      }

      if (startPage < localPageCount - maxPageButtons) {
        items.push( /*#__PURE__*/external_react_default.a.createElement(PaginationItem_PaginationItem, extends_default()({
          key: uuid_default()()
        }, handleInteractionProps(localPageCount)), localPageCount));
      }

      return items;
    };

    return /*#__PURE__*/external_react_default.a.createElement(Tagname, {
      className: classNames
    }, renderPageCount(), /*#__PURE__*/external_react_default.a.createElement("ul", {
      className: "sage-pagination__pages"
    }, /*#__PURE__*/external_react_default.a.createElement(PaginationItem_PaginationItem, extends_default()({
      disabled: currentPage === 1
    }, handleInteractionProps(currentPage - 1)), labels && labels.previous ? labels.previous : PAGINATION_LABEL_PREVIOUS), renderPageItems(), /*#__PURE__*/external_react_default.a.createElement(PaginationItem_PaginationItem, extends_default()({
      disabled: currentPage === localPageCount
    }, handleInteractionProps(currentPage + 1)), labels && labels.next ? labels.next : PAGINATION_LABEL_NEXT)));
  };

  Pagination_Pagination.defaultProps = {
    align: null,
    className: null,
    hideCounter: false,
    hidePageButtons: false,
    itemsTotalCount: null,
    itemsNoun: PAGINATION_DEFAULT_ITEMS_NOUN,
    labels: null,
    maxPageButtons: 4,
    onClickPage: null,
    pageCount: null,
    pageCountPrefix: null,
    pageCountSuffix: null,
    pageSize: null,
    pageURLFn: null
  };
  Pagination_Pagination.propTypes = {
    align: prop_types_default.a.string,
    className: prop_types_default.a.string,
    currentPage: prop_types_default.a.number.isRequired,
    hideCounter: prop_types_default.a.bool,
    hidePageButtons: prop_types_default.a.bool,
    itemsTotalCount: prop_types_default.a.number,
    itemsNoun: prop_types_default.a.string,
    labels: prop_types_default.a.shape({
      next: prop_types_default.a.string,
      previous: prop_types_default.a.string
    }),
    maxPageButtons: prop_types_default.a.number,
    onClickPage: prop_types_default.a.func,
    pageCount: prop_types_default.a.number,
    pageCountPrefix: prop_types_default.a.string,
    pageCountSuffix: prop_types_default.a.string,
    pageSize: prop_types_default.a.number,
    pageURLFn: prop_types_default.a.func
  }; // CONCATENATED MODULE: ./lib/Pagination/index.js
  // CONCATENATED MODULE: ./lib/PanelControls/configs.js

  var SELECTION_TYPES = {
    NONE: 'none',
    PARTIAL: 'partial',
    ALL: 'all'
  };
  var DEFAULT_NOUN = {
    singular: 'item',
    plural: 'items'
  }; // CONCATENATED MODULE: ./lib/PanelControls/utils.js

  function utils_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function utils_objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? utils_ownKeys(Object(source), !0).forEach(function (key) {
        defineProperty_default()(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : utils_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }

    return target;
  }

  var listCurrentRange = function listCurrentRange(page, itemsShown, itemsTotal) {
    var start = (page - 1) * itemsShown + 1;
    var maxEnd = start + (itemsShown - 1);
    var end = maxEnd > itemsTotal ? itemsTotal : maxEnd;
    return {
      start: start,
      end: end
    };
  };

  var listCurrentRangeString = function listCurrentRangeString(page, itemsShown, itemsTotal) {
    var _listCurrentRange = listCurrentRange(page, itemsShown, itemsTotal),
        start = _listCurrentRange.start,
        end = _listCurrentRange.end;

    return "".concat(start, "\u2013").concat(end);
  };

  var listDisplayString = function listDisplayString(page, itemsShown, itemsTotal) {
    var noun = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
      plural: 'items'
    };
    var displayStr = "Displaying ".concat(listCurrentRangeString(page, itemsShown, itemsTotal), " of ").concat(itemsTotal);

    if (noun && noun.plural) {
      displayStr += " ".concat(noun.plural);
    }

    return displayStr;
  };

  var utils_handleChange = function handleChange(_ref) {
    var bulkActionsHandlerFn = _ref.bulkActionsHandlerFn,
        data = _ref.data,
        pageChangeHandlerFn = _ref.pageChangeHandlerFn,
        pageSizeChangeHandlerFn = _ref.pageSizeChangeHandlerFn,
        stateData = _ref.stateData,
        setStateDataFn = _ref.setStateDataFn,
        sortHandlerFn = _ref.sortHandlerFn; // First if a page change is requested, send for that

    if (data.page) {
      pageChangeHandlerFn(data.page);
      return;
    } // Of if requested change is a bulk actions command


    if (data.bulkActionCommand) {
      if (bulkActionsHandlerFn) {
        bulkActionsHandlerFn(data);
        return;
      }
    }

    if (data.sortActionCommand) {
      if (sortHandlerFn) {
        sortHandlerFn(data);
        return;
      }
    }

    if (data.pageSizeCommand) {
      if (pageSizeChangeHandlerFn) {
        pageSizeChangeHandlerFn(data.pageSizeCommand);
        return;
      }
    } // Or if reqeust is to change the selection


    if (data.selectionType) {
      // Parse selection type and adjust selected rows accordingly
      var selectedRows;

      switch (data.selectionType) {
        case SELECTION_TYPES.ALL:
          selectedRows = SELECTION_TYPES.ALL;
          break;

        case SELECTION_TYPES.NONE:
        default:
          selectedRows = [];
          break;
      }

      setStateDataFn(utils_objectSpread(utils_objectSpread({}, stateData), {}, {
        selectedRows: selectedRows,
        panelControlConfigs: utils_objectSpread(utils_objectSpread({}, stateData.panelControlConfigs), {}, {
          numSelectedRows: selectedRows.length,
          selectionType: data.selectionType
        })
      }));
    }
  };

  var utils_handleSelection = function handleSelection(_ref2) {
    var data = _ref2.data,
        stateData = _ref2.stateData,
        setStateDataFn = _ref2.setStateDataFn;
    var selectedRows = data.selectedRows;
    var totalItems = stateData.panelControls; // Determine selection type based on number of items
    // sent from table's current selection list

    var numSelectedRows = selectedRows.length;
    var selectionType;

    if (numSelectedRows === totalItems) {
      selectionType = SELECTION_TYPES.ALL;
    } else if (numSelectedRows > 0) {
      selectionType = SELECTION_TYPES.PARTIAL;
    } else {
      selectionType = SELECTION_TYPES.NONE;
    }

    setStateDataFn(utils_objectSpread(utils_objectSpread({}, stateData), {}, {
      selectedRows: selectedRows,
      panelControlConfigs: utils_objectSpread(utils_objectSpread({}, stateData.panelControlConfigs), {}, {
        numSelectedRows: numSelectedRows,
        selectionType: selectionType
      })
    }));
  }; // CONCATENATED MODULE: ./lib/PanelControls/PanelControlsBulkActions.jsx


  function PanelControlsBulkActions_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function PanelControlsBulkActions_objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? PanelControlsBulkActions_ownKeys(Object(source), !0).forEach(function (key) {
        defineProperty_default()(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PanelControlsBulkActions_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }

    return target;
  }

  var PanelControlsBulkActions_PanelControlsBulkActions = function PanelControlsBulkActions(_ref) {
    var bulkActionsItems = _ref.bulkActionsItems,
        checked = _ref.checked,
        currentPage = _ref.currentPage,
        itemsPerPage = _ref.itemsPerPage,
        numSelectedRows = _ref.numSelectedRows,
        onSelectBulkAction = _ref.onSelectBulkAction,
        onToggleSelection = _ref.onToggleSelection,
        rowNoun = _ref.rowNoun,
        selectionType = _ref.selectionType,
        totalItems = _ref.totalItems;
    var selectionCount = selectionType === SELECTION_TYPES.ALL ? totalItems : numSelectedRows;
    var bulkActionsLabelText = selectionCount > 0 ? "Selected ".concat(selectionCount, " ").concat(rowNoun.plural || 'items') : listDisplayString(currentPage, itemsPerPage, totalItems, rowNoun);
    var classNames = classnames_default()('sage-panel-controls__bulk-actions', {
      'sage-panel-controls__bulk-actions--checked': checked
    });
    var checkboxClassNames = classnames_default()('sage-panel-controls__bulk-actions-checkbox', {
      'sage-checkbox--partial-selection': selectionType === SELECTION_TYPES.PARTIAL
    });
    return /*#__PURE__*/external_react_default.a.createElement("div", {
      className: classNames
    }, /*#__PURE__*/external_react_default.a.createElement(Checkbox_Checkbox, {
      className: checkboxClassNames,
      id: uuid_default()(),
      label: bulkActionsLabelText,
      name: "bulk-actions-checkbox",
      onChange: onToggleSelection,
      checked: checked
    }), checked && bulkActionsItems && /*#__PURE__*/external_react_default.a.createElement(SelectDropdown_SelectDropdown, {
      className: "sage-panel-controls__bulk-actions-dropdown",
      id: uuid_default()(),
      items: bulkActionsItems,
      label: "Bulk Actions",
      searchable: false,
      onSelect: onSelectBulkAction
    }));
  };

  PanelControlsBulkActions_PanelControlsBulkActions.defaultProps = {
    bulkActionsItems: null,
    checked: false,
    currentPage: 1,
    itemsPerPage: 1,
    numSelectedRows: 0,
    onSelectBulkAction: function onSelectBulkAction(data) {
      return data;
    },
    onToggleSelection: function onToggleSelection(data) {
      return data;
    },
    rowNoun: PanelControlsBulkActions_objectSpread({}, DEFAULT_NOUN),
    selectionType: SELECTION_TYPES.NONE,
    totalItems: 0
  };
  PanelControlsBulkActions_PanelControlsBulkActions.propTypes = {
    bulkActionsItems: prop_types_default.a.arrayOf(prop_types_default.a.shape(Dropdown_Dropdown.ItemList.itemsPropTypes)),
    checked: prop_types_default.a.bool,
    currentPage: prop_types_default.a.number,
    itemsPerPage: prop_types_default.a.number,
    numSelectedRows: prop_types_default.a.number,
    onSelectBulkAction: prop_types_default.a.func,
    onToggleSelection: prop_types_default.a.func,
    rowNoun: prop_types_default.a.shape({
      plural: prop_types_default.a.string,
      singular: prop_types_default.a.string
    }),
    selectionType: prop_types_default.a.oneOf(Object.values(SELECTION_TYPES)),
    totalItems: prop_types_default.a.number
  }; // CONCATENATED MODULE: ./lib/PanelControls/PanelControlsPagination.jsx

  var PanelControlsPagination_PanelControlsPagination = function PanelControlsPagination(_ref) {
    var currentPage = _ref.currentPage,
        onClickPagination = _ref.onClickPagination,
        totalPages = _ref.totalPages;
    return /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-panel-controls__pagination"
    }, /*#__PURE__*/external_react_default.a.createElement(Button, {
      className: "sage-panel-controls__pagination-prev",
      color: Button.COLORS.SECONDARY,
      disabled: currentPage === 1,
      icon: SageTokens.ICONS.ARROW_LEFT,
      iconOnly: true,
      onClick: function onClick() {
        return onClickPagination(currentPage - 1);
      }
    }, "Previous Page"), /*#__PURE__*/external_react_default.a.createElement(Button, {
      className: "sage-panel-controls__pagination-next",
      color: Button.COLORS.SECONDARY,
      disabled: currentPage === totalPages,
      icon: SageTokens.ICONS.ARROW_RIGHT,
      iconOnly: true,
      onClick: function onClick() {
        return onClickPagination(currentPage + 1);
      }
    }, "Next Page"));
  };

  PanelControlsPagination_PanelControlsPagination.defaultProps = {
    currentPage: 1,
    onClickPagination: function onClickPagination(num) {
      return num;
    },
    totalPages: 1
  };
  PanelControlsPagination_PanelControlsPagination.propTypes = {
    currentPage: prop_types_default.a.number,
    onClickPagination: prop_types_default.a.func,
    totalPages: prop_types_default.a.number
  }; // CONCATENATED MODULE: ./lib/PanelControls/PanelControlsToolbar.jsx

  var PanelControlsToolbar_excluded = ["children", "className"];

  var PanelControlsToolbar_PanelControlsToolbar = function PanelControlsToolbar(_ref) {
    var children = _ref.children,
        className = _ref.className,
        rest = objectWithoutProperties_default()(_ref, PanelControlsToolbar_excluded);
    return /*#__PURE__*/external_react_default.a.createElement("div", extends_default()({
      className: "sage-panel-controls__toolbar ".concat(className || '')
    }, rest), children);
  };

  PanelControlsToolbar_PanelControlsToolbar.defaultProps = {
    children: null,
    className: null
  };
  PanelControlsToolbar_PanelControlsToolbar.propTypes = {
    children: prop_types_default.a.node,
    className: prop_types_default.a.string
  }; // CONCATENATED MODULE: ./lib/PanelControls/PanelControlsToolbarButtonGroup.jsx

  var PanelControlsToolbarButtonGroup_excluded = ["children", "className"];

  var PanelControlsToolbarButtonGroup_PanelControlsToolbarButtonGroup = function PanelControlsToolbarButtonGroup(_ref) {
    var children = _ref.children,
        className = _ref.className,
        rest = objectWithoutProperties_default()(_ref, PanelControlsToolbarButtonGroup_excluded);
    return /*#__PURE__*/external_react_default.a.createElement("div", extends_default()({
      className: "sage-panel-controls__toolbar-btn-group ".concat(className || '')
    }, rest), children);
  };

  PanelControlsToolbarButtonGroup_PanelControlsToolbarButtonGroup.defaultProps = {
    children: null,
    className: null
  };
  PanelControlsToolbarButtonGroup_PanelControlsToolbarButtonGroup.propTypes = {
    children: prop_types_default.a.node,
    className: prop_types_default.a.string
  }; // CONCATENATED MODULE: ./lib/PanelControls/PanelControls.jsx

  function PanelControls_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function PanelControls_objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? PanelControls_ownKeys(Object(source), !0).forEach(function (key) {
        defineProperty_default()(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PanelControls_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }

    return target;
  }

  var PanelControls_PanelControls = function PanelControls(_ref) {
    var children = _ref.children,
        className = _ref.className,
        controlSettings = _ref.controlSettings,
        onRequestChange = _ref.onRequestChange;

    var _useState = Object(external_react_["useState"])({
      // Set locally
      bulkActionsChecked: false,
      bulkActionsItems: [],
      sortOptions: null,
      // Synched with `controlSettings
      currentPage: 1,
      itemsOnThisPage: 0,
      numSelectedRows: 0,
      pageSize: 1,
      pageSizeOptions: null,
      pageSizeOptionSuffix: null,
      rowNoun: PanelControls_objectSpread({}, DEFAULT_NOUN),
      selectionType: SELECTION_TYPES.NONE,
      showDefaultToolbar: false,
      totalItems: 0,
      totalPages: 1
    }),
        _useState2 = slicedToArray_default()(_useState, 2),
        selfConfigs = _useState2[0],
        setSelfConfigs = _useState2[1]; //
    // Effects
    //


    var syncSelfConfigsWithPropsConfigs = function syncSelfConfigsWithPropsConfigs(bulkActionsChecked) {
      return setSelfConfigs(PanelControls_objectSpread(PanelControls_objectSpread(PanelControls_objectSpread({}, selfConfigs), controlSettings), {}, {
        bulkActionsChecked: bulkActionsChecked
      }));
    }; // Update when control settings change


    Object(external_react_["useEffect"])(function () {
      var bulkActionsChecked = controlSettings && (controlSettings.selectionType === SELECTION_TYPES.ALL || controlSettings.selectionType === SELECTION_TYPES.PARTIAL);
      syncSelfConfigsWithPropsConfigs(bulkActionsChecked);
    }, [controlSettings]); // eslint-disable-line
    //
    // Event handlers
    //
    // Respond to change on bulk actions checkbox

    var onChangeSelectAll = function onChangeSelectAll() {
      var bulkActionsChecked = !selfConfigs.bulkActionsChecked;
      var selectionType;

      if (bulkActionsChecked) {
        selectionType = SELECTION_TYPES.ALL;
      } else {
        selectionType = SELECTION_TYPES.NONE;
      }

      onRequestChange({
        selectionType: selectionType
      });
      setSelfConfigs(PanelControls_objectSpread(PanelControls_objectSpread({}, selfConfigs), {}, {
        bulkActionsChecked: bulkActionsChecked,
        selectionType: selectionType
      }));
    }; // Respond to pagination clicks


    var onClickPagination = function onClickPagination(newPageNumber) {
      onRequestChange({
        page: newPageNumber
      });
    }; // Respond to bulk action command selection


    var onSelectBulkAction = function onSelectBulkAction(payload) {
      onRequestChange({
        bulkActionCommand: payload
      });
    };

    var handleSortSelection = function handleSortSelection(payload) {
      onRequestChange({
        sortActionCommand: payload
      });
    };

    var handlePageSizeSelection = function handlePageSizeSelection(_ref2) {
      var size = _ref2.size;
      onRequestChange({
        pageSizeCommand: size
      });
    }; //
    // Render
    //


    var renderPageSizeDropdown = function renderPageSizeDropdown() {
      var pageSizeItems = selfConfigs.pageSizeOptions.map(function (size) {
        var suffix = selfConfigs.pageSizeOptionSuffix || '';
        var label = "".concat(size).concat(suffix);
        return {
          id: "page-size-".concat(size),
          label: label,
          payload: {
            id: "page-size-".concat(size),
            label: label,
            size: size
          }
        };
      });
      var initialPageSizeItem = pageSizeItems.filter(function (item) {
        return item.payload.size === selfConfigs.pageSize;
      });

      if (initialPageSizeItem && initialPageSizeItem.length >= 1) {
        var _initialPageSizeItem = initialPageSizeItem;

        var _initialPageSizeItem2 = slicedToArray_default()(_initialPageSizeItem, 1);

        initialPageSizeItem = _initialPageSizeItem2[0];
      } else {
        initialPageSizeItem = pageSizeItems.length >= 1 ? pageSizeItems[0] : null;
      }

      return /*#__PURE__*/external_react_default.a.createElement(SelectDropdown_SelectDropdown, {
        align: "right",
        className: "sage-dropdown--page-size sage-panel-controls__page-size",
        customized: true,
        initialSelectedValue: initialPageSizeItem,
        items: pageSizeItems,
        label: "Page size",
        onSelect: handlePageSizeSelection,
        selectionBecomesLabel: true
      });
    }; // Primary render


    var classNames = classnames_default()('sage-panel-controls', className);
    return /*#__PURE__*/external_react_default.a.createElement("div", {
      className: classNames
    }, children, selfConfigs.showDefaultToolbar && /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-panel-controls__default-controls"
    }, /*#__PURE__*/external_react_default.a.createElement(PanelControlsBulkActions_PanelControlsBulkActions, {
      bulkActionsItems: selfConfigs.bulkActionsItems,
      checked: selfConfigs.bulkActionsChecked,
      currentPage: selfConfigs.currentPage,
      itemsPerPage: selfConfigs.pageSize,
      numSelectedRows: selfConfigs.numSelectedRows,
      onSelectBulkAction: onSelectBulkAction,
      onToggleSelection: onChangeSelectAll,
      rowNoun: selfConfigs.rowNoun,
      selectionType: selfConfigs.selectionType,
      totalItems: selfConfigs.totalItems
    }), /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-panel-controls__toolbar"
    }, /*#__PURE__*/external_react_default.a.createElement(PanelControlsPagination_PanelControlsPagination, {
      currentPage: selfConfigs.currentPage,
      onClickPagination: onClickPagination,
      totalPages: selfConfigs.totalPages
    }), selfConfigs.pageSizeOptions && renderPageSizeDropdown(), selfConfigs.sortOptions && /*#__PURE__*/external_react_default.a.createElement(SelectDropdown_SelectDropdown, {
      align: "right",
      className: "sage-dropdown--sort sage-panel-controls__sorts",
      customized: true,
      items: selfConfigs.sortOptions,
      label: "Sort",
      onSelect: handleSortSelection,
      selectionBecomesLabel: true
    }))));
  };

  PanelControls_PanelControls.SELECTION_TYPES = SELECTION_TYPES;
  PanelControls_PanelControls.handlerUtils = {
    handleChange: utils_handleChange,
    handleSelection: utils_handleSelection
  };
  PanelControls_PanelControls.Toolbar = PanelControlsToolbar_PanelControlsToolbar;
  PanelControls_PanelControls.ToolbarButtonGroup = PanelControlsToolbarButtonGroup_PanelControlsToolbarButtonGroup;
  PanelControls_PanelControls.defaultProps = {
    children: null,
    className: null,
    controlSettings: null
  };
  PanelControls_PanelControls.propTypes = {
    children: prop_types_default.a.node,
    className: prop_types_default.a.string,
    controlSettings: prop_types_default.a.shape({
      currentPage: prop_types_default.a.number,
      itemsOnThisPage: prop_types_default.a.number,
      numSelectedRows: prop_types_default.a.number,
      pageSize: prop_types_default.a.number,
      pageSizeOptions: prop_types_default.a.arrayOf(prop_types_default.a.number),
      pageSizeOptionSuffix: prop_types_default.a.string,
      rowNoun: prop_types_default.a.shape({
        singular: prop_types_default.a.string,
        plural: prop_types_default.a.string
      }),
      selectionType: prop_types_default.a.oneOf(Object.values(SELECTION_TYPES)),
      showDefaultToolbar: prop_types_default.a.bool,
      sortOptions: prop_types_default.a.arrayOf(prop_types_default.a.shape({})),
      totalItems: prop_types_default.a.number,
      totalPages: prop_types_default.a.number
    }),
    onRequestChange: prop_types_default.a.func.isRequired
  }; // CONCATENATED MODULE: ./lib/PanelControls/index.js
  // CONCATENATED MODULE: ./lib/ProgressBar/configs.js

  var PROGRESSBAR_TOOLTIP_POSITIONS = {
    TOP: 'top',
    BOTTOM: 'bottom'
  }; // CONCATENATED MODULE: ./lib/ProgressBar/ProgressBar.jsx

  var ProgressBar_excluded = ["backgroundColor", "className", "color", "disableTooltip", "displayPercent", "label", "percent", "tooltipPosition"];

  var ProgressBar_ProgressBar = function ProgressBar(_ref) {
    var backgroundColor = _ref.backgroundColor,
        className = _ref.className,
        color = _ref.color,
        disableTooltip = _ref.disableTooltip,
        displayPercent = _ref.displayPercent,
        label = _ref.label,
        percent = _ref.percent,
        tooltipPosition = _ref.tooltipPosition,
        rest = objectWithoutProperties_default()(_ref, ProgressBar_excluded);
    var classNames = classnames_default()('sage-progress-bar', className, {
      'sage-progress-bar--has-percentage': displayPercent
    });
    var displayText = label ? "".concat(label, ": ").concat(percent, "% progress") : '';

    var renderBar = function renderBar() {
      var bgStyles = {};

      if (backgroundColor) {
        bgStyles['--sage-progress-bar-background-color'] = backgroundColor;
      }

      return /*#__PURE__*/external_react_default.a.createElement("div", {
        className: "sage-progress-bar__background",
        style: bgStyles
      }, /*#__PURE__*/external_react_default.a.createElement("progress", {
        className: "sage-progress-bar__element",
        "aria-valuemax": "100",
        max: "100",
        "aria-valuemin": "0",
        value: String(percent),
        "aria-valuenow": percent,
        "aria-valuetext": displayText
      }, displayText), /*#__PURE__*/external_react_default.a.createElement("div", {
        className: "sage-progress-bar__value",
        style: {
          width: "".concat(percent, "%"),
          '--progress-bar-value-color': color
        }
      }));
    };

    return /*#__PURE__*/external_react_default.a.createElement("div", extends_default()({
      className: classNames
    }, rest), disableTooltip ? renderBar() : /*#__PURE__*/external_react_default.a.createElement(Tooltip_Tooltip, {
      content: displayText
    }, renderBar()), displayPercent && /*#__PURE__*/external_react_default.a.createElement("span", {
      className: "sage-progress-bar__percent"
    }, percent, "%"));
  };

  ProgressBar_ProgressBar.COLORS = SageTokens.COLOR_PALETTE;
  ProgressBar_ProgressBar.TOOLTIP_POSITIONS = PROGRESSBAR_TOOLTIP_POSITIONS;
  ProgressBar_ProgressBar.defaultProps = {
    backgroundColor: null,
    className: null,
    color: ProgressBar_ProgressBar.COLORS.PRIMARY_300,
    disableTooltip: false,
    displayPercent: false,
    label: null,
    percent: null,
    tooltipPosition: null
  };
  ProgressBar_ProgressBar.propTypes = {
    backgroundColor: prop_types_default.a.string,
    className: prop_types_default.a.string,
    color: prop_types_default.a.oneOf(Object.values(ProgressBar_ProgressBar.COLORS)),
    disableTooltip: prop_types_default.a.bool,
    displayPercent: prop_types_default.a.bool,
    label: prop_types_default.a.string,
    percent: prop_types_default.a.string,
    tooltipPosition: prop_types_default.a.oneOf(Object.values(ProgressBar_ProgressBar.TOOLTIP_POSITIONS))
  }; // CONCATENATED MODULE: ./lib/ProgressBar/index.js
  // CONCATENATED MODULE: ./lib/Property/PropertyGroup.jsx

  var PropertyGroup_excluded = ["children", "className"];

  var PropertyGroup_PropertyGroup = function PropertyGroup(_ref) {
    var children = _ref.children,
        className = _ref.className,
        rest = objectWithoutProperties_default()(_ref, PropertyGroup_excluded);
    var classNames = classnames_default()('sage-property-group', className);
    return /*#__PURE__*/external_react_default.a.createElement("div", extends_default()({
      className: classNames
    }, rest), children);
  };

  PropertyGroup_PropertyGroup.defaultProps = {
    className: null,
    children: null
  };
  PropertyGroup_PropertyGroup.propTypes = {
    className: prop_types_default.a.string,
    children: prop_types_default.a.node
  }; // CONCATENATED MODULE: ./lib/Property/Property.jsx

  var Property_excluded = ["children", "className", "icon"];

  var Property_Property = function Property(_ref) {
    var children = _ref.children,
        className = _ref.className,
        icon = _ref.icon,
        rest = objectWithoutProperties_default()(_ref, Property_excluded);
    var classNames = classnames_default()('sage-property', className);
    return /*#__PURE__*/external_react_default.a.createElement("span", extends_default()({
      className: classNames
    }, rest), icon && /*#__PURE__*/external_react_default.a.createElement(Icon_Icon, {
      icon: icon,
      className: "sage-property__icon"
    }), children && /*#__PURE__*/external_react_default.a.createElement("span", {
      className: "sage-property__value"
    }, children));
  };

  Property_Property.Group = PropertyGroup_PropertyGroup;
  Property_Property.defaultProps = {
    className: null,
    children: null,
    icon: null
  };
  Property_Property.propTypes = {
    className: prop_types_default.a.string,
    children: prop_types_default.a.node,
    icon: prop_types_default.a.oneOf(Object.values(SageTokens.ICONS))
  }; // CONCATENATED MODULE: ./lib/Property/index.js
  // CONCATENATED MODULE: ./lib/SampleComponent/configs.js

  var SAMPLE_TOKEN = {
    VALUE_1: 'value-1',
    VALUE_2: 'value-2'
  }; // CONCATENATED MODULE: ./lib/SampleComponent/SampleComponent.jsx
  // component configurations as needed

  var SampleComponent_SampleComponent = function SampleComponent(_ref) {
    var children = _ref.children,
        className = _ref.className;
    var classNames = classnames_default()('sage-sample-component', className);
    return /*#__PURE__*/external_react_default.a.createElement("div", {
      className: classNames
    }, children);
  }; // Public assignment of component configuration tokens as needed


  SampleComponent_SampleComponent.SAMPLE_TOKEN = SAMPLE_TOKEN;
  SampleComponent_SampleComponent.defaultProps = {
    // optional default values here in alpha order
    children: null,
    className: null
  };
  SampleComponent_SampleComponent.propTypes = {
    // all proptypes here in alpha order
    children: prop_types_default.a.node,
    className: prop_types_default.a.string
  }; // CONCATENATED MODULE: ./lib/SampleComponent/index.js
  // CONCATENATED MODULE: ./lib/Select/Select.jsx

  var Select_excluded = ["className", "disabled", "hasError", "id", "includeLabelInOptions", "label", "message", "onChange", "options", "required", "value"];

  var Select_Select = function Select(_ref) {
    var className = _ref.className,
        disabled = _ref.disabled,
        hasError = _ref.hasError,
        id = _ref.id,
        includeLabelInOptions = _ref.includeLabelInOptions,
        label = _ref.label,
        message = _ref.message,
        onChange = _ref.onChange,
        options = _ref.options,
        required = _ref.required,
        value = _ref.value,
        rest = objectWithoutProperties_default()(_ref, Select_excluded);
    var classNames = classnames_default()('sage-select', className, {
      'sage-form-field--error': hasError,
      'sage-select--value-selected': value
    });

    var buildOption = function buildOption(option, i) {
      var optionLabel, optionValue, optionDisabled;

      if (typeof option === 'string') {
        optionLabel = option;
        optionValue = option;
      } else {
        optionLabel = option.label;
        optionValue = option.value;
        optionDisabled = option.disabled;
      }

      return /*#__PURE__*/external_react_default.a.createElement("option", {
        key: optionValue + i.toString(),
        value: optionValue,
        disabled: optionDisabled
      }, optionLabel);
    };

    var buildOptgroup = function buildOptgroup(_ref2, i) {
      var disabled = _ref2.disabled,
          groupLabel = _ref2.groupLabel,
          groupOptions = _ref2.groupOptions;
      return /*#__PURE__*/external_react_default.a.createElement("optgroup", {
        label: groupLabel,
        disabled: disabled,
        key: groupLabel + i.toString()
      }, groupOptions && groupOptions.map(buildOption));
    };

    return /*#__PURE__*/external_react_default.a.createElement("div", {
      className: classNames
    }, /*#__PURE__*/external_react_default.a.createElement("select", extends_default()({
      className: "sage-select__field",
      id: id,
      onChange: onChange,
      placeholder: label,
      value: value,
      disabled: disabled,
      required: required
    }, rest), label && includeLabelInOptions && /*#__PURE__*/external_react_default.a.createElement("option", {
      label: label
    }), options && options.map(function (option, i) {
      return option.groupLabel ? buildOptgroup(option, i) : buildOption(option, i);
    })), /*#__PURE__*/external_react_default.a.createElement("i", {
      className: "sage-select__arrow",
      "aria-hidden": "true"
    }), label && /*#__PURE__*/external_react_default.a.createElement("label", {
      htmlFor: id,
      className: "sage-select__label"
    }, label), message && /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-select__info"
    }, /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-select__message"
    }, message)));
  };

  Select_Select.defaultProps = {
    className: null,
    disabled: false,
    hasError: false,
    includeLabelInOptions: false,
    label: null,
    message: null,
    onChange: function onChange(evt) {
      return evt;
    },
    options: [],
    required: false,
    value: ''
  };
  Select_Select.propTypes = {
    className: prop_types_default.a.string,
    disabled: prop_types_default.a.bool,
    hasError: prop_types_default.a.bool,
    id: prop_types_default.a.string.isRequired,
    includeLabelInOptions: prop_types_default.a.bool,
    label: prop_types_default.a.string,
    message: prop_types_default.a.string,
    onChange: prop_types_default.a.func,
    options: prop_types_default.a.arrayOf(prop_types_default.a.oneOfType([prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.shape({
      label: prop_types_default.a.string,
      value: prop_types_default.a.string,
      disabled: prop_types_default.a.bool
    })]), prop_types_default.a.shape({
      disabled: prop_types_default.a.bool,
      groupLabel: prop_types_default.a.string,
      groupOptions: prop_types_default.a.arrayOf(prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.shape({
        label: prop_types_default.a.string,
        value: prop_types_default.a.string,
        disabled: prop_types_default.a.bool
      })]))
    })])),
    required: prop_types_default.a.bool,
    value: prop_types_default.a.string
  }; // CONCATENATED MODULE: ./lib/Select/index.js
  // CONCATENATED MODULE: ./lib/Tabs/configs.js

  var CHOICE_TYPES = {
    ARROW: 'arrow',
    GRAPHIC: 'graphic',
    ICON: 'icon',
    RADIO: 'radio'
  };
  var CHOICE_ICON_ALIGNMENTS = {
    DEFAULT: null,
    START: 'start'
  };
  var TAB_JUSTIFY_OPTIONS = {
    DEFAULT: null,
    CENTER: 'center',
    END: 'end',
    SPACE_BETWEEN: 'space-between'
  };
  var TAB_LAYOUTS = {
    DEFAULT: 'default',
    STACKED: 'stacked'
  };
  var TAB_STYLES = {
    CHOICE: 'choice',
    FILTER: 'filter',
    PROGRESSBAR: 'progressbar',
    TAB: 'tab'
  };
  var tabsItemsPropTypes = prop_types_default.a.shape({
    id: prop_types_default.a.string.isRequired,
    content: prop_types_default.a.node,
    disabled: prop_types_default.a.bool,
    label: prop_types_default.a.string.isRequired,
    subtext: prop_types_default.a.string,
    tabChoiceCustomClass: prop_types_default.a.string,
    tabChoiceIcon: prop_types_default.a.oneOf(Object.values(SageTokens.ICONS)),
    tabChoicIconAlignment: prop_types_default.a.oneOf(Object.values(CHOICE_ICON_ALIGNMENTS)),
    tabChoiceType: prop_types_default.a.oneOf(Object.values(CHOICE_TYPES))
  }); // CONCATENATED MODULE: ./lib/Tabs/TabsItem.jsx

  var TabsItem_excluded = ["alignCenter", "children", "className", "customContentClassName", "disabled", "graphic", "label", "icon", "isActive", "itemStyle", "linkText", "onClick", "panelId", "subtext", "type", "verticalAlignIcon"];

  function TabsItem_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function TabsItem_objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? TabsItem_ownKeys(Object(source), !0).forEach(function (key) {
        defineProperty_default()(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : TabsItem_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }

    return target;
  }

  var TabsItem_TabsItem = function TabsItem(_ref) {
    var _classnames;

    var alignCenter = _ref.alignCenter,
        children = _ref.children,
        className = _ref.className,
        customContentClassName = _ref.customContentClassName,
        disabled = _ref.disabled,
        graphic = _ref.graphic,
        label = _ref.label,
        icon = _ref.icon,
        isActive = _ref.isActive,
        itemStyle = _ref.itemStyle,
        linkText = _ref.linkText,
        _onClick = _ref.onClick,
        panelId = _ref.panelId,
        subtext = _ref.subtext,
        type = _ref.type,
        verticalAlignIcon = _ref.verticalAlignIcon,
        rest = objectWithoutProperties_default()(_ref, TabsItem_excluded);
    var to = rest.to,
        href = rest.href;
    var isLink = to || href;
    var TagName = children ? 'div' : 'button';
    TagName = isLink ? Link_Link : TagName;
    var itemStyleProtected = itemStyle === TAB_STYLES.PROGRESSBAR ? TAB_STYLES.TAB : itemStyle;
    var isChoice = itemStyle === TAB_STYLES.CHOICE;
    var isIconType = type && type === CHOICE_TYPES.ICON;
    var isRadioType = type && type === CHOICE_TYPES.RADIO;
    var baseClass = "sage-".concat(itemStyleProtected);
    var classNames = classnames_default()(className, (_classnames = {}, defineProperty_default()(_classnames, baseClass, itemStyleProtected), defineProperty_default()(_classnames, "".concat(baseClass, "--active"), isActive), defineProperty_default()(_classnames, "".concat(baseClass, "--align-center"), isIconType && alignCenter), defineProperty_default()(_classnames, "".concat(baseClass, "--").concat(type), type && !isIconType), defineProperty_default()(_classnames, "".concat(baseClass, "--icon-").concat(icon), isIconType && icon), defineProperty_default()(_classnames, "".concat(baseClass, "--vertical-align-icon-").concat(verticalAlignIcon), isChoice && verticalAlignIcon && (isIconType || isRadioType)), _classnames));
    var attrs = TabsItem_objectSpread({
      'aria-controls': panelId,
      'aria-selected': isActive,
      className: classNames,
      role: 'tab'
    }, rest);

    if (isLink) {
      attrs = TabsItem_objectSpread(TabsItem_objectSpread({}, attrs), {}, {
        'aria-disabled': disabled,
        suppressDefaultClass: true
      });
    } else {
      attrs = TabsItem_objectSpread(TabsItem_objectSpread({}, attrs), {}, {
        disabled: disabled,
        onClick: function onClick() {
          return _onClick(panelId);
        }
      });

      if (!children) {
        attrs.type = 'button';
      }
    }

    return /*#__PURE__*/external_react_default.a.createElement(TagName, attrs, isChoice ? /*#__PURE__*/external_react_default.a.createElement(external_react_default.a.Fragment, null, graphic && /*#__PURE__*/external_react_default.a.createElement("span", {
      className: "sage-choice__graphic"
    }, graphic), /*#__PURE__*/external_react_default.a.createElement("span", {
      className: "sage-choice__content ".concat(customContentClassName, " ").concat(children && 'sage-choice__content--custom')
    }, label && /*#__PURE__*/external_react_default.a.createElement("em", {
      className: "sage-choice__text"
    }, label), subtext && /*#__PURE__*/external_react_default.a.createElement("span", {
      className: "sage-choice__subtext"
    }, subtext), children), linkText && /*#__PURE__*/external_react_default.a.createElement("span", {
      className: "sage-choice__link-text"
    }, linkText)) : label);
  };

  TabsItem_TabsItem.STYLES = TAB_STYLES;
  TabsItem_TabsItem.CHOICE_TYPES = CHOICE_TYPES;
  TabsItem_TabsItem.ICON_ALIGNMENTS = CHOICE_ICON_ALIGNMENTS;
  TabsItem_TabsItem.defaultProps = {
    alignCenter: false,
    children: null,
    className: null,
    customContentClassName: null,
    disabled: false,
    graphic: null,
    icon: null,
    isActive: false,
    itemStyle: 'tab',
    linkText: null,
    onClick: function onClick(id) {
      return id;
    },
    subtext: null,
    type: null,
    verticalAlignIcon: CHOICE_ICON_ALIGNMENTS.DEFAULT
  };
  TabsItem_TabsItem.propTypes = {
    alignCenter: prop_types_default.a.bool,
    children: prop_types_default.a.node,
    className: prop_types_default.a.string,
    customContentClassName: prop_types_default.a.string,
    disabled: prop_types_default.a.bool,
    graphic: prop_types_default.a.node,
    icon: prop_types_default.a.oneOf(Object.values(SageTokens.ICONS)),
    isActive: prop_types_default.a.bool,
    itemStyle: prop_types_default.a.oneOf(Object.values(TabsItem_TabsItem.STYLES)),
    label: prop_types_default.a.string.isRequired,
    linkText: prop_types_default.a.string,
    onClick: prop_types_default.a.func,
    panelId: prop_types_default.a.string.isRequired,
    subtext: prop_types_default.a.string,
    type: prop_types_default.a.oneOf(Object.values(TabsItem_TabsItem.CHOICE_TYPES)),
    verticalAlignIcon: prop_types_default.a.oneOf(Object.values(TabsItem_TabsItem.ICON_ALIGNMENTS))
  }; // CONCATENATED MODULE: ./lib/Tabs/TabsPane.jsx

  var TabsPane_excluded = ["card", "cardSpacing", "children", "className", "id", "isActive", "panelSpacing"];

  var TabsPane_TabsPane = function TabsPane(_ref) {
    var card = _ref.card,
        cardSpacing = _ref.cardSpacing,
        children = _ref.children,
        className = _ref.className,
        id = _ref.id,
        isActive = _ref.isActive,
        panelSpacing = _ref.panelSpacing,
        rest = objectWithoutProperties_default()(_ref, TabsPane_excluded);
    var classNames = classnames_default()('sage-tabs-pane', className, {
      'sage-tabs-pane--card': card,
      'sage-tabs-pane--card-spacing': cardSpacing,
      'sage-tabs-pane--active': isActive,
      'sage-tabs-pane--panel-spacing': panelSpacing
    });
    return isActive && children ? /*#__PURE__*/external_react_default.a.createElement("div", extends_default()({
      className: classNames,
      id: id,
      role: "tabpanel"
    }, rest), children) : null;
  };

  TabsPane_TabsPane.defaultProps = {
    card: false,
    cardSpacing: false,
    children: null,
    className: null,
    isActive: false,
    panelSpacing: false
  };
  TabsPane_TabsPane.propTypes = {
    card: prop_types_default.a.bool,
    cardSpacing: prop_types_default.a.bool,
    children: prop_types_default.a.node,
    className: prop_types_default.a.string,
    id: prop_types_default.a.string.isRequired,
    isActive: prop_types_default.a.bool,
    panelSpacing: prop_types_default.a.bool
  }; // CONCATENATED MODULE: ./lib/Tabs/Tabs.jsx

  var Tabs_excluded = ["alignItemsCenter", "className", "gap", "initialActiveId", "justify", "onClickTab", "onChangeTabsHook", "panesClassName", "tabLayout", "tabs", "tabStyle", "tabsClassName", "useSeparator", "withBackground"],
      Tabs_excluded2 = ["disabled", "id", "label", "tabDetails", "tabChoiceCustomClass", "tabChoiceIcon", "tabChoiceIconAlignment", "tabChoiceType", "subtext", "panelSpacing", "cardSpacing"];

  var Tabs_Tabs = function Tabs(_ref) {
    var _classnames;

    var alignItemsCenter = _ref.alignItemsCenter,
        className = _ref.className,
        gap = _ref.gap,
        initialActiveId = _ref.initialActiveId,
        justify = _ref.justify,
        onClickTab = _ref.onClickTab,
        onChangeTabsHook = _ref.onChangeTabsHook,
        panesClassName = _ref.panesClassName,
        tabLayout = _ref.tabLayout,
        tabs = _ref.tabs,
        tabStyle = _ref.tabStyle,
        tabsClassName = _ref.tabsClassName,
        useSeparator = _ref.useSeparator,
        withBackground = _ref.withBackground,
        rest = objectWithoutProperties_default()(_ref, Tabs_excluded);

    var _useState = Object(external_react_["useState"])(initialActiveId),
        _useState2 = slicedToArray_default()(_useState, 2),
        activeId = _useState2[0],
        setActiveId = _useState2[1];

    var tabsClassNames = classnames_default()('sage-tabs', tabsClassName, (_classnames = {
      'sage-tabs--progressbar': tabStyle === TAB_STYLES.PROGRESSBAR,
      'sage-tabs--filter': tabStyle === TAB_STYLES.FILTER,
      'sage-tabs--align-items-center': tabStyle === TAB_STYLES.CHOICE && alignItemsCenter,
      'sage-tabs--choice': tabStyle === TAB_STYLES.CHOICE
    }, defineProperty_default()(_classnames, "sage-tabs--layout-".concat(tabLayout), tabLayout), defineProperty_default()(_classnames, "sage-tabs--justify-".concat(justify), justify), defineProperty_default()(_classnames, 'sage-tabs--with-background', withBackground), defineProperty_default()(_classnames, "sage-grid-gap-".concat(gap), gap), _classnames));
    Object(external_react_["useEffect"])(function () {
      return setActiveId(initialActiveId);
    }, [initialActiveId, setActiveId]);

    var handleClickTab = function handleClickTab(id) {
      if (onClickTab) {
        onClickTab(id);
      } else {
        setActiveId(id);
      }

      if (onChangeTabsHook) {
        onChangeTabsHook(id);
      }
    };

    var setTabStyle = function setTabStyle(tabStyle) {
      if (tabStyle === TAB_STYLES.FILTER || tabStyle === TAB_STYLES.PROGRESSBAR) {
        return 'tab';
      }

      return tabStyle;
    };

    return /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-tabs-container ".concat(className || '')
    }, /*#__PURE__*/external_react_default.a.createElement("div", extends_default()({
      className: tabsClassNames,
      role: "tablist"
    }, rest), tabs.map(function (_ref2) {
      var disabled = _ref2.disabled,
          id = _ref2.id,
          label = _ref2.label,
          tabDetails = _ref2.tabDetails,
          tabChoiceCustomClass = _ref2.tabChoiceCustomClass,
          tabChoiceIcon = _ref2.tabChoiceIcon,
          tabChoiceIconAlignment = _ref2.tabChoiceIconAlignment,
          tabChoiceType = _ref2.tabChoiceType,
          subtext = _ref2.subtext,
          panelSpacing = _ref2.panelSpacing,
          cardSpacing = _ref2.cardSpacing,
          rest = objectWithoutProperties_default()(_ref2, Tabs_excluded2);
      return /*#__PURE__*/external_react_default.a.createElement(TabsItem_TabsItem, extends_default()({
        disabled: disabled,
        icon: tabChoiceIcon,
        isActive: id === activeId,
        itemStyle: setTabStyle(tabStyle),
        key: id.toString(),
        onClick: handleClickTab,
        panelId: id,
        label: label,
        subtext: subtext,
        customContentClassName: tabChoiceCustomClass,
        type: tabChoiceType,
        verticalAlignIcon: tabChoiceIconAlignment
      }, rest), tabDetails);
    })), useSeparator && /*#__PURE__*/external_react_default.a.createElement("hr", {
      className: "sage-tabs-divider"
    }), tabs.map(function (_ref3) {
      var id = _ref3.id,
          content = _ref3.content,
          card = _ref3.card,
          cardSpacing = _ref3.cardSpacing,
          panelSpacing = _ref3.panelSpacing;
      return /*#__PURE__*/external_react_default.a.createElement(TabsPane_TabsPane, {
        card: card,
        cardSpacing: cardSpacing,
        className: panesClassName,
        id: id,
        isActive: id === activeId,
        key: id.toString(),
        panelSpacing: panelSpacing
      }, content);
    }));
  };

  Tabs_Tabs.Item = TabsItem_TabsItem;
  Tabs_Tabs.Pane = TabsPane_TabsPane;
  Tabs_Tabs.itemsPropTypes = tabsItemsPropTypes;
  Tabs_Tabs.JUSTIFY_OPTIONS = TAB_JUSTIFY_OPTIONS;
  Tabs_Tabs.LAYOUTS = TAB_LAYOUTS;
  Tabs_Tabs.STYLES = TAB_STYLES;
  Tabs_Tabs.defaultProps = {
    alignItemsCenter: false,
    className: '',
    gap: SageTokens.GRID_GAP_OPTIONS.SM,
    initialActiveId: null,
    justify: Tabs_Tabs.JUSTIFY_OPTIONS.DEFAULT,
    onChangeTabsHook: null,
    onClickTab: null,
    panesClassName: null,
    tabLayout: Tabs_Tabs.LAYOUTS.DEFAULT,
    tabStyle: Tabs_Tabs.STYLES.TAB,
    tabsClassName: null,
    useSeparator: false,
    withBackground: false
  };
  Tabs_Tabs.propTypes = {
    alignItemsCenter: prop_types_default.a.bool,
    className: prop_types_default.a.string,
    gap: prop_types_default.a.oneOf(Object.values(SageTokens.GRID_GAP_OPTIONS)),
    initialActiveId: prop_types_default.a.string,
    justify: prop_types_default.a.oneOf(Object.values(Tabs_Tabs.JUSTIFY_OPTIONS)),
    onChangeTabsHook: prop_types_default.a.func,
    onClickTab: prop_types_default.a.func,
    panesClassName: prop_types_default.a.string,
    tabLayout: prop_types_default.a.oneOf(Object.values(Tabs_Tabs.LAYOUTS)),
    tabs: prop_types_default.a.arrayOf(tabsItemsPropTypes).isRequired,
    tabStyle: prop_types_default.a.oneOf(Object.values(Tabs_Tabs.STYLES)),
    tabsClassName: prop_types_default.a.string,
    useSeparator: prop_types_default.a.bool,
    withBackground: prop_types_default.a.bool
  }; // CONCATENATED MODULE: ./lib/Tabs/index.js
  // CONCATENATED MODULE: ./lib/Sortable/configs.js

  var SORTABLE_ITEM_TYPES = {
    DEFAULT: null,
    CARD: 'card'
  };
  var SORTABLE_ROW_GAP_OPTIONS = {
    DEFAULT: null,
    XS: 'xs',
    SM: 'sm',
    MD: 'md',
    LG: 'lg'
  }; // CONCATENATED MODULE: ./lib/Sortable/SortableItem.jsx

  var SortableItem_excluded = ["title", "subtitle", "actionItems", "image", "type"];

  var SortableItem_SortableItem = function SortableItem(_ref) {
    var title = _ref.title,
        subtitle = _ref.subtitle,
        actionItems = _ref.actionItems,
        image = _ref.image,
        type = _ref.type,
        rest = objectWithoutProperties_default()(_ref, SortableItem_excluded);
    var className = classnames_default()('sage-sortable__item', {
      'sage-sortable__item--card': type === SORTABLE_ITEM_TYPES.CARD
    });
    return /*#__PURE__*/external_react_default.a.createElement("section", extends_default()({}, rest, {
      className: className
    }), image && /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-sortable__item-image"
    }, /*#__PURE__*/external_react_default.a.createElement("img", {
      src: image,
      alt: "Cover for ".concat(title)
    })), /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-sortable__item-content"
    }, /*#__PURE__*/external_react_default.a.createElement("h1", {
      className: "sage-sortable__item-title"
    }, title), subtitle && /*#__PURE__*/external_react_default.a.createElement("h2", {
      className: "sage-sortable__item-subtitle"
    }, subtitle)), actionItems && /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-sortable__item-actions"
    }, actionItems));
  };

  SortableItem_SortableItem.TYPES = SORTABLE_ITEM_TYPES;
  SortableItem_SortableItem.defaultProps = {
    actionItems: null,
    subtitle: null,
    image: null,
    type: SORTABLE_ITEM_TYPES.DEFAULT
  };
  SortableItem_SortableItem.propTypes = {
    actionItems: prop_types_default.a.arrayOf(prop_types_default.a.node),
    title: prop_types_default.a.string.isRequired,
    subtitle: prop_types_default.a.string,
    image: prop_types_default.a.string,
    type: prop_types_default.a.oneOf(Object.values(SORTABLE_ITEM_TYPES))
  }; // CONCATENATED MODULE: ./lib/Sortable/Sortable.jsx

  var Sortable_excluded = ["list", "setList", "onEnd", "renderItem"];

  var Sortable_Sortable = function Sortable(_ref) {
    var list = _ref.list,
        setList = _ref.setList,
        onEnd = _ref.onEnd,
        renderItem = _ref.renderItem,
        rest = objectWithoutProperties_default()(_ref, Sortable_excluded);
    if (list.length === 0) return null;
    return /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-sortable"
    }, /*#__PURE__*/external_react_default.a.createElement(dist["ReactSortable"], extends_default()({
      list: list,
      setList: setList,
      onEnd: onEnd,
      ghostClass: "sage-sortable__item--ghost",
      chosenClass: "sage-sortable__item--active",
      dragClass: "sage-sortable__item--drag"
    }, rest), list.map(function (item) {
      return renderItem(item);
    })));
  };

  Sortable_Sortable.Item = SortableItem_SortableItem;
  Sortable_Sortable.defaultProps = {};
  Sortable_Sortable.propTypes = {
    list: prop_types_default.a.arrayOf(prop_types_default.a.shape({
      id: prop_types_default.a.string
    })).isRequired,
    setList: prop_types_default.a.func.isRequired,
    onEnd: prop_types_default.a.func.isRequired,
    renderItem: prop_types_default.a.func.isRequired
  }; // CONCATENATED MODULE: ./lib/Sortable/index.js
  // CONCATENATED MODULE: ./lib/StatBox/configs.js

  var configs_LABEL_COLORS = {
    DEFAULT: 'draft',
    PUBLISHED: 'published',
    DANGER: 'danger'
  };
  var LEGEND_COLORS = {
    CHARCOAL: 'grey',
    GREY: 'grey',
    ORANGE: 'orange',
    PRIMARY: 'primary',
    PURPLE: 'purple',
    RED: 'red',
    SAGE: 'sage',
    YELLOW: 'yellow'
  };
  var TYPE = {
    DEFAULT: 'neutral',
    NEGATIVE: 'negative',
    POSITIVE: 'positive'
  }; // CONCATENATED MODULE: ./lib/StatBox/StatBox.jsx
  // component configurations as needed

  var StatBox_StatBox = function StatBox(_ref) {
    var _classnames;

    var customLabel = _ref.customLabel,
        change = _ref.change,
        data = _ref.data,
        hasData = _ref.hasData,
        icon = _ref.icon,
        image = _ref.image,
        legendDotColor = _ref.legendDotColor,
        legendDotCustomColor = _ref.legendDotCustomColor,
        link = _ref.link,
        popover = _ref.popover,
        raised = _ref.raised,
        timeframe = _ref.timeframe,
        title = _ref.title;
    var statBoxContainer = classnames_default()('sage-stat-box', {
      'sage-stat-box--raised': raised,
      'sage-stat-box--with-img': image,
      'sage-stat-box--with-icon': icon
    });
    var statBoxTitle = classnames_default()('sage-stat-box__title', (_classnames = {}, defineProperty_default()(_classnames, "sage-stat-box__title--legend-".concat(legendDotColor), legendDotColor), defineProperty_default()(_classnames, 'sage-stat-box__title--legend-custom', legendDotCustomColor), _classnames));

    var renderLabelStatus = function renderLabelStatus() {
      var color;

      switch (change.type) {
        case StatBox.TYPE.POSITIVE:
          color = StatBox.LABEL_COLORS.PUBLISHED;
          break;

        case StatBox.TYPE.NEGATIVE:
          color = StatBox.LABEL_COLORS.DANGER;
          break;

        default:
          color = StatBox.LABEL_COLORS.DRAFT;
          break;
      }

      return /*#__PURE__*/external_react_default.a.createElement(Badge, {
        color: color,
        value: change.value,
        dot: /*#__PURE__*/external_react_default.a.createElement(Dot_Dot, null)
      });
    };

    return /*#__PURE__*/external_react_default.a.createElement("article", {
      className: statBoxContainer
    }, icon && /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-stat-box__icon"
    }, /*#__PURE__*/external_react_default.a.createElement(Icon_Icon, {
      cardColor: icon.cardColor,
      color: icon.color,
      icon: icon.name
    })), image && /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-stat-box__img"
    }, /*#__PURE__*/external_react_default.a.createElement("img", {
      src: image.src,
      alt: image.alt || ''
    })), /*#__PURE__*/external_react_default.a.createElement("header", {
      className: "sage-stat-box__header"
    }, /*#__PURE__*/external_react_default.a.createElement("h2", {
      className: statBoxTitle,
      style: legendDotCustomColor && legendDotCustomColor !== '' && {
        '--legend-color': legendDotCustomColor
      }
    }, title), popover), /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-stat-box__body sage-grid-template-te"
    }, /*#__PURE__*/external_react_default.a.createElement("p", {
      className: "sage-stat-box__data ".concat(!hasData ? 'sage-stat-box__data--no-data' : null)
    }, data, timeframe && /*#__PURE__*/external_react_default.a.createElement("span", {
      className: "sage-stat-box__timeframe"
    }, timeframe)), customLabel || change && renderLabelStatus()), link && /*#__PURE__*/external_react_default.a.createElement("footer", {
      className: "sage-stat-box__footer"
    }, /*#__PURE__*/external_react_default.a.createElement(Button, {
      color: Button.COLORS.PRIMARY,
      href: link.href,
      icon: SageTokens.ICONS.ARROW_RIGHT,
      iconPosition: Button.ICON_POSITIONS.RIGHT,
      subtle: true,
      className: "sage-stat-box__link"
    }, link.value)));
  };

  StatBox_StatBox.LABEL_COLORS = configs_LABEL_COLORS;
  StatBox_StatBox.LEGEND_COLORS = LEGEND_COLORS;
  StatBox_StatBox.TYPE = TYPE;
  StatBox_StatBox.defaultProps = {
    change: {
      type: StatBox_StatBox.TYPE.DEFAULT,
      value: null
    },
    customLabel: null,
    hasData: true,
    icon: null,
    image: null,
    legendDotColor: null,
    legendDotCustomColor: null,
    link: null,
    popover: null,
    raised: false,
    timeframe: null
  };
  StatBox_StatBox.propTypes = {
    change: prop_types_default.a.shape({
      type: prop_types_default.a.oneOf(Object.values(StatBox_StatBox.TYPE)),
      value: prop_types_default.a.string
    }),
    customLabel: prop_types_default.a.node,
    data: prop_types_default.a.string.isRequired,
    hasData: prop_types_default.a.bool,
    icon: prop_types_default.a.shape({
      cardColor: prop_types_default.a.oneOf(Object.values(Icon_Icon.CARD_COLORS)),
      color: prop_types_default.a.oneOf(Object.values(Icon_Icon.COLORS)),
      name: prop_types_default.a.oneOf(Object.values(Icon_Icon.ICONS))
    }),
    image: prop_types_default.a.shape({
      alt: prop_types_default.a.string,
      src: prop_types_default.a.string
    }),
    legendDotColor: prop_types_default.a.oneOf(Object.values(StatBox_StatBox.LEGEND_COLORS)),
    legendDotCustomColor: prop_types_default.a.string,
    link: prop_types_default.a.shape({
      href: prop_types_default.a.string,
      value: prop_types_default.a.string
    }),
    popover: prop_types_default.a.node,
    raised: prop_types_default.a.bool,
    timeframe: prop_types_default.a.string,
    title: prop_types_default.a.string.isRequired
  }; // CONCATENATED MODULE: ./lib/StatBox/index.js
  // CONCATENATED MODULE: ./lib/helpers/tables/dataTypes.js
  // Sage Data Types

  var SAGE_DATA_TYPES = {
    BOOL: 'bool',
    NUM: 'number',
    DATE: 'date',
    STRING: 'string',
    AVATAR: 'avatar',
    LABEL: 'label',
    HTML: 'html'
  }; // CONCATENATED MODULE: ./lib/helpers/tables/dataRenderers.jsx
  // Data Renderers

  var renderBooleanAsYesOrNo = function renderBooleanAsYesOrNo(data) {
    return data ? 'Yes' : 'No';
  };

  var dataRenderers_renderObjectAsAvatar = function renderObjectAsAvatar(data) {
    var initials = data.initials,
        color = data.color;

    if (!color) {
      // get a random color
      var colorKeys = Object.keys(Avatar_Avatar.COLORS);
      var index = Math.floor(Math.random() * colorKeys.length);
      color = Avatar_Avatar.COLORS[colorKeys[index]];
    }

    if (!initials) {
      // Try to use first two characters of a string
      if (typeof data === 'string') {
        initials = data.substring(0, 2).toUpperCase();
      } else {
        initials = '?';
      }
    }

    return /*#__PURE__*/external_react_default.a.createElement(Avatar_Avatar, {
      initials: initials,
      color: color
    });
  };

  var renderObjectAsHTML = function renderObjectAsHTML(data) {
    return data;
  };

  var dataRenderers_renderObjectAsLabel = function renderObjectAsLabel(_ref) {
    var color = _ref.color,
        value = _ref.value;
    return /*#__PURE__*/external_react_default.a.createElement(Badge, {
      color: color,
      value: value
    });
  };

  var renderStringAsIs = function renderStringAsIs(data) {
    return typeof data === 'string' || typeof data === 'number' ? data : '?';
  }; // CONCATENATED MODULE: ./lib/helpers/tables/index.js

  /* eslint-disable valid-typeof */
  // Sage Data Type Renderers map


  var tables_typeRenderers = {
    avatar: {
      customType: SAGE_DATA_TYPES.AVATAR,
      render: dataRenderers_renderObjectAsAvatar
    },
    label: {
      customType: SAGE_DATA_TYPES.LABEL,
      render: dataRenderers_renderObjectAsLabel
    },
    html: {
      customType: SAGE_DATA_TYPES.HTML,
      render: renderObjectAsHTML
    },
    "boolean": {
      rawType: 'boolean',
      customType: SAGE_DATA_TYPES.BOOL,
      render: renderBooleanAsYesOrNo
    },
    "default": {
      render: renderStringAsIs
    }
  }; // Renders based on provided data types (custom) or actual type (raw)

  var tables_renderDataTypes = function renderDataTypes(data, dataType, renderers) {
    var selfRenderers = renderers || tables_typeRenderers;
    var keys = Object.keys(selfRenderers); // First search for a matching renderer from the provided renderers

    var renderedValue;

    for (var i = 0; i < keys.length; i += 1) {
      var _renderers$keys$i = renderers[keys[i]],
          customType = _renderers$keys$i.customType,
          rawType = _renderers$keys$i.rawType,
          render = _renderers$keys$i.render;

      if (customType && customType === dataType) {
        renderedValue = render(data);
        break;
      } else if (rawType && typeof_default()(data) === rawType) {
        renderedValue = render(data);
        break;
      }
    } // If no match is found, use Sage default renderer


    if (renderedValue === undefined) {
      renderedValue = selfRenderers["default"].render(data);
    }

    return renderedValue;
  };

  var TableHelpers = {
    DATA_TYPES: SAGE_DATA_TYPES,
    renderDataTypes: tables_renderDataTypes,
    typeRenderers: tables_typeRenderers
  }; // CONCATENATED MODULE: ./lib/helpers/index.js
  // CONCATENATED MODULE: ./lib/Table/configs.js

  var CAPTION_SIDE = {
    BOTTOM: 'bottom',
    TOP: 'top'
  }; // Basic data value types

  var configs_dataPropTypes = prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number, prop_types_default.a.bool, prop_types_default.a.shape({})]); // Cell structure

  var cellPropTypes = {
    attributes: prop_types_default.a.shape({}),
    className: prop_types_default.a.string,
    dataType: prop_types_default.a.string,
    field: prop_types_default.a.string,
    id: prop_types_default.a.string,
    style: prop_types_default.a.shape({}),
    value: configs_dataPropTypes
  }; // CONCATENATED MODULE: ./lib/Table/helpers.js
  //
  // The transformers in this helper accept data in a variety of forms
  // and ensure they resolve into a single consistent structure for use in tables.
  // See `cellPropTypes` for this final structure.
  //
  // This structure is extracted from provided data ensuring that at least
  // the `value` property is present in a way that it can be displayed
  // as content of a table header or table cell.
  //
  // Transforms individual cells

  var helpers_parseCellData = function parseCellData(cell, _field) {
    var attributes = null,
        className = null,
        dataType = null,
        field = _field || null,
        id = uuid_default()(),
        style = null,
        value = cell;

    if (cell && typeof_default()(cell) === 'object') {
      // Allow each property to pass or fall back to default
      attributes = cell.attributes || attributes;
      className = cell.className || className;
      dataType = cell.dataType || dataType;
      field = cell.field || field;
      id = cell.id || id;
      style = cell.style || style; // Empty strings are allowed in value, so a little more logic is needed

      if (cell.value !== undefined && cell.value !== null) {
        value = cell.value;
      }
    } else {
      value = cell;
    }

    return {
      attributes: attributes,
      className: className,
      dataType: dataType,
      field: field,
      id: id,
      style: style,
      value: value
    };
  }; // Ensures a consistent structure for cells in a row
  // Returns an array of specially formatted objects.
  // See `cellPropTypes`.


  var parseRowData = function parseRowData(row, schema) {
    var parsedRow = [];

    if (row instanceof Array) {
      // An array for the row means we don't have field names provided
      // so we check the schema for field names as we parse the items
      parsedRow = row.map(function (cell, i) {
        var field = null; // If we have a schema, it should provide
        // the field name to use for this cell
        // but this is not required.
        // The schema should contain the same number of properties
        // as the row has cells, and in the same order,
        // but the schema may indicate that a cell should be skipped
        // by having a `false` value assigned to it.

        if (schema) {
          field = Object.keys(schema)[i];
        }

        return helpers_parseCellData(cell, field);
      });
    } else if (row instanceof Object) {
      // An object for the row must be parse by the keys in contains
      // and such an object will assume the keys are field names
      parsedRow = Object.keys(row).map(function (field) {
        return helpers_parseCellData(row[field], field);
      });
    }

    return parsedRow;
  }; // CONCATENATED MODULE: ./lib/Table/TableHeader.jsx


  function TableHeader_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function TableHeader_objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? TableHeader_ownKeys(Object(source), !0).forEach(function (key) {
        defineProperty_default()(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : TableHeader_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }

    return target;
  }
  /* eslint-disable react/default-props-match-prop-types */


  var TableHeader_TableHeader = function TableHeader(_ref) {
    var attributes = _ref.attributes,
        children = _ref.children,
        className = _ref.className,
        dataType = _ref.dataType,
        style = _ref.style,
        value = _ref.value;
    var classNames = classnames_default()('sage-table__header', className, defineProperty_default()({}, "sage-table__header--".concat(dataType), dataType));
    return /*#__PURE__*/external_react_default.a.createElement("th", extends_default()({
      className: classNames,
      style: style
    }, attributes), value, children);
  };

  TableHeader_TableHeader.parseHeaderData = helpers_parseCellData;
  TableHeader_TableHeader.defaultProps = {
    attributes: null,
    children: null,
    className: null,
    dataType: null,
    style: null,
    value: null
  };
  TableHeader_TableHeader.propTypes = TableHeader_objectSpread(TableHeader_objectSpread({}, cellPropTypes), {}, {
    children: prop_types_default.a.node
  }); // CONCATENATED MODULE: ./lib/Table/TableRow.jsx

  var TableRow_TableRow = function TableRow(_ref) {
    var className = _ref.className,
        cells = _ref.cells,
        id = _ref.id,
        hasBorders = _ref.hasBorders,
        onSelect = _ref.onSelect,
        schema = _ref.schema,
        selectable = _ref.selectable,
        selected = _ref.selected,
        typeRenderers = _ref.typeRenderers;

    var _useState = Object(external_react_["useState"])(false),
        _useState2 = slicedToArray_default()(_useState, 2),
        selfSelected = _useState2[0],
        setSelfSelected = _useState2[1];

    var _useState3 = Object(external_react_["useState"])([]),
        _useState4 = slicedToArray_default()(_useState3, 2),
        selfCells = _useState4[0],
        setSelfCells = _useState4[1];

    var classNames = classnames_default()('sage-table__row', className, {
      'sage-table__row--selectable': selectable
    });
    var selectableClassNames = classnames_default()('sage-table-cell', 'sage-table-cell--checkbox', className, {
      'sage-table-cell--borders': hasBorders
    });
    Object(external_react_["useEffect"])(function () {
      setSelfSelected(selected);
    }, [selected]);
    Object(external_react_["useEffect"])(function () {
      var selfTypeRenderers = Object.assign(typeRenderers, TableHelpers.typeRenderers);
      var newCells = cells.map(function (_ref2) {
        var field = _ref2.field,
            attributes = _ref2.attributes,
            className = _ref2.className,
            dataType = _ref2.dataType,
            style = _ref2.style,
            value = _ref2.value;

        if (schema && !schema[field]) {
          return null;
        }

        if (schema) {
          var _schema$field = schema[field],
              schemaAttributes = _schema$field.attributes,
              schemaClassName = _schema$field.className,
              schemaDataType = _schema$field.dataType,
              schemaStyle = _schema$field.style;
          attributes = attributes || schemaAttributes;
          className = className || schemaClassName;
          dataType = dataType || schemaDataType;
          style = style || schemaStyle;
        }

        var cellClassnames = classnames_default()('sage-table-cell', className, defineProperty_default()({
          'sage-table-cell--borders': hasBorders
        }, "sage-table-cell--".concat(dataType), dataType));
        return {
          attributes: attributes,
          classNames: cellClassnames,
          contents: TableHelpers.renderDataTypes(value, dataType, selfTypeRenderers),
          key: uuid_default()(),
          style: style
        };
      });
      setSelfCells(newCells);
    }, [cells, schema, typeRenderers]);

    var onChangeSelector = function onChangeSelector(value, checked) {
      setSelfSelected(!checked);
      onSelect(id);
    };

    return /*#__PURE__*/external_react_default.a.createElement("tr", {
      className: classNames,
      "data-table-row-id": id
    }, selectable && /*#__PURE__*/external_react_default.a.createElement("td", {
      className: selectableClassNames
    }, /*#__PURE__*/external_react_default.a.createElement(Checkbox_Checkbox, {
      checked: selfSelected,
      id: "sage-table__row-selector-".concat(id),
      label: "Select row",
      name: "sage-table-selections",
      onChange: onChangeSelector,
      standalone: true,
      value: id.toString()
    })), selfCells.map(function (configs) {
      if (!configs) {
        return;
      }

      var key = configs.key,
          classNames = configs.classNames,
          style = configs.style,
          attributes = configs.attributes,
          contents = configs.contents; // eslint-disable-next-line consistent-return

      return /*#__PURE__*/external_react_default.a.createElement("td", extends_default()({
        key: key,
        className: classNames,
        style: style
      }, attributes), contents);
    }));
  };

  TableRow_TableRow.parseCellData = helpers_parseCellData;
  TableRow_TableRow.parseRowData = parseRowData;
  TableRow_TableRow.defaultProps = {
    className: null,
    cells: [],
    hasBorders: false,
    onSelect: function onSelect(ev) {
      return ev;
    },
    selectable: false,
    selected: false,
    typeRenderers: {},
    schema: {}
  };
  TableRow_TableRow.propTypes = {
    className: prop_types_default.a.string,
    cells: prop_types_default.a.arrayOf(prop_types_default.a.shape(cellPropTypes)),
    hasBorders: prop_types_default.a.bool,
    id: prop_types_default.a.oneOfType([prop_types_default.a.number, prop_types_default.a.string]).isRequired,
    onSelect: prop_types_default.a.func,
    selectable: prop_types_default.a.bool,
    selected: prop_types_default.a.bool,
    schema: prop_types_default.a.shape({}),
    typeRenderers: prop_types_default.a.shape({})
  }; // CONCATENATED MODULE: ./lib/Table/Table.jsx
  //
  // Tables are built out from a provided set of rows.
  // These rows can be provided in a variety of formats,
  // typically, as an array of arrays or an array of objects.
  // Regardless, they are parsed by this component
  // into a collection structure (array of objects) for flexible rendering.
  // See `cellPropTypes` for this structure.
  //
  // In order for a set of rows to be tailored to display in particular ways,
  // a `schema` can be provided that specifies the header, data type, html attributes,
  // and custom style attributes for each cell of data in each row.
  // If cells are included in the data but omitted from the schema,
  // those cells will also be omitted from display.
  //
  // `headers` can also be provided apart from a `schema` if
  // either you want to override schema settings specifically for one or more headings
  // or if no schema is provided and you want to specify just settings for headers.
  // `headers` can be a simple array of strings to show in the `th` cells in the order provided,
  // or they can use the cell data structure with a label, dataType, attributes, etc.
  // If a schema is provided, a matching entry in `headers` will override for any settings provided.
  // If no schema is provided, the number of items in `headers` must match the items in each row
  // for a properly formatted table.
  //

  var Table_Table = function Table(_ref) {
    var caption = _ref.caption,
        captionSide = _ref.captionSide,
        className = _ref.className,
        hasBorders = _ref.hasBorders,
        hasDataBeyondCurrentRows = _ref.hasDataBeyondCurrentRows,
        headers = _ref.headers,
        isResponsive = _ref.isResponsive,
        onSelectRowHook = _ref.onSelectRowHook,
        resetAbove = _ref.resetAbove,
        resetBelow = _ref.resetBelow,
        rows = _ref.rows,
        schema = _ref.schema,
        selectable = _ref.selectable,
        selectAllConfigs = _ref.selectAllConfigs,
        selectedRows = _ref.selectedRows,
        showSelectAll = _ref.showSelectAll,
        tableAttributes = _ref.tableAttributes;

    var _useState = Object(external_react_["useState"])([]),
        _useState2 = slicedToArray_default()(_useState, 2),
        selfSelectedRows = _useState2[0],
        setSelfSelectedRows = _useState2[1];

    var _useState3 = Object(external_react_["useState"])([]),
        _useState4 = slicedToArray_default()(_useState3, 2),
        selfHeaders = _useState4[0],
        setSelfHeaders = _useState4[1];

    var _useState5 = Object(external_react_["useState"])(SELECTION_TYPES.NONE),
        _useState6 = slicedToArray_default()(_useState5, 2),
        selfSelectionType = _useState6[0],
        setSelfSelectionType = _useState6[1];

    var containerClassNames = classnames_default()('sage-table-wrapper', className, {
      'sage-table-wrapper--reset-above': resetAbove,
      'sage-table-wrapper--reset-below': resetBelow
    });
    var tableClassNames = classnames_default()('sage-table', {
      'sage-table--selectable': selectable
    }); //
    // Component utilities
    //

    var extractHeaderOverrides = function extractHeaderOverrides(field, index) {
      var overrides = null; // If headers is an array look for matching index
      // Or if headers is an object, look for field

      if (headers instanceof Array) {
        overrides = headers[index];
      } else if (headers instanceof Object) {
        overrides = headers[field];
      } // If match is just a string, map it to the label prop


      if (typeof overrides === 'string') {
        overrides = {
          label: overrides
        };
      }

      return overrides;
    };

    var buildHeaders = function buildHeaders() {
      if (!headers && !schema) {
        return;
      }

      var newSelfHeaders = []; // If schema is provided use it as a base for headers

      if (schema) {
        newSelfHeaders = Object.keys(schema).map(function (field, i) {
          // Fetch configs for this schema item
          var _schema$field = schema[field],
              attributes = _schema$field.attributes,
              className = _schema$field.className,
              dataType = _schema$field.dataType,
              label = _schema$field.label,
              style = _schema$field.style; // Check for configs in header and override where applicable

          if (headers) {
            var overrides = extractHeaderOverrides(field, i);

            if (overrides) {
              var overrideAttributes = overrides.attributes,
                  overrideClassname = overrides.className,
                  overrideDataType = overrides.dataType,
                  overrideLabel = overrides.label,
                  overrideStyle = overrides.style;
              attributes = overrideAttributes || attributes;
              className = overrideClassname || className;
              dataType = overrideDataType || dataType;
              label = overrideLabel || label;
              style = overrideStyle || style;
            }
          }

          return {
            attributes: attributes,
            className: className,
            dataType: dataType,
            field: field,
            style: style,
            value: label
          };
        });
      } else if (headers) {
        newSelfHeaders = headers.map(TableHeader_TableHeader.parseHeaderData);
      }

      setSelfHeaders(newSelfHeaders);
    };

    var getSelectionType = function getSelectionType(selection) {
      if (selection === SELECTION_TYPES.ALL) {
        return SELECTION_TYPES.ALL;
      }

      if (selection.length === 0) {
        return SELECTION_TYPES.NONE;
      }

      if (hasDataBeyondCurrentRows) {
        return SELECTION_TYPES.PARTIAL;
      }

      return selection.length === rows.length ? SELECTION_TYPES.ALL : SELECTION_TYPES.PARTIAL;
    }; //
    // Component state and event handlers
    //
    // Ensure headers are built out dynamically


    Object(external_react_["useEffect"])(function () {
      buildHeaders();
    }, [schema, headers]); // Ensure selected rows change when adjusted from the outside

    Object(external_react_["useEffect"])(function () {
      setSelfSelectedRows(selectedRows);
      setSelfSelectionType(getSelectionType(selectedRows));
    }, [selectedRows]);

    var removeFromList = function removeFromList(data, list) {
      return list.filter(function (each) {
        return each !== data;
      });
    };

    var addToList = function addToList(data, list) {
      return [].concat(toConsumableArray_default()(list), [data]);
    };

    var onToggleSelection = function onToggleSelection() {
      var selectedRows, selectionType;

      if (selfSelectionType === SELECTION_TYPES.NONE) {
        selectedRows = SELECTION_TYPES.ALL;
        selectionType = SELECTION_TYPES.ALL;
      } else {
        selectedRows = [];
        selectionType = SELECTION_TYPES.NONE;
      }

      setSelfSelectionType(selectionType);
      setSelfSelectedRows(selectedRows);

      if (onSelectRowHook) {
        onSelectRowHook({
          selectedRows: selectedRows
        });
      }
    };

    var onSelectRow = function onSelectRow(data) {
      var updatedArray;

      if (selfSelectedRows === SELECTION_TYPES.ALL) {
        // If ALL selected currently, build an array of current row ids
        updatedArray = rows.map(function (_ref2) {
          var id = _ref2.id;
          return id;
        });
      } else {
        // Otherwise, we should already have just ids in the selfSelectedRows list
        updatedArray = selfSelectedRows;
      } // Now toggle the indicated item


      var rowsSelected = updatedArray.includes(data);
      updatedArray = rowsSelected ? removeFromList(data, updatedArray) : addToList(data, updatedArray);
      setSelfSelectedRows(updatedArray);
      setSelfSelectionType(getSelectionType(updatedArray));

      if (onSelectRowHook) {
        onSelectRowHook({
          changedRow: {
            row: data,
            selected: rowsSelected
          },
          selectedRows: updatedArray
        });
      }
    }; // Renders the cells in the header row


    var renderTableHeader = function renderTableHeader(_ref3) {
      var attributes = _ref3.attributes,
          className = _ref3.className,
          dataType = _ref3.dataType,
          field = _ref3.field,
          style = _ref3.style,
          value = _ref3.value; // Skip headers not present in schema

      if (schema && !schema[field]) {
        return null;
      }

      return /*#__PURE__*/external_react_default.a.createElement(TableHeader_TableHeader, {
        key: uuid_default()(),
        attributes: attributes,
        className: className,
        dataType: dataType,
        style: style,
        value: value
      });
    }; // Renders a row of cells


    var renderTableRow = function renderTableRow(row) {
      // Ensure there's a unique id for the row if one is not provided
      var rowId = row.id || uuid_default()(); // Transform the raw row data into a consistent structure

      var cells = TableRow_TableRow.parseRowData(row, schema);
      return /*#__PURE__*/external_react_default.a.createElement(TableRow_TableRow, {
        hasBorders: hasBorders,
        key: rowId,
        id: rowId,
        cells: cells,
        schema: schema,
        selected: selfSelectedRows === SELECTION_TYPES.ALL || selfSelectedRows.includes(rowId),
        selectable: selectable,
        onSelect: onSelectRow
      });
    }; // Renders the table itself


    var renderTable = function renderTable() {
      return /*#__PURE__*/external_react_default.a.createElement("table", extends_default()({
        className: tableClassNames
      }, tableAttributes), caption && /*#__PURE__*/external_react_default.a.createElement("caption", {
        className: "sage-table__caption--".concat(captionSide || CAPTION_SIDE.BOTTOM)
      }, caption), selfHeaders && /*#__PURE__*/external_react_default.a.createElement("thead", null, /*#__PURE__*/external_react_default.a.createElement("tr", null, selectable && /*#__PURE__*/external_react_default.a.createElement(TableHeader_TableHeader, {
        dataType: "checkbox"
      }, showSelectAll ? /*#__PURE__*/external_react_default.a.createElement(Checkbox_Checkbox, extends_default()({
        standalone: true,
        partialSelection: selfSelectionType === SELECTION_TYPES.PARTIAL,
        checked: selfSelectionType !== SELECTION_TYPES.NONE,
        onChange: onToggleSelection
      }, selectAllConfigs)) : ' '), selfHeaders.map(renderTableHeader))), /*#__PURE__*/external_react_default.a.createElement("tbody", null, rows.map(renderTableRow)));
    };

    return /*#__PURE__*/external_react_default.a.createElement("div", {
      className: containerClassNames
    }, isResponsive ? /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-table-wrapper__overflow"
    }, renderTable()) : renderTable());
  };

  Table_Table.Header = TableHeader_TableHeader;
  Table_Table.Row = TableRow_TableRow;
  Table_Table.CAPTION_SIDE = CAPTION_SIDE;
  Table_Table.DATA_TYPES = TableHelpers.DATA_TYPES;
  Table_Table.defaultProps = {
    caption: null,
    captionSide: null,
    className: null,
    hasBorders: false,
    hasDataBeyondCurrentRows: false,
    headers: [],
    isResponsive: true,
    onSelectRowHook: null,
    resetAbove: false,
    resetBelow: false,
    rows: [],
    schema: null,
    selectable: true,
    selectAllConfigs: null,
    selectedRows: [],
    showSelectAll: false,
    tableAttributes: null
  };
  Table_Table.propTypes = {
    caption: prop_types_default.a.string,
    captionSide: prop_types_default.a.oneOf(Object.values(Table_Table.CAPTION_SIDE)),
    className: prop_types_default.a.string,
    hasBorders: prop_types_default.a.bool,
    hasDataBeyondCurrentRows: prop_types_default.a.bool,
    // Headers provide a simpler alternative to schema
    headers: prop_types_default.a.oneOfType([prop_types_default.a.arrayOf(prop_types_default.a.oneOfType([prop_types_default.a.shape(cellPropTypes), prop_types_default.a.string])), prop_types_default.a.shape({})]),
    isResponsive: prop_types_default.a.bool,
    onSelectRowHook: prop_types_default.a.func,
    resetAbove: prop_types_default.a.bool,
    resetBelow: prop_types_default.a.bool,
    rows: prop_types_default.a.arrayOf(prop_types_default.a.oneOfType([prop_types_default.a.shape(cellPropTypes), prop_types_default.a.arrayOf(configs_dataPropTypes), prop_types_default.a.shape({})])),
    // Schema provides a structure for applying settings to headers and cells
    schema: prop_types_default.a.shape({}),
    selectable: prop_types_default.a.bool,
    selectAllConfigs: prop_types_default.a.shape({
      id: prop_types_default.a.string.isRequired,
      name: prop_types_default.a.string.isRequired,
      label: prop_types_default.a.string.isRequired,
      onChange: prop_types_default.a.func
    }),
    selectedRows: prop_types_default.a.oneOfType([prop_types_default.a.oneOf([SELECTION_TYPES.ALL]), prop_types_default.a.arrayOf(prop_types_default.a.oneOfType([prop_types_default.a.number, prop_types_default.a.shape({}), prop_types_default.a.string]))]),
    showSelectAll: prop_types_default.a.bool,
    tableAttributes: prop_types_default.a.shape({})
  }; // CONCATENATED MODULE: ./lib/Table/index.js
  // CONCATENATED MODULE: ./lib/Tag/Tag.jsx

  var Tag_Tag = function Tag(_ref) {
    var className = _ref.className,
        dismissAttributes = _ref.dismissAttributes,
        image = _ref.image,
        showDismiss = _ref.showDismiss,
        value = _ref.value;
    var classNames = classnames_default()('sage-tag', className, {
      'sage-tag--has-image': image
    });
    return /*#__PURE__*/external_react_default.a.createElement("span", {
      className: classNames
    }, image && /*#__PURE__*/external_react_default.a.createElement("img", {
      className: "sage-tag__image",
      src: image,
      alt: "",
      role: "presentation"
    }), /*#__PURE__*/external_react_default.a.createElement("span", {
      className: "sage-tag__value"
    }, value), showDismiss && /*#__PURE__*/external_react_default.a.createElement(Button, extends_default()({
      className: "sage-tag__button",
      color: Button.COLORS.PRIMARY,
      icon: SageTokens.ICONS.REMOVE,
      iconOnly: true,
      subtle: true,
      small: true
    }, dismissAttributes), value));
  };

  Tag_Tag.defaultProps = {
    className: null,
    dismissAttributes: null,
    image: null,
    showDismiss: false
  };
  Tag_Tag.propTypes = {
    className: prop_types_default.a.string,
    dismissAttributes: prop_types_default.a.shape({}),
    image: prop_types_default.a.string,
    showDismiss: prop_types_default.a.bool,
    value: prop_types_default.a.string.isRequired
  }; // CONCATENATED MODULE: ./lib/Tag/index.js
  // CONCATENATED MODULE: ./lib/Textarea/Textarea.jsx

  var Textarea_excluded = ["className", "disabled", "hasError", "id", "label", "message", "onChange", "value"];

  var Textarea_Textarea = function Textarea(_ref) {
    var className = _ref.className,
        disabled = _ref.disabled,
        hasError = _ref.hasError,
        id = _ref.id,
        label = _ref.label,
        message = _ref.message,
        onChange = _ref.onChange,
        value = _ref.value,
        rest = objectWithoutProperties_default()(_ref, Textarea_excluded);

    var _useState = Object(external_react_["useState"])(null),
        _useState2 = slicedToArray_default()(_useState, 2),
        fieldValue = _useState2[0],
        updateFieldValue = _useState2[1];

    var classNames = classnames_default()('sage-textarea', className, {
      'sage-form-field--error': hasError
    });

    var handleChange = function handleChange(e) {
      if (onChange) {
        onChange(e);
      } else {
        updateFieldValue(e.target.value);
      }
    };

    return /*#__PURE__*/external_react_default.a.createElement("div", {
      className: classNames
    }, /*#__PURE__*/external_react_default.a.createElement("textarea", extends_default()({
      className: "sage-textarea__field",
      disabled: disabled,
      id: id,
      onChange: handleChange,
      placeholder: label,
      value: fieldValue || value
    }, rest)), label && /*#__PURE__*/external_react_default.a.createElement("label", {
      htmlFor: id,
      className: "sage-textarea__label"
    }, label), message && /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-textarea__info"
    }, /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-textarea__message"
    }, message)));
  };

  Textarea_Textarea.TEST = 'TEST';
  Textarea_Textarea.defaultProps = {
    className: null,
    disabled: false,
    hasError: false,
    label: null,
    message: null,
    onChange: null,
    value: ''
  };
  Textarea_Textarea.propTypes = {
    className: prop_types_default.a.string,
    disabled: prop_types_default.a.bool,
    id: prop_types_default.a.string.isRequired,
    hasError: prop_types_default.a.bool,
    label: prop_types_default.a.string,
    message: prop_types_default.a.string,
    onChange: prop_types_default.a.func,
    value: prop_types_default.a.string
  }; // CONCATENATED MODULE: ./lib/Textarea/index.js
  // CONCATENATED MODULE: ./lib/Toast/configs.js

  var TOAST_TYPES = {
    DEFAULT: null,
    DANGER: 'danger',
    LOADING: 'loading'
  }; // CONCATENATED MODULE: ./lib/Toast/Toast.jsx

  var Toast_Toast = function Toast(_ref) {
    var className = _ref.className,
        description = _ref.description,
        icon = _ref.icon,
        isActive = _ref.isActive,
        onDismiss = _ref.onDismiss,
        timeout = _ref.timeout,
        link = _ref.link,
        type = _ref.type,
        title = _ref.title;

    var _useState = Object(external_react_["useState"])(!isActive),
        _useState2 = slicedToArray_default()(_useState, 2),
        isDismissed = _useState2[0],
        setDismissed = _useState2[1];

    var dismiss = function dismiss(dismissed) {
      if (dismissed) {
        if (onDismiss) {
          onDismiss();
        }

        setDismissed(true);
      } else {
        setDismissed(false);
      }
    };

    var onClickDismiss = function onClickDismiss() {
      dismiss(true);
    }; // Auto dismiss when applicable


    Object(external_react_["useEffect"])(function () {
      if (timeout && isActive) {
        setTimeout(function () {
          dismiss(true);
        }, timeout);
      }
    }, [timeout, isActive]); // Toggle dismissed when isActive changes

    Object(external_react_["useEffect"])(function () {
      dismiss(!isActive);
    }, [isActive]);
    var classNames = classnames_default()('sage-toast', className, defineProperty_default()({}, "sage-toast--style-".concat(type), type));
    var id = uuid_default()();

    var renderAsset = function renderAsset() {
      if (type === Toast.TYPES.LOADING) {
        return /*#__PURE__*/external_react_default.a.createElement("svg", {
          className: "sage-loader__spinner sage-loader__spinner--loading-button",
          "aria-hidden": "true",
          viewBox: "25 25 50 50"
        }, /*#__PURE__*/external_react_default.a.createElement("circle", {
          className: "sage-loader__spinner sage-loader__spinner-path sage-loader__spinner-path--loading-button",
          cx: "50",
          cy: "50",
          r: "20",
          fill: "none",
          stroke: "0072EF",
          strokeWidth: "4"
        }));
      }

      if (icon) {
        return /*#__PURE__*/external_react_default.a.createElement(Icon_Icon, {
          className: "sage-toast__icon",
          icon: icon
        });
      }

      return false;
    };

    return !isDismissed && /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-toast-container"
    }, /*#__PURE__*/external_react_default.a.createElement("dialog", {
      open: true,
      className: classNames,
      "aria-labelledby": "sage-toast-label-".concat(id)
    }, renderAsset(), /*#__PURE__*/external_react_default.a.createElement("output", {
      className: "sage-toast__value",
      id: "sage-toast-label-".concat(id),
      "aria-live": "assertive",
      "aria-atomic": "true"
    }, title, " ", description), link && /*#__PURE__*/external_react_default.a.createElement("a", {
      href: link.href,
      className: "sage-toast__button sage-toast__button--underline"
    }, link.text), /*#__PURE__*/external_react_default.a.createElement("button", {
      type: "button",
      className: "sage-toast__button sage-toast__button--close sage-btn sage-btn--subtle sage-btn--secondary sage-btn--icon-only-remove",
      onClick: onClickDismiss
    }, /*#__PURE__*/external_react_default.a.createElement("span", {
      className: "visually-hidden"
    }, "Dismiss message"))));
  };

  Toast_Toast.TYPES = TOAST_TYPES;
  Toast_Toast.defaultProps = {
    className: null,
    description: null,
    icon: null,
    isActive: false,
    onDismiss: function onDismiss(evt) {
      return evt;
    },
    timeout: 4500,
    link: null,
    title: null,
    type: Toast_Toast.TYPES.DEFAULT
  };
  Toast_Toast.propTypes = {
    className: prop_types_default.a.string,
    description: prop_types_default.a.string,
    icon: prop_types_default.a.oneOf(Object.values(SageTokens.ICONS)),
    isActive: prop_types_default.a.bool,
    onDismiss: prop_types_default.a.func,
    timeout: prop_types_default.a.oneOfType([prop_types_default.a.number, prop_types_default.a.oneOf([false])]),
    link: prop_types_default.a.shape({
      text: prop_types_default.a.string,
      href: prop_types_default.a.string
    }),
    type: prop_types_default.a.oneOf(Object.values(Toast_Toast.TYPES)),
    title: prop_types_default.a.string
  }; // CONCATENATED MODULE: ./lib/Toast/index.js
  // CONCATENATED MODULE: ./lib/Toolbar/ToolbarGroup.jsx

  var ToolbarGroup_excluded = ["children", "className"];

  var ToolbarGroup_ToolbarGroup = function ToolbarGroup(_ref) {
    var children = _ref.children,
        className = _ref.className,
        rest = objectWithoutProperties_default()(_ref, ToolbarGroup_excluded);
    return /*#__PURE__*/external_react_default.a.createElement("div", extends_default()({
      className: "sage-toolbar__group ".concat(className || '')
    }, rest), children);
  };

  ToolbarGroup_ToolbarGroup.defaultProps = {
    children: null,
    className: null
  };
  ToolbarGroup_ToolbarGroup.propTypes = {
    children: prop_types_default.a.node,
    className: prop_types_default.a.string
  }; // CONCATENATED MODULE: ./lib/Toolbar/configs.js

  var TOOLBAR_GAP_OPTIONS = {
    XS: null,
    SM: 'sm',
    MD: 'md',
    LG: 'lg'
  }; // CONCATENATED MODULE: ./lib/Toolbar/Toolbar.jsx

  var Toolbar_excluded = ["children", "className", "gap"];

  var Toolbar_Toolbar = function Toolbar(_ref) {
    var children = _ref.children,
        className = _ref.className,
        gap = _ref.gap,
        rest = objectWithoutProperties_default()(_ref, Toolbar_excluded);
    var classNames = classnames_default()('sage-toolbar', className, defineProperty_default()({}, "sage-grid-gap-".concat(gap), gap));
    return /*#__PURE__*/external_react_default.a.createElement("div", extends_default()({
      className: classNames
    }, rest), children);
  };

  Toolbar_Toolbar.Group = ToolbarGroup_ToolbarGroup;
  Toolbar_Toolbar.GAP_OPTIONS = TOOLBAR_GAP_OPTIONS;
  Toolbar_Toolbar.defaultProps = {
    children: null,
    className: null,
    gap: Toolbar_Toolbar.GAP_OPTIONS.MD
  };
  Toolbar_Toolbar.propTypes = {
    children: prop_types_default.a.node,
    className: prop_types_default.a.string,
    gap: prop_types_default.a.oneOf(Object.values(Toolbar_Toolbar.GAP_OPTIONS))
  }; // EXTERNAL MODULE: /__w/sage-lib/sage-lib/node_modules/lodash/debounce.js

  var lodash_debounce = __webpack_require__(24);

  var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce); // CONCATENATED MODULE: ./lib/Dropdown/ToolbarEditorDropdown.jsx


  var ToolbarEditorDropdown_ToolbarEditorDropdown = function ToolbarEditorDropdown(_ref) {
    var align = _ref.align,
        className = _ref.className,
        exitPanelHandler = _ref.exitPanelHandler,
        icon = _ref.icon,
        isPinned = _ref.isPinned,
        onEscapeHook = _ref.onEscapeHook,
        panelMaxWidth = _ref.panelMaxWidth,
        panelSize = _ref.panelSize,
        options = _ref.options,
        triggerClassnames = _ref.triggerClassnames,
        triggerButtonSubtle = _ref.triggerButtonSubtle;
    return /*#__PURE__*/external_react_default.a.createElement(Dropdown_Dropdown, {
      align: align,
      className: className,
      disclosure: true,
      exitPanelHandler: exitPanelHandler,
      icon: icon,
      isLabelVisible: false,
      isPinned: isPinned,
      label: "More options",
      onEscapeHook: onEscapeHook,
      panelMaxWidth: panelMaxWidth,
      panelSize: panelSize,
      triggerModifier: "options",
      triggerButtonSubtle: triggerButtonSubtle,
      triggerClassnames: triggerClassnames
    }, /*#__PURE__*/external_react_default.a.createElement("ul", {
      className: "sage-dropdown__menu"
    }, options.map(function (item) {
      return /*#__PURE__*/external_react_default.a.createElement("li", {
        className: "sage-dropdown__item"
      }, item.label);
    })));
  };

  ToolbarEditorDropdown_ToolbarEditorDropdown.PANEL_SIZES = DROPDOWN_PANEL_SIZES;
  ToolbarEditorDropdown_ToolbarEditorDropdown.POSITIONS = DROPDOWN_POSITIONS;
  ToolbarEditorDropdown_ToolbarEditorDropdown.defaultProps = {
    align: DROPDOWN_POSITIONS.DEFAULT,
    className: null,
    exitPanelHandler: function exitPanelHandler(evt) {
      return evt;
    },
    icon: SageTokens.ICONS.ADD,
    isPinned: true,
    onEscapeHook: function onEscapeHook() {
      return false;
    },
    panelMaxWidth: null,
    panelSize: DROPDOWN_PANEL_SIZES.DEFAULT,
    options: null,
    triggerClassnames: '',
    triggerButtonSubtle: true
  };
  ToolbarEditorDropdown_ToolbarEditorDropdown.propTypes = {
    align: prop_types_default.a.oneOf(Object.values(DROPDOWN_POSITIONS)),
    className: prop_types_default.a.string,
    exitPanelHandler: prop_types_default.a.func,
    icon: prop_types_default.a.oneOf(Object.values(SageTokens.ICONS)),
    isPinned: prop_types_default.a.bool,
    onEscapeHook: prop_types_default.a.func,
    panelMaxWidth: prop_types_default.a.string,
    panelSize: prop_types_default.a.oneOf(Object.values(DROPDOWN_PANEL_SIZES)),
    options: DropdownItemList_DropdownItemList.itemsPropTypes,
    triggerButtonSubtle: prop_types_default.a.bool,
    triggerClassnames: prop_types_default.a.string
  }; // CONCATENATED MODULE: ./lib/Toolbar/ToolbarEditor.jsx

  var ToolbarEditor_excluded = ["name", "isFixed"];

  var ToolbarEditor_ToolbarEditor = function ToolbarEditor(_ref) {
    var name = _ref.name,
        isFixed = _ref.isFixed,
        rest = objectWithoutProperties_default()(_ref, ToolbarEditor_excluded);
    var children = rest.children;
    var MORE_DROPDOWN_WIDTH = 60;
    var navigationRef = Object(external_react_["useRef"])(null);
    var moreMenuRef = Object(external_react_["useRef"])(null);
    var navigationOuterRef = Object(external_react_["useRef"])(null);

    var _useState = Object(external_react_["useState"])(children),
        _useState2 = slicedToArray_default()(_useState, 2),
        priorityItems = _useState2[0],
        setPriorityItems = _useState2[1];

    var _useState3 = Object(external_react_["useState"])([]),
        _useState4 = slicedToArray_default()(_useState3, 2),
        moreItems = _useState4[0],
        setMoreItems = _useState4[1];

    var fullNavArray = [children].flat(Infinity);
    var widthsArray;
    var sectionClassNames = classnames_default()('toolbar-editor__section', {
      'toolbar-editor__section--is-fixed': isFixed
    });

    var calculateWidth = function calculateWidth() {
      if (isFixed) {
        return;
      } // Do not collapse or expand if expected to be fixed


      var availableWidth = navigationOuterRef.current.getBoundingClientRect().width - MORE_DROPDOWN_WIDTH;
      var navWidth = 0,
          moreItemCount = 0,
          sliceIdx = 0;

      if (fullNavArray.length > 1) {
        widthsArray.every(function (width, idx) {
          navWidth += width;

          if (navWidth > availableWidth) {
            moreItemCount = widthsArray.length - idx;
            sliceIdx = idx;
            return false;
          }

          sliceIdx = widthsArray.length;
          return true;
        });
        setPriorityItems(fullNavArray.slice(0, sliceIdx));
      } else {
        setPriorityItems(fullNavArray);
      }

      if (moreItemCount > 0) {
        setMoreItems(fullNavArray.slice(sliceIdx).map(function (item, idx) {
          return {
            id: idx,
            label: item
          };
        }));
      } else {
        setMoreItems([]);
      }
    };

    Object(external_react_["useEffect"])(function () {
      // Get width of all items in navigation menu
      // eslint-disable-next-line react-hooks/exhaustive-deps
      widthsArray = Array.from(navigationRef.current.children).map(function (item) {
        return item.getBoundingClientRect().width;
      }); // Add resize listener but throttle for smoother experience

      window.addEventListener('resize', lodash_debounce_default()(function () {
        calculateWidth();
      }, 500));
      calculateWidth();
      return function () {
        window.removeEventListener('resize', calculateWidth);
      };
    }, []);

    var renderToolbarItem = function renderToolbarItem(item, idx) {
      return /*#__PURE__*/external_react_default.a.createElement("span", {
        key: "".concat(name, "-").concat(idx)
      }, item);
    };

    var renderToolbarItems = function renderToolbarItems(items) {
      return items.map(function (item, idx) {
        return renderToolbarItem(item, idx);
      });
    };

    var getIcon = function getIcon() {
      if (priorityItems.length === 0) {
        return moreItems[0].label.props.icon;
      }

      return 'add';
    };

    return /*#__PURE__*/external_react_default.a.createElement("div", {
      ref: navigationOuterRef,
      className: sectionClassNames,
      "aria-label": name
    }, /*#__PURE__*/external_react_default.a.createElement("span", {
      ref: navigationRef,
      key: "toolbar-editor-".concat(name),
      className: "toolbar-editor__section-list"
    }, priorityItems.length > 1 ? renderToolbarItems(priorityItems) : renderToolbarItem(priorityItems), moreItems.length > 0 && /*#__PURE__*/external_react_default.a.createElement("span", {
      className: "toolbar-editor__section-list-item",
      ref: moreMenuRef
    }, /*#__PURE__*/external_react_default.a.createElement(ToolbarEditorDropdown_ToolbarEditorDropdown, {
      align: "right",
      icon: getIcon(),
      triggerClassnames: "sage-btn--rich-text",
      triggerButtonSubtle: false,
      options: moreItems,
      isPinned: true
    }))));
  };

  ToolbarEditor_ToolbarEditor.defaultProps = {
    isFixed: false,
    name: null
  };
  ToolbarEditor_ToolbarEditor.propTypes = {
    /**
     * Determines whether the toolbar section is flexible or fixed
    */
    isFixed: prop_types["PropTypes"].bool,

    /**
     * Name of the toolbar
    */
    name: prop_types["PropTypes"].string
  }; // CONCATENATED MODULE: ./lib/Toolbar/index.js
  // CONCATENATED MODULE: ./lib/TransactionCard/configs.js

  var AMOUNT_COLORS = {
    DEFAULT: null,
    RED: 'red',
    SAGE: 'sage'
  };
  var TransactionCard_configs_LABEL_COLORS = {
    PUBLISHED: 'published',
    DRAFT: 'draft',
    DANGER: 'danger',
    INFO: 'info',
    WARNING: 'warning',
    LOCKED: 'locked'
  };
  var STATE_COLORS = {
    DEFAULT: null,
    SAGE: 'sage',
    RED: 'red'
  }; // CONCATENATED MODULE: ./lib/TransactionCard/TransactionCard.jsx

  var TransactionCard_TransactionCard = function TransactionCard(_ref) {
    var amount = _ref.amount,
        amountColor = _ref.amountColor,
        labelColor = _ref.labelColor,
        labelText = _ref.labelText,
        name = _ref.name,
        nameHref = _ref.nameHref,
        nameTag = _ref.nameTag,
        relatedProperty = _ref.relatedProperty,
        relatedPropertyHref = _ref.relatedPropertyHref,
        transactionState = _ref.transactionState,
        transactionStateColor = _ref.transactionStateColor,
        transactionTime = _ref.transactionTime;
    var NameTag = nameTag;
    var amountClassNames = classnames_default()('sage-transaction-card__amount', defineProperty_default()({}, "sage-transaction-card__amount--".concat(amountColor), amountColor));
    var stateClassNames = classnames_default()('sage-transaction-card__state', defineProperty_default()({}, "sage-transaction-card__state--".concat(transactionStateColor), transactionStateColor));
    return /*#__PURE__*/external_react_default.a.createElement("article", {
      className: "sage-transaction-card"
    }, /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-transaction-card__header"
    }, /*#__PURE__*/external_react_default.a.createElement(Badge, {
      className: "sage-transaction-card__label",
      value: labelText,
      color: labelColor
    }), /*#__PURE__*/external_react_default.a.createElement("div", {
      className: stateClassNames
    }, transactionState || 'Awesome')), /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-transaction-card__body"
    }, /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-transaction-card__body-group"
    }, /*#__PURE__*/external_react_default.a.createElement(NameTag, {
      className: "sage-transaction-card__name"
    }, nameHref ? /*#__PURE__*/external_react_default.a.createElement(Link_Link, {
      href: nameHref,
      className: "sage-link sage-transaction-card__name-link",
      suppressDefaultClass: true,
      truncate: true
    }, name) : name), amount && /*#__PURE__*/external_react_default.a.createElement("div", {
      className: amountClassNames
    }, amount)), /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-transaction-card__body-group"
    }, relatedPropertyHref ? /*#__PURE__*/external_react_default.a.createElement(Button, {
      className: "sage-transaction-card__product",
      color: Button.COLORS.SECONDARY,
      href: relatedPropertyHref,
      icon: SageTokens.ICONS.TAG,
      small: true,
      subtle: true
    }, relatedProperty) : /*#__PURE__*/external_react_default.a.createElement(Property_Property, {
      className: "sage-transaction-card__product",
      icon: SageTokens.ICONS.TAG
    }, relatedProperty), /*#__PURE__*/external_react_default.a.createElement(Property_Property, {
      className: "sage-transaction-card__time"
    }, transactionTime))));
  };

  TransactionCard_TransactionCard.LABEL_COLORS = TransactionCard_configs_LABEL_COLORS;
  TransactionCard_TransactionCard.AMOUNT_COLORS = AMOUNT_COLORS;
  TransactionCard_TransactionCard.STATE_COLORS = STATE_COLORS;
  TransactionCard_TransactionCard.defaultProps = {
    amount: '0.00',
    amountColor: null,
    labelColor: TransactionCard_configs_LABEL_COLORS.PUBLISHED,
    labelText: '--',
    name: '--',
    nameHref: null,
    nameTag: 'h4',
    relatedProperty: '--',
    relatedPropertyHref: null,
    transactionState: null,
    transactionStateColor: null,
    transactionTime: '--'
  };
  TransactionCard_TransactionCard.propTypes = {
    amount: prop_types_default.a.string,
    amountColor: prop_types_default.a.oneOf(Object.values(TransactionCard_TransactionCard.AMOUNT_COLORS)),
    labelColor: prop_types_default.a.oneOf(Object.values(TransactionCard_TransactionCard.LABEL_COLORS)),
    labelText: prop_types_default.a.string,
    name: prop_types_default.a.string,
    nameHref: prop_types_default.a.string,
    nameTag: prop_types_default.a.string,
    relatedProperty: prop_types_default.a.string,
    relatedPropertyHref: prop_types_default.a.string,
    transactionState: prop_types_default.a.string,
    transactionStateColor: prop_types_default.a.oneOf(Object.values(TransactionCard_TransactionCard.STATE_COLORS)),
    transactionTime: prop_types_default.a.string
  }; // CONCATENATED MODULE: ./lib/TransactionCard/index.js
  // CONCATENATED MODULE: ./lib/Type/Type.jsx

  var Type_excluded = ["children", "className"];

  var Type_Type = function Type(_ref) {
    var children = _ref.children,
        className = _ref.className,
        rest = objectWithoutProperties_default()(_ref, Type_excluded);
    return /*#__PURE__*/external_react_default.a.createElement("div", extends_default()({
      className: "".concat(SageClassnames.TYPE_BLOCK, " ").concat(className || '')
    }, rest), children);
  };

  Type_Type.defaultProps = {
    children: null,
    className: ''
  };
  Type_Type.propTypes = {
    children: prop_types_default.a.node,
    className: prop_types_default.a.string
  }; // CONCATENATED MODULE: ./lib/Type/index.js
  // CONCATENATED MODULE: /__w/sage-lib/sage-lib/node_modules/tabbable/dist/index.esm.js

  /*!
  * tabbable 5.3.3
  * @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
  */

  var candidateSelectors = ['input', 'select', 'textarea', 'a[href]', 'button', '[tabindex]:not(slot)', 'audio[controls]', 'video[controls]', '[contenteditable]:not([contenteditable="false"])', 'details>summary:first-of-type', 'details'];
  var candidateSelector = /* #__PURE__ */candidateSelectors.join(',');
  var NoElement = typeof Element === 'undefined';
  var matches = NoElement ? function () {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
  var getRootNode = !NoElement && Element.prototype.getRootNode ? function (element) {
    return element.getRootNode();
  } : function (element) {
    return element.ownerDocument;
  };
  /**
   * @param {Element} el container to check in
   * @param {boolean} includeContainer add container to check
   * @param {(node: Element) => boolean} filter filter candidates
   * @returns {Element[]}
   */

  var getCandidates = function getCandidates(el, includeContainer, filter) {
    var candidates = Array.prototype.slice.apply(el.querySelectorAll(candidateSelector));

    if (includeContainer && matches.call(el, candidateSelector)) {
      candidates.unshift(el);
    }

    candidates = candidates.filter(filter);
    return candidates;
  };
  /**
   * @callback GetShadowRoot
   * @param {Element} element to check for shadow root
   * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
   */

  /**
   * @callback ShadowRootFilter
   * @param {Element} shadowHostNode the element which contains shadow content
   * @returns {boolean} true if a shadow root could potentially contain valid candidates.
   */

  /**
   * @typedef {Object} CandidatesScope
   * @property {Element} scope contains inner candidates
   * @property {Element[]} candidates
   */

  /**
   * @typedef {Object} IterativeOptions
   * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
   *  if a function, implies shadow support is enabled and either returns the shadow root of an element
   *  or a boolean stating if it has an undisclosed shadow root
   * @property {(node: Element) => boolean} filter filter candidates
   * @property {boolean} flatten if true then result will flatten any CandidatesScope into the returned list
   * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
   */

  /**
   * @param {Element[]} elements list of element containers to match candidates from
   * @param {boolean} includeContainer add container list to check
   * @param {IterativeOptions} options
   * @returns {Array.<Element|CandidatesScope>}
   */


  var getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
    var candidates = [];
    var elementsToCheck = Array.from(elements);

    while (elementsToCheck.length) {
      var element = elementsToCheck.shift();

      if (element.tagName === 'SLOT') {
        // add shadow dom slot scope (slot itself cannot be focusable)
        var assigned = element.assignedElements();
        var content = assigned.length ? assigned : element.children;
        var nestedCandidates = getCandidatesIteratively(content, true, options);

        if (options.flatten) {
          candidates.push.apply(candidates, nestedCandidates);
        } else {
          candidates.push({
            scope: element,
            candidates: nestedCandidates
          });
        }
      } else {
        // check candidate element
        var validCandidate = matches.call(element, candidateSelector);

        if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) {
          candidates.push(element);
        } // iterate over shadow content if possible


        var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
        typeof options.getShadowRoot === 'function' && options.getShadowRoot(element);
        var validShadowRoot = !options.shadowRootFilter || options.shadowRootFilter(element);

        if (shadowRoot && validShadowRoot) {
          // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
          //  shadow exists, so look at light dom children as fallback BUT create a scope for any
          //  child candidates found because they're likely slotted elements (elements that are
          //  children of the web component element (which has the shadow), in the light dom, but
          //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
          //  _after_ we return from this recursive call
          var _nestedCandidates = getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);

          if (options.flatten) {
            candidates.push.apply(candidates, _nestedCandidates);
          } else {
            candidates.push({
              scope: element,
              candidates: _nestedCandidates
            });
          }
        } else {
          // there's not shadow so just dig into the element's (light dom) children
          //  __without__ giving the element special scope treatment
          elementsToCheck.unshift.apply(elementsToCheck, element.children);
        }
      }
    }

    return candidates;
  };

  var getTabindex = function getTabindex(node, isScope) {
    if (node.tabIndex < 0) {
      // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
      // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
      // yet they are still part of the regular tab order; in FF, they get a default
      // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
      // order, consider their tab index to be 0.
      // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
      // so if they don't have a tabindex attribute specifically set, assume it's 0.
      //
      // isScope is positive for custom element with shadow root or slot that by default
      // have tabIndex -1, but need to be sorted by document order in order for their
      // content to be inserted in the correct position
      if ((isScope || /^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || node.isContentEditable) && isNaN(parseInt(node.getAttribute('tabindex'), 10))) {
        return 0;
      }
    }

    return node.tabIndex;
  };

  var sortOrderedTabbables = function sortOrderedTabbables(a, b) {
    return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
  };

  var isInput = function isInput(node) {
    return node.tagName === 'INPUT';
  };

  var isHiddenInput = function isHiddenInput(node) {
    return isInput(node) && node.type === 'hidden';
  };

  var isDetailsWithSummary = function isDetailsWithSummary(node) {
    var r = node.tagName === 'DETAILS' && Array.prototype.slice.apply(node.children).some(function (child) {
      return child.tagName === 'SUMMARY';
    });
    return r;
  };

  var getCheckedRadio = function getCheckedRadio(nodes, form) {
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].checked && nodes[i].form === form) {
        return nodes[i];
      }
    }
  };

  var isTabbableRadio = function isTabbableRadio(node) {
    if (!node.name) {
      return true;
    }

    var radioScope = node.form || getRootNode(node);

    var queryRadios = function queryRadios(name) {
      return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
    };

    var radioSet;

    if (typeof window !== 'undefined' && typeof window.CSS !== 'undefined' && typeof window.CSS.escape === 'function') {
      radioSet = queryRadios(window.CSS.escape(node.name));
    } else {
      try {
        radioSet = queryRadios(node.name);
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s', err.message);
        return false;
      }
    }

    var checked = getCheckedRadio(radioSet, node.form);
    return !checked || checked === node;
  };

  var isRadio = function isRadio(node) {
    return isInput(node) && node.type === 'radio';
  };

  var isNonTabbableRadio = function isNonTabbableRadio(node) {
    return isRadio(node) && !isTabbableRadio(node);
  };

  var isZeroArea = function isZeroArea(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(),
        width = _node$getBoundingClie.width,
        height = _node$getBoundingClie.height;

    return width === 0 && height === 0;
  };

  var isHidden = function isHidden(node, _ref) {
    var displayCheck = _ref.displayCheck,
        getShadowRoot = _ref.getShadowRoot; // NOTE: visibility will be `undefined` if node is detached from the document
    //  (see notes about this further down), which means we will consider it visible
    //  (this is legacy behavior from a very long way back)
    // NOTE: we check this regardless of `displayCheck="none"` because this is a
    //  _visibility_ check, not a _display_ check

    if (getComputedStyle(node).visibility === 'hidden') {
      return true;
    }

    var isDirectSummary = matches.call(node, 'details>summary:first-of-type');
    var nodeUnderDetails = isDirectSummary ? node.parentElement : node;

    if (matches.call(nodeUnderDetails, 'details:not([open]) *')) {
      return true;
    } // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
    //  (but NOT _the_ document; see second 'If' comment below for more).
    // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
    //  is attached, and the one we need to check if it's in the document or not (because the
    //  shadow, and all nodes it contains, is never considered in the document since shadows
    //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
    //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
    //  visibility, including all the nodes it contains). The host could be any normal node,
    //  or a custom element (i.e. web component). Either way, that's the one that is considered
    //  part of the document, not the shadow root, nor any of its children (i.e. the node being
    //  tested).
    // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
    //  document (per the docs) and while it's a Document-type object, that document does not
    //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
    //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
    //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
    //  node is actually detached.


    var nodeRootHost = getRootNode(node).host;
    var nodeIsAttached = (nodeRootHost === null || nodeRootHost === void 0 ? void 0 : nodeRootHost.ownerDocument.contains(nodeRootHost)) || node.ownerDocument.contains(node);

    if (!displayCheck || displayCheck === 'full') {
      if (typeof getShadowRoot === 'function') {
        // figure out if we should consider the node to be in an undisclosed shadow and use the
        //  'non-zero-area' fallback
        var originalNode = node;

        while (node) {
          var parentElement = node.parentElement;
          var rootNode = getRootNode(node);

          if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
          ) {
            // node has an undisclosed shadow which means we can only treat it as a black box, so we
            //  fall back to a non-zero-area test
            return isZeroArea(node);
          } else if (node.assignedSlot) {
            // iterate up slot
            node = node.assignedSlot;
          } else if (!parentElement && rootNode !== node.ownerDocument) {
            // cross shadow boundary
            node = rootNode.host;
          } else {
            // iterate up normal dom
            node = parentElement;
          }
        }

        node = originalNode;
      } // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
      //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
      //  it might be a falsy value, which means shadow DOM support is disabled
      // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
      //  now we can just test to see if it would normally be visible or not, provided it's
      //  attached to the main document.
      // NOTE: We must consider case where node is inside a shadow DOM and given directly to
      //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.


      if (nodeIsAttached) {
        // this works wherever the node is: if there's at least one client rect, it's
        //  somehow displayed; it also covers the CSS 'display: contents' case where the
        //  node itself is hidden in place of its contents; and there's no need to search
        //  up the hierarchy either
        return !node.getClientRects().length;
      } // Else, the node isn't attached to the document, which means the `getClientRects()`
      //  API will __always__ return zero rects (this can happen, for example, if React
      //  is used to render nodes onto a detached tree, as confirmed in this thread:
      //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
      //
      // It also means that even window.getComputedStyle(node).display will return `undefined`
      //  because styles are only computed for nodes that are in the document.
      //
      // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
      //  somehow. Though it was never stated officially, anyone who has ever used tabbable
      //  APIs on nodes in detached containers has actually implicitly used tabbable in what
      //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
      //  considering __everything__ to be visible because of the innability to determine styles.

    } else if (displayCheck === 'non-zero-area') {
      // NOTE: Even though this tests that the node's client rect is non-zero to determine
      //  whether it's displayed, and that a detached node will __always__ have a zero-area
      //  client rect, we don't special-case for whether the node is attached or not. In
      //  this mode, we do want to consider nodes that have a zero area to be hidden at all
      //  times, and that includes attached or not.
      return isZeroArea(node);
    } // visible, as far as we can tell, or per current `displayCheck` mode


    return false;
  }; // form fields (nested) inside a disabled fieldset are not focusable/tabbable
  //  unless they are in the _first_ <legend> element of the top-most disabled
  //  fieldset


  var isDisabledFromFieldset = function isDisabledFromFieldset(node) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
      var parentNode = node.parentElement; // check if `node` is contained in a disabled <fieldset>

      while (parentNode) {
        if (parentNode.tagName === 'FIELDSET' && parentNode.disabled) {
          // look for the first <legend> among the children of the disabled <fieldset>
          for (var i = 0; i < parentNode.children.length; i++) {
            var child = parentNode.children.item(i); // when the first <legend> (in document order) is found

            if (child.tagName === 'LEGEND') {
              // if its parent <fieldset> is not nested in another disabled <fieldset>,
              // return whether `node` is a descendant of its first <legend>
              return matches.call(parentNode, 'fieldset[disabled] *') ? true : !child.contains(node);
            }
          } // the disabled <fieldset> containing `node` has no <legend>


          return true;
        }

        parentNode = parentNode.parentElement;
      }
    } // else, node's tabbable/focusable state should not be affected by a fieldset's
    //  enabled/disabled state


    return false;
  };

  var isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
    if (node.disabled || isHiddenInput(node) || isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
    isDetailsWithSummary(node) || isDisabledFromFieldset(node)) {
      return false;
    }

    return true;
  };

  var isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
    if (isNonTabbableRadio(node) || getTabindex(node) < 0 || !isNodeMatchingSelectorFocusable(options, node)) {
      return false;
    }

    return true;
  };

  var isValidShadowRootTabbable = function isValidShadowRootTabbable(shadowHostNode) {
    var tabIndex = parseInt(shadowHostNode.getAttribute('tabindex'), 10);

    if (isNaN(tabIndex) || tabIndex >= 0) {
      return true;
    } // If a custom element has an explicit negative tabindex,
    // browsers will not allow tab targeting said element's children.


    return false;
  };
  /**
   * @param {Array.<Element|CandidatesScope>} candidates
   * @returns Element[]
   */


  var sortByOrder = function sortByOrder(candidates) {
    var regularTabbables = [];
    var orderedTabbables = [];
    candidates.forEach(function (item, i) {
      var isScope = !!item.scope;
      var element = isScope ? item.scope : item;
      var candidateTabindex = getTabindex(element, isScope);
      var elements = isScope ? sortByOrder(item.candidates) : element;

      if (candidateTabindex === 0) {
        isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
      } else {
        orderedTabbables.push({
          documentOrder: i,
          tabIndex: candidateTabindex,
          item: item,
          isScope: isScope,
          content: elements
        });
      }
    });
    return orderedTabbables.sort(sortOrderedTabbables).reduce(function (acc, sortable) {
      sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
      return acc;
    }, []).concat(regularTabbables);
  };

  var tabbable = function tabbable(el, options) {
    options = options || {};
    var candidates;

    if (options.getShadowRoot) {
      candidates = getCandidatesIteratively([el], options.includeContainer, {
        filter: isNodeMatchingSelectorTabbable.bind(null, options),
        flatten: false,
        getShadowRoot: options.getShadowRoot,
        shadowRootFilter: isValidShadowRootTabbable
      });
    } else {
      candidates = getCandidates(el, options.includeContainer, isNodeMatchingSelectorTabbable.bind(null, options));
    }

    return sortByOrder(candidates);
  };

  var focusable = function focusable(el, options) {
    options = options || {};
    var candidates;

    if (options.getShadowRoot) {
      candidates = getCandidatesIteratively([el], options.includeContainer, {
        filter: isNodeMatchingSelectorFocusable.bind(null, options),
        flatten: true,
        getShadowRoot: options.getShadowRoot
      });
    } else {
      candidates = getCandidates(el, options.includeContainer, isNodeMatchingSelectorFocusable.bind(null, options));
    }

    return candidates;
  };

  var isTabbable = function isTabbable(node, options) {
    options = options || {};

    if (!node) {
      throw new Error('No node provided');
    }

    if (matches.call(node, candidateSelector) === false) {
      return false;
    }

    return isNodeMatchingSelectorTabbable(options, node);
  };

  var focusableCandidateSelector = /* #__PURE__ */candidateSelectors.concat('iframe').join(',');

  var isFocusable = function isFocusable(node, options) {
    options = options || {};

    if (!node) {
      throw new Error('No node provided');
    }

    if (matches.call(node, focusableCandidateSelector) === false) {
      return false;
    }

    return isNodeMatchingSelectorFocusable(options, node);
  }; // CONCATENATED MODULE: /__w/sage-lib/sage-lib/node_modules/focus-trap/dist/focus-trap.esm.js

  /*!
  * focus-trap 6.9.4
  * @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
  */


  function focus_trap_esm_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? focus_trap_esm_ownKeys(Object(source), !0).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : focus_trap_esm_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }

    return target;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var activeFocusTraps = function () {
    var trapQueue = [];
    return {
      activateTrap: function activateTrap(trap) {
        if (trapQueue.length > 0) {
          var activeTrap = trapQueue[trapQueue.length - 1];

          if (activeTrap !== trap) {
            activeTrap.pause();
          }
        }

        var trapIndex = trapQueue.indexOf(trap);

        if (trapIndex === -1) {
          trapQueue.push(trap);
        } else {
          // move this existing trap to the front of the queue
          trapQueue.splice(trapIndex, 1);
          trapQueue.push(trap);
        }
      },
      deactivateTrap: function deactivateTrap(trap) {
        var trapIndex = trapQueue.indexOf(trap);

        if (trapIndex !== -1) {
          trapQueue.splice(trapIndex, 1);
        }

        if (trapQueue.length > 0) {
          trapQueue[trapQueue.length - 1].unpause();
        }
      }
    };
  }();

  var isSelectableInput = function isSelectableInput(node) {
    return node.tagName && node.tagName.toLowerCase() === 'input' && typeof node.select === 'function';
  };

  var isEscapeEvent = function isEscapeEvent(e) {
    return e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
  };

  var isTabEvent = function isTabEvent(e) {
    return e.key === 'Tab' || e.keyCode === 9;
  };

  var focus_trap_esm_delay = function delay(fn) {
    return setTimeout(fn, 0);
  }; // Array.find/findIndex() are not supported on IE; this replicates enough
  //  of Array.findIndex() for our needs


  var findIndex = function findIndex(arr, fn) {
    var idx = -1;
    arr.every(function (value, i) {
      if (fn(value)) {
        idx = i;
        return false; // break
      }

      return true; // next
    });
    return idx;
  };
  /**
   * Get an option's value when it could be a plain value, or a handler that provides
   *  the value.
   * @param {*} value Option's value to check.
   * @param {...*} [params] Any parameters to pass to the handler, if `value` is a function.
   * @returns {*} The `value`, or the handler's returned value.
   */


  var valueOrHandler = function valueOrHandler(value) {
    for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      params[_key - 1] = arguments[_key];
    }

    return typeof value === 'function' ? value.apply(void 0, params) : value;
  };

  var getActualTarget = function getActualTarget(event) {
    // NOTE: If the trap is _inside_ a shadow DOM, event.target will always be the
    //  shadow host. However, event.target.composedPath() will be an array of
    //  nodes "clicked" from inner-most (the actual element inside the shadow) to
    //  outer-most (the host HTML document). If we have access to composedPath(),
    //  then use its first element; otherwise, fall back to event.target (and
    //  this only works for an _open_ shadow DOM; otherwise,
    //  composedPath()[0] === event.target always).
    return event.target.shadowRoot && typeof event.composedPath === 'function' ? event.composedPath()[0] : event.target;
  };

  var focus_trap_esm_createFocusTrap = function createFocusTrap(elements, userOptions) {
    // SSR: a live trap shouldn't be created in this type of environment so this
    //  should be safe code to execute if the `document` option isn't specified
    var doc = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.document) || document;

    var config = _objectSpread2({
      returnFocusOnDeactivate: true,
      escapeDeactivates: true,
      delayInitialFocus: true
    }, userOptions);

    var state = {
      // containers given to createFocusTrap()
      // @type {Array<HTMLElement>}
      containers: [],
      // list of objects identifying tabbable nodes in `containers` in the trap
      // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
      //  is active, but the trap should never get to a state where there isn't at least one group
      //  with at least one tabbable node in it (that would lead to an error condition that would
      //  result in an error being thrown)
      // @type {Array<{
      //   container: HTMLElement,
      //   tabbableNodes: Array<HTMLElement>, // empty if none
      //   focusableNodes: Array<HTMLElement>, // empty if none
      //   firstTabbableNode: HTMLElement|null,
      //   lastTabbableNode: HTMLElement|null,
      //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
      // }>}
      containerGroups: [],
      // same order/length as `containers` list
      // references to objects in `containerGroups`, but only those that actually have
      //  tabbable nodes in them
      // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
      //  the same length
      tabbableGroups: [],
      nodeFocusedBeforeActivation: null,
      mostRecentlyFocusedNode: null,
      active: false,
      paused: false,
      // timer ID for when delayInitialFocus is true and initial focus in this trap
      //  has been delayed during activation
      delayInitialFocusTimer: undefined
    };
    var trap; // eslint-disable-line prefer-const -- some private functions reference it, and its methods reference private functions, so we must declare here and define later

    /**
     * Gets a configuration option value.
     * @param {Object|undefined} configOverrideOptions If true, and option is defined in this set,
     *  value will be taken from this object. Otherwise, value will be taken from base configuration.
     * @param {string} optionName Name of the option whose value is sought.
     * @param {string|undefined} [configOptionName] Name of option to use __instead of__ `optionName`
     *  IIF `configOverrideOptions` is not defined. Otherwise, `optionName` is used.
     */

    var getOption = function getOption(configOverrideOptions, optionName, configOptionName) {
      return configOverrideOptions && configOverrideOptions[optionName] !== undefined ? configOverrideOptions[optionName] : config[configOptionName || optionName];
    };
    /**
     * Finds the index of the container that contains the element.
     * @param {HTMLElement} element
     * @returns {number} Index of the container in either `state.containers` or
     *  `state.containerGroups` (the order/length of these lists are the same); -1
     *  if the element isn't found.
     */


    var findContainerIndex = function findContainerIndex(element) {
      // NOTE: search `containerGroups` because it's possible a group contains no tabbable
      //  nodes, but still contains focusable nodes (e.g. if they all have `tabindex=-1`)
      //  and we still need to find the element in there
      return state.containerGroups.findIndex(function (_ref) {
        var container = _ref.container,
            tabbableNodes = _ref.tabbableNodes;
        return container.contains(element) || // fall back to explicit tabbable search which will take into consideration any
        //  web components if the `tabbableOptions.getShadowRoot` option was used for
        //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
        //  look inside web components even if open)
        tabbableNodes.find(function (node) {
          return node === element;
        });
      });
    };
    /**
     * Gets the node for the given option, which is expected to be an option that
     *  can be either a DOM node, a string that is a selector to get a node, `false`
     *  (if a node is explicitly NOT given), or a function that returns any of these
     *  values.
     * @param {string} optionName
     * @returns {undefined | false | HTMLElement | SVGElement} Returns
     *  `undefined` if the option is not specified; `false` if the option
     *  resolved to `false` (node explicitly not given); otherwise, the resolved
     *  DOM node.
     * @throws {Error} If the option is set, not `false`, and is not, or does not
     *  resolve to a node.
     */


    var getNodeForOption = function getNodeForOption(optionName) {
      var optionValue = config[optionName];

      if (typeof optionValue === 'function') {
        for (var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          params[_key2 - 1] = arguments[_key2];
        }

        optionValue = optionValue.apply(void 0, params);
      }

      if (optionValue === true) {
        optionValue = undefined; // use default value
      }

      if (!optionValue) {
        if (optionValue === undefined || optionValue === false) {
          return optionValue;
        } // else, empty string (invalid), null (invalid), 0 (invalid)


        throw new Error("`".concat(optionName, "` was specified but was not a node, or did not return a node"));
      }

      var node = optionValue; // could be HTMLElement, SVGElement, or non-empty string at this point

      if (typeof optionValue === 'string') {
        node = doc.querySelector(optionValue); // resolve to node, or null if fails

        if (!node) {
          throw new Error("`".concat(optionName, "` as selector refers to no known node"));
        }
      }

      return node;
    };

    var getInitialFocusNode = function getInitialFocusNode() {
      var node = getNodeForOption('initialFocus'); // false explicitly indicates we want no initialFocus at all

      if (node === false) {
        return false;
      }

      if (node === undefined) {
        // option not specified: use fallback options
        if (findContainerIndex(doc.activeElement) >= 0) {
          node = doc.activeElement;
        } else {
          var firstTabbableGroup = state.tabbableGroups[0];
          var firstTabbableNode = firstTabbableGroup && firstTabbableGroup.firstTabbableNode; // NOTE: `fallbackFocus` option function cannot return `false` (not supported)

          node = firstTabbableNode || getNodeForOption('fallbackFocus');
        }
      }

      if (!node) {
        throw new Error('Your focus-trap needs to have at least one focusable element');
      }

      return node;
    };

    var updateTabbableNodes = function updateTabbableNodes() {
      state.containerGroups = state.containers.map(function (container) {
        var tabbableNodes = tabbable(container, config.tabbableOptions); // NOTE: if we have tabbable nodes, we must have focusable nodes; focusable nodes
        //  are a superset of tabbable nodes

        var focusableNodes = focusable(container, config.tabbableOptions);
        return {
          container: container,
          tabbableNodes: tabbableNodes,
          focusableNodes: focusableNodes,
          firstTabbableNode: tabbableNodes.length > 0 ? tabbableNodes[0] : null,
          lastTabbableNode: tabbableNodes.length > 0 ? tabbableNodes[tabbableNodes.length - 1] : null,

          /**
           * Finds the __tabbable__ node that follows the given node in the specified direction,
           *  in this container, if any.
           * @param {HTMLElement} node
           * @param {boolean} [forward] True if going in forward tab order; false if going
           *  in reverse.
           * @returns {HTMLElement|undefined} The next tabbable node, if any.
           */
          nextTabbableNode: function nextTabbableNode(node) {
            var forward = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true; // NOTE: If tabindex is positive (in order to manipulate the tab order separate
            //  from the DOM order), this __will not work__ because the list of focusableNodes,
            //  while it contains tabbable nodes, does not sort its nodes in any order other
            //  than DOM order, because it can't: Where would you place focusable (but not
            //  tabbable) nodes in that order? They have no order, because they aren't tabbale...
            // Support for positive tabindex is already broken and hard to manage (possibly
            //  not supportable, TBD), so this isn't going to make things worse than they
            //  already are, and at least makes things better for the majority of cases where
            //  tabindex is either 0/unset or negative.
            // FYI, positive tabindex issue: https://github.com/focus-trap/focus-trap/issues/375

            var nodeIdx = focusableNodes.findIndex(function (n) {
              return n === node;
            });

            if (nodeIdx < 0) {
              return undefined;
            }

            if (forward) {
              return focusableNodes.slice(nodeIdx + 1).find(function (n) {
                return isTabbable(n, config.tabbableOptions);
              });
            }

            return focusableNodes.slice(0, nodeIdx).reverse().find(function (n) {
              return isTabbable(n, config.tabbableOptions);
            });
          }
        };
      });
      state.tabbableGroups = state.containerGroups.filter(function (group) {
        return group.tabbableNodes.length > 0;
      }); // throw if no groups have tabbable nodes and we don't have a fallback focus node either

      if (state.tabbableGroups.length <= 0 && !getNodeForOption('fallbackFocus') // returning false not supported for this option
      ) {
        throw new Error('Your focus-trap must have at least one container with at least one tabbable node in it at all times');
      }
    };

    var tryFocus = function tryFocus(node) {
      if (node === false) {
        return;
      }

      if (node === doc.activeElement) {
        return;
      }

      if (!node || !node.focus) {
        tryFocus(getInitialFocusNode());
        return;
      }

      node.focus({
        preventScroll: !!config.preventScroll
      });
      state.mostRecentlyFocusedNode = node;

      if (isSelectableInput(node)) {
        node.select();
      }
    };

    var getReturnFocusNode = function getReturnFocusNode(previousActiveElement) {
      var node = getNodeForOption('setReturnFocus', previousActiveElement);
      return node ? node : node === false ? false : previousActiveElement;
    }; // This needs to be done on mousedown and touchstart instead of click
    // so that it precedes the focus event.


    var checkPointerDown = function checkPointerDown(e) {
      var target = getActualTarget(e);

      if (findContainerIndex(target) >= 0) {
        // allow the click since it ocurred inside the trap
        return;
      }

      if (valueOrHandler(config.clickOutsideDeactivates, e)) {
        // immediately deactivate the trap
        trap.deactivate({
          // if, on deactivation, we should return focus to the node originally-focused
          //  when the trap was activated (or the configured `setReturnFocus` node),
          //  then assume it's also OK to return focus to the outside node that was
          //  just clicked, causing deactivation, as long as that node is focusable;
          //  if it isn't focusable, then return focus to the original node focused
          //  on activation (or the configured `setReturnFocus` node)
          // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
          //  which will result in the outside click setting focus to the node
          //  that was clicked, whether it's focusable or not; by setting
          //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
          //  on activation (or the configured `setReturnFocus` node)
          returnFocus: config.returnFocusOnDeactivate && !isFocusable(target, config.tabbableOptions)
        });
        return;
      } // This is needed for mobile devices.
      // (If we'll only let `click` events through,
      // then on mobile they will be blocked anyways if `touchstart` is blocked.)


      if (valueOrHandler(config.allowOutsideClick, e)) {
        // allow the click outside the trap to take place
        return;
      } // otherwise, prevent the click


      e.preventDefault();
    }; // In case focus escapes the trap for some strange reason, pull it back in.


    var checkFocusIn = function checkFocusIn(e) {
      var target = getActualTarget(e);
      var targetContained = findContainerIndex(target) >= 0; // In Firefox when you Tab out of an iframe the Document is briefly focused.

      if (targetContained || target instanceof Document) {
        if (targetContained) {
          state.mostRecentlyFocusedNode = target;
        }
      } else {
        // escaped! pull it back in to where it just left
        e.stopImmediatePropagation();
        tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
      }
    }; // Hijack Tab events on the first and last focusable nodes of the trap,
    // in order to prevent focus from escaping. If it escapes for even a
    // moment it can end up scrolling the page and causing confusion so we
    // kind of need to capture the action at the keydown phase.


    var checkTab = function checkTab(e) {
      var target = getActualTarget(e);
      updateTabbableNodes();
      var destinationNode = null;

      if (state.tabbableGroups.length > 0) {
        // make sure the target is actually contained in a group
        // NOTE: the target may also be the container itself if it's focusable
        //  with tabIndex='-1' and was given initial focus
        var containerIndex = findContainerIndex(target);
        var containerGroup = containerIndex >= 0 ? state.containerGroups[containerIndex] : undefined;

        if (containerIndex < 0) {
          // target not found in any group: quite possible focus has escaped the trap,
          //  so bring it back in to...
          if (e.shiftKey) {
            // ...the last node in the last group
            destinationNode = state.tabbableGroups[state.tabbableGroups.length - 1].lastTabbableNode;
          } else {
            // ...the first node in the first group
            destinationNode = state.tabbableGroups[0].firstTabbableNode;
          }
        } else if (e.shiftKey) {
          // REVERSE
          // is the target the first tabbable node in a group?
          var startOfGroupIndex = findIndex(state.tabbableGroups, function (_ref2) {
            var firstTabbableNode = _ref2.firstTabbableNode;
            return target === firstTabbableNode;
          });

          if (startOfGroupIndex < 0 && (containerGroup.container === target || isFocusable(target, config.tabbableOptions) && !isTabbable(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target, false))) {
            // an exception case where the target is either the container itself, or
            //  a non-tabbable node that was given focus (i.e. tabindex is negative
            //  and user clicked on it or node was programmatically given focus)
            //  and is not followed by any other tabbable node, in which
            //  case, we should handle shift+tab as if focus were on the container's
            //  first tabbable node, and go to the last tabbable node of the LAST group
            startOfGroupIndex = containerIndex;
          }

          if (startOfGroupIndex >= 0) {
            // YES: then shift+tab should go to the last tabbable node in the
            //  previous group (and wrap around to the last tabbable node of
            //  the LAST group if it's the first tabbable node of the FIRST group)
            var destinationGroupIndex = startOfGroupIndex === 0 ? state.tabbableGroups.length - 1 : startOfGroupIndex - 1;
            var destinationGroup = state.tabbableGroups[destinationGroupIndex];
            destinationNode = destinationGroup.lastTabbableNode;
          }
        } else {
          // FORWARD
          // is the target the last tabbable node in a group?
          var lastOfGroupIndex = findIndex(state.tabbableGroups, function (_ref3) {
            var lastTabbableNode = _ref3.lastTabbableNode;
            return target === lastTabbableNode;
          });

          if (lastOfGroupIndex < 0 && (containerGroup.container === target || isFocusable(target, config.tabbableOptions) && !isTabbable(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target))) {
            // an exception case where the target is the container itself, or
            //  a non-tabbable node that was given focus (i.e. tabindex is negative
            //  and user clicked on it or node was programmatically given focus)
            //  and is not followed by any other tabbable node, in which
            //  case, we should handle tab as if focus were on the container's
            //  last tabbable node, and go to the first tabbable node of the FIRST group
            lastOfGroupIndex = containerIndex;
          }

          if (lastOfGroupIndex >= 0) {
            // YES: then tab should go to the first tabbable node in the next
            //  group (and wrap around to the first tabbable node of the FIRST
            //  group if it's the last tabbable node of the LAST group)
            var _destinationGroupIndex = lastOfGroupIndex === state.tabbableGroups.length - 1 ? 0 : lastOfGroupIndex + 1;

            var _destinationGroup = state.tabbableGroups[_destinationGroupIndex];
            destinationNode = _destinationGroup.firstTabbableNode;
          }
        }
      } else {
        // NOTE: the fallbackFocus option does not support returning false to opt-out
        destinationNode = getNodeForOption('fallbackFocus');
      }

      if (destinationNode) {
        e.preventDefault();
        tryFocus(destinationNode);
      } // else, let the browser take care of [shift+]tab and move the focus

    };

    var checkKey = function checkKey(e) {
      if (isEscapeEvent(e) && valueOrHandler(config.escapeDeactivates, e) !== false) {
        e.preventDefault();
        trap.deactivate();
        return;
      }

      if (isTabEvent(e)) {
        checkTab(e);
        return;
      }
    };

    var checkClick = function checkClick(e) {
      var target = getActualTarget(e);

      if (findContainerIndex(target) >= 0) {
        return;
      }

      if (valueOrHandler(config.clickOutsideDeactivates, e)) {
        return;
      }

      if (valueOrHandler(config.allowOutsideClick, e)) {
        return;
      }

      e.preventDefault();
      e.stopImmediatePropagation();
    }; //
    // EVENT LISTENERS
    //


    var addListeners = function addListeners() {
      if (!state.active) {
        return;
      } // There can be only one listening focus trap at a time


      activeFocusTraps.activateTrap(trap); // Delay ensures that the focused element doesn't capture the event
      // that caused the focus trap activation.

      state.delayInitialFocusTimer = config.delayInitialFocus ? focus_trap_esm_delay(function () {
        tryFocus(getInitialFocusNode());
      }) : tryFocus(getInitialFocusNode());
      doc.addEventListener('focusin', checkFocusIn, true);
      doc.addEventListener('mousedown', checkPointerDown, {
        capture: true,
        passive: false
      });
      doc.addEventListener('touchstart', checkPointerDown, {
        capture: true,
        passive: false
      });
      doc.addEventListener('click', checkClick, {
        capture: true,
        passive: false
      });
      doc.addEventListener('keydown', checkKey, {
        capture: true,
        passive: false
      });
      return trap;
    };

    var removeListeners = function removeListeners() {
      if (!state.active) {
        return;
      }

      doc.removeEventListener('focusin', checkFocusIn, true);
      doc.removeEventListener('mousedown', checkPointerDown, true);
      doc.removeEventListener('touchstart', checkPointerDown, true);
      doc.removeEventListener('click', checkClick, true);
      doc.removeEventListener('keydown', checkKey, true);
      return trap;
    }; //
    // TRAP DEFINITION
    //


    trap = {
      get active() {
        return state.active;
      },

      get paused() {
        return state.paused;
      },

      activate: function activate(activateOptions) {
        if (state.active) {
          return this;
        }

        var onActivate = getOption(activateOptions, 'onActivate');
        var onPostActivate = getOption(activateOptions, 'onPostActivate');
        var checkCanFocusTrap = getOption(activateOptions, 'checkCanFocusTrap');

        if (!checkCanFocusTrap) {
          updateTabbableNodes();
        }

        state.active = true;
        state.paused = false;
        state.nodeFocusedBeforeActivation = doc.activeElement;

        if (onActivate) {
          onActivate();
        }

        var finishActivation = function finishActivation() {
          if (checkCanFocusTrap) {
            updateTabbableNodes();
          }

          addListeners();

          if (onPostActivate) {
            onPostActivate();
          }
        };

        if (checkCanFocusTrap) {
          checkCanFocusTrap(state.containers.concat()).then(finishActivation, finishActivation);
          return this;
        }

        finishActivation();
        return this;
      },
      deactivate: function deactivate(deactivateOptions) {
        if (!state.active) {
          return this;
        }

        var options = _objectSpread2({
          onDeactivate: config.onDeactivate,
          onPostDeactivate: config.onPostDeactivate,
          checkCanReturnFocus: config.checkCanReturnFocus
        }, deactivateOptions);

        clearTimeout(state.delayInitialFocusTimer); // noop if undefined

        state.delayInitialFocusTimer = undefined;
        removeListeners();
        state.active = false;
        state.paused = false;
        activeFocusTraps.deactivateTrap(trap);
        var onDeactivate = getOption(options, 'onDeactivate');
        var onPostDeactivate = getOption(options, 'onPostDeactivate');
        var checkCanReturnFocus = getOption(options, 'checkCanReturnFocus');
        var returnFocus = getOption(options, 'returnFocus', 'returnFocusOnDeactivate');

        if (onDeactivate) {
          onDeactivate();
        }

        var finishDeactivation = function finishDeactivation() {
          focus_trap_esm_delay(function () {
            if (returnFocus) {
              tryFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation));
            }

            if (onPostDeactivate) {
              onPostDeactivate();
            }
          });
        };

        if (returnFocus && checkCanReturnFocus) {
          checkCanReturnFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation)).then(finishDeactivation, finishDeactivation);
          return this;
        }

        finishDeactivation();
        return this;
      },
      pause: function pause() {
        if (state.paused || !state.active) {
          return this;
        }

        state.paused = true;
        removeListeners();
        return this;
      },
      unpause: function unpause() {
        if (!state.paused || !state.active) {
          return this;
        }

        state.paused = false;
        updateTabbableNodes();
        addListeners();
        return this;
      },
      updateContainerElements: function updateContainerElements(containerElements) {
        var elementsAsArray = [].concat(containerElements).filter(Boolean);
        state.containers = elementsAsArray.map(function (element) {
          return typeof element === 'string' ? doc.querySelector(element) : element;
        });

        if (state.active) {
          updateTabbableNodes();
        }

        return this;
      }
    }; // initialize container elements

    trap.updateContainerElements(elements);
    return trap;
  }; // CONCATENATED MODULE: ./lib/common/hooks/useFocusTrap.jsx

  /**
  *
  * @param {Boolean} active          - React boolean state
  * @param {ReactRef} containerRef   - React ref of containing element where focus trapping occurs
  * @param {Function} onDeactivateFn - Fires on deactivation, this is where you can set the state of
  *                                    your component when a click outside or `esc` happens
  * @param {Boolean} returnFocus     - Determines whether the focus trap focuses the initial element
  *                                    on deactivation this is typically turned off for context menus
  *                                    that scrollTo another element on the page
  *
  */


  var useFocusTrap_useFocusTrap = function useFocusTrap(_ref) {
    var active = _ref.active,
        containerRef = _ref.containerRef,
        _ref$onDeactivateFn = _ref.onDeactivateFn,
        onDeactivateFn = _ref$onDeactivateFn === void 0 ? function () {} : _ref$onDeactivateFn,
        _ref$returnFocus = _ref.returnFocus,
        returnFocus = _ref$returnFocus === void 0 ? true : _ref$returnFocus;

    if (typeof active !== 'boolean' || containerRef === undefined || typeof onDeactivateFn !== 'function' || typeof returnFocus !== 'boolean') {
      throw new Error('Sage useFocusTrap Hook: malformed args, see param documentation in hooks/useFocusTrap.jsx');
    }

    Object(external_react_["useEffect"])(function (additionalFocustrapSettings) {
      // eslint-disable-line
      var focusTrapInstance = focus_trap_esm_createFocusTrap(containerRef.current, {
        escapeDeactivates: false,
        allowOutsideClick: true,
        returnFocusOnDeactivate: returnFocus
      });

      var handleEscape = function handleEscape(evt) {
        if (evt.keyCode === 27) onDeactivateFn();
      };

      var handleClickOutside = function handleClickOutside(evt) {
        if (!containerRef.current.contains(evt.target)) onDeactivateFn();
      };

      var setup = function setup() {
        focusTrapInstance.activate();
        document.addEventListener('keydown', handleEscape, false);
        document.addEventListener('click', handleClickOutside, false);
      };

      var cleanup = function cleanup() {
        focusTrapInstance.deactivate();
        document.removeEventListener('keydown', handleEscape, false);
        document.removeEventListener('click', handleClickOutside, false);
      };

      if (active) {
        setup();
      } else {
        cleanup();
      }

      return function () {
        return cleanup();
      };
    }, [active, containerRef.current]);
  }; // CONCATENATED MODULE: ./lib/common/hooks/useDebounceEffect.jsx


  var useDebounceEffect_useDebounceEffect = function useDebounceEffect(effect, deps) {
    var delay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 250;
    var callback = Object(external_react_["useCallback"])(effect, deps);
    Object(external_react_["useEffect"])(function () {
      var timeout = setTimeout(callback, delay);
      return function () {
        return clearTimeout(timeout);
      };
    }, [callback, delay]);
  }; // CONCATENATED MODULE: ./lib/common/hooks/index.js
  // EXTERNAL MODULE: /__w/sage-lib/sage-lib/node_modules/html-react-parser/index.js


  var html_react_parser = __webpack_require__(25);

  var html_react_parser_default = /*#__PURE__*/__webpack_require__.n(html_react_parser); // CONCATENATED MODULE: ./lib/common/renderers/renderSubstringHighlight.jsx

  /**
   *
   * @param {string} targetString      the string value to display
   * @param {string} searchString      the substrings to highlight with `targetString`
   */


  var renderSubstringHighlight_renderSubstringHighlight = function renderSubstringHighlight(targetString, searchString) {
    return html_react_parser_default()(targetString.replace(new RegExp(searchString, 'gi'), function (match) {
      return "<mark>".concat(match, "</mark>");
    }));
  }; // CONCATENATED MODULE: ./lib/common/renderers/index.js
  // CONCATENATED MODULE: ./lib/Typeahead/TypeaheadItem.jsx


  var TypeaheadItem_excluded = ["actions", "icon", "subTitle", "searchValue", "title"];

  var TypeaheadItem_TypeaheadItem = function TypeaheadItem(_ref) {
    var actions = _ref.actions,
        icon = _ref.icon,
        subTitle = _ref.subTitle,
        searchValue = _ref.searchValue,
        title = _ref.title,
        rest = objectWithoutProperties_default()(_ref, TypeaheadItem_excluded);
    return /*#__PURE__*/external_react_default.a.createElement("li", {
      className: "sage-typeahead__item"
    }, /*#__PURE__*/external_react_default.a.createElement(Link_Link, extends_default()({
      className: "sage-typeahead__item-trigger",
      suppressDefaultClass: true
    }, rest), /*#__PURE__*/external_react_default.a.createElement("i", {
      className: "sage-icon-".concat(icon),
      style: {
        gridArea: 'icon'
      }
    }), /*#__PURE__*/external_react_default.a.createElement("span", {
      className: "t-sage-heading-6",
      style: {
        gridArea: 'title'
      }
    }, renderSubstringHighlight_renderSubstringHighlight(title, searchValue)), /*#__PURE__*/external_react_default.a.createElement("span", {
      className: "t-sage-body-small",
      style: {
        gridArea: 'subTitle'
      }
    }, subTitle)), /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-typeahead__item-actions"
    }, actions && actions.map(function (action) {
      return /*#__PURE__*/external_react_default.a.cloneElement(action, {
        key: uuid_default()()
      });
    })));
  };

  TypeaheadItem_TypeaheadItem.defaultProps = {
    actions: null,
    searchValue: '',
    subTitle: ''
  };
  TypeaheadItem_TypeaheadItem.propTypes = {
    actions: prop_types_default.a.arrayOf(prop_types_default.a.node),
    icon: prop_types_default.a.oneOf(Object.values(SageTokens.ICONS)).isRequired,
    searchValue: prop_types_default.a.string,
    subTitle: prop_types_default.a.string,
    title: prop_types_default.a.string.isRequired
  }; // CONCATENATED MODULE: ./lib/Typeahead/TypeaheadPanel.jsx

  var TypeaheadPanel_excluded = ["items", "searchValue"];

  var TypeaheadPanel_TypeaheadPanel = function TypeaheadPanel(_ref) {
    var items = _ref.items,
        searchValue = _ref.searchValue,
        rest = objectWithoutProperties_default()(_ref, TypeaheadPanel_excluded);
    var NullState = /*#__PURE__*/external_react_default.a.createElement("p", {
      className: "sage-typeahead__null-state"
    }, "No Results Available For:", /*#__PURE__*/external_react_default.a.createElement("br", null), "\u201C", searchValue, "\u201D");
    return /*#__PURE__*/external_react_default.a.createElement("ul", extends_default()({
      className: "sage-typeahead__panel"
    }, rest), items.length > 0 ? items.map(function (item) {
      return /*#__PURE__*/external_react_default.a.createElement(TypeaheadItem_TypeaheadItem, extends_default()({}, item, {
        key: uuid_default()(),
        searchValue: searchValue
      }));
    }) : NullState);
  };

  TypeaheadPanel_TypeaheadPanel.defaultProps = {
    searchValue: ''
  };
  TypeaheadPanel_TypeaheadPanel.propTypes = {
    items: prop_types_default.a.arrayOf(prop_types_default.a.shape(TypeaheadItem_TypeaheadItem.propTypes)).isRequired,
    searchValue: prop_types_default.a.string
  }; // CONCATENATED MODULE: ./lib/Typeahead/Typeahead.jsx

  var Typeahead_excluded = ["contained", "filterFn", "items", "maxResults", "onClearHook", "placeholder", "searchFn"];
  var A11Y_ID = uuid_default()();

  var Typeahead_Typeahead = function Typeahead(_ref) {
    var contained = _ref.contained,
        filterFn = _ref.filterFn,
        items = _ref.items,
        maxResults = _ref.maxResults,
        onClearHook = _ref.onClearHook,
        placeholder = _ref.placeholder,
        searchFn = _ref.searchFn,
        rest = objectWithoutProperties_default()(_ref, Typeahead_excluded);

    var _useState = Object(external_react_["useState"])(''),
        _useState2 = slicedToArray_default()(_useState, 2),
        searchValue = _useState2[0],
        setSearchValue = _useState2[1];

    var _useState3 = Object(external_react_["useState"])([]),
        _useState4 = slicedToArray_default()(_useState3, 2),
        searchResults = _useState4[0],
        setSearchResults = _useState4[1];

    var _useState5 = Object(external_react_["useState"])(false),
        _useState6 = slicedToArray_default()(_useState5, 2),
        open = _useState6[0],
        setOpen = _useState6[1];

    var containerRef = Object(external_react_["useRef"])(null);

    var filterList = function filterList(_items) {
      var newItems = searchValue && filterFn ? filterFn(searchValue, _items, maxResults) : _items;
      setSearchResults(newItems.slice(0, maxResults));
    };

    useFocusTrap_useFocusTrap({
      active: open,
      containerRef: containerRef,
      onDeactivateFn: function onDeactivateFn() {
        return setOpen(false);
      },
      // NOTE: `returnFocus` prevents the search input from being refocused when Typeahead is closed,
      // which prevents blocking the 'scrollTo element' UX pattern that is used with this component
      returnFocus: false
    }); // Watch items and filter when updated

    Object(external_react_["useEffect"])(function () {
      return filterList(items);
    }, [items]); // Update list when search value changes (after debounce)
    // If a search function is provided it is called,
    // trusting that that function will handle updating `items` externally.
    // Otherwise, we proceed to call the filtering function.

    useDebounceEffect_useDebounceEffect(function () {
      if (searchFn) {
        searchFn(searchValue);
      } else {
        filterList(items);
      }
    }, [searchValue], 200);

    var onSearchInteraction = function onSearchInteraction(evt) {
      setSearchValue(evt.target.value);

      if (evt.target.value.length) {
        setOpen(true);
      } else {
        setOpen(false);
      }
    };

    var onSearchClear = function onSearchClear() {
      setSearchValue('');
      setOpen(false);

      if (onClearHook) {
        onClearHook();
      }
    };

    var onPanelInteraction = function onPanelInteraction(evt) {
      if (evt.target.closest('button, a')) setOpen(false);
    };

    return /*#__PURE__*/external_react_default.a.createElement("div", extends_default()({
      className: "sage-typeahead",
      ref: containerRef,
      "aria-expanded": open,
      "aria-haspopup": "listbox",
      "aria-owns": A11Y_ID
    }, rest), /*#__PURE__*/external_react_default.a.createElement(Search_Search, {
      contained: contained,
      placeholder: placeholder,
      value: searchValue,
      onChange: onSearchInteraction,
      onKeyDown: function onKeyDown(evt) {
        return evt.which === 13 && onSearchInteraction(evt);
      },
      onClear: onSearchClear
    }), open && /*#__PURE__*/external_react_default.a.createElement(TypeaheadPanel_TypeaheadPanel, {
      items: searchResults,
      onClick: onPanelInteraction,
      onKeyDown: function onKeyDown(evt) {
        return evt.which === 13 && onPanelInteraction(evt);
      },
      searchValue: searchValue,
      role: "listbox",
      id: A11Y_ID
    }));
  };

  Typeahead_Typeahead.defaultProps = {
    contained: true,
    filterFn: function filterFn(_value, _items) {
      var _limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5;

      return _items.filter(function (_ref2) {
        var title = _ref2.title;
        return title.toUpperCase().includes(_value.toUpperCase());
      }).slice(0, _limit);
    },
    items: [],
    maxResults: 5,
    onClearHook: null,
    placeholder: 'Find',
    searchFn: null
  };
  Typeahead_Typeahead.propTypes = {
    contained: prop_types_default.a.bool,
    filterFn: prop_types_default.a.func,
    items: TypeaheadPanel_TypeaheadPanel.propTypes.items,
    maxResults: prop_types_default.a.number,
    onClearHook: prop_types_default.a.func,
    placeholder: prop_types_default.a.string,
    searchFn: prop_types_default.a.func
  }; // CONCATENATED MODULE: ./lib/Typeahead/index.js
  // CONCATENATED MODULE: ./lib/UploadCard/UploadCard.jsx

  var UploadCard_excluded = ["acceptedFiles", "className", "errors", "inputProps", "replaceLabel", "rootProps", "selectionLabel", "selectionSubtext"];

  var UploadCard_UploadCard = function UploadCard(_ref) {
    var acceptedFiles = _ref.acceptedFiles,
        className = _ref.className,
        errors = _ref.errors,
        inputProps = _ref.inputProps,
        replaceLabel = _ref.replaceLabel,
        rootProps = _ref.rootProps,
        selectionLabel = _ref.selectionLabel,
        selectionSubtext = _ref.selectionSubtext,
        rest = objectWithoutProperties_default()(_ref, UploadCard_excluded);

    var _useState = Object(external_react_["useState"])(acceptedFiles && acceptedFiles.length > 0),
        _useState2 = slicedToArray_default()(_useState, 2),
        filesSelected = _useState2[0],
        updateFilesSelected = _useState2[1];

    Object(external_react_["useEffect"])(function () {
      updateFilesSelected(acceptedFiles && acceptedFiles.length > 0);
    }, [acceptedFiles, updateFilesSelected]);
    var classNames = classnames_default()('sage-upload-card', className, {
      'sage-upload-card--selected': filesSelected,
      'sage-upload-card--error': errors
    });
    return /*#__PURE__*/external_react_default.a.createElement("div", extends_default()({
      className: classNames
    }, rest), /*#__PURE__*/external_react_default.a.createElement("div", extends_default()({
      className: "sage-upload-card__dropzone"
    }, rootProps), /*#__PURE__*/external_react_default.a.createElement("input", extends_default()({
      className: "sage-upload-card__input"
    }, inputProps)), filesSelected ? /*#__PURE__*/external_react_default.a.createElement(external_react_default.a.Fragment, null, /*#__PURE__*/external_react_default.a.createElement(IconCard_IconCard, {
      className: "sage-upload-card__preview",
      color: IconCard_IconCard.COLORS.DRAFT,
      icon: IconCard_IconCard.ICONS.FILE,
      size: IconCard_IconCard.SIZES.XL
    }), /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-upload-card__body"
    }, acceptedFiles.map(function (_ref2, i) {
      var name = _ref2.name,
          size = _ref2.size; // Limit to one file for now

      if (i > 0) {
        return null;
      }

      return /*#__PURE__*/external_react_default.a.createElement(external_react_default.a.Fragment, {
        key: name
      }, /*#__PURE__*/external_react_default.a.createElement("p", {
        className: "sage-upload-card__text"
      }, name), /*#__PURE__*/external_react_default.a.createElement(Button, {
        color: Button.COLORS.PRIMARY,
        subtle: true
      }, "Replace file"), /*#__PURE__*/external_react_default.a.createElement("p", {
        className: "sage-upload-card__subtext"
      }, "File size: ".concat(size, "B")));
    }))) : /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-upload-card__body"
    }, /*#__PURE__*/external_react_default.a.createElement(Icon_Icon, {
      className: "sage-upload-card__icon",
      icon: Icon_Icon.ICONS.FILE,
      size: Icon_Icon.SIZES.XL,
      color: SageTokens.COLOR_SLIDERS.CHARCOAL_100
    }), /*#__PURE__*/external_react_default.a.createElement(Button, {
      color: Button.COLORS.PRIMARY,
      subtle: true
    }, selectionLabel), /*#__PURE__*/external_react_default.a.createElement("p", {
      className: "sage-upload-card__subtext"
    }, selectionSubtext))), errors && /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "sage-upload-card__errors"
    }, errors.map(function (_ref3) {
      var code = _ref3.code,
          message = _ref3.message;
      return /*#__PURE__*/external_react_default.a.createElement("p", {
        key: code
      }, message);
    })));
  };

  UploadCard_UploadCard.defaultProps = {
    acceptedFiles: [],
    className: null,
    errors: null,
    inputProps: null,
    replaceLabel: 'Replace file',
    rootProps: null,
    selectionLabel: 'Select a file',
    selectionSubtext: null
  };
  UploadCard_UploadCard.propTypes = {
    acceptedFiles: prop_types_default.a.arrayOf(prop_types_default.a.shape),
    className: prop_types_default.a.string,
    errors: prop_types_default.a.arrayOf(prop_types_default.a.shape({
      code: prop_types_default.a.string,
      message: prop_types_default.a.string
    })),
    inputProps: prop_types_default.a.shape({}),
    replaceLabel: prop_types_default.a.string,
    rootProps: prop_types_default.a.shape({}),
    selectionLabel: prop_types_default.a.string,
    selectionSubtext: prop_types_default.a.string
  }; // CONCATENATED MODULE: ./lib/UploadCard/index.js
  // CONCATENATED MODULE: ./lib/common/providers/breakpoint-provider.jsx
  //
  // This code is adapted from this helpful article:
  // https://betterprogramming.pub/how-to-use-media-queries-programmatically-in-react-4d6562c3bc97
  //

  var defaultValue = {};
  var SageBreakpointContext = /*#__PURE__*/Object(external_react_["createContext"])(defaultValue);

  var breakpoint_provider_SageBreakpointProvider = function SageBreakpointProvider(_ref) {
    var children = _ref.children,
        queries = _ref.queries;

    var _useState = Object(external_react_["useState"])({}),
        _useState2 = slicedToArray_default()(_useState, 2),
        queryMatch = _useState2[0],
        setQueryMatch = _useState2[1];

    Object(external_react_["useEffect"])(function () {
      var mediaQueryLists = {};
      var keys = Object.keys(queries);
      var isAttached = false;

      var handleQueryListener = function handleQueryListener() {
        var updatedMatches = keys.reduce(function (acc, media) {
          acc[media] = !!(mediaQueryLists[media] && mediaQueryLists[media].matches);
          return acc;
        }, {});
        setQueryMatch(updatedMatches);
      };

      if (window && window.matchMedia) {
        var matches = {};
        keys.forEach(function (media) {
          if (typeof queries[media] === 'string') {
            mediaQueryLists[media] = window.matchMedia(queries[media]);
            matches[media] = mediaQueryLists[media].matches;
          } else {
            matches[media] = false;
          }
        });
        setQueryMatch(matches);
        isAttached = true;
        keys.forEach(function (media) {
          if (typeof queries[media] === 'string') {
            mediaQueryLists[media].addListener(handleQueryListener);
          }
        });
      }

      return function () {
        if (isAttached) {
          keys.forEach(function (media) {
            if (typeof queries[media] === 'string') {
              mediaQueryLists[media].removeListener(handleQueryListener);
            }
          });
        }
      };
    }, [queries]);
    return /*#__PURE__*/external_react_default.a.createElement(SageBreakpointContext.Provider, {
      value: queryMatch
    }, children);
  };

  breakpoint_provider_SageBreakpointProvider.defaultProps = {
    children: null
  };
  breakpoint_provider_SageBreakpointProvider.propTypes = {
    children: prop_types_default.a.node,
    queries: prop_types_default.a.shape({}).isRequired
  };

  var breakpoint_provider_useSageBreakpoint = function useSageBreakpoint() {
    var context = Object(external_react_["useContext"])(SageBreakpointContext);

    if (context === defaultValue) {
      throw new Error('useBreakpoint must be used within BreakpointProvider');
    }

    return context;
  }; // CONCATENATED MODULE: ./lib/common/providers/index.js
  // CONCATENATED MODULE: ./lib/index.js

  /***/

}
/******/
]);